(function () {
  "use strict";

  angular.module("smakmak.directives", []);
  angular.module("smakmak.services", []);
  angular.module("smakmak.controllers", []);
  angular.module("smakmak.utils", []);
  angular.module("smakmak.filters", []);
  //angular.module('smakmak.widget', []);
  angular.module("smakMakweb", [
    "ngAnimate",
    "ngCookies",
    "restangular",
    "ngSanitize",
    "ngResource",
    "ui.router",
    "ui.router.state",
    "ui.bootstrap",
    "smakmak.directives",
    "smakmak.services",
    "smakmak.controllers",
    "smakmak.utils",
    "smakmak.filters",
    "ngStorage",
    "pascalprecht.translate",
    "bootstrapLightbox",
    "formly",
    "formlyBootstrap",
    "ui.select",
    "dndLists",
    "perfect_scrollbar",
    "smakmak.common.controllers",
    "smakmak.common.directives",
    "smakmak.common.services",
    "smakmak.common.utils",
    "ui.grid",
    "ui.grid.pagination",
    "ngFileUpload",
    "angularIonRangeSlider",
    "19degrees.ngSweetAlert2",
    "ui-notification",
    "ui.ace",
    "angular-circular-progress",
    "ngFileSaver",
  ]);
})();

(function() {
  "use strict";

  angular
    .module("smakmak.services")
    .factory("orderHistoryModalService", orderHistoryModalService);

  orderHistoryModalService.$inject = ["$log", "$uibModal", "$state", "$q"];

  function orderHistoryModalService($log, $uibModal, $state, $q) {
    var service = {
      show: showModal,
      getContractorObject: getContractorObject
    };
    var isVisible = false;
    var _contractorObject = {};

    return service;

    //var

    function showModal(size, contractorObject) {
      if (isVisible) return;
      _contractorObject = contractorObject;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl:
          "app/components/routes/orderHistory/orderHistory.modal.html",
        controller: "orderHistoryModalController",
        controllerAs: "vm",
        size: size,
        resolve: {}
      });

      var deferred = $q.defer();

      isVisible = true;
      modalInstance.result.then(
        function() {
          $log.info("Modal ok with ");
          isVisible = false;
          deferred.resolve();
        },
        function() {
          $log.info("Modal dismissed");
          isVisible = false;
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getContractorObject() {
      return _contractorObject;
    }
  }

  angular
    .module("smakmak.controllers")
    .controller("orderHistoryModalController", orderHistoryModalController);

  /** @ngInject */
  function orderHistoryModalController(
    $scope,
    $uibModalInstance,
    $log,
    contractorRest,
    orderHistoryModalService
  ) {
    var vm = this;
    vm.close = close;
    vm.orders = [];
    vm.contractorObject = {};
    vm.isDataReloading = false;

    constructor();

    function constructor() {
      vm.contractorObject = orderHistoryModalService.getContractorObject();
      loadOrderHistory();
    }

    function close() {
      $uibModalInstance.close();
    }

    function loadOrderHistory() {
      vm.isDataReloading = true;
      contractorRest
        .getOrderHistory(vm.contractorObject.Id)
        .then(function(data) {
          vm.orders = data;
          vm.isDataReloading = false;
        })
        .catch(function(error) {
          vm.isDataReloading = false;
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ProductPickerService', ProductPickerService);

  ProductPickerService.$inject = ['$log', '$uibModal'];

  function ProductPickerService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      check: check,
      getProducts: getProducts,
      getOptions: getOptions
    };

    var instance = undefined;
    var isVisible = false;
    var callbackMultiSelect = undefined;
    // check function should return false if element isn't chosen or true if is chosen
    var checkFunction = undefined;
    var productss = undefined;
    var opt = {};

    return service;

    function showModal(size, products, callback, callbackMulti, checkFunc, options) {
      if(isVisible)
        return;
      callbackMultiSelect = callbackMulti;
      checkFunction = checkFunc;
      opt = options;
      productss = products;
      isVisible = true;

      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/order/productPicker/productPicker.html',
        controller: 'ProductPickerController',
        controllerAs: 'vm',
        size: size
      });
      //return modalInstance.result;
      instance.result.then(function (data) {
        $log.debug('productPicker ok with ' + data);
        isVisible = false;
        if(data)
          callback(data);
      }, function (err) {
        $log.debug('productPicker dismissed with:  ' + err);
        isVisible = false;
      });
    }

    function close(obj){
      if(callbackMultiSelect != undefined)
        callbackMultiSelect(obj);
      else
        instance.close(obj);
    };

    function check(obj) {
      return checkFunction(obj);
    }

    function visible(){
      return isVisible;
    }

    function getProducts(){
      return productss;
    }
    function getOptions(){
      return opt;
    }
  };

})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ProductPickerController", ProductPickerController);

  ProductPickerController.$inject = [
    "ProductPickerService",
    "$filter",
    "ProductCountPickerService",
  ];

  function ProductPickerController(
    ProductPickerService,
    $filter,
    ProductCountPickerService
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.onListTypeChange = onListTypeChange;
    vm.isAdded = isAdded;
    vm.selectProduct = selectProduct;
    //data
    vm.products = ProductPickerService.getProducts();
    vm.visibleProducts = ProductPickerService.getProducts();
    vm.options = ProductPickerService.getOptions();
    vm.searchStr = "";
    //1 - wszystkie, 2 - promocje, 3 - preferowane
    vm.productListType = 1;

    function onListTypeChange() {
      if (vm.productListType === 1) {
        vm.visibleProducts = vm.products;
      } else if (vm.productListType === 2) {
        vm.visibleProducts = _.filter(vm.products, function (product) {
          return product.Price.PromotionId;
        });
      } else {
        vm.visibleProducts = _.filter(vm.products, function (product) {
          return product.IsPreferred;
        });
      }
    }

    function isAdded(key) {
      return ProductPickerService.check(key);
    }

    function selectProduct(product) {
      ProductCountPickerService.show("md", product, undefined, vm.options);
      ProductPickerService.close(product);
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ProductCountPickerService', ProductCountPickerService);

  ProductCountPickerService.$inject = ['$log', '$uibModal'];

  function ProductCountPickerService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      getProduct: getProduct,
      getOptions: getOptions
    };

    var instance = undefined;
    var isVisible = false;
    // check function should return false if element isn't chosen or true if is chosen
    var product = undefined;
    var opt = {};

    return service;

    function showModal(size, _product, callback, options) {
      if(isVisible)
        return;
      product = _product;
      opt = options;
      isVisible = true;

      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/order/productPicker/productCountPicker.html',
        controller: 'ProductCountPickerController',
        controllerAs: 'vm',
        size: size
      });
      //return modalInstance.result;
      instance.result.then(function (data) {
        $log.debug('productCountPicker ok with ' + data);
        isVisible = false;
        if(data && callback){
          callback(data);
        }
      }, function (err) {
        $log.debug('productCountPicker dismissed with:  ' + err);
        isVisible = false;
      });
    }

    function close(obj){
        instance.close(obj);
    }

    function getProduct(){
      return product;
    }

    function getOptions(){
      return opt;
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ProductCountPickerController", ProductCountPickerController);

  ProductCountPickerController.$inject = ["ProductCountPickerService"];

  function ProductCountPickerController(ProductCountPickerService) {
    /* jshint validthis: true */
    var vm = this;
    vm.closeModal = closeModal;
    vm.closeByEnter = closeByEnter;
    vm.openDP = openDP;
    vm.product = ProductCountPickerService.getProduct();
    vm.options = ProductCountPickerService.getOptions();
    vm.expirationDateOptions = {
      formatYear: "yy",
      startingDay: 1,
    };

    function openDP($event, statusObj, object) {
      if (statusObj == 1) object.expirationDateDatePickerOpenedModal = true;
    }

    function closeByEnter() {
      ProductCountPickerService.close(vm.product);
    }

    function closeModal(product) {
      ProductCountPickerService.close(product);
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('DocumentHistoryReportController', DocumentHistoryReportController);

  DocumentHistoryReportController.$inject = ['$log', '$stateParams', '$sessionStorage', 'constRest', 'documentRest', 'SessionService', 'userRest', 'storageRest'];

  function DocumentHistoryReportController($log, $stateParams, $sessionStorage, constRest, documentRest, SessionService, userRest, storageRest) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.onFilterChange = onFilterChange;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.onSelect = onSelect;
    vm.resetSearchTerms = resetSearchTerms;
    vm.loadReport = loadReport;

    //data
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerOpened = false;
    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };
    vm.pagingData = {
      date: Date.today().toString('yyyy-MM-dd'),
      objectStatus: -1,
      storageId: undefined
    };
    vm.dataStats = {
      addedCount: 0.0,
      addedAmount: 0.0,
      removedCount: 0,
      removedAmount: 0.0
    };
    vm.dictionaryData = {};
    //constructor call
    loadData();

    function loadData() {
      $log.debug("DocumentHistoryReportController.controller");
      loadDictionaryData("DeletedDocumentsDictionary");
      loadStoragesData();

      

      if ($sessionStorage.samplesPagingData != undefined){
        vm.pagingData = $sessionStorage.samplesPagingData;
      }
      loadDataWithPagingData(true);
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
          if(name === "DocumentTypeDictionary"){
            filterDocumentTypeDictionary()
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }


    function filterDocumentTypeDictionary(){
      var filtered = [];
      vm.dictionaryData["DocumentTypeDictionary"].forEach(function(type){
        if((type.LocalId == 1003)||(type.LocalId == 1002)){
          filtered.push(type);
        }
      });
      vm.dictionaryData["DocumentTypeDictionary"] = filtered;
    }

    function loadDataWithPagingData() {
      vm.loadReport(
        vm.pagingData.date,
        vm.pagingData.storageId,
        vm.pagingData.objectStatus
      );
    }

    function loadReport(date, storageId, objectStatus) {
      vm.isDataReloading = true;
      documentRest.reportProductHistory(date,storageId, objectStatus, getLoggedUser().Id)
      .then(function (result) {
        vm.data = result;
        vm.isDataReloading = false;
        vm.dataStats = {
          addedCount: 0.0,
          addedAmount: 0.0,
          removedCount: 0,
          removedAmount: 0.0
        };
        vm.dataStats.addedCount = 0.0;
        vm.dataStats.addedAmount = 0.0;
        vm.dataStats.removedCount = 0.0;
        vm.dataStats.removedAmount = 0.0;

        for (var i = 0; i < vm.data.removedProducts.length; i++) {
          vm.data.removedProducts[i].isCollapsed = true;
          vm.dataStats.removedCount += vm.data.removedProducts[i].TotalCount;
          vm.dataStats.removedAmount += vm.data.removedProducts[i].TotalAmount;
        }
        for (var i = 0; i < vm.data.addedProducts.length; i++) {
          vm.data.addedProducts[i].isCollapsed = true;
          vm.dataStats.addedCount += vm.data.addedProducts[i].TotalCount;
          vm.dataStats.addedAmount += vm.data.addedProducts[i].TotalAmount;
        }
      })
      .catch(function (error) {
        $log.debug("Error while getting sample: " + vm.pagingData);
        vm.isDataReloading = false;
        vm.error = error;
      });
    }

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.samplesPagingData = vm.pagingData;
      loadDataWithPagingData(true);
    }

    function openDP() {
      
        vm.datePickerOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      onFilterChange();
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function resetSearchTerms() {
      vm.pagingData.date = Date.today().toString('yyyy-MM-dd');
      vm.pagingData.objectStatus = -1;
      vm.pagingData.storageId = undefined;
      onFilterChange();
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug(error);
          $log.debug("Error while getting sotrages ");
        });
    }

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }
    //controller ends
  }
})
();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('DegustationsReportController', DegustationsReportController);

  DegustationsReportController.$inject = ['$log', '$stateParams', '$sessionStorage', 'constRest', 'documentRest', 'SessionService', 'userRest', 'storageRest'];

  function DegustationsReportController($log, $stateParams, $sessionStorage, constRest, documentRest, SessionService, userRest, storageRest) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.onFilterChange = onFilterChange;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.onSelect = onSelect;
    vm.resetSearchTerms = resetSearchTerms;
    vm.loadReport = loadReport;

    //data
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerOpened = false;
    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };
    vm.pagingData = {
      date: Date.today().toString('yyyy-MM-dd'),
      objectStatus: undefined,
      storageId: undefined
    };

    vm.StatusDictionary = [
      {
        id: 1,
        name: 'Akceptacja'
      }, {
        id: 10,
        name: 'Zaakceptowany'
      }, {
        id: 11,
        name: 'Do wysłania'
      }, {
        id: 23,
        name: 'Wysłany do klienta'
      }, {
        id: 30,
        name: 'Odrzucony'
      }];
    vm.dictionaryData = {};
    //constructor call
    loadData();

    function loadData() {
      $log.debug("DegustationsReportController.controller");
      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadStoragesData();

      if ($sessionStorage.samplesPagingData != undefined){
        vm.pagingData = $sessionStorage.samplesPagingData;
      }
      loadDataWithPagingData(true);
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
          if(name === "DocumentTypeDictionary"){
            filterDocumentTypeDictionary()
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }


    function filterDocumentTypeDictionary(){
      var filtered = [];
      vm.dictionaryData["DocumentTypeDictionary"].forEach(function(type){
        if((type.LocalId == 1003)||(type.LocalId == 1002)){
          filtered.push(type);
        }
      });
      vm.dictionaryData["DocumentTypeDictionary"] = filtered;
    }

    function loadDataWithPagingData() {
      vm.loadReport(
        vm.pagingData.date,
        vm.pagingData.storageId,
        vm.pagingData.objectStatus
      );
    }

    function loadReport(date, storageId, objectStatus) {
      vm.isDataReloading = true;
      documentRest.reportDegustations(date,storageId, objectStatus)
      .then(function (result) {
        vm.data = result;
        vm.isDataReloading = false;
      })
      .catch(function (error) {
        $log.debug("Error while getting sample: " + vm.pagingData);
        vm.isDataReloading = false;
        vm.error = error;
      });
    }

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.samplesPagingData = vm.pagingData;
      loadDataWithPagingData(true);
    }

    function openDP() {
      
        vm.datePickerOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      onFilterChange();
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function resetSearchTerms() {
      vm.pagingData.date = Date.today().toString('yyyy-MM-dd');
      vm.pagingData.objectStatus = undefined;
      vm.pagingData.storageId = undefined;
      onFilterChange();
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }
    //controller ends
  }
})
();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('DocumentsSelectService', DocumentsSelectService);

  DocumentsSelectService.$inject = ['$log', '$uibModal'];

  function DocumentsSelectService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      check: check,
      visible: visible,
      getContractorObj: getContractorObj
    };

    var instance = undefined;
    var isVisible = false;
    var callbackMultiSelect = undefined;
    var checkFunction = undefined;
    var contractorObjj = undefined;

    return service;

    //var

    function showModal(size, callback, callbackMulti, checkFunc, contractorObj) {
      if(isVisible)
        return;
      callbackMultiSelect = callbackMulti;
      checkFunction = checkFunc;
      isVisible = true;
      contractorObjj = contractorObj;

      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/documents/documentsSelect/documentsSelect.html',
        controller: 'DocumentsSelectController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        }
      });
      //return modalInstance.result;
      instance.result.then(function (data) {
        isVisible = false;
        if(data)
          callback(data);
      }, function (err) {
        isVisible = false;
      });
    }

    function close(obj){
      if(callbackMultiSelect != undefined)
        callbackMultiSelect(obj);
      else
        instance.close(obj);
    };

    function check(obj) {
      return checkFunction(obj);
    }

    function visible(){
      return isVisible;
    }


    function getContractorObj(){
      return contractorObjj;
    }
  };

})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('DocumentsSelectController', DocumentsSelectController);

  DocumentsSelectController.$inject = ['$log', '$stateParams', 'constRest', 'documentRest', 'DocumentsSelectService'];

  function DocumentsSelectController($log, $stateParams, constRest, documentRest, DocumentsSelectService) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.loadDocumentsData = loadDocumentsData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.onSelectPageCount = onSelectPageCount;
    vm.onFilterChange = onFilterChange;
    vm.resetSearchTerms = resetSearchTerms;
    vm.selectDocument = selectDocument;
    vm.onDateChange = onDateChange;
    vm.openDP = openDP;
    //data
    vm.isDataReloading = true;
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.beginDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: undefined
    }
    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      typeId: 2,
      contractorObj: undefined,
      payerId: undefined,
      documentNumber: undefined,
      beginDate: Date.today().addMonths(-2).toString('yyyy-MM-dd'),
      endDate: Date.today().toString('yyyy-MM-dd')
    };
    vm.dictionaryData = {};

    loadData();

    function loadData(){
      vm.pagingData.contractorObj = DocumentsSelectService.getContractorObj();
      if(vm.pagingData.contractorObj){
        vm.pagingData.payerId = vm.pagingData.contractorObj.Id;
      }
      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadDataWithPagingData(true);
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
    };

    function onFilterChange() {
      loadDataWithPagingData(true);
    }

    function loadDataWithPagingData(getCount) {
      vm.loadDocumentsData(
        vm.pagingData.documentNumber,
        vm.pagingData.storageId,
        vm.pagingData.categoryId,
        vm.pagingData.payerId,
        vm.pagingData.userId,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.status,
        vm.pagingData.typeId,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.isAcceptanceRequired,
        vm.pagingData.amountBegin,
        vm.pagingData.amountEnd,
        vm.pagingData.sortByDate
      );
    }

    function loadDocumentsData(documentNumber, storageId,categoryId, payerId, userId, beginDate, endDate, status, typeId, count, page, getCount, isAcceptanceRequired, amountBegin, amountEnd, sortByDate) {
      vm.isDataReloading = true;
        documentRest.allView(documentNumber, storageId,categoryId, payerId, userId, beginDate, endDate, status, typeId, page, count, getCount, isAcceptanceRequired, amountBegin, amountEnd, sortByDate)
          .then(function (result) {
            vm.data = result;
            vm.isDataReloading = false;
            if (result.totalCount) {
              vm.setTotalCount(parseInt(result.totalCount, 10));
            }
          })
          .catch(function (error) {
            $log.debug("Error while documents date: " + vm.pagingData);
            vm.isDataReloading = false;
            vm.error = error;
          });
    }

    function selectDocument(obj) {
      DocumentsSelectService.close(obj);
    }

    function resetSearchTerms(){
      vm.pagingData.beginDate = Date.today().addMonths(-2).toString('yyyy-MM-dd');
      vm.pagingData.endDate = Date.today().toString('yyyy-MM-dd');
      onFilterChange();
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      if(isMin){
        datepickerOptions.minDate = new Date(pagingDataField);
      }else{
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      onFilterChange();
    }

    function openDP($event, statusObj) {
      if(statusObj ==1)
        vm.datePickerBeginOpened = true;
      else
        vm.datePickerEndOpened = true;
    };

  }
})
();

(function() {
  "use strict";

  angular
    .module("smakmak.services")
    .factory("PeriodPickerService", PeriodPickerService);

  PeriodPickerService.$inject = ["$log", "$uibModal"];

  function PeriodPickerService($log, $uibModal) {
    var service = {
      show: showModal,
      close: close,
      closeAndReload: closeAndReload,
      getData: getData
    };

    var instance = undefined;
    var isVisible = false;
    var mode = 0;
    var beginDate = undefined;
    var endDate = undefined;
    var counterId = undefined;

    return service;

    function showModal(
      size,
      callback,
      modee,
      beginDatee,
      endDatee,
      counterIdd
    ) {
      if (isVisible) return;
      isVisible = true;
      mode = modee;
      beginDate = beginDatee;
      endDate = endDatee;
      counterId = counterIdd;

      instance = $uibModal.open({
        animation: true,
        templateUrl: "app/components/counters/periodSelect/periodPicker.html",
        controller: "PeriodPickerController",
        controllerAs: "vm",
        size: size
      });
      //return modalInstance.result;
      instance.result.then(
        function(data) {
          $log.debug("periodPicker ok with " + data);
          isVisible = false;
          callback();
        },
        function(err) {
          $log.debug("periodPicker dismissed with:  " + err);
          isVisible = false;
        }
      );
    }

    function close(obj) {
      instance.close(obj);
    }

    function getData() {
      return {
        beginDate: beginDate,
        endDate: endDate,
        counterId: counterId,
        mode: mode
      };
    }

    function visible() {
      return isVisible;
    }

    function closeAndReload(obj) {
      close(obj);
    }
  }
})();

(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("PeriodPickerController", PeriodPickerController);

  PeriodPickerController.$inject = [
    "PeriodPickerService",
    "counterRest",
    "Notification"
  ];

  function PeriodPickerController(
    PeriodPickerService,
    counterRest,
    Notification
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.openDP = openDP;
    vm.submit = submit;
    vm.edit = edit;
    vm.areDatesSelected = areDatesSelected;
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.isSaving = false;
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined
    };
    vm.dates = {
      beginDate: undefined,
      endDate: undefined
    };
    vm.selectedId = undefined;

    vm.mode = 0;

    init();

    function init() {
      // vm.mode = PeriodPickerService.getMode();
      var data = PeriodPickerService.getData();
      vm.mode = data.mode;
      if (vm.mode === 1) {
        vm.dates.beginDate = new Date(data.beginDate).toString("yyyy-MM-dd");
        vm.dates.endDate = new Date(data.endDate).toString("yyyy-MM-dd");
        vm.selectedId = data.counterId;
      }
      //if(sDates.beginDate)
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function submit() {
      vm.isSaving = true;
      var periodObj = {
        TypeId: 3,
        BeginDate: vm.dates.beginDate,
        EndDate: vm.dates.endDate
      };
      periodObj.BeginDate = restTime(
        periodObj.BeginDate,
        0,
        0,
        0
      ).toISOString();
      periodObj.EndDate = restTime(periodObj.EndDate, 23, 59, 59).toISOString();
      counterRest
        .addPeriod(periodObj)
        .then(function(res) {
          vm.isSaving = false;
          var message = "Zapisano przedział";
          Notification.success(message);
          PeriodPickerService.closeAndReload(res);
        })
        .catch(function(error) {
          var message = "Błąd zapisu";
          if (error.data.ExceptionMessage === "counterDatesPeriodException") {
            message = "Błędny zakres dat. Liczniki się pokrywają!";
          }
          Notification.error(message);
        });
    }

    function edit() {
      vm.isSaving = true;
      var periodObj = {
        TypeId: 3,
        BeginDate: vm.dates.beginDate,
        EndDate: vm.dates.endDate
      };
      periodObj.BeginDate = restTime(
        periodObj.BeginDate,
        0,
        0,
        0
      ).toISOString();
      periodObj.EndDate = restTime(periodObj.EndDate, 23, 59, 59).toISOString();
      counterRest
        .updatePeriod(vm.selectedId, periodObj)
        .then(function(res) {
          vm.isSaving = false;
          var message = "Zaktualizowano przedział";
          Notification.success(message);
          PeriodPickerService.closeAndReload(res);
        })
        .catch(function(error) {
          var message = "Błąd aktualizacji";
          if (error.data.ExceptionMessage === "counterDatesPeriodException") {
            message = "Błędny zakres dat. Liczniki się pokrywają!";
          }
          Notification.error(message);
        });
      vm.isSaving = false;
    }

    function restTime(BeginDate, offsetHH, offsetMM, offsetSS) {
      var newDate = new Date(BeginDate);
      newDate.setHours(offsetHH, offsetMM, offsetSS, 0);
      var timezoneOffset = newDate.getTimezoneOffset();
      var time = undefined;
      time = newDate.getTime();
      newDate = new Date(time - timezoneOffset * 60 * 1000);
      return newDate;
    }

    function areDatesSelected() {
      return !(
        vm.dates.beginDate === undefined || vm.dates.endDate === undefined
      );
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services', []);
  angular.module('smakmak.common.directives', []);
  angular.module('smakmak.common.controllers', []);
  angular.module('smakmak.common.utils', []);
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('visitRest', visitRest);

  visitRest.$inject = ['$q', '$log', 'Restangular'];

  function visitRest($q, $log, Restangular) {
    return {
      get: get,
      post: post,
      save: save,
      remove: remove,
      accept: accept,
      comment: comment,
      list: list,
      sum: sum
    };

    function get(id) {
      var filterObject = {};
      return Restangular.one('visits', id).get(filterObject);
    }

    function post(visit) {
      return Restangular.all('visits').post(visit);
    }

    function save(obj) {
      return Restangular.one('visits', obj.Id).customPUT(obj);
    }

    function accept(id) {

    }

    function remove(id) {
      return Restangular.one('visits', id).remove();
    }

    function comment(id, obj) {
      return Restangular.one('visits', id).customPUT(obj, 'comment');
    }

    function list(page, count, getCount, beginDate, endDate, contractorId, userId, contractorSymbol, orderDocumentStatus, qualityReturnDocumentStatus, returnDocumentStatus, isComment, sampleStatus) {
      var filterObject = {};
      if (page !== undefined) {
        angular.extend(filterObject, { page: page });
      }
      if (count !== undefined) {
        angular.extend(filterObject, { count: count });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, { beginDate: beginDate });
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, { endDate: endDate });
      }
      if (contractorId !== undefined) {
        angular.extend(filterObject, { contractorId: contractorId });
      }
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (contractorSymbol !== undefined) {
        angular.extend(filterObject, { contractorSymbol: contractorSymbol });
      }
      if (orderDocumentStatus !== undefined) {
        angular.extend(filterObject, { orderDocumentStatus: orderDocumentStatus });
      }
      if (qualityReturnDocumentStatus !== undefined) {
        angular.extend(filterObject, { qualityReturnDocumentStatus: qualityReturnDocumentStatus });
      }
      if (returnDocumentStatus !== undefined) {
        angular.extend(filterObject, { returnDocumentStatus: returnDocumentStatus });
      }
      if (isComment !== undefined) {
        angular.extend(filterObject, { isComment: isComment });
      }
      if (sampleStatus !== undefined) {
        angular.extend(filterObject, { sampleStatus: sampleStatus });
      }

      return Restangular.all('visits').getList(filterObject);
    }

    function sum(page, count, getCount, beginDate, endDate, contractorId, userId, contractorSymbol, orderDocumentStatus, qualityReturnDocumentStatus, returnDocumentStatus, isComment, docSum, net) {
      var filterObject = {};
      if (page !== undefined) {
        angular.extend(filterObject, { page: page });
      }
      if (count !== undefined) {
        angular.extend(filterObject, { count: count });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, { beginDate: beginDate });
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, { endDate: endDate });
      }
      if (contractorId !== undefined) {
        angular.extend(filterObject, { contractorId: contractorId });
      }
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (contractorSymbol !== undefined) {
        angular.extend(filterObject, { contractorSymbol: contractorSymbol });
      }
      if (orderDocumentStatus !== undefined) {
        angular.extend(filterObject, { orderDocumentStatus: orderDocumentStatus });
      }
      if (qualityReturnDocumentStatus !== undefined) {
        angular.extend(filterObject, { qualityReturnDocumentStatus: qualityReturnDocumentStatus });
      }
      if (returnDocumentStatus !== undefined) {
        angular.extend(filterObject, { returnDocumentStatus: returnDocumentStatus });
      }
      if (isComment !== undefined) {
        angular.extend(filterObject, { isComment: isComment });
      }
      if (docSum !== undefined) {
        angular.extend(filterObject, { docSum: docSum });
      }
      if (net !== undefined) {
        angular.extend(filterObject, { net: net });
      }

      return Restangular.all('visits').customGET('sum', filterObject);
    }

  }
})();

/**
 * Created by Misiek on 2016-05-16.
 */
(function () {
  'use strict';

  angular
    .module('smakmak.common.directives')
    .directive('onlyNumbers', onlyNumbers);

  /** @ngInject */
  function onlyNumbers() {
    var directive = {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {
          // this next if is necessary for when using ng-required on your input.
          // In such cases, when a letter is typed first, this parser will be called
          // again, and the 2nd time, the value will be undefined
          if (inputValue == undefined) return ''
          var transformedInput = inputValue.replace(/[^0-9]/g, '');
          if (transformedInput != inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular.module('smakmak.common.services').factory('loadingPopupService', loadingPopupService);

  loadingPopupService.$inject = ['$ionicLoading', '$window'];

  function loadingPopupService($ionicLoading, $window) {

    return {
      show: show,
      hide: hide
    };

    function show() {
      $ionicLoading.show();
      if ($window.cordova && $window.plugins) {
          $window.plugins.insomnia.keepAwake();
      }
    }

    function hide() {
      $ionicLoading.hide();
      if ($window.cordova && $window.plugins) {
          $window.plugins.insomnia.allowSleepAgain();
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('debounce', ['$timeout', '$q', function ($timeout, $q) {
    // The service is actually this function, which we call with the func
    // that should be debounced and how long to wait in between calls
    return function(func, wait, immediate) {
      var timeout;
      var deferred = $q.defer();
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if(!immediate) {
            deferred.resolve(func.apply(context, args));
            deferred = $q.defer();
          }
        };
        var callNow = immediate && !timeout;
        if ( timeout ) {
          $timeout.cancel(timeout);
        }
        timeout = $timeout(later, wait);
        if (callNow) {
          deferred.resolve(func.apply(context,args));
          deferred = $q.defer();
        }
        return deferred.promise;
      };
    };
  }]);

})();

(function () {
  'use strict';

  angular.module('smakmak.common.services').factory('attributesHelper', attributesHelper);

  attributesHelper.$inject = [];

  function attributesHelper() {

    return {
      extendObject: extendObject
    };

    function extendObject(obj, attrPropertyName) {
      if (obj != undefined)
        angular.extend(obj, {
          attrPropertyName: attrPropertyName != undefined ? attrPropertyName : "Attributes",
          getAttributesByType: getAttributesByTypeF(),
          addAttribute: addAttributeF(),
          removeAttribute: removeAttributeF()
        });
    }

    function getAttributesByTypeF() {

      var f = function (type) {
        var attr = [];
        for (var i = 0; i < this[this.attrPropertyName].length; i++) {
          if (this[this.attrPropertyName][i].Type == type) {
            attr.push(this[this.attrPropertyName][i]);
          }
        }
        return attr;
      };
      return f;
    }

    function addAttributeF() {

      var f = function (contextType, contextId, type, value, dictLocalId) {
        var attr = {
          ContextType: contextType,
          ContextId: contextId,
          Type: type,
          ValueStr: value,
          DictionaryLocalId: dictLocalId
        };
        this[this.attrPropertyName].push(attr);
        return attr;
      };
      return f;
    }

    function removeAttributeF(){
      var f = function(attribute){
        this[this.attrPropertyName].splice(this[this.attrPropertyName].indexOf(attribute), 1);
      }
      return f;
    }
  }
})();

(function () {
  "use strict";

  angular.module("smakmak.common.services").factory("userRest", userRest);

  userRest.$inject = ["$q", "Restangular"];

  function userRest(q, Restangular) {
    return {
      getUserByToken: getUserByToken,
      all: all,
      one: one,
      save: save,
      getEmployees: getEmployees,
      getSuperiorUsers: getSuperiorUsers,
      changeState: changeState,
      getSalesRepresentatives: getSalesRepresentatives,
      getSuperiors: getSuperiors,
      registerAsDocumentUser: registerAsDocumentUser,
    };

    function getUserByToken() {
      return Restangular.all("Account").customGET("GetUserWithToken");
    }

    function changeState(id) {
      var filterObject = {};

      return Restangular.one("users", id).customPOST(
        filterObject,
        "changeState"
      );
    }

    function save(obj, updateAttributes) {
      var filterObject = {};
      if (updateAttributes !== undefined) {
        angular.extend(filterObject, { updateAttributes: updateAttributes });
      }
      return Restangular.all("users").customPUT(obj, obj.Id + "", filterObject);
    }
    function all(
      isActive,
      searchStr,
      count,
      page,
      getCount,
      JobTitleId,
      storage,
      getEmployees,
      getAllIfPossible,
      userId,
      superiorId
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (searchStr !== undefined) {
        angular.extend(filterObject, { searchStr: searchStr });
      }
      if (isActive !== undefined) {
        angular.extend(filterObject, { isActive: isActive });
      }
      if (JobTitleId !== undefined) {
        angular.extend(filterObject, { JobTitleId: JobTitleId });
      }
      if (storage !== undefined) {
        angular.extend(filterObject, { storage: storage });
      }
      if (getEmployees !== undefined) {
        angular.extend(filterObject, { getEmployees: getEmployees });
      }
      if (getAllIfPossible !== undefined) {
        angular.extend(filterObject, { getAllIfPossible: getAllIfPossible });
      }
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (superiorId !== undefined) {
        angular.extend(filterObject, { superiorId: superiorId });
      }

      return Restangular.all("users").getList(filterObject);
    }

    function one(id, getAttributes) {
      var filterObject = {};
      if (getAttributes !== undefined) {
        angular.extend(filterObject, { getAttributes: getAttributes });
      }

      return Restangular.one("users", id).get(filterObject);
    }

    function getEmployees(id, getAllIfPossible) {
      var filterObject = {};
      if (getAllIfPossible !== undefined) {
        angular.extend(filterObject, { getAllIfPossible: getAllIfPossible });
      }
      return Restangular.one("users/employees", id).get(filterObject);
    }

    function getSuperiorUsers(Id, JobTitleId) {
      var filterObject = {};
      if (Id !== undefined) {
        angular.extend(filterObject, { Id: Id });
      }
      if (JobTitleId !== undefined) {
        angular.extend(filterObject, { JobTitleId: JobTitleId });
      }
      return Restangular.all("users/superiorUsers").getList(filterObject);
    }

    function getSalesRepresentatives(
      id,
      searchStr,
      storage,
      count,
      page,
      getCount
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (searchStr !== undefined) {
        angular.extend(filterObject, { searchStr: searchStr });
      }
      if (storage !== undefined) {
        angular.extend(filterObject, { storage: storage });
      }
      return Restangular.one("users", id).all("sales").getList(filterObject);
    }

    function getSuperiors() {
      return Restangular.all("users/superiors").getList();
    }

    function registerAsDocumentUser(Id) {
      var filterObject = {};
      if (Id !== undefined) {
        angular.extend(filterObject, { Id: Id });
        return Restangular.all("users/registerDocumentUser").post(filterObject);
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('uploadRest', uploadRest);

  uploadRest.$inject = ['$q', '$log', 'Restangular'];

  function uploadRest($q, $log, Restangular) {
    return {
      remove: remove
    };

    function remove(id){
      return Restangular.one('MediaFiles', id).remove();
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('templateRest', templateRest);

  templateRest.$inject = ['$q', '$log', 'Restangular'];

  function templateRest($q, $log, Restangular) {
    return {
      get: get,
      getList: getList,
      add: add,
      update: update,
      remove: remove,
      validate: validate
    };

    function add(template, documentId){
      var filterObject = {};
      if (documentId !== undefined) {
        angular.extend(filterObject, {documentId: documentId});
      }
      return Restangular.all('Templates').post(template, filterObject);
    }

    function update(template){
      return Restangular.one('Templates', template.Id).customPUT(template);
    }

    function remove(template){
      return Restangular.one('Templates', template.Id).remove();
    }

    function getList(page, count, getCount, type){
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
	  if (type !== undefined) {
        angular.extend(filterObject, {type: type});
      }
      return Restangular.all('Templates').getList(filterObject);
    }

    function get(id){
      return Restangular.one('Templates', id).get();
    }

    function validate(template, documentId){
      var filterObject = {};
      if (documentId !== undefined) {
        angular.extend(filterObject, {documentId: documentId});
      }
      return Restangular.all('Templates/validate').post(template, filterObject);
    }

  }
})();

(function() {
  "use strict";
  angular.module("smakmak.common.services").factory("taskRest", taskRest);

  taskRest.$inject = ["$q", "$log", "Restangular"];

  function taskRest($q, $log, Restangular) {
    return {
      all: all,
      get: get,
      getNow: getNow,
      post: post,
      save: save,
      remove: remove,
      routeStats: routeStats
    };

    function getNow(userId, type) {
      var filterObject = {};
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (type !== undefined) {
        angular.extend(filterObject, { type: type });
      }

      return Restangular.all("tasks/now").getList(filterObject);
    }

    function all(
      userId,
      type,
      count,
      page,
      getCount,
      beginDate,
      endDate,
      status,
      customTypeId,
      searchStr,
      selectedUserId
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (type !== undefined) {
        angular.extend(filterObject, { type: type });
      }

      if (beginDate !== undefined) {
        angular.extend(filterObject, { beginDate: beginDate });
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, { endDate: endDate });
      }
      if (status !== undefined) {
        angular.extend(filterObject, { status: status });
      }
      if (customTypeId !== undefined) {
        angular.extend(filterObject, { customTypeId: customTypeId });
      }
      if (searchStr !== undefined) {
        angular.extend(filterObject, { searchStr: searchStr });
      }
      if (selectedUserId !== undefined) {
        angular.extend(filterObject, { selectedUserId: selectedUserId });
      }
      return Restangular.all("tasks").getList(filterObject);
    }

    function get(id, userId, getUsers) {
      var filterObject = {};
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (getUsers !== undefined) {
        angular.extend(filterObject, { getUsers: getUsers });
      }
      return Restangular.one("tasks", id).get(filterObject);
    }

    function routeStats(userId, routeDate) {
      var filterObject = {};
      if (userId !== undefined) {
        angular.extend(filterObject, { userId: userId });
      }
      if (routeDate !== undefined) {
        angular.extend(filterObject, { routeDate: routeDate });
      }

      return Restangular.all("tasks").customGET("routeStats", filterObject);
      //return Restangular.all("tasks/routeStats").getList(filterObject);
    }

    function post(contractor) {
      return Restangular.all("tasks").post(contractor);
    }

    function save(obj) {
      return Restangular.one("tasks", obj.Id).customPUT(obj);
    }

    function remove(id) {
      return Restangular.one("tasks", id).remove();
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.common.services').factory('storageRest', storageRest);

  storageRest.$inject = ['$q', 'Restangular'];

  function storageRest($q, Restangular) {
    var storages = undefined;
    return {
      all: all
    };

    function all()
    {
      var q = $q.defer();

      if (storages === undefined) {
        Restangular.all("storages").getList()
          .then(function (data) {
            storages = data;
            q.resolve(data);
          })
          .catch(function (data) {
            q.reject(data);
          });
      } else {
        q.resolve(storages);
      }

      return q.promise;
    }
  }
})();

(function () {
  "use strict";
  angular.module("smakmak.common.services").factory("returnRest", returnRest);

  returnRest.$inject = ["$q", "$log", "Restangular"];

  function returnRest($q, $log, Restangular) {
    return {
      all: all,
      get: get,
      accept: accept,
      setEmails: setEmails,
      acceptByClient: acceptByClient,
      acceptToSend: acceptToSend,
      regenerateFinalDocuments: regenerateFinalDocuments,
      sum: sum,
      cancel: cancel,
      sendAgainFinal: sendAgainFinal,
      sendAgainProposition: sendAgainProposition,
      skipError: skipError,
    };

    function all(
      count,
      page,
      getCount,
      status,
      patronId,
      recipientId,
      beginDate,
      endDate
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (status !== undefined) {
        angular.extend(filterObject, { status: status });
      }
      if (patronId !== undefined) {
        angular.extend(filterObject, { patronId: patronId });
      }

      if (recipientId !== undefined) {
        angular.extend(filterObject, { recipientId: recipientId });
      }

      if (beginDate !== undefined) {
        angular.extend(filterObject, { beginDate: beginDate });
      }

      if (endDate !== undefined) {
        angular.extend(filterObject, { endDate: endDate });
      }

      return Restangular.all("returnsacceptance").getList(filterObject);
    }

    function get(id) {
      return Restangular.one("returnsacceptance", id).get();
    }

    function accept(id, userId, emails) {
      return Restangular.all(
        "returnsacceptance/" + id + "/acceptemployee"
      ).customPOST({ userId: userId });
    }

    function cancel(id, userId) {
      return Restangular.all(
        "returnsacceptance/" + id + "/cancelemployee"
      ).customPOST({ userId: userId });
    }

    function setEmails(id, emails) {
      return Restangular.all("returnsacceptance/" + id + "/emails").customPUT({
        emails: emails,
      });
    }

    function acceptByClient(code) {
      return Restangular.all("returnsacceptance/code").customPOST({
        code: code,
      });
    }

    function acceptToSend(id) {
      return Restangular.all(
        "returnsacceptance/" + id + "/acceptemployeesend"
      ).customPOST();
    }

    function sendAgainFinal(id) {
      return Restangular.all(
        "returnsacceptance/" + id + "/sendagainfinal"
      ).customPOST();
    }

    function sendAgainProposition(id) {
      return Restangular.all(
        "returnsacceptance/" + id + "/sendagainproposition"
      ).customPOST();
    }

    function skipError(id) {
      return Restangular.all(
        "returnsacceptance/" + id + "/skiperror"
      ).customPOST();
    }

    function regenerateFinalDocuments(id) {
      return Restangular.all(
        "returnsacceptance/" + id + "/regeneratefinaldocuments"
      ).customPOST();
    }
    function sum(status, patronId, recipientId, beginDate, endDate) {
      var filterObject = {};
      if (status !== undefined) {
        angular.extend(filterObject, { status: status });
      }
      if (patronId !== undefined) {
        angular.extend(filterObject, { patronId: patronId });
      }

      if (recipientId !== undefined) {
        angular.extend(filterObject, { recipientId: recipientId });
      }

      if (beginDate !== undefined) {
        angular.extend(filterObject, { beginDate: beginDate });
      }

      if (endDate !== undefined) {
        angular.extend(filterObject, { endDate: endDate });
      }

      return Restangular.all("returnsacceptance").customGET(
        "sum",
        filterObject
      );
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.common.services")
    .factory("returnHistoryRest", returnHistoryRest);

  returnHistoryRest.$inject = ["$q", "$log", "Restangular"];

  function returnHistoryRest($q, $log, Restangular) {
    return {
      all: all,
    };

    function all(acceptanceId) {
      return Restangular.all(
        "returnsacceptancehistory/" + acceptanceId
      ).getList();
    }
  }
})();

(function () {
  "use strict";
  angular.module("smakmak.common.services").factory("reportRest", reportRest);

  reportRest.$inject = ["$q", "$log", "Restangular"];

  function reportRest($q, $log, Restangular) {
    return {
      all: all,
      getFile: getFile,
      createReport: createReport,
    };

    function all(count, page, getCount) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }

      return Restangular.all("reports").getList(filterObject);
    }

    function getFile(id) {
      return Restangular.one("reports", id).get({});
    }

    function createReport(beginDate, endDate, type, userId) {
      var obj = {};
      if (beginDate !== undefined) {
        angular.extend(obj, { beginDate: beginDate });
      }
      if (endDate !== undefined) {
        angular.extend(obj, { endDate: endDate });
      }
      if (type !== undefined) {
        angular.extend(obj, { type: type });
      }
      if (userId !== undefined) {
        angular.extend(obj, { userId: userId });
      }
      return Restangular.all("reports").customPOST(obj);
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('productRest', productRest);

  productRest.$inject = ['$q', '$log', 'Restangular'];

  function productRest($q, $log, Restangular) {
    return {
      all: all,
      get: get,
      save: save
    };

    function getForContext() {

    }

    function all(count, page, getCount, isBLocked, groupId, searchStr) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (isBLocked !== undefined) {
        angular.extend(filterObject, {isBLocked: isBLocked});
      }
      if (groupId !== undefined) {
        angular.extend(filterObject, {groupId: groupId});
      }
      if (searchStr !== undefined) {
        angular.extend(filterObject, {searchStr: searchStr});
      }
      return Restangular.all("products").getList(filterObject);
    }

    function get(id) {
      return Restangular.one('products', id).get();
    }

    function save(obj) {
      return Restangular.all('products').customPUT(obj, obj.Id + "");
    }
  }
})();

(function() {
  "use strict";
  angular
    .module("smakmak.common.services")
    .factory("openIdConnectRest", openIdConnectRest);

  openIdConnectRest.$inject = ["$window", "$q", "$log", "Restangular"];

  function openIdConnectRest($window, $q, $log, Restangular) {
    return {
      get: get
    };

    function get(client_id, redirect_uri, scope, response_type, response_mode) {
      console.info("dupa");
      // $window.location.href =
      //   "" +
      //   "?client_id=" +
      //   client_id +
      //   "&redirect_uri=" +
      //   redirect_uri +
      //   "&response_type=" +
      //   response_type +
      //   "&scope=" +
      //   scope;
      // return Restangular.all("connect").customGET("authorize", {
      //   client_id: client_id,
      //   redirect_uri: redirect_uri,
      //   scope: scope,
      //   response_type: response_type,
      //   response_mode: response_mode
      // });
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.common.services').factory('notificationRest', notificationRest);

  notificationRest.$inject = ['$q', 'Restangular'];

  function notificationRest($q, Restangular) {
    return {
      all: all,
      count: count,
      setRead: setRead
    };

    function all(userId) {
      return Restangular.one('users', userId).getList('notifications');
    }

    function count(userId) {
      return Restangular.one('users', userId).all("notifications").get("count");
    }

    function setRead(userId, notification, setAllMyRead, fResponse, fError) {
      var filterObject = {};
      if (setAllMyRead !== undefined) {
        angular.extend(filterObject, {setAllMyRead: setAllMyRead});
      }
      return Restangular.one('users', userId).all("notifications").customPUT(notification, "SetNotificationsRead");
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('objectivesRest', objectivesRest);

  objectivesRest.$inject = ['$q', '$log', 'Restangular'];

  function objectivesRest($q, $log, Restangular) {
    return {
      get: get,
      post: post,
      save: save,
      remove: remove,
      childsList: childsList,
      list: list,
      forMobile: forMobile
    };

    function get(id) {
      return Restangular.one('objectives', id).get();
    }

    function post(objective){
      return Restangular.all('objectives').post(objective);
    }

    function save(obj){
      return Restangular.one('objectives', obj.Id).customPUT(obj);
    }

    function remove(objective){
      return Restangular.one('objectives').customOperation("remove", objective.Id + "", undefined,{'Content-Type': 'application/json' },objective);
    }

    function childsList(id, page, count, getCount){
      var filterObject = {};
      if (page !== undefined) {
        angular.extend(filterObject, {page: page});
      }
      if (count !== undefined) {
        angular.extend(filterObject, {count: count});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
        return Restangular.one('objectives', id).getList('childs', filterObject);
      }

    function forMobile(id, page, count){
      var filterObject = {};
      if (page !== undefined) {
        angular.extend(filterObject, {page: page});
      }
      if (count !== undefined) {
        angular.extend(filterObject, {count: count});
      }
      return Restangular.one('objectives', id).getList('mobile', filterObject);
    }

    function list(searchStr, beginDate, endDate, type, page, count, getCount, selectedUserId, status) {
      var filterObject = {};
      if (searchStr !== undefined) {
        angular.extend(filterObject, {searchStr: searchStr});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (type !== undefined) {
        angular.extend(filterObject, {type: type});
      }
      if (page !== undefined) {
        angular.extend(filterObject, {page: page});
      }
      if (count !== undefined) {
        angular.extend(filterObject, {count: count});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (selectedUserId !== undefined) {
        angular.extend(filterObject, {selectedUserId: selectedUserId});
      }
      if (status !== undefined) {
        angular.extend(filterObject, {status: status});
      }

      return Restangular.all("objectives").getList(filterObject);
    }

  }
})();

(function () {
    'use strict';

    angular.module('smakmak.common.services').factory('messagesRest', messagesRest);

    messagesRest.$inject = ['$q', 'Restangular'];

    function messagesRest($q, Restangular) {
        return {
            getForUser: getForUser
        };

        function getForUser(userId, page, count) {
            var filterObject = {};
            if (count !== undefined && page !== undefined) {
                angular.extend(filterObject, { count: count, page: page });
            }
            return Restangular.one('users', userId).getList('messages', filterObject);
        }
    }
})();

(function() {
  "use strict";
  angular.module("smakmak.common.services").factory("logRest", logRest);

  logRest.$inject = ["$q", "$log", "Restangular"];

  function logRest($q, $log, Restangular) {
    return {
      post: post
    };

    function post(UserId, Message) {
      console.info(Message);
      return Restangular.all("logs").post({
        UserId: UserId,
        Message: Message
      });
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('listRest', listRest);

  listRest.$inject = ['$q', '$log', 'Restangular'];

  function listRest($q, $log, Restangular) {
    return {
      all: all,
      get: get,
      post:post,
      save:save,
	  remove:remove
    };

    function all(type, page, count, getCount, getData) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (type !== undefined) {
        angular.extend(filterObject, {type: type});
      }
      if (getData !== undefined) {
        angular.extend(filterObject, {getData: getData});
      }

      return Restangular.all("Lists").getList(filterObject);
    }

    function get(id, getAddresses, getContractors, getEntities, getCorrectedEntities, getRelatedProducts, getRelatedUser) {
      var filterObject = {};
      if (getAddresses !== undefined) {
        angular.extend(filterObject, {getAddresses: getAddresses});
      }
      if (getContractors !== undefined) {
        angular.extend(filterObject, {getAddresses: getContractors});
      }
      if (getEntities !== undefined) {
        angular.extend(filterObject, {getEntities: getEntities});
      }
      if (getCorrectedEntities !== undefined) {
        angular.extend(filterObject, {getCorrectedEntities: getCorrectedEntities});
      }
      if (getRelatedProducts !== undefined) {
        angular.extend(filterObject, {getRelatedProducts: getRelatedProducts});
      }
      if (getRelatedUser !== undefined) {
        angular.extend(filterObject, {getRelatedUser: getRelatedUser});
      }
return Restangular.one('Lists', id).get(filterObject);

    }

    function post(contractor){
      return Restangular.all('Lists').post(contractor);
    }

    function save(obj){
      return Restangular.one('Lists', obj.Id).customPUT(obj);
    }
	
	function remove(id){
      return Restangular.one('Lists', id).remove();
    }
	
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('excludedProductRest', excludedProductRest);

  excludedProductRest.$inject = ['$q', '$log', 'Restangular'];

  function excludedProductRest($q, $log, Restangular) {
    return {
      add: add,
      all: all,
      update: update,
      remove: remove
    };

    function add(entity) {
      return Restangular.all('excludedProducts').post(entity);
    }

    function update(entity) {
      return Restangular.one('excludedProducts', entity.Id).customPUT(entity);
    }

    function remove(entity) {
      return Restangular.one('excludedProducts', entity.Id).remove();
    }

    function all() {
      return Restangular.all('excludedProducts').getList();
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('eventsRest', eventsRest);

  eventsRest.$inject = ['$q', '$log', 'Restangular'];

  function eventsRest($q, $log, Restangular) {
    return {
      all: all,
      get: get,
      post:post,
      save:save,
      remove: remove,
      holidays: holidays,
      list: list,
      current: current,
      forMobile: forMobile,
      childsList: childsList,
      accept: accept,
      routesForMobile: routesForMobile,
      postHoliday: postHoliday,
      removeHoliday: removeHoliday,
      changeOwner: changeOwner
    };

    function current(currentDate, type, userId){
      var filterObject = {};
      if (currentDate !== undefined) {
        angular.extend(filterObject, {currentDate: currentDate});
      }
      if (type !== undefined) {
        angular.extend(filterObject, {type: type});
      }
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      return Restangular.all("events").all("day").getList(filterObject);
    }

    function holidays(month, year){
      var filterObject = {};
      if (month !== undefined) {
        angular.extend(filterObject, {month: month});
      }
      if (year !== undefined) {
        angular.extend(filterObject, {year: year});
      }

      return Restangular.all("events").all("holidays").getList(filterObject);
    }

    function all(userId, beginDate, endDate, calendarType, managerId) {
      var filterObject = {};
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (calendarType !== undefined){
        angular.extend(filterObject, {calendarType: calendarType});
      }
      if (managerId !== undefined){
        angular.extend(filterObject, {managerId: managerId});
      }
      return Restangular.all("events").getList(filterObject);
    }

    function list(searchStr, beginDate, endDate, type, page, count, getCount, selectedUserId, status, acceptanceLevel, subType) {
      var filterObject = {};
      if (searchStr !== undefined) {
        angular.extend(filterObject, {searchStr: searchStr});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (type !== undefined) {
        angular.extend(filterObject, {type: type});
      }
      if (page !== undefined) {
        angular.extend(filterObject, {page: page});
      }
      if (count !== undefined) {
        angular.extend(filterObject, {count: count});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (selectedUserId !== undefined) {
        angular.extend(filterObject, {selectedUserId: selectedUserId});
      }
      if (status !== undefined) {
        angular.extend(filterObject, {status: status});
      }
      if (acceptanceLevel !== undefined) {
        angular.extend(filterObject, {acceptanceLevel: acceptanceLevel});
      }
      if(subType !== null){
        angular.extend(filterObject, {subType: subType});
      }



      return Restangular.all("events/list").getList(filterObject);
    }

    function get(id, getVisit) {
      var filterObject = {};
	  if (getVisit !== undefined) {
        angular.extend(filterObject, {getVisit: getVisit});
      }
      return Restangular.one('events', id).get(filterObject);
    }

    function post(event){
      return Restangular.all('events').post(event);
    }

    function save(obj){
      return Restangular.one('events', obj.Id).customPUT(obj);
    }

    function remove(event){
      return Restangular.one('events').customOperation("remove", event.Id + "", undefined,{'Content-Type': 'application/json' },event);
    }

    function forMobile(userId, beginDate, endDate, type, page, count){
      var filterObject = {};
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (type !== undefined) {
        angular.extend(filterObject, {type: type});
      }
      if (page !== undefined) {
        angular.extend(filterObject, {page: page});
      }
      if (count !== undefined) {
        angular.extend(filterObject, {count: count});
      }
      return Restangular.all('events').one('user', userId).get(filterObject);
    }

    function childsList(id, page, count, getCount){
      var filterObject = {};
      if (page !== undefined) {
        angular.extend(filterObject, {page: page});
      }
      if (count !== undefined) {
        angular.extend(filterObject, {count: count});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});

        return Restangular.one('events', id).getList('childs', filterObject);
      }
    }

    function accept(id, userId){
      var filterObject = {};
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      return Restangular.one('events', id).customGET('accept', filterObject);
    }

    function routesForMobile(userId){
      return Restangular.one('events', userId).getList('routesForMobile');
    }

    function postHoliday(holiday){
      return Restangular.all('events/holidays').post(holiday);
    }

    function removeHoliday(event){
      return Restangular.one('events/holidays', event.Id).remove();
    }

    function changeOwner(sourceUserId, destinationUserId) {
      var filterObject = {
        sourceUserId: sourceUserId,
        destinationUserId: destinationUserId
      };
      return Restangular.all("events/changeOwner").getList(filterObject);
    }
  }
})();

(function () {
  "use strict";
  angular.module("smakmak.common.services").factory("emailRest", emailRest);

  emailRest.$inject = ["$q", "$log", "Restangular"];

  function emailRest($q, $log, Restangular) {
    return {
      get: get,
    };

    function get(contractorId) {
      return Restangular.one("emails", contractorId).get();
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('documentRest', documentRest);

  documentRest.$inject = ['$q', '$log', 'Restangular'];

  function documentRest($q, $log, Restangular) {
    return {
      all: all,
      allForUser: allForUser,
      getForUser: getForUser,
      allView: allView,
      get: get,
      post: post,
      save: save,
      sendAgainToAccountingSystem: sendAgainToAccountingSystem,
      sendToClient: sendToClient,
      acceptEntitiesOrDocument: acceptEntitiesOrDocument,
      remove: remove,
      changeStatus: changeStatus,
      comment: comment,
      logisticsAcceptance: logisticsAcceptance,
logisticsAcceptanceMulti: logisticsAcceptanceMulti,
      allForContractor: allForContractor,
      reportDegustations: reportDegustations,
      history: history,
      allViewHistory: allViewHistory,
      getHistory: getHistory,
      reportProductHistory: reportProductHistory
    };

    function remove(id){
      return Restangular.one('documents', id).remove();
    }

    function reportDegustations(date, storageId, objectStatus){
      var filterObject = {};
      if (date !== undefined) {
        angular.extend(filterObject, {date: date});
      }
      if (storageId !== undefined) {
        angular.extend(filterObject, {storageId: storageId});
      }
      if (objectStatus !== undefined) {
        angular.extend(filterObject, {objectStatus: objectStatus});
      }
      return Restangular.all('documents').get('reportDegustations', filterObject);
    }

    function reportProductHistory(date, storageId, objectStatus, userId){
      var filterObject = {};
      if (date !== undefined) {
        angular.extend(filterObject, {date: date});
      }
      if (storageId !== undefined) {
        angular.extend(filterObject, {storageId: storageId});
      }
      if(objectStatus == -1){
        objectStatus = undefined;
      }
      if (objectStatus !== undefined) {
        angular.extend(filterObject, {objectStatus: objectStatus});
      }
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      
      return Restangular.all('documents').get('reportProductHistory', filterObject);
    }

    function allForUser(userId, count, page, getCount, getAddresses, getContractors, getEntities, getForMigration) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (getAddresses !== undefined) {
        angular.extend(filterObject, {getAddresses: getAddresses});
      }
      if (getContractors !== undefined) {
        angular.extend(filterObject, {getContractors: getContractors});
      }
      if (getEntities !== undefined) {
        angular.extend(filterObject, {getEntities: getEntities});
      }
      if (getForMigration !== undefined) {
        angular.extend(filterObject, {getForMigration: getForMigration});
      }
      return Restangular.one('users', userId).getList('documents', filterObject);
    }

    function allForContractor(contratorId, count, page) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (contratorId !== undefined) {
        angular.extend(filterObject, {contratorId: contratorId});
      }
      return Restangular.one('contractor', contratorId).getList('documents', filterObject);
    }

    function getForUser(categoryId, payerId, userId, beginDate, endDate, status, typeId, page, count, getCount, getAddresses, getContractors, isAcceptanceRequired, getForMigration) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (categoryId !== undefined) {
        angular.extend(filterObject, {categoryId: categoryId});
      }
      if (payerId !== undefined) {
        angular.extend(filterObject, {payerId: payerId});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (status !== undefined) {
        angular.extend(filterObject, {status: status});
      }
      if (typeId !== undefined) {
        angular.extend(filterObject, {typeId: typeId});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (getAddresses !== undefined) {
        angular.extend(filterObject, {getAddresses: getAddresses});
      }
      if (getContractors !== undefined) {
        angular.extend(filterObject, {getContractors: getContractors});
      }
      if (isAcceptanceRequired !== undefined) {
        angular.extend(filterObject, {isAcceptanceRequired: isAcceptanceRequired});
      }
      if (getForMigration !== undefined) {
        angular.extend(filterObject, {getForMigration: getForMigration});
      }
      return Restangular.one('users', userId).getList('documents', filterObject);
    }

    function all(categoryId, payerId, userId, beginDate, endDate, status, typeId, page, count, getCount, getAddresses, getContractors, getEntities) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (categoryId !== undefined) {
        angular.extend(filterObject, {categoryId: categoryId});
      }
      if (payerId !== undefined) {
        angular.extend(filterObject, {payerId: payerId});
      }
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (status !== undefined) {
        angular.extend(filterObject, {status: status});
      }
      if (typeId !== undefined) {
        angular.extend(filterObject, {typeId: typeId});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (getAddresses !== undefined) {
        angular.extend(filterObject, {getAddresses: getAddresses});
      }
      if (getContractors !== undefined) {
        angular.extend(filterObject, {getContractors: getContractors});
      }
      if (getEntities !== undefined) {
        angular.extend(filterObject, {getEntities: getEntities});
      }
      return Restangular.all("documents").getList(filterObject);
    }

    function allView(documentNumber, storageId, categoryId, payerId, userId, beginDate, endDate, status, typeId, page, count, getCount, isAcceptanceRequired, amountBegin, amountEnd, sortByDate, IsSendToClient, ObjectStatus, isModified) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (documentNumber !== undefined) {
        angular.extend(filterObject, {documentNumber: documentNumber});
      }
      if (storageId !== undefined) {
        angular.extend(filterObject, {storageId: storageId});
      }
      if (categoryId !== undefined) {
        angular.extend(filterObject, {categoryId: categoryId});
      }
      if (payerId !== undefined) {
        angular.extend(filterObject, {payerId: payerId});
      }
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (status !== undefined) {
        angular.extend(filterObject, {status: status});
      }
      if (typeId !== undefined) {
        angular.extend(filterObject, {typeId: typeId});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (isAcceptanceRequired !== undefined) {
        angular.extend(filterObject, {isAcceptanceRequired: isAcceptanceRequired});
      }
      if (amountBegin !== undefined) {
        angular.extend(filterObject, {amountBegin: amountBegin});
      }
      if (amountEnd !== undefined) {
        angular.extend(filterObject, {amountEnd: amountEnd});
      }
      if (sortByDate !== undefined) {
        angular.extend(filterObject, {sortByDate: sortByDate});
      }
      if (IsSendToClient !== undefined) {
        angular.extend(filterObject, {IsSendToClient: IsSendToClient});
      }
      if (ObjectStatus !== undefined) {
        angular.extend(filterObject, {ObjectStatus: ObjectStatus});
      }
      if (isModified !== undefined) {
        angular.extend(filterObject, {isModified: isModified});
      }

      return Restangular.all("documents/listView").getList(filterObject);
    }

    function allViewHistory(page, count, getCount, payerId, userId, beginDate, endDate, typeId) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, {count: count, page: page});
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, {getCount: getCount});
      }
      if (payerId !== undefined) {
        angular.extend(filterObject, {payerId: payerId});
      }
      if (userId !== undefined) {
        angular.extend(filterObject, {userId: userId});
      }
      if (beginDate !== undefined) {
        angular.extend(filterObject, {beginDate: beginDate});
      }
      if (endDate !== undefined) {
        angular.extend(filterObject, {endDate: endDate});
      }
      if (typeId !== undefined) {
        angular.extend(filterObject, {typeId: typeId});
      }
      return Restangular.all("documents/deletedListView").getList(filterObject);
    }

    function getHistory(id, getAddresses, getContractors, getEntities, getCorrectedEntities, getRelatedProducts, getRelatedUser, getRelatedDocuments) {
      var filterObject = {};
      if (getAddresses !== undefined) {
        angular.extend(filterObject, {getAddresses: getAddresses});
      }
      if (getContractors !== undefined) {
        angular.extend(filterObject, {getAddresses: getContractors});
      }
      if (getEntities !== undefined) {
        angular.extend(filterObject, {getEntities: getEntities});
      }
      if (getCorrectedEntities !== undefined) {
        angular.extend(filterObject, {getCorrectedEntities: getCorrectedEntities});
      }
      if (getRelatedProducts !== undefined) {
        angular.extend(filterObject, {getRelatedProducts: getRelatedProducts});
      }
      if (getRelatedUser !== undefined) {
        angular.extend(filterObject, {getRelatedUser: getRelatedUser});
      }
      if (getRelatedDocuments !== undefined) {
        angular.extend(filterObject, {getRelatedDocuments: getRelatedDocuments});
      }
      return Restangular.one('documents/history', id).get(filterObject);
    }

    function get(id, getAddresses, getContractors, getEntities, getCorrectedEntities, getRelatedProducts, getRelatedUser, getRelatedDocuments) {
      var filterObject = {};
      if (getAddresses !== undefined) {
        angular.extend(filterObject, {getAddresses: getAddresses});
      }
      if (getContractors !== undefined) {
        angular.extend(filterObject, {getAddresses: getContractors});
      }
      if (getEntities !== undefined) {
        angular.extend(filterObject, {getEntities: getEntities});
      }
      if (getCorrectedEntities !== undefined) {
        angular.extend(filterObject, {getCorrectedEntities: getCorrectedEntities});
      }
      if (getRelatedProducts !== undefined) {
        angular.extend(filterObject, {getRelatedProducts: getRelatedProducts});
      }
      if (getRelatedUser !== undefined) {
        angular.extend(filterObject, {getRelatedUser: getRelatedUser});
      }
      if (getRelatedDocuments !== undefined) {
        angular.extend(filterObject, {getRelatedDocuments: getRelatedDocuments});
      }
      return Restangular.one('documents', id).get(filterObject);
    }

    function post(contractor) {
      return Restangular.all('documents').post(contractor);
    }

    function acceptEntitiesOrDocument(acceptRecords) {
      return Restangular.all('documents/acceptEntitiesOrDocument').post(acceptRecords);
    }

    function save(obj) {
      return Restangular.one('documents', obj.Id).customPUT(obj);
    }

    function comment(id, obj) {
      return Restangular.one('documents', id).customPUT(obj, 'comment');
    }

    function sendAgainToAccountingSystem(id) {
      return Restangular.one('documents', id).customGET("sendAgainToAccountingSystem");
    }

    function sendToClient(id) {
      return Restangular.one('documents', id).customGET("sendToClient");
    }

    function history(id) {
      return Restangular.one('documents', id).customGET("history");
    }

    function changeStatus(id, status) {
      return Restangular.one('documents', id).one('status', status).get();
    }
    function logisticsAcceptance(id, DocumentReleaseDate, FinishDate, StorageId) {
      var filterObject = {};
      if (DocumentReleaseDate !== undefined) {
        angular.extend(filterObject, {DocumentReleaseDate: DocumentReleaseDate});
      }
      if (FinishDate !== undefined) {
        angular.extend(filterObject, {FinishDate: FinishDate});
      }
      if (StorageId !== undefined) {
        angular.extend(filterObject, {StorageId: StorageId});
      }
      return Restangular.one('documents', id).customGET('logisticsAcceptance', filterObject);
    }
	
	function logisticsAcceptanceMulti(sendObject){
		return Restangular.all('documents').customPOST(sendObject, 'logisticsAcceptanceMulti');
	}
	
  }
})();
(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('constRest', constRest);

  constRest.$inject = ['$q', '$log', 'Restangular'];

  function constRest($q, $log, Restangular) {
    var localDictionary = {};
    buildLocalDict();
    return {
      all: all,
      remove: remove,
      get: get,
      getDictionary: getDictionary,
      putObject: putObject,
      postObject: postObject
    };

    function all() {
    }

    function get(id) {
      return Restangular.one('consts', id).get();
    }

    function putObject(obj, id) {
      return Restangular.one('consts', id).customPUT(obj);
    }

    function postObject(dictName, obj) {
      return Restangular.all('consts').one('dict', dictName).customPOST(obj);
    }

    function remove(obj) {
      return Restangular.one('consts', obj.Id).remove();
    }

    function getDictionary(name) {
      var q = $q.defer();
      var filterObject = {};
      if (name !== undefined) {
        angular.extend(filterObject, { name: name });
      }
      if (!localDictionary.hasOwnProperty(name)) {
        Restangular.all("consts").getList(filterObject)
          .then(function (data) {
            localDictionary[name] = data;
            q.resolve(data);
          })
          .catch(function (data) {
            q.reject(data);
          });
      } else {
        q.resolve(localDictionary[name]);
      }

      return q.promise;
    }

    function buildLocalDict() {
      localDictionary.BlockedDictionary = [
        {
          Value: undefined,
          Name: "Wszyscy"
        }, {
          Value: false,
          Name: "Aktywni"
        }, {
          Value: true,
          Name: "Nieaktywni"
        }];

      localDictionary.ActiveDictionary = [
        {
          Value: undefined,
          Name: "Wszyscy"
        }, {
          Value: true,
          Name: "Aktywni"
        }, {
          Value: false,
          Name: "Nieaktywni"
        }];

      localDictionary.DeletedDocumentsDictionary = [
        {
          Value: -1,
          Name: "Wszystkie"
        }, {
          Value: 0,
          Name: "Zmodyfikowane"
        }, {
          Value: 1,
          Name: "Usunięte"
        }];

      localDictionary.TrueFalseDictionary = [
        {
          Value: true,
          Name: "Tak"
        }, {
          Value: false,
          Name: "Nie"
        }];

      localDictionary.PageSizeDictionary = [
        {
          Value: 10,
          Name: "10"
        }, {
          Value: 25,
          Name: "25"
        }, {
          Value: 50,
          Name: "50"
        }, {
          Value: 100,
          Name: "100"
        }];
      localDictionary.TaskUnitDictionary = [
        {
          Value: "Ilość",
          Name: "",
          LocalId: 2
        }, {
          Value: "Wartość",
          Name: "",
          LocalId: 3
        }];
      localDictionary.EDIStatusedDictionary = [
        {
          Value: undefined,
          Name: "Wszyscy"
        }, {
          Value: true,
          Name: "Produkcja"
        }, {
          Value: false,
          Name: "Test"
        }];
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('customParameterRest', customParameterRest);

  customParameterRest.$inject = ['$q', '$log', 'Restangular'];

  function customParameterRest($q, $log, Restangular) {
    return {
      add: add,
      update: update,
      remove: remove
    };

    function add(parameter){
      return Restangular.all('customParameters').post(parameter);
    }

    function update(parameter){
      return Restangular.one('customParameters', parameter.Id).customPUT(parameter);
    }

    function remove(parameter){
      return Restangular.one('customParameters', parameter.Id).remove();
    }

  }
})();

(function() {
  "use strict";
  angular.module("smakmak.common.services").factory("counterRest", counterRest);

  counterRest.$inject = ["$q", "$log", "Restangular"];

  function counterRest($q, $log, Restangular) {
    return {
      get: get,
      post: post,
      getForMobile: getForMobile,
      updateCurrentValues: updateCurrentValues,
      getPeriods: getPeriods,
      addPeriod: addPeriod,
      updatePeriod: updatePeriod
    };

    function get(userId, parentId) {
      var filterObject = {};
      if (parentId !== undefined) {
        angular.extend(filterObject, { parentId: parentId });
      }
      return Restangular.one("users", userId).customGET(
        "salesCounters",
        filterObject
      );
    }

    function getPeriods() {
      var filterObject = {};
      // if (date !== undefined) {
      //   angular.extend(filterObject, {date: date});
      // }
      return Restangular.all("Counters").customGET("periods", filterObject);
    }

    function getForMobile(userId) {
      return Restangular.one("users", userId).getList("getCountersForMobile");
    }

    function post(counters) {
      return Restangular.all("Counters").post(counters);
    }

    function addPeriod(counters) {
      return Restangular.all("Counters//periods").post(counters);
    }

    function updatePeriod(id, counters) {
      return Restangular.one("Counters//periods", id).customPUT(counters);
    }

    function updateCurrentValues(id, record) {
      return Restangular.one("Counters", id).post("UpdateCurrentValue", record);
    }
  }
})();

(function() {
  "use strict";
  angular
    .module("smakmak.common.services")
    .factory("contractorRest", contractorRest);

  contractorRest.$inject = ["$q", "$log", "Restangular"];

  function contractorRest($q, $log, Restangular) {
    return {
      all: all,
      allForUser: allForUser,
      getForUser: getForUser,
      get: get,
      post: post,
      save: save,
      getNextSymbol: getNextSymbol,
      check: check,
      changeStatus: changeStatus,
      getOrderData: getOrderData,
      getOrderHistory: getOrderHistory,
      saveNextVisitNote: saveNextVisitNote
    };

    function allForUser(
      userId,
      count,
      page,
      getCount,
      getAddresses,
      getPreferredProducts
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { patronId: getCount });
      }
      if (getAddresses !== undefined) {
        angular.extend(filterObject, { getAddresses: getAddresses });
      }
      if (getPreferredProducts !== undefined) {
        angular.extend(filterObject, {
          getPreferredProducts: getPreferredProducts
        });
      }

      return Restangular.one("users", userId).getList(
        "contractors",
        filterObject
      );
    }

    function getForUser(
      userId,
      featureId,
      isBlocked,
      groupId,
      searchStr,
      count,
      page,
      getCount,
      getAddresses,
      type,
      orderByName,
      isAcceptanceRequired,
      getPreferredProducts
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (featureId !== undefined) {
        angular.extend(filterObject, { featureId: featureId });
      }
      if (isBlocked !== undefined) {
        angular.extend(filterObject, { isBlocked: isBlocked });
      }
      if (groupId !== undefined) {
        angular.extend(filterObject, { groupId: groupId });
      }
      if (searchStr !== undefined) {
        angular.extend(filterObject, { searchStr: searchStr });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (getAddresses !== undefined) {
        angular.extend(filterObject, { getAddresses: getAddresses });
      }
      if (type !== undefined) {
        angular.extend(filterObject, { type: type });
      }
      if (orderByName !== undefined) {
        angular.extend(filterObject, { orderByName: orderByName });
      }
      if (isAcceptanceRequired !== undefined) {
        angular.extend(filterObject, {
          isAcceptanceRequired: isAcceptanceRequired
        });
      }
      if (getPreferredProducts !== undefined) {
        angular.extend(filterObject, {
          getPreferredProducts: getPreferredProducts
        });
      }

      return Restangular.one("users", userId).getList(
        "contractors",
        filterObject
      );
    }

    function all(
      featureId,
      isBlocked,
      groupId,
      searchStr,
      patronId,
      count,
      page,
      getCount,
      getAddresses,
      type,
      orderByName,
      isAcceptanceRequired,
      getPreferredProducts,
      gln,
      IsFsSendProd,
      IsKfsSendProd,
      IsOrderLoadProd
    ) {
      var filterObject = {};
      if (count !== undefined && page !== undefined) {
        angular.extend(filterObject, { count: count, page: page });
      }
      if (featureId !== undefined) {
        angular.extend(filterObject, { featureId: featureId });
      }
      if (isBlocked !== undefined) {
        angular.extend(filterObject, { isBlocked: isBlocked });
      }
      if (groupId !== undefined) {
        angular.extend(filterObject, { groupId: groupId });
      }
      if (searchStr !== undefined) {
        angular.extend(filterObject, { searchStr: searchStr });
      }
      if (patronId !== undefined) {
        angular.extend(filterObject, { patronId: patronId });
      }
      if (getCount !== undefined) {
        angular.extend(filterObject, { getCount: getCount });
      }
      if (getAddresses !== undefined) {
        angular.extend(filterObject, { getAddresses: getAddresses });
      }
      if (type !== undefined) {
        angular.extend(filterObject, { type: type });
      }
      if (orderByName !== undefined) {
        angular.extend(filterObject, { orderByName: orderByName });
      }
      if (isAcceptanceRequired !== undefined) {
        angular.extend(filterObject, {
          isAcceptanceRequired: isAcceptanceRequired
        });
      }
      if (getPreferredProducts !== undefined) {
        angular.extend(filterObject, {
          getPreferredProducts: getPreferredProducts
        });
      }
      if (gln !== undefined) {
        angular.extend(filterObject, { gln: gln });
      }
      if (IsFsSendProd !== undefined) {
        angular.extend(filterObject, { IsFsSendProd: IsFsSendProd });
      }
      if (IsKfsSendProd !== undefined) {
        angular.extend(filterObject, { IsKfsSendProd: IsKfsSendProd });
      }
      if (IsOrderLoadProd !== undefined) {
        angular.extend(filterObject, { IsOrderLoadProd: IsOrderLoadProd });
      }

      return Restangular.all("contractors").getList(filterObject);
    }

    function get(
      id,
      getAddresses,
      getAttributes,
      getPreferredProducts,
      getCustomParameters,
      getPendingPayments
    ) {
      var filterObject = {};
      if (getAddresses !== undefined) {
        angular.extend(filterObject, { getAddresses: getAddresses });
      }
      if (getAttributes !== undefined) {
        angular.extend(filterObject, { getAttributes: getAttributes });
      }
      if (getPreferredProducts !== undefined) {
        angular.extend(filterObject, {
          getPreferredProducts: getPreferredProducts
        });
      }
      if (getCustomParameters !== undefined) {
        angular.extend(filterObject, {
          getCustomParameters: getCustomParameters
        });
      }
      if (getPendingPayments !== undefined) {
        angular.extend(filterObject, {
          getPendingPayments: getPendingPayments
        });
      }
      return Restangular.one("contractors", id).get(filterObject);
    }

    function changeStatus(id) {
      return Restangular.one("contractors", id).customGET("changeStatus");
    }

    function post(contractor, updateAttributes) {
      var filterObject = {};
      if (updateAttributes !== undefined) {
        angular.extend(filterObject, { updateAttributes: updateAttributes });
      }
      return Restangular.all("contractors").post(contractor, filterObject);
    }

    function save(obj, updateAttributes) {
      var filterObject = {};
      if (updateAttributes !== undefined) {
        angular.extend(filterObject, { updateAttributes: updateAttributes });
      }
      return Restangular.all("contractors").customPUT(
        obj,
        obj.Id + "",
        filterObject
      );
    }

    function getNextSymbol() {
      return Restangular.all("contractors").customGET("GetNextSymbol");
    }
    function check(nip, symbol) {
      var filterObject = {};
      if (nip !== undefined) {
        angular.extend(filterObject, { nip: nip });
      }
      if (symbol !== undefined) {
        angular.extend(filterObject, { symbol: symbol });
      }
      return Restangular.all("contractors").customGET("check", filterObject);
    }

    function getOrderData(contractorId) {
      return Restangular.one("contractors", contractorId).customGET("order");
    }

    function getOrderHistory(contractorId) {
      return Restangular.one("contractors", contractorId).customGET("history");
    }

    function saveNextVisitNote(contractorId, NextVisitNote) {
      return Restangular.one("contractors", contractorId).customPUT(
        { NextVisitNote: NextVisitNote },
        "visitnote"
      );
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('addressRest', addressRest);

  addressRest.$inject = ['$q', 'logService', 'Restangular'];

  function addressRest($q, logService, Restangular) {
    return {
      get: get
    };

    function get(id) {
      return Restangular.one('addresses', id).get();
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ConstSelectService', ConstSelectService);

  ConstSelectService.$inject = ['$log', '$uibModal'];

  function ConstSelectService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      addMulti: addMulti
    };

    var instance = undefined;
    var isVisible = false;
    var addMultiCallback = undefined;

    return service;

    //var

    function showModal(size, callback, multiCallback, dictName, idArray, checkFunc, title, filterField) {
      if(isVisible)
        return;
      addMultiCallback = multiCallback;
      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/commonComponents/constSelect/constSelect.html',
        controller: 'ConstSelectController',
        controllerAs: 'vm',
        size: size,
        resolve: {
          loadDictName: function(){
            return dictName;
          },
          idArray : function(){
            return idArray;
          },
          checkFunction: function(){
            if(checkFunc == undefined)
              return undefined;
            else
              return checkFunc;
          },
          title: function(){
            if (title == undefined)
              return undefined
            else
              return title;
          },
          filterField: function (){
            return filterField;
          }
        }
      });
      isVisible = true;
      instance.result.then(function (data) {
        $log.debug('constSelect ok with ' + data);
        isVisible = false;
        if(data)
          callback(data);
      }, function (err) {
        $log.debug('constSelect dismissed with:  ' + err);
        isVisible = false;
      });
    }
    function close(obj){
      instance.close(obj);
    };

    function addMulti(obj){
      if(addMultiCallback !== undefined) {
        addMultiCallback(obj);
        return true;
      }
      return false;
    }
  };
})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ConstSelectController', ConstSelectController);

  ConstSelectController.$inject = ['$log', '$scope', '$translate', 'constRest', '$sessionStorage', 'ConstSelectService', 'loadDictName', 'idArray', 'checkFunction', 'title', 'filterField'];

  function ConstSelectController($log, $scope, $translate, constRest, $sessionStorage, ConstSelectService, loadDictName, idArray, checkFunction, title, filterField) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.loadUserDictionaryData = loadUserDictionaryData;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.resetSearchTerms = resetSearchTerms
    vm.selectObject = selectObject;
    vm.loadConstData = loadConstData;
    vm.isAdded = isAdded;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.filterField = undefined;
    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      searchStr: undefined
    };
    vm.dictionaryData = {};
    vm.title = undefined;
    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("constselect.controller");
      //constructor body
      vm.setPageSize(10);
      loadDictionaryData("PageSizeDictionary");
      //if ($sessionStorage.contractorsPagingData != undefined)
      //  vm.pagingData = $sessionStorage.contractorsPagingData;
      //if($stateParams.pagingData != undefined){
      //  resetSearchTerms();
      //  if($stateParams.pagingData.isAcceptanceRequired !== undefined)
      //    vm.pagingData.isAcceptanceRequired =  $stateParams.pagingData.isAcceptanceRequired;
      //}
      loadDataWithPagingData(true);
      if (title == undefined)
        vm.title = "Wybierz";
      else {
        vm.title = title;
      }
      vm.filterField = filterField;
    }

    ///////////////// business logic

    function selectObject(obj) {
      if(ConstSelectService.addMulti(obj) == false) {
        ConstSelectService.close(obj);
      }
    }

    function selectMultiObject(obj) {

    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
      //$sessionStorage.constPagingData = vm.pagingData;
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      //$sessionStorage.contractorsPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function resetSearchTerms() {
      vm.pagingData.searchStr = undefined;
      vm.pagingData.currentPage = 1;
      onFilterChange();
    }

    function getPageData(data, pageSize, page) {
      var ret = [];
      var min = pageSize * (page - 1);
      var max = min + pageSize;
      for (var i = min; i < max; i++) {
        if (i >= data.length)
          return ret;
        ret.push(data[i]);
      }

      return ret;
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions


    function isAdded(objjj) {
      var obj = undefined;
      if(checkFunction === undefined) {
        obj = idArray.find(function (key) {
            return key == objjj.LocalId;
          }
        );
      }
      else{
        obj = checkFunction(objjj);
      }
      if(obj === undefined)
        return false;
      else
        return true;
    }

    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadConstData(
        loadDictName,
        vm.pagingData.searchStr,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount
      );
    }

    function loadConstData(dictName, searchStr, pageSize, currentPage, getCount) {
      vm.isDataReloading = true;

      constRest.getDictionary(dictName)
        .then(function (data) {
          data = filterResult(data);
          vm.data = getPageData(data, pageSize, currentPage);
          vm.setTotalCount(data.length);
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + dictName);
          vm.error = error;
        })
        .finally(function () {
          vm.isDataReloading = false;
          vm.isLoading = false;
        });
      //contractorRest.getForUser(SessionService.getAuthenticatedUser().Id, featureId, isBlocked, groupId, searchStr, count, page, getCount, undefined, type, sortByName)
      //  .then(function (result) {
      //    vm.data = result;
      //    vm.isDataReloading = false;
      //    if (result.totalCount) {
      //      vm.setTotalCount(parseInt(result.totalCount, 10));
      //    }
      //  })
      //  .catch(function (error) {
      //    $log.debug("Error while contractors date: " + vm.pagingData);
      //    vm.isDataReloading = false;
      //    vm.error = error;
      //  });
    }

    function filterResult(data){
      if((vm.filterField != undefined)&&(vm.pagingData.searchStr !== undefined)){
        var searchStr = vm.pagingData.searchStr.toUpperCase();
        data = data.filter(function(object){
          var result = true;
          var objectProperty = object[vm.filterField].toUpperCase();
          result = objectProperty.includes(searchStr);
          return result;
        });
      }
      return data;
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadUserDictionaryData() {
      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    ///////////////// FORMLY

  }
})
();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('UploadService', UploadService);

  UploadService.$inject = ['$log', '$uibModal'];

  function UploadService($log, $uibModal) {

    var service = {
      show: showModal,
      getContextId: getContextId,
      getContextType: getContextType,
      getFileTypes: getFileTypes
    };

    var instance = undefined;
    var isVisible = false;
    var callbackMultiSelect = undefined;
    var ContextIdd = undefined;
    var ContextTypee = undefined;
    /**File types are passed as string to the modal instance
    remember to use backslash escape character to turn string ''
    special characters into string elements, for eg. '\'image/*, application/pdf\''
    is a valid FileTypes parameter. If parameter is undefined, default file types
    shown in example will be used**/
    var FileTypess = undefined;

    return service;

    function showModal(size, callback, callbackMulti, ContextId, ContextType, FileTypes) {
      if(isVisible)
        return;

      callbackMultiSelect = callbackMulti;
      ContextIdd = ContextId;
      ContextTypee = ContextType;
      FileTypess = FileTypes;

      isVisible = true;
      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/commonComponents/uploadService/upload.modal.html',
        controller: 'UploadController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        }
    });
        //return modalInstance.result;
        instance.result.then(function (data) {
          $log.debug('uploadService ok with ' + data);
          isVisible = false;
          if(data)
            callback(data);
        }, function (err) {
          $log.debug('uploadService dismissed with:  ' + err);
          isVisible = false;
        });

    }

    function getContextId(){
      return ContextIdd;
    }

    function getContextType(){
      return ContextTypee;
    }

    function getFileTypes(){
      return FileTypess;
    }

  };

})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("UploadController", UploadController);

  UploadController.$inject = [
    "$log",
    "$stateParams",
    "$scope",
    "$translate",
    "$timeout",
    "Upload",
    "$uibModalInstance",
    "UploadService",
    "apiUrl",
  ];

  function UploadController(
    $log,
    $stateParams,
    $scope,
    $translate,
    $timeout,
    Upload,
    $uibModalInstance,
    UploadService,
    apiUrl
  ) {
    var vm = this;
    //functions
    vm.submit = submit;
    vm.progressCheck = progressCheck;
    vm.checkFilesExtension = checkFilesExtension;
    vm.initialize = initialize;

    //data
    vm.file = undefined;
    vm.uploading = false;
    vm.progress = 0;
    vm.FileTypes = "'image/*, application/pdf'";

    //init call
    initialize();

    // gets parameter values needed for modal instance
    function initialize() {
      //file types which can be chosen in modal
      var fileTypes = UploadService.getFileTypes();
      if (fileTypes !== undefined) {
        vm.FileTypes = fileTypes;
      }
    }

    //submits chosen file to server
    function submit(file) {
      if (vm.uploading) return;
      vm.uploading = true;

      var type = undefined;
      type = vm.checkFilesExtension(file);
      //file must be img or pdf, 0 - file undefined or wrong type
      if (type === 0) {
        vm.uploading = false;
        return;
      }

      var ContextId = UploadService.getContextId();
      var ContextType = UploadService.getContextType();
      vm.progress = 1;
      $timeout(function () {
        Upload.upload({
          url: apiUrl + "/MediaFiles/upload",
          data: {
            file: file,
            Type: type,
            ContextId: ContextId,
            ContextType: ContextType,
          },
        }).then(
          function (resp) {
            console.log(
              "Success " + resp.config.data.file.name + "uploaded. Response: "
            );
            console.log(resp);
            vm.uploading = false;
            $uibModalInstance.close(resp.data);
          },
          function (resp) {
            console.log("Error status: " + resp.status);
            vm.uploading = false;
            $uibModalInstance.close();
          },
          function (evt) {
            vm.progress = parseInt((100.0 * evt.loaded) / evt.total);
          }
        );
      }, 1000);
    }

    //progress check
    function progressCheck() {
      if (0 < vm.progress) {
        return true;
      }
      return false;
    }

    //checks which format is file
    //checks if attachment is an image or pdf
    function checkFilesExtension(file) {
      if (file === undefined || file == null) return 0;
      else if (file.name.match(/\.(jpeg|jpg|gif|png)$/) != null) return 1;
      else if (file.name.match(/\.(pdf)$/) != null) return 3;

      return 0;
    }
  }
})();

/**
 * Created by Misiek on 2016-08-01.
 */
angular.module("smakmak.directives").directive("httpSrc", [
  "$http",
  "SessionService",
  function ($http, SessionService) {
    var directive = {
      link: link,
      restrict: "A",
    };
    return directive;

    function link(scope, element, attrs) {
      var requestConfig = {
        method: "GET",
        url: attrs.httpSrc,
        responseType: "arraybuffer",
        headers: {
          Authorization: SessionService.getAuthorisationHeader(),
        },
      };

      $http(requestConfig).then(function (response) {
        var arr = new Uint8Array(response.data);

        var raw = "";
        var i,
          j,
          subArray,
          chunk = 5000;
        for (i = 0, j = arr.length; i < j; i += chunk) {
          subArray = arr.subarray(i, i + chunk);
          raw += String.fromCharCode.apply(null, subArray);
        }

        var b64 = btoa(raw);

        attrs.$set("src", "data:image/jpeg;base64," + b64);
      });
    }
  },
]);

(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("VisitsController", VisitsController);

  VisitsController.$inject = [
    "$scope",
    "$q",
    "$state",
    "$log",
    "$stateParams",
    "$translate",
    "$sessionStorage",
    "$localStorage",
    "visitRest",
    "constRest",
    "SessionService",
    "userRest",
    "ContractorSelectService",
    "documentRest",
    "$interval",
    "Notification",
    "counterRest",
    "changeStorageService",
    "sweetAlert",
    "logRest"
  ];

  function VisitsController(
    $scope,
    $q,
    $state,
    $log,
    $stateParams,
    $translate,
    $sessionStorage,
    $localStorage,
    visitRest,
    constRest,
    SessionService,
    userRest,
    ContractorSelectService,
    documentRest,
    $interval,
    Notification,
    counterRest,
    changeStorageService,
    sweetAlert,
    logRest
  ) {
    /* jshint validthis: true */
    var vm = this;
    //functions
    vm.setPageSize = setPageSize;
    vm.setTotalCount = setTotalCount;
    vm.loadDictionaryData = loadDictionaryData;
    vm.loadDataWithPagingData = loadDataWithPagingData;
    vm.loadData = loadData;
    vm.pageChanged = pageChanged;
    vm.goToElement = goToElement;
    vm.removeVisit = removeVisit;
    vm.openDP = openDP;
    vm.onFilterChange = onFilterChange;
    vm.resetSearchTerms = resetSearchTerms;
    vm.onSelect = onSelect;
    vm.onSelectUser = onSelectUser;
    vm.onSelectPageCount = onSelectPageCount;
    vm.selectContractor = selectContractor;
    vm.selectAll = selectAll;
    vm.acceptVisits = acceptVisits;
    vm.addManualReturn = addManualReturn;
    vm.checkPermission = checkPermission;
    vm.sendDocAgainToAccountingSystem = sendDocAgainToAccountingSystem;
    vm.changeDocumentStatus = changeDocumentStatus;
    vm.changeDocumentStatusWithConfirm = changeDocumentStatusWithConfirm;
    vm.changeStorage = changeStorage;
    vm.changeStorageSelected = changeStorageSelected;
    vm.onDateChange = onDateChange;
    vm.selectAllForChangeStorage = selectAllForChangeStorage;
    vm.print = print;
    vm.changeColumns = changeColumns;
    vm.addVisit = addVisit;
    //data
    vm.loggedUser = undefined;
    vm.viewEditDD = false;
    vm.data = undefined;
    vm.isDataReloading = false;
    vm.documentSums = [];
    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      beginDate: undefined,
      endDate: undefined,
      selectedUserId: undefined,
      selectedUserObject: null,
      contractorId: undefined,
      contractorObj: undefined,
      contractorSymbol: undefined,
      OrderDocumentStatus: undefined,
      QualityReturnDocumentStatus: undefined,
      ReturnDocumentStatus: undefined,
      isComment: false,
      sampleStatus: undefined
    };
    vm.viewVisitsConfig = {
      order: true,
      timeReturn: true,
      qualityReturn: true,
      sample: false,
      degustation: false
    };
    vm.dictionaryData = {};
    vm.userDictName = "UsersDictionary";
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined
    };
    vm.selectAllTimeReturn = false;
    vm.selectAllOrder = false;
    vm.selectAllQualityReturn = false;
    vm.selectAllTimeReturnCount = 0;
    vm.selectAllOrderCount = 0;
    vm.selectAllQualityReturnCount = 0;
    vm.selectAllTimeReturnCountSelected = 0;
    vm.selectAllOrderCountSelected = 0;
    vm.selectAllQualityReturnCountSelected = 0;
    vm.isSelectAllForChangeStorage = false;

    vm.refresh = {
      refreshInterval: undefined,
      refreshTimeTotal: 180,
      refreshTime: 180
    };

    vm.OrderDocumentStatusDictionary = [
      {
        id: 1,
        name: "Akceptacja"
      },
      {
        id: 2,
        name: "Akceptacja logistyka"
      },
      {
        id: 10,
        name: "Zaakceptowany"
      },
      {
        id: 11,
        name: "Przetwarzanie"
      },
      {
        id: 12,
        name: "Przetworzony"
      },
      {
        id: 20,
        name: "Wysłany"
      },
      {
        id: 21,
        name: "Błąd"
      },
      {
        id: 30,
        name: "Odrzucony"
      }
    ];

    vm.QualityReturnDocumentStatusDictionary = [
      {
        id: 1,
        name: "Akceptacja"
      },
      {
        id: 10,
        name: "Zaakceptowany"
      },
      {
        id: 11,
        name: "Przetwarzanie"
      },
      {
        id: 12,
        name: "Przetworzony"
      },
      {
        id: 13,
        name: "Zaakceptowany częściowo"
      },
      {
        id: 14,
        name: "Przetworzony - brak zwrotów"
      },
      {
        id: 22,
        name: "Dodany ręcznie"
      },
      {
        id: 30,
        name: "Odrzucony"
      }
    ];

    vm.ReturnDocumentStatusDictionary = [
      {
        id: 1,
        name: "Akceptacja"
      },
      {
        id: 6,
        name: "Odłożony"
      },
      {
        id: 10,
        name: "Zaakceptowany"
      },
      {
        id: 11,
        name: "Przetwarzanie"
      },
      {
        id: 12,
        name: "Przetworzony"
      },
      {
        id: 14,
        name: "Przetworzony - brak zwrotów"
      },
      {
        id: 22,
        name: "Dodany ręcznie"
      },
      {
        id: 31,
        name: "Anulowany"
      }
    ];

    vm.SamplesStatusDictionary = [
      {
        id: 1,
        name: "Akceptacja"
      },
      {
        id: 10,
        name: "Zaakceptowany"
      },
      {
        id: 11,
        name: "Do wysłania"
      },
      {
        id: 23,
        name: "Wysłany do klienta"
      },
      {
        id: 30,
        name: "Odrzucony"
      }
    ];

    constructor();

    function constructor() {
      $log.debug("VisitsController");
      vm.loggedUser = getLoggedUser();
      loadDictionaryData("PageSizeDictionary");
      vm.setPageSize(10);
      if ($sessionStorage.visitsPagingData != undefined)
        vm.pagingData = $sessionStorage.visitsPagingData;
      if ($localStorage.viewVisitsConfig != undefined)
        vm.viewVisitsConfig = $localStorage.viewVisitsConfig;
      loadUserDictionaryData().then(function() {
        loadDataWithPagingData(true);
      });
      initReload();
    }

    $scope.$on("$destroy", function() {
      stopReload();
    });

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }

    function stopReload() {
      if (vm.refresh.refreshInterval != undefined) {
        $interval.cancel(vm.refresh.refreshInterval);
      }
    }

    function resetReloadTime() {
      vm.refresh.refreshTime = vm.refresh.refreshTimeTotal;
    }

    function initReload() {
      resetReloadTime();
      vm.refresh.refreshInterval = $interval(function() {
        var ele = _.find(vm.data, function(vv) {
          if (vv.acceptQualityReturn == true || vv.acceptTimeReturn == true) {
            return true;
          } else {
            return false;
          }
        });
        if (ele != undefined) {
          return;
        }
        vm.refresh.refreshTime--;
        if (vm.refresh.refreshTime < 0) {
          resetReloadTime();
          loadDataWithPagingData(false);
        }
      }, 1000);
    }

    function getCounter() {
      if (vm.pagingData.selectedUserId == undefined) {
        return;
      }
      if (
        vm.prevUser != undefined &&
        vm.prevUser != vm.pagingData.selectedUserId
      ) {
        vm.counters = undefined;
        vm.prevUser = vm.pagingData.selectedUserId;
      }

      vm.isCounterReloading = true;
      counterRest
        .get(vm.pagingData.selectedUserId, new Date())
        .then(function(counters) {
          vm.counters = counters;
          vm.isCounterReloading = false;
        })
        .catch(function(error) {
          vm.isCounterReloading = false;
        });
    }

    function getDocumentSum(
      page,
      count,
      getCount,
      beginDate,
      endDate,
      contractorId,
      userId,
      contractorSymbol,
      orderDocumentStatus,
      qualityReturnDocumentStatus,
      returnDocumentStatus,
      isComment,
      docSum,
      net
    ) {
      if (vm.pagingData.selectedUserId == undefined) {
        return;
      }
      if (
        vm.prevUser != undefined &&
        vm.prevUser != vm.pagingData.selectedUserId
      ) {
        vm.documentSums[docSum] = undefined;
        vm.prevUser = vm.pagingData.selectedUserId;
      }
      visitRest
        .sum(
          page,
          count,
          getCount,
          beginDate,
          endDate,
          contractorId,
          userId,
          contractorSymbol,
          orderDocumentStatus,
          qualityReturnDocumentStatus,
          returnDocumentStatus,
          isComment,
          docSum,
          net
        )
        .then(function(summ) {
          vm.documentSums[docSum] = summ;
        })
        .catch(function(error) {});
    }

    function sendDocAgainToAccountingSystem(docId, visit, lockField) {
      if (visit[lockField]) {
        return;
      }
      blockRecords(visit, lockField);
      documentRest
        .sendAgainToAccountingSystem(docId)
        .then(function() {
          var message = $translate.instant("documents.notifications.sendAgain");
          Notification.success(message);
          loadDataWithPagingData(true);
        })
        .catch(function(error) {
          var message = $translate.instant(
            "documents.notifications.sendAgainError"
          );
          Notification.error(message);
        })
        .finally(function() {
          unblockRecords(visit, lockField);
        });
    }

    function changeDocumentStatus(docId, status, visit, lockField) {
      if (visit[lockField]) {
        return;
      }
      blockRecords(visit, lockField);
      documentRest
        .changeStatus(docId, status)
        .then(function() {
          var message = $translate.instant(
            "documents.notifications.changeStatus"
          );
          Notification.success(message);
          loadDataWithPagingData(true);
        })
        .catch(function(error) {
          var message = $translate.instant(
            "documents.notifications.changeError"
          );
          Notification.error(message);
        })
        .finally(function() {
          unblockRecords(visit, lockField);
        });
    }

    function blockRecords(objectToBlock, lockField) {
      changeRecordsStatus(objectToBlock, true, lockField);
    }

    function unblockRecords(objectToBlock, lockField) {
      changeRecordsStatus(objectToBlock, false, lockField);
    }

    function changeRecordsStatus(objectToBlock, status, lockField) {
      objectToBlock[lockField] = status;
    }

    function changeDocumentStatusWithConfirm(docId, status, visit, lockField) {
      if (visit.isBlocked) {
        return;
      }
      sweetAlert
        .swal({
          title: "Uwaga",
          text: "Zamierzasz odrzucić dokument",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Potwierdzam",
          cancelButtonText: "Zrezygnuj",
          closeOnConfirm: false,
          closeOnCancel: true
        })
        .then(
          function() {
            changeDocumentStatus(docId, status, visit, lockField);
          },
          function(dismiss) {
            // dismiss can be 'cancel', 'overlay',
            // 'close', and 'timer'
          }
        );
    }

    function loadUserDictionaryData() {
      var deferred = $q.defer();
      var salesUsers = [];
      var superiorUsers = [];
      userRest
        .getSalesRepresentatives(
          SessionService.getAuthenticatedUser().Id,
          undefined,
          undefined,
          200,
          1,
          false
        )
        //userRest.all(undefined, undefined, 200, 1, false, 40, undefined, false, true,vm.loggedUser.Id, true)
        .then(function(data) {
          salesUsers = data;
          return loadSuperiorUsers();
        })
        .then(function(data2) {
          superiorUsers = data2;
          sortUsersForSelect(superiorUsers, salesUsers);
          setSuperiorOnFilterIfLogged();
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        })
        .finally(function() {
          deferred.resolve();
        });
      return deferred.promise;
    }

    function loadSuperiorUsers() {
      if (vm.loggedUser.JobTitleId != 30) {
        return userRest.all(
          true,
          undefined,
          100,
          1,
          false,
          30,
          undefined,
          false,
          true,
          vm.loggedUser.Id,
          undefined
        );
      } else {
        return [vm.loggedUser];
      }
    }

    function sortUsersForSelect(superiorUsers, salesUsers) {
      var mergedUsers = [];
      superiorUsers.forEach(function(superior) {
        superior.IsSuperior = true;
        mergedUsers.push(superior);
        addSalesUsers(superior.Id, salesUsers, mergedUsers);
      });
      vm.dictionaryData[vm.userDictName] = mergedUsers;
    }

    function setSuperiorOnFilterIfLogged() {
      if (vm.loggedUser.JobTitleId == 30) {
        vm.pagingData.selectedUserId = vm.loggedUser.Id;
      }
    }

    function addSalesUsers(superiorId, salesUsers, mergedUsers) {
      for (var i = 0; i < salesUsers.length; i++) {
        if (superiorId == salesUsers[i].superiorId) {
          mergedUsers.push(salesUsers[i]);
        }
      }
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function(data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function(a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    }

    function loadDataWithPagingData(getCount) {
      resetReloadTime();
      //getCounter();
      vm.loadData(
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.contractorId,
        vm.pagingData.selectedUserId,
        vm.pagingData.contractorSymbol,
        vm.pagingData.OrderDocumentStatus,
        vm.pagingData.QualityReturnDocumentStatus,
        vm.pagingData.ReturnDocumentStatus,
        vm.pagingData.isComment,
        vm.pagingData.sampleStatus
      );
    }

    function selectAll(type) {
      var selectedCount = 0;

      _.forEach(vm.data, function(visit) {
        if (type == 1) {
          visit.acceptDocument = vm.selectAllOrder;
          if (visit.acceptDocument == true) selectedCount++;
        }
        if (type == 2) {
          visit.acceptQualityReturn = vm.selectAllQualityReturn;
          if (visit.acceptQualityReturn == true) selectedCount++;
        }
        if (type == 3) {
          if (visit.ReturnDocumentStatus > 1) {
            return;
          }
          visit.acceptTimeReturn = vm.selectAllTimeReturn;
          if (visit.acceptTimeReturn == true) selectedCount++;
        }
      });
    }

    function selectOne(visit, type) {
      if (type == 1) {
        if (visit.acceptDocument == true) vm.selectAllOrderCountSelected++;
        else vm.selectAllOrderCountSelected--;
        if (vm.selectAllOrderCount == vm.selectAllOrderCountSelected) {
        }
      }
      if (type == 2) {
        visit.acceptQualityReturn = vm.selectAllQualityReturn;
        selectedCount++;
      }
      if (type == 3) {
        visit.acceptTimeReturn = vm.selectAllTimeReturn;
        selectedCount++;
      }
    }

    function addManualReturn(docId) {
      var visitsToAccept = [{ DocumentId: docId, Action: 4 }];
      sendVisitsToAccept(visitsToAccept);
    }

    function acceptVisits(action) {
      var ac = action;
      var visitsToAccept = [];
      _.forEach(vm.data, function(key) {
        if (
          key.acceptQualityReturn &&
          key.QualityReturnDocumentId != null &&
          key.IsQualityReturnDocumentAccepted === false
        ) {
          visitsToAccept.push({
            DocumentId: key.QualityReturnDocumentId,
            Action: ac
          });
        }
        if (
          key.acceptTimeReturn &&
          key.ReturnDocumentId != null &&
          key.IsReturnDocumentAccepted === false
        ) {
          visitsToAccept.push({ DocumentId: key.ReturnDocumentId, Action: ac });
        }
      });
      sendVisitsToAccept(visitsToAccept);
    }

    function sendVisitsToAccept(visitsToAccept) {
      documentRest
        .acceptEntitiesOrDocument(visitsToAccept)
        .then(function(response) {
          var message = $translate.instant(
            "documents.notifications.changeStatus"
          );
          Notification.success(message);
          loadDataWithPagingData(true);
        })
        .catch(function(error) {
          var message = $translate.instant(
            "documents.notifications.changeError"
          );
          Notification.error(message);
        });
    }

    function loadData(
      count,
      page,
      getCount,
      beginDate,
      endDate,
      contractorId,
      userId,
      contractorSymbol,
      orderDocumentStatus,
      qualityReturnDocumentStatus,
      returnDocumentStatus,
      isComment,
      sampleStatus
    ) {
      vm.isDataReloading = true;

      visitRest
        .list(
          page,
          count,
          getCount,
          beginDate,
          endDate,
          contractorId,
          userId,
          contractorSymbol,
          orderDocumentStatus,
          qualityReturnDocumentStatus,
          returnDocumentStatus,
          isComment,
          sampleStatus
        )
        .then(function(result) {
          vm.data = result;
          addCreateDateOffsets(vm.data);
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
          vm.selectAllTimeReturnCount = 0;
          vm.selectAllOrderCount = 0;
          vm.selectAllQualityReturnCount = 0;
          vm.selectAllTimeReturn = false;
          vm.selectAllOrder = false;
          vm.selectAllQualityReturn = false;

          _.forEach(vm.data, function(visit) {
            if (
              visit.QualityReturnDocumentId != null &&
              visit.IsQualityReturnDocumentAccepted == false
            ) {
              vm.selectAllQualityReturnCount++;
            }
            if (
              visit.OrderDocumentId != null &&
              visit.IsOrderDocumentAccepted == false
            ) {
              vm.selectAllOrderCount++;
            }
            if (
              visit.ReturnDocumentId != null &&
              visit.IsReturnDocumentAccepted == false
            ) {
              vm.selectAllTimeReturnCount++;
            }
          });
        })
        .catch(function(error) {
          $log.debug("Error while visits data: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
      getDocumentSum(
        page,
        count,
        getCount,
        beginDate,
        endDate,
        contractorId,
        userId,
        contractorSymbol,
        orderDocumentStatus,
        qualityReturnDocumentStatus,
        returnDocumentStatus,
        isComment,
        0,
        true
      );
      getDocumentSum(
        page,
        count,
        getCount,
        beginDate,
        endDate,
        contractorId,
        userId,
        contractorSymbol,
        orderDocumentStatus,
        qualityReturnDocumentStatus,
        returnDocumentStatus,
        isComment,
        1,
        true
      );
      getDocumentSum(
        page,
        count,
        getCount,
        beginDate,
        endDate,
        contractorId,
        userId,
        contractorSymbol,
        orderDocumentStatus,
        qualityReturnDocumentStatus,
        returnDocumentStatus,
        isComment,
        2,
        true
      );
      getDocumentSum(
        page,
        count,
        getCount,
        beginDate,
        endDate,
        contractorId,
        userId,
        contractorSymbol,
        orderDocumentStatus,
        qualityReturnDocumentStatus,
        returnDocumentStatus,
        isComment,
        3,
        true
      );
      getDocumentSum(
        page,
        count,
        getCount,
        beginDate,
        endDate,
        contractorId,
        userId,
        contractorSymbol,
        orderDocumentStatus,
        qualityReturnDocumentStatus,
        returnDocumentStatus,
        isComment,
        4,
        true
      );
    }

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    function onFilterChange() {
      $sessionStorage.visitsPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.visitsPagingData = vm.pagingData;
    }

    function goToElement(key) {
      $state.go("home.visits.visit", { id: key.Id, cameFrom: "visits" });
    }

    function addCreateDateOffsets(data) {
      data.forEach(function(item) {
        item.CreateDateTime = new Date(item.CreateDateTime);
        var timezoneOffset = item.CreateDateTime.getTimezoneOffset(),
          time = item.CreateDateTime.getTime();
        item.CreateDateTime = new Date(time - timezoneOffset * 60 * 1000);
      });
    }

    function removeVisit(visit) {
      visitRest
        .remove(visit.Id)
        .then(function(data) {
          onFilterChange();
        })
        .catch(function(err) {
          console.log(err);
        });
    }

    //opens datepicker
    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      vm.onFilterChange();
    }

    function resetSearchTerms() {
      vm.pagingData.currentPage = 1;
      vm.pagingData.beginDate = undefined;
      vm.pagingData.endDate = undefined;
      vm.pagingData.contractorId = undefined;
      vm.pagingData.contractorObj = undefined;
      vm.pagingData.selectedUserId = undefined;
      vm.pagingData.selectedUserObject = null;
      vm.pagingData.contractorSymbol = undefined;
      vm.pagingData.OrderDocumentStatus = undefined;
      vm.pagingData.QualityReturnDocumentStatus = undefined;
      vm.pagingData.ReturnDocumentStatus = undefined;
      vm.pagingData.isComment = false;
      vm.beginDateOptions.maxDate = undefined;
      vm.endDateOptions.minDate = undefined;
      vm.pagingData.sampleStatus = undefined;

      setSuperiorOnFilterIfLogged();
      onFilterChange();
    }

    function onSelectUser(item, model) {
      vm.pagingData.selectedUserObject = item;
      onSelect(item, model);
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function selectContractor() {
      var callback = function(obj) {
        vm.pagingData.contractorObj = obj;
        vm.pagingData.contractorId = obj.Id;
        onFilterChange();
      };

      var callbackCheck = function(obj) {
        if (vm.pagingData.contractorId === obj.Id) return true;
        else {
          return undefined;
        }
      };

      ContractorSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        undefined,
        undefined
      );
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function changeStorage(Id) {
      changeStorageService.show("lg", Id, undefined).then(function(isReload) {
        if (isReload) loadDataWithPagingData(true);
      });
    }

    function selectAllForChangeStorage() {
      vm.data.forEach(function(visit) {
        if (visit.OrderDocumentStatus == 2) {
          visit.IsChangeStorage = vm.isSelectAllForChangeStorage;
        }
      });
    }

    function changeStorageSelected() {
      var documentIds = [];
      vm.data.forEach(function(visit) {
        if (visit.IsChangeStorage) {
          documentIds.push(visit.OrderDocumentId);
        }
      });
      changeStorageService
        .show("lg", undefined, documentIds)
        .then(function(isReload) {
          if (isReload) loadDataWithPagingData(true);
        });
    }

    function print() {
      window.print();
    }

    function changeColumns(columnField) {
      vm.viewVisitsConfig[columnField] = !vm.viewVisitsConfig[columnField];
      $localStorage.viewVisitsConfig = vm.viewVisitsConfig;
    }

    function addVisit() {
      var callback = function(obj) {
        logRest.post(
          vm.loggedUser.Id,
          "visits.controller | Add visit without event for contractorId: " +
            obj.Id
        );
        $state.go("home.order", { id: obj.Id });
      };

      var callbackCheck = function(obj) {
        return undefined;
      };

      ContractorSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        undefined,
        false
      );
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('VisitController', VisitController);

  VisitController.$inject = ['$state', '$log', '$stateParams', '$translate', 'eventsRest', 'userRest', 'SessionService', 'visitRest', 'Notification', 'constRest'];

  function VisitController($state, $log, $stateParams, $translate, eventsRest, userRest, SessionService, visitRest, Notification, constRest) {
    /* jshint validthis: true */
    var vm = this;
    vm.goBack = goBack;
    vm.comment = comment;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.goToDocument = goToDocument;

    vm.cameFrom = undefined;
    vm.dictionaryData = {};
    vm.currentVisit = undefined;

    //init
    constructor();

    function constructor(){
      $log.debug("VisitController");
      if($stateParams.cameFrom !== undefined){
        vm.cameFrom = $stateParams.cameFrom;
      }
      loadDictionaryData("CountryDictionary");
      loadDictionaryData("ProvinceDictionary");
      if ($stateParams.id > 0) {
        loadData($stateParams.id);
      }
    }

    function goToDocument(id){
      $state.go("home.documents.document", { id: id });
    }

    function comment(id, comment){
     visitRest.comment(id, {Comment: comment})
     .then(function(ret){
        Notification.success("Komentarz został zapisany");
      })
      then(function(visit){
        Notification.error("Nie udało się zapisać komentarza");
      });
   }

   function loadDictionaryData(name) {
     constRest.getDictionary(name)
       .then(function (data) {
         vm.dictionaryData[name] = data;
         if (name === "ContractorGroupDictionary") {
           vm.dictionaryData[name].sort(function (a, b) {
             if (a.Value == undefined)
               return -1;
             if (b.Value == undefined)
               return 1;
             if (a.Value < b.Value)
               return -1;
             else if (a.Value > b.Value)
               return 1;
             else
               return 0;
           });
         }
       })
       .catch(function (error) {
         $log.debug("Error while getting dictionary: " + name);
         vm.error = error;
       });
   };

    function loadData(id){
      visitRest.get(id).then(function(visit){
        vm.currentVisit = visit;
        setReceiverData();
      });
    }

    function setReceiverData(){
      if(vm.currentVisit.ContractorObject.IsDeliveryAddress){
        vm.currentVisit.Receiver = vm.currentVisit.ContractorObject.DeliveryAddress;
      }else{
        vm.currentVisit.Receiver = vm.currentVisit.ContractorObject.DefaultAddress;
      }
    }

    function goBack(){
      if(vm.cameFrom !== undefined)
        $state.go("home." + vm.cameFrom);
      else {
        $state.go("home.visits");
      }
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('changeStorageService', changeStorageService);

  changeStorageService.$inject = ['$log', '$uibModal', '$state', '$q'];

  function changeStorageService($log, $uibModal, $state, $q) {

    var service = {
      show: showModal,
      getDocumentId: getDocumentId,
      getDocumentIdArray: getDocumentIdArray,
      showConfirmModal: showConfirmModal
    };

    return service;

    //var
    var isVisible = false;
    var documentIdd = undefined;
    var documentIdArrayy = undefined;

    function showModal(size, documentId, documentIdArray) {
      if (isVisible)
        return;

      documentIdd = documentId;
      documentIdArrayy = documentIdArray;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/visits/changeStorage.modal.html',
        controller: 'changeStorageController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        }
      });

      var deferred = $q.defer();

      isVisible = true;
      modalInstance.result.then(function (data) {
        $log.info('Modal ok with ' + data);
        isVisible = false;
        deferred.resolve(data);
      }, function (err) {
        $log.info('Modal dismissed with:  ' + err);
        isVisible = false;
        deferred.reject();
      });
      return deferred.promise;
    }

    function showConfirmModal(requestData){
      return $uibModal.open({
        animation: true,
        templateUrl: 'app/components/visits/changeStorageConfirm.modal.html',
        size: 'sm',
        controller: 'changeStorageConfirmController',
        controllerAs: 'vm',
        resolve: {
          data: function () {
            return requestData
          }
        }
      });
    }

    function getDocumentId(){
      return documentIdd;
    }

    function getDocumentIdArray() {
      return documentIdArrayy;
    }

  };

  angular
    .module('smakmak.controllers')
    .controller('changeStorageController', changeStorageController);

  /** @ngInject */
  function changeStorageController($scope, $uibModalInstance, $log, documentRest, storageRest, changeStorageService, Notification, $translate) {
    var vm = this;

    //functions
    vm.action = action;
    vm.onSelectStorage = onSelectStorage;
    //data
    vm.document = undefined;
    vm.dictionaryData = {};
    vm.isSingleDocument = false;
    vm.documentIds = [];
    //datePicker
    vm.openDP = openDP;
    vm.datePickerReleaseOpened = false;
    vm.datePickerFinishOpened = false;
    vm.releaseDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: new Date().add(0).day()
    };
    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: new Date().add(0).day()
    };

    constructor();

    function constructor() {
      if (changeStorageService.getDocumentId() !== undefined) {
        vm.isSingleDocument = true;
        loadDocument();
      } else {
        vm.isSingleDocument = false;
        setUpDocumentObjectForPlural();
        vm.document.DocumentIds = changeStorageService.getDocumentIdArray();
      }
      loadStoragesData();
    }

    function setUpDocumentObjectForPlural() {
      vm.document = {};
      vm.document.DocumentReleaseDate = new Date().add(0).day();
      setFinishDate();
      vm.document.Storage = undefined;
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function loadDocument() {
      var id = changeStorageService.getDocumentId();
      documentRest.get(id).then(function (document) {
        vm.document = document;
        setReleaseDate();
        setFinishDate();
      }).catch(function (error) {
        $log.debug("Error while getting document");
      });
    }

    function setReleaseDate(){
      var tmpDate = Date.today();
      var tmpDay = tmpDate.getDay();
      var relDate = (new Date(vm.document.DocumentReleaseDate)).getDay();
      if(tmpDay < relDate){
        tmpDate = tmpDay;
        tmpDay = relDate;
      }
        
      //determines if next working day is monday
      
      vm.document.DocumentReleaseDate = tmpDate;
    }

    function setFinishDate(){
      var tmpDate = Date.today();
      var tmpDay = tmpDate.getDay();
      //determines if next working day is monday
      var isMonday = false;
      if((tmpDay == 0) || (tmpDay == 5) || (tmpDay == 6)){
        isMonday = true;
      }
      if(isMonday){
        tmpDate = tmpDate.next().monday();
      }else{
        tmpDate = tmpDate.add(1).day();
      }
      vm.document.FinishDate = tmpDate;
    }

    function onSelectStorage(item, model){
      vm.document.StorageName = item.Name;
    }

    function openDP($event, statusObj) {
      if (statusObj == 1)
        vm.datePickerReleaseOpened = true;
      else
        vm.datePickerFinishOpened = true;
    };

    function action(isSave) {
      if (isSave) {
        formatDates();
        setMissingFields();
        showConfirmModal();
      } else {
        $uibModalInstance.close(false);
      }
    }

    function formatDates() {
      if (vm.document.DocumentReleaseDate != null) {
        var release = new Date(vm.document.DocumentReleaseDate);
        release.setHours(0, 0, 0, 0);
        if (release.getUTCDate() !== release.getDate()) {
          var timezoneOffset = release.getTimezoneOffset(), time = release.getTime();
          release = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.document.DocumentReleaseDate = release;
      } else {
        var release = new Date();
        release.setHours(0, 0, 0, 0);
        if (release.getUTCDate() !== release.getDate()) {
          var timezoneOffset = release.getTimezoneOffset(), time = release.getTime();
          release = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.document.DocumentReleaseDate = release;
      }

      if (vm.document.FinishDate != null && vm.document.FinishDate != undefined) {
        var finish = new Date(vm.document.FinishDate);
        finish.setHours(0, 0, 0, 0);
        if (finish.getUTCDate() !== finish.getDate()) {
          var timezoneOffset = finish.getTimezoneOffset(), time = finish.getTime();
          finish = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.document.FinishDate = finish;
      } else {
        var finish = new Date();
        finish.setHours(0, 0, 0, 0);
        if (finish.getUTCDate() !== finish.getDate()) {
          var timezoneOffset = finish.getTimezoneOffset(), time = finish.getTime();
          finish = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.document.FinishDate = finish;
      }
    }

    function setMissingFields(){
      if (vm.isSingleDocument) {
        vm.document.DocumentIds = [vm.document.Id];
        setStorageNameById();
      } else {
        vm.document.StorageId = vm.document.Storage;
      }
    }

    function setStorageNameById(){
      for(var i = 0; i < vm.dictionaryData.Storages.length; i++){
        if(vm.dictionaryData.Storages[i].Id == vm.document.Storage){
          vm.document.StorageName = vm.dictionaryData.Storages[i].Name;
          break;
        }
      }
    }

    function showConfirmModal(){
      var confirmInstance = changeStorageService.showConfirmModal(vm.document);
      confirmInstance.result.then(function (confirmed) {
        if(confirmed && vm.isSingleDocument){
          save();
        }else if(confirmed && !vm.isSingleDocument){
          savePlural();
        }else{
          return;
        }
      });
    }

    function save(){
      documentRest.logisticsAcceptance(vm.document.Id, vm.document.DocumentReleaseDate, vm.document.FinishDate, vm.document.Storage).then(function(){
        var message = $translate.instant('visits.notifications.changeSuccess');
        Notification.success(message);
        $uibModalInstance.close(true);
      }).catch(function () {
        var message = $translate.instant('visits.notifications.changeError');
        Notification.error(message);
        $uibModalInstance.close(false);
      });
    }

    function savePlural() {
      documentRest.logisticsAcceptanceMulti(vm.document).then(function () {
        var message = $translate.instant('visits.notifications.changeSuccess');
        Notification.success(message);
        $uibModalInstance.close(true);
      }).catch(function () {
        var message = $translate.instant('visits.notifications.changeError');
        Notification.error(message);
        $uibModalInstance.close(false);
      });
    }

}

angular
  .module('smakmak.controllers')
  .controller('changeStorageConfirmController', changeStorageConfirmController);

/** @ngInject */
function changeStorageConfirmController($scope, $uibModalInstance, data) {
    var vm = this;
    vm.data = data;
    vm.action = action;

    function action(result){
      $uibModalInstance.close(result);
    }
 }

})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ImgUploadController", ImgUploadController);

  ImgUploadController.$inject = ["$log", "Upload", "apiUrl"];

  function ImgUploadController($log, Upload, apiUrl) {
    /* jshint validthis: true */
    var vm = this;

    vm.onFileSelect = onFileSelect;

    vm.uploading = false;
    vm.progress = 0;

    function onFileSelect($file, $invalidFiles) {
      if (vm.uploading) return;
      vm.uploading = true;
      Upload.upload({
        url: apiUrl + "/MediaFiles/upload",
        data: { file: $file, Type: 11, ContextId: 22, ContextType: 33 },
      }).then(
        function (resp) {
          console.log(
            "Success " +
              resp.config.data.file.name +
              "uploaded. Response: " +
              resp.data
          );
          vm.uploading = false;
        },
        function (resp) {
          console.log("Error status: " + resp.status);
          vm.uploading = false;
        },
        function (evt) {
          vm.progress = parseInt((100.0 * evt.loaded) / evt.total);
        }
      );
    }

    ///////////////// FORMLY
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('UsersSelectService', UsersSelectService);

  UsersSelectService.$inject = ['$log', '$uibModal'];

  function UsersSelectService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      check: check,
      visible: visible,
      getEmployees: getEmployees,
      getAllIfPossible: getAllIfPossible,
      getUserId: getUserId,
      getIsActive: getIsActive,
      getJobTitleId: getJobTitleId,
      getSalesRepresentatives: getSalesRepresentatives,
      getNotShowingThisUser: getNotShowingThisUser
    };

    return service;

    //var
    var isVisible = false;
    var instance = undefined;
    var callbackMultiSelect = undefined;
    var checkFunction = undefined;
    var getEmployeess = false;
    var getAllIfPossiblee = false;
    var userIdd = undefined;
    var isActivee = undefined;
    var JobTitleIdd = undefined;
    var isSalesRepresentativess = undefined;
    //used if we want to hide one user (see objectives owner/user list example)
    var notShowingThisUserr = undefined;

    function showModal(size, callback, callbackMulti, checkFunc, getEmployees, getAllIfPossible, userId, isActive, JobTitleId, isSalesRepresentatives, notShowingThisUser) {
      if(isVisible)
        return;
      callbackMultiSelect = callbackMulti;
      checkFunction = checkFunc;
      isVisible = true;
      getEmployeess = getEmployees;
      getAllIfPossiblee = getAllIfPossible;
      userIdd = userId;
      isActivee = isActive;
      JobTitleIdd = JobTitleId;
      isSalesRepresentativess = isSalesRepresentatives;
      notShowingThisUserr = notShowingThisUser;

      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/users/usersSelect.html',
        controller: 'UsersController',
        controllerAs: 'vm',
        size: size,
        resolve: {

        }
      });

      //return modalInstance.result;
      instance.result.then(function (data) {
        $log.debug('usersSelect ok with ' + data);
        isVisible = false;
        if(data){
          callback(data);
        }
      }, function (err) {
        $log.debug('usersSelect dismissed with:  ' + err);
        resetServiceVariables();
        isVisible = false;
      });
    }

    function close(obj){
      if(callbackMultiSelect != undefined)
        callbackMultiSelect(obj);
      else{
        instance.close(obj);
        resetServiceVariables();
      }
    };

    function check(obj) {
      return checkFunction(obj);
    }

    function visible(){
      return isVisible;
    }

    function getEmployees(){
      return getEmployeess;
    }
    function getAllIfPossible(){
      return getAllIfPossiblee;
    }
    function getUserId(){
      return userIdd;
    }
    function getIsActive(){
      return isActivee;
    }
    function getJobTitleId(){
      return JobTitleIdd;
    }
    function getSalesRepresentatives(){
      return isSalesRepresentativess;
    }
    function getNotShowingThisUser(){
      return notShowingThisUserr;
    }
    function resetServiceVariables(){
      isVisible = false;
      instance = undefined;
      callbackMultiSelect = undefined;
      checkFunction = undefined;
      getEmployeess = false;
      getAllIfPossiblee = false;
      userIdd = undefined;
      isActivee = undefined;
      JobTitleIdd = undefined;
      isSalesRepresentativess = undefined;
      notShowingThisUserr = undefined;
    }

  };

})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('UsersController', UsersController);

  UsersController.$inject = ['$log', '$state', 'UsersService', '$translate', 'SessionService', 'constRest', '$sessionStorage', 'userRest', 'UsersSelectService', 'storageRest'];

  function UsersController($log, $state, UsersService, $translate, SessionService, constRest, $sessionStorage, userRest, UsersSelectService, storageRest) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadUsers = loadUsers;
    vm.togleActiveFlag = togleActiveFlag;
    vm.goToRegPass = goToRegPass;
    vm.getUserStatusText = getUserStatusText;
    vm.checkPermission = checkPermission;
    vm.back = back;
    vm.pageChanged = pageChanged;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.onSelect = onSelect;
    vm.selectUser = selectUser;
    vm.isAdded = isAdded;
    vm.resetSearchTerms = resetSearchTerms;
    vm.resetSearchTermsWithoutLoad = resetSearchTermsWithoutLoad;
    vm.getStrorageById = getStrorageById;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.setNotShowingThisUser = setNotShowingThisUser;

    ///////////////// data def
    vm.isDataReloading = false;
    vm.isLogged = false;
    vm.JobTitleId = undefined;
    vm.isActive = undefined;
    vm.isSalesRepresentatives = undefined;
    vm.userId = undefined;
    vm.notShowingThisUser = undefined;
    vm.userId = undefined;

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      isActive: undefined,
      searchStr: undefined,
      jobTitleId: undefined,
      storage: undefined,
      superiorId: undefined
    };
    vm.dictionaryData = {};
    vm.SessionObjectName = "usersPagingData";


    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("users.controller");
      //constructor body
      vm.JobTitleId = UsersSelectService.getJobTitleId();
      vm.isActive = UsersSelectService.getIsActive();
      vm.isSalesRepresentatives = UsersSelectService.getSalesRepresentatives();
      vm.userId = UsersSelectService.getUserId();
      vm.setNotShowingThisUser();

      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("ActiveDictionary");
      loadDictionaryData("JobTitleDictionary");
      loadStoragesData();
      loadSuperiorsData();

      if ($sessionStorage[vm.SessionObjectName] != undefined)
        vm.pagingData = angular.copy($sessionStorage[vm.SessionObjectName]);
      if (UsersSelectService.visible()) {
        vm.resetSearchTermsWithoutLoad();

        //parameters passed in modal
        if (vm.JobTitleId !== undefined)
          vm.pagingData.jobTitleId = vm.JobTitleId;
        if (vm.isActive !== undefined)
          vm.pagingData.isActive = vm.isActive;
      }

      loadDataWithPagingData(true);
    }

    function setNotShowingThisUser(){
      var notShowingThisUser = UsersSelectService.getNotShowingThisUser();
      if (notShowingThisUser !== undefined){
        vm.notShowingThisUser = notShowingThisUser;
      }
    }
    ///////////////// business logic
    function selectUser(obj) {
      UsersSelectService.close(obj);
    }

    function back() {
      $state.go('home.users');
    }

    function goToRegPass(userObj) {
      $state.get('home.users.registerPass').user = userObj;
      $state.go('home.users.registerPass', {'id': userObj.Id});
    }

    function getUserStatusText(userObj) {
      return userObj.IsActive ? $translate.instant('users.actions.active') : $translate.instant('users.actions.deactive');
    }

    function pageChanged() {
      loadDataWithPagingData(false);
      if (!UsersSelectService.visible()) {
        $sessionStorage[vm.SessionObjectName] = vm.pagingData;
      }
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      loadDataWithPagingData(true);
      if (!UsersSelectService.visible()) {
        $sessionStorage[vm.SessionObjectName] = vm.pagingData;
      }
    }

    function resetSearchTerms() {
      vm.resetSearchTermsWithoutLoad();
      onFilterChange();
    }

    function resetSearchTermsWithoutLoad() {
      vm.pagingData.isActive = undefined;
      vm.pagingData.jobTitleId = undefined;
      vm.pagingData.searchStr = undefined;
      vm.pagingData.storage = undefined;
      vm.pagingData.superiorId = undefined;
      vm.pagingData.currentPage = 1;

      //parameters passed in modal
      if(UsersSelectService.visible()) {
        if (vm.JobTitleId !== undefined)
          vm.pagingData.jobTitleId = vm.JobTitleId;
        if (vm.isActive !== undefined)
          vm.pagingData.isActive = vm.isActive;
      }
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }


    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }


    ///////////////// check state functions

    function isAdded(key) {
      var obj = UsersSelectService.check(key);
      if (obj === undefined)
        return false;
      else
        return true;
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function getStrorageById(id) {
      if (vm.dictionaryData["Storages"] == undefined || id == undefined)
        return;
      return vm.dictionaryData["Storages"].find(function (key) {
        return key.Id === id;
      });
    }

    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadUsers(vm.pagingData.isActive, vm.pagingData.searchStr, vm.pagingData.jobTitleId, vm.pagingData.storage, vm.pagingData.pageSize, vm.pagingData.currentPage, getCount, vm.isSalesRepresentatives, vm.pagingData.superiorId);
    }

    /*getEmployees, getAllIfPossible, userId are connected*/
    function loadUsers(isActive, searchStr, jobTitleId, storage, count, page, getCount, isSalesRepresentatives, superiorId) {
      console.log(isSalesRepresentatives);
      vm.isDataReloading = true;
      if (UsersSelectService.visible() && UsersSelectService.getEmployees() == true) {
        var getEmployees = UsersSelectService.getEmployees();
        var getAllIfPossible = UsersSelectService.getAllIfPossible();
      }
      if(isSalesRepresentatives){
        userRest.getSalesRepresentatives(vm.userId, searchStr, storage, count, page, getCount).then(function (result) {
          vm.users = result;
          if (result.totalCount) {
            vm.pagingData.totalCount = parseInt(result.totalCount, 10);
          }
          vm.isDataReloading = false;
        })
        .catch(function (error) {
          $log.debug("Error while getting users list: " + error.status);
          $log.debug(vm.pagingData);
          vm.isDataReloading = false;
        });
      }else{
        userRest.all(isActive, searchStr, count, page, getCount, jobTitleId, storage, getEmployees, getAllIfPossible, vm.userId, superiorId)
          .then(function (result) {
            vm.users = result;
            if (result.totalCount) {
              vm.pagingData.totalCount = parseInt(result.totalCount, 10);
            }
            vm.isDataReloading = false;
          })
          .catch(function (error) {
            $log.debug("Error while getting users list: " + error.status);
            $log.debug(vm.pagingData);
            vm.isDataReloading = false;
          });
      }
    }

    function togleActiveFlag(user) {
      user.disableChangeStatusButton = true;
      userRest.changeState(user.Id)
        .then(function (data) {
          user.disableChangeStatusButton = false;
          user.IsActive = data.IsActive;
        })
        .catch(function (error) {
          user.disableChangeStatusButton = false;
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function loadSuperiorsData() {
      userRest.getSuperiors()
        .then(function (data) {
          vm.dictionaryData["Superiors"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    ///////////////// FORMLY


  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('RegisterController', RegisterController);

  RegisterController.$inject = ['$scope', '$log', 'UsersService', 'AuthorizationService', '$stateParams', '$state', '$translate', '$filter'];

  function RegisterController($scope, $log, UsersService, AuthorizationService, $stateParams, $state, $translate, $filter) {
    var vm = this;

    ////////////// functions def
    vm.register = register;
    vm.changePassword = changePassword;
    vm.getUser = getUser;
    vm.submit = submit;
    vm.getButtonText = getButtonText;
    vm.updateUser = updateUser;

    ////////////// data def
    vm.registerObj = {
      EMail: '',
      password: '',
      password2: ''
    };
    vm.user = undefined;
    vm.isError = false;

    ///////////////// constructor call

    loadData();

    function loadData() {
      $log.debug("user.register.controller");
      vm.user = $state.current.user;
      if (vm.user === undefined) {
        vm.getUser($stateParams.id);
      }
      else {
        vm.registerObj.EMail = vm.user.EMail;
      }
    }

    /////////////////business logic
    function getButtonText() {
      if (vm.user.AccountId === null) {
        return $translate.instant('register.register');
      }
      else {
        return $translate.instant('register.changePassword');
      }
    }

    //function register(email, password, confirmPassword) {
    //  if (password !== confirmPassword) {
    //    fError('differentPasswords', 'validate');
    //  }
    //  else {
    //    AuthorizationService.registerUser(email, password, confirmPassword,
    //      function (obj) {
    //        vm.isError = false;
    //        $state.go('home.users');
    //      },
    //      function (err) {
    //        fError(err);
    //      }
    //    );
    //  }
    //}

    function changePassword(email, password, confirmPassword) {
      if (password !== confirmPassword) {
        fError('differentPasswords', 'validate');
      }
      else {
        AuthorizationService.changePasswordByAdministrator(email, password, confirmPassword,
          function (obj) {
            vm.isError = false;
            $state.go('home.users');
          },
          function (err) {
            fError(err);
          }
        );
      }
    }

    function submit(user) {
      $log.log(vm.registerObj);
      if (vm.user.AccountId === null) {

        var regFunction = function () {
          vm.register(vm.registerObj.EMail, vm.registerObj.password, vm.registerObj.password2);
        };
        if (vm.user.EMail !== vm.registerObj.EMail) {
          vm.user.EMail = vm.registerObj.EMail;
          vm.updateUser(vm.user, regFunction, fError);
        }
        else {
          regFunction();
        }
      }
      else {
        vm.changePassword(vm.registerObj.EMail, vm.registerObj.password, vm.registerObj.password2);
      }
    }

    function fError(err, type) {
      $log.log(type, err);
      vm.isError = true;
      if (type === 'validate') {
        vm.error = $filter('translate')('common.validators.' + err);
      }
      else {
        vm.error = $filter('translate')('common.services.register.' + err);
      }
    }

    ///////////////// watchers

    ///////////////// check state functions

    ///////////////// resource invoke functions

    function getUser(id) {
      UsersService.getUserById(id,
        function (data) {
          vm.user = data;
          vm.registerObj.EMail = data.EMail;
          if (vm.user.superiorId === 0) {
            vm.user.superiorId = undefined;
          }
        },
        function (error) {
          //error
        });
    }

    function register(email, password, confirmPassword) {
      if (vm.userForm.$invalid) {
        fError('formInvalid');
        return;
      }
      if (password !== confirmPassword) {
        fError('differentPasswords', 'validate');
      }
      else {
        AuthorizationService.registerUser(email, password, confirmPassword,
          function (obj) {
            vm.isError = false;
            $state.go('home.users');
          },
          function (err) {
            fError(err);
          }
        );
      }
    }

    function updateUser(user, freg, ferr) {
      //if (vm.userForm.$invalid) {
      //  fError("Proszę uzupełnić wszyskie wymagane pola: email, nazwisko!")
      //  return;
      //}

      if (user !== undefined) {
        UsersService.editUser(user,
          function (obj) {
            freg();
          },
          function (err) {
            ferr(err);
          }
        );
      }
    }

    ///////////////// FORMLY
    vm.userFields = [{
      key: 'EMail',
      type: 'input',
      templateOptions: {
        type: 'email',
        label: 'E-mail',
        placeholder: $translate.instant('common.form.email'),
        required: true,
        minlength: 6
      },
      validation: {
        messages: {
          // required: 'to.label + " jest wymagane"',
          minlength: 'to.label + " musi zawierać 6 znaków i znak @"'
        }
      }

    }, {
      key: 'password',
      type: 'input',
      templateOptions: {
        type: 'password',
        label: 'Hasło',
        placeholder: $translate.instant('common.form.password'),
        required: true,
        minlength: 6
      },
      validation: {
        messages: {
          minlength: 'to.label + " musi zawierać minimum 6 znaków"'
        }
      }
    },
      {
        key: 'password2',
        type: 'input',
        templateOptions: {
          type: 'password',
          label: 'Hasło',
          placeholder: $translate.instant('common.form.password'),
          required: true,
          minlength: 6
        },
        validation: {
          messages: {
            minlength: 'to.label + " musi zawierać minimum 6 znaków"'
          }
        }
      }];
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("UserController", UserController);

  UserController.$inject = [
    "$scope",
    "$log",
    "$state",
    "$stateParams",
    "$translate",
    "UsersService",
    "StorageService",
    "PermissionsService",
    "constRest",
    "userRest",
    "attributesHelper",
    "Notification",
  ];

  function UserController(
    $scope,
    $log,
    $state,
    $stateParams,
    $translate,
    UsersService,
    StorageService,
    PermissionsService,
    constRest,
    userRest,
    attributesHelper,
    Notification
  ) {
    var vm = this;

    ////////////// functions def
    vm.back = back;
    vm.submit = submit;
    vm.getUser = getUser;
    vm.updateUser = updateUser;
    //roles
    vm.getUserRoles = getUserRoles;
    vm.updateUserRoles = updateUserRoles;
    vm.getAllRoles = getAllRoles;
    vm.addRoleToUser = addRoleToUser;
    vm.removeRoleFromUser = removeRoleFromUser;
    vm.getStorages = getStorages;
    vm.getUsers = getUsers;
    vm.getUserSelectText = getUserSelectText;
    vm.someFunction = someFunction;
    vm.copyUserData = copyUserData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.removeAttribute = removeAttribute;
    vm.addAttribute = addAttribute;
    vm.jobTitleSelect = jobTitleSelect;
    vm.onDictSelect = onDictSelect;
    vm.addUserToDocumentSystem = addUserToDocumentSystem;

    ////////////// data def
    vm.user = {};
    vm.viewUser = {};
    vm.userRoles = [];
    vm.allRoles = [];
    vm.role = {};
    vm.rolesToAdd = [];
    vm.storages = [];
    vm.users = [];
    vm.phoneAttributes = {
      Attributes: [],
    };

    vm.userRolesLoaded = false;
    vm.allRolesLoaded = false;
    vm.isError = false;
    vm.error = {};
    vm.isLoading = false;
    vm.dictionaryData = {};
    vm.blockDocumentRegister = false;

    //datePicker
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.openDP = function ($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    };

    vm.dateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: new Date(2000, 0, 1),
    };

    ///////////////// constructor call

    loadData();

    function loadData() {
      $log.debug("user.controller");
      loadDictionaryData("TrueFalseDictionary");
      loadDictionaryData("UserPhoneTypeDictionary");
      loadDictionaryData("JobTitleDictionary");
      loadDictionaryData("DocumentCategoryDictionary");
      vm.getUser($stateParams.id);
      vm.getUserRoles($stateParams.id);
      vm.getAllRoles();
      vm.getStorages();
      vm.getUsers($stateParams.id);
    }

    /////////////////business logic

    //$scope.$watch('vm.viewUser.JobTitleId', function (newValue, oldValue) {
    //    if (newValue !== oldValue) {
    //    }
    //  }
    //);

    function onDictSelect($item) {
      vm.viewUser.QualityReturnDocumentCategory = $item.LocalId;
    }

    function jobTitleSelect($item, $model) {
      if ($model != undefined && $model != null) {
        vm.viewUser.superiorId = undefined;
        vm.getUsers(undefined, $model);
      } else vm.users = [];
    }

    function removeAttribute(attr) {
      vm.user.removeAttribute(attr);
      if (attr.Type == 1) vm.phoneAttributes.removeAttribute(attr);
    }

    function addAttribute(contextType, contextId, type, value, dictLocalId) {
      var attr = vm.user.addAttribute(
        contextType,
        contextId,
        type,
        value,
        dictLocalId
      );
      if (type == 1) vm.phoneAttributes.Attributes.push(attr);
    }

    function getUserSelectText(selectObj) {
      var str;
      if (selectObj == undefined || selectObj == {} || selectObj == 0)
        return "";
      str = selectObj.SurName + " " + selectObj.Name;
      if (selectObj.EMail != undefined && selectObj.EMail.length > 0)
        str = str + " (" + selectObj.EMail + ")";
      return str;
    }

    function setUserSuperiorId(id) {
      vm.user.superiorId = id;
    }

    function someFunction(item, model) {
      var a = 3;
      a++;
    }

    function checkRoles() {
      if (!vm.userRolesLoaded || !vm.allRolesLoaded) return;
      vm.rolesToAdd = [];
      angular.forEach(vm.allRoles, function (allRole) {
        var addRrole = true;
        angular.forEach(vm.userRoles, function (userRole) {
          if (userRole.GroupDefId == allRole.Id) {
            addRrole = false;
            return;
          }
        });
        if (addRrole) vm.rolesToAdd.push(allRole);
      });
    }

    function addRoleToUser(role) {
      if (role.Id == undefined) return;
      var newUserRole = {
        GroupDefId: role.Id,
        UserId: $stateParams.id,
        GroupDef: role,
      };
      vm.userRoles.push(newUserRole);
      updateUserRoles(vm.userRoles);
    }

    function removeRoleFromUser(role) {
      for (var i in vm.userRoles) {
        if (vm.userRoles[i].GroupDefId == role.GroupDefId) {
          vm.userRoles.splice(i, 1);
          break;
        }
      }
      updateUserRoles(vm.userRoles);
    }

    function back() {
      $state.go("home.users");
    }

    function submit(user) {
      updateUser(user);
    }

    function getStorages() {
      StorageService.getList(function (data) {
        vm.storages = data;
      });
    }

    function getUserRoles(id) {
      vm.loading = true;
      PermissionsService.getUserRoles(
        id,
        function (data) {
          vm.loading = false;
          vm.userRolesLoaded = true;
          vm.userRoles = data;
          checkRoles();
        },
        function (error) {
          vm.loading = false;
        }
      );
    }

    function updateUserRoles(objList) {
      vm.loading = true;
      PermissionsService.editUserRoles(
        $stateParams.id,
        objList,
        function (data) {
          vm.loading = false;
          //vm.UserRoles = data;
          checkRoles();
        },
        function (error) {
          vm.loading = false;
        }
      );
    }

    function getUser(id) {
      userRest
        .one(id, true, true)
        .then(function (data) {
          vm.user = data;
          if (vm.user.superiorId == 0) vm.user.superiorId = undefined;
          vm.user.EmploymentDateBegin = new Date(vm.user.EmploymentDateBegin);
          vm.user.EmploymentDateEnd = new Date(vm.user.EmploymentDateEnd);
          if (vm.user.EmploymentDateBegin.getFullYear() < 2000)
            vm.user.EmploymentDateBegin = undefined;
          if (vm.user.EmploymentDateEnd.getFullYear() < 2000)
            vm.user.EmploymentDateEnd = undefined;
          vm.copyUserData(vm.user, vm.viewUser);
          attributesHelper.extendObject(vm.user);
          vm.phoneAttributes.Attributes = vm.user.getAttributesByType(1);
          attributesHelper.extendObject(vm.phoneAttributes);
          if (
            vm.viewUser.SuperiorUser != null ||
            vm.viewUser.SuperiorUser != undefined
          ) {
            if (vm.users.length == 0) vm.users.push(vm.viewUser.SuperiorUser);
            var test = _.find(vm.users, function (ele) {
              return ele.Id == vm.viewUser.SuperiorUser.Id;
            });
            if (test == undefined) {
              vm.users.push(vm.viewUser.SuperiorUser);
            }
          }
        })
        .catch(function () {});
    }

    function copyUserData(src, dst) {
      dst.AccountId = src.AccountId;
      dst.City = src.City;
      dst.CreateDateTime = src.CreateDateTime;
      dst.EMail = src.EMail;
      dst.EmploymentDateBegin = src.EmploymentDateBegin;
      dst.EmploymentDateEnd = src.EmploymentDateEnd;
      dst.Id = src.Id;
      dst.IsActive = src.IsActive;
      dst.ModifiedDateTime = src.ModifiedDateTime;
      dst.Name = src.Name;
      dst.PostalCode = src.PostalCode;
      dst.RecordVersion = src.RecordVersion;
      dst.Storage = src.Storage;
      dst.StreetWithNumber = src.StreetWithNumber;
      dst.SubiektId = src.SubiektId;
      dst.SurName = src.SurName;
      dst.businessPhone = src.businessPhone;
      dst.privatePhone = src.privatePhone;
      dst.superiorId = src.superiorId;
      dst.AllowMobile = src.AllowMobile;
      dst.Attributes = src.Attributes;
      dst.JobTitleId = src.JobTitleId;
      dst.SuperiorUser = src.SuperiorUser;
      dst.QualityReturnDocumentCategory = src.QualityReturnDocumentCategory;
      dst.ReturnDocumentCategory = src.ReturnDocumentCategory;
      dst.OrderDocumentCategory = src.OrderDocumentCategory;
    }

    function getAllRoles() {
      vm.loading = true;
      PermissionsService.getAllRoles(
        function (data) {
          vm.allRolesLoaded = true;
          vm.loading = false;
          vm.allRoles = data;
          checkRoles();
        },
        function (error) {
          vm.loading = false;
        }
      );
    }

    function updateUser(user) {
      if (vm.userForm.$invalid) {
        fError($translate.instant("users.errors.eMailSurnameRequired"));
        return;
      }

      //ckech dates
      var dateFrom;
      var dateTo;
      //new Date(1900,1,1)
      if (
        vm.viewUser.EmploymentDateBegin != undefined &&
        vm.viewUser.EmploymentDateBegin != ""
      )
        dateFrom = new Date(vm.viewUser.EmploymentDateBegin);
      if (
        vm.viewUser.EmploymentDateEnd != undefined &&
        vm.viewUser.EmploymentDateEnd != ""
      )
        dateTo = new Date(vm.viewUser.EmploymentDateEnd);

      if (dateFrom != undefined && dateTo != undefined) {
        if (dateFrom > dateTo) {
          fError($translate.instant("users.errors.dateFromDateTo"));
          return;
        }
      }

      if (user !== undefined) {
        vm.copyUserData(vm.viewUser, user);
        userRest
          .save(user, true)
          .then(function () {
            var message = $translate.instant("users.notifications.updated");
            Notification.success(message);
            $state.go("home.users");
          })
          .catch(function () {
            fError(err);
            var message = $translate.instant("users.notifications.error");
            Notification.success(message);
            $state.go("error");
          });
      }
    }

    function getUsers(id, jobId) {
      if (id === undefined && jobId === undefined) return;
      userRest
        .getSuperiorUsers(id, jobId)
        .then(function (data) {
          vm.isLoading = false;
          vm.users = data;
          vm.users.sort(function (a, b) {
            if (a.SurName == undefined) return -1;
            if (b.SurName == undefined) return 1;
            if (a.SurName < b.SurName) return -1;
            else if (a.SurName > b.SurName) return 1;
            else return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error: " + error.status);
          vm.isLoading = false;
        });
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          if (name === "JobTitleDictionary") {
            var data = _.sortBy(data, "LocalId");
          }
          vm.dictionaryData[name] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
        });
    }

    function fError(err) {
      $log.log(err);
      vm.isLoading = false;
      vm.isError = true;
      vm.error = err;
    }

    function addUserToDocumentSystem(userId) {
      if (vm.blockDocumentRegister == true) return;
      vm.blockDocumentRegister = true;
      userRest
        .registerAsDocumentUser(userId)
        .then(function (res) {
          vm.blockDocumentRegister = false;
          vm.user.DocumentSystemid = res._id;
          var message = $translate.instant(
            "Zarejestrowano uzytkownika w systemie dokuentów"
          );
          Notification.success(message);
          //$state.go("home.users");
        })
        .catch(function () {
          fError(err);
          vm.blockDocumentRegister = false;
          var message = $translate.instant(
            "Błąd podczas rejestracji w systemie dokumentów"
          );
          Notification.error(message);
        });
    }

    vm.userFields = [
      {
        key: "EMail",
        type: "input",
        templateOptions: {
          type: "email",
          label: $translate.instant("users.user.label.email"),
          required: true,
          minlength: 6,
          // placeholder: $translate.instant('users.user.email')
        },
      },
      {
        key: "Name",
        type: "input",
        templateOptions: {
          type: "text",
          label: $translate.instant("users.user.label.name"),
          // placeholder: $translate.instant('users.user.name')
        },
      },
      {
        key: "SurName",
        type: "input",
        templateOptions: {
          type: "text",
          label: $translate.instant("users.user.label.surname"),
          required: true,
          minlength: 3,
          // placeholder: $translate.instant('users.user.surname'),
        },
      },
      {
        key: "City",
        type: "input",
        templateOptions: {
          type: "text",
          label: $translate.instant("users.user.label.city"),
          required: false,
          // placeholder: $translate.instant('users.user.address'),
        },
      },
      {
        key: "PostalCode",
        type: "input",
        templateOptions: {
          type: "text",
          label: $translate.instant("users.user.label.postalCode"),
          required: false,
          // placeholder: $translate.instant('users.user.address'),
        },
      },
      {
        key: "StreetWithNumber",
        type: "input",
        templateOptions: {
          type: "text",
          label: $translate.instant("users.user.label.streetWithNumber"),
          required: false,
          // placeholder: $translate.instant('users.user.address'),
        },
      },
    ];
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("TemplatesController", TemplatesController);

  TemplatesController.$inject = [
    "$state",
    "$translate",
    "constRest",
    "templateRest",
    "Notification",
  ];

  function TemplatesController(
    $state,
    $translate,
    constRest,
    templateRest,
    Notification
  ) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.goToAddTemplate = goToAddTemplate;
    vm.pageChanged = pageChanged;
    vm.onSelectPageCount = onSelectPageCount;
    vm.onSelect = onSelect;
    vm.removeTemplate = removeTemplate;
    //data
    vm.templateTypes = [
      { Name: "Powiadomienie", Value: 1 },
      { Name: "EDI", Value: 2 },
      { Name: "HDI", Value: 4 },
    ];
    vm.data = [];
    vm.isDataReloading = false;
    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      type: undefined,
    };
    vm.dictionaryData = {};

    loadData();

    function loadData() {
      loadDictionaryData("PageSizeDictionary");
      loadDataWithPagingData(true);
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function pageChanged() {
      loadDataWithPagingData(false);
    }

    function loadDataWithPagingData(getCount) {
      loadTemplatesData(
        vm.pagingData.currentPage,
        vm.pagingData.pageSize,
        getCount,
        vm.pagingData.type
      );
    }

    function loadTemplatesData(page, count, getCount, type) {
      vm.isDataReloading = true;
      templateRest
        .getList(page, count, getCount, type)
        .then(function (result) {
          setTypeNamesOnTemplates(result);
          vm.data = result;
          if (result.totalCount) {
            vm.pagingData.totalCount = result.totalCount;
          }
        })
        .finally(function () {
          vm.isDataReloading = false;
        });
    }

    function setTypeNamesOnTemplates(templates) {
      templates.forEach(function (template) {
        for (var i = 0; i < vm.templateTypes.length; i++) {
          if (template.Type == vm.templateTypes[i].Value) {
            template.TypeName = vm.templateTypes[i].Name;
            break;
          }
        }
      });
    }

    function goToAddTemplate() {
      $state.go("home.templates.template", { id: 0 });
    }

    function onSelectPageCount() {
      loadDataWithPagingData(true);
    }

    function onSelect() {
      loadDataWithPagingData(true);
    }

    function removeTemplate(template) {
      templateRest
        .remove(template)
        .then(function () {
          var message = $translate.instant(
            "templates.notifications.deleteSuccess"
          );
          Notification.success(message);
          loadDataWithPagingData(true);
        })
        .catch(function (error) {
          if (error.status == 405) {
            var message = $translate.instant(
              "templates.notifications.deleteIsUsed"
            );
            Notification.error(message);
          } else {
            var message = $translate.instant(
              "templates.notifications.deleteError"
            );
            Notification.error(message);
          }
        });
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("TemplateController", TemplateController);

  TemplateController.$inject = [
    "$state",
    "$stateParams",
    "$translate",
    "ContractorSelectService",
    "templateRest",
    "Notification",
    "DocumentsSelectService",
  ];

  function TemplateController(
    $state,
    $stateParams,
    $translate,
    ContractorSelectService,
    templateRest,
    Notification,
    DocumentsSelectService
  ) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.selectContractor = selectContractor;
    vm.selectDocument = selectDocument;
    vm.submit = submit;
    vm.validateTemplate = validateTemplate;
    vm.aceLoaded = aceLoaded;
    //data
    vm.currentTemplate = {};
    vm.contractorObject = undefined;
    vm.documentObject = undefined;
    vm.isTemplateModified = false;
    vm.templateTypes = [
      { Name: "Powiadomienie", Value: 1 },
      { Name: "EDI", Value: 2 },
      { Name: "HDI", Value: 4 },
    ];
    constructor();

    function constructor() {
      if ($stateParams.id && $stateParams.id != 0) {
        vm.currentTemplate.Id = $stateParams.id;
        templateRest
          .get($stateParams.id)
          .then(function (template) {
            vm.currentTemplate = template;
          })
          .catch(function () {
            var message = $translate.instant(
              "templates.notifications.loadSingleError"
            );
            Notification.error(message);
          });
      } else {
        vm.currentTemplate = {
          Id: 0,
          Type: 2,
          Title: "Tytuł",
          Name: "Unikatowa nazwa",
          Content: undefined,
        };
      }
    }

    function submit() {
      if (vm.currentTemplate.Id > 0) {
        updateTemplate();
      } else {
        addNew();
      }
    }

    function updateTemplate() {
      templateRest
        .update(vm.currentTemplate)
        .then(function (result) {
          console.log(result);
          var message = $translate.instant(
            "templates.notifications.updateSuccess"
          );
          Notification.success(message);
          $state.go("home.templates");
        })
        .catch(function (err) {
          console.log(err);
          if (
            err.data.ExceptionType ==
            "System.Data.Entity.Infrastructure.DbUpdateException"
          ) {
            var message = $translate.instant(
              "templates.notifications.nameExists"
            );
            Notification.error(message);
          } else {
            var message = $translate.instant(
              "templates.notifications.sendError"
            );
            Notification.error(message);
          }
        });
    }

    function addNew() {
      templateRest
        .add(vm.currentTemplate)
        .then(function (result) {
          console.log(result);
          var message = $translate.instant(
            "templates.notifications.sendSuccess"
          );
          Notification.success(message);
          $state.go("home.templates");
        })
        .catch(function (err) {
          console.log(err);
          if (
            err.data.ExceptionType ==
            "System.Data.Entity.Infrastructure.DbUpdateException"
          ) {
            var message = $translate.instant(
              "templates.notifications.nameExists"
            );
            Notification.error(message);
          } else {
            var message = $translate.instant(
              "templates.notifications.sendError"
            );
            Notification.error(message);
          }
        });
    }

    function validateTemplate() {
      if (!vm.documentObject) {
        var message = $translate.instant(
          "templates.notifications.validateNoDocumentNumber"
        );
        Notification.error(message);
        return;
      }
      templateRest
        .validate(vm.currentTemplate, vm.documentObject.Id)
        .then(function (result) {
          vm.currentTemplate.RenderedTemplate = result.RenderedTemplate;
          vm.isTemplateModified = false;
          var message = $translate.instant(
            "templates.notifications.validateSuccess"
          );
          Notification.success(message);
        })
        .catch(function () {
          var message = $translate.instant(
            "templates.notifications.validateError"
          );
          Notification.error(message);
        });
    }

    function aceLoaded(_editor) {
      _editor.setReadOnly(true);
    }

    function selectContractor() {
      var callback = function (contractor) {
        vm.contractorObject = contractor;
        vm.documentObject = undefined;
      };

      var callbackCheck = function (obj) {
        if (vm.contractorObject && vm.contractorObject.Id == obj.Id) {
          return true;
        } else {
          return undefined;
        }
      };

      ContractorSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        undefined,
        false
      );
    }

    function selectDocument() {
      var callback = function (document) {
        vm.documentObject = document;
      };

      var callbackCheck = function (obj) {
        if (vm.documentObject && vm.documentObject.Id == obj.Id) {
          return true;
        } else {
          return undefined;
        }
      };

      DocumentsSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        vm.contractorObject
      );
    }
  }
})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("UserTaskController", UserTaskController);

  UserTaskController.$inject = [
    "$log",
    "$stateParams",
    "$state",
    "constRest",
    "$sessionStorage",
    "SessionService",
    "taskRest",
    "userRest",
    "ContractorSelectService",
    "UsersSelectService",
    "ConstSelectService"
  ];

  function UserTaskController(
    $log,
    $stateParams,
    $state,
    constRest,
    $sessionStorage,
    SessionService,
    taskRest,
    userRest,
    ContractorSelectService,
    UsersSelectService,
    ConstSelectService
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadData = loadData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.checkPermission = checkPermission;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.remove = remove;
    vm.selectContractor = selectContractor;
    vm.selectUser = selectUser;
    vm.selectContractorGroup = selectContractorGroup;
    vm.submit = submit;
    vm.removeEntity = removeEntity;
    vm.addEntity = addEntity;
    vm.getProgress = getProgress;
    vm.removeUser = removeUser;
    vm.openDP = openDP;
    vm.isEntityValid = isEntityValid;
    vm.isTaskValid = isTaskValid;
    vm.isTaskStarted = isTaskStarted;
    vm.allowPropagate = allowPropagate;
    vm.goBack = goBack;
    vm.onDateChange = onDateChange;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerEndOpened = false;
    vm.datePickerBeginOpened = false;
    vm.onSelectType = onSelectType;
    vm.taskTypes = [];
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined
    };

    vm.dictionaryData = {};

    //workaround na ui-select.on-select
    vm.previousType = undefined;

    ///////////////// constructor call
    constructor();

    function constructor() {
      $log.debug("PreferredProductsController");
      //constructor body
      loadDictionaryData("ContractorGroupDictionary");
      loadDictionaryData("ProductGroupDictionary");
      loadDictionaryData("TaskUnitDictionary");
      loadDictionaryData("JobTitleDictionary");
      loadDictionaryData("ProductFieldsNameDictionary");
      loadDictionaryData("TaskProductTypeDictionary");
      loadDictionaryData("PriceLevel");
      loadDictionaryData("ManufacturerDictionary");

      if ($stateParams.id > 0) {
        loadData($stateParams.id);
      } else {
        vm.data = {};
        vm.data.Name = "";
        vm.data.TaskEntities = [];
        vm.data.subTasks = [];
        vm.data.Type = 1;
        vm.data.RootTaskId = 0;
        vm.data.ParentTaskId = 0;
        vm.data.OwnerId = SessionService.getAuthenticatedUser().Id;
        vm.data.IsSubTask = false;
        vm.data.HasChild = false;
        vm.data.Progress = 0;
        vm.data.Employees = [];
        vm.data.ChildTasks = [];
        vm.data.BeginDate = Date.today();
        vm.data.EndDate = undefined;
        vm.data.ChildTaskRemoved = [];
        vm.data.TaskEntitiesRemoved = [];
        vm.data.CustomTypeId = 6;
        vm.data.CurrentAmount = 0.0;
        vm.data.TotalAmount = 0.0;
        //loadUserEmployees(SessionService.getAuthenticatedUser().Id);
      }
    }

    ///////////////// business logic

    function onSelectType($item, $model) {
      if ($model === vm.previousType) return;
      vm.data.ChildTasks = [];
      vm.previousType = $model;
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, dateFieldModel, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(dateFieldModel);
      } else {
        datepickerOptions.maxDate = new Date(dateFieldModel);
      }
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function(key) {
        return key.LocalId === localId;
      });
    }

    function remove(arr, dataArr, id) {
      var idx = arr.indexOf(id);
      if (idx > -1) {
        arr.splice(idx, 1);
        dataArr.splice(idx, 1);
      }
    }

    function addEntity(object, type, parentEntity) {
      // product
      var entity = {};
      entity.ContextObject = {};
      if (type == 1) {
        entity.Type = 1;
        entity.ContextId = object.Id;
        entity.ContextObject.Name = object.Name;
        for (var i = 1; i <= 10; i++) {
          entity.ContextObject["AmountGross" + i] = object["AmountGross" + i];
        }
      }
      // productGroup
      if (type == 2) {
        entity.Type = 2;
        entity.ContextId = object.LocalId;
        entity.ContextObject.Name = object.Value;
      }
      //contractor
      if (type == 3) {
        entity.Type = 3;
        entity.ContextId = object.Id;
        entity.ContextObject.Name = object.Name;
        entity.ContextObject.Symbol = object.Symbol;
      }
      //contractor group
      if (type == 4) {
        entity.Type = 4;
        entity.ContextId = object.LocalId;
        entity.ContextObject.Name = object.Value;
      }
      entity.CurrentAmount = 0;
      entity.TotalAmount = 0;
      entity.MeasureUnit = 1;
      entity.Param1 = 0;
      //widok
      vm.data.TaskEntities.push(entity);
    }

    function getProgress(entity) {
      if (entity.TotalAmount != 0)
        return (entity.CurrentAmount / entity.TotalAmount) * 100;
      else return 0;
    }

    function removeEntity(object) {
      var idx = vm.data.TaskEntities.indexOf(object);
      if (idx > -1) vm.data.TaskEntities.splice(idx, 1);
      if (object.Id != undefined) {
        vm.data.TaskEntitiesRemoved.push(object.Id);
      }
    }

    function selectContractor(arr, dataArr) {
      var callback = function(obj) {
        addEntity(obj, 3);
      };

      var callbackCheck = function(obj) {
        return vm.data.TaskEntities.find(function(element) {
          return element.ContextId === obj.Id && element.Type === 3;
        });
      };

      ContractorSelectService.show("lg", callback, callback, callbackCheck);
    }

    function selectUser() {
      function callback(obj) {
        var curr = vm.data.ChildTasks.find(function(element) {
          return element.Owner.Id == obj.Id;
        });
        if (curr != undefined) return;

        addUser(obj);
      }

      function callbackCheck(obj) {
        return vm.data.ChildTasks.find(function(element) {
          return element.Owner.Id == obj.Id;
        });
      }

      UsersSelectService.show(
        "lg",
        callback,
        callback,
        callbackCheck,
        true,
        true,
        SessionService.getAuthenticatedUser().Id
      );
    }

    function selectContractorGroup(arr, dataArr) {
      function callback(obj) {
        if (obj == undefined) return;
        addEntity(obj, 4);
        vm.group = undefined;
      }

      var callbackCheck = function(obj) {
        return vm.data.TaskEntities.find(function(element) {
          return element.ContextId === obj.LocalId && element.Type === 4;
        });
      };
      ConstSelectService.show(
        "lg",
        callback,
        callback,
        "ContractorGroupDictionary",
        undefined,
        callbackCheck,
        undefined,
        "Value"
      );
    }

    function addElemnt(
      arr,
      dataArr,
      obj,
      idAttrName,
      attrName1,
      attrName2,
      attrName1Name,
      attrName2Name
    ) {
      if (arr.indexOf(obj[idAttrName]) > -1) {
        return;
      }
      if (attrName1Name == undefined) attrName1Name = "Name";
      if (attrName2Name == undefined) attrName2Name = "Symbol";

      arr.push(obj[idAttrName]);
      var addedObj = {};
      addedObj["Id"] = obj[idAttrName];
      if (attrName1 != undefined) addedObj[attrName1Name] = obj[attrName1];
      if (attrName2 != undefined) addedObj[attrName2Name] = obj[attrName2];
      dataArr.push(addedObj);
    }

    function addUser(user) {
      var task = createTaskForUser(user, vm.data);
      vm.data.ChildTasks.push(task);
    }

    function removeUser(task) {
      if (task.Id != undefined) vm.data.ChildTaskRemoved.push(task.Id);
      var idx = vm.data.ChildTasks.indexOf(task);
      vm.data.ChildTasks.splice(idx, 1);
    }

    function createTaskForUser(user, parentTask) {
      var task = {};
      task.Name = parentTask.Name;
      task.ContextData1 = parentTask.ContextData1;
      task.ContextData1Objects = parentTask.ContextData1Objects;
      task.ContextData2 = parentTask.ContextData2;
      task.ContextData2Objects = parentTask.ContextData2Objects;
      task.CustomTypeId = parentTask.CustomTypeId;
      task.TaskEntities = [];
      task.subTasks = [];
      task.Type = 1;
      task.RootTaskId = 0;
      task.ParentTaskId = 0;
      task.OwnerId = user.Id;
      task.Owner = user;
      task.IsSubTask = false;
      task.HasChild = false;
      task.Progress = 0;
      task.CurrentAmount = 0.0;
      task.TotalAmount = 0.0;
      task.Employees = [];
      task.ChildTasks = [];
      return task;
    }

    function recalculateTotalAmount() {
      var total = 0.0;
      for (var i = 0; i < vm.data.ChildTasks.length; i++) {
        total += vm.data.ChildTasks[i].TotalAmount;
      }
      vm.data.TotalAmount = total;
    }

    ///////////////// watchers

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function isEntityValid(obj) {
      var count = 0;
      obj.IsValid = false;
      if (!(obj.TotalAmount > 0)) {
        obj.ErrorText =
          "Wartość nie może być pusta oraz musi być większa niż zero";
        return false;
      }

      for (var i = 0; i < obj.ChildEntities.length; i++) {
        count += obj.ChildEntities[i].TotalAmount;
        if (!(obj.ChildEntities[i].TotalAmount > 0)) {
          obj.ErrorText =
            "Wartość nie może być pusta oraz musi być większa niż zero";
          return false;
        }
      }
      if (count < obj.TotalAmount && obj.ChildEntities.length > 0) {
        obj.ErrorText =
          "Suma rozłożonych celów jest mniejsza niż wartość nadrzędna";
        return false;
      }

      if (obj.Type === 1) {
        if (obj.MeasureUnit === 2) {
          {
            if (obj.TotalAmount < obj.Param1) {
              obj.ErrorText =
                "Wartość celu musi być większa, niż minimalna cena produktu";
              return false;
            }
          }
        }
      }
      if (obj.Type === 1) {
        if (
          obj.Param1 === null ||
          obj.Param1 === undefined ||
          obj.Param1 <= 0
        ) {
          obj.ErrorText = "Cena musi być większa od zera";
          return false;
        }
      }

      obj.ErrorText = undefined;
      obj.IsValid = true;
      return true;
    }

    function isTaskValid() {
      if (vm.data === undefined) {
        return false;
      }
      if (vm.data.ChildTasks === undefined) {
        return false;
      }

      if (!vm.form.$valid) {
        return false;
      }
      return true;
    }

    function isTaskStarted(checkProgress) {
      if (vm.data === undefined) {
        return false;
      }
      if (!($stateParams.id > 0)) {
        return false;
      }
      if (vm.data.BeginDate === undefined) {
        return false;
      }
      if (vm.data.BeginDate <= Date.today() && vm.data.Progress > 0) {
        return true;
      }
      return false;
    }

    function allowPropagate() {
      return checkPermission(9);
    }

    ///////////////// resource invoke functions
    function loadData(id) {
      vm.isDataReloading = true;
      taskRest
        .get(id, undefined, true)
        .then(function(result) {
          vm.data = result;
          vm.data.BeginDate = Date.parse(vm.data.BeginDate);
          vm.data.EndDate = Date.parse(vm.data.EndDate);
          vm.previousType = vm.data.CustomTypeId;
          vm.isDataReloading = false;
        })
        .catch(function(error) {
          $log.debug("Error while task data");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function submit() {
      if (vm.data.Name.length <= 0) return;
      if (vm.data.CustomTypeId == 6) {
        recalculateTotalAmount();
      }
      for (var i = 0; i < vm.data.ChildTasks.length; i++) {
        delete vm.data.ChildTasks[i].Owner;
      }
      if ($stateParams.id > 0) {
        taskRest.save(vm.data).then(function() {
          $state.go("home.tasks");
        });
      } else {
        taskRest.post(vm.data).then(function(res) {
          $state.go("home.tasks");
        });
      }
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function(data) {
          vm.dictionaryData[name] = data;
          if (name === "TaskProductTypeDictionary") {
            vm.taskTypes = _.filter(data, function(val) {
              return val.LocalId > 5;
            });
          }
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function(a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    //goes back to previous state
    function goBack() {
      $state.go("home.tasks");
    }
    ///////////////// FORMLY
  }
})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("TasksController", TasksController);

  TasksController.$inject = [
    "$log",
    "constRest",
    "$sessionStorage",
    "SessionService",
    "taskRest",
    "UsersService",
    "userRest",
    "$state",
    "taskTypeService",
    "sweetAlert"
  ];

  function TasksController(
    $log,
    constRest,
    $sessionStorage,
    SessionService,
    taskRest,
    UsersService,
    userRest,
    $state,
    taskTypeService,
    sweetAlert
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadData = loadData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.removeTask = removeTask;
    vm.allowRemove = allowRemove;
    vm.isTaskStarted = isTaskStarted;
    vm.isTaskValid = isTaskValid;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.goToElement = goToElement;
    vm.openTaskCreationModal = openTaskCreationModal;

    function goToElement(key) {
      if (key.CustomTypeId <= 5) $state.go("home.tasks.task", { id: key.Id });
      else $state.go("home.tasks.userTask", { id: key.Id });
    }

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.userDictName = "UsersDictionary";

    vm.maxCount = 20000;
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined
    };

    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchStr: undefined,
      pagingButtonsMaxSize: 5,
      type: undefined,
      beginDate: undefined,
      endDate: undefined,
      status: undefined,
      customTypeId: undefined,
      selectedUserId: undefined
    };
    vm.dictionaryData = {};

    ///////////////// constructor call
    constructor();

    function constructor() {
      loadUserDictionaryData();
      $log.debug("TasksController");
      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("TaskProductTypeDictionary");
      loadDictionaryData("TaskProductStatusDictionary");

      //constructor body
      vm.setPageSize(10);

      //loadDictionaryData("ProductGroupDictionary");
      //loadDictionaryData("VATDictionary");
      if ($sessionStorage.tasksPagingData != undefined)
        vm.pagingData = $sessionStorage.tasksPagingData;

      loadDataWithPagingData(true);
    }

    ///////////////// business logic

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      vm.onFilterChange();
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function(key) {
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    }

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    }

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    }

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.tasksPagingData = vm.pagingData;
    }

    function onFilterChange() {
      if (vm.pagingData.searchStr == "") vm.pagingData.searchStr = undefined;
      $sessionStorage.tasksPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function resetSearchTerms() {
      vm.pagingData.currentPage = 1;
      vm.pagingData.beginDate = undefined;
      vm.pagingData.endDate = undefined;
      vm.pagingData.status = undefined;
      vm.pagingData.customTypeId = undefined;
      vm.pagingData.searchStr = undefined;
      vm.pagingData.selectedUserId = undefined;

      vm.beginDateOptions.maxDate = undefined;
      vm.endDateOptions.minDate = undefined;

      onFilterChange();
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function prepareObject(obj) {
      var beginDate = Date.parse(obj.BeginDate);
      obj.viewProgress = obj.Progress;
      if (beginDate > Date.today()) {
        obj.fillText = "-";
        obj.progressType = "info";
        obj.viewProgress = 100;
        return;
      }
      if (obj.viewProgress < 0.01) obj.viewProgress = 0;
      obj.fillText = "Wykonano:" + obj.viewProgress + "%";
      if (obj.Progress >= 100) {
        obj.progressType = "success";
      } else {
        obj.progressType = "danger";
      }
    }

    function isTaskStarted(obj) {
      if (obj.BeginDate === undefined) {
        return false;
      }
      if (obj.BeginDate >= Date.today()) {
        return false;
      }
      if (!(obj.Progress > 0)) {
        return false;
      }

      return true;
    }

    function allowRemove() {
      return checkPermission(10);
    }

    function isTaskValid(obj) {
      if (
        obj.LastCalculateDocumentId === undefined ||
        obj.LastCalculateDocumentId === null
      ) {
        obj.ErrorText = "Cel musi zostać ponownie przeliczony";
        return false;
      }
      if (obj.LastCalculateDocumentId === 0) {
        obj.ErrorText = "Cel musi zostać ponownie przeliczony";
        return false;
      }
      return true;
    }

    ///////////////// resource invoke functions

    function removeTask(id) {
      sweetAlert
        .swal({
          title: "Uwaga",
          text: "Zamierzasz usunąć cel",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Potwierdzam",
          cancelButtonText: "Zrezygnuj"
        })
        .then(
          function() {
            handleTaskRemoval(id);
          },
          function(dismiss) {
            // dismiss can be 'cancel', 'overlay',
            // 'close', and 'timer'
          }
        );
    }

    function handleTaskRemoval(id) {
      taskRest
        .remove(id)
        .then(function(data) {
          onFilterChange();
        })
        .catch(function(err) {});
    }

    function loadDataWithPagingData(getCount) {
      vm.loadData(
        2,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.status,
        vm.pagingData.customTypeId,
        vm.pagingData.searchStr,
        vm.pagingData.selectedUserId
      );
    }

    /*m.pagingData.beginDate = undefined;
     vm.pagingData.endDate = undefined;
     vm.pagingData.status = undefined;
     vm.pagingData.customTypeId = undefined;*/
    function loadData(
      type,
      count,
      page,
      getCount,
      beginDate,
      endDate,
      status,
      customTypeId,
      searchStr,
      selectedUserId
    ) {
      vm.isDataReloading = true;
      taskRest
        .all(
          SessionService.getAuthenticatedUser().Id,
          type,
          count,
          page,
          getCount,
          beginDate,
          endDate,
          status,
          customTypeId,
          searchStr,
          selectedUserId
        )
        .then(function(result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
          for (var i = 0; i < vm.data.length; i++) {
            prepareObject(vm.data[i]);
          }
        })
        .catch(function(error) {
          $log.debug("Error while tasks data: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function(data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function(a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadUserDictionaryData() {
      /*isActive, searchStr, count, page, getCount, JobTitleId, storage, getEmployees, getAllIfPossible, userId*/
      userRest
        .all(
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
          true,
          SessionService.getAuthenticatedUser().Id
        )
        .then(function(data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function(a, b) {
            if (a.SurName == undefined) return -1;
            if (b.SurName == undefined) return 1;
            if (a.SurName < b.SurName) return -1;
            else if (a.SurName > b.SurName) return 1;
            else return 0;
          });
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    //opens modal allowing user to choose type of new task (user/contractor/product)
    function openTaskCreationModal() {
      taskTypeService.show("sm");
    }

    ///////////////// FORMLY
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('taskTypeService', taskTypeService);

  taskTypeService.$inject = ['$log', '$uibModal', '$state'];

  function taskTypeService($log, $uibModal, $state) {

    var service = {
      show: showSelectionModal
    };

    return service;

    //var
    var isVisible = false;

    function showSelectionModal(size) {
      if(isVisible)
        return;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/tasks/taskType.modal.html',
        controller: 'taskTypeController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        }
      });

      isVisible = true;
      modalInstance.result.then(function (data) {
        $log.info('Modal ok with ' + data);
        switch(data){
          case 1:
            $state.go("home.tasks.task", {id: 0});
            break;
          case 2:
          case 3:
            $state.go("home.tasks.userTask", {id: 0});
            break;
        }
        isVisible = false;
      }, function (err) {
        $log.info('Modal dismissed with:  ' + err);
        isVisible = false;
      });
    }


  };

  angular
    .module('smakmak.controllers')
    .controller('taskTypeController', taskTypeController);

  /** @ngInject */
  function taskTypeController($scope, $uibModalInstance) {
    var vm = this;

    //functions
    vm.action = action;

    //data
    vm.result = undefined;

    function action(value) {
      vm.result = value;
      $uibModalInstance.close(vm.result);
    }
  }

})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("TaskController", TaskController);

  TaskController.$inject = [
    "$log",
    "$stateParams",
    "$state",
    "constRest",
    "$sessionStorage",
    "SessionService",
    "taskRest",
    "userRest",
    "ContractorSelectService",
    "ProductsSelectService",
    "UsersSelectService",
    "ConstSelectService"
  ];

  function TaskController(
    $log,
    $stateParams,
    $state,
    constRest,
    $sessionStorage,
    SessionService,
    taskRest,
    userRest,
    ContractorSelectService,
    ProductsSelectService,
    UsersSelectService,
    ConstSelectService
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadData = loadData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.checkPermission = checkPermission;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.remove = remove;
    vm.selectContractor = selectContractor;
    vm.selectProduct = selectProduct;
    vm.selectUser = selectUser;
    vm.selectContractorGroup = selectContractorGroup;
    vm.submit = submit;
    vm.removeEntity = removeEntity;
    vm.addEntity = addEntity;
    vm.selectProductGroup = selectProductGroup;
    vm.getProgress = getProgress;
    vm.removeUser = removeUser;
    vm.updateUnit = updateUnit;
    vm.updatePrice = updatePrice;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.isEntityValid = isEntityValid;
    vm.isTaskValid = isTaskValid;
    vm.divideEntity = divideEntity;
    vm.isTaskStarted = isTaskStarted;
    vm.allowPropagate = allowPropagate;
    vm.goBack = goBack;
    vm.addNewMix = addNewMix;
    vm.addProductToMix = addProductToMix;
    vm.removeProductFromMix = removeProductFromMix;

    ///////////////// data def
    vm.data = undefined;
    vm.viewData = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerEndOpened = false;
    vm.datePickerBeginOpened = false;
    vm.taskTypes = [];
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined
    };

    vm.dictionaryData = {};

    ///////////////// constructor call
    constructor();

    function constructor() {
      $log.debug("PreferredProductsController");
      //constructor body
      loadDictionaryData("ContractorGroupDictionary");
      loadDictionaryData("ProductGroupDictionary");
      loadDictionaryData("TaskUnitDictionary");
      loadDictionaryData("JobTitleDictionary");
      loadDictionaryData("ProductFieldsNameDictionary");
      loadDictionaryData("TaskProductTypeDictionary");
      loadDictionaryData("PriceLevel");
      loadDictionaryData("ManufacturerDictionary");

      if ($stateParams.id > 0) {
        loadData($stateParams.id);
      } else {
        vm.viewData = {};
        vm.viewData.Name = "";
        vm.viewData.TaskEntities = [];
        vm.viewData.subTasks = [];
        vm.viewData.Type = 1;
        vm.viewData.RootTaskId = 0;
        vm.viewData.ParentTaskId = 0;
        vm.viewData.OwnerId = SessionService.getAuthenticatedUser().Id;
        vm.viewData.IsSubTask = false;
        vm.viewData.HasChild = false;
        vm.viewData.Progress = 0;
        vm.viewData.Employees = [];
        vm.viewData.ChildTasks = [];
        vm.viewData.BeginDate = Date.today();
        vm.viewData.EndDate = undefined;
        vm.viewData.ChildTaskRemoved = [];
        vm.viewData.TaskEntitiesRemoved = [];
        vm.viewData.CustomTypeId = undefined;
        vm.endDateOptions.minDate = Date.today();
        loadUserEmployees(SessionService.getAuthenticatedUser().Id);
      }
    }

    ///////////////// business logic

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function(key) {
        return key.LocalId === localId;
      });
    }

    function remove(arr, dataArr, id) {
      var idx = arr.indexOf(id);
      if (idx > -1) {
        arr.splice(idx, 1);
        dataArr.splice(idx, 1);
      }
    }

    function addEntity(object, type, rootEntity) {
      // product
      var entity = {};
      entity.ContextObject = {};
      if (type == 1) {
        entity.Type = 1;
        entity.ContextId = object.Id;
        entity.ContextObject.Name = object.Name;
        for (var i = 1; i <= 10; i++) {
          entity.ContextObject["AmountGross" + i] = object["AmountGross" + i];
          entity.ContextObject["AmountNet" + i] = object["AmountNet" + i];
        }
        if (rootEntity) {
          entity.RootEntity = rootEntity;
        }
      }
      // productGroup
      if (type == 2) {
        entity.Type = 2;
        entity.ContextId = object.LocalId;
        entity.ContextObject.Name = object.Value;
      }
      //contractor
      if (type == 3) {
        entity.Type = 3;
        entity.ContextId = object.Id;
        entity.ContextObject.Name = object.Name;
        entity.ContextObject.Symbol = object.Symbol;
      }
      //contractor group
      if (type == 4) {
        entity.Type = 4;
        entity.ContextId = object.LocalId;
        entity.ContextObject.Value = object.Value;
      }
      //mix products
      if (type == 6) {
        entity.Type = 6;
        entity.isCollapsedMixProducts = true;
        //entity.ContextId = object.LocalId;
        //entity.ContextObject.Value = object.Value;
      }
      entity.CurrentAmount = 0;
      entity.TotalAmount = 1;
      entity.MeasureUnit = 1;
      entity.Param1 = 0;
      //widok
      entity.isCollapsed = true;
      entity.ChildEntities = [];
      if (!rootEntity) {
        vm.viewData.TaskEntities.push(entity);
        if (entity.Type < 3 || entity.Type == 6)
          splitEntityToTasks(entity, vm.viewData.ChildTasks);
      } else {
        rootEntity.ChildEntities.push(entity);
      }
    }

    function getProgress(entity) {
      if (entity.TotalAmount != 0 && entity.CurrentAmount > 0.001)
        return (entity.CurrentAmount / entity.TotalAmount) * 100;
      else return 0;
    }

    function removeEntity(object) {
      var idx = vm.viewData.TaskEntities.indexOf(object);
      if (idx > -1) vm.viewData.TaskEntities.splice(idx, 1);
      if (object.Id != undefined) {
        vm.viewData.TaskEntitiesRemoved.push(object.Id);
      }
      for (var i = 0; i < object.ChildEntities.length; i++) {
        var cIdx = object.ChildEntities[i].ParentT.TaskEntities.indexOf(
          object.ChildEntities[i]
        );
        if (cIdx > -1)
          object.ChildEntities[i].ParentT.TaskEntities.splice(cIdx, 1);
      }
    }

    function selectContractor(arr, dataArr) {
      var callback = function(obj) {
        addEntity(obj, 3);
      };

      var callbackCheck = function(obj) {
        return vm.viewData.TaskEntities.find(function(element) {
          return element.ContextId === obj.Id && element.Type === 3;
        });
      };

      ContractorSelectService.show("lg", callback, callback, callbackCheck);
    }

    function selectUser() {
      var select = function callback(obj) {
        var curr = vm.viewData.Employees.find(function(element) {
          return element.Id == obj.Id;
        });
        if (curr != undefined) return;
        vm.viewData.Employees.push(obj.plain());
        addUser(obj.plain());
      };

      var check = function callbackCheck(obj) {
        return vm.viewData.Employees.find(function(element) {
          return element.Id == obj.Id;
        });
      };

      UsersSelectService.show(
        "lg",
        select,
        select,
        check,
        true,
        true,
        SessionService.getAuthenticatedUser().Id
      );
    }

    function selectContractorGroup(arr, dataArr) {
      function callback(obj) {
        if (obj == undefined) return;
        addEntity(obj, 4);
        vm.group = undefined;
      }

      var callbackCheck = function(obj) {
        return vm.viewData.TaskEntities.find(function(element) {
          return element.ContextId === obj.LocalId && element.Type === 4;
        });
      };
      ConstSelectService.show(
        "lg",
        callback,
        callback,
        "ContractorGroupDictionary",
        undefined,
        callbackCheck,
        undefined,
        "Value"
      );
    }

    function selectProduct() {
      function callback(obj) {
        addEntity(obj, 1, null);
      }

      function callbackCheck(obj) {
        return vm.viewData.TaskEntities.find(function(element) {
          return element.ContextId === obj.Id && element.Type === 1;
        });
      }

      ProductsSelectService.show("lg", callback, callback, callbackCheck);
    }

    function addProductToMix(entity) {
      function callback(obj) {
        addEntity(obj, 1, entity);
      }

      function callbackCheck(obj) {
        return entity.ChildEntities.find(function(element) {
          return element.ContextId === obj.Id && element.Type === 1;
        });
      }

      ProductsSelectService.show("lg", callback, callback, callbackCheck);
    }

    function removeProductFromMix(entity) {
      var index = entity.RootEntity.ChildEntities.indexOf(entity);
      if (index > -1) {
        entity.RootEntity.ChildEntities.splice(index, 1);
      }
    }

    //function selectProductGroup($item, $model) {
    //  if ($item == undefined)
    //    return;
    //  addEntity($item, 2, null);
    //  vm.productGroup = undefined;
    //}

    function selectProductGroup() {
      function callback(obj) {
        if (obj == undefined) return;
        addEntity(obj, 2, null);
        vm.productGroup = undefined;
      }

      function callbackCheck(obj) {
        return vm.viewData.TaskEntities.find(function(element) {
          return element.ContextId === obj.LocalId && element.Type === 2;
        });
      }

      ConstSelectService.show(
        "lg",
        callback,
        callback,
        "ProductGroupDictionary",
        undefined,
        callbackCheck
      );
    }

    function addNewMix() {
      addEntity(undefined, 6, null);
    }

    function updateUnit(entity) {
      for (var i = 0; i < entity.ChildEntities.length; i++) {
        entity.ChildEntities[i].MeasureUnit = entity.MeasureUnit;
      }
    }

    function updatePrice(entity, value) {
      if (value != undefined) entity.Param1 = value;
      for (var i = 0; i < entity.ChildEntities.length; i++) {
        entity.ChildEntities[i].Param1 = entity.Param1;
      }
    }

    function addUser(user) {
      var task = createTaskForUser(user, vm.viewData);
      vm.viewData.ChildTasks.push(task);
      splitEntitiesToTask(vm.viewData.TaskEntities, task);
    }

    function removeUser(user) {
      var task = user.Task;
      user.Task = undefined;
      if (task.Id != undefined) vm.viewData.ChildTaskRemoved.push(task.Id);
      for (var i = 0; i < task.TaskEntities.length; i++) {
        if (task.TaskEntities[i].ParentEntity != undefined) {
          var idx = task.TaskEntities[i].ParentEntity.ChildEntities.indexOf(
            task.TaskEntities[i]
          );
          task.TaskEntities[i].ParentEntity.ChildEntities.splice(idx, 1);
        }
      }
      var idx = vm.viewData.ChildTasks.indexOf(task);
      vm.viewData.ChildTasks.splice(idx, 1);

      idx = vm.viewData.Employees.indexOf(user);
      vm.viewData.Employees.splice(idx, 1);
    }

    function trySplit(task) {
      //przygotowanie obiektów -
      for (var i = 0; i < task.TaskEntities.length; i++) {
        task.TaskEntities[i].isCollapsed = true;
        task.TaskEntities[i].ChildEntities = [];
      }
      if (task.ChildTasks.length > 0 || task.Employees.length === 0) {
        for (var i = 0; i < task.ChildTasks.length; i++) {
          var user = vm.viewData.Employees.find(function(obj) {
            return obj.Id == task.ChildTasks[i].OwnerId;
          });
          user.Task = task.ChildTasks[i];
        }
        for (var i = 0; i < task.TaskEntities.length; i++) {
          if (task.TaskEntities[i].Type > 2 && task.TaskEntities[i].Type !== 6)
            continue;
          for (var j = 0; j < task.ChildTasks.length; j++) {
            var chdEntityTask = task.ChildTasks[j].findEntityByParentEntityId(
              task.TaskEntities[i].Id
            );
            //var chdEntityTaskMix = task.ChildTasks[j].task.findEntityByMixRootId(task.TaskEntities[i].Id);
            if (chdEntityTask != undefined) {
              chdEntityTask.ParentEntity = task.TaskEntities[i];
              chdEntityTask.ParentT = task.ChildTasks[j];
              task.TaskEntities[i].ChildEntities.push(chdEntityTask);
            } else {
              /*When entity in tash dont have childs, split it.*/
              splitEntityToTasks(task.TaskEntities[i], task.ChildTasks);
              break;
            }
          }
          for (var k = 0; k < task.TaskEntities[i].MixEntities.length; k++) {
            task.TaskEntities[i].ChildEntities.push(
              task.TaskEntities[i].MixEntities[k]
            );
          }
        }

        return;
      }
      var mixProductsAdded = false;
      for (var i = 0; i < task.Employees.length; i++) {
        var t = createTaskForUser(task.Employees[i], task);
        task.ChildTasks.push(t);
        splitEntitiesToTask(vm.viewData.TaskEntities, t);
        if (!mixProductsAdded)
          for (var j = 0; j < task.TaskEntities.length; j++) {
            for (var k = 0; k < task.TaskEntities[j].MixEntities.length; k++) {
              task.TaskEntities[j].ChildEntities.push(
                task.TaskEntities[j].MixEntities[k]
              );
            }
          }
        mixProductsAdded = true;
      }
    }

    function splitEntitiesToTask(entities, task) {
      for (var i = 0; i < entities.length; i++) {
        if (entities[i] > 2) continue;
        var entity = newEntity(entities[i]);
        entity.ParentT = task;
        task.TaskEntities.push(entity);
        entities[i].ChildEntities.unshift(entity);
      }
    }

    function splitEntityToTasks(entity, tasks) {
      for (var i = 0; i < tasks.length; i++) {
        var newT = newEntity(entity);
        newT.ParentT = tasks[i];
        tasks[i].TaskEntities.push(newT);
        entity.ChildEntities.push(newT);
      }
    }

    function createTaskForUser(user, parentTask) {
      var task = {};
      task.Name = parentTask.Name;
      task.CustomTypeId = parentTask.CustomTypeId;
      task.TaskEntities = [];
      task.subTasks = [];
      task.Type = 1;
      task.RootTaskId = 0;
      task.ParentTaskId = 0;
      task.OwnerId = user.Id;
      task.Owner = user;
      task.IsSubTask = false;
      task.HasChild = false;
      task.Progress = 0;
      task.Employees = [];
      task.ChildTasks = [];

      extendTaskObject(task);
      user.Task = task;
      return task;
    }

    function newEntity(entity) {
      var ent = {};
      ent.ContextObject = entity.ContextObject;
      ent.ContextId = entity.ContextId;
      ent.Type = entity.Type;
      if (ent.ContextObject) ent.ContextObject.Name = entity.ContextObject.Name;
      ent.TotalAmount = 0;
      ent.CurrentAmount = 0;
      ent.MeasureUnit = entity.MeasureUnit;
      ent.Param1 = entity.Param1;
      ent.ManufacturerId = entity.ManufacturerId;
      ent.ParentEntity = entity;
      return ent;
    }

    function extendTaskObject(task) {
      task.findEntity = function(contextId, type) {
        return this.TaskEntities.find(function(entity) {
          return entity.Type == type && entity.ContextId == contextId;
        });
      };
      task.findEntityByParentEntityId = function(id) {
        return this.TaskEntities.find(function(entity) {
          return entity.ParentEntityId == id;
        });
      };
      task.findEntityByMixParentId = function(id) {
        return this.TaskEntities.find(function(entity) {
          return entity.MixParentId == id;
        });
      };

      task.findEntityByMixRootId = function(id) {
        return this.TaskEntities.find(function(entity) {
          return entity.MixRootId == id;
        });
      };

      for (var i = 0; i < task.ChildTasks.length; i++) {
        extendTaskObject(task.ChildTasks[i]);
      }
    }

    function copyViewModelToData(data) {
      vm.data = angular.copy(vm.viewData);
      for (var i = 0; i < vm.data.TaskEntities.length; i++) {
        //Mix
        if (vm.data.TaskEntities[i].Type === 6) {
          vm.data.TaskEntities[i].MixEntities = vm.data.TaskEntities[
            i
          ].ChildEntities.filter(function(key) {
            if (key.Type === 1) {
              key.RootEntity = undefined;
              return true;
            }
            return false;
          });
        }
        vm.data.TaskEntities[i].ChildEntities = undefined;
        vm.data.TaskEntities[i].ParentT = undefined;
      }
      for (var i = 0; i < vm.data.Employees.length; i++) {
        vm.data.Employees[i].Task = undefined;
      }
      for (var i = 0; i < vm.data.ChildTasks.length; i++) {
        vm.data.ChildTasks[i].CustomTypeId = vm.data.CustomTypeId;
        for (var j = 0; j < vm.data.ChildTasks[i].TaskEntities.length; j++) {
          if (vm.data.ChildTasks[i].TaskEntities[j].Type === 6) {
            vm.data.ChildTasks[i].TaskEntities[j].MixEntities =
              vm.data.ChildTasks[i].TaskEntities[j].ParentEntity.MixEntities;
          }
          vm.data.ChildTasks[i].TaskEntities[j].ParentT = undefined;
          vm.data.ChildTasks[i].TaskEntities[j].ParentEntity = undefined;
          vm.data.ChildTasks[i].Owner.Task = undefined;
        }
        //vm.data.ChildTasks[i]*
      }
    }

    function divideEntity(obj) {
      if (obj.TotalAmount === undefined || obj.TotalAmount === null) {
        return;
      }
      if (obj.ChildEntities.length < 1) {
        return;
      }
      var childToDivide = obj.ChildEntities.filter(function(key) {
        if (obj.Type != 6) return true;
        if (key.Type === 6) return true;
        return false;
      });

      var dividedAmount = Math.ceil(obj.TotalAmount / childToDivide.length);
      for (var i = 0; i < childToDivide.length; i++) {
        childToDivide[i].TotalAmount = dividedAmount;
      }
    }

    ///////////////// watchers

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function isEntityValid(obj) {
      var count = 0;
      obj.IsValid = false;
      if (!(obj.TotalAmount > 0)) {
        obj.ErrorText =
          "Wartość nie może być pusta oraz musi być większa niż zero";
        return false;
      }

      for (var i = 0; i < obj.ChildEntities.length; i++) {
        //For mixes, count only mix entities, not product
        if (
          obj.Type != 6 ||
          (obj.Type == 6 && obj.ChildEntities[i].Type == 6)
        ) {
          count += obj.ChildEntities[i].TotalAmount;
        }
        if (!(obj.ChildEntities[i].TotalAmount >= 0)) {
          obj.ErrorText =
            "Wartość nie może być pusta oraz musi być większa, bądź równa zero";
          return false;
        }
      }
      if (count < obj.TotalAmount && obj.ChildEntities.length > 0) {
        obj.ErrorText =
          "Suma rozłożonych celów jest mniejsza niż wartość nadrzędna";
        return false;
      }

      if (obj.Type === 1) {
        if (obj.MeasureUnit === 1) {
          {
            if (obj.TotalAmount < obj.Param1) {
              obj.ErrorText =
                "Wartość celu musi być większa, niż minimalna cena produktu";
              return false;
            }
          }
        }
      }
      if (obj.Type === 1) {
        if (
          obj.Param1 === null ||
          obj.Param1 === undefined ||
          obj.Param1 <= 0
        ) {
          obj.ErrorText = "Cena musi być większa od zera";
          return false;
        }
      }

      if (obj.Type === 6) {
        var mixProducts = obj.ChildEntities.filter(function(key) {
          if (key.Type === 1) return true;
          return false;
        });
        if (mixProducts.length < 1) {
          obj.ErrorText = "Brak produktów";
          return false;
        }
      }

      obj.ErrorText = undefined;
      obj.IsValid = true;
      return true;
    }

    function isTaskValid() {
      if (vm.viewData === undefined) {
        return false;
      }
      if (
        vm.viewData.TaskEntities === undefined &&
        vm.viewData.ChildTasks == undefined &&
        vm.viewData.ContextData1 == undefined &&
        vm.viewData.ContextData2 == undefined
      ) {
        return false;
      }
      if (vm.viewData.TaskEntities !== undefined) {
        if (vm.viewData.TaskEntities.length < 1) {
          return false;
        }
      }

      /*nie ma być walidacji na ilość użytowników*/
      //if (vm.viewData.Employees.length < 1) {
      //  return false;
      //}

      for (var i = 0; i < vm.viewData.TaskEntities.length; i++) {
        if (vm.viewData.TaskEntities[i].IsValid == false) {
          return false;
        }
      }

      if (!vm.form.$valid) {
        return false;
      }
      return true;
    }

    function isTaskStarted(checkProgress) {
      if (vm.viewData === undefined) {
        return false;
      }
      if (!($stateParams.id > 0)) {
        return false;
      }
      if (vm.data.BeginDate === undefined) {
        return false;
      }
      if (vm.data.BeginDate <= Date.today() && vm.viewData.Progress > 0) {
        return true;
      }
      return false;
    }

    function allowPropagate() {
      return checkPermission(9);
    }

    ///////////////// resource invoke functions
    function loadData(id) {
      vm.isDataReloading = true;
      taskRest
        .get(id, undefined, true)
        .then(function(result) {
          vm.data = result;
          var timezoneOffset = new Date().getTimezoneOffset();
          var time = Date.parse(vm.data.BeginDate).getTime();
          vm.data.BeginDate = new Date(time - timezoneOffset * 60 * 1000);

          time = Date.parse(vm.data.EndDate).getTime();

          vm.data.EndDate = new Date(time - timezoneOffset * 60 * 1000);
          vm.viewData = angular.copy(result);
          extendTaskObject(vm.viewData);
          trySplit(vm.viewData);
          vm.isDataReloading = false;
        })
        .catch(function(error) {
          $log.debug("Error while task data");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function submit() {
      copyViewModelToData(vm.data);
      if (vm.data.Name.length <= 0) return;

      if ($stateParams.id > 0) {
        taskRest.save(vm.data).then(function() {
          $state.go("home.tasks");
        });
      } else
        taskRest.post(vm.data).then(function(res) {
          $state.go("home.tasks.task", { id: res.Id });
        });
    }

    function loadUserEmployees(id) {
      userRest
        .getEmployees(id)
        .then(function(data) {
          vm.viewData.Employees = data;
          trySplit(vm.viewData);
        })
        .catch(function(data) {});
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function(data) {
          vm.dictionaryData[name] = data;
          if (name === "TaskProductTypeDictionary") {
            vm.taskTypes = _.filter(data, function(val) {
              return val.LocalId <= 5;
            });
          }
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function(a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    //goes back to previous state
    function goBack() {
      $state.go("home.tasks");
    }

    ///////////////// FORMLY
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("SamplesController", SamplesController);

  SamplesController.$inject = [
    "$filter",
    "$log",
    "$q",
    "$stateParams",
    "$translate",
    "$sessionStorage",
    "ContractorSelectService",
    "constRest",
    "documentRest",
    "SessionService",
    "userRest",
    "sweetAlert",
    "Notification",
    "storageRest",
  ];

  function SamplesController(
    $filter,
    $log,
    $q,
    $stateParams,
    $translate,
    $sessionStorage,
    ContractorSelectService,
    constRest,
    documentRest,
    SessionService,
    userRest,
    sweetAlert,
    Notification,
    storageRest
  ) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.selectContractor = selectContractor;
    vm.removeContractor = removeContractor;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.setTotalCount = setTotalCount;
    vm.pageChanged = pageChanged;
    vm.onFilterChange = onFilterChange;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.onSelect = onSelect;
    vm.onSelectPageCount = onSelectPageCount;
    vm.loadDocumentsData = loadDocumentsData;
    vm.resetSearchTerms = resetSearchTerms;
    vm.tryRemoveDocument = tryRemoveDocument;
    vm.markForPrint = markForPrint;
    vm.printDocuments = printDocuments;

    //data
    vm.data = undefined;
    vm.printOnce = false;
    vm.loggedUser = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.userDictName = "UsersDictionary";
    vm.maxCount = 20000;
    vm.isAnyPrintMarked = false;
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: Date.today(),
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: Date.today().addMonths(-2),
    };
    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      firstId: undefined,
      categoryId: undefined,
      payerId: undefined,
      userId: undefined,
      beginDate: Date.today().addMonths(-2).toString("yyyy-MM-dd"),
      endDate: Date.today().toString("yyyy-MM-dd"),
      amountBegin: undefined,
      amountEnd: undefined,
      status: undefined,
      typeId: 1002,
      isAcceptanceRequired: undefined,
      contractor: undefined,
      storageId: undefined,
      documentNumber: undefined,
      sortByDate: 1,
      isSentToClient: undefined,
      objectStatus: undefined,
    };

    vm.StatusDictionary = [
      {
        id: 1,
        name: "Akceptacja",
      },
      {
        id: 10,
        name: "Zaakceptowany",
      },
      {
        id: 11,
        name: "Do wysłania",
      },
      {
        id: 23,
        name: "Wysłany do klienta",
      },
      {
        id: 30,
        name: "Odrzucony",
      },
    ];
    vm.dictionaryData = {};
    //constructor call
    loadData();

    function loadData() {
      $log.debug("samples.controller");
      //constructor body
      vm.setPageSize(10);

      vm.loggedUser = getLoggedUser();
      loadSalesRepresentatives();
      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadStoragesData();

      if ($sessionStorage.samplesPagingData != undefined) {
        vm.pagingData = $sessionStorage.samplesPagingData;
      }

      if ($stateParams.typeId != null) {
        vm.pagingData.typeId = $stateParams.typeId;
        console.log("State param: " + $stateParams.typeId);
      }

      loadDataWithPagingData(true);
    }

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
          if (name === "DocumentTypeDictionary") {
            filterDocumentTypeDictionary();
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadSalesRepresentatives() {
      // 1000 users - there will never be more
      userRest
        .getSalesRepresentatives(
          vm.loggedUser.Id,
          undefined,
          undefined,
          1000,
          1,
          false
        )
        .then(function (result) {
          vm.dictionaryData["SalesRepresentatives"] = result;
        })
        .catch(function (error) {
          $log.debug("Error while getting users list: " + error.status);
        });
    }

    function filterDocumentTypeDictionary() {
      var filtered = [];
      vm.dictionaryData["DocumentTypeDictionary"].forEach(function (type) {
        if (type.LocalId == 1003 || type.LocalId == 1002) {
          filtered.push(type);
        }
      });
      vm.dictionaryData["DocumentTypeDictionary"] = filtered;
    }

    function loadDataWithPagingData(getCount) {
      vm.loadDocumentsData(
        vm.pagingData.documentNumber,
        vm.pagingData.storageId,
        vm.pagingData.categoryId,
        vm.pagingData.payerId,
        vm.pagingData.userId,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.status,
        vm.pagingData.typeId,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.isAcceptanceRequired,
        vm.pagingData.amountBegin,
        vm.pagingData.amountEnd,
        vm.pagingData.sortByDate,
        vm.pagingData.isSentToClient,
        vm.pagingData.objectStatus
      );
    }

    function loadDocumentsData(
      documentNumber,
      storageId,
      categoryId,
      payerId,
      userId,
      beginDate,
      endDate,
      status,
      typeId,
      count,
      page,
      getCount,
      isAcceptanceRequired,
      amountBegin,
      amountEnd,
      sortByDate,
      isSentToClient,
      objectStatus
    ) {
      vm.isDataReloading = true;
      documentRest
        .allView(
          documentNumber,
          storageId,
          categoryId,
          payerId,
          userId,
          beginDate,
          endDate,
          status,
          typeId,
          page,
          count,
          getCount,
          isAcceptanceRequired,
          amountBegin,
          amountEnd,
          sortByDate,
          isSentToClient,
          objectStatus
        )
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting sample: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function removeDocument(key) {
      documentRest
        .remove(key.Id)
        .then(function (result) {
          Notification.success("Dokument został usunięty");
          onFilterChange();
        })
        .catch(function (error) {
          $log.debug("Error while removing sample/promotion: " + vm.pagingData);
          Notification.error("Błąd podczas próby usunięcia dokumentu");
        });
    }
    function tryRemoveDocument(key) {
      sweetAlert
        .swal({
          title: "Uwaga",
          text: "Zamierzasz  usunąć dokument: " + key.DocumentNumberFull,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Potwierdzam",
          cancelButtonText: "Zrezygnuj",
          closeOnConfirm: true,
          closeOnCancel: true,
        })
        .then(
          function () {
            removeDocument(key);
          },
          function (dismiss) {
            // dismiss can be 'cancel', 'overlay',
            // 'close', and 'timer'
          }
        );
    }

    function selectContractor() {
      var callback = function (obj) {
        vm.pagingData.contractor = obj;
        vm.pagingData.payerId = obj.Id;
        onFilterChange();
      };
      ContractorSelectService.show("lg", callback);
    }

    function removeContractor() {
      vm.pagingData.contractor = undefined;
      vm.pagingData.payerId = undefined;
      onFilterChange();
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    }

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    }

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    }

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.samplesPagingData = vm.pagingData;
    }

    function onFilterChange() {
      if (vm.pagingData.searchStr == "") vm.pagingData.searchStr = undefined;
      $sessionStorage.samplesPagingData = vm.pagingData;
      loadDataWithPagingData(true);
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      onFilterChange();
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    function resetSearchTerms() {
      vm.pagingData.categoryId = undefined;
      vm.pagingData.payerId = undefined;
      vm.pagingData.userId = undefined;
      vm.pagingData.beginDate = Date.today()
        .addMonths(-2)
        .toString("yyyy-MM-dd");
      vm.pagingData.endDate = Date.today().toString("yyyy-MM-dd");
      vm.pagingData.status = undefined;
      vm.pagingData.currentPage = 1;
      vm.pagingData.isAcceptanceRequired = undefined;
      vm.pagingData.firstId = undefined;
      vm.pagingData.amountBegin = undefined;
      vm.pagingData.amountEnd = undefined;
      vm.pagingData.contractor = undefined;
      vm.pagingData.payerId = undefined;
      vm.pagingData.storageId = undefined;
      vm.pagingData.documentNumber = undefined;
      vm.pagingData.sortByDate = 1;
      vm.pagingData.isSentToClient = undefined;
      vm.pagingData.objectStatus = undefined;

      vm.beginDateOptions.maxDate = Date.today();
      vm.endDateOptions.minDate = Date.today().addMonths(-2);

      onFilterChange();
    }

    function loadStoragesData() {
      storageRest
        .all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function markForPrint(document) {
      document.isMarkedForPrint = !document.isMarkedForPrint;
      if (document.isMarkedForPrint) {
        vm.isAnyPrintMarked = true;
      } else {
        checkIfAnyPrintMarked();
      }
    }

    function checkIfAnyPrintMarked() {
      var isAny = false;
      for (var i = 0; i < vm.data.length; i++) {
        if (vm.data[i].isMarkedForPrint) {
          isAny = true;
          break;
        }
      }
      vm.isAnyPrintMarked = isAny;
    }

    function printDocuments() {
      vm.printOnce = true;
      getDocumentsForPrint()
        .then(function (documents) {
          preparePdfForPrint(documents);
        })
        .catch(function () {
          vm.printOnce = false;
        });
    }

    function getDocumentsForPrint() {
      var deferred = $q.defer();
      var promiseList = [];

      vm.data.forEach(function (doc) {
        if (doc.isMarkedForPrint) {
          promiseList.push(
            documentRest.get(doc.Id, true, true, true, false, true, true, true)
          );
        }
      });

      $q.all(promiseList)
        .then(function (result) {
          deferred.resolve(result);
        })
        .catch(function () {
          Notification.error("Błąd podczas pobierania oznaczonych dokumentów");
          deferred.reject();
        });

      return deferred.promise;
    }

    function preparePdfForPrint(documents) {
      var pdfDefinition = { content: [] };
      var win = window.open("", "_blank");
      for (var i = 0; i < documents.length; i++) {
        addHeadersToPdf(pdfDefinition.content, documents[i]);
        addRecipientTableToPdf(pdfDefinition.content, documents[i]);
        addEntitiesTableToPdf(pdfDefinition.content, documents[i]);
        addSignFieldToPdf(pdfDefinition.content);
        if (i !== documents.length - 1) {
          goToNextPagePdf(pdfDefinition.content);
        }
      }
      try {
        pdfMake.createPdf(pdfDefinition).print({}, win);
        unMarkForPrint();
      } catch (err) {
        Notification.error(
          "Najpierw należy zezwolić stronie na wyświetlanie wyskakujących okienek"
        );
      }
      vm.printOnce = false;
    }

    function addHeadersToPdf(pdfContent, document) {
      pdfContent.push({
        columns: [
          {
            text: "Smakmak sp. z o.o.",
          },
          {
            text:
              "Data wystawienia: " +
              $filter("date")(document.DocumentReleaseDate, "yyyy.MM.dd"),
            alignment: "right",
          },
        ],
      });
      pdfContent.push({
        text: "Ul. Balonowa 7A, 64-100 Strzyżewice",
      });
      pdfContent.push({
        text: "Wydanie: " + document.DocumentNumberFull,
        margin: 45,
        alignment: "center",
      });
      pdfContent.push({
        text: "Odbiorca",
        bold: true,
        margin: [0, 20],
      });
    }

    function addRecipientTableToPdf(pdfContent, document) {
      var city = document.RecipientAddress.City
        ? document.RecipientAddress.City
        : " ";
      var postalCode = document.RecipientAddress.PostalCode
        ? document.RecipientAddress.PostalCode
        : " ";
      var street = document.RecipientAddress.Street
        ? document.RecipientAddress.Street
        : " ";
      pdfContent.push({
        table: {
          headerRows: 0,
          body: [
            [
              { text: "Symbol", bold: true, margin: [5, 0, 0, 0] },
              { text: document.RecipientSymbol, margin: [15, 0, 0, 0] },
            ],
            [
              { text: "Nazwa", bold: true, margin: [5, 0, 0, 0] },
              { text: document.RecipientName, margin: [15, 0, 0, 0] },
            ],
            [
              { text: "Adres", bold: true, margin: [5, 0, 0, 0] },
              { text: city, margin: [15, 0, 0, 0] },
            ],
            [
              { text: " ", margin: [5, 0, 0, 0] },
              { text: postalCode, margin: [15, 0, 0, 0] },
            ],
            [
              { text: "Ulica", bold: true, margin: [5, 0, 0, 0] },
              { text: street, margin: [15, 0, 0, 0] },
            ],
          ],
        },
        layout: "noBorders",
      });
    }

    function addEntitiesTableToPdf(pdfContent, document) {
      var tableObject = {
        headerRows: 1,
        widths: ["*", 100, 100],
        body: [
          [
            { text: "Nazwa produktu", bold: true, alignment: "center" },
            { text: "Ilość", bold: true, alignment: "center" },
            { text: "J.M", bold: true, alignment: "center" },
          ],
        ],
      };
      document.DocumentEntities.forEach(function (entity) {
        tableObject.body.push([
          { text: entity.RelatedProduct.Name, alignment: "center" },
          { text: entity.Count, alignment: "center" },
          { text: entity.MeasureUnit, alignment: "center" },
        ]);
      });
      pdfContent.push({ table: tableObject, margin: [0, 40, 0, 0] });
    }

    function addSignFieldToPdf(pdfContent) {
      pdfContent.push({
        columns: [
          { text: "", width: "*" },
          {
            table: {
              headerRows: 1,
              widths: [200],
              body: [
                [" "],
                [
                  {
                    text: "Podpis - potwierdzenie odbioru",
                    alignment: "center",
                  },
                ],
              ],
            },
            layout: "lightHorizontalLines",
            margin: [0, 40, 0, 0],
          },
        ],
      });
    }

    function goToNextPagePdf(pdfContent) {
      pdfContent.push({
        text: " ",
        pageBreak: "after",
      });
    }

    function unMarkForPrint() {
      vm.data.forEach(function (doc) {
        doc.isMarkedForPrint = false;
      });
      vm.isAnyPrintMarked = false;
    }

    //controller ends
  }
})();

(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("RoutesController", RoutesController);

  RoutesController.$inject = [
    "$log",
    "$state",
    "$stateParams",
    "$translate",
    "SessionService",
    "constRest",
    "eventsRest",
    "userRest",
    "UsersSelectService",
    "ContractorSelectService",
    "ActionModalService",
    "UsersService",
    "Notification",
    "storageRest",
    "orderHistoryModalService",
    "$sessionStorage",
    "$anchorScroll",
    "$location",
    "visitRest",
    "taskRest",
    "logRest"
  ];

  function RoutesController(
    $log,
    $state,
    $stateParams,
    $translate,
    SessionService,
    constRest,
    eventsRest,
    userRest,
    UsersSelectService,
    ContractorSelectService,
    ActionModalService,
    UsersService,
    Notification,
    storageRest,
    orderHistoryModalService,
    $sessionStorage,
    $anchorScroll,
    $location,
    visitRest,
    taskRest,
    logRest
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.updateError = updateError;
    vm.fillWeek = fillWeek;
    vm.fillMonth = fillMonth;
    vm.searchFirstMondayInMonth = searchFirstMondayInMonth;
    vm.previousMonthGenerate = previousMonthGenerate;
    vm.previousMonth = previousMonth;
    vm.nextMonthGenerate = nextMonthGenerate;
    vm.nextMonth = nextMonth;
    vm.pushRoutes = pushRoutes;
    vm.dropCallback = dropCallback;
    vm.dragStartCallback = dragStartCallback;
    vm.dragEndCallback = dragEndCallback;
    vm.constructor = constructor;
    vm.trashDrop = trashDrop;
    vm.transferDrop = transferDrop;
    vm.chosenDay = chosenDay;
    vm.isFree = isFree;
    vm.holidays = holidays;
    vm.pushHolidays = pushHolidays;
    vm.submit = submit;
    vm.remove = remove;
    vm.isRouteValid = isRouteValid;
    vm.selectcalendarUser = selectcalendarUser;
    vm.selectFormUser = selectFormUser;
    vm.selectRoute = selectRoute;
    vm.selectDay = selectDay;
    vm.selectContractor = selectContractor;
    vm.selectContractorSeasonal = selectContractorSeasonal;
    vm.checkEntities = checkEntities;
    vm.getRoutes = getRoutes;
    vm.refreshAfterPush = refreshAfterPush;
    vm.deleteDateOffsetsFromRoute = deleteDateOffsetsFromRoute;
    vm.clearCurrentRoute = clearCurrentRoute;
    vm.countTimePeriodEfficiency = countTimePeriodEfficiency;
    vm.switchToMonthlyView = switchToMonthlyView;
    vm.switchToWeeklyView = switchToWeeklyView;
    vm.initializeMonth = initializeMonth;
    vm.nextWeek = nextWeek;
    vm.previousWeek = previousWeek;
    vm.goNext = goNext;
    vm.goPrevious = goPrevious;
    vm.checkIfChoosingUserIsPossible = checkIfChoosingUserIsPossible;
    vm.removeUser = removeUser;
    vm.showFormUser = showFormUser;
    vm.setFormUser = setFormUser;
    vm.setRouteUserBeforeSubmit = setRouteUserBeforeSubmit;
    vm.disableContractorSelect = disableContractorSelect;
    vm.goToVisit = goToVisit;
    vm.checkPermission = checkPermission;
    vm.isFormBlocked = isFormBlocked;
    vm.isDraggingPermitted = isDraggingPermitted;
    vm.selectFormDestinationUser = selectFormDestinationUser;
    vm.contractorHistory = contractorHistory;
    vm.addOrderForContractorAndRouteItem = addOrderForContractorAndRouteItem;
    //datePicker
    vm.openDP = openDP;
    vm.disableDP = disableDP;
    vm.onDateChange = onDateChange;
    //userpicker
    vm.onSelect = onSelect;
    vm.onRemove = onRemove;
    vm.swapItemsInArray = swapItemsInArray;
    vm.assignIndex = assignIndex;
    vm.resetStats = resetStats;
    vm.isEmailVaild = isEmailVaild;
    vm.userDictName = "UsersDictionary";

    /**blocks form fields if edition of route isn't allowed
    because of some condition for eg. event already happened in past **/
    vm.block = true;
    vm.hasContractor = false;

    vm.dictionaryData = {};
    vm.documentSums = [];
    vm.relatedTasks = {
      WeekTasks: [],
      MonthTask: undefined,
      MonthAmountTask: undefined
    };
    vm.currentRouteEfficiency = {
      finishedSum: "---",
      totalSum: "---",
      percentage: "---"
    };
    //user from calendar
    vm.calendarUser = undefined;
    //user from form (weekly view)
    vm.formUser = undefined;
    vm.destinationUser = undefined;
    //user logged into website
    vm.loggedUser = undefined;
    vm.hasError = false;
    vm.errorText = undefined;
    vm.selectedOption = undefined;
    vm.routeEditType = "data";
    vm.calendar = {};
    vm.calendar.currentDate = Date.today();
    vm.calendar.tomorrow = Date.today()
      .add(1)
      .days();
    vm.calendar.recentlyChosen = undefined;
    vm.calendar.display = undefined;
    vm.calendar.holidays = undefined;
    vm.calendar.title = undefined;
    //1 - month, 2 - week
    vm.calendar.displayType = 1;

    //datepicker
    vm.datePickerEndOpened = false;
    vm.datePickerBeginOpened = false;
    vm.dateOptions = {
      formatYear: "yy",
      startingDay: 1
    };
    vm.currentDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: vm.calendar.tomorrow,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined
    };

    vm.efficiencyStringfied;
    vm.currentRoute = {
      DndId: undefined,
      Id: undefined,
      ParentId: undefined,
      UserId: undefined,
      Name: undefined,
      Cyclic: false,
      CycleDays: undefined,
      CycleCount: 2,
      Type: 1,
      BeginDate: Date.today(),
      EndDate: undefined,
      Entities1Count: 0,
      Entities1FinishedCount: 0,
      Entities2Count: 0,
      Entities2FinishedCount: 0,
      ListId: undefined,
      list: undefined,
      Entities: [],
      StorageId: undefined,
      LogisticsAcceptanceRequired: false,
      SyncToMobile: true
    };
    vm.routeChanging = false;

    constructor();

    //init
    function constructor() {
      loadUserDictionaryData();
      vm.routes = [];
      vm.loggedUser = getLoggedUser();
      vm.isDataReloading = false;
      vm.isDragging = false;
      vm.iteratorID = 1;
      vm.initializeMonth();
      updateError();
      loadStoragesData();
      userSelectCore(undefined, true);
    }

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }

    //datepicker method
    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
        if (pagingDataField && vm.currentRoute.UserId > 0)
          getDocumentSumByType(0);
        getDocumentSumByType(2);
        getDocumentSumByType(3);
        getRouteStats(vm.currentRoute.UserId, new Date());
        vm.currentRouteEfficiency = countTimePeriodEfficiencyForRoute(
          vm.currentRoute
        );
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
    }

    function resetStats() {
      vm.documentSums = [];
      vm.relatedTasks = {
        WeekTasks: [],
        MonthTask: undefined,
        MonthAmountTask: undefined
      };
      vm.currentRouteEfficiency = {
        finishedSum: "---",
        totalSum: "---",
        percentage: "---"
      };
    }

    //diasbles choosing sundays in datepicker
    function disableDP(date, mode) {
      return mode === "day" && date.getDay() === 0;
    }

    function getRouteStats(userId, date) {
      taskRest
        .routeStats(userId, date)
        .then(function(stats) {
          vm.relatedTasks = stats;
        })
        .catch(function() {});
    }

    function getDocumentSumByType(type) {
      getDocumentSum(
        0,
        0,
        true,
        deleteDateOffsetFromDate(vm.currentRoute.BeginDate),
        deleteDateOffsetFromDate(vm.currentRoute.BeginDate),
        undefined,
        vm.currentRoute.UserId,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        type
      );
    }

    function getDocumentSum(
      page,
      count,
      getCount,
      beginDate,
      endDate,
      contractorId,
      userId,
      contractorSymbol,
      orderDocumentStatus,
      qualityReturnDocumentStatus,
      returnDocumentStatus,
      isComment,
      docSum,
      net
    ) {
      if (userId == undefined) {
        return;
      }
      visitRest
        .sum(
          page,
          count,
          getCount,
          beginDate,
          endDate,
          contractorId,
          userId,
          contractorSymbol,
          orderDocumentStatus,
          qualityReturnDocumentStatus,
          returnDocumentStatus,
          isComment,
          docSum,
          net
        )
        .then(function(summ) {
          vm.documentSums[docSum] = summ;
        })
        .catch(function() {});
    }

    //userpicker methods
    function loadUserDictionaryData() {
      /*isActive, searchStr, count, page, getCount, JobTitleId, storage, getEmployees, getAllIfPossible, userId*/
      userRest
        .all(
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
          true,
          SessionService.getAuthenticatedUser().Id
        )
        .then(function(data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function(a, b) {
            if (a.SurName == undefined) return -1;
            if (b.SurName == undefined) return 1;
            if (a.SurName < b.SurName) return -1;
            else if (a.SurName > b.SurName) return 1;
            else return 0;
          });
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    function loadStoragesData() {
      storageRest
        .all()
        .then(function(data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function(error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    //user selection ui-select
    function onSelect(item, model) {
      if (item !== undefined) {
        getRoutes();
        updateError();
      } else {
        vm.calendarUser = undefined;
        updateError();
        vm.routes.splice(0, vm.routes.length);
        //refresh routes
        pushRoutes(vm.calendar.display, vm.routes);
      }
      clearCurrentRoute();
    }

    //ui-select issue, currently not working without multiselect as of 15.07.2016, maybe will work in future ;)
    function onRemove() {
      //console.log("remove");
    }

    function userSelectCore(obj, loadFromSession) {
      if (loadFromSession) {
        if ($sessionStorage.routeCalendarUser) {
          vm.calendarUser = $sessionStorage.routeCalendarUser;
        } else return;
      } else {
        vm.calendarUser = {
          selectedUserId: obj.Id,
          Context: obj
        };
        $sessionStorage.routeCalendarUser = vm.calendarUser;
      }
      resetStats();
      getRoutes(loadFromSession);
      updateError();
      if (
        $sessionStorage.routeRouteId === undefined ||
        $sessionStorage.routeRouteId === null
      ) {
        clearCurrentRoute();
      }
    }
    //user select modal
    function selectcalendarUser() {
      var callback = userSelectCore;
      var callbackCheck = function(obj) {
        if (
          vm.calendarUser !== undefined &&
          vm.calendarUser.selectedUserId === obj.Id
        ) {
          return obj.Id;
        }
      };

      if (vm.calendar.displayType === 1)
        UsersSelectService.show(
          "lg",
          callback,
          undefined,
          callbackCheck,
          true,
          true,
          vm.loggedUser.Id,
          true,
          40,
          true
        );
      else {
        UsersSelectService.show(
          "lg",
          callback,
          undefined,
          callbackCheck,
          true,
          true,
          vm.loggedUser.Id,
          true,
          30,
          false
        );
      }
    }

    //user select modal
    function selectFormUser() {
      var callback = function(obj) {
        vm.formUser = {
          selectedUserId: obj.Id,
          Context: obj
        };
        vm.updateError();
      };

      var callbackCheck = function(obj) {
        if (
          vm.formUser !== undefined &&
          vm.formUser.selectedUserId === obj.Id
        ) {
          return obj.Id;
        }
      };
      //if weekly calendar and calendar user chosen (for eg. boss picked in calendar - shows only his employees in form to choose from)
      if (
        vm.calendarUser !== undefined &&
        vm.calendarUser.Context.JobTitleId <= 30
      ) {
        UsersSelectService.show(
          "lg",
          callback,
          undefined,
          callbackCheck,
          true,
          true,
          vm.calendarUser.selectedUserId,
          true,
          40,
          true
        );
        //weekly calendar, salesman chosen in calendar - only he can be picked in form
      } else if (
        vm.calendarUser !== undefined &&
        vm.calendarUser.Context.JobTitleId == 40
      ) {
        vm.formUser = vm.calendarUser.Context;
      } else {
        UsersSelectService.show(
          "lg",
          callback,
          undefined,
          callbackCheck,
          true,
          true,
          vm.loggedUser.Id,
          true,
          40,
          true
        );
      }
    }

    //user select modal for destination user
    function selectFormDestinationUser() {
      var callback = function(obj) {
        vm.destinationUser = {
          selectedUserId: obj.Id,
          Context: obj
        };
        eventsRest
          .changeOwner(
            vm.calendarUser.selectedUserId,
            vm.destinationUser.selectedUserId
          )
          .then(function() {
            clearCurrentRoute();
            getRoutes();
            var message = $translate.instant("routes.notifications.movedAll");
            Notification.success(message);
          })
          .catch(function() {
            var message = $translate.instant("routes.notifications.error");
            Notification.error(message);
          });
        vm.updateError();
      };

      var callbackCheck = function(obj) {
        if (
          vm.destinationUser !== undefined &&
          vm.destinationUser.selectedUserId === obj.Id
        ) {
          return obj.Id;
        }
      };

      //monthly, only salesmens
      UsersSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        true,
        true,
        vm.loggedUser.Id,
        true,
        40,
        true
      );
    }

    //adding route
    function submit() {
      if (vm.currentRoute.CycleCount > 0) vm.currentRoute.Cyclic = true;
      //if fresh route is being added
      if (!vm.routeChanging) {
        vm.currentRoute.BeginDate = vm.currentRoute.CurrentDate;
        vm.currentRoute.CurrentDate = undefined;
      }

      //date format change for comparing
      formatChange(vm.currentRoute);

      if (
        vm.currentRoute.BeginDate.getUTCDate() !==
        vm.currentRoute.BeginDate.getDate()
      )
        deleteDateOffsetsFromRoute(vm.currentRoute);

      //begin and end date comparison (end > begin [must be that way])

      //previous CYCLIC
      //if (vm.currentRoute.Cyclic === true){
      //current Cyclic
      if (vm.currentRoute.CycleCount > 0) {
        if (vm.currentRoute.EndDate !== undefined)
          if (
            Date.compare(vm.currentRoute.BeginDate, vm.currentRoute.EndDate) !==
            -1
          ) {
            window.alert(
              "Data zakończenia nie moze byc wczesniej niz data rozpoczęcia"
            );
            return false;
          }
        vm.currentRoute.CycleDays = vm.currentRoute.CycleCount * 7;
      }

      if (vm.calendarUser !== undefined || vm.formUser !== undefined) {
        if (vm.routeChanging) {
          var callback = function(operation) {
            vm.currentRoute.Operation = operation;
            vm.setRouteUserBeforeSubmit();
            eventsRest
              .save(vm.currentRoute)
              .then(function() {
                clearCurrentRoute();
                getRoutes();
                var message = $translate.instant(
                  "routes.notifications.updated"
                );
                Notification.success(message);
                vm.routeChanging = false;
              })
              .catch(function() {
                var message = $translate.instant("routes.notifications.error");
                Notification.error(message);
              });
          };
          //previous CYCLIC
          //if (vm.currentRoute.Cyclic === true){
          //current Cyclic
          if (vm.currentRoute.CycleCount > 0) {
            ActionModalService.show("sm", callback, false, undefined);
          } else {
            callback(1);
          }
        } else {
          vm.setRouteUserBeforeSubmit();
          eventsRest
            .post(vm.currentRoute)
            .then(function() {
              clearCurrentRoute();
              getRoutes();
              var message = $translate.instant("routes.notifications.added");
              Notification.success(message);
            })
            .catch(function() {
              var message = $translate.instant("routes.notifications.error");
              Notification.error(message);
            });
        }
      }
    }

    //enable/disable submitting route
    function isRouteValid() {
      if (vm.calendarUser === undefined && vm.formUser === undefined) {
        return false;
      }
      if (vm.currentRoute === undefined) {
        return false;
      }
      if (vm.currentRoute.Name === undefined) {
        return false;
      }
      if (vm.currentRoute.BeginDate === undefined) {
        return false;
      }
      if (vm.currentRoute.CurrentDate === undefined) {
        return false;
      }
      if (vm.isFormBlocked()) {
        return false;
      }
      /**if(new Date(vm.currentRoute.CurrentDate).getDate() < Date.today().getDate()){
        return false;
      }**/
      if (vm.hasContractor === false) {
        return false;
      }

      //previous CYCLIC
      //if (vm.currentRoute.Cyclic === true){
      //if(vm.currentRoute.CycleCount === undefined){
      //return false;
      //}
      //}
      if (!vm.form.$valid) {
        return false;
      }
      return true;
    }

    //remove from contractors list
    function remove(dataArr, id) {
      for (var i = 0; i < dataArr.length; i++)
        if (dataArr[i].ContextObject.Id === id) {
          var idx = i;
          break;
        }
      if (idx > -1) {
        dataArr.splice(idx, 1);
        checkEntities(vm.currentRoute.Entities);
      }
    }

    //selecting contractors
    function selectContractorSeasonal(type, dataArr) {
      var callback = function(obj) {
        addElemnt(type, dataArr, obj, "Id", "Name", "Symbol", "Name", "Symbol");
      };

      var callbackCheck = function(obj) {
        return vm.currentRoute.Entities.find(function(element) {
          return element.ContextObject.Id === obj.Id;
        });
      };

      //contractors only for selected user in modal (last parameters are users id, status)
      var id = undefined;
      if (vm.calendarUser !== undefined) id = vm.calendarUser.selectedUserId;

      ContractorSelectService.show(
        "lg",
        callback,
        callback,
        callbackCheck,
        id,
        false
      );
    }

    function selectContractor(type, dataArr) {
      var callback = function(obj) {
        addElemnt(type, dataArr, obj, "Id", "Name", "Symbol", "Name", "Symbol");
        vm.hasContractor = true;
        updateError();
      };

      var callbackCheck = function(obj) {
        return vm.currentRoute.Entities.find(function(element) {
          return element.ContextId === obj.Id;
        });
      };

      //contractors only for selected user in modal (last parameters are users id, status)
      var id = undefined;
      if (vm.formUser !== undefined) id = vm.formUser.Context.Id;
      else if (
        vm.calendarUser !== undefined &&
        vm.calendarUser.Context.JobTitleId == 40
      ) {
        id = vm.calendarUser.selectedUserId;
      }

      ContractorSelectService.show(
        "lg",
        callback,
        callback,
        callbackCheck,
        id,
        false
      );
    }

    function addElemnt(
      type,
      dataArr,
      obj,
      idAttrName,
      attrName1,
      attrName2,
      attrName1Name,
      attrName2Name
    ) {
      if (attrName1Name == undefined) attrName1Name = "Name";
      if (attrName2Name == undefined) attrName2Name = "Symbol";

      var addedObj = {};
      addedObj.ContextObject = {};
      addedObj.ContextObject["Id"] = obj[idAttrName];
      if (attrName1 != undefined)
        addedObj.ContextObject[attrName1Name] = obj[attrName1];
      if (attrName2 != undefined)
        addedObj.ContextObject[attrName2Name] = obj[attrName2];

      addedObj.ContextId = addedObj.ContextObject.Id;
      addedObj.Type = type;
      dataArr.push(addedObj);
    }

    //on route click
    function selectRoute(route) {
      //vm.block clear
      vm.block = false;
      vm.isDataReloading = true;
      var idx = route.Id;
      if (route.Id === 0) {
        idx = route.ParentId;
      }
      $sessionStorage.routeRouteId = idx;

      logRest.post(
        vm.loggedUser.Id,
        "routes.controller | Select route with Id: " + idx
      );
      eventsRest
        .get(idx, true)
        .then(function(result) {
          logRest.post(
            vm.loggedUser.Id,
            "routes.controller | Route returned with Id: " + result.Id
          );
          var tmpRoute = angular.copy(result);
          formatChange(tmpRoute);
          if (route.Id === 0) {
            tmpRoute.BeginDate = route.BeginDate.clone();
            tmpRoute.CurrentDate = route.BeginDate.clone();
            tmpRoute.ParentId = route.ParentId;
            tmpRoute.Id = route.Id;
            tmpRoute.Entities.forEach(function(entity) {
              entity.Id = 0;
            });
          } else {
            tmpRoute.CurrentDate = tmpRoute.BeginDate.clone();
          }

          if (tmpRoute.EndDate.getFullYear() == 1970) {
            tmpRoute.EndDate = undefined;
          }

          //cannot change past events (applies also to todays events)
          if (route.DndId === undefined) {
            vm.block = true;
          }

          vm.routeChanging = true;
          vm.currentRoute = tmpRoute;
          vm.isDataReloading = false;
          checkEntities(vm.currentRoute.Entities);
          vm.setFormUser();
          vm.onDateChange(vm.endDateOptions, vm.currentRoute.CurrentDate, true);
          vm.onDateChange(
            vm.currentDateOptions,
            vm.currentRoute.EndDate,
            false
          );
        })
        .catch(function(error) {
          $log.debug("Error while routes data");
          vm.isDataReloading = false;
        });
    }

    //on day click
    function selectDay(day) {
      //clearCurrentRoute();
      vm.currentRoute.CurrentDate = day.date;
    }

    // Returns date of first Monday before month, specified in date argument
    function searchFirstMondayInMonth(date) {
      var tmpDate = date.clone(),
        dayNumber = date.getDate();
      if (dayNumber > 1) {
        tmpDate = tmpDate.add(-dayNumber + 1).day();
      }
      if (tmpDate.getDay() != 1) tmpDate = tmpDate.last().monday();
      return tmpDate;
    }

    //creates array of 7 days starting from date, checks if these are days of current month
    function fillWeek(date, month) {
      var days = [];
      for (var i = 0; i < 7; i++) {
        days.push({
          stringed: date.toString(),
          number: date.getDate(),
          isCurrentMonth: date.getMonth() === month.getMonth(),
          date: date,
          list: [],
          isFree: vm.isFree(date)
        });
        date = date.clone();
        date.add({ days: 1 });
      }
      return days;
    }

    //creates array of weeks from start parameter to end of month
    function fillMonth(start, month) {
      var weeks = [];
      var done = false,
        date = start.clone(),
        monthIndex = date.getMonth(),
        count = 0;
      while (!done) {
        weeks.push({ days: fillWeek(date.clone(), month) });
        date.add({ weeks: 1 });
        done = count++ > 2 && monthIndex !== date.getMonth();
        monthIndex = date.getMonth();
      }
      pushRoutes(weeks, vm.routes);
      setWeekTitles(weeks);
      vm.calendar.title = weeks[1].days[0].date.toString("MMMM yyyy");
      return weeks;
    }

    function setWeekTitles(weeks) {
      weeks.forEach(function(week) {
        week.title = week.days[0].date.getWeek();
      });
    }

    //generates previous month based on given date
    function previousMonthGenerate(date) {
      var tmpDate = date.clone(),
        dayNumber = date.getDate(),
        month = null;
      tmpDate = tmpDate.add(-dayNumber).day();
      month = tmpDate.clone();
      tmpDate = searchFirstMondayInMonth(tmpDate);
      return fillMonth(tmpDate, month);
    }

    //displays previous month in calendar
    function previousMonth() {
      vm.calendar.display = previousMonthGenerate(
        vm.calendar.display[0].days[6].date
      );
      holidays(
        vm.calendar.display[0].days[6].date.getMonth(),
        vm.calendar.display[0].days[6].date.getFullYear()
      );
      getRoutes();
      //clearCurrentRoute();
    }

    //generates next month based on given date
    function nextMonthGenerate(date) {
      var tmpDate = date.clone(),
        dayNumber = date.getDate(),
        month = null;
      tmpDate = tmpDate.add(-dayNumber + 1).day();
      tmpDate = tmpDate.add({ months: 1 });
      dayNumber = tmpDate.getDate();
      tmpDate = tmpDate.add(-dayNumber + 1).day();
      month = tmpDate.clone();
      if (tmpDate.getDay() != 1) tmpDate = searchFirstMondayInMonth(tmpDate);
      return fillMonth(tmpDate, month);
    }

    //displays following month in calendar
    function nextMonth() {
      vm.calendar.display = nextMonthGenerate(
        vm.calendar.display[0].days[6].date
      );
      holidays(
        vm.calendar.display[0].days[6].date.getMonth(),
        vm.calendar.display[0].days[6].date.getFullYear()
      );
      getRoutes();
      //clearCurrentRoute();
    }

    //puts routes from current month into calendar, also used to refresh routes display
    function pushRoutes(month, routesAll) {
      for (var i = 0; i < month.length; i++) {
        for (var j = 0; j < month[i].days.length; j++) {
          month[i].days[j].list = [];
          routesAll.forEach(function(routes) {
            month[i].days[j].list.push({
              UserId: routes.UserId,
              UserFullName: routes.Name + " " + routes.Surname,
              routes: []
            });
            routes.List.forEach(function(route) {
              if (route.CurrentDate === undefined) {
                if (
                  route.BeginDate.getDate() ===
                    month[i].days[j].date.getDate() &&
                  route.BeginDate.getMonth() ===
                    month[i].days[j].date.getMonth()
                ) {
                  month[i].days[j].list[
                    month[i].days[j].list.length - 1
                  ].routes.push(route);
                }
              } else {
                if (
                  route.CurrentDate.getDate() ===
                    month[i].days[j].date.getDate() &&
                  route.CurrentDate.getMonth() ===
                    month[i].days[j].date.getMonth()
                ) {
                  month[i].days[j].list[
                    month[i].days[j].list.length - 1
                  ].routes.push(route);
                }
              }
            });
          });
        }
      }
      //displays month efficiency
      vm.efficiencyStringfied = vm.countTimePeriodEfficiency(routesAll);
    }

    //fires when user starts dragging
    function dragStartCallback() {
      vm.isDragging = true;
    }

    //fires when user stops dragging
    function dragEndCallback() {
      vm.isDragging = false;
    }

    //event that happens after drag and drop action performed on route
    function dropCallback(item, day, list) {
      //drog and drop in same cell
      if (
        day.date.getDate() == new Date(item.BeginDate).getDate() &&
        vm.calendar.displayType === 1
      )
        return;

      //dropping in cells past today
      if (day.date.getMonth() == Date.today().getMonth()) {
        if (day.date.getDate() < Date.today().getDate()) {
          var message = $translate.instant("routes.notifications.pastDate");
          Notification.error(message);
          return;
        }
      }

      // cannot change date of past events
      if (item.DndId === undefined) {
        return;
      }

      //dropping into sunday
      if (day.date.getDay() === 0) {
        var message = $translate.instant("routes.notifications.sundayDrop");
        Notification.error(message);
        return;
      }

      var callback = function(operation) {
        vm.routes.forEach(function(routes) {
          routes.List.forEach(function(route) {
            if (route.DndId == item.DndId) {
              route.CurrentDate = day.date.clone();
              /**if drop is connected with transfer to another user in weekly calendar, we need to change userId
                  if no transfer is executed, id will remain the same**/
              route.UserId = list.UserId;
              route.Operation = operation;
              deleteDateOffsetsFromRoute(route);
              if (route.ParentId > 0) {
                eventsRest.get(route.ParentId).then(function(result) {
                  route.Entities = result.Entities;
                  eventsRest
                    .save(route)
                    .then(function() {
                      getRoutes();
                      var message = $translate.instant(
                        "routes.notifications.updated"
                      );
                      Notification.success(message);
                    })
                    .catch(function() {
                      var message = $translate.instant(
                        "routes.notifications.error"
                      );
                      Notification.error(message);
                    });
                });
              } else {
                eventsRest
                  .save(route)
                  .then(function() {
                    getRoutes();
                    var message = $translate.instant(
                      "routes.notifications.updated"
                    );
                    Notification.success(message);
                  })
                  .catch(function() {
                    var message = $translate.instant(
                      "routes.notifications.error"
                    );
                    Notification.error(message);
                  });
              }
            }
          });
        });
        clearCurrentRoute();
      };
      if (item.CycleCount > 0)
        ActionModalService.show("sm", callback, false, undefined);
      else {
        callback(1);
      }
    }

    //dropCallback on trash
    function trashDrop(item) {
      //cannot delete past event
      if (item.DndId === undefined) {
        return;
      }

      var callback = function(operation) {
        vm.routes.forEach(function(routes) {
          routes.List.forEach(function(route) {
            if (route.DndId == item.DndId) {
              route.Operation = operation;
              deleteDateOffsetsFromRoute(route);
              eventsRest
                .remove(route)
                .then(function() {
                  getRoutes();
                  var message = $translate.instant(
                    "routes.notifications.trashDrop"
                  );
                  Notification.success(message);
                })
                .catch(function() {
                  var message = $translate.instant(
                    "routes.notifications.error"
                  );
                  Notification.error(message);
                });
            }
          });
        });

        //refresh current route in case deleted one was selected to edit
        clearCurrentRoute();
      };

      if (item.CycleCount > 0)
        ActionModalService.show("sm", callback, false, undefined, "delete");
      else {
        callback(1);
      }
    }

    //dropCAllback on route transfer
    function transferDrop(item) {
      //cannot transfer past event
      if (item.DndId === undefined) {
        return;
      }

      var callback = function(operation) {
        //if user wasn't picked - no action
        if (operation.selectedId === undefined) {
          return;
        }

        vm.routes.forEach(function(routes) {
          routes.List.forEach(function(route) {
            if (route.DndId == item.DndId) {
              if (route.CycleCount > 0) route.Operation = operation.value;
              else {
                route.Operation = 1;
              }

              route.UserId = operation.selectedId;
              deleteDateOffsetsFromRoute(route);
              eventsRest
                .save(route)
                .then(function() {
                  getRoutes();
                  var message = $translate.instant(
                    "routes.notifications.transfer"
                  );
                  Notification.success(message);
                })
                .catch(function() {
                  var message = $translate.instant(
                    "routes.notifications.error"
                  );
                  Notification.error(message);
                });
            }
          });
        });
      };

      ActionModalService.show(
        "sm",
        callback,
        true,
        vm.dictionaryData.UsersDictionary
      );
    }

    //fires after clicking on calendar cell (day)
    function chosenDay(day) {
      vm.calendar.recentlyChosen = day;
      selectDay(day);
    }

    //getting array of months holidays to display
    function holidays(month, year) {
      month++;
      vm.isDataReloading = true;
      eventsRest
        .holidays(month, year)
        .then(function(result) {
          $log.debug("Got holidays: ");

          vm.calendar.holidays = result;
          pushHolidays(vm.calendar.display, vm.calendar.holidays);
          vm.isDataReloading = false;
        })
        .catch(function(error) {
          $log.debug("Error while holidays data");
          vm.isDataReloading = false;
        });
    }

    //pushing holidays fetched from eventsRest to calendar
    function pushHolidays(month, holidays) {
      for (var i = 0; i < month.length; i++) {
        for (var j = 0; j < month[i].days.length; j++) {
          holidays.forEach(function(day) {
            var d = new Date(day.Date);
            if (
              d.getDate() === month[i].days[j].date.getDate() &&
              d.getMonth() === month[i].days[j].date.getMonth()
            ) {
              month[i].days[j].isFree = true;
            }
          });
        }
      }
    }

    //checks if a day is on weekend
    function isFree(day) {
      if (day.getDay() == 0 || day.getDay() == 6) {
        return true;
      }
      return false;
    }

    //date format change on every date in object
    function formatChange(obj) {
      var begin = new Date(obj.BeginDate);
      begin.setHours(0, 0, 0, 0);
      obj.BeginDate = begin;

      if (obj.EndDate == "") {
        obj.EndDate = undefined;
      }

      if (obj.EndDate !== undefined) {
        var end = new Date(obj.EndDate);
        end.setHours(0, 0, 0, 0);
        obj.EndDate = end;
      }

      if (obj.CurrentDate !== undefined) {
        var current = new Date(obj.CurrentDate);
        current.setHours(0, 0, 0, 0);
        obj.CurrentDate = current;
      }
    }

    function getRoutesCore(rawRoutes) {
      for (var i = 0; i < rawRoutes.length; i++) {
        vm.routes.push({
          UserId: rawRoutes[i].Id,
          Name: rawRoutes[i].Name,
          Surname: rawRoutes[i].SurName,
          List: []
        });
        rawRoutes[i].Route.forEach(function(day) {
          day.Events.forEach(function(route) {
            var r = route;
            formatChange(r);
            //changing enddate from 1970 to undefined
            if (r.EndDate.getFullYear() == 1970) {
              r.EndDate = undefined;
            }
            // changing currentDate

            if (r.CurrentDate == null || r.CurrentDate.getFullYear() == 1970)
              r.CurrentDate = undefined;

            /**adding id for drag and drop
          (must be unique for each draggable element)
          if route is past todays date or happens today
          it wont be draggable or changeable**/
            if (r.BeginDate.getTime() <= Date.today().getTime())
              r.DndId = undefined;
            else r.DndId = vm.iteratorID++;

            vm.routes[i].List.push(r);
          });
        });
      }
      //refresh routes
      pushRoutes(vm.calendar.display, vm.routes);
    }

    //getting routes from rest api
    function getRoutes(loadFromSession) {
      vm.routes = [];
      if (loadFromSession && !$stateParams.shouldReload) {
        if ($sessionStorage.routeRawRoutes) {
          logRest.post(
            vm.loggedUser.Id,
            "routes.controller | Should reload route && have raw routes"
          );
          getRoutesCore(
            JSON.parse(JSON.stringify($sessionStorage.routeRawRoutes))
          );
          if ($sessionStorage.routeRouteId) {
            $location.hash("routeTable");
            $anchorScroll();
            selectRoute({ Id: $sessionStorage.routeRouteId });
          }
        }
        return;
      } else {
        logRest.post(
          vm.loggedUser.Id,
          "routes.controller | shouldnt reload and shouldnt load from sessions"
        );
      }
      //second part of condition || for weekly calendar
      if (
        (vm.calendarUser !== undefined &&
          vm.calendarUser.selectedUserId !== undefined) ||
        vm.loggedUser.JobTitleId <= 30
      ) {
        vm.isDataReloading = true;
        //first and last day of display
        var begin = vm.calendar.display[0].days[0].date;
        var monthLength = vm.calendar.display.length - 1;
        var weekLength = vm.calendar.display[monthLength].days.length - 1;
        var end = vm.calendar.display[monthLength].days[weekLength].date;

        begin = deleteDateOffsetFromDate(begin);
        end = deleteDateOffsetFromDate(end);

        var userId = undefined;
        var managerId = undefined;
        var calendarType = vm.calendar.displayType;

        if (calendarType === 2 && vm.loggedUser.JobTitleId <= 30) {
          userId = vm.loggedUser.Id;
          if (vm.calendarUser !== undefined)
            managerId = vm.calendarUser.selectedUserId;
        }

        if (calendarType === 1) {
          if (vm.calendarUser === undefined) return;
          else {
            userId = vm.calendarUser.selectedUserId;
          }
        }
        //eventsRest.all(vm.calendarUser.selectedUserId, begin, end).then(function(result){
        eventsRest
          .all(userId, begin, end, calendarType, managerId)
          .then(function(result) {
            $sessionStorage.routeRawRoutes = JSON.parse(JSON.stringify(result));
            getRoutesCore(result);
            vm.isDataReloading = false;
            if ($sessionStorage.routeRouteId) {
              $location.hash("routeTable");
              $anchorScroll();
              selectRoute({ Id: $sessionStorage.routeRouteId });
            }
          })
          .catch(function(error) {
            $log.debug("Error while routes data");
            vm.isDataReloading = false;
          });
      }
    }

    //adds single route to display
    function refreshAfterPush(route, month) {
      for (var i = 0; i < month.length; i++) {
        for (var j = 0; j < month[i].days.length; j++) {
          if (
            route.BeginDate.getDate() === month[i].days[j].date.getDate() &&
            route.BeginDate.getMonth() === month[i].days[j].date.getMonth()
          ) {
            month[i].days[j].list.push(route);
          }
        }
      }
    }

    //deletes timezone offset from all route dates
    function deleteDateOffsetsFromRoute(route) {
      var timezoneOffset = route.BeginDate.getTimezoneOffset(),
        time = route.BeginDate.getTime();
      route.BeginDate = new Date(time - timezoneOffset * 60 * 1000);

      if (route.EndDate !== undefined) {
        time = route.EndDate.getTime();
        route.EndDate = new Date(time - timezoneOffset * 60 * 1000);
      }
      if (route.CurrentDate !== undefined) {
        time = route.CurrentDate.getTime();
        route.CurrentDate = new Date(time - timezoneOffset * 60 * 1000);
      }
    }

    //deletes timezone offset from date
    function deleteDateOffsetFromDate(date) {
      var timezoneOffset = date.getTimezoneOffset();
      var time = date.getTime();
      var returnDate = new Date(time - timezoneOffset * 60 * 1000);

      return returnDate;
    }

    //checks if theres a contractor in Entities list
    function checkEntities(Entities) {
      vm.hasContractor = false;
      updateError();
      for (var i = 0; i < Entities.length; i++) {
        if (Entities[i].Type === 1) {
          vm.hasContractor = true;
          updateError();
          break;
        }
      }
    }
    //checks if theres any message to show as error next to submit button
    function updateError() {
      vm.errorText = undefined;
      vm.hasError = false;

      if (vm.calendarUser === undefined && vm.formUser === undefined) {
        vm.errorText = "Wybierz użytkownika";
        vm.hasError = true;
      } else if (
        vm.calendarUser !== undefined &&
        vm.calendarUser.Context.JobTitleId <= 30 &&
        vm.formUser === undefined
      ) {
        vm.errorText = "Wybierz użytkownika";
        vm.hasError = true;
      } else if (vm.hasContractor === false) {
        vm.errorText = "Wybierz kontrahenta";
        vm.hasError = true;
      }
    }

    function countTimePeriodEfficiencyForRoute(route) {
      var efficiency = {
        finishedSum: 0,
        totalSum: 0
      };

      efficiency.finishedSum = route.Entities1FinishedCount;
      efficiency.totalSum = route.Entities1Count;

      if (efficiency.totalSum === 0) {
        efficiency.finishedSum = "---";
        efficiency.totalSum = "---";
        efficiency.percentage = "---";
      } else {
        efficiency.percentage = efficiency.finishedSum / efficiency.totalSum;
        efficiency.percentage = Math.round(efficiency.percentage * 100);
      }
      return efficiency;
    }

    //counts efficiency of current month/week based on past routes entities
    function countTimePeriodEfficiency(routesAll) {
      var efficiency = {
        finishedSum: 0,
        totalSum: 0
      };
      //summing values from all current month/week routes
      routesAll.forEach(function(routes) {
        routes.List.forEach(function(route) {
          //if route is from diferent month than current display dont count it
          // if counting only for one week - count everything
          if (
            (route.BeginDate.getMonth() ===
              vm.calendar.display[0].days[6].date.getMonth() &&
              vm.calendar.displayType === 1) ||
            vm.calendar.displayType === 2 ||
            route.SubType != 2
          ) {
            //counting only past + todays routes
            if (route.DndId === undefined) {
              efficiency.finishedSum =
                efficiency.finishedSum + route.Entities1FinishedCount;
              efficiency.totalSum = efficiency.totalSum + route.Entities1Count;
            }
          }
        });
      });

      //counting percentage, if there were no routes to count from, display -%-/- string
      if (efficiency.totalSum === 0) {
        efficiency.finishedSum = "-";
        efficiency.totalSum = "-";
        efficiency.percentage = "-";
      } else {
        efficiency.percentage = efficiency.finishedSum / efficiency.totalSum;
        efficiency.percentage = Math.round(efficiency.percentage * 100);
      }

      //creating return string
      var efficiencyStringfied =
        "Skuteczność: " +
        String(efficiency.percentage) +
        "% " +
        String(efficiency.finishedSum) +
        "/" +
        String(efficiency.totalSum);

      return efficiencyStringfied;
    }

    function searchLastMonday(date) {
      var tmpDate = date;
      if (tmpDate.getDay() != 1) tmpDate = tmpDate.last().monday();
      return tmpDate;
    }

    //generates first month to display in calendar view
    function initializeMonth() {
      vm.calendar.display = fillMonth(
        searchFirstMondayInMonth(Date.today()),
        Date.today()
      );
      holidays(
        vm.calendar.display[0].days[6].date.getMonth(),
        vm.calendar.display[0].days[6].date.getFullYear()
      );
    }

    //generates first week to display in calendar view if parameter undefined, else generates next/previous one
    function generateWeek(date) {
      vm.calendar.display = [];
      var week = undefined;
      if (date === undefined)
        week = fillWeek(searchLastMonday(Date.today()), Date.today());
      else {
        week = fillWeek(searchLastMonday(date), Date.today());
      }
      vm.calendar.title =
        week[0].date.toString("MMMM yyyy") +
        " / Tydzień: " +
        week[0].date.getWeek();
      vm.calendar.display.push({
        days: week,
        title: week[0].date.getWeek()
      });
      holidays(
        vm.calendar.display[0].days[6].date.getMonth(),
        vm.calendar.display[0].days[6].date.getFullYear()
      );
    }

    function nextWeek() {
      var tmpDate = vm.calendar.display[0].days[6].date.add(2).day();
      generateWeek(tmpDate);
      getRoutes();
      //clearCurrentRoute();
    }

    function previousWeek() {
      var tmpDate = vm.calendar.display[0].days[0].date.add(-2).day();
      generateWeek(tmpDate);
      getRoutes();
      //clearCurrentRoute();
    }

    function switchToMonthlyView() {
      if (vm.calendar.displayType === 1) return;
      vm.calendar.displayType = 1;
      $sessionStorage.routeDisplayType = 1;
      vm.routes.splice(0, vm.routes.length);
      clearUserSelect();
      initializeMonth();
      clearCurrentRoute();
      vm.block = true;
    }

    function switchToWeeklyView() {
      if (vm.calendar.displayType === 2) return;
      vm.calendar.displayType = 2;
      $sessionStorage.routeDisplayType = 2;
      clearUserSelect();
      generateWeek();
      getRoutes();
      clearCurrentRoute();
    }

    //html ng-click functions for calendar arrows
    function goNext() {
      if (vm.calendar.displayType === 1) {
        vm.nextMonth();
      } else if (vm.calendar.displayType === 2) {
        vm.nextWeek();
      }
    }

    function goPrevious() {
      if (vm.calendar.displayType === 1) {
        vm.previousMonth();
      } else if (vm.calendar.displayType === 2) {
        vm.previousWeek();
      }
    }

    function checkIfChoosingUserIsPossible() {
      if (vm.loggedUser.JobTitleId == 30 && vm.calendar.displayType === 2) {
        return false;
      }
      return true;
    }

    function clearUserSelect() {
      vm.calendarUser = undefined;
      vm.formUser = undefined;
      $sessionStorage.routeCalendarUser = undefined;
    }

    function removeUser() {
      clearUserSelect();
      updateError();
      if (vm.calendar.displayType === 2) getRoutes();
      else {
        vm.routes.splice(0, vm.routes.length);
        pushRoutes(vm.calendar.display, vm.routes);
      }
      clearCurrentRoute();
      if (vm.calendar.displayType === 1) vm.block = true;
      $sessionStorage.route = undefined;
    }

    //determines if form user table row should be generated
    function showFormUser() {
      if (vm.calendar.displayType === 2) {
        return true;
      }
      return false;
    }

    //sets form user on route click if weekly calendar
    function setFormUser() {
      if (vm.calendar.displayType === 1) {
        return;
      } else {
        var response = function(user) {
          vm.formUser = {
            selectedUserId: user.Id,
            Context: user
          };
          vm.updateError();
        };
        UsersService.getUserById(vm.currentRoute.UserId, response, undefined);
      }
    }

    //sets user in current route as calendarUser or formUser under conditions
    function setRouteUserBeforeSubmit() {
      if (vm.formUser !== undefined) {
        vm.currentRoute.UserId = vm.formUser.selectedUserId;
        return;
      } else if (vm.calendarUser !== undefined) {
        vm.currentRoute.UserId = vm.calendarUser.selectedUserId;
      }
    }

    function disableContractorSelect() {
      if (vm.calendarUser === undefined && vm.formUser === undefined) {
        return true;
      }
      if (vm.isFormBlocked()) {
        return true;
      }
      return false;
    }

    function goToVisit(key) {
      $state.go("home.visits.visit", { id: key.Id, cameFrom: "routes" });
    }

    //clears new route form
    function clearCurrentRoute() {
      vm.hasContractor = false;
      vm.routeChanging = false;
      vm.block = false;
      vm.formUser = undefined;
      vm.destinationUser = undefined;
      $sessionStorage.routeRouteId = undefined;
      vm.currentRoute = {
        Id: undefined,
        ParentId: undefined,
        UserId: undefined,
        Name: undefined,
        Cyclic: false,
        CycleDays: undefined,
        CycleCount: 2,
        Type: 1,
        BeginDate: Date.today(),
        EndDate: undefined,
        CurrentDate: undefined,
        Entities1Count: 0,
        Entities1FinishedCount: 0,
        Entities2Count: 0,
        Entities2FinishedCount: 0,
        ListId: undefined,
        list: undefined,
        Entities: [],
        StorageId: undefined,
        LogisticsAcceptanceRequired: false,
        SyncToMobile: true
      };
      vm.currentDateOptions.maxDate = undefined;
      vm.endDateOptions.minDate = undefined;
      updateError();
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function swapItemsInArray(array, idx1, idx2) {
      var tmp = array[idx1];
      array[idx1] = array[idx2];
      array[idx2] = tmp;
      //array[idx1].Position = idx1;
      //array[idx2].Position = idx2;
    }

    function assignIndex(item, index) {
      item.Position = index;
      return index;
    }

    function isFormBlocked() {
      if (vm.block) {
        return true;
      }
      if (!vm.checkPermission(33)) {
        return true;
      }
      return false;
    }

    function isDraggingPermitted(item) {
      if (item.DndId === undefined) {
        return false;
      }
      if (!vm.checkPermission(33)) {
        return false;
      }
      return true;
    }
    function contractorHistory(contractorObject) {
      orderHistoryModalService.show("lg", contractorObject);
    }

    function addOrderForContractorAndRouteItem(
      contractorId,
      route,
      routeEntity
    ) {
      logRest.post(
        vm.loggedUser.Id,
        "routes.controller | Adding order for contractorId: " +
          contractorId +
          " routeId:  " +
          route.Id
      );
      $state.go("home.order", {
        id: contractorId,
        route: route,
        routeEntity: routeEntity
      });
    }

    function isEmailVaild(email) {
      if (!email) return false;
      if (email.length < 3) return false;
      return true;
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ActionModalService', ActionModalService);

  ActionModalService.$inject = ['$log', '$uibModal'];

  function ActionModalService($log, $uibModal) {

    var service = {
      show: showSelectionModal
    };

    return service;

    //var
    var isVisible = false;

    function showSelectionModal(size, callback, transfer, UsersDictionary, actionName) {
      if(isVisible)
        return;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/routes/selection.modal.html',
        controller: 'ActionModalController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        UsersDictionary: function () {
          return UsersDictionary;
        },
        transfer: function(){
          return transfer;
        },
        actionName: function(){
          return actionName;
        }
      }
      });

      isVisible = true;
      modalInstance.result.then(function (data) {
        $log.info('Modal ok with ' + data);
        if(transfer === false)
          callback(data.value);
        else {
          callback(data)
        }
        isVisible = false;
      }, function (err) {
        $log.info('Modal dismissed with:  ' + err);
        isVisible = false;
      });
    }

  };

  angular
    .module('smakmak.controllers')
    .controller('ActionModalController', ActionModalController);

  /** @ngInject */
  function ActionModalController($scope, $uibModalInstance,transfer, UsersDictionary, actionName) {
    var vm = this;

    //data
    vm.result = {};
    vm.result.selectedId = undefined;
    vm.UsersDictionary = UsersDictionary
    vm.transfer = transfer;
    vm.actionName = actionName;
    //true by default because popup can show without user selection
    vm.userPicked = true;

    //functions
    vm.action = action;
    vm.onSelect = onSelect;

    constructor();

    function constructor(){
      //if user selection needed in popup
      if (vm.transfer){
        vm.userPicked = false;
      }

    }

    function action(value) {
      vm.result.value = value;
      $uibModalInstance.close(vm.result);
    }

    //user selection
    function onSelect(item, model) {
      if(item !== undefined){
        vm.userPicked = true;
      }
      else {
        vm.userPicked = false;
      }
    }

  }

})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ReturnsController", ReturnsController);

  ReturnsController.$inject = [
    "$log",
    "constRest",
    "$sessionStorage",
    "SessionService",
    "returnRest",
    "userRest",
    "ContractorSelectService",
  ];

  function ReturnsController(
    $log,
    constRest,
    $sessionStorage,
    SessionService,
    returnRest,
    userRest,
    ContractorSelectService
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadReturnsData = loadReturnsData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.resetSearchTermsWithoutLoad = resetSearchTermsWithoutLoad;
    vm.mapStatusToText = mapStatusToText;
    vm.selectContractor = selectContractor;
    vm.onDateChange = onDateChange;
    vm.openDP = openDP;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.loggedUser = undefined;
    vm.userDictName = "UsersDictionary";
    vm.documentSums = undefined;

    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined,
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined,
    };

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      status: undefined,
      userId: undefined,
      contractorId: undefined,
      contractorObj: undefined,
      endDate: undefined,
      beginDate: undefined,
    };
    vm.dictionaryData = {};

    vm.ReturnAcceptanceStatusDictionary = [
      {
        id: 1,
        name: "Akceptacja - biuro",
      },
      {
        id: 33,
        name: "Obliczanie możliwych zwrotów",
      },
      {
        id: 3,
        name: "Tworzenie PDF",
      },
      {
        id: 4,
        name: "Wysyłka maila do klienta",
      },
      {
        id: 5,
        name: "Akceptacja - klient",
      },
      {
        id: 8,
        name: "Tworzenie KFS",
      },
      {
        id: 12,
        name: "Zapisywanie KFS do Subiekta",
      },
      {
        id: 20,
        name: "Tworznie PDF dla KFS",
      },
      {
        id: 24,
        name: "Oczekuje akceptacji",
      },
      {
        id: 26,
        name: "Wysyłka do klienta",
      },
      {
        id: 25,
        name: "Proces zakończony",
      },
      {
        id: 22,
        name: "Wystawiono ręcznie",
      },
      {
        id: 6,
        name: "Do wystawienia w przyszłości",
      },
      {
        id: 14,
        name: "Brak produktów do zwrotu",
      },
      {
        id: 10,
        name: "Zaakceptowanie - inny proces",
      },
      {
        id: 31,
        name: "Anulowany",
      },
      {
        id: 34,
        name: "Ponowna wysyłka akceptacji",
      },
      {
        id: 37,
        name: "Błąd w cenach",
      },
      {
        id: 38,
        name: "Błąd w ilościach",
      },
    ];

    ///////////////// constructor call
    loadData();

    function loadData() {
      vm.loggedUser = getLoggedUser();

      $log.debug("returns.controller");
      //constructor body
      vm.setPageSize(10);

      loadDictionaryData("PageSizeDictionary");
      if ($sessionStorage.returnsPagingData != undefined)
        vm.pagingData = angular.copy($sessionStorage.returnsPagingData);

      loadDataWithPagingData(true);
      loadSalesRepresentatives();
    }

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }

    ///////////////// business logic

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    }

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    }

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    }

    function pageChanged() {
      loadDataWithPagingData(false);
    }

    function onFilterChange() {
      $sessionStorage.returnsPagingData = vm.pagingData;

      if (vm.pagingData.status == "") vm.pagingData.status = undefined;
      loadDataWithPagingData(true);
    }

    function resetSearchTerms() {
      vm.resetSearchTermsWithoutLoad();
      onFilterChange();
    }

    function resetSearchTermsWithoutLoad() {
      vm.pagingData.currentPage = 1;
      vm.pagingData.status = undefined;
      vm.pagingData.userId = undefined;
      vm.pagingData.contractorId = undefined;
      vm.pagingData.contractorObj = undefined;
      vm.pagingData.endDate = undefined;
      vm.pagingData.beginDate = undefined;
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadReturnsData(
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.status,
        vm.pagingData.userId,
        vm.pagingData.contractorId,
        vm.pagingData.beginDate,
        vm.pagingData.endDate
      );
    }

    function loadReturnsData(
      count,
      page,
      getCount,
      status,
      userId,
      contractorId,
      beginDate,
      endDate
    ) {
      vm.isDataReloading = true;
      returnRest
        .all(
          count,
          page,
          getCount,
          status,
          userId,
          contractorId,
          beginDate,
          endDate
        )
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
        })
        .catch(function (error) {
          $log.debug("Error while contractors date: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
      if ((userId || contractorId) && getCount) {
        returnRest
          .sum(status, userId, contractorId, beginDate, endDate)
          .then(function (result) {
            console.info(result);
            vm.documentSums = result;
          });
      } else {
        vm.documentSums = undefined;
      }
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadUserDictionaryData() {
      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined) return -1;
            if (b.SurName == undefined) return 1;
            if (a.SurName < b.SurName) return -1;
            else if (a.SurName > b.SurName) return 1;
            else return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    function mapStatusToText(status) {
      switch (status) {
        case 1:
          return "Akceptacja - biuro";
        case 33:
          return "Obliczanie możliwych zwrotów";
        case 3:
          return "Tworzenie PDF";
        case 4:
          return "Wysyłka maila do klienta";
        case 5:
          return "Akceptacja - klient";
        case 8:
          return "Tworzenie KFS";
        case 12:
          return "Zapisywanie KFS do Subiekta";
        case 20:
          return "Tworznie PDF dla KFS";
        case 24:
          return "Oczekuje akceptacji";
        case 26:
          return "Wysyłka do klienta";
        case 25:
          return "Proces zakończony";
        case 22:
          return "Wystawiono ręcznie";
        case 6:
          return "Do wystawienia w przyszłości";
        case 14:
          return "Brak produktów do zwrotu";
        case 10:
          return "Zaakceptowanie - inny proces";
        case 31:
          return "Anulowany";
        case 34:
          return "Ponowna wysyłka akceptacji";
        case 37:
          return "Błąd w cenach";
        case 38:
          return "Błąd w ilościach";
      }
      return "Status nieznany";
    }

    function loadSalesRepresentatives() {
      // 1000 users - there will never be more
      userRest
        .getSalesRepresentatives(
          vm.loggedUser.Id,
          undefined,
          undefined,
          1000,
          1,
          false
        )
        .then(function (result) {
          vm.dictionaryData["SalesRepresentatives"] = result;
        })
        .catch(function (error) {
          $log.debug("Error while getting users list: " + error.status);
        });
    }

    function selectContractor() {
      var callback = function (obj) {
        vm.pagingData.contractorObj = obj;
        vm.pagingData.contractorId = obj.Id;
        onFilterChange();
      };

      var callbackCheck = function (obj) {
        if (vm.pagingData.contractorId === obj.Id) return true;
        else {
          return undefined;
        }
      };

      ContractorSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        undefined,
        undefined
      );
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      vm.onFilterChange();
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ReturnController", ReturnController);

  ReturnController.$inject = [
    "$rootScope",
    "$state",
    "$log",
    "$stateParams",
    "$translate",
    "eventsRest",
    "userRest",
    "SessionService",
    "visitRest",
    "Notification",
    "constRest",
    "returnRest",
    "emailRest",
    "returnHistoryRest",
    "$http",
    "FileSaver",
    "Blob",
    "documentRest",
  ];

  function ReturnController(
    $rootScope,
    $state,
    $log,
    $stateParams,
    $translate,
    eventsRest,
    userRest,
    SessionService,
    visitRest,
    Notification,
    constRest,
    returnRest,
    emailRest,
    returnHistoryRest,
    $http,
    FileSaver,
    Blob,
    documentRest
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.goBack = goBack;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.goToDocument = goToDocument;
    vm.mapStatusToText = mapStatusToText;
    vm.accept = accept;
    vm.getEmails = getEmails;
    vm.validateEmail = validateEmail;
    vm.setEmails = setEmails;
    vm.getHistory = getHistory;
    vm.acceptToSend = acceptToSend;
    vm.download = download;
    vm.regenerate = regenerate;
    vm.cancel = cancel;
    vm.sendAgainFinal = sendAgainFinal;
    vm.sendAgainProposition = sendAgainProposition;
    vm.skipError = skipError;
    vm.isExpired = isExpired;
    vm.inFuture = inFuture;

    vm.cameFrom = undefined;
    vm.dictionaryData = {};
    vm.returnObject = undefined;
    vm.emails = [];
    vm.acceptanceHistory = [];

    vm.objectBlock = false;

    //init
    constructor();

    function constructor() {
      $log.debug("ReturnController");
      if ($stateParams.cameFrom !== undefined) {
        vm.cameFrom = $stateParams.cameFrom;
      }
      loadDictionaryData("CountryDictionary");
      loadDictionaryData("ProvinceDictionary");
      if ($stateParams.id > 0) {
        loadData($stateParams.id);
      }
    }

    function goToDocument(id) {
      $state.go("home.documents.document", { id: id });
    }

    function unblockRecord() {
      vm.objectBlock = false;
    }

    function isObjectBlocked() {
      return vm.objectBlock;
    }

    function blockRecord() {
      vm.objectBlock = true;
    }

    function isExpired(dateReturn) {
      const date1 = new Date(dateReturn);
      const date2 = new Date();
      const diffTime = date2 - date1;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      console.log(diffDays + " days");
      return diffDays > 0;
    }

    function selectAllEmailIfNotSelectedAny() {
      var emails = [];
      var anySelected = false;
      for (var i = 0; i < vm.emails.length; i++) {
        if (vm.emails[i].selected === true) {
          anySelected = true;
          break;
        }
      }

      if (anySelected) {
        return;
      }

      for (var i = 0; i < vm.emails.length; i++) {
        if (vm.emails[i].valid === true) {
          vm.emails[i].selected = true;
          emails.push(vm.emails[i].Email);
        }
      }
    }

    function sendAgainFinal(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      returnRest
        .sendAgainFinal(id)
        .then(function (ret) {
          Notification.success("KFS zostaną ponownie wysłane");
          vm.returnObject.Status = 26;
        })
        .catch(function () {
          Notification.error(
            "Nie udało się zmienić statusu żeby ponownie wysłać KFS"
          );
        })
        .finally(function () {
          unblockRecord();
        });
    }

    function sendAgainProposition(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      returnRest
        .sendAgainProposition(id)
        .then(function (ret) {
          Notification.success("Propozycje zostaną na nowo wysłane");
          vm.returnObject.Status = 33;
        })
        .catch(function () {
          Notification.error(
            "Nie udało się zmienić statusu żeby ponownie wysłać propozycję KFS"
          );
        })
        .finally(function () {
          unblockRecord();
        });
    }

    function skipError(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      returnRest
        .skipError(id)
        .then(function (ret) {
          Notification.success("Błąd został pominięty");
          vm.returnObject.Status = 33;
        })
        .catch(function () {
          Notification.error("Nie udało się pominąć błędu");
        })
        .finally(function () {
          unblockRecord();
        });
    }

    function accept(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      selectAllEmailIfNotSelectedAny();
      var emails = [];
      for (var i = 0; i < vm.emails.length; i++) {
        if (vm.emails[i].valid === true && vm.emails[i].selected === true) {
          emails.push(vm.emails[i].Email);
        }
      }

      returnRest
        .setEmails(vm.returnObject.Id, emails)
        .then(function (ret) {
          Notification.success("Adresy email ustawione");
          return returnRest.accept(
            id,
            SessionService.getAuthenticatedUser().Id,
            emails
          );
        })
        .then(function (ret) {
          Notification.success("Zwrot zaakceptowany");
          vm.returnObject.Status = 33;
          unblockRecord();
        })
        .catch(function (visit) {
          Notification.error("Nie udało się zaakceptować zwrotu");
          unblockRecord();
        });
    }

    function cancel(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      returnRest
        .cancel(id, SessionService.getAuthenticatedUser().Id)
        .then(function (ret) {
          Notification.success("Zwrot anulowany");
          vm.returnObject.Status = 31;
          unblockRecord();
        })
        .catch(function () {
          unblockRecord();
        });
    }

    function inFuture(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      documentRest
        .changeStatus(id, 6)
        .then(function () {
          Notification.success("Zwrot do wystawienia w przyszłości");
          vm.returnObject.Status = 6;
          unblockRecord();
        })
        .catch(function () {
          Notification.error("Nie udało się ustawić statusu");
          unblockRecord();
        });
    }

    function acceptToSend(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      returnRest
        .acceptToSend(id)
        .then(function (ret) {
          Notification.success("Zwrot zaakceptowany do wysyłki");
          vm.returnObject.Status = 25;
          unblockRecord();
        })
        .catch(function (visit) {
          Notification.error("Nie udało się zaakceptować zwrotu do wysyłki");
          unblockRecord();
        });
    }

    function regenerate(id) {
      if (isObjectBlocked()) return;
      blockRecord();
      returnRest
        .regenerateFinalDocuments(id)
        .then(function (ret) {
          Notification.success("Dokumenty PDF zostaną wygenerowane ponownie");
          vm.returnObject.Status = 20;
          unblockRecord();
        })
        .catch(function (visit) {
          Notification.error("Błąd");
          unblockRecord();
        });
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function getHistory(acceptanceId) {
      returnHistoryRest.all(acceptanceId).then(function (resp) {
        vm.acceptanceHistory = resp;
        console.info(resp);
      });
    }

    function getEmails(contractorId) {
      const emailsStrings = vm.returnObject.emails
        ? vm.returnObject.emails.split("|")
        : [];
      emailRest.get(contractorId).then(function (emails) {
        vm.emails = [];
        var localEmails = [];
        for (var i = 0; i < emails.length; i++) {
          var localEmailsSemicolon = emails[i].Email.split(";");
          var localEmailsComma = emails[i].Email.split(";");
          for (var j = 0; j < localEmailsSemicolon.length; j++) {
            if (localEmailsSemicolon[j].length < 1) continue;
            localEmails.push(localEmailsSemicolon[j].trim());
          }
          for (var j = 0; j < localEmailsComma.length; j++) {
            if (localEmailsComma[j].length < 1) continue;
            localEmails.push(localEmailsComma[j].trim());
          }
          if (
            localEmailsSemicolon.length < 1 &&
            localEmailsSemicolon.length < 1
          ) {
            localEmails.push(emails[0].Email.trim());
          }
        }
        var uniqueEmails = localEmails.filter(function (item, pos) {
          return localEmails.indexOf(item) == pos;
        });

        for (var i = 0; i < uniqueEmails.length; i++) {
          vm.emails.push({
            Email: uniqueEmails[i],
            valid: validateEmail(uniqueEmails[i]),
            selected: emailsStrings.includes(uniqueEmails[i]),
          });
        }
      });
    }

    function loadData(id) {
      returnRest.get(id).then(function (returnObject) {
        vm.returnObject = returnObject;
        setProperAddress(vm.returnObject.RecipientObject);
        if (!!returnObject.RecipientObject) {
          getEmails(returnObject.RecipientObject.Id);
        } else {
          getEmails(returnObject.PayerObject.Id);
        }

        getHistory(returnObject.Id);
      });
    }

    function setProperAddress(contractor) {
      if (contractor.IsDeliveryAddress) {
        contractor.recieverAddress = contractor.DeliveryAddress;
      } else {
        contractor.recieverAddress = contractor.DefaultAddress;
      }
    }

    function goBack() {
      if (vm.cameFrom !== undefined) $state.go("home." + vm.cameFrom);
      else {
        $state.go("home.returns");
      }
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function mapStatusToText(status) {
      switch (status) {
        case 1:
          return "Akceptacja - biuro";
        case 33:
          return "Obliczanie możliwych zwrotów";
        case 3:
          return "Tworzenie PDF";
        case 4:
          return "Wysyłka maila do klienta";
        case 5:
          return "Akceptacja - klient";
        case 8:
          return "Tworzenie KFS";
        case 12:
          return "Zapisywanie KFS do Subiekta";
        case 20:
          return "Tworznie PDF dla KFS";
        case 24:
          return "Oczekuje akceptacji";
        case 26:
          return "Wysyłka do klienta";
        case 25:
          return "Proces zakończony";
        case 22:
          return "Wystawiono ręcznie";
        case 6:
          return "Do wystawienia w przyszłości";
        case 14:
          return "Brak produktów do zwrotu";
        case 10:
          return "Zaakceptowanie - inny proces";
        case 31:
          return "Anulowany";
        case 34:
          return "Ponowna wysyłka akceptacji";
        case 37:
          return "Błąd w cenach";
        case 38:
          return "Błąd w ilościach";
      }
      return "Status nieznany";
    }

    function setEmails() {
      if (isObjectBlocked()) return;
      blockRecord();
      var emails = [];
      for (var i = 0; i < vm.emails.length; i++) {
        if (vm.emails[i].valid === true && vm.emails[i].selected === true) {
          emails.push(vm.emails[i].Email);
        }
      }
      returnRest
        .setEmails(vm.returnObject.Id, emails)
        .then(function (ret) {
          Notification.success("Adresy email zmienione");
          unblockRecord();
        })
        .catch(function () {
          Notification.error("Nie udało się zmienić adresów emails");
          unblockRecord();
        });
    }

    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function download(document) {
      var splits = document.GeneratedFileUrl.split("/");
      var fileName = splits[splits.length - 1];

      $http({
        method: "GET",
        url: $rootScope.API_URL + "/documents/" + document.Id + "/pdf",
        responseType: "arraybuffer",
        headers: {
          Authorization: SessionService.getAuthorisationHeader(),
        },
      }).then(function successCallback(response) {
        console.info(response.data.length);
        var file = new Blob([response.data], {
          type: "application/pdf",
        });
        FileSaver.saveAs(file, fileName);
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("smakmak.services")
    .factory("NewReportService", NewReportService);

  NewReportService.$inject = ["$log", "$uibModal"];

  function NewReportService($log, $uibModal) {
    var service = {
      show: showModal,
      close: close,
      getProduct: getProduct,
      getOptions: getOptions,
    };

    var instance = undefined;
    var isVisible = false;
    // check function should return false if element isn't chosen or true if is chosen
    var product = undefined;
    var opt = {};

    return service;

    function showModal(size, callback, options) {
      if (isVisible) return;
      opt = options;
      isVisible = true;

      instance = $uibModal.open({
        animation: true,
        templateUrl: "app/components/reports/reports.modal.html",
        controller: "NewReportController",
        controllerAs: "vm",
        size: size,
      });
      //return modalInstance.result;
      instance.result.then(
        function (data) {
          $log.debug("NewReportService ok with " + data);
          isVisible = false;
          if (data && callback) {
            callback(data);
          }
        },
        function (err) {
          $log.debug("NewReportService dismissed with:  " + err);
          isVisible = false;
        }
      );
    }

    function close(obj) {
      instance.close(obj);
    }

    function getProduct() {
      return product;
    }

    function getOptions() {
      return opt;
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("NewReportController", NewReportController);

  NewReportController.$inject = [
    "NewReportService",
    "reportRest",
    "Notification",
  ];

  function NewReportController(NewReportService, reportRest, Notification) {
    /* jshint validthis: true */
    var vm = this;
    vm.closeModal = closeModal;
    vm.closeByEnter = closeByEnter;
    vm.openDP = openDP;
    vm.createReport = createReport;
    vm.dateOptions = {
      formatYear: "yy",
      startingDay: 1,
    };
    vm.beginDateDatePickerOpenedModal = false;
    vm.endDateDatePickerOpenedModal = false;
    vm.dates = {
      beginDate: undefined,
      endDate: undefined,
    };
    vm.objectBlock = false;

    function unblockRecord() {
      vm.objectBlock = false;
    }

    function isObjectBlocked() {
      return vm.objectBlock;
    }

    function blockRecord() {
      vm.objectBlock = true;
    }

    function createReport() {
      if (isObjectBlocked()) return;
      blockRecord();
      console.info("create report");
      reportRest
        .createReport(vm.dates.beginDate, vm.dates.endDate, 1, 2)
        .then(function (result) {
          Notification.success("Raport stworzony");
          closeModal();
        })
        .catch(function (error) {
          Notification.error("Nie udało się stworzyć raportu");
        })
        .finally(function (error) {
          unblockRecord();
        });
    }
    function openDP($event, object) {
      console.info("open dp");
      if (object === 1) vm.beginDateDatePickerOpenedModal = true;
      else vm.endDateDatePickerOpenedModal = true;
    }

    function closeByEnter() {
      NewReportService.close(vm.product);
    }

    function closeModal(product) {
      NewReportService.close(product);
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ReportsController", ReportsController);

  ReportsController.$inject = [
    "$rootScope",
    "$log",
    "constRest",
    "$sessionStorage",
    "SessionService",
    "reportRest",
    "NewReportService",
    "$http",
    "FileSaver",
    "Blob",
  ];

  function ReportsController(
    $rootScope,
    $log,
    constRest,
    $sessionStorage,
    SessionService,
    reportRest,
    NewReportService,
    $http,
    FileSaver,
    Blob
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadReturnsData = loadReturnsData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.resetSearchTermsWithoutLoad = resetSearchTermsWithoutLoad;
    vm.mapStatusToText = mapStatusToText;
    vm.openDP = openDP;
    vm.addReport = addReport;
    vm.download = download;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.loggedUser = undefined;
    vm.userDictName = "UsersDictionary";
    vm.documentSums = undefined;

    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.beginDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      maxDate: undefined,
    };
    vm.endDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: undefined,
    };

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
    };
    vm.dictionaryData = {};

    vm.ReportStatusDictionary = [
      {
        id: 35,
        name: "Oczekuje na wygenerowanie",
      },
      {
        id: 36,
        name: "Wygenerowano",
      },
    ];

    ///////////////// constructor call
    loadData();

    function loadData() {
      vm.loggedUser = getLoggedUser();

      $log.debug("reports.controller");
      //constructor body
      vm.setPageSize(10);

      loadDictionaryData("PageSizeDictionary");
      if ($sessionStorage.reportsPagingData != undefined)
        vm.pagingData = angular.copy($sessionStorage.reportsPagingData);

      loadDataWithPagingData(true);
    }

    function addReport() {
      console.info("add report");
      NewReportService.show("md");
    }

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }

    ///////////////// business logic

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    }

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    }

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    }

    function pageChanged() {
      loadDataWithPagingData(false);
    }

    function onFilterChange() {
      $sessionStorage.reportsPagingData = vm.pagingData;

      if (vm.pagingData.status == "") vm.pagingData.status = undefined;
      loadDataWithPagingData(true);
    }

    function resetSearchTerms() {
      vm.resetSearchTermsWithoutLoad();
      onFilterChange();
    }

    function resetSearchTermsWithoutLoad() {
      vm.pagingData.currentPage = 1;
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadReturnsData(
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount
      );
    }

    function loadReturnsData(count, page, getCount) {
      vm.isDataReloading = true;
      reportRest
        .all(count, page, getCount)
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
        })
        .catch(function (error) {
          $log.debug("Error while contractors date: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function download(key) {
      var splits = key.FileUrl.split("/");
      var fileName = splits[splits.length - 1];

      $http({
        method: "GET",
        url: $rootScope.API_URL + "/reports/" + key.Id + "/csv",
        responseType: "arraybuffer",
        headers: {
          Authorization: SessionService.getAuthorisationHeader(),
        },
      }).then(function successCallback(response) {
        console.info(response.data.length);
        var file = new Blob([response.data], {
          type: "text/csv",
        });
        FileSaver.saveAs(file, fileName);
      });
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function mapStatusToText(status) {
      switch (status) {
        case 35:
          return "Oczekuje na wygenerowanie";
        case 36:
          return "Wygenerowano";
      }
      return "Status nieznany";
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerBeginOpened = true;
      else vm.datePickerEndOpened = true;
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ResetController', ResetController);

  ResetController.$inject = ['$log', 'UsersService', 'AuthorizationService', '$stateParams', '$state', '$filter', '$timeout', '$translate'];

  function ResetController($log, UsersService, AuthorizationService, $stateParams, $state, $filter, $timeout, $translate) {
    var vm = this;

    vm.checkAuthStatus = checkAuthStatus;
    vm.forgotPassword = forgotPassword;
    vm.forgotPasswordConfirm = forgotPasswordConfirm;
    vm.closeAlert = closeAlert;
    vm.disableButton = false;

    // FORMLY
    vm.user = {
      email: '',
      type: '',
      code:'',
      password: '',
      password2:  ''
    };
    vm.isError = false;
    vm.isSend = false;
    vm.error = {};

    vm.user.code = decodeURIComponent((decodeURI($stateParams.code))); //decodeURI


    // FORMLY

    ///////////

    function checkAuthStatus() {
      AuthorizationService.isUserLogged(function (status) {
        vm.isLogged = status;
      });
    }

    function forgotPassword(email) {
      $log.log(email);
      if (vm.disableButton == true)
        return;

      if(vm.userForm.$invalid) {
        return;
      }
      vm.disableButton = true;
      vm.isSend = false;
      AuthorizationService.forgotPassword(email,
        function (obj) {
          $timeout(function () {
            $state.go('login');
          }, 10000);
        },
        function (err) {
          vm.disableButton = false;
          $log.log(err);
          vm.isError = true;
          vm.error = $filter('translate')('common.services.forgotPassword.' + err);
        });
    }

    function resetPass(email, code, password){
      AuthorizationService.forgotPasswordConfirm(email, code, password,
        function (obj) {
          vm.disableButton = false;
          $state.go('login');
        },
        function (err) {
          $log.log(err);
          vm.isError = true;
          vm.error = $filter('translate')('common.services.forgotPasswordConfirm.' + err);
          vm.disableButton = false;
        });
    }

    function forgotPasswordConfirm(email, code, password, password2) {
      $log.log(email, code, password, password2);
      if(vm.userForm.$invalid) {
        return;
      }
      if(password != password2) {
        vm.isError = true;
        vm.error = $filter('translate')('common.validators.differentPasswords');
        return
      }
      vm.disableButton = true;

      //0: e mail w subiekcie i zarejestrowany
      //1: e-mail w subiekie i niezarejestrowany
      //2: e-mail nie istnieje
      AuthorizationService.checkEmail(email, function (data) {
        switch (data.Status) {
          case 1:
          case 2:
            vm.isError = true;
            vm.error = $filter('translate')('login.states.emailInvalid');
            break;
          default:
          {
            resetPass(email, code, password);
          }
        }
      }, function error(err) {
        vm.isError = true;
        vm.error = $filter('translate')('common.services.500');
      });
    }

    function closeAlert(){
      vm.isError = false;
      vm.error = undefined;
    }

    vm.resetpassFields = [{
      key: 'email',
      type: 'input',
      templateOptions: {
        type: 'email',
        label: 'E-mail',
        required: true,
        placeholder: $translate.instant('common.form.email'),
        minlength: 6
      },
      validation: {
        messages: {
          // required: 'to.label + " jest wymagane"',
          minlength: 'to.label + " musi zawierać 6 znaków i znak @"'
        }
      }}];

    vm.resetpassConfirmFields = [{
      key: 'email',
      type: 'input',
      templateOptions: {
        type: 'email',
        label: 'E-mail',
        required: true,
        placeholder: $translate.instant('common.form.email'),
        minlength: 6
      },
      validation: {
        messages: {
          // required: 'to.label + " jest wymagane"',
          minlength: 'to.label + " musi zawierać 6 znaków i znak @"'
        }
      }}, {
      key: 'code',
      type: 'textarea',
      templateOptions: {
        type: 'code',
        label: 'Kod(Wykorzystany tylko do testów)',
        required: true,
        // label: 'token',
        placeholder: 'Kod z adresu e-mail. Tylko w celach testowych. W produkcyjnej aplikacji nie będzie tego pola.',
        rows: 8
      }
    }, {
      key: 'password',
      type: 'input',
      templateOptions: {
        type: 'password',
        label: 'Nowe hasło',
        placeholder: $translate.instant('reset.passwordConf'),
        required: true,
        minlength: 6
      },
      validation: {
        messages: {
          required: 'to.label + " jest wymagane"',
          minlength: 'to.label + " musi zawierać minimum 6 znaków"'
        }
      }
    }, {
      key: 'password2',
      type: 'input',
      templateOptions: {
        type: 'password',
        label: 'Potwierdzenie nowego hasła',
        placeholder: $translate.instant('reset.passwordConf2'),
        required: true,
        minlength: 6
      },

      validation: {
        messages: {
          required: 'to.label + " jest wymagane"',
          minlength: 'to.label + " minimum 6 znaków"'
        }
      }
    }];

  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ProductsSelectService', ProductsSelectService);

  ProductsSelectService.$inject = ['$log', '$uibModal'];

  function ProductsSelectService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      check: check,
      visible: visible
    };

    return service;

    //var
    var isVisible = false;
    var instance = undefined;
    var callbackMultiSelect = undefined;
    var checkFunction = undefined;

    function showModal(size, callback, callbackMulti, checkFunc) {
      if (isVisible)
        return;
      callbackMultiSelect = callbackMulti;
      checkFunction = checkFunc;
      isVisible = true;
      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/products/productsSelect.html',
        controller: 'ProductsController',
        controllerAs: 'vm',
        size: size,
        resolve: {
          checkFunction: function () {
            return checkFunc;
          }
        }
      });
      //return modalInstance.result;
      instance.result.then(function (data) {
        $log.debug('contractorsSelect ok with ' + data);
        isVisible = false;
        if (data)
          callback(data);
      }, function (err) {
        $log.debug('contractorsSelect dismissed with:  ' + err);
        isVisible = false;
      });
    }

    function close(obj) {
      if (callbackMultiSelect != undefined)
        callbackMultiSelect(obj);
      else
        instance.close(obj);
    };

    function check(obj) {
      return checkFunction(obj);
    }
    function visible(){
      return isVisible;
    }

  };

})();



/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ProductsController', ProductsController);

  ProductsController.$inject = ['$log', 'constRest', '$sessionStorage', 'SessionService', 'productRest', 'ProductsSelectService'];

  function ProductsController($log, constRest, $sessionStorage, SessionService, productRest, ProductsSelectService) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadProductsData = loadProductsData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.selectProduct = selectProduct;
    vm.isAdded = isAdded;
    vm.resetSearchTermsWithoutLoad = resetSearchTermsWithoutLoad;


    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      isBlocked: undefined,
      groupId: undefined,
      searchStr: undefined,
      isAcceptanceRequired: undefined
    };
    vm.dictionaryData = {};

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("documents.controller");
      //constructor body
      vm.setPageSize(10);


      loadDictionaryData("ProductGroupDictionary");
      loadDictionaryData("VATDictionary");
      loadDictionaryData("PageSizeDictionary");
      if ($sessionStorage.productsPagingData != undefined)
        vm.pagingData = angular.copy($sessionStorage.productsPagingData)  ;

      if(ProductsSelectService.visible()) {
        resetSearchTermsWithoutLoad();
      }

      loadDataWithPagingData(true);
    }

    ///////////////// business logic

    function selectProduct(obj) {
      ProductsSelectService.close(obj);
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
      if(!ProductsSelectService.visible()) {
        $sessionStorage.productsPagingData = vm.pagingData;
      }
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      if(!ProductsSelectService.visible()) {
        $sessionStorage.documentsPagingData = vm.pagingData;
      }
      loadDataWithPagingData(true);
    }

    function getUserSelectText(selectObj) {
      var str;
      if (selectObj == undefined || selectObj == {} || selectObj == 0)
        return "";
      return selectObj.SurName + " " + selectObj.Name;
    }

    function resetSearchTerms() {
      vm.resetSearchTermsWithoutLoad();
      onFilterChange();
    }

    function resetSearchTermsWithoutLoad(){
      vm.pagingData.currentPage = 1;
      vm.pagingData.groupId = undefined;
      vm.pagingData.searchStr = undefined;
      vm.pagingData.isBlocked = undefined;
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function isAdded(key){
      var obj = ProductsSelectService.check(key);
      if(obj === undefined)
        return false;
      else
        return true;
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadProductsData(
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.isBlocked,
        vm.pagingData.groupId,
        vm.pagingData.searchStr
      );
    }

    function loadProductsData(count, page, getCount, isBlocked, groupId, searchStr) {
      vm.isDataReloading = true;
      productRest.all(count, page, getCount, isBlocked, groupId, searchStr)
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
        })
        .catch(function (error) {
          $log.debug("Error while contractors date: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadUserDictionaryData() {
      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    ///////////////// FORMLY

  }
})
();

/**
 * Created by Misiek on 2015-11-05.
 */
(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ProductController", ProductController);

  ProductController.$inject = [
    "$q",
    "$log",
    "$stateParams",
    "$state",
    "$translate",
    "constRest",
    "SessionService",
    "productRest",
    "Notification",
    "ContractorSelectService",
    "contractorRest",
    "customParameterRest",
    "sweetAlert"
  ];

  function ProductController(
    $q,
    $log,
    $stateParams,
    $state,
    $translate,
    constRest,
    SessionService,
    productRest,
    Notification,
    ContractorSelectService,
    contractorRest,
    customParameterRest,
    sweetAlert
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.addOrUpdateParam = addOrUpdateParam;
    vm.setParamInColumn = setParamInColumn;
    vm.trySetParamInColumn = trySetParamInColumn;
    vm.deleteParam = deleteParam;
    vm.deleteParamsRow = deleteParamsRow;
    vm.filterParamsRows = filterParamsRows;
    vm.resetParamsFilters = resetParamsFilters;
    vm.loadProductData = loadProductData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.toggleBlockedFlag = toggleBlockedFlag;
    vm.checkPermission = checkPermission;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.getStrorageById = getStrorageById;
    vm.formatDate = formatDate;
    vm.goBack = goBack;
    vm.selectContractor = selectContractor;
    vm.submit = submit;
    ///////////////// data def
    vm.data = undefined;
    vm.displayedParameters = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.dictionaryData = {};
    vm.paramsFilters = undefined;
    vm.contractorFilter = undefined;
    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("document.controller");
      //constructor body

      loadDictionaryData("PriceLevel");
      loadDictionaryData("VATDictionary");
      loadDictionaryData("ProductFieldsNameDictionary");
      loadDictionaryData("ProductGroupDictionary");
      loadDictionaryData("ManufacturerDictionary");
      loadDictionaryData("CustomParamsDictionary").then(function() {
        setFiltersRow(vm.dictionaryData["CustomParamsDictionary"]);
        loadProductData($stateParams.id);
      });

      document
        .getElementById("paramsPanel")
        .addEventListener("scroll", function() {
          var translate = "translate(0," + this.scrollTop + "px)";
          this.querySelector("div").style.transform = translate;
          this.querySelector("thead").style.transform = translate;
        });
    }

    ///////////////// business logic

    function toggleBlockedFlag(object) {
      var toggleAccept = function(object) {
        object.IsBlocked = !object.IsBlocked;
        object
          .save()
          .then(function(result) {})
          .catch(function(error) {});
      };

      ConfirmModalService.show(
        "sm",
        {
          title: "confirmModal.warning",
          topBodyText: $translate.instant("confirmModal.bodyChangeStatus"),
          type: 1,
          okText: "confirmModal.ok",
          cancelText: "confirmModal.cancel"
        },
        toggleAccept,
        object
      );
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function(key) {
        return key.LocalId === localId;
      });
    }

    function formatDate(date) {}

    function getStrorageById(id) {
      if (vm.dictionaryData["Storages"] == undefined || id == undefined) return;
      return vm.dictionaryData["Storages"].find(function(key) {
        return key.Id === id;
      });
    }

    function submit() {
      vm.isDataReloading = true;
      if (vm.data.Height == null || vm.data.Height == undefined) {
        vm.data.Height = 0.0;
      }
      var data = {};
      angular.copy(vm.data, data);
      data.CustomParameters = null;
      productRest
        .save(data)
        .then(function(result) {
          var message = $translate.instant("products.notifications.updated");
          Notification.success(message);
          $state.go("home.products");
          vm.isLoading = false;
        })
        .catch(function(error) {
          var message = $translate.instant("products.notifications.error");
          Notification.error(message);
          $log.debug("Error while saving product");
          vm.error = error;
          vm.isLoading = false;
        });
    }
    ///////////////// watchers

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function setFiltersRow(CustomParamsDictionary) {
      var filtersRow = [];
      CustomParamsDictionary.forEach(function(param) {
        filtersRow.push({ paramId: param.Id, value: undefined });
      });
      vm.paramsFilters = filtersRow;
    }

    function loadProductData(id) {
      vm.isDataReloading = true;
      var loadedProduct = undefined;
      productRest
        .get(id)
        .then(function(result) {
          loadedProduct = result;
          result.CustomParameters = getCustomParamsSortedByDictionary(
            result.CustomParameters
          );
          generateParamsRowObjects(result, result.CustomParameters);
          return loadContractorObjectsForCustomParams(result.CustomParameters);
        })
        .then(function() {
          vm.data = loadedProduct;
          vm.displayedParameters = vm.data.CustomParameters;
          vm.isDataReloading = false;
        })
        .catch(function(error) {
          $log.debug("Error while getting document");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function loadContractorObjectsForCustomParams(customParams) {
      var deferred = $q.defer();
      var promiseList = [];
      customParams.forEach(function(paramsRow) {
        promiseList.push(loadContractorForParamsRowSingle(paramsRow));
      });
      $q.all(promiseList)
        .then(function() {
          deferred.resolve();
        })
        .catch(function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function loadContractorForParamsRowSingle(paramsRow) {
      var deferred = $q.defer();
      contractorRest
        .get(paramsRow.Params[0].ContextId2, false, false, false)
        .then(function(contractor) {
          paramsRow.ContractorObject = contractor;
          paramsRow.ContractorId = contractor.Id;
          deferred.resolve();
        })
        .catch(function() {
          deferred.reject();
        });
      return deferred.promise;
    }

    function generateParamsRowObjects(productObject, paramsArray) {
      var arrayWithObjects = [];
      paramsArray.forEach(function(row) {
        arrayWithObjects.push(createContractorRowObject(row));
      });
      productObject.CustomParameters = arrayWithObjects;
    }

    function createContractorRowObject(paramsRow) {
      var newObjectParams = paramsRow;
      var arrayObject = {
        ContractorObject: undefined,
        ProductId: undefined,
        ContractorId: undefined,
        Params: newObjectParams
      };
      return arrayObject;
    }

    function loadDictionaryData(name) {
      var deferred = $q.defer();
      constRest
        .getDictionary(name)
        .then(function(data) {
          vm.dictionaryData[name] = data;
          vm.dictionaryData[name].sort(function(a, b) {
            if (a.Value == "Jednostka Miary") {
              return 2;
            }
            if (a.Value == undefined) return -1;
            if (b.Value == undefined) return 1;
            if (a.Value < b.Value) return -1;
            else if (a.Value > b.Value) return 1;
            else return 0;
          });
          deferred.resolve();
        })
        .catch(function(error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
          deferred.reject();
        });
      return deferred.promise;
    }

    //goes back to previous state
    function goBack() {
      $state.go("home.products");
    }

    function selectContractor() {
      var callback = function(contractor) {
        var cont = getContractorRequiredData(
          contractor,
          "Id",
          "Name",
          "SearchField",
          "Name",
          "SearchField"
        );
        var newRow = {
          ContractorObject: cont.ContextObject,
          ProductId: vm.data.Id,
          ContractorId: cont.ContextId,
          Params: generateNewCustomParamsFields(vm.data.Id, cont.ContextId)
        };
        vm.data.CustomParameters.push(newRow);
        if (vm.displayedParameters !== vm.data.CustomParameters) {
          vm.displayedParameters.push(newRow);
        }
      };

      var callbackCheck = function(obj) {
        return vm.data.CustomParameters.find(function(element) {
          return element.ContractorId === obj.Id;
        });
      };

      ContractorSelectService.show(
        "lg",
        callback,
        callback,
        callbackCheck,
        undefined,
        false
      );
    }

    function generateNewCustomParamsFields(productId, contractorId) {
      var customParams = [];
      vm.dictionaryData["CustomParamsDictionary"].forEach(function(param) {
        customParams.push({
          Id: 0,
          ContextId: productId,
          ContextType: 2,
          ContextId2: contractorId,
          ContextType2: 1,
          TextValue: undefined,
          Name: param.LocalId,
          NameContext: 1
        });
      });
      return customParams;
    }

    function getContractorRequiredData(
      obj,
      idAttrName,
      attrName1,
      attrName2,
      attrName1Name,
      attrName2Name
    ) {
      if (attrName1Name == undefined) attrName1Name = "Name";
      if (attrName2Name == undefined) attrName2Name = "Symbol";

      var addedObj = {};
      addedObj.ContextObject = {};
      addedObj.ContextObject["Id"] = obj[idAttrName];
      if (attrName1 != undefined)
        addedObj.ContextObject[attrName1Name] = obj[attrName1];
      if (attrName2 != undefined)
        addedObj.ContextObject[attrName2Name] = obj[attrName2];

      addedObj.ContextId = addedObj.ContextObject.Id;
      return addedObj;
    }

    function getCustomParamsSortedByDictionary(customParams) {
      var sortedParams = [];
      customParams.forEach(function(rowParams) {
        var sortedRow = [];
        vm.dictionaryData["CustomParamsDictionary"].forEach(function(
          dictionaryItem
        ) {
          var isParamExisting = false;
          for (var i = 0; i < rowParams.length; i++) {
            if (rowParams[i].Name == dictionaryItem.LocalId) {
              isParamExisting = true;
              sortedRow.push(rowParams[i]);
            }
          }
          if (!isParamExisting) {
            sortedRow.push({
              Id: 0,
              ContextId: rowParams[0].ContextId,
              ContextType: 2,
              ContextId2: rowParams[0].ContextId2,
              ContextType2: 1,
              TextValue: undefined,
              Name: dictionaryItem.LocalId,
              NameContext: 1
            });
          }
        });
        sortedParams.push(sortedRow);
      });
      return sortedParams;
    }

    function addOrUpdateParam(param, isPartOfMultiple) {
      var deferred = $q.defer();
      if (param.isLocked) {
        deferred.resolve();
        return deferred.promise;
      }
      param.isLocked = true;
      if (param.Id) {
        customParameterRest
          .update(param)
          .then(function(response) {
            param.isModified = false;
            param.isLocked = false;
            if (!isPartOfMultiple) {
              var message = $translate.instant("products.notifications.list");
              Notification.success(message);
            }
            deferred.resolve();
          })
          .catch(function(err) {
            param.isLocked = false;
            if (!isPartOfMultiple) {
              var message = $translate.instant(
                "products.notifications.sendError"
              );
              Notification.error(message);
            }
            deferred.reject();
          });
      } else {
        customParameterRest
          .add(param)
          .then(function(response) {
            param.isLocked = false;
            param.Id = response.Id;
            param.isModified = false;
            if (!isPartOfMultiple) {
              var message = $translate.instant("products.notifications.list");
              Notification.success(message);
            }
            deferred.resolve();
          })
          .catch(function(err) {
            param.isLocked = false;
            if (!isPartOfMultiple) {
              var message = $translate.instant(
                "products.notifications.sendError"
              );
              Notification.error(message);
            }
            deferred.reject();
          });
      }
      return deferred.promise;
    }

    function deleteParam(param) {
      if (param.isLocked) {
        return;
      }
      param.isLocked = true;
      customParameterRest
        .remove(param)
        .then(function() {
          param.isLocked = false;
          afterParamDelete(param);
          var message = $translate.instant("products.notifications.list");
          Notification.success(message);
        })
        .catch(function() {
          param.isLocked = false;
          var message = $translate.instant("products.notifications.sendError");
          Notification.error(message);
        });
    }

    function deleteParamsRow(row, index) {
      if (isContractorHavingAnyParams(row)) {
        if (row.isLocked) {
          return;
        }
        row.isLocked = true;
        customParameterRest
          .removeByProductAndContractor(vm.data.Id, row.ContractorId)
          .then(function() {
            row.isLocked = false;
            deleteParamsRowInMainData(index);
            vm.displayedParameters.splice(index, 1);
            var message = $translate.instant("products.notifications.list");
            Notification.success(message);
          })
          .catch(function() {
            row.isLocked = false;
            var message = $translate.instant("products.notifications.error");
            Notification.error(message);
          });
      } else {
        deleteParamsRowInMainData(index);
        vm.displayedParameters.splice(index, 1);
      }
    }

    function deleteParamsRowInMainData(index) {
      if (vm.displayedParameters !== vm.data.CustomParameters) {
        var idx = vm.data.CustomParameters.indexOf(
          vm.displayedParameters[index]
        );
        vm.data.CustomParameters.splice(idx, 1);
      }
    }

    function isContractorHavingAnyParams(row) {
      var hasAny = false;
      for (var i = 0; i < row.Params.length; i++) {
        if (row.Params[i].TextValue) {
          hasAny = true;
          break;
        }
      }
      return hasAny;
    }

    function afterParamDelete(param) {
      param.Id = 0;
      param.TextValue = undefined;
    }

    function trySetParamInColumn(textValue, columnIndex) {
      sweetAlert
        .swal({
          title: "Uwaga",
          text:
            'Zamierzasz ustawić wartość "' +
            textValue +
            '" u wszystkich wybranych kontrahentów',
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Potwierdzam",
          cancelButtonText: "Zrezygnuj"
        })
        .then(
          function() {
            setParamInColumn(textValue, columnIndex);
          },
          function(dismiss) {
            // dismiss can be 'cancel', 'overlay',
            // 'close', and 'timer'
          }
        );
    }

    function setParamInColumn(textValue, columnIndex) {
      var promiseList = [];
      vm.displayedParameters.forEach(function(row) {
        row.Params[columnIndex].TextValue = textValue;
        promiseList.push(addOrUpdateParam(row.Params[columnIndex], true));
      });

      $q.all(promiseList)
        .then(function() {
          setParamInColumnCleanUp(columnIndex);
          var message = $translate.instant("products.notifications.list");
          Notification.success(message);
        })
        .catch(function() {
          var message = $translate.instant("products.notifications.list");
          Notification.error(message);
        });
    }

    function setParamInColumnCleanUp(columnIndex) {
      vm.displayedParameters.forEach(function(row) {
        row.Params[columnIndex].isModified = false;
      });
    }

    function filterParamsRows() {
      var displayedParameters = vm.data.CustomParameters.filter(function(row) {
        var isVisible = true;

        if (
          vm.contractorFilter &&
          !row.ContractorObject.SearchField.toUpperCase().includes(
            vm.contractorFilter.toUpperCase()
          )
        ) {
          isVisible = false;
          return isVisible;
        }

        for (var i = 0; i < row.Params.length; i++) {
          if (vm.paramsFilters[i].value) {
            if (
              !row.Params[i].TextValue ||
              !row.Params[i].TextValue.toUpperCase().includes(
                vm.paramsFilters[i].value.toUpperCase()
              )
            ) {
              isVisible = false;
              break;
            }
          }
        }
        return isVisible;
      });
      vm.displayedParameters = displayedParameters;
    }

    function resetParamsFilters() {
      vm.paramsFilters.forEach(function(filter) {
        filter.value = undefined;
      });
      vm.contractorFilter = undefined;
      vm.displayedParameters = vm.data.CustomParameters;
    }

    ///////////////// FORMLY
  }
})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('PreferredProductsListController', PreferredProductsListController);

  PreferredProductsListController.$inject = ['$log', '$translate', 'constRest', '$sessionStorage', 'SessionService', 'listRest', '$state', 'Notification'];

  function PreferredProductsListController($log, $translate, constRest, $sessionStorage, SessionService, listRest, $state, Notification) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadData = loadData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.goToPreferredProducts = goToPreferredProducts;
    vm.deleteOne = deleteOne;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      type: undefined
    };
    vm.dictionaryData = {};

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("PreferredProductsListController");
      //constructor body
      vm.setPageSize(10);
      loadDictionaryData("PageSizeDictionary");


      //loadDictionaryData("ProductGroupDictionary");
      //loadDictionaryData("VATDictionary");
      if ($sessionStorage.productsListPagingData != undefined)
        vm.pagingData = $sessionStorage.productsListPagingData;

      loadDataWithPagingData(true);
    }

    ///////////////// business logic

    function getDictionaryElementByType(dictionaryName, localId){
      if(vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function(key){
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.productsListPagingData = vm.pagingData;
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.productsListPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function resetSearchTerms() {
      vm.pagingData.currentPage = 1;
      onFilterChange();
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5
    };
    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadData(
        2,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        true
      );
    }

    function loadData(type, count, page, getCount, getData) {
      vm.isDataReloading = true;
      listRest.all(type, count, page, getCount, getData)
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
        })
        .catch(function (error) {
          $log.debug("Error while lists data: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function goToPreferredProducts(){
      $state.go("home.preferredProductsList.one", {id: 0});
    }

    function deleteOne(id){
      listRest.remove(id).then(function(){
        loadData();
        var message = $translate.instant('products.notifications.removed');
        Notification.success(message);
      }).catch(function(error){
        var message = $translate.instant('products.notifications.loadError');
        Notification.error(message);
      });
    }
    ///////////////// FORMLY

  }
})
();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('PreferredProductsController', PreferredProductsController);

  PreferredProductsController.$inject = ['$translate', '$log', '$stateParams', '$state', 'constRest', '$sessionStorage', 'SessionService', 'listRest', 'ContractorSelectService', 'ProductsSelectService', 'ConstSelectService', 'Notification'];

  function PreferredProductsController($translate, $log, $stateParams, $state, constRest, $sessionStorage, SessionService, listRest, ContractorSelectService, ProductsSelectService, ConstSelectService, Notification) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadData = loadData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.checkPermission = checkPermission;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.remove = remove;
    vm.selectContractor = selectContractor;
    vm.selectGroup = selectGroup;
    vm.selectProduct = selectProduct;
    vm.submit = submit;
    vm.goBack = goBack;
    vm.disableSubmit = disableSubmit;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;


    vm.dictionaryData = {};

    ///////////////// constructor call
    constructor();

    function constructor() {
      $log.debug("PreferredProductsController");
      //constructor body
      loadDictionaryData("ContractorGroupDictionary");

      if ($stateParams.id > 0) {
        loadData($stateParams.id);
      } else {
        vm.data = {};
        vm.data.Name = "";
        vm.data.ListData = [];
        vm.data.ListDataObjects = [];
        vm.data.ContextData1 = [];
        vm.data.ContextData1Objects = [];
        vm.data.ContextData2 = [];
        vm.data.ContextData2Objects = [];
        vm.data.Type = 1;
      }
    }

    ///////////////// business logic

    function getDictionaryElementByType(dictionaryName, localId) {
      if (vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function remove(arr, dataArr, id) {
      var idx = arr.indexOf(id);
      if (idx > -1) {
        arr.splice(idx, 1);
        dataArr.splice(idx, 1);
      }
    }

    function selectContractor(arr, dataArr) {
      function callback(obj) {
        addElemnt(arr, dataArr, obj, "Id", "Name", "Symbol", "Name", "Symbol")
      }

      var callbackCheck = function (obj) {
        return vm.data.ContextData1.find(function (element) {
          return element === obj.Id;
        });
      }

      ContractorSelectService.show("lg", callback, callback, callbackCheck);
    }

    function selectGroup(arr, dataArr) {
      function callback(obj) {
        if (obj == undefined)
          return;
        addElemnt(arr, dataArr, obj, "LocalId", "Value", undefined, "Name");
        vm.group = undefined;
      }

      console.log('selectGroup');

      ConstSelectService.show("lg", callback, callback, 'ContractorGroupDictionary', vm.data.ContextData2, undefined, undefined, 'Value');
    }

    function selectProduct(arr, dataArr) {
      function callback(obj) {
        addElemnt(arr, dataArr, obj, "Id", "Name")
      }

      function callbackCheck(obj) {
        return vm.data.ListData.find(function (element) {
          return element === obj.Id;
        });
      }

      ProductsSelectService.show("lg", callback, callback, callbackCheck);
    }

    function addElemnt(arr, dataArr, obj, idAttrName, attrName1, attrName2, attrName1Name, attrName2Name) {
      if (arr.indexOf(obj[idAttrName]) > -1) {
        return;
      }
      if (attrName1Name == undefined)
        attrName1Name = "Name";
      if (attrName2Name == undefined)
        attrName2Name = "Symbol";

      arr.push(obj[idAttrName]);
      var addedObj = {};
      addedObj["Id"] = obj[idAttrName];
      if (attrName1 != undefined)
        addedObj[attrName1Name] = obj[attrName1];
      if (attrName2 != undefined)
        addedObj[attrName2Name] = obj[attrName2];
      dataArr.push(addedObj);
    }

    ///////////////// watchers

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    ///////////////// resource invoke functions
    function loadData(id) {
      vm.isDataReloading = true;
      listRest.get(id)
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
        })
        .catch(function (error) {
          $log.debug("Error while prefProduct data");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function submit(data) {
      if (vm.data.Name.length <= 0)
        return;

      if ($stateParams.id > 0) {
        listRest.save(data).then(function () {
          var message = $translate.instant('products.notifications.list');
          Notification.success(message);
          $state.go("home.preferredProductsList");
        }).catch(function (){
          var message = $translate.instant('products.notifications.error');
          Notification.error(message);
        });
      }else{
        listRest.post(data).then(function () {
          var message = $translate.instant('products.notifications.list');
          Notification.success(message);
          $state.go("home.preferredProductsList");
        }).catch(function (){
          var message = $translate.instant('products.notifications.error');
          Notification.error(message);
        });
      }
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    //goes back to previous state
    function goBack(){
      $state.go("home.preferredProductsList");
    }

    function disableSubmit(){
      if(vm.data.Name.length <= 0){
        return true;
      }
      //products
      if(vm.data.ListDataObjects.length == 0){
        return true;
      }
      //contractors and groups
      if((vm.data.ContextData1Objects == 0)&&(vm.data.ContextData2Objects.length == 0)){
        return true;
      }
      return false;
    }
    ///////////////// FORMLY

  }
})
();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('PromotionsController', PromotionsController);

  PromotionsController.$inject = ['$log', '$stateParams', '$translate', '$sessionStorage', 'SessionService', 'constRest', 'userRest', 'eventsRest', '$state', 'sweetAlert', 'Notification'];

  function PromotionsController($log, $stateParams, $translate, $sessionStorage, SessionService, constRest, userRest, eventsRest, $state, sweetAlert, Notification) {
    /* jshint validthis: true */
    var vm = this;

    //functions def
    vm.onFilterChange = onFilterChange;
    vm.resetSearchTerms = resetSearchTerms;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.onSelect = onSelect;
    vm.onSelectPageCount = onSelectPageCount;
    vm.setCurrentPage = setCurrentPage;
    vm.pageChanged = pageChanged;
    vm.setPageSize = setPageSize;
    vm.goToElement = goToElement;
    vm.removePromotion = removePromotion;
    vm.setTotalCount = setTotalCount;
    vm.loadData = loadData;
    vm.checkPermission = checkPermission;
    vm.isAcceptRequired = isAcceptRequired;
    vm.getUsersAcceptanceLevel = getUsersAcceptanceLevel;
    vm.checkboxChanged = checkboxChanged;
    //data def
    vm.data = undefined;
    vm.isDataReloading = false;
    vm.userDictName = "UsersDictionary";
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.beginDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: undefined
    };
    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchStr: undefined,
      pagingButtonsMaxSize: 5,
      type: undefined,
      beginDate: undefined,
      endDate: undefined,
      status: undefined,
      customTypeId: undefined,
      selectedUserId: undefined,
      acceptance: false
    };
    vm.dictionaryData = {};

    constructor();

    function constructor() {
      loadUserDictionaryData();
      $log.debug("PromotionsController");
      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("PromotionTypeDictionary");

      vm.setPageSize(10);

      if ($sessionStorage.promotionsPagingData != undefined)
        vm.pagingData = $sessionStorage.promotionsPagingData;

      loadDataWithPagingData(true);
    }

    function loadUserDictionaryData() {
      /*isActive, searchStr, count, page, getCount, JobTitleId, storage, getEmployees, getAllIfPossible, userId*/
      userRest.all(undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, true, SessionService.getAuthenticatedUser().Id)
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          console.log(vm.dictionaryData);
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    //TODO zapytac ocb z tym
    function goToElement(key) {
      $state.go("home.promotions.promotion", { id: key.Id });
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.promotionsPagingData = vm.pagingData;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    //opens datepicker
    function openDP($event, statusObj) {
      if (statusObj == 1)
        vm.datePickerBeginOpened = true;
      else
        vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      if(isMin){
        datepickerOptions.minDate = new Date(pagingDataField);
      }else{
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      vm.onFilterChange();
    }

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.promotionsPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function loadDataWithPagingData(getCount) {
      vm.loadData(
        2,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.status,
        vm.pagingData.customTypeId,
        vm.pagingData.searchStr,
        vm.pagingData.selectedUserId
      );
    }

    function loadData(type, count, page, getCount, beginDate, endDate, status, customTypeId, searchStr, selectedUserId) {
      vm.isDataReloading = true;
      eventsRest.list(searchStr, beginDate, endDate, 2, page, count, getCount, undefined, undefined, getUsersAcceptanceLevel(), customTypeId)
        .then(function (result) {
          console.log(result);
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
          console.log(vm.pagingData);
        })
        .catch(function (error) {
          $log.debug("Error while promotions data: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function resetSearchTerms() {
      vm.pagingData.currentPage = 1;
      vm.pagingData.beginDate = undefined;
      vm.pagingData.endDate = undefined;
      vm.pagingData.status = undefined;
      vm.pagingData.customTypeId = undefined;
      vm.pagingData.searchStr = undefined;
      vm.pagingData.selectedUserId = undefined;
      vm.pagingData.acceptance = false;
      
      vm.beginDateOptions.maxDate = undefined;
      vm.endDateOptions.minDate = undefined;

      onFilterChange();
    }


    function removePromotion(promotion) {

      sweetAlert.swal({
        title: "Uwaga",
        text: "Zamierzasz  usunąć promocję: " + promotion.Name,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Potwierdzam",
        cancelButtonText: "Zrezygnuj",
        closeOnConfirm: true,
        closeOnCancel: true

      }).then(function () {
        eventsRest.remove(promotion)
          .then(function (data) {
            Notification.success("Promocja została usunięta");
            onFilterChange();
          })
          .catch(function (err) {
            Notification.error("Błąd podczas próby usunięcia promocji");
          });
      }, function (dismiss) {
        // dismiss can be 'cancel', 'overlay',
        // 'close', and 'timer'
      });
    }

    function isAcceptRequired(promotion) {
      if ((promotion.AcceptanceLevel == 2) && (checkPermission(15))) {
        return true;
      } else if ((promotion.AcceptanceLevel == 1) && (checkPermission(16))) {
        return true;
      }
      return false;
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function checkboxChanged() {
      console.log(vm.pagingData.acceptance);
    }

    function getUsersAcceptanceLevel() {
      var acceptance = undefined;
      if ((checkPermission(16)) && (vm.pagingData.acceptance)) {
        acceptance = 1;
      } else if ((checkPermission(15)) && (vm.pagingData.acceptance)) {
        acceptance = 2;
      }
      return acceptance;
    }

  }
})
  ();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('PromotionController', PromotionController);

  PromotionController.$inject = ['$q', '$log', '$stateParams', '$translate','SessionService', 'constRest', 'userRest', 'ContractorSelectService','ConstSelectService', 'ProductsSelectService', 'eventsRest', '$state', 'UploadService', 'uploadRest', 'Lightbox', 'Notification'];

  function PromotionController($q, $log, $stateParams, $translate, SessionService, constRest, userRest, ContractorSelectService, ConstSelectService, ProductsSelectService, eventsRest, $state, UploadService, uploadRest, Lightbox, Notification) {
    /* jshint validthis: true */
    var vm = this;
    //datePicker
    vm.openDP = openDP;
    vm.remove = remove;
    vm.submit = submit;
    vm.loadData = loadData;
    vm.selectContractor = selectContractor;
    vm.selectContractorGroup = selectContractorGroup;
    vm.selectProduct = selectProduct;
    vm.selectProductGroup = selectProductGroup;
    vm.updatePrice = updatePrice;
    vm.loadDictionaryData = loadDictionaryData;
    vm.isPromotionValid = isPromotionValid;
    vm.checkEntities = checkEntities;
    vm.checkProducts = checkProducts;
    vm.productTypeChange = productTypeChange;
    vm.uploadAttachment = uploadAttachment;
    vm.removeAttachment = removeAttachment;
    vm.openLightboxModal = openLightboxModal;
    vm.pushImagesToGallery = pushImagesToGallery;
    vm.addToGallery = addToGallery;
    vm.cleanGallery = cleanGallery;
    vm.goBack = goBack;
    vm.checkPermission = checkPermission;
    vm.isAcceptRequired = isAcceptRequired;
    vm.acceptPromotion = acceptPromotion;

    vm.blockSubmit = false;
    vm.minDeliveryDate = undefined;
    //validation before submitting
    vm.hasProduct = false;
    vm.hasContractor = false;
    vm.hasProductsValid = true;
    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: undefined,
      maxDate: undefined
    };
    /**sepearate array for holding image references from vm.currentPromotion.Files
    needed for bootstrap lightbox gallery display, because files contain pdfs too**/
    vm.imageGallery = [];

    vm.currentPromotion = {
       "Id": undefined,
       "Name": undefined,
       "Type": 2,
       "SubType": undefined,
       "BeginDate": undefined,
       "EndDate": undefined,
       "DeliveryDate": undefined,
       "MarketingDocumentPaid": false,
       "DocumentNumber": undefined,
       "DocumentDate": undefined,
       "Entities": [],
       "Files": [],
       "FilesIds": []
     };
     //user picker
     vm.dictionaryData = {};

     constructor();

     //init
     function constructor(){
       loadUserDictionaryData();
       loadDictionaryData("PriceLevel");
       loadDictionaryData("PromotionTypeDictionary");
       loadDictionaryData("EventMeasureUnitDoctionary");
       if ($stateParams.id > 0) {
         loadData($stateParams.id);
       }
     }

     //datepicker method
     function openDP($event, statusObj) {
       if (statusObj == 1){
         vm.dateOptions.minDate = new Date(vm.currentPromotion.DeliveryDate).add(0).days();
         vm.dateOptions.maxDate = new Date (vm.currentPromotion.EndDate);
         vm.datePickerBeginOpened = true;
       }
       else if(statusObj === 2){
         vm.dateOptions.minDate = new Date(vm.currentPromotion.BeginDate);
         vm.dateOptions.maxDate = undefined;
         vm.datePickerEndOpened = true;
       }
       else if(statusObj === 3){
         vm.dateOptions.minDate = undefined;
         vm.dateOptions.maxDate = new Date(vm.currentPromotion.BeginDate).add(0).days();
         vm.datePickerDeliveryOpened = true;
       }
       else if(statusObj === 4){
         vm.dateOptions.minDate = undefined;
         vm.dateOptions.maxDate = undefined;
         vm.datePickerDocumentOpened = true;
        }
     };

     function loadData(id) {
       vm.isDataReloading = true;
       cleanGallery();
       eventsRest.get(id)
         .then(function (result) {
           vm.currentPromotion = angular.copy(result);
           vm.currentPromotion.BeginDate = Date.parse(vm.currentPromotion.BeginDate);
           vm.currentPromotion.EndDate = Date.parse(vm.currentPromotion.EndDate);
           vm.currentPromotion.DeliveryDate = Date.parse(vm.currentPromotion.DeliveryDate);
           vm.currentPromotion.DocumentDate = Date.parse(vm.currentPromotion.DocumentDate);
           vm.isDataReloading = false;
           console.log('Current Product :');
           console.log(vm.currentPromotion);

           pushImagesToGallery(vm.currentPromotion.Files);
           checkEntities();
           vm.hasProductsValid = true;
           vm.currentPromotion.FilesIds = [];

         })
         .catch(function (error) {
           $log.debug("Error while getting promotion data");
           vm.isDataReloading = false;
           vm.error = error;
         });
     }

     function loadUserDictionaryData() {
       /*isActive, searchStr, count, page, getCount, JobTitleId, storage, getEmployees, getAllIfPossible, userId*/
       userRest.all(undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, true, SessionService.getAuthenticatedUser().Id)
         .then(function (data) {
           vm.dictionaryData[vm.userDictName] = data;
           vm.dictionaryData[vm.userDictName].sort(function (a, b) {
             if (a.SurName == undefined)
               return -1;
             if (b.SurName == undefined)
               return 1;
             if (a.SurName < b.SurName)
               return -1;
             else if (a.SurName > b.SurName)
               return 1;
             else
               return 0;
           });
         })
         .catch(function (error) {
           $log.debug("Error while getting dictionary: " + vm.userDictName);
           vm.error = error;
         });
     }

     function loadDictionaryData(name) {
       constRest.getDictionary(name)
         .then(function (data) {
           vm.dictionaryData[name] = data;
           if(name === "TaskProductTypeDictionary"){
             vm.taskTypes = _.filter(data, function(val){ return val.LocalId <= 5; });
           }
           if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
             vm.dictionaryData[name].sort(function (a, b) {
               if (a.Value == undefined)
                 return -1;
               if (b.Value == undefined)
                 return 1;
               if (a.Value < b.Value)
                 return -1;
               else if (a.Value > b.Value)
                 return 1;
               else
                 return 0;
             });
           }
         })
         .catch(function (error) {
           $log.debug("Error while getting dictionary: " + name);
           vm.error = error;
         });
     }

     //submit option 1 - submit via submit button, 2 - submit via attachment upload
     function submit(option) {
       /** previous submit while creating new promotion with attachment
          this part became not necessary after upload api change

       if(option === 2){
        var deferred = $q.defer();

        eventsRest.post(vm.currentPromotion).then(function (res) {
          deferred.resolve(res.Id);
        }).catch(function (error) {
          deferred.reject();
          $log.debug("Error while posting event");
        });

        return deferred.promise;
      }**/

      //submit button click
      //date format change for comparing
      formatChange(vm.currentPromotion);

      if(vm.currentPromotion.BeginDate.getUTCDate() !== vm.currentPromotion.BeginDate.getDate())
        deleteDateOffset(vm.currentPromotion);

       vm.blockSubmit = true;
       if ($stateParams.id > 0) {
         eventsRest.save(vm.currentPromotion).then(function () {
           var message = $translate.instant('promo.notifications.updated');
           Notification.success(message);
           $state.go("home.promotions");
         }).catch(function (error) {
           var message = $translate.instant('promo.notifications.error');
           Notification.error(message);
           $log.debug("Error while saving event");
         });
       }
       else{
         eventsRest.post(vm.currentPromotion).then(function (res) {
           var message = $translate.instant('promo.notifications.added');
           Notification.success(message);
           $state.go("home.promotions");
         }).catch(function (error) {
           var message = $translate.instant('promo.notifications.error');
           Notification.error(message);
           $log.debug("Error while posting event");
         });
       }
     }

     //promotion format change
     function formatChange(promotion){
       var begin = new Date(promotion.BeginDate);
       begin.setHours(0,0,0,0);
       promotion.BeginDate = begin;

       var end = new Date(promotion.EndDate);
       end.setHours(0,0,0,0);
       promotion.EndDate = end;

       var delivery = new Date(promotion.DeliveryDate);
       delivery.setHours(0,0,0,0);
       promotion.DeliveryDate = delivery;

       if ((promotion.DocumentDate != null)&&(promotion.DocumentDate !== undefined)){
         var documentDate = new Date(promotion.DocumentDate);
         documentDate.setHours(0,0,0,0);
         promotion.DocumentDate = documentDate;
       }
     }

     //deletes timezone offset from dates
     function deleteDateOffset(promotion){
       var timezoneOffset = promotion.BeginDate.getTimezoneOffset(),
           time = promotion.BeginDate.getTime();
           promotion.BeginDate = new Date(time - timezoneOffset * 60 * 1000);

         time = promotion.EndDate.getTime();
         promotion.EndDate = new Date(time - timezoneOffset * 60 * 1000);

         time = promotion.DeliveryDate.getTime();
         promotion.DeliveryDate = new Date(time - timezoneOffset * 60 * 1000);

         if ((promotion.DocumentDate !== null)&&(promotion.DocumentDate !== undefined)){
           time = promotion.DocumentDate.getTime();
           promotion.DocumentDate = new Date(time - timezoneOffset * 60 * 1000);
         }
     }

     //checks if theres at least one product and Contractor
     //used in case of removal in entities array
     function checkEntities(){
       vm.hasProduct = false;
       vm.hasContractor = false;

       for(var i = 0; i < vm.currentPromotion.Entities.length; i++){
         if((vm.currentPromotion.Entities[i].Type === 4)||(vm.currentPromotion.Entities[i].Type === 5)){
           vm.hasProduct = true;
         }
         if((vm.currentPromotion.Entities[i].Type === 1)||(vm.currentPromotion.Entities[i].Type === 3)){
           vm.hasContractor = true;
         }
       }
       console.log('Has Product - ' + vm.hasProduct);
       console.log('Has Contractor - '+ vm.hasContractor);
     }

     function checkProducts(){
       vm.hasProductsValid = true;
       for (var i = 0; i < vm.currentPromotion.Entities.length; i++){
         //a product...
         if((vm.currentPromotion.Entities[i].Type === 4)||(vm.currentPromotion.Entities[i].Type === 5)){
           //..that has 0 or nothing as price...
           if((vm.currentPromotion.Entities[i].ValueDecimal === undefined)||
           (vm.currentPromotion.Entities[i].ValueDecimal == 0)){
              //... isn't valid :).
              vm.hasProductsValid = false;
              break;
            }
            //percentage must be between 0 and 100
            if(vm.currentPromotion.Entities[i].Type === 5)
              if ((0 > vm.currentPromotion.Entities[i].ValueDecimal)||(vm.currentPromotion.Entities[i].ValueDecimal > 100)){
                vm.hasProductsValid = false;
                break;
            }
         }
       }
     }

     function isPromotionValid(){
       if (vm.currentPromotion === undefined){
         return false;
       }
       if(vm.currentPromotion.Entities.length < 1){
         return false;
       }
       if(!vm.hasProduct){
         return false;
       }
       if(!vm.hasContractor){
         return false;
       }
       if(!vm.hasProductsValid){
         return false;
       }
       if (!vm.form.$valid) {
         return false;
       }
       return true;
     }
     //remove from contractors list
     function remove(dataArr, id) {
       for(var i = 0; i < dataArr.length; i++)
         if(dataArr[i].ContextId === id){
           var idx = i;
           console.log("a hit!");
           break;
         }
       if (idx > -1) {
         dataArr.splice(idx, 1);
       }
       if((vm.hasProduct)||(vm.hasContractor))
        checkEntities();
     }

     //adding new contractors button
     function selectContractor(type, dataArr) {
       var callback = function (obj) {
         addElemnt(type, dataArr, obj, "Id", "Name", "Symbol", "Name", "Symbol");
       }

       var callbackCheck = function (obj) {
         return vm.currentPromotion.Entities.find(function (element) {
           return element.ContextId === obj.Id;
         });
       }

       ContractorSelectService.show("lg", callback, callback, callbackCheck, undefined, false);
     }

     //adds element (obj) to entities list (dataArr) with specified entity type (type)
     function addElemnt(type, dataArr, obj, idAttrName, attrName1, attrName2, attrName1Name, attrName2Name) {

       if (attrName1Name == undefined)
         attrName1Name = "Name";
       if (attrName2Name == undefined)
         attrName2Name = "Symbol";

       var addedObj = {};
       addedObj.ContextObject = {};
       addedObj.ContextObject["Id"] = obj[idAttrName];
       if (attrName1 != undefined)
         addedObj.ContextObject[attrName1Name] = obj[attrName1];
       if (attrName2 != undefined)
         addedObj.ContextObject[attrName2Name] = obj[attrName2];

         //if contractors group is being selected
         if (type === 3){
           addedObj.ContextObject["Value"] = obj[attrName1];
         }
        //if product is being selected
        if (type === 4){
          for (var i = 1; i <= 10; i++) {
            addedObj.ContextObject['AmountGross' + i] = obj['AmountGross' + i];
          }
          addedObj.MeasureUnit = 1;
          vm.hasProductsValid = false;
        }

        if(type === 5){
          addedObj.MeasureUnit = 2;
          vm.hasProductsValid = false;
          addedObj.ContextObject["LocalId"] = obj[idAttrName];
        }

       addedObj.ContextId = addedObj.ContextObject.Id;
       addedObj.Type = type;
       dataArr.push(addedObj);

       //for validation (must have at least one contractor and product)
       if((type === 1)||(type === 3)){
          vm.hasContractor = true;
        } else if ((type === 4)||(type === 5)){
          vm.hasProduct = true;
        }

     }

     //adding new contractors group button
     function selectContractorGroup(type, dataArr) {
       function callback(obj) {
         if (obj == undefined)
           return;
         addElemnt(type, dataArr, obj, "LocalId", "Value", undefined, "Name");
         //vm.group = undefined;
       }

       var callbackCheck = function (obj) {
         return vm.currentPromotion.Entities.find(function (element) {
           return element.ContextId === obj.LocalId;
         });
       }

       ConstSelectService.show("lg", callback, callback, 'ContractorGroupDictionary', vm.currentPromotion.Entities, callbackCheck, "Wybierz grupy kontrahentów", 'Value');
     }

     //adding new product button
     function selectProduct(type, dataArr) {
       function callback(obj) {
         if (obj == undefined)
            return;
        addElemnt(type, dataArr, obj, "Id", "Name", undefined, undefined)
       }

       function callbackCheck(obj) {
         return vm.currentPromotion.Entities.find(function (element) {
           return element.ContextId === obj.Id && element.Type === 4;
         });
       }

       ProductsSelectService.show("lg", callback, callback, callbackCheck);
     }

     function selectProductGroup(type, dataArr) {
       function callback(obj) {
         if (obj == undefined)
           return;
           addElemnt(type, dataArr, obj, "LocalId", "Value", undefined, "Value")
       }

       function callbackCheck(obj) {
         return vm.currentPromotion.Entities.find(function (element) {
           return element.ContextId === obj.LocalId && element.Type === 5;
         });
       }


       ConstSelectService.show("lg", callback, callback, 'ProductGroupDictionary', undefined, callbackCheck);
     }

     //update price of product
     function updatePrice(product, value){
       if(value != undefined)
        product.ValueDecimal = value;

      checkProducts();
     }

     //on product type change
     function productTypeChange(key){
       key.ValueDecimal = undefined;
     }

     //uploads pdf or image
     function uploadAttachment(){

       //adds uploaded attachment to the displayed ones
       var callback = function(data){
         console.log(data);
         vm.currentPromotion.Files.push(data);
         vm.currentPromotion.FilesIds.push(data.Id);

         if(data.Type === 1)
          addToGallery(data);
       };


       //if a new promotion is being created
       if ($stateParams.id == 0) {
           UploadService.show("sm", callback, undefined, undefined, 1);
       }else{
       UploadService.show("sm", callback, undefined, vm.currentPromotion.Id, 1);
       }
     }

     //removes attachment from server and then display
     function removeAttachment(attachment){
       uploadRest.remove(attachment.Id).then(function(){
         var index = findIndexInFilesArray(attachment);
         if (index > -1){
          removeFromFiles(index);
          pushImagesToGallery(vm.currentPromotion.Files);
         }
       });
     }

     //opens bigger image of image in gallery
     function openLightboxModal(index) {
       Lightbox.openModal(vm.imageGallery, index);
     };

     //gets images from files array
     function pushImagesToGallery(files){
       cleanGallery();
       files.forEach(function(file){
         //if file is image
         if(file.Type === 1){
           addToGallery(file);
         }
       });
     }

     //adds image to display
     function addToGallery(image){
       vm.imageGallery.push(image);
     }

     //removes file from Files array based on its index
     function removeFromFiles(index){
       vm.currentPromotion.Files.splice(index, 1);
     }

     //searches for attchament in vm.currentPromotion.Files and returns its index in this arrray
     function findIndexInFilesArray(attachment){
       for (var i = 0; i < vm.currentPromotion.Files.length; i++){
         if(vm.currentPromotion.Files[i].Id === attachment.Id){
           return i;
         }
       }
     }

     function cleanGallery(){
       vm.imageGallery = [];
     }

     //goes back to objectives state
     function goBack(){
       $state.go("home.promotions");
     }

     function acceptPromotion(){
       if(isAcceptRequired(vm.currentPromotion)){
         var User = SessionService.getAuthenticatedUser();
         eventsRest.accept($stateParams.id, User.Id).then(function(){
           var message = $translate.instant('promo.notifications.accepted');
           Notification.success(message);
           $state.go("home.promotions");
         }).catch(function(){
           var message = $translate.instant('promo.notifications.notAccepted');
           Notification.error(message);
         });
       }
     }

     function isAcceptRequired(promotion){
       if((promotion.AcceptanceLevel == 2)&&(checkPermission(15)&&($stateParams.id > 0))){
         return true;
       }else if((promotion.AcceptanceLevel == 1)&&(checkPermission(16)&&($stateParams.id > 0))){
         return true;
       }
       return false;
     }

     function checkPermission(id){
       return SessionService.checkPermission(id);
     }

   }
})
();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('RoleController', RoleController);

  RoleController.$inject = ['$log', '$state', '$stateParams', '$translate', 'PermissionsService', '$scope'];

  function RoleController($log, $state, $stateParams, $translate, PermissionsService, $scope) {
    var vm = this;


    ////////////// functions def
    vm.goBack = goBack;
    vm.submit = submit;
    vm.getRole = getRole;
    vm.updateRole = updateRole;
    vm.getRolePermissions = getRolePermissions;
    vm.getAllPermissions = getAllPermissions;
    vm.updateRolePermissions = updateRolePermissions;
    vm.isPermissionInRole = isPermissionInRole;
    vm.checkAllPermissions = checkAllPermissions;
    vm.isNewRole = isNewRole;
    vm.addRole = addRole;


    ////////////// data def
    vm.role = {};
    vm.oldRole = {};
    vm.rolePermissions = [];
    vm.oldRolePermissions = [];
    vm.permissionsDefs = [];

    vm.serviceCallCount = 0;
    vm.servicesToCall = 2;


    vm.rolePermissionsLoadaed = false;
    vm.allPermissionsLoaded = false;


    ///////////////// constructor call

    loadData();

    /////////////////business logic

    function saveAndExit() {
      vm.serviceCallCount = 0;
      if (isNewRole()) {
        addRole(function (data) {
          vm.serviceCallCount += 1;
          updateRolePermissions(data.Id, function (data) {
            vm.serviceCallCount += 1;
          }, function (error) {
          });
        }, function (error) {
        });
      }
      else {
        if (hasRoleChanged()) {
          updateRole(function (data) {
            vm.serviceCallCount += 1;
          }, function (error) {
          });
        }
        else
          vm.serviceCallCount += 1;

        if (hasRolePermissionsChanged()) {
          updateRolePermissions(vm.role.Id,
            function (data) {
              vm.serviceCallCount += 1;
            }, function (error) {
            });
        }
        else
          vm.serviceCallCount += 1;
      }
    }

    function loadData() {
      if (!isNewRole()) {
        vm.getRole($stateParams.id);
        vm.getRolePermissions($stateParams.id);
      }
      vm.getAllPermissions();
    };


    function goBack() {
      $state.go('home.roles');
    }

    function submit() {
      saveAndExit();
    }


    ///////////////// watchers

    $scope.$watch("vm.serviceCallCount", function (newValue, oldValue) {
      if (newValue === oldValue)
        return;
      if (newValue >= vm.servicesToCall)
        $state.go('home.roles');
    });

    ///////////////// check state functions

    function hasRoleChanged() {
      return !angular.equals(vm.oldRole, vm.role);
    }

    function hasRolePermissionsChanged() {
      return !angular.equals(vm.oldRolePermissions, vm.permissionsDefs);
    }

    function isPermissionInRole(perm) {
      var is = false;
      angular.forEach(vm.rolePermissions, function (rolePermission) {
        if (rolePermission.RoleDefId == perm.Id) {
          is = true;
          return;
        }
      });

      return is;
    }

    function checkAllPermissions() {
      if (!vm.allPermissionsLoaded || !vm.allPermissionsLoaded)
        return;
      angular.forEach(vm.permissionsDefs, function (permDef) {
        permDef.isInRole = isPermissionInRole(permDef);
      });
    };

    function isNewRole() {
      if ($stateParams.id == "new")
        return true;
      else
        return false;
    }


    ///////////////// resource invoke functions


    function getAllPermissions() {
      vm.loading = true;
      PermissionsService.getAllPermissions(function (data) {
        vm.loading = false;
        vm.permissionsDefs = data;
        vm.allPermissionsLoaded = true;
        checkAllPermissions();
        angular.copy(vm.permissionsDefs, vm.oldRolePermissions);
      }, function (error) {
        vm.loading = false;
      });
    }

    function getRole(id) {
      vm.loading = true;
      PermissionsService.getRoleById(id, function (data) {
        vm.loading = false;
        vm.role = data;
        angular.copy(vm.role, vm.oldRole); // kopia do porównania
      }, function (error) {
        vm.loading = false;
      });
    }

    function updateRole(response, error) {
      if (vm.role !== undefined) {
        $log.log(vm.role);
        PermissionsService.editRole(vm.role,
          function (obj) {
            response(obj);
          },
          function (err) {
            $log.log(err);
            error(err);
          });
      }
    };

    function getRolePermissions(id) {
      PermissionsService.getRolePermissions(id, function (data) {
        vm.rolePermissions = data;
        vm.rolePermissionsLoadaed = true;
        angular.copy(vm.rolePermissions, vm.oldRolePermissions);
        checkAllPermissions();
      }, function (error) {
        $log.log(error);
      });
    };

    function addRole(response, error) {
      PermissionsService.addRole(vm.role.Name, vm.role.Description, response, error);
    };

    function updateRolePermissions(id, fresponse, ferror) {
      var roles = [];
      angular.forEach(vm.permissionsDefs, function (permDef) {
        if (permDef.isInRole)
          roles.push({'GroupDefId': id, 'RoleDefId': permDef.Id});

      });
      PermissionsService.editRolePermissions(id, roles, function (data) {
        fresponse(data);
      }, function (error) {
        ferror(error)
      });
    };

    // FORMLY
    vm.roleFields = [{
      key: 'Name',
      type: 'input',
      templateOptions: {
        type: 'text',
        label: $translate.instant('roles.role.name'),
        placeholder: $translate.instant('roles.role.name')
      }
    }, {
      key: 'Description',
      type: 'input',
      templateOptions: {
        type: 'text',
        label: $translate.instant('roles.role.description'),
        placeholder: $translate.instant('roles.role.description'),
      }
    }];


    vm.roleRegisterFields = [{
      key: 'email',
      type: 'input',
      templateOptions: {
        type: 'email',
        label: 'Email address',
        placeholder: 'Enter email'
      }
    }, {
      key: 'password',
      type: 'input',
      templateOptions: {
        type: 'password',
        label: 'Password',
        placeholder: 'Password'
      }
    }];
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('PermissionsController', PermissionsController);

  PermissionsController.$inject = ['$scope', '$log', 'PermissionsService', '$state', '$timeout', '$filter'];

  function PermissionsController($scope, $log, PermissionsService, $state, $timeout, $filter) {
    var vm = this;

    vm.permissions = undefined;
    vm.roles = undefined;


    vm.getAllRoles = getAllRoles;
    vm.getPermissionById = getPermissionById;
    vm.updatePermission = updatePermission;
    //vm.updateRolePermissions = updateRolePermissions;
    vm.getAllUserPermissions = getAllUserPermissions;
    vm.newRole = newRole;
    vm.deleteRole = deleteRole;
    vm.closeAlert = closeAlert;

    vm.loading = false;
    vm.isError = false;
    vm.error = "";

    vm.getAllRoles();


    function fError(err, type) {
      $log.log(type, err);
      vm.isError = true;
      if (type === 'validate')
        vm.error = $filter('translate')('common.validators.' + err);
      else
        vm.error = $filter('translate')('common.services.roles.' + err);
    };

    function deleteRole(role)
    {
      vm.loading = true;
      PermissionsService.deleteRole(role.Id,function (data) {
        vm.loading = false;
        vm.getAllRoles();
      }, function (error) {
        fError(error);
        vm.loading = false;
      });
    };


    function getAllRoles() {
      vm.loading = true;
      PermissionsService.getAllRoles(function (data) {
        vm.roleDefs = data;
        $timeout(function(){vm.loading = false;}, 150);
      }, function (error) {
        vm.loading = false;
      });
    }

    function getPermissionById(id) {
      vm.loading = true;
      PermissionsService.getPermissionById(id, function (data) {
        vm.loading = false;
        vm.permission = data;
      }, function (error) {
        vm.loading = false;
      });
    };

    function updatePermission() {
      if (vm.permission != undefined) {
        vm.permission.Description = 'testZapittttttsu';
        PermissionsService.editPermission(vm.permission);
      }
    };

    function getAllUserPermissions(id) {
      PermissionsService.getAgregatedUserPermissions(id, function (data) {
        vm.loading = false;
        vm.allUserPermissions = data;
      }, function (error) {
        vm.loading = false;
      });
    }

    function newRole()
    {
      $state.go('home.roles.role',{'id': 'new'} );
    };

    function closeAlert()
    {
      vm.isError = false;
      vm.error = "";
    };
  };
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ParametrizationController', ParametrizationController);

  ParametrizationController.$inject = ['$log', '$q', '$stateParams', '$translate','SessionService', 'eventsRest', 'Notification', 'constRest', 'sweetAlert'];

  function ParametrizationController($log, $q, $stateParams, $translate, SessionService, eventsRest, Notification, constRest, sweetAlert) {
    /* jshint validthis: true */
    var vm = this;
    //function
    vm.addNewParam = addNewParam;
    vm.addToDictionary = addToDictionary;
    vm.remove = remove;
    vm.removeRow = removeRow;
    vm.loadHolidays = loadHolidays;
    vm.onYearChange = onYearChange;
    vm.saveNewHoliday = saveNewHoliday;
    vm.saveMinOrderPrice = saveMinOrderPrice;
    vm.saveVisitCloseTime = saveVisitCloseTime;
    vm.sendConst = sendConst;
    vm.openDP = openDP;
    vm.updateCompanyData = updateCompanyData;
    //data
    vm.dictionaryData = {};
    vm.holidays = [];
    vm.holidayYears = [];
    vm.chosenYear = undefined;
    vm.newHolidayDate = undefined;
    vm.datePickerHolidayOpened = false;

    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    vm.myTime= new Date();
    vm.timeOptions = {
      hstep: 1,
      mstep: 1
    }
    vm.parameters={
      "MinimumOrderPrice": undefined,
      "MinimumReturnPrice": undefined,
      "RegionalManagerMin": undefined,
      "RegionalManagerMax": undefined,
      "DirectorMin": undefined,
      "DirectorMax": undefined,
      "ExpirationDays": undefined,
      "VisitCloseTime": undefined,
      "CustomParametersProduct": [],
      "CustomParametersContractor": [],
      "Manufacturers": []
    };

    loadData();

    function loadData(){
      vm.holidayYears = generateYears();
      vm.chosenYear = vm.holidayYears[0];
      loadHolidays();
      loadMinOrderPrice();
      loadVisitCloseTime();
      loadDictionaryData("CustomParamsDictionary");
      loadDictionaryData("CustomParams2Dictionary");
      loadDictionaryData("CompanyDataDictionary");
      loadDictionaryData("ManufacturerDictionary");
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
          if(name == "CustomParamsDictionary"){
            vm.parameters.CustomParametersProduct = vm.dictionaryData[name];
          }else if (name == "CustomParams2Dictionary"){
            vm.parameters.CustomParametersContractor = vm.dictionaryData[name];
          }else if (name == "CompanyDataDictionary"){
            sortCompanyDataDictionary();
          }else if (name == "ManufacturerDictionary"){
            vm.parameters.Manufacturers = vm.dictionaryData[name];
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function sortCompanyDataDictionary(){
      var sortedCompanyData = [];
      vm.dictionaryData["CompanyDataDictionary"].forEach(function(element){
        if(element.Value == "Name"){
          sortedCompanyData[0] = element;
          return;
        }
        if(element.Value == "StreetAndNumber"){
          sortedCompanyData[1] = element;
          return;
        }
        if(element.Value == "CityName"){
          sortedCompanyData[2] = element;
          return;
        }
        if(element.Value == "PostalCode"){
          sortedCompanyData[3] = element;
          return;
        }
        if(element.Value == "Country"){
          sortedCompanyData[4] = element;
          return;
        }
        if(element.Value == "ILN"){
          sortedCompanyData[5] = element;
          return;
        }
        if(element.Value == "TaxID"){
          sortedCompanyData[6] = element;
          return;
        }
        if(element.Value == "NRB"){
          sortedCompanyData[7] = element;
          return;
        }
      });
      vm.dictionaryData["CompanyDataDictionary"] = sortedCompanyData;
    }

    function loadHolidays(){
      eventsRest.holidays(undefined, vm.chosenYear).then(function(holidays){
        vm.holidays = holidays;
      });
    }


    function loadMinOrderPrice(){
      constRest.getDictionary('MinimumOrderPrice').then(function(MinOrderPriceDictionary){
        if(MinOrderPriceDictionary[0] !== undefined){
          vm.parameters.MinimumOrderPrice = MinOrderPriceDictionary[0];
        }
      });
    }

    function loadVisitCloseTime(){
      constRest.getDictionary('VisitCloseTime').then(function(VisitCloseTimeDictionary){
        if(VisitCloseTimeDictionary[0] !== undefined){
          formatTimeToDateInDictionaryObject(VisitCloseTimeDictionary[0]);
          vm.parameters.VisitCloseTime = VisitCloseTimeDictionary[0];
        }
      });
    }

    function formatTimeToDateInDictionaryObject(VisitCloseTimeDictionary){
      var timeParts = VisitCloseTimeDictionary.Value.split(":");
      var time = {
        hour: parseInt(timeParts[0]),
        minute: parseInt(timeParts[1])
      }
      VisitCloseTimeDictionary.Value = Date.today().at(time);
    }

    function formatDateToTimeInDictionaryObject(VisitCloseTimeDictionary){
      VisitCloseTimeDictionary.Value = VisitCloseTimeDictionary.Value.toString('HH:mm');
    }

    function remove(holiday){
      var index = vm.holidays.indexOf(holiday);
      eventsRest.removeHoliday(holiday).then(function(){
        if (index > -1) {
          vm.holidays.splice(index, 1);
        }
        var message = $translate.instant('parametrization.notifications.removeHoliday');
        Notification.success(message);
      }).catch(function(){
        var message = $translate.instant('parametrization.notifications.removeHolidayErr');
        Notification.error(message);
      });
    }

    function generateYears(){
      var years = [];
      var date = new Date();
      var year = date.getFullYear();
      years.push(year);
      year += 1;
      years.push(year);
      year += 1;
      years.push(year);
      return years;
    }

    function onYearChange(){
      loadHolidays();
    }

    function saveNewHoliday(){
      if((vm.newHolidayDate === undefined)||(vm.newHolidayDate == null)||(vm.newHolidayDate == "")){
        var message = $translate.instant('parametrization.notifications.holidayBadDate');
        Notification.error(message);
        return;
      }
      var holiday = {
        'Name': undefined,
        'Id': undefined,
        'Free': true,
        'Date': vm.newHolidayDate
      }
      eventsRest.postHoliday(holiday).then(function(){
        vm.newHolidayDate = undefined;
        loadHolidays();
        var message = $translate.instant('parametrization.notifications.addHoliday');
        Notification.success(message);
      }).catch(function(){
        var message = $translate.instant('parametrization.notifications.addHolidayErr');
        Notification.error(message);
      });
    }

    function saveMinOrderPrice(){
      constRest.putObject(vm.parameters.MinimumOrderPrice, vm.parameters.MinimumOrderPrice.Id).then(function(){
        var message = $translate.instant('parametrization.notifications.successChange');
        Notification.success(message);
      }).catch(function(error){
        var message = $translate.instant('parametrization.notifications.errorChange');
        Notification.error(message);
      });
    }

    function saveVisitCloseTime(){
      var dictionaryObject = angular.copy(vm.parameters.VisitCloseTime);
      formatDateToTimeInDictionaryObject(dictionaryObject);
      constRest.putObject(dictionaryObject, dictionaryObject.Id).then(function(){
        var message = $translate.instant('parametrization.notifications.successChange');
        Notification.success(message);
      }).catch(function(error){
        var message = $translate.instant('parametrization.notifications.errorChange');
        Notification.error(message);
      });
    }

    function openDP($event, statusObj) {
      if (statusObj == 1)
        vm.datePickerHolidayOpened = true;
    };

    function addNewParam(type){
      if(type == 1){
        addToDictionary(vm.parameters.CustomParametersProduct, "CustomParamsDictionary");
      }else{
        addToDictionary(vm.parameters.CustomParametersContractor, "CustomParams2Dictionary");
      }
    }

    function addToDictionary(dictionaryRef, dictionaryName){
      dictionaryRef.push({
        "Id": 0,
        "LocalId": 0,
        "Name": dictionaryName,
        "Value": "Nowa wartość"
      })
    }

    function sendConst(key){
      if(key.Id){
        constRest.putObject(key, key.Id).then(function(){
          var message = $translate.instant('parametrization.notifications.successChange');
          Notification.success(message);
        }).catch(function(error){
          var message = $translate.instant('parametrization.notifications.errorChange');
          Notification.error(message);
        });
      }else{
        constRest.postObject(key.Name, key).then(function(response){
          key.Id = response.Id;
          key.LocalId = response.LocalId;
          var message = $translate.instant('parametrization.notifications.newValueSuccess');
          Notification.success(message);
        }).catch(function(error){
          var message = $translate.instant('parametrization.notifications.newValueError');
          Notification.error(message);
        });
      }
    }

    function removeRow(key, index, dictionaryRef){
      if (key.Id) {
        sweetAlert.swal({
            title: "Uwaga",
            text: "Zamierzasz usunąć parametr",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Potwierdzam",
            cancelButtonText: "Zrezygnuj"
          }).then(function() {
              removeConst(key, index, dictionaryRef);
          }, function(dismiss) {
            // dismiss can be 'cancel', 'overlay',
            // 'close', and 'timer'
          });
      } else {
        dictionaryRef.splice(index, 1);
      }
    }

    function removeRowNoAlert(key, index, dictonaryRef){
      if (key.Id) {
        removeConst(key, index, dictionaryRef);
      } else {
        dictionaryRef.splice(index, 1);
      }
    }

    function removeConst(key, index, dictionaryRef){
      constRest.remove(key).then(function(){
        dictionaryRef.splice(index, 1);
        var message = $translate.instant('parametrization.notifications.removeParam');
        Notification.success(message);
      }).catch(function(){
        var message = $translate.instant('parametrization.notifications.removeParamErr');
        Notification.error(message);
      });
    }

    function updateCompanyData(){
      if(!vm.dictionaryData["CompanyDataDictionary"]){
        return;
      }
      var promiseList = [];
      vm.dictionaryData["CompanyDataDictionary"].forEach(function(param){
        promiseList.push(constRest.putObject(param, param.Id));
      });
      $q.all(promiseList).then(function(){
        var message = $translate.instant('parametrization.notifications.companyDataSuccess');
        Notification.success(message);
      }).catch(function(){
        var message = $translate.instant('parametrization.notifications.companyDataError');
        Notification.success(message);
      });
    }

  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("OrderController", OrderController);

  OrderController.$inject = [
    "$scope",
    "$log",
    "$state",
    "$stateParams",
    "$translate",
    "contractorRest",
    "ProductPickerService",
    "UsersSelectService",
    "SessionService",
    "visitRest",
    "Notification",
    "orderHistoryModalService",
    "$sessionStorage",
    "logRest",
    "UploadService",
    "Lightbox",
  ];

  function OrderController(
    $scope,
    $log,
    $state,
    $stateParams,
    $translate,
    contractorRest,
    ProductPickerService,
    UsersSelectService,
    SessionService,
    visitRest,
    Notification,
    orderHistoryModalService,
    $sessionStorage,
    logRest,
    UploadService,
    Lightbox
  ) {
    /* jshint validthis: true */
    var vm = this;

    $scope.$watch("vm.order.Products", function (newValue, oldValue) {
      if (newValue === undefined) {
        return;
      } else {
        var i = 0;
        _.forEach(vm.order.Products, function (p) {
          $scope.$watch("vm.order.Products[" + i + "].Count", function (
            newValue,
            oldValue
          ) {
            vm.updatePrice(p, vm.order, vm.order.Products);
          });
          $scope.$watch("vm.order.Products[" + i + "].MyPriceNet", function (
            newValue,
            oldValue
          ) {
            if (p.DiscountPercent === undefined && p.DiscountPercent != 0) {
              return;
            }
            vm.onPriceChange(p, false, vm.order, vm.order.Products);
          });
          $scope.$watch(
            "vm.order.Products[" + i + "].DiscountPercent",
            function (newValue, oldValue) {
              if (!p.MyPriceNet) {
                return;
              }
              vm.onPriceChange(p, true, vm.order, vm.order.Products);
            }
          );
          i++;
        });
      }
    });

    $scope.$watch("vm.timeReturn.Products", function (newValue, oldValue) {
      if (newValue === undefined) {
        return;
      } else {
        var i = 0;
        _.forEach(vm.timeReturn.Products, function (p) {
          $scope.$watch("vm.timeReturn.Products[" + i + "].Count", function (
            newValue,
            oldValue
          ) {
            vm.updatePrice(p, vm.timeReturn, vm.timeReturn.Products);
          });
          i++;
        });
      }
    });

    $scope.$watch("vm.qualityReturn.Products", function (newValue, oldValue) {
      if (newValue === undefined) {
        return;
      } else {
        var i = 0;
        _.forEach(vm.qualityReturn.Products, function (p) {
          $scope.$watch("vm.qualityReturn.Products[" + i + "].Count", function (
            newValue,
            oldValue
          ) {
            vm.updatePrice(p, vm.qualityReturn, vm.qualityReturn.Products);
          });
          i++;
        });
      }
    });

    $scope.$watch("vm.samples.Products", function (newValue, oldValue) {
      if (newValue === undefined) {
        return;
      } else {
        var i = 0;
        _.forEach(vm.samples.Products, function (p) {
          $scope.$watch("vm.samples.Products[" + i + "].Count", function (
            newValue,
            oldValue
          ) {
            vm.updatePrice(p, vm.samples, vm.samples.Products);
          });
          i++;
        });
      }
    });

    $scope.$watch("vm.gratis.Products", function (newValue, oldValue) {
      if (newValue === undefined) {
        return;
      } else {
        var i = 0;
        _.forEach(vm.gratis.Products, function (p) {
          $scope.$watch("vm.gratis.Products[" + i + "].Count", function (
            newValue,
            oldValue
          ) {
            vm.updatePrice(p, vm.gratis, vm.gratis.Products);
          });
          i++;
        });
      }
    });
    var today = Date.today();
    var date = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    $scope.current_date = today.getTime();

    vm.selectUser = selectUser;
    vm.showProductPicker = showProductPicker;
    vm.onPriceChange = onPriceChange;
    vm.updatePrice = updatePrice;
    vm.openDP = openDP;
    vm.openDPForEntity = openDPForEntity;
    vm.save = save;
    vm.isProductsError = isProductsError;
    vm.isCountValid = isCountValid;
    vm.isPriceValid = isPriceValid;
    vm.isMultiplicityValid = isMultiplicityValid;
    vm.areProductsFromDocumentValid = areProductsFromDocumentValid;
    vm.areProductsMultiplicityValid = areProductsMultiplicityValid;
    vm.isEmpty = isEmpty;
    vm.lengthPendingPayments = lengthPendingPayments;
    vm.areAllExpiredPaymentsResolved = areAllExpiredPaymentsResolved;
    vm.contractorHistory = contractorHistory;
    vm.isSelectedDateSameAsRoute = isSelectedDateSameAsRoute;
    vm.setOtherPendingAsThis = setOtherPendingAsThis;
    vm.saveNextVisitNote = saveNextVisitNote;
    vm.getEventId = getEventId;
    vm.isBatchNumberValid = isBatchNumberValid;
    vm.isExpirationDateValid = isExpirationDateValid;
    vm.uploadEntityAttachment = uploadEntityAttachment;
    vm.checkPermission = checkPermission;
    vm.showImagesGallery = showImagesGallery;
    //data
    vm.contractor = undefined;
    vm.loggedUser = undefined;
    vm.user = undefined;
    vm.visitNote = undefined;
    vm.isDataReloading = false;
    var worker = undefined;
    var route = undefined;
    var routeEntity = undefined;
    vm.order = {
      AmountNet: 0,
      AmountGross: 0,
      AmountVAT: 0,
      CurrencySymbol: "PLN",
      Date: Date.today(),
      mId: 0,
      Note: undefined,
      Products: undefined,
      PendingPayments: undefined,
    };
    vm.timeReturn = {
      AmountNet: 0,
      AmountGross: 0,
      AmountVAT: 0,
      CurrencySymbol: "PLN",
      Date: Date.today(),
      mId: 0,
      Note: undefined,
      Products: undefined,
    };
    vm.qualityReturn = {
      AmountNet: 0,
      AmountGross: 0,
      AmountVAT: 0,
      CurrencySymbol: "PLN",
      Date: Date.today(),
      mId: 0,
      Note: undefined,
      Products: undefined,
    };
    vm.samples = {
      AmountNet: 0,
      AmountGross: 0,
      AmountVAT: 0,
      CurrencySymbol: "PLN",
      Date: Date.today(),
      mId: 0,
      Note: undefined,
      Products: undefined,
    };
    vm.gratis = {
      AmountNet: 0,
      AmountGross: 0,
      AmountVAT: 0,
      CurrencySymbol: "PLN",
      Date: Date.today(),
      mId: 0,
      Note: undefined,
      Products: undefined,
    };
    vm.error = undefined;
    vm.orderDatePickerOpened = false;
    vm.orderDateOptions = {
      formatYear: "yy",
      startingDay: 1,
      minDate: Date.today(),
      maxDate: Date.today().addDays(7),
    };
    vm.expirationDateOptions = {
      formatYear: "yy",
      startingDay: 1,
    };
    vm.dictionaryExpiredPayments = [
      { id: 2, name: "Skasuje kierowca" },
      { id: 3, name: "Przelew" },
      { id: 4, name: "Inna forma płatności" },
    ];

    // vm.selections = [];
    vm.saveOnce = false;
    vm.canOpen = false;
    vm.saveNextNote = false;

    constructor();

    function constructor() {
      $log.debug("OrderController");
      // vm.contractor = $stateParams.contractor;
      vm.loggedUser = getLoggedUser();
      vm.user = { selectedUserId: vm.loggedUser.Id, Context: vm.loggedUser };
      route = $stateParams.route;
      routeEntity = $stateParams.routeEntity;
      if (route) {
        logRest.post(
          vm.loggedUser.Id,
          "order.controller | Order constructor with route.Id: " +
            route.Id +
            " ContractorId: " +
            $stateParams.id
        );
        vm.order.Date = route.BeginDate;
        if (dateBefore(vm.order.Date, new Date()) < 0) {
          vm.order.Date = new Date();
          route.BeginDate = vm.order.Date;
        }
        if (route.User) {
          vm.user = { selectedUserId: route.User.Id, Context: route.User };
        }
      } else {
        logRest.post(
          vm.loggedUser.Id,
          "order.controller | No route Id for order, contractorId: " +
            $stateParams.id
        );
      }

      //
      loadProducts($stateParams.id);
    }

    function dateBefore(date1, date2) {
      var d1 = new Date(date1);
      var d2 = new Date(date2);
      if (d1.getFullYear() < d2.getFullYear()) return -1;
      if (d1.getFullYear() > d2.getFullYear()) return 1;
      if (d1.getMonth() < d2.getMonth()) return -1;
      if (d1.getMonth() > d2.getMonth()) return 1;
      if (d1.getDate() < d2.getDate()) return -1;
      if (d1.getDate() > d2.getDate()) return 1;
      return 0;
    }

    function getEventId() {
      if (route) {
        return route.Id == 0 ? route.ParentId : route.Id;
      }
      return undefined;
    }

    function getLoggedUser() {
      return SessionService.getAuthenticatedUser();
    }

    function loadProducts(contractorId) {
      vm.isDataReloading = true;
      contractorRest
        .getOrderData(contractorId)
        .then(function (res) {
          vm.isDataReloading = false;
          vm.contractor = res.contractor;
          vm.order.Products = res.products;
          vm.order.PendingPayments = res.pendingPayments;
          calculateExpiredPayments(vm.order.PendingPayments);
          vm.timeReturn.Products = angular.copy(res.products);
          vm.qualityReturn.Products = angular.copy(res.products);
          vm.samples.Products = angular.copy(res.products);
          vm.gratis.Products = angular.copy(res.products);
        })
        .catch(function (error) {
          vm.error = error;
          vm.isDataReloading = false;
        });
    }

    function isEmpty(pendingPayments) {
      return pendingPayments && Object.keys(pendingPayments).length === 0;
    }

    function lengthPendingPayments(pendingPayments) {
      return pendingPayments && Object.keys(pendingPayments).length;
    }

    function calculateExpiredPayments(pendingPayments) {
      var expiredPayments = 0;
      _.forEach(pendingPayments, function (pp) {
        pp.isExpired = false;
        var today = new Date().setHours(0, 0, 0, 0);
        var pendingPaymentsDate = new Date(pp.PaymentDate);
        var checkDate = pendingPaymentsDate.getTime() - today;
        var diffDays = Math.ceil(checkDate / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
          pp.isExpired = true;
          expiredPayments++;
        } else {
          pp.isExpired = false;
        }
      });
      vm.expiredPayments = expiredPayments;
    }

    function showImagesGallery(docEntity) {
      Lightbox.openModal(docEntity.Files, 0);
    }

    function areAllExpiredPaymentsResolved() {
      var expiredNotSelected = 0;
      _.forEach(vm.order.PendingPayments, function (pp) {
        if (pp.isExpired && !pp.selectedAction) {
          expiredNotSelected++;
        }
      });
      if (expiredNotSelected === 0) {
        return true;
      } else {
        return false;
      }
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.orderDatePickerOpened = true;
    }
    function openDPForEntity($event, statusObj, entity) {
      if (statusObj == 1) entity.expirationDateDatePickerOpened = true;
    }

    function showProductPicker(productsArray, isOrder, options) {
      var callback = function (obj) {
        if (!obj.Count) {
          obj.Count = 0;
        }
        if (isOrder) {
          obj.AmountProductNet = obj.Price.PromotionId
            ? obj.Price.PromotionAmountProductNet
            : obj.Price.AmountProductNet;
          obj.AmountProductGross = obj.Price.PromotionId
            ? obj.Price.PromotionAmountProductGross
            : obj.Price.AmountProductGross;
        } else {
          obj.AmountProductNet = obj.Price.AmountProductNet;
          obj.AmountProductGross = obj.Price.AmountProductGross;
        }
        obj.MyPriceNet = obj.AmountProductNet;
        obj.DiscountPercent = 0;
        obj.isAdded = true;
        obj.Files = [];
        obj.FilesIds = [];
      };

      var callbackCheck = function (obj) {
        return obj.isAdded;
      };

      ProductPickerService.show(
        "lg",
        productsArray,
        callback,
        callback,
        callbackCheck,
        options
      );
    }

    function onPriceChange(product, percentageInput, orderObjRef, productsRef) {
      if (percentageInput) {
        calculateMyPriceNet(product);
        updatePrice(product, orderObjRef, productsRef);
      } else {
        calculatePercentage(product);
        updatePrice(product, orderObjRef, productsRef);
      }
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function updatePrice(product, orderObjRef, productsRef) {
      var myNetto = parseFloat(product.MyPriceNet);
      var myGross = myNetto + myNetto * (product.Price.VatValue / 100);
      product.AmountProductNet = myNetto;
      product.AmountProductGross = myGross;

      setBasketTotalPriceToZero(orderObjRef);
      var basket = getProductsFromBasket(productsRef);
      _.forEach(basket, function (p) {
        calculatePrice(p, orderObjRef);
      });
    }

    function setBasketTotalPriceToZero(orderObjRef) {
      orderObjRef.AmountNet = 0;
      orderObjRef.AmountGross = 0;
      orderObjRef.AmountVAT = 0;
    }

    function calculatePrice(product, orderObjRef) {
      if (product.Count > 0) {
        product.AmountAllProductNet = round(
          product.AmountProductNet * product.Count
        );
        product.AmountAllProductGross = round(
          product.AmountProductGross * product.Count
        );
        addToBasketBill(product, orderObjRef);
      }
    }

    function getProductsFromBasket(productsRef) {
      return _.filter(productsRef, { isAdded: true });
    }

    function addToBasketBill(product, orderObjRef) {
      orderObjRef.AmountNet += product.AmountAllProductNet;
      orderObjRef.AmountGross += product.AmountAllProductGross;
      orderObjRef.AmountVAT += orderObjRef.AmountGross - orderObjRef.AmountNet;
    }

    function round(val) {
      return Math.round(val * 100) / 100;
    }

    function selectUser() {
      var callback = function (obj) {
        vm.user = { selectedUserId: obj.Id, Context: obj };
      };

      var callbackCheck = function (obj) {
        if (vm.user && vm.user.selectedUserId === obj.Id) {
          return obj.Id;
        }
      };
      UsersSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        undefined,
        true,
        undefined,
        true
      );
    }

    function setOtherPendingAsThis(pendingPayment) {
      _.forEach(vm.order.PendingPayments, function (pp) {
        pp.selectedAction = pendingPayment.selectedAction;
      });
    }

    function saveNextVisitNote(contractor) {
      if (vm.saveNextNote) return;
      vm.saveNextNote = true;
      contractorRest
        .saveNextVisitNote(contractor.Id, contractor.NextVisitNote)
        .then(function () {
          Notification.success("Komentarz do następnej wizyty dodany");
        })
        .catch(function () {
          Notification.error("Wystąpił błąd przy dodawaniu komantarza");
        })
        .finally(function () {
          vm.saveNextNote = false;
        });
    }

    function calculateMyPriceNet(product) {
      var myPriceNet = 0.0;
      if (!!!product.DiscountPercent) {
        myPriceNet = product.Price.PromotionId
          ? product.Price.PromotionAmountProductNet
          : product.Price.AmountProductNet;
      } else {
        myPriceNet =
          product.Price.AmountProductNet -
          (product.DiscountPercent / 100) * product.Price.AmountProductNet;
      }
      product.MyPriceNet = Math.round(myPriceNet * 100) / 100;
    }

    function uploadEntityAttachment(documentEntity) {
      var callback = function (data) {
        console.log(data);
        documentEntity.Files.push(data);
        documentEntity.FilesIds.push(data.Id);
      };

      UploadService.show(
        "sm",
        callback,
        undefined,
        documentEntity.Id,
        5,
        "'image/*'"
      );
    }

    function calculatePercentage(product) {
      if (product.MyPriceNet != product.Price.PromotionAmountProductNet) {
        var discountPercent =
          100 - (product.MyPriceNet * 100) / product.Price.AmountProductNet;
        product.DiscountPercent = Math.round(discountPercent * 10) / 10;
      } else {
        product.DiscountPercent = 0;
      }
    }

    function save() {
      if (vm.saveOnce || isProductsError() || vm.contractor === undefined) {
        return;
      }
      vm.saveOnce = true;
      var order = {};
      //jeśli jest defaultowy dokument to on, albo 2(FS)
      order.TypeId =
        vm.contractor.DefaultDocumentType != null
          ? vm.contractor.DefaultDocumentType
          : 2;
      addBasicInformation(order, "Zamówienie od klienta z aplikacji web");
      addEntities(order, vm.order.Products);
      addPricesAndNote(order, vm.order, false);

      var timeReturn = {};
      timeReturn.TypeId = 1001;
      addBasicInformation(timeReturn, "Zwrot w terminie z aplikacji web");
      addEntities(timeReturn, vm.timeReturn.Products);
      addPricesAndNote(timeReturn, vm.timeReturn, true);

      var qualityReturn = {};
      qualityReturn.TypeId = 1004;
      addBasicInformation(qualityReturn, "Zwrot w jakościowy z aplikacji web");
      addEntities(qualityReturn, vm.qualityReturn.Products);
      addPricesAndNote(qualityReturn, vm.qualityReturn, true);

      var samplesDoc = {};
      samplesDoc.TypeId = 1002;
      addBasicInformation(samplesDoc, "Gratisy z aplikacji web");
      addEntities(samplesDoc, vm.samples.Products);
      addPricesAndNote(samplesDoc, vm.samples, false);

      var gratisDoc = {};
      gratisDoc.TypeId = 1003;
      addBasicInformation(gratisDoc, "Degustacje z aplikacji web");
      addEntities(gratisDoc, vm.gratis.Products);
      addPricesAndNote(gratisDoc, vm.gratis, false);

      var visit = getVisitObject();
      addDocumentsToVisit(
        visit,
        order,
        timeReturn,
        qualityReturn,
        samplesDoc,
        gratisDoc
      );
      addPaymentsInfo(visit);
      visitRest
        .post(visit)
        .then(function (data) {
          if (routeEntity) {
            logRest.post(vm.loggedUser.Id, "order.controller | Visit saved");
            var routeObj = {
              shouldReload: false,
            };
            if (route) {
              var selectedId = route.Id == 0 ? route.ParentId : route.Id;
              if (selectedId != data.EventId) {
                routeObj.shouldReload = true;
                logRest.post(
                  vm.loggedUser.Id,
                  "order.controller | Route visit should be reloaded with VisitId: " +
                    data.EventId
                );
                $sessionStorage.routeRouteId = data.EventId;
              }
            }
            $state.go("home.routes", routeObj);
          } else {
            $state.go("home.visits");
          }
          Notification.success("Pomyślnie dodano wizytę");
        })
        .catch(function () {
          Notification.error("Wystąpił błąd przy zapisie wizyty");
        })
        .finally(function () {
          vm.saveOnce = false;
        });
    }

    function addPaymentsInfo(document) {
      var payments = [];
      _.forEach(vm.order.PendingPayments, function (pp) {
        if (!pp.isExpired) return;
        var payment = {
          Amount: 0,
          Comment: pp.comment,
          CreateDateTime: new Date(),
          DocumentId: pp.DocumentId,
          DocumentNumberFull: pp.DocumentNumberFull,
          Id: pp.Id,
          ModifiedDateTime: new Date(),
          RecordVersion: 1,
          Type: pp.selectedAction.id,
          UserId: vm.user.selectedUserId,
          VisitDate: vm.order.Date,
          VisitId: 0,
        };
        if (pp.isExpired) {
          payments.push(payment);
        }
      });
      document.Payments = payments;
    }

    function addBasicInformation(document, title) {
      document.UserId = vm.user.selectedUserId;
      document.SubTypeId = 0;
      document.Storage = vm.contractor.StorageId;
      document.PayerId = vm.contractor.Id;
      document.PayerSymbol = vm.contractor.Symbol;
      document.PayerName = vm.contractor.Name;
      document.PayerAddressId = vm.contractor.DefaultAddressId;
      document.RecipientAddressId = vm.contractor.DeliveryAddressId;
      document.RecipientId = vm.contractor.Id;

      document.CurrencyExchangeRate = 1;
      document.Title = title;
      document.DocumentNumberFull = "Nienadany numer";
      document.PriceLevelId = vm.contractor.PriceLevelId;
      document.CurrencySymbol = "PLN";

      var date = new Date(vm.order.Date);
      document.DocumentReleaseDate = new Date(
        date.valueOf() - date.getTimezoneOffset() * 60000
      );
      document.DocumentReleaseDate = document.DocumentReleaseDate.toISOString();
    }

    function addEntities(document, productsRef) {
      document.DocumentEntities = [];
      var i = 1;
      var basket = getProductsFromBasket(productsRef);
      basket = _.filter(basket, function (prod) {
        return prod.Count > 0;
      });
      _.forEach(basket, function (product) {
        var entity = {};

        entity.Sign = 1;
        entity.ProductId = product.Id;
        entity.ProductTypeId = product.Type;
        entity.PositionOnDocument = i;
        entity.OnStorageDocument = i;
        entity.Count = product.Count;
        entity.CountStorage = product.Count;
        entity.MeasureUnit = product.MeasureUnit;

        if (!vm.contractor.PriceLevelId) {
          vm.contractor.PriceLevelId = 1;
        }
        entity.AmountDiscount = 1;
        entity.AmountProductGross = round(product.AmountProductGross);
        entity.AmountProductNet = round(product.AmountProductNet);
        entity.AmountInCurrency = entity.AmountProductNet;
        entity.AmountDoscount = 0;
        entity.AmountNet = round(product.AmountProductNet * product.Count);
        entity.AmountGross = round(product.AmountProductGross * product.Count);
        entity.AmountVAT = round(entity.AmountGross - entity.AmountNet);
        entity.VATId = product.VATId;
        entity.VATValue = product.Price.VatValue;
        if (
          product.AmountProductNet == product.Price.PromotionAmountProductNet
        ) {
          entity.PromotionId = product.Price.PromotionId;
          entity.PromotionAmountProductNet =
            product.Price.PromotionAmountProductNet;
        }

        entity.AcceptanceReason = 0;
        entity.CountReturned = 0;
        entity.ContractorId = vm.contractor.Id;
        entity.DocumentReleaseDate = document.DocumentReleaseDate;
        entity.DiscountPercent = product.DiscountPercent;
        if (
          entity.DiscountPercent == null ||
          entity.DiscountPercent == undefined
        ) {
          entity.DiscountPercent == 0.0;
        }
        entity.OriginalAmountProductNet = product.Price.AmountProductNet;
        entity.AmountSelectedNet = entity.AmountProductNet;
        entity.AcceptanceReason = 0;
        entity.ExpirationDate = product.ExpirationDate;
        entity.BatchNumber = product.BatchNumber;
        entity.FilesIds = product.FilesIds;

        document.DocumentEntities.push(entity);
        i++;
      });
    }

    function addPricesAndNote(document, prices, changeSign) {
      document.AmountTotal = round(prices.AmountGross);
      document.AmountNet = round(prices.AmountNet);
      document.AmountGross = round(prices.AmountGross);
      document.AmountVAT = round(prices.AmountVAT);
      document.AmountServicesNet = document.AmountNet;
      document.AmountServicesGross = document.AmountGross;
      document.AmountPaidLeft = document.AmountTotal;

      document.Note = prices.Note;
      if (changeSign) {
        document.AmountTotal = document.AmountTotal * -1;
        document.AmountNet = document.AmountNet * -1;
        document.AmountGross = document.AmountGross * -1;
        document.AmountVAT = document.AmountVAT * -1;
        document.AmountServicesNet = document.AmountServicesNet * -1;
        document.AmountServicesGross = document.AmountServicesGross * -1;
        document.AmountTotal = document.AmountTotal * -1;
      }
    }
    function datesAreOnSameDay(first, second) {
      return (
        first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate()
      );
    }

    function isSelectedDateSameAsRoute() {
      if (route === undefined) return true;
      return datesAreOnSameDay(
        new Date(route.BeginDate),
        new Date(vm.order.Date)
      );
    }

    function getVisitObject(orderId) {
      var visit = {};
      visit.ContractorId = vm.contractor.Id;
      if (route) {
        // console.log(route.BeginDate);
        // console.log(vm.order.Date);
        if (
          datesAreOnSameDay(new Date(route.BeginDate), new Date(vm.order.Date))
        ) {
          visit.EventId = route.Id == 0 ? route.ParentId : route.Id;
          logRest.post(
            vm.loggedUser.Id,
            "order.controller | Posting visit  with event Id: " + visit.EventId
          );
        } else {
          console.log("Route day and selected day diferent");
        }
        //if(route.BeginDate)
      } else {
        logRest.post(
          vm.loggedUser.Id,
          "order.controller | Posting visit without event Id"
        );
      }
      visit.OrderDocumentAmountGross = round(vm.order.AmountGross);
      visit.SendDateTime = Date.today().setTimeToNow().addHours(1);
      var date = new Date(vm.order.Date);
      visit.Date = new Date(
        date.valueOf() - date.getTimezoneOffset() * 60000
      ).toISOString();
      visit.UniqueId = Date.now() + vm.contractor.Id + "w";
      visit.UserId = vm.user.selectedUserId;
      visit.Comment = vm.visitNote;
      return visit;
    }

    function addDocumentsToVisit(
      visit,
      order,
      timeReturn,
      qualityReturn,
      samplesDoc,
      gratisDoc
    ) {
      visit.OrderDocument = vm.order.AmountGross > 0 ? order : null;
      visit.ReturnDocument = vm.timeReturn.AmountGross > 0 ? timeReturn : null;
      visit.QualityReturnDocument =
        vm.qualityReturn.AmountGross > 0 ? qualityReturn : null;
      visit.SampleDocument = vm.samples.AmountGross > 0 ? samplesDoc : null;
      visit.DegustationDocument = vm.gratis.AmountGross > 0 ? gratisDoc : null;
    }

    //this function checks products from all orders
    function isProductsError() {
      var basket = [].concat(
        getProductsFromBasket(vm.order.Products),
        getProductsFromBasket(vm.timeReturn.Products),
        getProductsFromBasket(vm.samples.Products),
        getProductsFromBasket(vm.gratis.Products)
      );
      var qualityBasket = getProductsFromBasket(vm.qualityReturn.Products);
      return (
        !areProductsValid(basket) ||
        !areProductsMultiplicityValid() ||
        !areProductsValid(qualityBasket, 1004)
      );
    }

    function areProductsFromDocumentValid(productsRef, docTypeId) {
      var basket = getProductsFromBasket(productsRef);
      return areProductsValid(basket, docTypeId);
    }

    function areProductsValid(products, docTypeId) {
      var areValid = true;
      for (var i = 0; i < products.length; i++) {
        if (!isCountValid(products[i])) {
          areValid = false;
          break;
        } else if (!isPriceValid(products[i])) {
          areValid = false;
          break;
        }
        if (docTypeId == 1004) {
          if (!isBatchNumberValid(products[i])) {
            areValid = false;
            break;
          }
          if (!isExpirationDateValid(products[i])) {
            areValid = false;
            break;
          }
        }
      }
      return areValid;
    }

    //only for order
    function areProductsMultiplicityValid() {
      var basket = getProductsFromBasket(vm.order.Products);
      var areValid = true;
      for (var i = 0; i < basket.length; i++) {
        if (!isMultiplicityValid(basket[i])) {
          areValid = false;
          break;
        }
      }
      return areValid;
    }

    function isCountValid(product) {
      return product.Count > 0;
    }

    function isPriceValid(product) {
      return (
        (product.MyPriceNet >= product.Price.MinimalPriceNet ||
          product.MyPriceNet == product.Price.PromotionAmountProductNet ||
          product.MyPriceNet == product.Price.AmountProductNet) &&
        product.MyPriceNet > 0
      );
    }

    function isMultiplicityValid(product) {
      //second modulo is because it sometimes produces Multiplicity instead of 0 (f.e. when count is 13.2 and multi = 1.2, without second modulo it equals 1.2 )
      return product.Multiplicity
        ? (Math.round( ( (product.Count % product.Multiplicity) + Number.EPSILON ) * 100 ) / 100)  % product.Multiplicity   == 0
        : true;
    }


    function isBatchNumberValid(product) {
      if (product.BatchNumber) return true;
      return false;
    }

    function isExpirationDateValid(product) {
      if (!product.ExpirationDate) return false;
      var date = new Date(product.ExpirationDate);
      if (date.getFullYear() < 2000) return false;
      return true;
    }

    function contractorHistory(contractorObject) {
      //vm.contractor = $stateParams.contractor;
      orderHistoryModalService.show("lg", contractorObject);
    }
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ObjectivesController', ObjectivesController);

  ObjectivesController.$inject = ['$log', '$stateParams', '$translate','$sessionStorage', 'SessionService', 'constRest', 'userRest', 'objectivesRest', '$state', 'objectiveTypeService'];

  function ObjectivesController($log, $stateParams, $translate, $sessionStorage, SessionService, constRest, userRest, objectivesRest, $state, objectiveTypeService) {
    /* jshint validthis: true */
    var vm = this;

    //functions def
    vm.onFilterChange = onFilterChange;
    vm.resetSearchTerms = resetSearchTerms;
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.onSelect = onSelect;
    vm.checkPermission = checkPermission;
    vm.onSelectPageCount = onSelectPageCount;
    vm.setCurrentPage = setCurrentPage;
    vm.pageChanged = pageChanged;
    vm.setPageSize = setPageSize;
    vm.goToElement = goToElement;
    vm.removeObjective = removeObjective;
    vm.setTotalCount = setTotalCount;
    vm.loadData = loadData;
    vm.setStatus = setStatus;
    vm.setTypeMessage = setTypeMessage;
    vm.openObjectiveCreationModal = openObjectiveCreationModal;

    //data def
    vm.data = undefined;
    vm.isDataReloading = false;
    vm.userDictName = "UsersDictionary";
    vm.minDate = new Date(2000, 0, 1);
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.beginDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: undefined
    };
    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchStr: undefined,
      pagingButtonsMaxSize: 5,
      type: undefined,
      beginDate: undefined,
      endDate: undefined,
      status: undefined,
      customTypeId: undefined,
      selectedUserId: undefined
    };
    vm.dictionaryData = {};
    vm.statusOptions = [
      {"Id":1, "Message": $translate.instant('objectives.statusOptions.Done')},
      {"Id":2, "Message": $translate.instant('objectives.statusOptions.InProgress')},
      {"Id":3, "Message": $translate.instant('objectives.statusOptions.NotDone')},
      {"Id":4, "Message": $translate.instant('objectives.statusOptions.ToDoInFuture')}
    ];
    vm.typeOptions = [
      {"Id": 1, "Message": $translate.instant('objectives.typeOptions.User')},
      {"Id": 2, "Message": $translate.instant('objectives.typeOptions.Contractor')},
      {"Id": 3, "Message": $translate.instant('objectives.typeOptions.Group')}
    ];

    constructor();

    function constructor(){
      loadUserDictionaryData();
      $log.debug("ObjectivesController");
      loadDictionaryData("PageSizeDictionary");

      vm.setPageSize(10);

      if ($sessionStorage.objectivesPagingData != undefined)
        vm.pagingData = $sessionStorage.objectivesPagingData;

      loadDataWithPagingData(true);
    }

    function loadUserDictionaryData() {
      /*isActive, searchStr, count, page, getCount, JobTitleId, storage, getEmployees, getAllIfPossible, userId*/
      userRest.all(undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, true, SessionService.getAuthenticatedUser().Id)
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          console.log(vm.dictionaryData);
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }


    function goToElement(key){
        $state.go("home.objectives.objective", {typeId: key.Type, id: key.Id});
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.objectivesPagingData = vm.pagingData;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    //opens datepicker
    function openDP($event, statusObj) {
      if(statusObj ==1)
        vm.datePickerBeginOpened = true;
      else
        vm.datePickerEndOpened = true;
    }

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      if(isMin){
        datepickerOptions.minDate = new Date(pagingDataField);
      }else{
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      vm.onFilterChange();
    }

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.objectivesPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function loadDataWithPagingData(getCount) {
      vm.loadData(
        vm.pagingData.type,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.status,
        vm.pagingData.customTypeId,
        vm.pagingData.searchStr,
         vm.pagingData.selectedUserId
      );
    }

    function loadData(type, count, page, getCount, beginDate, endDate, status, customTypeId, searchStr, selectedUserId) {
      vm.isDataReloading = true;

      objectivesRest.list(searchStr, beginDate, endDate, type, page, count, getCount, selectedUserId, status)
        .then(function (result) {
          console.log(result);

          //adding status to objectives
          result.forEach(function(objective){
            vm.setStatus(objective);
            vm.setTypeMessage(objective);
          });

          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
          console.log(vm.pagingData);
        })
        .catch(function (error) {
          $log.debug("Error while objectives data: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function resetSearchTerms() {
      vm.pagingData.currentPage = 1;
      vm.pagingData.beginDate = undefined;
      vm.pagingData.endDate = undefined;
      vm.pagingData.status = undefined;
      vm.pagingData.customTypeId = undefined;
      vm.pagingData.searchStr = undefined;
      vm.pagingData.selectedUserId = undefined;

      vm.beginDateOptions.maxDate = undefined;
      vm.endDateOptions.minDate = undefined;
      
      onFilterChange();
    }

    //checking permissions of user
    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function removeObjective(objective){
      objectivesRest.remove(objective)
        .then(function (data) {
          onFilterChange();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    //sets status of an objective based on beginDate/endEate/finished fields
    function setStatus(objective){

      var begin = new Date(objective.BeginDate);
      var end = new Date(objective.EndDate);
      end = new Date(end.setDate(end.getDate() + 1));
      var now = new Date();
      now.setHours(2,0,0,0);
      var done = objective.Finished;
      if(objective.childCount > 0 && objective.childCount == objective.childFinished){
        done = true;
      }

      //TODO
      if (done){
        objective.Status = vm.statusOptions[0];
      }else if ((begin <= now)&&(now <= end)){
        objective.Status = vm.statusOptions[1];
      }else if (now > end){
        objective.Status = vm.statusOptions[2];
      }else if (now < begin){
        objective.Status = vm.statusOptions[3];
      }
    }

    //opens modal allowing user to choose type of new objective (user/contractor/group)
    function openObjectiveCreationModal(){
      objectiveTypeService.show('sm');
    }

    //sets list type display value based on type of objective
    function setTypeMessage(objective){
      if(objective.Type == 1){
        objective.TypeDisplay = vm.typeOptions[0].Message;
      }else if(objective.Type == 2){
        objective.TypeDisplay = vm.typeOptions[1].Message;
      }else if(objective.Type == 3){
        objective.TypeDisplay = vm.typeOptions[2].Message;
      }
    }

  }
})
();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('objectiveTypeService', objectiveTypeService);

  objectiveTypeService.$inject = ['$log', '$uibModal', '$state'];

  function objectiveTypeService($log, $uibModal, $state) {

    var service = {
      show: showSelectionModal
    };

    return service;

    //var
    var isVisible = false;

    //css classes are in tasks/taskType.css because modal is based on task one
    function showSelectionModal(size) {
      if(isVisible)
        return;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/objectives/objectiveType.modal.html',
        controller: 'objectiveTypeController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        }
      });

      isVisible = true;
      modalInstance.result.then(function (data) {
        $log.info('Modal ok with ' + data);
        switch(data){
          case 1:
            $state.go("home.objectives.objective", {typeId:1, id: 0});
            break;
          case 2:
            $state.go("home.objectives.objective", {typeId:2, id: 0});
            break;
          case 3:
            $state.go("home.objectives.objective", {typeId:3, id: 0});
            break;
        }
        isVisible = false;
      }, function (err) {
        $log.info('Modal dismissed with:  ' + err);
        isVisible = false;
      });
    }


  };

  angular
    .module('smakmak.controllers')
    .controller('objectiveTypeController', objectiveTypeController);

  /** @ngInject */
  function objectiveTypeController($scope, $uibModalInstance) {
    var vm = this;

    //functions
    vm.action = action;

    //data
    vm.result = undefined;

    function action(value) {
      vm.result = value;
      $uibModalInstance.close(vm.result);
    }
  }

})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ObjectiveController', ObjectiveController);

  ObjectiveController.$inject = ['$log', '$stateParams', '$translate','SessionService', 'userRest', 'ConstSelectService', 'ContractorSelectService', 'objectivesRest', '$state', 'UploadService', 'uploadRest', 'Lightbox', 'constRest', 'UsersSelectService', 'Notification'];

  function ObjectiveController($log, $stateParams, $translate, SessionService, userRest, ConstSelectService, ContractorSelectService, objectivesRest, $state, UploadService, uploadRest, Lightbox, constRest, UsersSelectService, Notification) {
    /* jshint validthis: true */
    var vm = this;

    //FUNCTIONS DEF
    vm.openDP = openDP;
    vm.onDateChange = onDateChange;
    vm.selectContractorGroup = selectContractorGroup;
    vm.selectContractor = selectContractor;
    vm.isObjectiveValid = isObjectiveValid;
    vm.checkPermission = checkPermission;
    vm.goBack = goBack;
    vm.remove = remove;
    vm.submit = submit;
    vm.execute = execute;
    vm.canBeExecuted = canBeExecuted;
    vm.progressCheck = progressCheck;
    vm.permission = undefined;
    vm.uploadAttachment = uploadAttachment;
    vm.removeImg = removeImg;
    vm.openLightboxModal = openLightboxModal;
    vm.showSubContractorList = showSubContractorList;
    vm.showCommentary = showCommentary;
    vm.setStatus = setStatus;
    vm.setUser = setUser;
    vm.checkParent = checkParent;
    vm.searchIndexesOfPhoto = searchIndexesOfPhoto;
    vm.removePhotoFromFrontend = removePhotoFromFrontend;
    //paging functions
    vm.setPageSize = setPageSize;
    vm.setTotalCount = setTotalCount;
    vm.onSelectPageCount = onSelectPageCount;
    vm.pageChanged = pageChanged;
    vm.setCurrentPage = setCurrentPage;
    //child actions
    vm.goToElement = goToElement;
    vm.removeObjective = removeObjective;
    //context picking user/contractor/group functions
    vm.selectContext = selectContext;
    vm.selectOwnerUser = selectOwnerUser;
    vm.setLoggedUserAsOwnerUser = setLoggedUserAsOwnerUser;
    vm.selectUsers = selectUsers;
    vm.getLoggedUser = getLoggedUser;
    vm.showSingleSubContext = showSingleSubContext;
    vm.showChildContextList = showChildContextList;
    vm.removeFromChildLists = removeFromChildLists;
    //DATA DEF
    //vm.new - not showing commentary and photos if creating new objective

    vm.beginDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: new Date(),
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: new Date()
    };

    vm.blockSubmit - false;
    vm.new = false;
    vm.hasParent = false;
    vm.isInProgress = true;
    vm.isToDoInFuture = true;

    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5
    };

    //paging data result (child objectives list)
    vm.data = undefined;

    //array containing old ChildContextIds if editing objective, prevents cloning child objectives while adding new user/contractor
    vm.oldChildContextIds = [];

    //options for status
    vm.statusOptions = [
      {"Id":1, "Message": $translate.instant('objectives.statusOptions.Done')},
      {"Id":2, "Message": $translate.instant('objectives.statusOptions.InProgress')},
      {"Id":3, "Message": $translate.instant('objectives.statusOptions.NotDone')},
      {"Id":4, "Message": $translate.instant('objectives.statusOptions.ToDoInFuture')}
    ];

    vm.dictionaryData = {};
    vm.userDictName = "UsersDictionary";

    vm.loggedUser = undefined;
    vm.currentObjective = {
      "Id": undefined,
      "Name": undefined,
      "Type": undefined,
      "BeginDate": Date.now(),
      "EndDate": undefined,
      "Description": undefined,
      "Finished": false,
      "UserComment": undefined,
      "ContextObject": undefined,
      "UserId": undefined,
      "User": undefined,
      "ImagesRequired": 0,
      "Files": [],
      "FilesIds": [],
      "ChildContextIds": [],
      "ChildContextObjects": []
    };

    constructor();

    function constructor(){
      vm.permission = vm.checkPermission(11);
      loadUserDictionaryData();
      loadDictionaryData("PageSizeDictionary");
      vm.setPageSize(10);
      vm.loggedUser = vm.getLoggedUser();

      if ($stateParams.id > 0) {
        loadData($stateParams.id);
        vm.new = false;
      }else{
        vm.new = true;
        vm.currentObjective.Type = parseInt($stateParams.typeId);
      }
    }

    function getLoggedUser(){
      return SessionService.getAuthenticatedUser();
    }

    //datepicker method
    function openDP($event, statusObj) {
      if (statusObj == 1)
        vm.datePickerBeginOpened = true;
      else if(statusObj === 2)
        vm.datePickerEndOpened = true;
    };

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      if(isMin){
        datepickerOptions.minDate = new Date(pagingDataField);
      }else{
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadData(id) {
      vm.isDataReloading = true;
      objectivesRest.get(id)
        .then(function (result) {
          vm.currentObjective = angular.copy(result);
          vm.currentObjective.BeginDate = Date.parse(vm.currentObjective.BeginDate);
          vm.currentObjective.EndDate = Date.parse(vm.currentObjective.EndDate);
          vm.beginDateOptions.maxDate = vm.currentObjective.EndDate;
          vm.endDateOptions.minDate = vm.currentObjective.BeginDate;
          vm.isDataReloading = false;
          loadChildList(true);

          console.log('Current Objective :');
          console.log(vm.currentObjective);

          vm.currentObjective.ChildContextObjects = [];
          vm.currentObjective.FilesIds = [];
          //to prevent cloning sub objectives
          vm.oldChildContextIds = angular.copy(vm.currentObjective.ChildContextIds);
          vm.currentObjective.ChildContextIds = [];

          vm.progressCheck();
          vm.checkParent();
        })
        .catch(function (error) {
          $log.debug("Error while getting objective data");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function loadUserDictionaryData() {
      /*isActive, searchStr, count, page, getCount, JobTitleId, storage, getEmployees, getAllIfPossible, userId*/
      userRest.all(undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, true, SessionService.getAuthenticatedUser().Id)
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    }

    function pageChanged() {
      loadChildList(false);
    };

    function onSelectPageCount(item, model) {
      loadChildList(true);
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function loadChildList(getCount){
      objectivesRest.childsList($stateParams.id, vm.pagingData.currentPage, vm.pagingData.pageSize, getCount).then(function(list){
        console.log(list);

      //adding status to objectives
      list.forEach(function(objective){
        vm.setStatus(objective);
        vm.setUser(objective);
      });

      vm.data = list;
      if (list.totalCount) {
        vm.setTotalCount(parseInt(list.totalCount, 10));
      }
    })
    .catch(function (error) {
      $log.debug("Error while child objectives data: " + vm.pagingData);
    });
   }

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    }

    function removeObjective(objective){
      vm.blockSubmit = true;
      objectivesRest.remove(objective)
        .then(function (data) {
          loadChildList(true);
          vm.blockSubmit = false;
        })
        .catch(function (err) {
          vm.blockSubmit = false;
          console.log(err);
        });
    }

    //remove from contractors list
    function remove(dataArr, id) {
      for(var i = 0; i < dataArr.length; i++)
        if(dataArr[i].ContextId === id){
          var idx = i;
          console.log("a hit!");
          break;
        }
      if (idx > -1) {
        dataArr.splice(idx, 1);
      }
    }

    //selects context object (user or ocntractor or group)
    function selectContext(){
      if(vm.currentObjective.Type === 1){
        //user
        vm.selectUsers(1);
      }else if(vm.currentObjective.Type === 2){
        //contractor
        vm.selectContractor(2);
      }else if(vm.currentObjective.Type === 3){
        //group
        vm.selectContractorGroup(3);
      }
    }

    //adding new contractors button
    function selectContractor(type) {
      var callback = function (obj) {
        addElemnt(type, obj, "Id", "Name", "Symbol", "Name", "Symbol");
      }

      var callbackCheck = function (obj) {

        for(var i = 0; i < vm.currentObjective.ChildContextIds.length; i++) {
          if(vm.currentObjective.ChildContextIds[i] == obj.Id)
            return vm.currentObjective.ChildContextIds[i];
        };

        for(var i = 0; i < vm.oldChildContextIds.length; i++) {
          if(vm.oldChildContextIds[i] == obj.Id)
            return vm.oldChildContextIds[i];
        };

        return undefined;
      }

      ContractorSelectService.show("lg", callback, callback, callbackCheck, undefined, false);
    }

    //adds element (obj) to contextObject (dataArr - previously array changed to single object) with specified entity type (type)
    function addElemnt(type, obj, idAttrName, attrName1, attrName2, attrName1Name, attrName2Name) {

      if (attrName1Name == undefined)
        attrName1Name = "Name";
      if (attrName2Name == undefined)
        attrName2Name = "Symbol";

      var addedObj = {};
      addedObj["ContextId"] = obj[idAttrName];
      if (attrName1 != undefined)
        addedObj[attrName1Name] = obj[attrName1];
      if (attrName2 != undefined)
        addedObj[attrName2Name] = obj[attrName2];

        //if contractors group is being selected
        if (type === 3){
          addedObj["Value"] = obj[attrName1];
        }


      addedObj.Type = type;
      //group
      if(vm.currentObjective.Type === 3){
        vm.currentObjective.ContextId = addedObj["ContextId"];
        vm.currentObjective.ContextObject = addedObj;
        //contractor or user
      }else{
        vm.currentObjective.ChildContextObjects.push(addedObj);
        vm.currentObjective.ChildContextIds.push(addedObj["ContextId"]);
      }
    }

    function goToElement(key){
        $state.go("home.objectives.objective", {id: key.Id});
    }

    //adding new contractors group button
    function selectContractorGroup(type) {
      function callback(obj) {
        if (obj == undefined)
          return;
        addElemnt(type, obj, "LocalId", "Value", undefined, "Name");
        //vm.group = undefined;
      }

      var callbackCheck = function (obj) {
          if((vm.currentObjective.ContextObject === undefined)||(vm.currentObjective.ContextObject === null)){
            return undefined;
          }else if(vm.currentObjective.ContextId == obj.LocalId){
            return obj;
          }else{
            return undefined;
          }
      }

      ConstSelectService.show("lg", callback, undefined, 'ContractorGroupDictionary', vm.Entities, callbackCheck, "Wybierz grupy kontrahentów", 'Value');
    }

    //opens user picker for sueprior user
    //user select modal
    function selectOwnerUser(){

      var callback = function (obj){
        //vm.currentObjective.User = obj;
        vm.currentObjective.User = obj;
        vm.currentObjective.UserId = obj.Id;
      }

      var callbackCheck = function (obj) {
        if((vm.currentObjective.User === undefined)||(vm.currentObjective.User === null)){
          return undefined;
        }else if(vm.currentObjective.UserId == obj.Id){
          return obj;
        }else{
          return undefined;
        }
      }

      UsersSelectService.show("lg", callback, undefined, callbackCheck,  false, true, vm.loggedUser.Id, true, undefined);
    }

    function setLoggedUserAsOwnerUser(){
      vm.currentObjective.User = vm.loggedUser;
      vm.currentObjective.UserId = vm.loggedUser.Id;
    }

    //selects list of users
    function selectUsers(type){
      var callback = function (obj) {
        addElemnt(type, obj, "Id", "Name", "SurName", "Name", "SurName");
      }

      var callbackCheck = function (obj) {
        for(var i = 0; i < vm.currentObjective.ChildContextIds.length; i++) {
          if(vm.currentObjective.ChildContextIds[i] == obj.Id)
            return vm.currentObjective.ChildContextIds[i];
        };

        for(var i = 0; i < vm.oldChildContextIds.length; i++) {
          if(vm.oldChildContextIds[i] == obj.Id)
            return vm.oldChildContextIds[i];
        };

        return undefined;
      }

      UsersSelectService.show("lg", callback, callback, callbackCheck,  false, true, vm.loggedUser.Id, true, undefined, undefined, vm.currentObjective.User.Id);
    }

    //check before submitting
    function isObjectiveValid(){
      if (vm.currentObjective === undefined){
        return false;
      }
      if(vm.currentObjective.Description === undefined){
        return false;
      }
      if(vm.currentObjective.UserId === undefined){
        return false;
      }
      if(((vm.currentObjective.ContextObject === undefined)||(vm.currentObjective.ContextObject === null))&&(vm.currentObjective.Type == 3)){
        return false;
      }
      if((vm.currentObjective.ContextId === undefined)&&(vm.currentObjective.Type == 3)){
        return false;
      }
      if (vm.currentObjective.Type === undefined){
        return false;
      }
      if(!vm.isToDoInFuture){
        return false;
      }
      if(vm.hasParent){
        return false;
      }
      if (!vm.form.$valid) {
        return false;
      }
      return true;
    }

    //checking permissions of user
    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    //submitting objective
    function submit(){

      formatChange(vm.currentObjective);

      if(vm.currentObjective.BeginDate.getUTCDate() !== vm.currentObjective.BeginDate.getDate())
        deleteDateOffset(vm.currentObjective);


      console.log(vm.currentObjective);
      //copies
      var ChildContextObjects = angular.copy(vm.currentObjective.ChildContextObjects);
      var User = angular.copy(vm.currentObjective.User);

      vm.currentObjective.ChildContextObjects = undefined;
      vm.currentObjective.User = undefined;

      vm.blockSubmit = true;
      if ($stateParams.id > 0) {
        objectivesRest.save(vm.currentObjective).then(function () {
          var message = $translate.instant('objective.notifications.updated');
          Notification.success(message);
          $state.go("home.objectives");
        }).catch(function(){
          vm.blockSubmit = false;
          var message = $translate.instant('objective.notifications.error');
          Notification.error(message);
          vm.currentObjective.ChildContextObjects = ChildContextObjects;
          vm.currentObjective.User = User;
        });
      }
      else
        objectivesRest.post(vm.currentObjective).then(function (res) {
          var message = $translate.instant('objective.notifications.added');
          Notification.success(message);
          $state.go("home.objectives");
        }).catch(function(){
          vm.blockSubmit = false;
          var message = $translate.instant('objective.notifications.error');
          Notification.error(message);
          vm.currentObjective.ChildContextObjects = ChildContextObjects;
          vm.currentObjective.User = User;
        });;

    }

    //executes an objective, making it finished
    function execute(){
      //needs to be before enddate but after begindate
      if(vm.isInProgress){
        if ($stateParams.id > 0) {
          //changing finished field
          vm.currentObjective.Finished = !vm.currentObjective.Finished;

          objectivesRest.save(vm.currentObjective).then(function () {
            $state.go("home.objectives");
          });
        }
      }
    }

    //checks if objective can be executed, used for disabling execution button
    function canBeExecuted(){
      //objectives beginDate < today < objectives endDate
      if(!vm.isInProgress){
        return false;
      }
      //objective must have required amount of images uploaded
      if(vm.currentObjective.ImagesRequired > vm.currentObjective.Files.length){
        return false;
      }
      //if objective is already executed
      if(vm.currentObjective.Finished){
        return false;
      }
      //if new event is being created
      if($stateParams.id == 0){
        return false;
      }
      return true;
    }

    //checks if current date is between begin and end dates of objective
    function progressCheck(){
      var begin = new Date(vm.currentObjective.BeginDate);
      var end = new Date(vm.currentObjective.EndDate);
      end = new Date(end.setDate(end.getDate() + 1));
      var now = new Date();
      now.setHours(0,0,0,0);

      //in progress is also considered as to do in future for simplification for simplification
      if((begin <= now)&&(now <= end)&&(!vm.currentObjective.Finished)){
        vm.isInProgress = true;
        vm.isToDoInFuture = true;
      } else if((now < begin)&&(!vm.currentObjective.Finished)){
        vm.isInProgress = false;
        vm.isToDoInFuture = true;
      }else{
        vm.isInProgress = false;
        vm.isToDoInFuture = false;
      }
    }

    //parent check
    function checkParent(){
      if((vm.currentObjective.ParentId !== undefined)&&(vm.currentObjective.ParentId > 0)){
        vm.hasParent = true;
      }else{
        vm.hasParent = false;
      }
    }

    //sets status of an objective based on beginDate/endEate/finished fields
    function setStatus(objective){

      var begin = new Date(objective.BeginDate);
      var end = new Date(objective.EndDate);
      end = new Date(end.setDate(end.getDate() + 1));
      var now = new Date();
      now.setHours(2,0,0,0);
      var done = objective.Finished;

      //TODO
      if (done){
        objective.Status = vm.statusOptions[0];
      }else if ((begin <= now)&&(now <= end)){
        objective.Status = vm.statusOptions[1];
      }else if (now > end){
        objective.Status = vm.statusOptions[2];
      }else if (now < begin){
        objective.Status = vm.statusOptions[3];
      }
    }

    //sets user full name to display
    function setUser(objective){
      if (objective.User !== undefined){
        objective.UserFullName = objective.User.Name + ' ' + objective.User.SurName;
      }else{
        objective.UserFullName = ' ';
      }
    }

    //promotion format change
    function formatChange(objective){
      var begin = new Date(objective.BeginDate);
      begin.setHours(0,0,0,0);
      objective.BeginDate = begin;

      var end = new Date(objective.EndDate);
      end.setHours(0,0,0,0);
      objective.EndDate = end;
    }

    //deletes timezone offset from dates
    function deleteDateOffset(objective){
      var timezoneOffset = objective.BeginDate.getTimezoneOffset(),
          time = objective.BeginDate.getTime();
          objective.BeginDate = new Date(time - timezoneOffset * 60 * 1000);

          time = objective.EndDate.getTime();
          objective.EndDate = new Date(time - timezoneOffset * 60 * 1000);
    }

    //uploads pdf or image
    function uploadAttachment(){

      var callback = function(data){
        console.log(data);
        vm.currentObjective.Files.push(data);
        vm.currentObjective.FilesIds.push(data.Id);
      };

      //if a new promotion is being created
      if ($stateParams.id == 0) {
          UploadService.show("sm", callback, undefined, undefined, 4);
      }else{
      UploadService.show("sm", callback, undefined, vm.currentObjective.Id, 4, '\'image/*\'');
      }
    }

    //if contractor group, show list of contractors in that group
    function showSubContractorList(){
        if((!vm.new)&&(!(vm.currentObjective.ParentId > 0))){
          return true;
        }
        return false;
    }

    function showCommentary(){
        if((!vm.new)&&(vm.currentObjective.Type !== 3)){
          return true;
        }
        return false;
    }

    //removes img
    function removeImg(image){
      var indexes = vm.searchIndexesOfPhoto(image);
      uploadRest.remove(image.Id).then(function(){
        vm.removePhotoFromFrontend(indexes);
      });
    }

    //searches indexes in files and filesids arrays of photo to delete
    function searchIndexesOfPhoto(image){
      //files
      var idx = [-1, -1];

      for(var i = 0; i < vm.currentObjective.Files.length; i++)
        if(vm.currentObjective.Files[i].Id == image.Id){
          idx[0] = i;
          break;
        }
      //files ids
      for(var i = 0; i < vm.currentObjective.FilesIds.length; i++)
        if(vm.currentObjective.FilesIds[i] == image.Id){
          idx[1] = i;
          break;
        }
        return idx;
    }

    //removes photos from frontend after removing in backend, based on previous found indexes [0] - files index, [1] - filesIds index
    function removePhotoFromFrontend(indexes){
      if(indexes[0] > -1){
        vm.currentObjective.Files.splice(indexes[0], 1);
      }
      if(indexes[1] > -1){
        vm.currentObjective.FilesIds.splice(indexes[1], 1);
      }
    }

    //opens bigger image of image in gallery
    function openLightboxModal(index) {
      Lightbox.openModal(vm.currentObjective.Files, index);
    };

    //goes back to objectives state
    function goBack(){
      $state.go("home.objectives");
    }

    //if objective has parent show single user/contractor row in form (type 1 - shows single user, 2 - single contractor)
    function showSingleSubContext(type){
      if((vm.currentObjective.ParentId !== undefined)&&(vm.currentObjective.ParentId > 0)&&(vm.currentObjective.Type === type)){
        return true;
      }
      return false;
    }

    //shows user/contractor list
    function showChildContextList(){
      if(((vm.currentObjective.Type === 1)||(vm.currentObjective.Type === 2))
        &&((vm.currentObjective.ParentId === undefined)||(vm.currentObjective.ParentId === null))){
          return true;
        }
      return false;
    }

    //removes object from child lists (user/contractor) in form
    function removeFromChildLists(id){
      var idx = -1;
      for(var i = 0; i < vm.currentObjective.ChildContextIds.length; i++)
        if(vm.currentObjective.ChildContextIds[i] === id){
          idx = i;
          break;
        }
      if (idx > -1) {
        vm.currentObjective.ChildContextIds.splice(idx, 1);
        vm.currentObjective.ChildContextObjects.splice(idx, 1);
      }
    }

  }
})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('NotificationsController', NotificationsController);

  NotificationsController.$inject = ['$log', '$state', '$stateParams', '$translate', 'contractorRest', 'constRest', 'UsersService', 'storageRest'];

  function NotificationsController($log, $state, $stateParams, $translate, contractorRest, constRest, UsersService, storageRest) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadDictionaryData = loadDictionaryData;

    ///////////////// data def
    vm.error = undefined;
    vm.isLoading = false;
    vm.userDictName = "UsersDictionary";

    vm.dictionaryData = {};

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("notifications.controller");
      //constructor body
      loadDictionaryData("ProvinceDictionary");       ////do adresów
    }

    ///////////////// business logic

    ///////////////// watchers


    ///////////////// check state functions

    ///////////////// resource invoke functions

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
        });
    }


    //accordion
    //accordion end

    ///////////////// FORMLY



  }
})
();

/**
 * Created by Misiek on 2015-11-05.
 */

(function () {
  "use strict";

  angular.module("smakmak.directives").directive("nxasNavbar", nxasNavbar);

  /** @ngInject */
  function nxasNavbar() {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/navbar/navbar.html",
      scope: {
        creationDate: "=",
      },
      controller: NavbarController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function NavbarController(
      AuthorizationService,
      LoginModalService,
      SessionService,
      $state,
      notificationRest,
      $interval,
      taskTypeService,
      $element
    ) {
      var vm = this;

      vm.getNotifications = getNotifications;
      vm.getCounts = getCounts;
      vm.goToNofif = goToNofif;
      vm.setNotifAsRead = setNotifAsRead;
      vm.setAllAsRead = setAllAsRead;
      vm.openTaskCreationModal = openTaskCreationModal;
      vm.goToDocumentSystem;

      vm.notificationsCount = 0;
      vm.newNotificationsCount = 0;
      vm.notifications = undefined;
      vm.popoverTemplate = "notifPopover.html";

      vm.menuShown = false;
      vm.menuItemActive = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      //vm.menuItemActive = new Array(7).fill(false);

      loadData();

      function loadData() {
        getNotifications();
        $interval(vm.getNotifications, 60000);
      }

      vm.AuthService = AuthorizationService;
      vm.openM = function () {
        LoginModalService.showLoginModal();
      };
      vm.checkPermission = function (id) {
        return SessionService.checkPermission(id);
      };
      vm.logout = function () {
        AuthorizationService.logOut();
        $state.go("login");
      };

      vm.toggleMenu = function () {
        vm.menuShown = !vm.menuShown;
        $element.toggleClass("menu-active");
      };
      vm.toggleMenuItem = function (n) {
        if (vm.menuItemActive[n]) vm.menuItemActive[n] = false;
        else {
          vm.menuItemActive = [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ];
          vm.menuItemActive[n] = true;
        }
      };

      function goToNofif(data) {
        //setNotifAsRead(data);
        if (data == "1")
          $state.go("home.contractors", {
            pagingData: { isAcceptanceRequired: true },
          });
      }

      function setNotifAsRead(data) {
        data.Status = 10;
        vm.newNotificationsCount -= 1;
        notificationRest
          .setRead(SessionService.getAuthenticatedUser().Id, data)
          .then()
          .catch();
      }

      function setAllAsRead() {}

      function getCounts() {
        vm.notificationsCount = 0;
        vm.newNotificationsCount = 0;
        vm.notificationsCountByType = {
          1: 0,
        };
        angular.forEach(vm.notifications, function (value, key) {
          vm.notificationsCount += 1;
          if (value.Status < 10) {
            vm.newNotificationsCount += 1;
          }
          vm.notificationsCountByType[value.TypeId] += 1;
        });
      }

      function getNotifications() {
        // notificationRest.all(SessionService.getAuthenticatedUser().Id)
        //   .then(function (data) {
        //     vm.notifications = data;
        //     getCounts();
        //   })
        //   .catch(function (error) {
        //   });
      }

      //opens modal allowing user to choose type of new task (user/contractor/product)
      function openTaskCreationModal() {
        taskTypeService.show("sm");
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('LoginModalService', LoginModalService);

  LoginModalService.$inject = ['$log', '$uibModal'];

  function LoginModalService($log, $uibModal) {

    var isVisible = false;


    var service = {
      showLoginModal: showLoginModal
    };

    return service;

    //var

    function showLoginModal() {
      if(isVisible)
        return;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/login/login.modal.html',
        controller: 'ModalController',
        size: 'm'
      });
      isVisible = true;
      modalInstance.result.then(function (data) {
        $log.info('Modal ok with ' + data);
        isVisible = false;
      }, function (err) {
        $log.info('Modal dismissed with:  ' + err);
        isVisible = false;
      });
    }


  };

  angular
    .module('smakmak.controllers')
    .controller('ModalController', ModalController);

  /** @ngInject */
  function ModalController($scope, $modalInstance, AuthorizationService) {
    var vm = this;

    vm.ok = ok;
    vm.cancel = cancel;
    vm.isLoging = false;

    ///////

    $scope.$on('logIn', function (event, mass) {
      console.log('Event ' + event + '   ' + mass);
      if (mass == true)
        vm.ok();
      else
        vm.cancel();
    });
    function ok() {
      $modalInstance.close(0);
    };

    function cancel() {
      AuthorizationService.logOut();
      $modalInstance.dismiss(1);
    };

  }

})();


(function () {
  "use strict";

  angular.module("smakmak.directives").directive("nxasLogin", nxasLogin);

  /** @ngInject */
  function nxasLogin() {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/login/login.directive.html",
      scope: {
        sref: "@",
        showRegister: "@",
        dispatchEvents: "@", // czy mają być wysłane eventy? Tylk wtedy gdy modal jest pokazywany
      },
      controller: LoginController,
      controllerAs: "vm",
    };

    return directive;
  }

  angular
    .module("smakmak.controllers")
    .controller("LoginController", LoginController);

  LoginController.$inject = [
    "$window",
    "$http",
    "$scope",
    "$log",
    "$translate",
    "UsersService",
    "AuthorizationService",
    "openIdConnectRest",
    "$state",
    "SessionService",
    "$filter",
    "$location",
    "Restangular",
  ];

  function LoginController(
    $window,
    $http,
    $scope,
    $log,
    $translate,
    UsersService,
    AuthorizationService,
    openIdConnectRest,
    $state,
    SessionService,
    $filter,
    $location,
    Restangular
  ) {
    var vm = this;

    ////////////// functions def
    vm.logIn = logIn;
    vm.goToRegister = goToRegister;
    vm.checkAuthStatus = checkAuthStatus;
    vm.closeAlert = closeAlert;
    vm.showRegister = $scope.showRegister;

    ////////////// data def

    vm.loginErrorText = undefined;
    vm.stayLogged = undefined;

    vm.user = {
      email: "",
      password: "",
    };
    vm.isError = false;
    vm.error = {};
    vm.isLoading = false;
    vm.openid = {};

    ///////////////// constructor call

    loadData();

    function loadData() {
      vm.openid = getOpenIdObject();
      vm.stayLogged = SessionService.checkStayLogged();
      if (
        vm.stayLogged === true &&
        SessionService.getAuthorisationHeader(1) != undefined
      )
        autoLogIn();
    }

    /////////////////business logic

    function fOk() {
      vm.isLoading = false;
      vm.isError = false;
      if (isOpenIdLogIn()) {
        console.info("openid login");
        authorizeWithOpenId()
          .then(function (res) {
            console.info(res);
          })
          .catch(function (err) {
            if (err.config.params) console.info(err);
          });
        return;
      }
      if ($scope.dispatchEvents == "true") $scope.$emit("logIn", true);
      if ($scope.sref != undefined) $state.go($scope.sref);
      else $state.go("home.mainPage");
    }

    function fError(err) {
      $log.log(err);
      vm.isLoading = false;
      vm.isError = true;
      vm.error = err;
      if ($scope.dispatchEvents == "true") $scope.$emit("logIn", false);
    }

    function logIn(email, password) {
      vm.isLoading = true;
      vm.isError = false;
      vm.loginErrorText = undefined;
      SessionService.setStayLogged(vm.stayLogged);

      function authUser() {
        AuthorizationService.authenticateUser(
          email,
          password,
          function (obj) {
            fOk();
          },
          function (err) {
            fError($filter("translate")("login.states.passwordInvalid"));
          }
        );
      }

      //0: e mail w subiekcie i zarejestrowany
      //1: e-mail w subiekie i niezarejestrowany
      //2: e-mail nie istnieje
      //3: e mail w subiekcie i zarejestrowany ale nieaktywny
      AuthorizationService.checkEmail(
        email,
        function (data) {
          switch (data.Status) {
            case 1:
              fError($filter("translate")("login.states.emailNotRegistered"));
              break;
            case 2:
              fError($filter("translate")("login.states.emailInvalid"));
              break;
            case 3:
              fError($filter("translate")("login.states.emailInactive"));
              break;
            default: {
              authUser();
            }
          }
        },
        function error(err) {
          fError($filter("translate")("common.services.500"));
        }
      );
    }

    function autoLogIn() {
      vm.isLoading = true;
      vm.isError = false;
      vm.loginErrorText = undefined;
      AuthorizationService.authenticateUserWithCredentials(fOk, fError);
    }

    function goToRegister() {
      if ($scope.dispatchEvents == "true") $scope.$emit("logIn", false);
      $state.go("resetpass");
    }

    function closeAlert() {
      vm.isError = false;
      vm.error = undefined;
    }

    function getOpenIdObject() {
      if (!$location.search().scope) return {};
      if ($location.search().scope.includes("openid")) {
        return {
          response_type: $location.search().response_type,
          scope: $location.search().scope,
          client_id: $location.search().client_id,
          state: $location.search().state,
          redirect_uri: $location.search().redirect_uri,
        };
      }
    }
    function isOpenIdLogIn() {
      if (!$location.search().scope) return false;
      return $location.search().scope.includes("openid");
    }

    function authorizeWithOpenId() {
      // return openIdConnectRest.get(
      //   vm.openid.client_id,
      //   vm.openid.redirect_uri,
      //   vm.openid.scope,
      //   vm.openid.response_type,
      //   vm.openid.response_mode
      // );
      var user = SessionService.getAuthenticatedUser();
      var params = vm.openid;
      params.userId = user.Id;
      params.surname = user.SurName;
      params.name = user.Name;
      params.email = user.EMail;
      var openidRedirectUrl =
        Restangular.configuration.baseUrl +
        "/connect/authorize" +
        "?client_id=" +
        vm.openid.client_id +
        "&redirect_uri=" +
        vm.openid.redirect_uri +
        "&response_type=" +
        vm.openid.response_type +
        "&scope=" +
        vm.openid.scope +
        "&userId=" +
        vm.openid.userId +
        "&state=" +
        vm.openid.state;

      $window.location.href = openidRedirectUrl;
    }

    ///////////////// watchers

    ///////////////// check state functions
    function checkAuthStatus() {
      vm.isLogged = AuthorizationService.isUserLogged();
    }

    ///////////////// resource invoke functions

    ///////////////// FORMLY

    vm.userFields = [
      {
        key: "email",
        type: "input",
        templateOptions: {
          type: "email",
          label: "E-mail",
          //placeholder: $translate.instant('common.form.email'),
          required: true,
          minlength: 6,
        },
        validation: {
          messages: {
            // required: 'to.label + " jest wymagane"',
            minlength: 'to.label + " musi zawierać 6 znaków i znak @"',
          },
        },
      },
      {
        key: "password",
        type: "input",
        templateOptions: {
          type: "password",
          label: "Hasło",
          //placeholder: $translate.instant('common.form.password'),
          required: true,
          minlength: 6,
        },
        validation: {
          messages: {
            minlength: 'to.label + " musi zawierać minimum 6 znaków"',
          },
        },
      },
    ];
  }
})();
/**
 * Created by Misiek on 2015-09-28.
 */

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ExcludedProductsController', ExcludedProductsController);

  ExcludedProductsController.$inject = ['$log', '$translate',  'excludedProductRest', 'storageRest', 'constRest', 'Notification', 'ProductsSelectService'];

  function ExcludedProductsController($log, $translate,  excludedProductRest, storageRest, constRest, Notification, ProductsSelectService) {
    /* jshint validthis: true */
    var vm = this;
    //func
    vm.addNew = addNew;
    vm.openDP = openDP;
    vm.removeRow = removeRow;
    vm.sendRecord = sendRecord;
    vm.selectProduct = selectProduct;
    vm.shouldSend = shouldSend;
    vm.onSelectPageCount = onSelectPageCount;
    vm.pageChanged = pageChanged;
    //data
    vm.isDataReloading = false;
    vm.beginDatePickerOpened  = [];
    vm.endDatePickerOpened = [];
    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: Date.today()
    };
    vm.dictionaryData = {};
    vm.excludedProducts = [];
    vm.excludedProductsView = [];
    vm.pagingData = {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5
    };

    loadData();

    function loadData() {
      loadExcludedProducts(vm.pagingData.pageSize, vm.pagingData.currentPage, true);
      loadDictionaryData("PageSizeDictionary");
      loadStoragesData();
    }

    function loadExcludedProducts(count, page, getCount) {
      vm.isDataReloading = true;
      excludedProductRest.all(count, page, getCount)
        .then(function (data) {
          vm.excludedProducts = data;
          if (data.totalCount) {
            vm.pagingData.totalCount = parseInt(data.totalCount, 10);
          }
          vm.excludedProductsView = groupExcludedProducts(data);
          $log.info(vm.excludedProductsView);
        })
        .catch(function (error) {
          $log.debug(error);
          $log.debug("Error while getting excluded products");
        })
        .finally(function () {
          vm.isDataReloading = false;
        });
    }

    function groupExcludedProducts(excludedProducts) {
      var groupFunction = function(element){
        return element.BeginDate + element.EndDate + element.ProductId;
      };
      var ret = [];
      var groups = _.groupBy(excludedProducts, groupFunction);
      _.forEach(groups, function (value, key) {
        var StorageIds = [];
        var relatedRecords = [];
        _.forEach(value, function (element) {
          StorageIds.push(element.StorageId);
          relatedRecords.push(element);
        });
        ret.push({
          IsNew: false,
          IsChanged: false,
          StorageIds: StorageIds,
          BeginDate: value[0].BeginDate,
          EndDate: value[0].EndDate,
          ProductId: value[0].ProductId,
          ProductContext: value[0].ProductContext,
          RelatedRecords: relatedRecords
        });
      });
      return ret;
    }

    function prepareModelData() {
      //dla każdego rekordu z widoku:
      //1. Sprawdź które rekory zmieniły datę.
      //2. Dla każdego rekordu ze zmienionych usuń, dodaj lub zmodyfikuj istniejące
      //3. Sprawdź które rekordy sa nowe i trzeba je zapisać
      var add = [];
      var remove = [];
      var mofify = [];
      _.forEach(vm.excludedProductsView, function(viewElement){
        _.forEach(viewElement.storageIds, function(storageId) {

        });
      });
    }
    //BeginDate: "2018-07-02T00:00:00"
    // CreateDateTime: "2018-07-02T10:43:11.457"
    // EndDate: "2018-07-12T00:00:00"
    // Id: 48
    // ModifiedDateTime: "2018-07-02T10:43:11.457"
    // ProductContext: {Id: 847, SubiektId: 1312, Blocked: false, Type: 1, Symbol: "TWP054", …}
    // ProductId: 847
    // RecordVersion: 1
    // StorageId: 6


    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting storages");
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function addNew() {
      vm.excludedProducts.push({
        "ProductId": undefined,
        "ProductContext": {},
        "StorageId": undefined,
        "BeginDate": new Date(),
        "EndDate": new Date(),
        "IsChanged": false
      });
    }

    function openDP($event, statusObj, $index, excludedProd) {
      if (statusObj == 1) {
        vm.beginDatePickerOpened[$index] = true;
        vm.dateOptions.minDate = undefined;
        vm.dateOptions.maxDate = new Date(excludedProd.EndDate);
      } else {
        vm.endDatePickerOpened[$index] = true;
        vm.dateOptions.minDate = new Date(excludedProd.BeginDate);
        vm.dateOptions.maxDate = undefined;
      }
    }

    function selectProduct(key) {
      function callback(obj) {
        key.IsChanged = true;
        key.ProductContext = obj;
        key.ProductId = obj.Id;
      }

      function callbackCheck(obj) {
        if (key.ProductId !== obj.Id) {
          return undefined;
        } else {
          return true;
        }
      }

      ProductsSelectService.show("lg", callback, undefined, callbackCheck);
    }

    function shouldSend(key) {
      return (key.IsChanged && (key.ProductId) && (key.StorageId))
    }

    function sendRecord(key){
      key.IsChanged = false;
      deleteDateOffsets(key);

      if(key.Id){
        excludedProductRest.update(key).then(function(){
          var message = $translate.instant('parametrization.notifications.successChange');
          Notification.success(message);
          key.IsChanged = false;
        }).catch(function(error){
          var message = $translate.instant('parametrization.notifications.errorChange');
          Notification.error(message);
          key.IsChanged = true;
        });
      } else {
        excludedProductRest.add(key).then(function(response){
          key.Id = response.Id;
          var message = $translate.instant('parametrization.notifications.newValueSuccess');
          Notification.success(message);
          key.IsChanged = false;
        }).catch(function(error){
          var message = $translate.instant('parametrization.notifications.newValueError');
          Notification.error(message);
          key.IsChanged = true;
        });
      }
    }

    function removeRow(key, index){
      if (key.Id) {
        excludedProductRest.remove(key).then(function(){
          vm.excludedProducts.splice(index, 1);
          var message = $translate.instant('common.notifications.deleteSuccess');
          Notification.success(message);
        }).catch(function(){
          var message = $translate.instant('common.notifications.deleteError');
          Notification.error(message);
        });
      } else {
        vm.excludedProducts.splice(index, 1);
      }
    }

    function onSelectPageCount() {
      loadExcludedProducts(vm.pagingData.pageSize, vm.pagingData.currentPage, true);
    }

    function pageChanged() {
      loadExcludedProducts(vm.pagingData.pageSize, vm.pagingData.currentPage, false);
    }

    function deleteDateOffsets(key){
      key.BeginDate = new Date(key.BeginDate);
      key.BeginDate.setHours(0, 0, 0, 0);
      key.EndDate = new Date(key.EndDate);
      key.EndDate.setHours(0, 0, 0, 0);
      var timezoneOffset = key.BeginDate.getTimezoneOffset();
      var time = undefined;
      if (key.BeginDate.getUTCDate() !== key.BeginDate.getDate()) {
        time = key.BeginDate.getTime();
        key.BeginDate = new Date(time - timezoneOffset * 60 * 1000);
      }
      if (key.EndDate.getUTCDate() !== key.EndDate.getDate()) {
        time = key.EndDate.getTime();
        key.EndDate = new Date(time - timezoneOffset * 60 * 1000);
      }
    }

  }
})();

(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ErrorController", ErrorController);

  ErrorController.$inject = ["$scope", "$log"];

  function ErrorController($scope, $log) {
    console.info("error page");
    var vm = this;
  }
})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('DocumentsHistoryController', DocumentsHistoryController);

  DocumentsHistoryController.$inject = ['$log', '$stateParams', '$translate', 'contractorRest', 'constRest', 'UsersService', '$sessionStorage', 'SessionService', 'documentRest', 'ContractorSelectService', 'storageRest'];

  function DocumentsHistoryController($log, $stateParams, $translate, contractorRest, constRest, UsersService, $sessionStorage, SessionService, documentRest, ContractorSelectService, storageRest) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadDocumentsData = loadDocumentsData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.loadUserDictionaryData = loadUserDictionaryData;
    vm.getUserSelectText = getUserSelectText;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.toggleBlockedFlag = toggleBlockedFlag;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.openDP = openDP;
    vm.selectContractor = selectContractor;
    vm.removeContractor = removeContractor;
    vm.changeSortByDate = changeSortByDate;
    vm.onDateChange = onDateChange;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.userDictName = "UsersDictionary";
    vm.maxCount = 20000;
    vm.beginDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: undefined
    }

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      payerId: undefined,
      userId: undefined,
      beginDate: Date.today().addMonths(-2).toString('yyyy-MM-dd'),
      endDate: Date.today().toString('yyyy-MM-dd'),
      typeId: undefined
    };

    vm.sums = {
      totalAmount: undefined
    };
    vm.dictionaryData = {};

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("documents.controller");
      //constructor body
      vm.setPageSize(10);


      loadDictionaryData("DocumentCategoryDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadDictionaryData("DocumentStatusDictionary");
      loadDictionaryData("PageSizeDictionary");

      loadUserDictionaryData();
      loadStoragesData();

      if ($sessionStorage.documentsPagingData != undefined)
        vm.pagingData = $sessionStorage.documentsPagingData;
      if ($stateParams.pagingData != undefined) {
        resetSearchTerms();
      }
      loadDataWithPagingData(true);
    }

    ///////////////// business logic

    function changeSortByDate() {
      vm.pagingData.sortByDate *= -1;
      onFilterChange();
    }

    function selectContractor() {
      var callback = function (obj) {
        vm.pagingData.contractor = obj;
        vm.pagingData.payerId = obj.Id;
        onFilterChange();
      };
      ContractorSelectService.show("lg", callback);
    }

    function removeContractor() {
      vm.pagingData.contractor = undefined;
      vm.pagingData.payerId = undefined;
      onFilterChange();
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.documentsPagingData = vm.pagingData;
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.documentsPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function getUserSelectText(selectObj) {
      var str;
      if (selectObj == undefined || selectObj == {} || selectObj == 0)
        return "";
      return selectObj.SurName + " " + selectObj.Name;
    }

    function toggleBlockedFlag(object) {
      var toggleAccept = function (object) {
        object.IsBlocked = !object.IsBlocked;
        object.save()
          .then(function (result) {

          })
          .catch(function (error) {

          });
      }

      ConfirmModalService.show('sm', {
        title: "confirmModal.warning",
        topBodyText: $translate.instant('confirmModal.bodyChangeStatus'),
        type: 1,
        okText: "confirmModal.ok",
        cancelText: "confirmModal.cancel"
      }, toggleAccept, object);
    }

    function resetSearchTerms() {
      vm.pagingData.payerId = undefined;
      vm.pagingData.userId = undefined;
      vm.pagingData.beginDate = Date.today().addMonths(-3).toString('yyyy-MM-dd');
      vm.pagingData.endDate = Date.today().toString('yyyy-MM-dd');
      vm.pagingData.typeId = undefined;
      onFilterChange();
    }

    function openDP($event, statusObj) {
      if (statusObj == 1)
        vm.datePickerBeginOpened = true;
      else
        vm.datePickerEndOpened = true;
    };

    function onDateChange(datepickerOptions, pagingDataField, isMin) {
      if (isMin) {
        datepickerOptions.minDate = new Date(pagingDataField);
      } else {
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      onFilterChange();
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }
    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadDocumentsData(
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.payerId,
        vm.pagingData.userId,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.typeId
      );
    }

    function loadDocumentsData(count, page, getCount, payerId, userId, beginDate, endDate, typeId) {
      vm.isDataReloading = true;
      documentRest.allViewHistory(page, count, getCount, payerId, userId, beginDate, endDate, typeId)
        .then(function (result) {
          vm.data = result;
          vm.isDataReloading = false;
          if (result.totalCount) {
            vm.setTotalCount(parseInt(result.totalCount, 10));
          }
          if (result.totalAmount) {
            vm.sums.totalAmount = parseFloat(result.totalAmount, 10);
          }
        })
        .catch(function (error) {
          $log.debug("Error while report data: " + vm.pagingData);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function loadUserDictionaryData() {
      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    ///////////////// FORMLY

  }
})
  ();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('DocumentsController', DocumentsController);

  DocumentsController.$inject = ['$log', '$stateParams', '$translate', 'contractorRest', 'constRest', 'UsersService', '$sessionStorage', 'SessionService', 'documentRest', 'ContractorSelectService', 'storageRest'];

  function DocumentsController($log, $stateParams, $translate, contractorRest, constRest, UsersService, $sessionStorage, SessionService, documentRest, ContractorSelectService, storageRest) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadDocumentsData = loadDocumentsData;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.loadUserDictionaryData = loadUserDictionaryData;
    vm.getUserSelectText = getUserSelectText;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.toggleBlockedFlag = toggleBlockedFlag;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.openDP = openDP;
    vm.selectContractor = selectContractor;
    vm.removeContractor = removeContractor;
    vm.changeSortByDate = changeSortByDate;
    vm.onDateChange = onDateChange;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.datePickerBeginOpened = false;
    vm.datePickerEndOpened = false;
    vm.userDictName = "UsersDictionary";
    vm.maxCount = 20000;
    vm.beginDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      maxDate: undefined
    };
    vm.endDateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      minDate: undefined
    }

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      firstId: undefined,
      categoryId: undefined,
      payerId: undefined,
      userId: undefined,
      beginDate: Date.today().addMonths(-2).toString('yyyy-MM-dd'),
      endDate: Date.today().toString('yyyy-MM-dd'),
      amountBegin: undefined,
      amountEnd: undefined,
      status: undefined,
      typeId: 2,
      isAcceptanceRequired: undefined,
      contractor: undefined,
      storageId: undefined,
      documentNumber: undefined,
      sortByDate: 1,
      isModified: false
    };
    vm.dictionaryData = {};

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("documents.controller");
      //constructor body
      vm.setPageSize(10);


      loadDictionaryData("DocumentCategoryDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadDictionaryData("DocumentStatusDictionary");
      loadDictionaryData("PageSizeDictionary");

      loadUserDictionaryData();
      loadStoragesData();

      if ($sessionStorage.documentsPagingData != undefined)
        vm.pagingData = $sessionStorage.documentsPagingData;
      if ($stateParams.pagingData != undefined) {
        resetSearchTerms();
        if ($stateParams.pagingData.isAcceptanceRequired !== undefined)
          vm.pagingData.isAcceptanceRequired = $stateParams.pagingData.isAcceptanceRequired;
      }
      loadDataWithPagingData(true);
    }

    ///////////////// business logic

    function changeSortByDate(){
      vm.pagingData.sortByDate *= -1;
      onFilterChange();
    }

    function selectContractor(){
      var callback = function(obj){
        vm.pagingData.contractor = obj;
        vm.pagingData.payerId = obj.Id;
        onFilterChange();
      };
      ContractorSelectService.show("lg", callback);
    }

    function removeContractor(){
      vm.pagingData.contractor = undefined;
      vm.pagingData.payerId = undefined;
      onFilterChange();
    }

    function getDictionaryElementByType(dictionaryName, localId){
      if(vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function(key){
        return key.LocalId === localId;
      });
    }

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
      $sessionStorage.documentsPagingData = vm.pagingData;
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      $sessionStorage.documentsPagingData = vm.pagingData;

      loadDataWithPagingData(true);
    }

    function getUserSelectText(selectObj) {
      var str;
      if (selectObj == undefined || selectObj == {} || selectObj == 0)
        return "";
      return selectObj.SurName + " " + selectObj.Name;
    }

    function toggleBlockedFlag(object) {
      var toggleAccept = function (object) {
        object.IsBlocked = !object.IsBlocked;
        object.save()
          .then(function (result) {

          })
          .catch(function (error) {

          });
      }

      ConfirmModalService.show('sm', {
        title: "confirmModal.warning",
        topBodyText: $translate.instant('confirmModal.bodyChangeStatus'),
        type: 1,
        okText: "confirmModal.ok",
        cancelText: "confirmModal.cancel"
      }, toggleAccept, object);
    }

    function resetSearchTerms() {
      vm.pagingData.categoryId = undefined;
      vm.pagingData.payerId = undefined;
      vm.pagingData.userId = undefined;
      vm.pagingData.beginDate = Date.today().addMonths(-2).toString('yyyy-MM-dd');
      vm.pagingData.endDate = Date.today().toString('yyyy-MM-dd');;
      vm.pagingData.status = undefined;
      vm.pagingData.typeId = 2;
      vm.pagingData.currentPage = 1;
      vm.pagingData.isAcceptanceRequired = undefined;
      vm.pagingData.firstId = undefined;
      vm.pagingData.amountBegin = undefined;
      vm.pagingData.amountEnd = undefined;
      vm.pagingData.contractor = undefined;
      vm.pagingData.payerId = undefined;
      vm.pagingData.storageId = undefined;
      vm.pagingData.documentNumber = undefined;
      vm.pagingData.sortByDate = 1;
      vm.pagingData.isModified = false;

      vm.beginDateOptions.maxDate = undefined;
      vm.endDateOptions.minDate = undefined;
    

      onFilterChange();
    }

    function openDP($event, statusObj) {
      if(statusObj ==1)
        vm.datePickerBeginOpened = true;
      else
        vm.datePickerEndOpened = true;
    };

    function onDateChange(datepickerOptions, pagingDataField, isMin){
      if(isMin){
        datepickerOptions.minDate = new Date(pagingDataField);
      }else{
        datepickerOptions.maxDate = new Date(pagingDataField);
      }
      onFilterChange();
    }

    ///////////////// watchers

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }
    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadDocumentsData(
        vm.pagingData.documentNumber,
        vm.pagingData.storageId,
        vm.pagingData.categoryId,
        vm.pagingData.payerId,
        vm.pagingData.userId,
        vm.pagingData.beginDate,
        vm.pagingData.endDate,
        vm.pagingData.status,
        vm.pagingData.typeId,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.isAcceptanceRequired,
        vm.pagingData.amountBegin,
        vm.pagingData.amountEnd,
        vm.pagingData.sortByDate,
        vm.pagingData.isModified
      );
    }

    function loadDocumentsData(documentNumber, storageId,categoryId, payerId, userId, beginDate, endDate, status, typeId, count, page, getCount, isAcceptanceRequired, amountBegin, amountEnd, sortByDate, isModified) {
      vm.isDataReloading = true;
        documentRest.allView(documentNumber, storageId,categoryId, payerId, userId, beginDate, endDate, status, typeId, page, count, getCount, isAcceptanceRequired, amountBegin, amountEnd, sortByDate, undefined, undefined, isModified)
          .then(function (result) {
            vm.data = result;
            vm.isDataReloading = false;
            if (result.totalCount) {
              vm.setTotalCount(parseInt(result.totalCount, 10));
            }
          })
          .catch(function (error) {
            $log.debug("Error while contractors date: " + vm.pagingData);
            vm.isDataReloading = false;
            vm.error = error;
          });
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function loadUserDictionaryData() {
      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {
            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
    }

    ///////////////// FORMLY

  }
})
();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('documentHistoryService', documentHistoryService);

  documentHistoryService.$inject = ['$log', '$uibModal', '$state', '$q'];

  function documentHistoryService($log, $uibModal, $state, $q) {

    var service = {
      show: showModal
    };

    return service;

    var data = undefined;

    function showModal(size, data) {
      data = data;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/documents/document.history.service.html',
        controller: 'documentHistoryController',
        controllerAs: 'vm',
        size: size,
        resolve: {
          data: function () {
            return data;
          }
        }
      });

    }

  }

angular
  .module('smakmak.controllers')
  .controller('documentHistoryController', documentHistoryController);

/** @ngInject */
function documentHistoryController($scope, $uibModalInstance, data) {
    var vm = this;
    vm.data = data;
    vm.action = action;
    function action(result){
      $uibModalInstance.close(result);
    }
 }

})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('DocumentHistoryController', DocumentHistoryController);

  DocumentHistoryController.$inject = ['$log', '$stateParams', '$state', '$translate', 'constRest', '$sessionStorage', 'SessionService', 'documentRest', 'storageRest', 'Lightbox', '$timeout', 'Notification', 'UploadService', 'uploadRest', 'documentHistoryService'];

  function DocumentHistoryController($log, $stateParams, $state, $translate, constRest, $sessionStorage, SessionService, documentRest, storageRest, Lightbox, $timeout, Notification, UploadService, uploadRest, documentHistoryService) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadDocumentData = loadDocumentData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.toggleBlockedFlag = toggleBlockedFlag;
    vm.checkPermission = checkPermission;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.getStrorageById = getStrorageById;
    vm.formatDate = formatDate;
    vm.goBack = goBack;
    vm.showImagesGallery = showImagesGallery;
    vm.goToDocument = goToDocument;
    vm.sendAgainToAccountingSystem = sendAgainToAccountingSystem;
    vm.printDocument = printDocument;
    //photos
    vm.uploadAttachment = uploadAttachment;
    vm.removeImg = removeImg;
    vm.openLightboxModal = openLightboxModal;
    vm.searchIndexesOfPhoto = searchIndexesOfPhoto;
    vm.removePhotoFromView = removePhotoFromView;
    //samples
    vm.canBeSendToClient = canBeSendToClient;
    vm.sendToClient = sendToClient;
    vm.sendForAcceptance = sendForAcceptance;

    vm.acceptEntityPrice = acceptEntityPrice;
    vm.rejectEntityPrice = rejectEntityPrice;
    vm.sendForAcceptance = sendForAcceptance;
    vm.priceImputChange = priceImputChange;
    vm.goToPromotion = goToPromotion;
    vm.comment = comment;
    vm.saveStorageChanges = saveStorageChanges;
    vm.showHistory = showHistory;

    ///////////////// data def
    vm.cameFrom = undefined;
    vm.previousPageId = undefined;
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.dictionaryData = {};

    //datePicker
    vm.openDP = openDP;
    vm.datePickerReleaseOpened = false;
    vm.datePickerFinishOpened = false;
    vm.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("document.controller");
      //constructor body
      $.Velocity(angular.element('#loader'), { scale: 1.3, opacity: 1.0 }, { duration: 1300, loop: true });

      loadDictionaryData("DocumentCategoryDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadDictionaryData("PriceLevel");
      loadDictionaryData("DocumentStatusDictionary");
      loadDictionaryData("VATDictionary");
      loadDictionaryData("CountryDictionary");
      loadDictionaryData("ProvinceDictionary");
      loadDictionaryData("PaymentTypesDictionary");
      loadStoragesData();
      loadDocumentData($stateParams.id, true, true, true, false, true, true, true);
      vm.cameFrom = $stateParams.cameFrom;
      vm.previousPageId = $stateParams.previousPageId;
    }


    ///////////////// business logic

    vm.goingTo = false;
    function goToDocument(id) {
      if (vm.goingTo == true)
        return;
      vm.goingTo = true;

      $.Velocity(angular.element('#doc-common-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-payer-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-related-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-recipient-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-entities-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-photos'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-print-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-back-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-send-again-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-send-to-client-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-accept_positions-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-note'), { opacity: 0.0 }, { duration: 200 });

      $timeout(function () {
        $state.go("home.documents.document", { id: id });
      }, 200);


    }

    function toggleBlockedFlag(object) {
      var toggleAccept = function (object) {
        object.IsBlocked = !object.IsBlocked;
        object.save()
          .then(function (result) {

          })
          .catch(function (error) {

          });
      };

      ConfirmModalService.show('sm', {
        title: "confirmModal.warning",
        topBodyText: $translate.instant('confirmModal.bodyChangeStatus'),
        type: 1,
        okText: "confirmModal.ok",
        cancelText: "confirmModal.cancel"
      }, toggleAccept, object);
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (vm.dictionaryData[dictionaryName] == undefined || localId == undefined)
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function formatDate(date) {

    }

    function getStrorageById(id) {
      if (vm.dictionaryData["Storages"] == undefined || id == undefined)
        return;
      return vm.dictionaryData["Storages"].find(function (key) {
        return key.Id === id;
      });
    }


    ///////////////// watchers

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function rejectEntity(de) {
      de.AcceptRecord = { Send: true, DocumentId: vm.data.Id, DocumentEntityId: de.Id, Action: 2 };
    }

    function acceptEntity(de) {
      de.AcceptRecord = { Send: true, DocumentId: vm.data.Id, DocumentEntityId: de.Id, Action: 1 };
    }

    function updatePriceEntity(de, price) {
      de.AcceptRecord = { Send: true, DocumentId: vm.data.Id, DocumentEntityId: de.Id, Action: 3, NewPrice: price };
    }

    function loadDocumentData(id, getAddresses, getContractors, getEntities, getCorrectedEntities, getRelatedProducts, getRelatedUser, getRelatedDocuments) {
      vm.isDataReloading = true;
      documentRest.getHistory(id, getAddresses, getContractors, getEntities, getCorrectedEntities, getRelatedProducts, getRelatedUser, getRelatedDocuments)
        .then(function (result) {

          $.Velocity(angular.element('#doc-common-data'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-payer-data'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-related-data'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-recipient-data'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-entities-data'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-print-button'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-back-button'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-send-again-button'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-send-to-client-button'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-photos'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-accept_positions-button'), { opacity: 1.0 }, { duration: 500 });
          $.Velocity(angular.element('#doc-note'), { opacity: 1.0 }, { duration: 500 });
          angular.element('#loader').velocity("stop").velocity({ opacity: 0.0 }, { duration: 500 });
          //$.Velocity(angular.element('#loader') , {, opacity: 0.0}, {duration: 1300,loop:true});
          vm.data = result;
          vm.data.FilesIds = [];
          vm.isDataReloading = false;
          vm.data.DocumentEntities = vm.data.HistoricalDocumentEntities;
          for (var i = 0; i < vm.data.DocumentEntities.length; i++) {
            vm.data.DocumentEntities[i].isCollapsed = true;
            if (vm.data.DocumentEntities[i].AcceptanceReason > 0) {
              vm.data.DocumentEntities[i].AcceptRecord = { Send: false };
              vm.data.DocumentEntities[i].newEEPrice = vm.data.DocumentEntities[i].AmountProductNet;
            }


            /*<span class="glyphicon glyphicon-exclamation-sign pull-right text-danger" popover-trigger="mouseenter"
             popover-append-to-body="true"
             uib-popover="Pozycje wymagają akceptacji z powodu zmiany ceny"
             style="font-size: 1.3em;"></span>*/
          }
          vm.data.AmountGrossView = Math.abs(vm.data.AmountGross);
          if (vm.data.RelatedDocuments != null) {
            vm.data.RelatedDocuments.sort(function (a, b) {
              if (a.Id < b.Id)
                return -1;
              else
                return 1;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting document");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function showImagesGallery(docEntity) {
      Lightbox.openModal(docEntity.Files, 0);
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadStoragesData() {
      storageRest.all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function sendAgainToAccountingSystem() {
      if(vm.data.documentLock){
        return;
      }
      vm.data.documentLock = true;
      documentRest.sendAgainToAccountingSystem(vm.data.Id)
        .then(function () {
          var message = $translate.instant('documents.notifications.sendAgain');
          Notification.success(message);
          goBack();
        })
        .catch(function (error) {
          var message = $translate.instant('documents.notifications.sendAgainError');
          Notification.error(message);
          $log.debug("Error while getting sotrages ");
        }).finally(function(){
          vm.data.documentLock = false;
        });
    }

    function showHistory(){
      if(vm.data.documentLock){
        return;
      }
      vm.data.documentLock = true;
      documentRest.history(vm.data.SubiektId)
        .then(function (res) {
          if(res === undefined){
            var message = "Brak wystarczającej ilości rekordów o zmianach. Wyślij do administratora informację o tym błędzie z numerem dokumentu";
          Notification.error(message);
          } else {
          documentHistoryService.show('lg', res);
          }
        })
        .catch(function (error) {
          var message = "Błąd podczas pobierania hisotrii dokumentu";
          Notification.error(message);
          $log.debug("Error while getting document history ");
        }).finally(function(){
          vm.data.documentLock = false;
        });
    }

    //goes back to previous state
    function goBack() {
      if (vm.previousPageId === undefined)
        $state.go("home." + vm.cameFrom);
      else {
        $state.go("home." + vm.cameFrom, { id: vm.previousPageId });
      }
    }

    //uploads pdf or image
    function uploadAttachment() {

      var callback = function (data) {
        console.log(data);
        vm.data.Files.push(data);
        vm.data.FilesIds.push(data.Id);
      };

      UploadService.show("sm", callback, undefined, vm.data.Id, 3, '\'image/*\'');
    }

    function removeImg(image) {
      var indexes = vm.searchIndexesOfPhoto(image);
      uploadRest.remove(image.Id).then(function () {
        vm.removePhotoFromView(indexes);
      });
    }

    //searches indexes in files and filesids arrays of photo to delete
    function searchIndexesOfPhoto(image) {
      //files
      var idx = [-1, -1];

      for (var i = 0; i < vm.data.Files.length; i++)
        if (vm.data.Files[i].Id == image.Id) {
          idx[0] = i;
          break;
        }
      //files ids
      for (var i = 0; i < vm.data.FilesIds.length; i++)
        if (vm.data.FilesIds[i] == image.Id) {
          idx[1] = i;
          break;
        }
      return idx;
    }

    //removes photos from View after removing in backend, based on previous found indexes [0] - files index, [1] - filesIds index
    function removePhotoFromView(indexes) {
      if (indexes[0] > -1) {
        vm.data.Files.splice(indexes[0], 1);
      }
      if (indexes[1] > -1) {
        vm.data.Files.splice(indexes[1], 1);
      }
    }

    //opens bigger image of image in gallery
    function openLightboxModal(index) {
      Lightbox.openModal(vm.data.Files, index);
    };

    function sendToClient() {
      // documentRest.sendToClient(vm.data.Id).then(function () {
        documentRest.changeStatus(vm.data.Id, 23).then(function () {
        var message = $translate.instant('documents.notifications.sendToClient');
        Notification.success(message);
        goBack();
      }).catch(function () {
        var message = $translate.instant('documents.notifications.sendError');
        Notification.error(message);
      });
    };

    //determines if sendToClient button should be visible (not sent samples document)
    function canBeSendToClient() {
      if ((vm.data !== undefined) && ((vm.data.TypeId == 1002) || (vm.data.TypeId == 1003)) && (vm.data.ObjectStatus == 11)) {
        return true;
      } else {
        return false;
      }
    };

    function printDocument() {
      window.print();
    }

    function openDP($event, statusObj) {
      if (statusObj == 1)
        vm.datePickerReleaseOpened = true;
      else
        vm.datePickerFinishOpened = true;
    };

    function saveStorageChanges() {
      formatDates();

      $.Velocity(angular.element('#loader'), { scale: 1.3, opacity: 1.0 }, { duration: 1300, loop: true });
      $.Velocity(angular.element('#doc-common-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-payer-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-related-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-recipient-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-entities-data'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-photos'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-print-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-back-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-send-again-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-send-to-client-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-accept_positions-button'), { opacity: 0.0 }, { duration: 200 });
      $.Velocity(angular.element('#doc-note'), { opacity: 0.0 }, { duration: 200 });

      documentRest.logisticsAcceptance(vm.data.Id, vm.data.DocumentReleaseDate, vm.data.FinishDate, vm.data.Storage).then(function () {
        var message = $translate.instant('visits.notifications.changeSuccess');
        Notification.success(message);
        loadDocumentData($stateParams.id, true, true, true, false, true, true, true);
      }).catch(function () {
        var message = $translate.instant('visits.notifications.changeError');
        Notification.error(message);
      });
    }

    function formatDates() {
      if (vm.data.DocumentReleaseDate != null) {
        var release = new Date(vm.data.DocumentReleaseDate);
        release.setHours(0, 0, 0, 0);
        if (release.getUTCDate() !== release.getDate()) {
          var timezoneOffset = release.getTimezoneOffset(), time = release.getTime();
          release = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.data.DocumentReleaseDate = release;
      }
      if (vm.data.FinishDate != null) {
        var finish = new Date(vm.data.FinishDate);
        finish.setHours(0, 0, 0, 0);
        if (finish.getUTCDate() !== finish.getDate()) {
          var timezoneOffset = finish.getTimezoneOffset(), time = finish.getTime();
          finish = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.data.FinishDate = finish;
      }
    }

    function comment(id, comment) {
      documentRest.comment(id, { Comment: comment })
        .then(function (ret) {
          Notification.success("Komentarz został zapisany");
        })
      then(function (visit) {
        Notification.error("Nie udało się zapisać komentarza");
      });
    }

    function goToPromotion(key) {
      $state.go("home.promotions.promotion", { id: key.PromotionId });
    }

    function acceptEntityPrice(docEntity) {
      docEntity.AcceptRecord = { Send: true, DocumentId: vm.data.Id, DocumentEntityId: docEntity.Id, Action: 1 };
    }

    function rejectEntityPrice(docEntity) {
      docEntity.AcceptRecord = { Send: true, DocumentId: vm.data.Id, DocumentEntityId: docEntity.Id, Action: 2 };
    }

    function priceImputChange(docEntity) {
      docEntity.AcceptRecord = { Send: true, DocumentId: vm.data.Id, DocumentEntityId: docEntity.Id, Action: 3, NewPrice: docEntity.newEEPrice };
    }

    function sendForAcceptance() {
      var toAccept = [];
      _.forEach(vm.data.DocumentEntities, function (de) {
        if (de.AcceptRecord != undefined) {
          if (de.AcceptRecord.Send == true) {
            delete de.AcceptRecord.Send;
            toAccept.push(de.AcceptRecord);
          }
        }
      });
      documentRest.acceptEntitiesOrDocument(toAccept)
        .then(function (response) {
          var message = "Pozycje na dokumencie zostały zaakceptowane";
          Notification.success(message);
          goBack();
        })
        .catch(function (error) {
          var message = "Bład podczas akceptacji pozycji";
          Notification.error(message);

        });
    }
    ///////////////// FORMLY

  }
})
  ();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("DocumentController", DocumentController);

  DocumentController.$inject = [
    "$log",
    "$stateParams",
    "$state",
    "$translate",
    "constRest",
    "$sessionStorage",
    "SessionService",
    "documentRest",
    "storageRest",
    "Lightbox",
    "$timeout",
    "Notification",
    "UploadService",
    "uploadRest",
    "documentHistoryService",
  ];

  function DocumentController(
    $log,
    $stateParams,
    $state,
    $translate,
    constRest,
    $sessionStorage,
    SessionService,
    documentRest,
    storageRest,
    Lightbox,
    $timeout,
    Notification,
    UploadService,
    uploadRest,
    documentHistoryService
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadDocumentData = loadDocumentData;
    vm.loadDictionaryData = loadDictionaryData;
    vm.toggleBlockedFlag = toggleBlockedFlag;
    vm.checkPermission = checkPermission;
    vm.getDictionaryElementByType = getDictionaryElementByType;
    vm.getStrorageById = getStrorageById;
    vm.formatDate = formatDate;
    vm.goBack = goBack;
    vm.showImagesGallery = showImagesGallery;
    vm.goToDocument = goToDocument;
    vm.sendAgainToAccountingSystem = sendAgainToAccountingSystem;
    vm.printDocument = printDocument;
    //photos
    vm.uploadAttachment = uploadAttachment;
    vm.uploadEntityAttachment = uploadEntityAttachment;
    vm.removeImg = removeImg;
    vm.openLightboxModal = openLightboxModal;
    vm.searchIndexesOfPhoto = searchIndexesOfPhoto;
    vm.removePhotoFromView = removePhotoFromView;
    //samples
    vm.canBeSendToClient = canBeSendToClient;
    vm.sendToClient = sendToClient;
    vm.sendForAcceptance = sendForAcceptance;

    vm.acceptEntityPrice = acceptEntityPrice;
    vm.rejectEntityPrice = rejectEntityPrice;
    vm.sendForAcceptance = sendForAcceptance;
    vm.priceImputChange = priceImputChange;
    vm.goToPromotion = goToPromotion;
    vm.comment = comment;
    vm.saveStorageChanges = saveStorageChanges;
    vm.showHistory = showHistory;

    ///////////////// data def
    vm.cameFrom = undefined;
    vm.previousPageId = undefined;
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.dictionaryData = {};

    //datePicker
    vm.openDP = openDP;
    vm.datePickerReleaseOpened = false;
    vm.datePickerFinishOpened = false;
    vm.dateOptions = {
      formatYear: "yy",
      startingDay: 1,
    };

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("document.controller");
      //constructor body
      $.Velocity(
        angular.element("#loader"),
        { scale: 1.3, opacity: 1.0 },
        { duration: 1300, loop: true }
      );

      loadDictionaryData("DocumentCategoryDictionary");
      loadDictionaryData("DocumentTypeDictionary");
      loadDictionaryData("PriceLevel");
      loadDictionaryData("DocumentStatusDictionary");
      loadDictionaryData("VATDictionary");
      loadDictionaryData("CountryDictionary");
      loadDictionaryData("ProvinceDictionary");
      loadDictionaryData("PaymentTypesDictionary");
      loadStoragesData();
      loadDocumentData(
        $stateParams.id,
        true,
        true,
        true,
        false,
        true,
        true,
        true
      );
      vm.cameFrom = $stateParams.cameFrom;
      vm.previousPageId = $stateParams.previousPageId;
    }

    ///////////////// business logic

    vm.goingTo = false;
    function goToDocument(id) {
      if (vm.goingTo == true) return;
      vm.goingTo = true;

      $.Velocity(
        angular.element("#doc-common-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-payer-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-related-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-recipient-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-entities-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-photos"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-print-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-back-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-send-again-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-send-to-client-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-accept_positions-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-note"),
        { opacity: 0.0 },
        { duration: 200 }
      );

      $timeout(function () {
        $state.go("home.documents.document", { id: id });
      }, 200);
    }

    function toggleBlockedFlag(object) {
      var toggleAccept = function (object) {
        object.IsBlocked = !object.IsBlocked;
        object
          .save()
          .then(function (result) {})
          .catch(function (error) {});
      };

      ConfirmModalService.show(
        "sm",
        {
          title: "confirmModal.warning",
          topBodyText: $translate.instant("confirmModal.bodyChangeStatus"),
          type: 1,
          okText: "confirmModal.ok",
          cancelText: "confirmModal.cancel",
        },
        toggleAccept,
        object
      );
    }

    function getDictionaryElementByType(dictionaryName, localId) {
      if (
        vm.dictionaryData[dictionaryName] == undefined ||
        localId == undefined
      )
        return;
      return vm.dictionaryData[dictionaryName].find(function (key) {
        return key.LocalId === localId;
      });
    }

    function formatDate(date) {}

    function getStrorageById(id) {
      if (vm.dictionaryData["Storages"] == undefined || id == undefined) return;
      return vm.dictionaryData["Storages"].find(function (key) {
        return key.Id === id;
      });
    }

    ///////////////// watchers

    ///////////////// check state functions

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    function rejectEntity(de) {
      de.AcceptRecord = {
        Send: true,
        DocumentId: vm.data.Id,
        DocumentEntityId: de.Id,
        Action: 2,
      };
    }

    function acceptEntity(de) {
      de.AcceptRecord = {
        Send: true,
        DocumentId: vm.data.Id,
        DocumentEntityId: de.Id,
        Action: 1,
      };
    }

    function updatePriceEntity(de, price) {
      de.AcceptRecord = {
        Send: true,
        DocumentId: vm.data.Id,
        DocumentEntityId: de.Id,
        Action: 3,
        NewPrice: price,
      };
    }

    function loadDocumentData(
      id,
      getAddresses,
      getContractors,
      getEntities,
      getCorrectedEntities,
      getRelatedProducts,
      getRelatedUser,
      getRelatedDocuments
    ) {
      vm.isDataReloading = true;
      documentRest
        .get(
          id,
          getAddresses,
          getContractors,
          getEntities,
          getCorrectedEntities,
          getRelatedProducts,
          getRelatedUser,
          getRelatedDocuments
        )
        .then(function (result) {
          $.Velocity(
            angular.element("#doc-common-data"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-payer-data"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-related-data"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-recipient-data"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-entities-data"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-print-button"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-back-button"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-send-again-button"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-send-to-client-button"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-photos"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-accept_positions-button"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          $.Velocity(
            angular.element("#doc-note"),
            { opacity: 1.0 },
            { duration: 500 }
          );
          angular
            .element("#loader")
            .velocity("stop")
            .velocity({ opacity: 0.0 }, { duration: 500 });
          //$.Velocity(angular.element('#loader') , {, opacity: 0.0}, {duration: 1300,loop:true});
          vm.data = result;
          vm.data.FilesIds = [];
          vm.isDataReloading = false;
          for (var i = 0; i < vm.data.DocumentEntities.length; i++) {
            vm.data.DocumentEntities[i].isCollapsed = true;
            if (vm.data.DocumentEntities[i].AcceptanceReason > 0) {
              vm.data.DocumentEntities[i].AcceptRecord = { Send: false };
              vm.data.DocumentEntities[i].newEEPrice =
                vm.data.DocumentEntities[i].AmountProductNet;
            }
            if (!vm.data.DocumentEntities.FilesIds)
              vm.data.DocumentEntities.FilesIds = [];
            /*<span class="glyphicon glyphicon-exclamation-sign pull-right text-danger" popover-trigger="mouseenter"
             popover-append-to-body="true"
             uib-popover="Pozycje wymagają akceptacji z powodu zmiany ceny"
             style="font-size: 1.3em;"></span>*/
          }
          vm.data.AmountGrossView = Math.abs(vm.data.AmountGross);
          if (vm.data.RelatedDocuments != null) {
            vm.data.RelatedDocuments.sort(function (a, b) {
              if (a.Id < b.Id) return -1;
              else return 1;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting document");
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function showImagesGallery(docEntity) {
      Lightbox.openModal(docEntity.Files, 0);
    }

    function loadDictionaryData(name) {
      constRest
        .getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (
            name === "ContractorFeature" ||
            name === "ContractorGroupDictionary"
          ) {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined) return -1;
              if (b.Value == undefined) return 1;
              if (a.Value < b.Value) return -1;
              else if (a.Value > b.Value) return 1;
              else return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadStoragesData() {
      storageRest
        .all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function sendAgainToAccountingSystem() {
      if (vm.data.documentLock) {
        return;
      }
      vm.data.documentLock = true;
      documentRest
        .sendAgainToAccountingSystem(vm.data.Id)
        .then(function () {
          var message = $translate.instant("documents.notifications.sendAgain");
          Notification.success(message);
          goBack();
        })
        .catch(function (error) {
          var message = $translate.instant(
            "documents.notifications.sendAgainError"
          );
          Notification.error(message);
          $log.debug("Error while getting sotrages ");
        })
        .finally(function () {
          vm.data.documentLock = false;
        });
    }

    function showHistory() {
      if (vm.data.documentLock) {
        return;
      }
      vm.data.documentLock = true;
      documentRest
        .history(vm.data.SubiektId)
        .then(function (res) {
          if (res === undefined) {
            var message =
              "Brak wystarczającej ilości rekordów o zmianach. Wyślij do administratora informację o tym błędzie z numerem dokumentu";
            Notification.error(message);
          } else {
            documentHistoryService.show("lg", res);
          }
        })
        .catch(function (error) {
          var message = "Błąd podczas pobierania hisotrii dokumentu";
          Notification.error(message);
          $log.debug("Error while getting document history ");
        })
        .finally(function () {
          vm.data.documentLock = false;
        });
    }

    //goes back to previous state
    function goBack() {
      if (vm.previousPageId === undefined) $state.go("home." + vm.cameFrom);
      else {
        $state.go("home." + vm.cameFrom, { id: vm.previousPageId });
      }
    }

    //uploads pdf or image
    function uploadAttachment() {
      var callback = function (data) {
        console.log(data);
        vm.data.Files.push(data);
        vm.data.FilesIds.push(data.Id);
      };

      UploadService.show("sm", callback, undefined, vm.data.Id, 3, "'image/*'");
    }

    function uploadEntityAttachment(documentEntity) {
      var callback = function (data) {
        console.log(data);
        documentEntity.Files.push(data);
        documentEntity.FilesIds.push(data.Id);
      };

      UploadService.show(
        "sm",
        callback,
        undefined,
        documentEntity.Id,
        5,
        "'image/*'"
      );
    }

    function removeImg(image) {
      var indexes = vm.searchIndexesOfPhoto(image);
      uploadRest.remove(image.Id).then(function () {
        vm.removePhotoFromView(indexes);
      });
    }

    //searches indexes in files and filesids arrays of photo to delete
    function searchIndexesOfPhoto(image) {
      //files
      var idx = [-1, -1];

      for (var i = 0; i < vm.data.Files.length; i++)
        if (vm.data.Files[i].Id == image.Id) {
          idx[0] = i;
          break;
        }
      //files ids
      for (var i = 0; i < vm.data.FilesIds.length; i++)
        if (vm.data.FilesIds[i] == image.Id) {
          idx[1] = i;
          break;
        }
      return idx;
    }

    //removes photos from View after removing in backend, based on previous found indexes [0] - files index, [1] - filesIds index
    function removePhotoFromView(indexes) {
      if (indexes[0] > -1) {
        vm.data.Files.splice(indexes[0], 1);
      }
      if (indexes[1] > -1) {
        vm.data.Files.splice(indexes[1], 1);
      }
    }

    //opens bigger image of image in gallery
    function openLightboxModal(index) {
      Lightbox.openModal(vm.data.Files, index);
    }

    function sendToClient() {
      // documentRest.sendToClient(vm.data.Id).then(function () {
      documentRest
        .changeStatus(vm.data.Id, 23)
        .then(function () {
          var message = $translate.instant(
            "documents.notifications.sendToClient"
          );
          Notification.success(message);
          goBack();
        })
        .catch(function () {
          var message = $translate.instant("documents.notifications.sendError");
          Notification.error(message);
        });
    }

    //determines if sendToClient button should be visible (not sent samples document)
    function canBeSendToClient() {
      if (
        vm.data !== undefined &&
        (vm.data.TypeId == 1002 || vm.data.TypeId == 1003) &&
        vm.data.ObjectStatus == 11
      ) {
        return true;
      } else {
        return false;
      }
    }

    function printDocument() {
      window.print();
    }

    function openDP($event, statusObj) {
      if (statusObj == 1) vm.datePickerReleaseOpened = true;
      else vm.datePickerFinishOpened = true;
    }

    function saveStorageChanges() {
      formatDates();

      $.Velocity(
        angular.element("#loader"),
        { scale: 1.3, opacity: 1.0 },
        { duration: 1300, loop: true }
      );
      $.Velocity(
        angular.element("#doc-common-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-payer-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-related-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-recipient-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-entities-data"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-photos"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-print-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-back-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-send-again-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-send-to-client-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-accept_positions-button"),
        { opacity: 0.0 },
        { duration: 200 }
      );
      $.Velocity(
        angular.element("#doc-note"),
        { opacity: 0.0 },
        { duration: 200 }
      );

      documentRest
        .logisticsAcceptance(
          vm.data.Id,
          vm.data.DocumentReleaseDate,
          vm.data.FinishDate,
          vm.data.Storage
        )
        .then(function () {
          var message = $translate.instant(
            "visits.notifications.changeSuccess"
          );
          Notification.success(message);
          loadDocumentData(
            $stateParams.id,
            true,
            true,
            true,
            false,
            true,
            true,
            true
          );
        })
        .catch(function () {
          var message = $translate.instant("visits.notifications.changeError");
          Notification.error(message);
        });
    }

    function formatDates() {
      if (vm.data.DocumentReleaseDate != null) {
        var release = new Date(vm.data.DocumentReleaseDate);
        release.setHours(0, 0, 0, 0);
        if (release.getUTCDate() !== release.getDate()) {
          var timezoneOffset = release.getTimezoneOffset(),
            time = release.getTime();
          release = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.data.DocumentReleaseDate = release;
      }
      if (vm.data.FinishDate != null) {
        var finish = new Date(vm.data.FinishDate);
        finish.setHours(0, 0, 0, 0);
        if (finish.getUTCDate() !== finish.getDate()) {
          var timezoneOffset = finish.getTimezoneOffset(),
            time = finish.getTime();
          finish = new Date(time - timezoneOffset * 60 * 1000);
        }
        vm.data.FinishDate = finish;
      }
    }

    function comment(id, comment) {
      documentRest.comment(id, { Comment: comment }).then(function (ret) {
        Notification.success("Komentarz został zapisany");
      });
      then(function (visit) {
        Notification.error("Nie udało się zapisać komentarza");
      });
    }

    function goToPromotion(key) {
      $state.go("home.promotions.promotion", { id: key.PromotionId });
    }

    function acceptEntityPrice(docEntity) {
      docEntity.AcceptRecord = {
        Send: true,
        DocumentId: vm.data.Id,
        DocumentEntityId: docEntity.Id,
        Action: 1,
      };
    }

    function rejectEntityPrice(docEntity) {
      docEntity.AcceptRecord = {
        Send: true,
        DocumentId: vm.data.Id,
        DocumentEntityId: docEntity.Id,
        Action: 2,
      };
    }

    function priceImputChange(docEntity) {
      docEntity.AcceptRecord = {
        Send: true,
        DocumentId: vm.data.Id,
        DocumentEntityId: docEntity.Id,
        Action: 3,
        NewPrice: docEntity.newEEPrice,
      };
    }

    function sendForAcceptance() {
      var toAccept = [];
      _.forEach(vm.data.DocumentEntities, function (de) {
        if (de.AcceptRecord != undefined) {
          if (de.AcceptRecord.Send == true) {
            delete de.AcceptRecord.Send;
            toAccept.push(de.AcceptRecord);
          }
        }
      });
      documentRest
        .acceptEntitiesOrDocument(toAccept)
        .then(function (response) {
          var message = "Pozycje na dokumencie zostały zaakceptowane";
          Notification.success(message);
          goBack();
        })
        .catch(function (error) {
          var message = "Bład podczas akceptacji pozycji";
          Notification.error(message);
        });
    }
    ///////////////// FORMLY
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.common.services').factory('customParameterRest', customParameterRest);

  customParameterRest.$inject = ['$q', '$log', 'Restangular'];

  function customParameterRest($q, $log, Restangular) {
    return {
      add: add,
      update: update,
      remove: remove,
      removeByProductAndContractor: removeByProductAndContractor
    };

    function add(parameter){
      return Restangular.all('customParameters').post(parameter);
    }

    function update(parameter){
      return Restangular.one('customParameters', parameter.Id).customPUT(parameter);
    }

    function remove(parameter){
      return Restangular.one('customParameters', parameter.Id).remove();
    }

    function removeByProductAndContractor(productId, contractorId){
      var params = {};
      angular.extend(params, {productId: productId});
      angular.extend(params, {contractorId: contractorId});
      return Restangular.one('CustomParameters').customDELETE('products', params);
    }

  }
})();

(function() {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("CountersController", CountersController);

  CountersController.$inject = [
    "$log",
    "$stateParams",
    "$state",
    "$translate",
    "SessionService",
    "counterRest",
    "Notification",
    "PeriodPickerService",
    "$sessionStorage"
  ];

  function CountersController(
    $log,
    $stateParams,
    $state,
    $translate,
    SessionService,
    counterRest,
    Notification,
    PeriodPickerService,
    $sessionStorage
  ) {
    /* jshint validthis: true */
    var vm = this;
    //functions
    vm.onSelect = onSelect;
    vm.submit = submit;
    vm.goToUser = goToUser;
    vm.splitToAll = splitToAll;
    vm.addPeriod = addPeriod;
    vm.onPeriodSelect = onPeriodSelect;
    vm.checkPermission = checkPermission;
    vm.editPeriod = editPeriod;
    vm.selectedMonth = undefined;
    vm.selectedPeriod = undefined;
    vm.selectedPeriodObject = undefined;
    vm.UserId = undefined;
    vm.counters = undefined;
    vm.periods = undefined;
    vm.isDataReloading = true;
    vm.isSaving = false;
    vm.showEdit = false;

    init();

    function init() {
      console.info("counters.init");
      vm.counters = undefined;
      vm.periods = undefined;
      vm.selectedPeriod = $sessionStorage.counterPeriodId;
      vm.selectedPeriodObject = $sessionStorage.selectedPeriodObject;

      if ($stateParams.id == 0) {
        vm.showEdit = true;
        var userObj = SessionService.getAuthenticatedUser();
        vm.UserId = userObj.Id;
      } else {
        vm.UserId = $stateParams.id;
      }
      getPeriods();
    }

    function getPeriods() {
      vm.isDataReloading = true;
      counterRest
        .getPeriods()
        .then(function(periods) {
          vm.periods = periods;
          vm.isDataReloading = false;
          if (vm.selectedPeriod) {
            onPeriodSelect({}, vm.selectedPeriod);
          }
        })
        .catch(function(error) {
          var message = $translate.instant("counters.notifications.loadError");
          Notification.error(message);
          vm.isDataReloading = false;
        });
    }

    function onPeriodSelect(item, model) {
      if (model) {
        $sessionStorage.counterPeriodId = model;
        vm.selectedPeriod = model;

        if (item.Id) {
          //workaround for reloads
          $sessionStorage.selectedPeriodObject = item;
          vm.selectedPeriodObject = item;
        }
        getCounters(vm.UserId, model);
      }
    }

    function getCounters(userId, parentId) {
      vm.isDataReloading = true;
      counterRest
        .get(userId, parentId)
        .then(function(counters) {
          vm.counters = counters;
          vm.isDataReloading = false;
        })
        .catch(function(error) {
          var message = $translate.instant("counters.notifications.loadError");
          Notification.error(message);
          vm.isDataReloading = false;
        });
    }

    function onSelect(item, model) {
      vm.selectedMonth = item.date;
      getCounters(vm.UserId, vm.selectedMonth);
    }

    function submit() {
      vm.isSaving = true;
      if (!vm.counters.IsUnlimited) {
        var sums = getSums();
        if (
          sums[0] > vm.counters.SampleCounter.DecimalValue ||
          sums[1] > vm.counters.TimeReturnCounter.DecimalValue
        ) {
          var message = $translate.instant("counters.notifications.tooMuch");
          Notification.error(message);
          vm.isSaving = false;
          return;
        }
      }
      var limitArray = getLimitArray();
      counterRest
        .post(limitArray)
        .then(function(result) {
          var message = $translate.instant("counters.notifications.success");
          Notification.success(message);
          vm.isSaving = false;
        })
        .catch(function(error) {
          var message = $translate.instant("counters.notifications.error");
          Notification.error(message);
          vm.isSaving = false;
        });
    }

    function addPeriod() {
      PeriodPickerService.show("md", init, 0);
    }

    function editPeriod() {
      PeriodPickerService.show(
        "md",
        init,
        1,
        vm.selectedPeriodObject.BeginDate,
        vm.selectedPeriodObject.EndDate,
        vm.selectedPeriodObject.Id
      );
    }

    function getLimitArray() {
      var limitArray = [];
      vm.counters.Employees.forEach(function(employee) {
        var sample = {};
        var timeReturn = {};

        sample.Id = employee.SampleCounter.Id;
        sample.DecimalValue = employee.SampleCounter.DecimalValue;
        timeReturn.Id = employee.TimeReturnCounter.Id;
        timeReturn.DecimalValue = employee.TimeReturnCounter.DecimalValue;

        limitArray.push(sample);
        limitArray.push(timeReturn);
      });
      return limitArray;
    }

    function getSums() {
      var sampleSum = 0;
      var timeReturnSum = 0;
      vm.counters.Employees.forEach(function(employee) {
        sampleSum += employee.SampleCounter.DecimalValue;
        timeReturnSum += employee.TimeReturnCounter.DecimalValue;
      });
      return [sampleSum, timeReturnSum];
    }

    function goToUser(userId) {
      $state.go("home.counters", { id: userId });
    }

    function splitToAll(fieldName) {
      var singleValue =
        vm.counters[fieldName].DecimalValue / vm.counters.Employees.length;
      singleValue = Math.floor(singleValue);
      vm.counters.Employees.forEach(function(employee) {
        employee[fieldName].DecimalValue = singleValue;
      });
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ContractorSelectService', ContractorSelectService);

  ContractorSelectService.$inject = ['$log', '$uibModal'];

  function ContractorSelectService($log, $uibModal) {

    var service = {
      show: showModal,
      close: close,
      check: check,
      visible: visible,
      getUserId: getUserId,
      getStatus: getStatus
    };

    var instance = undefined;
    var isVisible = false;
    var callbackMultiSelect = undefined;
    var checkFunction = undefined;
    var userIdd = undefined;
    // status:boolean false = active, true = non-active, undefined = all contractors
    var statuss = undefined;

    return service;

    function showModal(size, callback, callbackMulti, checkFunc, userId, status) {
      if(isVisible)
        return;
      callbackMultiSelect = callbackMulti;
      checkFunction = checkFunc;
      isVisible = true;
      userIdd = userId;
      statuss = status;

      instance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/contractors/contractorsSelect.html',
        controller: 'ContractorsController',
        controllerAs: 'vm',
        size: size,
        resolve: {
        }
      });
      //return modalInstance.result;
      instance.result.then(function (data) {
        $log.debug('contractorsSelect ok with ' + data);
        isVisible = false;
        if(data)
          callback(data);
      }, function (err) {
        $log.debug('contractorsSelect dismissed with:  ' + err);
        isVisible = false;
      });
    }

    function close(obj){
      if(callbackMultiSelect != undefined)
        callbackMultiSelect(obj);
      else
        instance.close(obj);
    };

    function check(obj) {
      return checkFunction(obj);
    }

    function visible(){
      return isVisible;
    }

    function getStatus(){
      return statuss;
    }

    function getUserId(){
      return userIdd;
    }
  };

})();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('ContractorsController', ContractorsController);

  ContractorsController.$inject = ['$q', '$log', '$stateParams', '$scope', '$translate', '$state', 'contractorRest', 'constRest', 'UsersService', '$sessionStorage', 'SessionService', 'ConfirmModalService', 'ContractorSelectService', 'sweetAlert'];

  function ContractorsController($q, $log, $stateParams, $scope, $translate, $state, contractorRest, constRest, UsersService, $sessionStorage, SessionService, ConfirmModalService, ContractorSelectService, sweetAlert) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.loadContractorsData = loadContractorsData;
    vm.getNameText = getNameText;
    vm.setTotalCount = setTotalCount;
    vm.setCurrentPage = setCurrentPage;
    vm.setPageSize = setPageSize;
    vm.pageChanged = pageChanged;
    vm.loadDictionaryData = loadDictionaryData;
    vm.loadUserDictionaryData = loadUserDictionaryData;
    vm.getUserSelectText = getUserSelectText;
    vm.onSelect = onSelect;
    vm.onFilterChange = onFilterChange;
    vm.toggleBlockedFlag = toggleBlockedFlag;
    vm.onSelectPageCount = onSelectPageCount;
    vm.checkPermission = checkPermission;
    vm.resetSearchTerms = resetSearchTerms;
    vm.resetSearchTermsWithoutLoad = resetSearchTermsWithoutLoad;
    vm.changeSortByName = changeSortByName;
    vm.selectContractor = selectContractor;
    vm.isAdded = isAdded;
    vm.addContractor = addContractor;

    ///////////////// data def
    vm.data = undefined;
    vm.error = undefined;
    vm.isLoading = false;
    vm.isDataReloading = false;
    vm.userDictName = "UsersDictionary";

    vm.pagingData = {
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      pagingButtonsMaxSize: 5,
      featureId: undefined,
      isBlocked: undefined,
      groupId: undefined,
      searchStr: undefined,
      patronId: undefined,
      type: undefined,
      isAcceptanceRequired: undefined,
      sortByName: 0,
      gln: undefined,
      IsFsSendProd: undefined,
      IsKfsSendProd: undefined,
      IsOrderLoadProd: undefined
    };
    vm.dictionaryData = {};
    vm.userId = undefined;
    vm.status = undefined;

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("contractors.controller");

      //constructor body
      vm.userId = ContractorSelectService.getUserId();
      vm.status = ContractorSelectService.getStatus();

      vm.setPageSize(10);

      loadDictionaryData("ContractorFeature");
      loadDictionaryData("ContractorGroupDictionary");
      loadDictionaryData("BlockedDictionary");
      loadDictionaryData("PageSizeDictionary");
      loadDictionaryData("ContractorType");
      loadDictionaryData("EDIStatusedDictionary");
      loadUserDictionaryData().then(function () {

        /** if user/status specified while opening modal instance
         they will be permanently chosen as patron/status in ui-selects**/
        if (vm.userId !== undefined)
          vm.pagingData.patronId = vm.userId;

        if (vm.status !== undefined)
          vm.pagingData.isBlocked = vm.status;

        onFilterChange();
      });

      if ($sessionStorage.contractorsPagingData != undefined) {
        vm.pagingData = angular.copy($sessionStorage.contractorsPagingData);
      }
      if (ContractorSelectService.visible()) {
        resetSearchTermsWithoutLoad();
      }
      if ($stateParams.pagingData != undefined) {
        resetSearchTermsWithoutLoad();
        if ($stateParams.pagingData.isAcceptanceRequired !== undefined)
          vm.pagingData.isAcceptanceRequired = $stateParams.pagingData.isAcceptanceRequired;
      }
      loadDataWithPagingData(true);

    }

    ///////////////// business logic

    function selectContractor(obj) {
      ContractorSelectService.close(obj);
    }

    function getNameText(object) {
      if (object.IsPerson)
        return object.PersonName + " " + object.PersonSurname;
      else
        return object.Name;
    };

    function setCurrentPage(pageNo) {
      vm.pagingData.currentPage = pageNo;
    };

    function setPageSize(pageSize) {
      vm.pagingData.pageSize = pageSize;
    };

    function setTotalCount(pageTotal) {
      vm.pagingData.totalCount = pageTotal;
    };

    function pageChanged() {
      loadDataWithPagingData(false);
      if (!ContractorSelectService.visible()) {
        $sessionStorage.contractorsPagingData = vm.pagingData;
      }
    };

    function onFilterChange() {
      if (vm.pagingData.searchStr == "")
        vm.pagingData.searchStr = undefined;
      if (!ContractorSelectService.visible()) {
        $sessionStorage.contractorsPagingData = vm.pagingData;
      }

      loadDataWithPagingData(true);
    }

    function getUserSelectText(selectObj) {
      var str;
      if (selectObj == undefined || selectObj == {} || selectObj == 0)
        return "";
      return selectObj.SurName + " " + selectObj.Name;
    }

    function toggleBlockedFlag(object) {
      var toggleAccept = function (object) {
        object.IsBlocked = !object.IsBlocked;
        contractorRest.changeStatus(object.Id)
          .then(function (result) {
            sweetAlert.swal({
              title: "Sukces",
              text: "Kontrahent został " + (object.IsBlocked ? "odblokowany" : "zablokowany"),
              type: "success"
            });
          })
          .catch(function (error) {

          });
      };

      sweetAlert.swal({
          title: "Uwaga",
          text: "Zamierzasz " + (object.IsBlocked ? "Odblokować" : "zablokować") + " kontrahenta!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Potwierdzam",
          cancelButtonText: "Zrezygnuj",
          closeOnConfirm: false,
          closeOnCancel: true
          
        }).then(function() {
        toggleAccept(object);
        }, function(dismiss) {
          // dismiss can be 'cancel', 'overlay',
          // 'close', and 'timer'
        });
    }

    function resetSearchTerms() {
      vm.resetSearchTermsWithoutLoad();
      onFilterChange();
    }

    function resetSearchTermsWithoutLoad() {
      vm.pagingData.featureId = undefined;
      vm.pagingData.groupId = undefined;
      vm.pagingData.isBlocked = undefined;
      vm.pagingData.patronId = undefined;
      vm.pagingData.searchStr = undefined;
      vm.pagingData.type = undefined;
      vm.pagingData.gln = undefined;
      vm.pagingData.currentPage = 1;
      vm.pagingData.IsFsSendProd = undefined;
      vm.pagingData.IsKfsSendProd = undefined;
      vm.pagingData.IsOrderLoadProd = undefined;
      if (ContractorSelectService.visible()) {
        vm.pagingData.isAcceptanceRequired = false;
      }
      else {
        vm.pagingData.isAcceptanceRequired = undefined;
      }
      //vm.pagingData.sortByName = 0;
      if (vm.userId !== undefined)
        vm.pagingData.patronId = vm.userId;

      if (vm.status !== undefined)
        vm.pagingData.isBlocked = vm.status;
    }

    ///////////////// watchers

    function changeSortByName() {
      if (vm.pagingData.sortByName === 0) {
        vm.pagingData.sortByName = 1;
      } else if (vm.pagingData.sortByName === 1) {
        vm.pagingData.sortByName = -1;
      } else
        vm.pagingData.sortByName = 0;
      onFilterChange();
    }

    function onSelect(item, model) {
      onFilterChange();
    }

    function onSelectPageCount(item, model) {
      onFilterChange();
    }

    ///////////////// check state functions

    function isAdded(key) {
      var obj = ContractorSelectService.check(key);
      if (obj === undefined)
        return false;
      else
        return true;
    }

    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    ///////////////// resource invoke functions
    function loadDataWithPagingData(getCount) {
      vm.loadContractorsData(
        vm.pagingData.featureId,
        vm.pagingData.isBlocked,
        vm.pagingData.groupId,
        vm.pagingData.searchStr,
        vm.pagingData.patronId,
        vm.pagingData.pageSize,
        vm.pagingData.currentPage,
        getCount,
        vm.pagingData.type,
        vm.pagingData.sortByName,
        vm.pagingData.isAcceptanceRequired,
        vm.pagingData.gln,
        vm.pagingData.IsFsSendProd,
        vm.pagingData.IsKfsSendProd,
        vm.pagingData.IsOrderLoadProd
      );
    }

    function loadContractorsData(featureId, isBlocked, groupId, searchStr, patronId, count, page, getCount, type, sortByName, isAcceptanceRequired, gln, IsFsSendProd,IsKfsSendProd, IsOrderLoadProd) {
      vm.isDataReloading = true;
      if (vm.checkPermission(6)) {
        contractorRest.all(featureId, isBlocked, groupId, searchStr, patronId, count, page, getCount, undefined, type, sortByName, isAcceptanceRequired, undefined, gln, IsFsSendProd,IsKfsSendProd, IsOrderLoadProd)
          .then(function (result) {
            vm.data = result;
            vm.isDataReloading = false;
            if (result.totalCount) {
              vm.setTotalCount(parseInt(result.totalCount, 10));
            }
          })
          .catch(function (error) {
            $log.debug("Error while contractors date: " + vm.pagingData);
            vm.isDataReloading = false;
            vm.error = error;
          });
      } else if (vm.checkPermission(7)) {
        contractorRest.getForUser(SessionService.getAuthenticatedUser().Id, featureId, isBlocked, groupId, searchStr, count, page, getCount, undefined, type, sortByName)
          .then(function (result) {
            vm.data = result;
            vm.isDataReloading = false;
            if (result.totalCount) {
              vm.setTotalCount(parseInt(result.totalCount, 10));
            }
          })
          .catch(function (error) {
            $log.debug("Error while contractors date: " + vm.pagingData);
            vm.isDataReloading = false;
            vm.error = error;
          });
      }
    }

    function loadDictionaryData(name) {
      constRest.getDictionary(name)
        .then(function (data) {
          vm.dictionaryData[name] = data;
          if (name === "ContractorFeature" || name === "ContractorGroupDictionary") {
            vm.dictionaryData[name].sort(function (a, b) {
              if (a.Value == undefined)
                return -1;
              if (b.Value == undefined)
                return 1;
              if (a.Value < b.Value)
                return -1;
              else if (a.Value > b.Value)
                return 1;
              else
                return 0;
            });
          }
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          vm.error = error;
        });
    }

    function loadUserDictionaryData() {
      var deferred = $q.defer();

      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
          deferred.resolve();
          vm.dictionaryData[vm.userDictName].sort(function (a, b) {

            if (a.SurName == undefined)
              return -1;
            if (b.SurName == undefined)
              return 1;
            if (a.SurName < b.SurName)
              return -1;
            else if (a.SurName > b.SurName)
              return 1;
            else
              return 0;
          });
        })
        .catch(function (error) {
          deferred.reject();
          $log.debug("Error while getting dictionary: " + vm.userDictName);
          vm.error = error;
        });
      return deferred.promise;
    }

    //go to state where you add new contractor
    function addContractor() {
      $state.go("home.contractors.contractor", {id: 0});
    }

    ///////////////// FORMLY

  }
})
();

/**
 * Created by Misiek on 2015-11-05.
 */
(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("ContractorController", ContractorController);

  ContractorController.$inject = [
    "$log",
    "$q",
    "$state",
    "$stateParams",
    "$translate",
    "contractorRest",
    "constRest",
    "UsersService",
    "storageRest",
    "SessionService",
    "ConfirmModalService",
    "attributesHelper",
    "Notification",
    "ContractorSelectService",
    "customParameterRest",
    "templateRest",
  ];

  function ContractorController(
    $log,
    $q,
    $state,
    $stateParams,
    $translate,
    contractorRest,
    constRest,
    UsersService,
    storageRest,
    SessionService,
    ConfirmModalService,
    attributesHelper,
    Notification,
    ContractorSelectService,
    customParameterRest,
    templateRest
  ) {
    /* jshint validthis: true */
    var vm = this;

    ///////////////// functions def
    vm.addOrUpdateParam = addOrUpdateParam;
    vm.deleteParam = deleteParam;
    vm.loadDictionaryData = loadDictionaryData;
    vm.loadUserDictionaryData = loadUserDictionaryData;
    vm.loadContractor = loadContractor;
    vm.saveContractor = saveContractor;
    vm.addContractor = addContractor;
    vm.checkPermission = checkPermission;
    vm.submit = submit;
    vm.tryCopyNameToFullName = tryCopyNameToFullName;
    vm.getDictionaryObject = getDictionaryObject;
    vm.removeAttribute = removeAttribute;
    vm.addAttribute = addAttribute;
    vm.goBack = goBack;
    vm.setDefaultPayer = setDefaultPayer;
    vm.removeDefaultPayer = removeDefaultPayer;
    vm.openTemplateInNewWindow = openTemplateInNewWindow;

    ///////////////// data def
    vm.contractor = {};
    vm.defaultDocTypes = [];
    vm.error = undefined;
    vm.isError = false;
    vm.isLoading = false;
    vm.userDictName = "UsersDictionary";
    vm.showStatusAlert = false;
    vm.allowToEdit = false;
    vm.dictionaryData = {};
    vm.templates = [];
    vm.hdiTemplates = [];
    vm.phoneAttributes = {
      Attributes: [],
    };
    vm.timeOptions = {
      hstep: 1,
      mstep: 1,
    };

    ///////////////// constructor call
    loadData();

    function loadData() {
      $log.debug("contractors.controller");
      //constructor body
      loadDictionaryData("ContractorFeature"); // ui-select z multiselect - lista przypisanych przychodzi w FeatureIds
      loadDictionaryData("ContractorGroupDictionary"); // mapuje się na pole GroupId
      loadDictionaryData("ContractorSizeDictionary"); // id mapuje się na pole ContractorSize
      loadDictionaryData("ContractorType"); //pole Type
      loadDictionaryData("PrefferedContact"); //PreferredContactId
      loadDictionaryData("PriceLevel"); //PriceLevelId
      loadDictionaryData("CountryDictionary"); //do adresów
      loadDictionaryData("ProvinceDictionary"); ////do adresów
      loadDictionaryData("PhoneTypeDictionary"); ////do kontaktu telefonicznego
      loadDictionaryData("DocumentTypeDictionary");
      loadDictionaryData("DocumentCategoryDictionary");
      loadStoragesData();
      loadUserDictionaryData();
      loadTemplates();

      if (!vm.checkPermission(8)) {
        vm.contractor.Disable = true;
      }
      loadDictionaryData("CustomParams2Dictionary").then(function () {
        if ($stateParams.id > 0) {
          loadContractor($stateParams.id);
        } else {
          getNextSymbol(vm.contractor);
          vm.contractor.Type = 2;
          vm.contractor.IsDeliveryAddress = false;
          vm.contractor.Attributes = [];
          attributesHelper.extendObject(vm.contractor);
          vm.phoneAttributes.Attributes = vm.contractor.getAttributesByType(1);
          attributesHelper.extendObject(vm.phoneAttributes);
        }
      });
    }

    ///////////////// business logic
    function tryCopyNameToFullName() {
      if (
        vm.contractor.FullName == undefined ||
        vm.constructor.FullName == ""
      ) {
        vm.contractor.FullName == vm.contractor.Name;
      }
    }

    function getDictionaryObject(dictName, localId) {
      var ret = vm.dictionaryData[dictName].filter(function (o) {
        return o.LocalId === localId;
      });
      return ret;
    }

    function removeAttribute(attr) {
      vm.contractor.removeAttribute(attr);
      if (attr.Type == 1) vm.phoneAttributes.removeAttribute(attr);
    }

    function addAttribute(contextType, contextId, type, value, dictLocalId) {
      var attr = vm.contractor.addAttribute(
        contextType,
        contextId,
        type,
        value,
        dictLocalId
      );
      if (type == 1) vm.phoneAttributes.Attributes.push(attr);
    }

    ///////////////// watchers

    ///////////////// check state functions
    function checkPermission(id) {
      return SessionService.checkPermission(id);
    }

    ///////////////// resource invoke functions

    function getNextSymbol(obj) {
      contractorRest
        .getNextSymbol()
        .then(function (data) {
          obj.Symbol = data;
        })
        .catch(function (error) {
          vm.isLoading = false;
          vm.error = error;
        });
    }

    function loadContractor(id) {
      vm.isDataReloading = true;
      contractorRest
        .get(id, true, true, false, true)
        .then(function (result) {
          vm.contractor = result;
          vm.contractor.CustomParameters = sortCustomParamsWithDictionary(
            vm.contractor.CustomParameters
          );
          formatTimeToDate();
          if (vm.contractor.Symbol === null || vm.contractor.Symbol === "") {
            getNextSymbol(vm.contractor);
          }
          if (vm.contractor.ObjectStatus < 10) {
            vm.showStatusAlert = true;
          }
          //obejście na dane w bazie źle zaimportowane, poprawiono wszystko więc na prod będzie ok, ale niech zostanie :)
          if (vm.contractor.DefaultAddress.ProvinceId === 0)
            vm.contractor.DefaultAddress.ProvinceId = undefined;
          if (vm.contractor.DeliveryAddress !== undefined) {
            if (vm.contractor.DeliveryAddress.ProvinceId === 0)
              vm.contractor.DeliveryAddress.ProvinceId = undefined;
            if (vm.contractor.DefaultAddress.CountryId === 0)
              vm.contractor.DefaultAddress.CountryId = undefined;
            if (vm.contractor.DeliveryAddress.CountryId === 0)
              vm.contractor.DeliveryAddress.CountryId = undefined;
          }
          if (!vm.checkPermission(8)) {
            vm.contractor.Disable = true;
          }
          attributesHelper.extendObject(vm.contractor);
          vm.phoneAttributes.Attributes = vm.contractor.getAttributesByType(1);
          attributesHelper.extendObject(vm.phoneAttributes);

          return getDefaultPayerName();
        })
        .then(function () {
          vm.isLoading = false;
        })
        .catch(function (error) {
          vm.isLoading = false;
          vm.error = error;
        });
    }

    function loadTemplates() {
      templateRest
        .getList(1, 1000, false, 2)
        .then(function (templates) {
          vm.templates = templates;
        })
        .catch(function () {
          Notification.error("Błąd podczas pobierania listy szablonów");
        });

      templateRest
        .getList(1, 1000, false, 4)
        .then(function (templates) {
          vm.hdiTemplates = templates;
        })
        .catch(function () {
          Notification.error("Błąd podczas pobierania listy szablonów dla HDI");
        });
    }

    function sortCustomParamsWithDictionary(paramsDictionary) {
      var sortedRow = [];
      vm.dictionaryData["CustomParams2Dictionary"].forEach(function (
        dictionaryItem
      ) {
        var isParamExisting = false;
        for (var property in paramsDictionary) {
          if (
            paramsDictionary.hasOwnProperty(property) &&
            paramsDictionary[property].Name == dictionaryItem.LocalId
          ) {
            isParamExisting = true;
            paramsDictionary[property].DictionaryItemValue =
              dictionaryItem.Value;
            sortedRow.push(paramsDictionary[property]);
          }
        }
        if (!isParamExisting) {
          sortedRow.push({
            Id: 0,
            ContextId: vm.contractor.Id,
            ContextType: 1,
            TextValue: undefined,
            Name: dictionaryItem.LocalId,
            DictionaryItemValue: dictionaryItem.Value,
            NameContext: 2,
          });
        }
      });
      return sortedRow;
    }

    function saveContractor(data) {
      vm.isDataReloading = true;
      data.ObjectStatus = 10;
      formatDateToTime();
      var dataa = {};
      angular.copy(data, dataa);
      dataa.CustomParameters = null;
      contractorRest
        .save(dataa, true)
        .then(function (result) {
          var message = $translate.instant("contractors.notifications.updated");
          Notification.success(message);
          $state.go("home.contractors");
          vm.isLoading = false;
        })
        .catch(function (error) {
          var message = $translate.instant("contractors.notifications.error");
          Notification.error(message);
          data.ObjectStatus = 1;
          vm.isLoading = false;
          vm.error = error;
        });
    }

    function addContractor(contractor) {
      vm.isDataReloading = true;
      formatDateToTime();
      contractor.ObjectStatus = 10;
      contractorRest
        .post(contractor, true)
        .then(function (result) {
          var message = $translate.instant("contractors.notifications.added");
          Notification.success(message);
          $state.go("home.contractors");
          vm.isDataReloading = false;
        })
        .catch(function (error) {
          contractor.ObjectStatus = 1;
          var message = $translate.instant("contractors.notifications.error");
          Notification.error(message);
          $log.debug("Error while add contractor: " + contractor);
          vm.isDataReloading = false;
          vm.error = error;
        });
    }

    function submit(contractor) {
      var submitAfterModal = function () {
        if (vm.defaultAddressForm.$invalid) {
          vm.isError = true;
          vm.error = $translate.instant(
            "contractors.contractor.errors.defaultAddressRequired"
          );
          return;
        }
        if (contractor.ObjectStatus < 10 && vm.contactDataForm.$invalid) {
          vm.isError = true;
          vm.error = $translate.instant(
            "contractors.contractor.errors.contactDataRequired"
          );
          return;
        }

        vm.isDataReloading = true;
        if ($stateParams.id > 0) {
          saveContractor(contractor);
        } else {
          addContractor(contractor);
        }
      };

      if (contractor.DeliveryAddress !== undefined) {
        if (contractor.DeliveryAddress.Name == undefined)
          contractor.DeliveryAddress.Name = contractor.Name;
        if (contractor.DeliveryAddress.Name.length < 1)
          //mamy pewność, że nie będzie undefined jak poprzednio było to sprawdzone :)
          contractor.DeliveryAddress.Name = contractor.Name;
      }
      if (contractor.FullName == undefined)
        contractor.FullName = contractor.Name;
      if (contractor.FullName.length < 1)
        //mamy pewność, że nie będzie undefined jak poprzednio było to sprawdzone :)
        contractor.FullName = contractor.Name;

      vm.isDataReloading = true;
      contractorRest
        .check(contractor.NIP)
        .then(function (result) {
          vm.isDataReloading = false;
          var totalCount = 0;
          if (result.length > 0) {
            if (result.length == 1 && contractor.Id == result[0].Id) {
              submitAfterModal();
              return; //prz edycji istnieje już aktualny - sprawdzenie tego
            }
            if (result.totalCount) {
              totalCount = parseInt(result.totalCount, 10);
            }
            ConfirmModalService.show(
              "m",
              {
                title: "confirmModal.warning",
                topBodyText: "confirmModal.contractor.titleNipExists",
                body: result,
                type: 2,
                okText: "confirmModal.ok",
                cancelText: "confirmModal.cancel",
              },
              submitAfterModal
            );
          } else {
            submitAfterModal();
          }
        })
        .catch(function () {});
    }

    function loadDictionaryData(name) {
      var deferred = $q.defer();
      constRest
        .getDictionary(name)
        .then(function (data) {
          if (name === "DocumentTypeDictionary") {
            vm.defaultDocTypes = _.filter(data, function (val) {
              return (
                val.LocalId === 2 || val.LocalId === 11 || val.LocalId === 16
              );
            });
          }
          vm.dictionaryData[name] = data;
          deferred.resolve();
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + name);
          deferred.reject();
        });
      return deferred.promise;
    }

    function loadStoragesData() {
      storageRest
        .all()
        .then(function (data) {
          vm.dictionaryData["Storages"] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting sotrages ");
        });
    }

    function loadUserDictionaryData() {
      UsersService.getAllUsersForDictionary()
        .then(function (data) {
          vm.dictionaryData[vm.userDictName] = data;
        })
        .catch(function (error) {
          $log.debug("Error while getting dictionary: " + vm.userDictName);
        });
    }

    function formatTimeToDate() {
      if (!vm.contractor.DeliveryStartTime) {
        vm.contractor.DeliveryStartTime = "00:00";
      }
      if (!vm.contractor.DeliveryStopTime) {
        vm.contractor.DeliveryStopTime = "00:00";
      }
      var timeParts = vm.contractor.DeliveryStartTime.split(":");
      var timeParts2 = vm.contractor.DeliveryStopTime.split(":");
      var time = {
        hour: parseInt(timeParts[0]),
        minute: parseInt(timeParts[1]),
      };
      var time2 = {
        hour: parseInt(timeParts2[0]),
        minute: parseInt(timeParts2[1]),
      };
      vm.contractor.DeliveryStartTimeProto = Date.today().at(time);
      vm.contractor.DeliveryStopTimeProto = Date.today().at(time2);
    }

    function formatDateToTime() {
      vm.contractor.DeliveryStartTime = vm.contractor.DeliveryStartTimeProto.toString(
        "HH:mm"
      );
      vm.contractor.DeliveryStopTime = vm.contractor.DeliveryStopTimeProto.toString(
        "HH:mm"
      );
    }

    //validation
    function replaceNIP(nip) {
      if (nip == undefined) return;
      nip = nip.replace(/-/g, "");
    }

    function validateNIP(nip) {
      if (nip == undefined) return false;
      //var nip_bez_kresek = nip.replace(/-/g,"");
      var nip_bez_kresek = nip;
      var reg = /^[0-9]{10}$/;
      if (reg.test(nip_bez_kresek) == false) {
        return false;
      } else {
        var dig = ("" + nip_bez_kresek).split("");
        var kontrola =
          (6 * parseInt(dig[0]) +
            5 * parseInt(dig[1]) +
            7 * parseInt(dig[2]) +
            2 * parseInt(dig[3]) +
            3 * parseInt(dig[4]) +
            4 * parseInt(dig[5]) +
            5 * parseInt(dig[6]) +
            6 * parseInt(dig[7]) +
            7 * parseInt(dig[8])) %
          11;
        if (parseInt(dig[9]) == kontrola) return true;
        else return false;
      }
    }

    function validateRegon9(regon) {
      var reg = /^[0-9]{9}$/;
      if (reg.test(regon) == false) {
        return false;
      } else {
        var dig = ("" + regon).split("");
        var kontrola =
          (8 * parseInt(dig[0]) +
            9 * parseInt(dig[1]) +
            2 * parseInt(dig[2]) +
            3 * parseInt(dig[3]) +
            4 * parseInt(dig[4]) +
            5 * parseInt(dig[5]) +
            6 * parseInt(dig[6]) +
            7 * parseInt(dig[7])) %
          11;
        if (kontrola == 10) kontrola = 0;
        if (parseInt(dig[8]) == kontrola) return true;
        else return false;
      }
    }

    //validation end

    ///////////////// FORMLY
    vm.contractorFields = [
      {
        key: "Name",
        type: "input",
        hideExpression: function () {
          return vm.contractor.IsPerson;
        },
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          minlength: 3,
          label: $translate.instant("contractors.contractor.label.name"),
          onBlur: function ($viewValue, $modelValue, scope) {
            scope.originalModel.FullName = scope.originalModel.Name;
          },
        },
        validation: {
          show: true,
        },
      },
      {
        key: "PersonName",
        type: "input",
        hideExpression: function () {
          return !vm.contractor.IsPerson;
        },
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.personName"),
        },
        validation: {
          show: true,
        },
      },
      {
        key: "PersonSurname",
        type: "input",
        hideExpression: function () {
          return !vm.contractor.IsPerson;
        },
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant(
            "contractors.contractor.label.personSurname"
          ),
        },
        validation: {
          show: true,
        },
      },
      {
        key: "FullName",
        type: "textarea",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          label: $translate.instant("contractors.contractor.label.fullname"),
          //required: true,
          rows: 4, //TODO add expressionProperties with dynamic rows
          minlength: 3,
        },
        validation: {
          show: true,
        },
      },
      {
        key: "Symbol",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled":
            "model.ObjectStatus >= 10 || model.Disable ===true",
        },

        templateOptions: {
          type: "text",
          label: $translate.instant("contractors.contractor.label.symbol"),
          onBlur: function ($viewValue, $modelValue, scope) {
            //scope.originalModel.FullName = scope.originalModel.Name;
            contractorRest.check(null, $viewValue).then(function (result) {
              if (result.nextSymbol) {
                scope.originalModel.Symbol = result.nextSymbol;
              }
            });
          },
        },
      },
      {
        key: "NIP",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.ObjectStatus > 10",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.nip"),
        },
        validators: {
          nip: {
            expression: function ($viewValue, $modelValue, scope) {
              var value = $modelValue || $viewValue;
              //return validateNIP(value);
              return true;
            },
            message: '$viewValue + " to nie jest prawidłowy NIP"',
          },
        },
        validation: {
          show: true,
        },
      },
    ];

    vm.contactDataFields = [
      {
        key: "EMail",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "email",
          // required: true,
          minlength: 6,
          label: $translate.instant("contractors.contractor.label.email"),
        },
        validation: {
          show: true,
        },
      },
      {
        key: "WWW",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          label: $translate.instant("contractors.contractor.label.www"),
        },
      },
    ];

    vm.contractorExtendedFields = [
      {
        //TODO check GLN / ILN to view/edit?
        key: "GLN",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          label: $translate.instant("contractors.contractor.label.gln"),
        },
        //walidacja EAN
      },
      {
        key: "ILN",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          label: $translate.instant("contractors.contractor.label.iln"),
        },
        //walidacja EAN
      },
      {
        key: "CustomSymbol",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          label: $translate.instant(
            "contractors.contractor.label.customSymbol"
          ),
        },
        //walidacja EAN
      },
    ];

    vm.defaultAddressFields = [
      {
        key: "DefaultAddress.City",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.city"),
        },
        validation: {
          show: true,
        },
      },
      {
        key: "DefaultAddress.PostalCode",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.postalCode"),
        },
        validation: {
          show: true,
        },
      },
      {
        key: "DefaultAddress.Street",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.street"),
        },
        validation: {
          show: true,
        },
      },
      {
        key: "DefaultAddress.BuildingNumber",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant(
            "contractors.contractor.label.buildingNumber"
          ),
        },
        validation: {
          show: true,
        },
      },
    ];

    vm.deliveryAddressFields = [
      {
        key: "DeliveryAddress.Name",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          label: $translate.instant("contractors.contractor.label.name"),
        },
      },
      {
        key: "DeliveryAddress.City",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.city"),
        },
      },
      {
        key: "DeliveryAddress.PostalCode",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.postalCode"),
        },
      },
      {
        key: "DeliveryAddress.Street",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant("contractors.contractor.label.street"),
        },
      },
      {
        key: "DeliveryAddress.BuildingNumber",
        type: "input",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        templateOptions: {
          type: "text",
          required: true,
          label: $translate.instant(
            "contractors.contractor.label.buildingNumber"
          ),
        },
      },
    ];

    vm.notesFields = [
      {
        key: "Note",
        expressionProperties: {
          "templateOptions.disabled": "model.Disable === true",
        },
        type: "textarea",
        templateOptions: {
          type: "text",
          rows: 9,
          label: $translate.instant("contractors.contractor.label.note"),
        },
      },
    ];

    //goes back to previous state
    function goBack() {
      $state.go("home.contractors");
    }

    function setDefaultPayer() {
      var callback = function (obj) {
        vm.contractor.DefaultPayerName = obj.Name;
        vm.contractor.DefaultPayerId = obj.Id;
      };

      var callbackCheck = function (obj) {
        if (vm.contractor.DefaultPayerId === obj.Id) return true;
        else {
          return undefined;
        }
      };

      ContractorSelectService.show(
        "lg",
        callback,
        undefined,
        callbackCheck,
        undefined,
        false
      );
    }

    function removeDefaultPayer() {
      vm.contractor.DefaultPayerId = undefined;
      vm.contractor.DefaultPayerName = undefined;
    }

    function getDefaultPayerName() {
      var deferred = $q.defer();
      if (
        vm.contractor.DefaultPayerId != null &&
        vm.contractor.DefaultPayerId != undefined
      ) {
        contractorRest
          .get(vm.contractor.DefaultPayerId, false, false)
          .then(function (contractor) {
            vm.contractor.DefaultPayerName = contractor.Name;
            deferred.resolve();
          })
          .catch(function () {
            deferred.reject();
          });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }

    function addOrUpdateParam(param) {
      if (param.isLocked) {
        return;
      }
      param.isLocked = true;
      if (param.Id) {
        param.isLocked = false;
        customParameterRest
          .update(param)
          .then(function (response) {
            param.isModified = false;
            var message = $translate.instant("products.notifications.list");
            Notification.success(message);
          })
          .catch(function (err) {
            param.isLocked = false;
            var message = $translate.instant(
              "products.notifications.sendError"
            );
            Notification.error(message);
          });
      } else {
        customParameterRest
          .add(param)
          .then(function (response) {
            param.isLocked = false;
            param.Id = response.Id;
            param.isModified = false;
            var message = $translate.instant("products.notifications.list");
            Notification.success(message);
          })
          .catch(function (err) {
            param.isLocked = false;
            var message = $translate.instant(
              "products.notifications.sendError"
            );
            Notification.error(message);
          });
      }
    }

    function deleteParam(param) {
      if (param.isLocked) {
        return;
      }
      param.isLocked = true;
      customParameterRest
        .remove(param)
        .then(function () {
          param.isLocked = false;
          afterParamDelete(param);
          var message = $translate.instant("products.notifications.list");
          Notification.success(message);
        })
        .catch(function () {
          param.isLocked = false;
          var message = $translate.instant("products.notifications.sendError");
          Notification.error(message);
        });
    }

    function afterParamDelete(param) {
      param.Id = 0;
      param.TextValue = undefined;
    }

    function openTemplateInNewWindow(templateId) {
      var url = $state.href("home.templates.template", { id: templateId });
      window.open(url, "_blank");
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('smakmak.common.directives')
    .directive('onPressEnter', onPressEnter);

  /** @ngInject */
  function onPressEnter() {
    var directive = {
      link: function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.onPressEnter);
            });
            event.preventDefault();
          }
        });
      }
    };

    return directive;
  }

})();




(function () {
  'use strict';


angular.module('smakmak.common.directives').directive('nonNumeric', function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attr, ctrl) {
        function inputValue(val) {
          if (val) {
            var digits = val.replace(/[^0-9]/g, '');

            if (digits !== val) {
              ctrl.$setViewValue(digits);
              ctrl.$render();
            }
            return parseInt(digits,10);
          }
          return undefined;
        }
        ctrl.$parsers.push(inputValue);
      }
    };
});
})(); 

/**
 * Created by Misiek on 2016-01-25.
 */

(function () {
  'use strict';


angular.module('smakmak.common.directives').directive('focusMe', function ($timeout, $parse) {
  return {
    link: function(scope, element, attrs) {
      var model = $parse(attrs.focusMe);
      scope.$watch(model, function(value) {
        //console.log('value=',value);
        if(value === true) { 
          $timeout(function() {
            element[0].focus();
            element[0].value = "";
          });
        }
      });
      
    }
  };
});
})(); 
(function() {
  'use strict';

  angular.module('smakmak.filters', []).filter('truncate', function () {
    return function (text, length, end) {
      if (text !== undefined) {
        if (isNaN(length)) {
          length = 10;
        }

        if (end === undefined) {
          end = "...";
        }

        if (text.length <= length || text.length - end.length <= length) {
          return text;
        } else {
          return String(text).substring(0, length - end.length) + end;
        }
      }
    };
  });
}());

(function () {
  'use strict';

angular.module('angularIonRangeSlider',[]);
angular.module('angularIonRangeSlider').directive('ionRangeSlider', [
  function () {
        return {
            restrict: "E",
            scope: {
                min: "=",
                max: "=",
                type: "@",
                prefix: "@",
                maxPostfix: "@",
                prettify: "@",
                grid: "@",
                gridMargin: "@",
                postfix: "@",
                step: "@",
                hideMinMax: "@",
                hideFromTo: "@",
                from: "=",
                to: "=",
                disable: "=",
                onChange: "&",
                onFinish: "&"
            },
            replace: true,
            link: function ($scope, $element) {
                $element.ionRangeSlider({
                    min: $scope.min,
                    max: $scope.max,
                    type: $scope.type,
                    prefix: $scope.prefix,
                    maxPostfix: $scope.maxPostfix,
                    prettify: $scope.prettify,
                    grid: $scope.grid,
                    gridMargin: $scope.gridMargin,
                    postfix: $scope.postfix,
                    step: $scope.step,
                    hideMinMax: $scope.hideMinMax,
                    hideFromTo: $scope.hideFromTo,
                    from: $scope.from,
                    to: $scope.to,
                    disable: $scope.disable,
                    onChange: function (a) {
                        $scope.$apply(function () {
                            $scope.from = a.from;
                          if($scope.to != undefined)
                              $scope.to = a.to;
                            $scope.onChange && $scope.onChange({
                                a: a
                            });
                        });
                    },
                    onFinish: function () {
                        $scope.$apply($scope.onFinish);
                    }
                });
                var watchers = [];
                watchers.push($scope.$watch("min", function (value) {
                    $element.data("ionRangeSlider").update({
                        min: value
                    });
                }));
                watchers.push($scope.$watch('max', function (value) {
                    $element.data("ionRangeSlider").update({
                        max: value
                    });
                }));
                watchers.push($scope.$watch('from', function (value) {
                    var slider = $element.data("ionRangeSlider");
                    if (slider.old_from !== value) {
                        slider.update({
                            from: value
                        });
                    }
                }));
                watchers.push($scope.$watch('to', function (value) {
                    var slider = $element.data("ionRangeSlider");
                    if (slider.old_to !== value) {
                        slider.update({
                            to: value
                        });
                    }
                }));
                watchers.push($scope.$watch('disable', function (value) {
                    $element.data("ionRangeSlider").update({
                        disable: value
                    });
                }));
            }
        }
      }
])}());

(function () {
  'use strict';

  angular
    .module('smakmak.directives')
    .directive('datepickerLocaldate', ['$parse', function ($parse) {
  var directive = {
    restrict: 'A',
    require: ['ngModel'],
    link: link
  };
  return directive;

  function link(scope, element, attr, ctrls) {
    var ngModelController = ctrls[0];

    // called with a JavaScript Date object when picked from the datepicker
    ngModelController.$parsers.push(function (viewValue) {
      if(viewValue == undefined) {
        return "";
      }
      // undo the timezone adjustment we did during the formatting
      viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
      // we just want a local date in ISO format
      return viewValue.toISOString().substring(0, 10);
    });

    // called with a 'yyyy-mm-dd' string to format
    ngModelController.$formatters.push(function (modelValue) {
      if (!modelValue) {
        return undefined;
      }
      // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
      var dt = new Date(modelValue);
      // 'undo' the timezone offset again (so we end up on the original date again)
      dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
      return dt;
    });
  }
    }])
    .directive('datepickerLocaldateNoAdjusting', ['$parse', function ($parse) {
      var directive = {
        restrict: 'A',
        require: ['ngModel'],
        link: link
      };
      return directive;

      function link(scope, element, attr, ctrls) {
        var ngModelController = ctrls[0];

        // called with a JavaScript Date object when picked from the datepicker
        ngModelController.$parsers.push(function (viewValue) {
          if(viewValue == undefined) {
            return "";
          }
          // undo the timezone adjustment we did during the formatting
          //viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
          // we just want a local date in ISO format
          return viewValue.toISOString().substring(0, 10);
        });

        // called with a 'yyyy-mm-dd' string to format
        ngModelController.$formatters.push(function (modelValue) {
          if (!modelValue) {
            return undefined;
          }
          // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
          var dt = new Date(modelValue);
          // 'undo' the timezone offset again (so we end up on the original date again)
          dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
          return dt;
        });
      }
    }])

}());

(function () {
  'use strict';

  angular.module('smakmak.services').factory('ConfirmModalService', ConfirmModalService);

  ConfirmModalService.$inject = ['$log', '$uibModal'];

  function ConfirmModalService($log, $uibModal) {

    var service = {
      show: showLoginModal
    };

    return service;

    //var
    var isVisible = false;

    function showLoginModal(size, content, callback, object) {
      if(isVisible)
        return;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/commonComponents/confirm.modal.html',
        controller: 'ConfirmModalController',
        controllerAs: 'vm',
        size: size,
        resolve: {
          content: function () {
            return content;
          }
        }
      });
      isVisible = true;
      modalInstance.result.then(function (data) {
        $log.info('Modal ok with ' + data);
        if(object)
          callback(object);
        else
          callback();
        isVisible = false;
      }, function (err) {
        $log.info('Modal dismissed with:  ' + err);
        isVisible = false;
      });
    }


  };

  angular
    .module('smakmak.controllers')
    .controller('ConfirmModalController', ConfirmModalController);

  /** @ngInject */
  function ConfirmModalController($scope, $uibModalInstance, content) {
    var vm = this;
    vm.content = content;

    vm.ok = ok;
    vm.cancel = cancel;

    ///////
    function ok() {
      $uibModalInstance.close(0);
    };

    function cancel() {
      $uibModalInstance.dismiss(1);
    };

  }

})();


(function () {
  'use strict';

  angular.module('smakmak.services').factory('UsersService', UsersService);

  UsersService.$inject = ['$log', 'Restangular', 'apiUrl', '$localStorage'];

  function UsersService($log, Restangular, apiUrl, $localStorage) {

    var service = {
      getUserById: getUserById,
      getUserByToken: getUserByToken,
      getAllUsers: getAllUsers,
      editUser: editUser,
      getAllUsersForDictionary: getAllUsersForDictionary,
      //block
      //activate
      getUserPreferences: getUserPreferences,
      setUserPreferences: setUserPreferences
    };

    return service;

    function getUserById(id, fResponse, fError) {
      //if ($sessionStorage.storages.users == undefined)
        Restangular.one('users', id).get().then(function (data) {
          ////response
          if (fResponse)
            fResponse(data);
        }, function error(reason) {
          ////error
          if (fError)
            fError(reason.status);
          $log.debug("Error: " + reason.status);
        });
    }

    function getUserByToken(fResponse, fError) {
      Restangular.all('Account').customGET('GetUserWithToken').then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }


    function getAllUsers(fResponse, fError) {
      $log.debug("getAllUsers");
      if (name != undefined)
      Restangular.all('users').getList().then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }
    function getAllUsersForDictionary()
    {
      return Restangular.all('users').getList({getDictionary: true});
    }

    function editUser(restObject, fResponse, fError) {
      $log.debug("editUser");
      if (restObject.restangularized == true) {
        if(restObject.EmploymentDateBegin == undefined || restObject.EmploymentDateBegin == "")
          restObject.EmploymentDateBegin = new Date(1900,1,1);
        if(restObject.EmploymentDateEnd == undefined || restObject.EmploymentDateEnd == "")
          restObject.EmploymentDateEnd = new Date(1900, 1, 1);
        restObject.save().then(function (data) {
          ////response
          if (fResponse)
            fResponse(data);
        }, function error(reason) {
          ////error
          if (fError)
            fError(reason.status);
          $log.debug("Error: " + reason.status);
        });
      }
    }

    function getUserPreferences() {
      return $sessionStorage.userPreferences;
    }

    function setUserPreferences(obj) {
      $sessionStorage.userPreferences = obj;
    }

  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('TrustedDeviceService', TrustedDeviceService);

  TrustedDeviceService.$inject = ['$log', 'Restangular'];

  function TrustedDeviceService($log, Restangular) {


    var service = {
      registerDevice: registerDevice,
      checkDeviceStatus: checkDeviceStatus
    };

    return service;


    function registerDevice(email, deviceCode, fResponse, fError) {
      var data = {
        'EMail': email,
        'Code': deviceCode
      };
    }

    function checkDeviceStatus(email, deviceCode, fResponse, fError){
      var data = {
        'EMail': email,
        'Code': deviceCode
      };
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('StorageService', StorageService);

  StorageService.$inject = ['$log', 'Restangular', 'apiUrl', '$sessionStorage'];

  function StorageService($log, Restangular, apiUrl, $sessionStorage) {


    var service = {
      getList: getList
    };

    return service;


    function getList(fResponse, fError) {
      if ($sessionStorage.storages != undefined)
        fResponse(storages);
      else
        loadStorages(fResponse, fError);
    }

    function loadStorages(fResponse, fError) {

      if ($sessionStorage.storages == undefined)
        Restangular.all('storages').getList().then(function (data) {
          ////response
          if (fResponse)
            fResponse(data);
        }, function error(reason) {
          ////error
          if (fError)
            fError(reason.status);
          $log.debug("Error: " + reason.status);
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('SessionService', SessionService);

  SessionService.$inject = ['$log', 'Restangular', 'apiUrl', '$sessionStorage', '$localStorage', 'UsersService', 'PermissionsService'];

  function SessionService($log, Restangular, apiUrl, $sessionStorage, $localStorage, UsersService, PermissionsService) {

    var rest = Restangular.all('Permissions', apiUrl + "/api");

    var service = {
      loadData: loadData,
      checkPermission: checkPermission,
      clear: clear,
      getAuthorisationHeader: getAuthorisationHeader,
      setAuthorisationHeader: setAuthorisationHeader,
      getAuthenticatedUser: getAuthenticatedUser,
      checkStayLogged: checkStayLogged,
      setStayLogged: setStayLogged,
      isUserLogged: isUserLogged,
      getUserPreferences: getUserPreferences,
      setUserPreferences: setUserPreferences,
      setUserHeader: setUserHeader,
      getUserHeader: getUserHeader
    };

    return service;

    function getAuthorisationHeader(val) {
      //if ($localStorage.SMAKMAKAuthorisation != undefined)
      //  return $localStorage.SMAKMAKAuthorisation;
      //return $sessionStorage.SMAKMAKAuthorisation;
      if (val === 1)
        return $localStorage.SMAKMAKAuthorisation;
      else
        return $localStorage.SMAKMAKAuthorisation ? $localStorage.SMAKMAKAuthorisation : $sessionStorage.SMAKMAKAuthorisation;
    }
    function getUserHeader(val) {
      //if ($localStorage.SMAKMAKAuthorisation != undefined)
      //  return $localStorage.SMAKMAKAuthorisation;
      //return $sessionStorage.SMAKMAKAuthorisation;
      if (val === 1)
        return $localStorage.SMAKMAKUserHeader;
      else
        return $localStorage.SMAKMAKUserHeader ? $localStorage.SMAKMAKUserHeader : $sessionStorage.SMAKMAKUserHeader;
    }

    function setAuthorisationHeader(val) {
      if (checkStayLogged())
        $localStorage.SMAKMAKAuthorisation = val;
      else
        $sessionStorage.SMAKMAKAuthorisation = val;
    }

    function setUserHeader(val) {
      if (checkStayLogged())
        $localStorage.SMAKMAKUserHeader = val;
      else
        $sessionStorage.SMAKMAKUserHeader = val;
    }

    function clear() {
      $sessionStorage.$reset();
      $localStorage.$reset();
    }

    function checkStayLogged() {
      if ($localStorage.SMAKMAKStayLogged != undefined)
        if ($localStorage.SMAKMAKStayLogged === true)
          return true;
      return false;
    }

    function isUserLogged() {
      if (getAuthorisationHeader() === undefined || getAuthenticatedUser() === undefined || getAuthenticatedUserPermissions() === undefined)
        return false;
      return true;
    }

    function setStayLogged(val) {
      $localStorage.SMAKMAKStayLogged = val;
    }

    function getAuthenticatedUser() {
      return $sessionStorage.SMAKMAKAuthenticatedUser;
    }

    function setAuthenticatedUser(obj) {
      $sessionStorage.SMAKMAKAuthenticatedUser = obj;
    }

    function getAuthenticatedUserPermissions() {
      return $sessionStorage.SMAKMAKAuthenticatedUserPermissions;
    }

    function setAuthenticatedUserPermissions(obj) {
      $sessionStorage.SMAKMAKAuthenticatedUserPermissions = obj;
    }

    function getUserPreferences() {
      return $sessionStorage.userPreferences;
    }

    function setUserPreferences(obj) {
      $sessionStorage.userPreferences = obj;
    }

    function loadData(fResponse, fError) {
      if (getAuthenticatedUser() == undefined || getAuthenticatedUserPermissions() == undefined) {
        UsersService.getUserByToken(function (data) {
            setAuthenticatedUser(data);
            PermissionsService.getAgregatedUserPermissions(getAuthenticatedUser().Id, function (data) {
              setAuthenticatedUserPermissions(data);
              if (fResponse)
                fResponse();
            }, function (err) {
              if (fError)
                fError(err);
            })
          }, function (err) {
            if (fError)
              fError(err);
          }
        );
      }
      else {
        (fResponse)
        fResponse();
      }
    }

    function checkPermission(id) {
      var returnVal = false;
      angular.forEach(getAuthenticatedUserPermissions(), function (value) {
        if (id == value.RoleId) {
          returnVal = true;
          return;
        }

      });
      return returnVal;
    }

  }
})();

/**
 * Created by Misiek on 2016-08-01.
 */
angular
  .module('smakmak.directives')
  .directive('selectResetModel', [selectResetModel])
function selectResetModel () {
  return {
    restrict: 'A',
    require: ['^ngModel','uiSelect'],
    link: function (scope, element, attrs, ctrls) {
      scope.$watch(attrs.ngModel,function (newval,oldval,scope) {
        if (newval === undefined){
          scope.$select.selected = undefined;
        }
      });
    }
  };
}

(function() {
  "use strict";

  angular
    .module("smakmak.services")
    .factory("PermissionsService", PermissionsService);

  PermissionsService.$inject = ["$log", "Restangular", "apiUrl"];

  function PermissionsService($log, Restangular, apiUrl) {
    var restPermissions = Restangular.all("roles", apiUrl + "/api/roles");
    var restGroups = Restangular.all("groups", apiUrl + "/api/groups");
    var restPermissionDefs = Restangular.all(
      "roleDefs",
      apiUrl + "/api/roledefs"
    );
    var restGroupDefs = Restangular.all("groupDefs", apiUrl + "/api/groupdefs");
    var restGroupRoles = Restangular.all(
      "groupRoles",
      apiUrl + "/api/grouproles"
    );

    var service = {
      getAllPermissions: getAllPermissions,
      getPermissionById: getPermissionById,
      editPermission: editPermission,
      getAllRoles: getAllRoles,
      getRoleById: getRoleById,
      getRolePermissions: getRolePermissions,
      editRolePermissions: editRolePermissions,
      editRole: editRole,
      addRole: addRole,
      getUserRoles: getUserRoles,
      editUserRoles: editUserRoles,
      deleteRole: deleteRole,
      getAgregatedUserPermissions: getAgregatedUserPermissions
    };

    return service;

    function getAllPermissions(fResponse, fError) {
      $log.debug("getAllPermissions");
      Restangular.all("roledefs")
        .getList()
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function getPermissionById(id, fResponse, fError) {
      $log.debug("getPermissionById");
      Restangular.one("roledefs", id)
        .get()
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function editPermission(restObject, fResponse, fError) {
      if (restObject.restangularized == true)
        restObject.save().then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function getAllRoles(fResponse, fError) {
      $log.debug("getAllrestGroupDefs");
      Restangular.all("groupdefs")
        .getList()
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function getRoleById(id, fResponse, fError) {
      Restangular.one("groupdefs", id)
        .get()
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function getRolePermissions(id, fResponse, fError) {
      Restangular.one("grouproles", id)
        .get()
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function editRolePermissions(id, objectList, fResponse, fError) {
      Restangular.one("grouproles", id)
        .post(undefined, objectList)
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function editRole(restObject, fResponse, fError) {
      if (restObject.restangularized == true)
        restObject.save().then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function addRole(name, description, fResponse, fError) {
      var object = {
        Name: name,
        Description: description
      };
      $log.debug("addRole");
      Restangular.all("groupdefs")
        .post(object)
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function getUserRoles(id, fResponse, fError) {
      Restangular.one("GroupUsers", id)
        .get()
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function editUserRoles(id, objectList, fResponse, fError) {
      Restangular.one("GroupUsers", id)
        .post(undefined, objectList)
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function deleteRole(Id, fResponse, fError) {
      Restangular.all("groupdefs")
        .customDELETE("" + Id)
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }

    function getAgregatedUserPermissions(id, fResponse, fError) {
      Restangular.one("GroupUsers", id)
        .customGET("allPermissions")
        .then(
          function(data) {
            ////response
            if (fResponse) fResponse(data);
          },
          function error(reason) {
            ////error
            if (fError) fError(reason.status);
            $log.debug("Error: " + reason.status);
          }
        );
    }
  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('NotificationsService', NotificationsService);

  NotificationsService.$inject = ['$log', 'Restangular'];

  function NotificationsService($log, Restangular) {


    var service = {
      getList: getList,
      getById: getById
    };

    return service;


    function getList(count ,fResponse, fError) {}

    function getById(id ,fResponse, fError) {}




  }
})();

(function () {
  'use strict';

  angular.module('smakmak.services').factory('AuthorizationService', AuthorizationService);

  AuthorizationService.$inject = ['$log', 'Restangular', '$sessionStorage', 'SessionService'];

  function AuthorizationService($log, Restangular, $sessionStorage, SessionService) {

    config();

    var service = {
      registerUser: registerUser,
      authenticateUser: authenticateUser,
      authenticateUserWithCredentials: authenticateUserWithCredentials,
      isUserLogged: isUserLogged,
      forgotPassword: forgotPassword,
      forgotPasswordConfirm: forgotPasswordConfirm,
      logOut: logOut,
      setAuthorisationHeader: setAuthorisationHeader,
      checkEmail: checkEmail,
      changePasswordByAdministrator: changePasswordByAdministrator
    };

    return service;

    function registerUser(email, password, confirmPassword, fResponse, fError) {
      var object = {
        "Email": email,
        "Password": password,
        "ConfirmPassword": confirmPassword

      };

      Restangular.all('account').customPOST(object, 'register').then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }

    function checkEmail(email, fResponse, fError){
      var object = {
        "Email": email,
        "Password": 'dumpdata',
        "ConfirmPassword": 'dumpdata'
      };
      Restangular.all('account').customPOST(object, 'CheckUser').then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }

    function authenticateUser(email, password, fResponse, fError) {
      var postSrt = "grant_type=password&username=" + email + "&password=" + password;

      Restangular.all('account').customPOST(postSrt, "token", undefined, {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }).then(function (data) {
        ////response
        SessionService.setAuthorisationHeader(data.token_type + " " + data.access_token);
        SessionService.setUserHeader(email);
        setAuthorisationHeader();
        setLoggedUserHeader();

        SessionService.loadData(function (data) {
            //if (fResponse)
            fResponse(data);
          }
          , function (error) {
            logOut();
            if (fError)
              fError(error);
          });
      }, function error(reason) {
        ////error
        logOut();
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }

    function authenticateUserWithCredentials(fResponse, fError)
    {
      setAuthorisationHeader(); //token już jest w localstorage wiec tylko go ustawiamy.
      setLoggedUserHeader();
      Restangular.all('account').customGET("UserInfo").then(function (data) {
        SessionService.loadData(function (data) {
            if (fResponse)
            fResponse(data);
          }
          , function (error) {
            logOut();
            if (fError)
              fError(error);
          });
      }, function error(reason){
        fError(reason);
      });
    }

    function isUserLogged() {
      return SessionService.isUserLogged();
    }

    function forgotPassword(email, fResponse, fError) {
      var object = {"Email": email};
      Restangular.all('account').customPOST(object, "ForgotPassword").then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }

    function forgotPasswordConfirm(email, code, password, fResponse, fError) {
      var object = {"Email": email, "Code": code, "Password": password};
      Restangular.all('account').customPOST(object, "ForgotPasswordConfirm").then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }

    function changePasswordByAdministrator(email, password, confirmPassword, fResponse, fError){
      var object = {
        "Email": email,
        "Password": password,
        "ConfirmPassword": confirmPassword
      };
      Restangular.all('account').customPOST(object, "SetPasswordByAdmin").then(function (data) {
        ////response
        if (fResponse)
          fResponse(data);
      }, function error(reason) {
        ////error
        if (fError)
          fError(reason.status);
        $log.debug("Error: " + reason.status);
      });
    }

    function logOut() {
      SessionService.clear();
      var defaultH = Restangular.defaultHeaders;
      delete defaultH['Authorization'];
      Restangular.setDefaultHeaders(defaultH);
    }

    function getHeaderForAuthorization() {
      return {
        'Authorization': SessionService.getAuthorisationHeader()
      };
    }

    function getHeaderForUser() {
      return {
        'x-smakmak-user': SessionService.getUserHeader()
      };
    }

    function setAuthorisationHeader()
    {
      var defaultH = Restangular.defaultHeaders;
      angular.extend(defaultH, getHeaderForAuthorization());
      Restangular.setDefaultHeaders(defaultH);
    }

    function setLoggedUserHeader()
    {
      var defaultH = Restangular.defaultHeaders;
      angular.extend(defaultH, getHeaderForUser());
      Restangular.setDefaultHeaders(defaultH);
    }

    function config() {

    }
  }
})();

(function () {
  "use strict";
  angular
    .module("smakmak.controllers")
    .controller("AcceptReturnController", AcceptReturnController);

  AcceptReturnController.$inject = [
    "$log",
    "$stateParams",
    "$state",
    "$filter",
    "$timeout",
    "$translate",
    "$location",
    "returnRest",
  ];

  function AcceptReturnController(
    $log,
    $stateParams,
    $state,
    $filter,
    $timeout,
    $translate,
    $location,
    returnRest
  ) {
    var vm = this;

    vm.disableButton = false;

    // FORMLY

    vm.isError = false;
    vm.isSend = false;
    vm.error = {};
    vm.code = $location.search().code;
    vm.text = "Akceptacja w toku, prosze nie wyłączać przeglądarki...";
    vm.result = undefined;

    constructor();

    function isGuid(guid) {
      const regex = new RegExp(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      );
      return regex.test(guid);
    }

    function constructor() {
      console.info(vm.code);
      if (!isGuid(vm.code)) {
        vm.text =
          "Błędny kod, proszę o ponowne skopiowanie linku z maila, jeśli to nie pomoże, proszę o kontakt z biurem obsługi";
        return;
      }
      returnRest
        .acceptByClient(vm.code)
        .then(function (ret) {
          vm.result = ret;
          switch (ret.code) {
            case "ACCEPTED":
              vm.text =
                "Zelecenie zaakceptowane. Po wygenerowaniu, zwroty zostaną wysłane na maila.";
              break;
            case "WRONG_STATUS":
              vm.text = "Zlecenie zostało już zaakceptowane";
              break;
            case "CODE_EXPIRED":
              vm.text =
                "Link stracił ważność. Proszę czekać, ponowny link zostanie wygenerowane wkrótce";
              break;
            case "NO_RECORD":
              vm.text =
                "Link zawiera kod który nie istnieje, prosze sprawdzić pocztę, czy nie został wygenerowany nowy link do akceptacji, jeśli nie, proszę o kontakt z biurem obsługi";
              break;
            default:
              vm.text =
                'Nieznany kod: "' +
                ret.code +
                '". Proszę o kontakt z biurem obsługi';
          }
        })
        .catch(function (err) {
          console.info(err);
        });
    }
    //vm.user.code = decodeURIComponent(decodeURI($stateParams.code)); //decodeURI

    // FORMLY

    ///////////
  }
})();

(function () {
  'use strict';
  angular.module('smakmak.controllers').controller('MainController', MainController);

  MainController.$inject = ['$log', '$scope', 'SessionService', '$localStorage'];
  //controler dla dashboard
  function MainController($log, $scope, SessionService, $localStorage) {
    var vm = this;
    vm.model = undefined;
    vm.dashboardName = "aaa";

    vm.getUser = getUser;
    console.log('MainController');

    constructor();

    function constructor() {
      vm.model = $localStorage.widgetDashboard;
      if (vm.model == undefined) {
        vm.model = {
          rows: [{
            columns: [{
              styleClass: 'col-md-4',
              widgets: [{
                type: 'visitOrderList',
                title: 'Wizyty - zamówienia wymagające uwagi',
                config: {mode: "1"}
              }]
            },
            {
              styleClass: 'col-md-4',
              widgets: [
              {
                type: 'visitOrderList',
                title: 'Wizyty - reklamacje wymagające uwagi',
                config: {mode: "2"}
              }]
            },
            {
              styleClass: 'col-md-4',
              widgets: [
              {
                type: 'visitOrderList',
                title: 'Wizyty - reklamacje jakościowe wymagające uwagi',
                config: {mode: "3"}
              }]
            }]
          }]
        };
      }
    }

    function getUser() {
      var aa = SessionService.getAuthenticatedUser();
      return aa;
    }
    $scope.$on('adfDashboardChanged', function (event, name, model) {
      $localStorage.widgetDashboard = model;
    });


  }
})();

(function () {
  "use strict";

  angular.module("smakMakweb").config(config);

  /** @ngInject */
  function config($translateProvider) {
    //translations
    $translateProvider.translations("pl", {
      headers: {
        users: {
          status: "Status",
          email: "Adres e-mail",
          name: "Imię",
          surname: "Nazwisko",
          actions: "Dostępne akcje",
          storage: "Magazyn",
          jobTitle: "Stanowisko",
        },
        roles: {
          name: "Nazwa roli",
          description: "Opis szczegółowy",
          actions: "Dostępne akcje",
        },
      },
      users: {
        search: {
          active: "Status",
          jobTitle: "Stanowisko",
          storage: "Magazyn",
          superior: "Przełożony",
        },
        user: {
          name: "Wprowadź imię.",
          surname: "Wprowadź nazwisko.",
          email: "Wprowadź adres e-mail.",
          storage: "Wybierz magazyn użytkownika.",
          status: "Status",
          address: "Wprowadź adres do korespondencji.",
          privatePhone: "Wprowadź prywatny numer.",
          businessPhone: "Wprowadź służbowy numer.",
          superior: "Wybierz przełożonego",
          jobTitle: "Wybierz stanowisko pracy",
          mobile: "Czy użytkownika może się logować do mobile",
          actions: "Dostępne akcje",
          addRole: "Dodaj rolę",
          removeRole: "Usuń rolę",
          roles: "Lista ról przypisanych do użytkownika:",
          label: {
            name: "Imię",
            surname: "Nazwisko",
            email: "E-mail",
            storage: "Domyślny magazyn",
            status: "Status",
            address: "Adres korespondencji",
            city: "Miasto zamieszkania",
            postalCode: "Kod pocztowy",
            streetWithNumber: "Ulica z numerem domu",
            privatePhone: "Prywatny numer telefonu",
            businessPhone: "Służbowy numer telefonu",
            superior: "Przełożony",
            jobTitle: "Stanowisko pracy",
            mobile: "Dostęp do mobile",
            employmentFrom: "Zatrudniony od",
            employmentTo: "Zatrudniony do",
          },
        },
        notifications: {
          added: "Użytkownik został dodany",
          updated: "Użytkownik został zaktualizowany",
          error: "Błąd przy zapisie danych",
        },
        actions: {
          actions: "Dostępne akcje",
          detailsEdit: "Szczegóły/Edycja",
          block: "Zablokuj użytkownika",
          activate: "Aktywuj użytkownika",
          active: "Aktywny",
          deactive: "Nieaktywny",
        },
        errors: {
          eMailSurnameRequired:
            "Proszę uzupełnić wszyskie wymagane pola: email, nazwisko!",
          dateFromDateTo:
            'Data "Zatrudniony do" powinna być większa od daty "Zatrudniony od"!',
        },
      },
      roles: {
        role: {
          name: "Nazwa roli",
          description: "Opis szczegółowy",
          actions: "Akcje",
          permission: {
            name: "Nazwa",
            description: "Szczegóły",
          },
        },
        actions: {
          actions: "Akcje",
          detailsEdit: "Szczegóły/Edycja",
          permissions: "Zmień uprawnienia",
          add: "Dodaj nową rolę",
        },
      },
      contractors: {
        search: {
          patron: "Opiekun",
          group: "Grupa",
          feature: "Cecha",
          blocked: "Status",
          type: "Typ",
        },
        notifications: {
          added: "Kontrahent został dodany",
          updated: "Kontrahent został zaktualizowany",
          error: "Błąd przy zapisie danych",
        },
        fields: {
          name: "Nazwa",
          NIP: "Numer identyfikacji podatkowej",
          actions: "Akcje",
          symbol: "Symbol",
        },
        modal: {
          warning: "Uwaga!",
          titleNipExists:
            "Wpisany NIP już istnieje dla następujących kontrahentów:",
          titleChangeStatus: "Zmiana statusu kontrahenta",
          ok: "Potwierdź",
          cancel: "Anuluj",
          totalRecordCount: "Całkowita loczba rekordów",
        },
        addContractor: "Dodaj kontrahenta",
        contractor: {
          name: "Wprowadź imię",
          surname: "Wprowadź nazwisko",
          email: "Wprowadź adres e-mail",
          storage: "Wybierz magazyn użytkownika",
          status: "Status",
          address: "Wprowadź adres do korespondencji",
          privatePhone: "Wprowadź prywatny numer",
          businessPhone: "Wprowadź służbowy numer",
          patron: "Wybierz opiekuna",
          actions: "Dostępne akcje",
          label: {
            isCompany: "Czy osoba fizyczna?",
            fullname: "Pełna nazwa",
            type: "Typ kontrahenta",
            name: "Nazwa",
            personName: "Imię",
            personSurname: "Nazwisko",
            www: "Strona internetowa",
            regon: "Regon",
            nip: "Numer identyfikacji podatkowej (NIP)",
            isDeliveryAddress: "Czy adres dostawy inny niż podstawowy?",
            email: "E-mail",
            storage: "Domyślny magazyn",
            status: "Status",
            deliveryAddress: "Adres dostawy",
            city: "Miasto",
            postalCode: "Kod pocztowy",
            street: "Ulica",
            suiteNumber: "Numer mieszkania",
            buildingNumber: "Numer budynku",
            province: "Województwo",
            country: "Kraj",
            patron: "Opiekun",
            phones: "Kontakt telefoniczny",
            priceLevel: "Kategoria cenowa",
            prefferedContact: "Preferowany sposób kontaktu",
            size: "Klasyfikacja powierzchni handlowej",
            createDateTime: "Data utworzenia",
            gln: "GLN",
            iln: "ILN",
            customSymbol: "Symbol własny kontrahenta",
            symbol: "Symbol",
            feature: "Cecha",
            group: "Grupa",
            note: "Uwagi",
            orderDocumentCategory: "Kategoria zamówienia",
            returnDocumentCategory: "Kategoria zwrotu w terminie",
            qualityReturnDocumentCategory: "Kategoria zwrotu jakościowego",
            defaultDocument: "Domyślny dokument zamówienia",
            payer: "Płatnik",
            isUsingEdi: "Korzysta z EDI",
            fsSend: "Wysyłanie FS",
            kfsSend: "Wysyłanie KFS",
            orderLoad: "Wczytywanie zamówień",
            fsTemplate: "Szablon do FS",
            kfsTemplate: "Szablon do KFS",
            prod: "Produkcyjne",
            test: "Testowe",
          },
          modal: {
            warning: "Uwaga!",
            titleNipExists:
              "Wpisany NIP już istnieje dla następujących kontrahentów:",
            ok: "Potwierdź",
            cancel: "Anuluj",
            totalRecordCount: "Całkowita loczba rekordów",
          },
          errors: {
            defaultAddressRequired:
              "Proszę uzupełnić wszyskie wymagane pola w sekcji Podstawowe informacje - adres podstawowy!",
            contactDataRequired:
              "Proszę uzupełnić wszyskie wymagane pola w sekcji Dane kontaktowe!",
          },
        },
        actions: {
          actions: "Dostępne akcje",
          detailsEdit: "Szczegóły/Edycja",
          active: "Aktywny",
          deactive: "Nieaktywny",
          add: "Dodaj nowego kontrahenta",
        },
        errors: {
          eMailSurnameRequired:
            "Proszę uzupełnić wszyskie wymagane pola: email, nazwisko!",
        },
      },
      counters: {
        name: "Liczniki",
        for: "dla",
        search: {
          date: "Data",
        },
        table: {
          user: "Użytkownik",
          gratis: "Gratisy",
          returns: "Zwroty",
          actions: "Akcje",
          counter: "Licznik",
          availableLimit: "dostępny limit: ",
          none: "brak",
          spent: "Wykorzystane",
        },
        notifications: {
          success: "Pomyślnie zmieniono wartości liczników",
          error: "Błąd przy zapisie danych",
          loadError: "Wystąpił błąd przy pobieraniu danych",
          tooMuch: "Przydzielono więcej niż dozwolona ilość",
        },
      },
      documents: {
        name: "aa",
        search: {
          dateFrom: "Data od",
          dateTo: "Data do",
          amountFrom: "Kwota od",
          amountTo: "Kwota do",
          category: "Kategoria",
          type: "Typ",
          countWarning1:
            "Ilość rekordów dla kryterium wyszukiwania została ograniczona do ",
          countWarning2: "z ",
          countWarning3: ".",
          contractor: "Kontrahent",
          status: "Status",
          storage: "Magazyn",
          documentNumber: "Numer dokumentu",
          drawer: "Użytkownik",
        },
        notifications: {
          sendAgain: "Ponownie wysłano do systemu księgowego",
          sendAgainError:
            "Błąd podczas ponownego wysłania do systemu księgowego",
          sendToClient: "Pomyślnie wysłano",
          sendError: "Błąd podczas wysyłania",
          changeStatus: "Zmieniono status dokumentu",
          changeError: "Nie udało się zmienić statusu dokumentu",
        },
        actions: {
          sendAgain: "Wyślij ponownie",
          sendToClient: "Wyślij",
        },
      },
      event: {
        measureUnit: {
          price: "PLN",
          percentage: "%",
        },
      },
      promotion: {
        type: {
          constant: "Promocja stała",
          variable: "Promocja zmienna",
        },
      },
      parametrization: {
        title: "Parametryzacja",
        holidays: "Święta",
        minimumOrderPrice: "Minimalna wartość zamówienia",
        visitCloseTime: "Czas zamknięcia wizyt",
        customParamsContractor: "Parametry kontrahenta",
        customParamsProduct: "Parametry produktu",
        productManufacturer: "Producent",
        companyData: {
          title: "Dane firmy",
          fullName: "Pełna nazwa",
          streetAndNumber: "Ulica i numer",
          cityName: "Miasto",
          postalCode: "Kod pocztowy",
          country: "Kraj",
          iln: "ILN",
          taxId: "NIP",
          nrb: "NRB",
        },
        notifications: {
          addHoliday: "Pomyślnie dodano nowe święto",
          addHolidayErr: "Wystąpił błąd przy dodawaniu nowego święta",
          removeHoliday: "Pomyślnie usunięto święto",
          removeHolidayErr: "Wystąpił błąd przy usuwaniu święta",
          holidayBadDate: "Wybrano niepoprawną datę dla święta",
          successChange: "Pomyślnie zmieniono wartość",
          errorChange: "Wystąpił błąd przy zmianie wartości",
          newValueSuccess: "Pomyślnie dodano nową wartość",
          newValueError: "Wystąpił błąd podczas dodawania nowej wartości",
          removeParam: "Pomyślnie usunięto parametr",
          removeParamErr: "Wystąpił błąd przy usuwaniu parametru",
          companyDataSuccess: "Pomyślnie zaktualizowano dane firmy",
          companyDataError: "Wystąpił błąd podczas aktualizowania danych",
        },
      },
      tasks: {
        name: "Cele",
        search: {
          dateFrom: "Data od",
          dateTo: "Data do",
          amountFrom: "Kwota od",
          amountTo: "Kwota do",
          category: "Kategoria",
          type: "Typ",
          countWarning1:
            "Ilość rekordów dla kryterium wyszukiwania została ograniczona do ",
          countWarning2: "z ",
          countWarning3: ".",
          contractor: "Kontrahent",
          status: "Status",
          storage: "Magazyn",
          name: "Nazwa",
          user: "Użytkownik",
        },
        type: {
          year: "Cel roczny",
          quarter: "Cel kwartalny",
          month: "Cel miesięczny",
          week: "Cel tygodniowy",
          other: "Cel inny",
          user: "Cel użytkownika",
          contractor: "Cel kontrahenta/grupy",
        },
        status: {
          notStarted: "Nierozpoczęty",
          inProgress: "Niezrealizowany",
          finished: "Zrealizowany",
        },
      },
      products: {
        search: {
          searchBox: "Wyszukaj",
          group: "Grupa",
        },
        notifications: {
          list: "Lista została zaktualizowana",
          added: "Produkt została dodany",
          updated: "Produkt został zaktualizowany",
          error: "Błąd przy zapisie danych",
          sendError: "Błąd przy wysyłce danych",
          loadError: "Błąd przy odczycie danych",
          removed: "Lista została usunięta",
        },
      },
      routes: {
        name: "Trasy",
        calendar: "Kalendarz",
        monthly: "Widok miesięczny",
        weekly: "Widok tygodniowy",
        route: {
          data: "Dane trasy",
          name: "Nazwa",
          date: "Data",
          cyclic: "Cykliczność",
          dateTo: "Do kiedy",
          concerns: "Dotyczy",
        },
        notifications: {
          added: "Trasa została dodana",
          updated: "Trasa została zaktualizowana",
          error: "Błąd przy zapisie danych",
          pastDate: "Wybrany dzień już się zakończył",
          sundayDrop: "Nie można dodać trasy na niedzielę",
          transfer: "Trasa została przeniesiona",
          trashDrop: "Pomyślnie usunięto trasę",
          movedAll: "Trasy przeniesione na innego użytkownika",
        },
      },
      promotions: {
        name: "Promocje",
        addNew: "Dodaj nową promocję",
        needsAccept: "Wymaga akceptacji",
        search: {
          name: "Nazwa",
          dateFrom: "Data od",
          dateTo: "Data do",
          type: "Typ",
          acceptance: "Wymagające akceptacji",
        },
      },
      promo: {
        name: "Promocja",
        notifications: {
          added: "Promocja została dodana",
          updated: "Promocja została zaktualizowana",
          error: "Wystąpił błąd przy zapisie danych",
          accepted: "Zaakceptowano promocję",
          notAccepted: "Wystąpił błąd przy akceptacji promocji",
        },
        view: {
          data: "Dane podstawowe",
          name: "Nazwa",
          dateFrom: "Obowiązuje od",
          dateTo: "Obowiązuje do",
          dateDelivery: "Data zatowarowania",
          type: "Typ",
          attachment: "Załączniki",
          invoice: {
            name: "Faktura marketingowa",
            number: "Numer faktury",
            date: "Data wystawienia faktury",
          },
        },
      },
      objectives: {
        name: "Zadania",
        search: {
          name: "Nazwa",
          dateFrom: "Data od",
          dateTo: "Data do",
          user: "Użytkownik",
          status: "Status",
          type: "Typ",
        },
        statusOptions: {
          Done: "Wykonane",
          NotDone: "Niewykonane",
          InProgress: "W trakcie",
          ToDoInFuture: "Do wykonania w przyszłości",
        },
        typeOptions: {
          User: "Użytkownik",
          Contractor: "Kontrahent",
          Group: "Grupa Kontrahentów",
        },
      },
      objective: {
        name: "Zadanie",
        data: {
          basic: "Dane podstawowe",
          name: "Nazwa",
          dateFrom: "Obowiązuje od",
          dateTo: "Obowiązuje do",
          done: "Wykonano",
          imagesQuantity: "Wymagana ilość zdjęć",
          description: "Opis",
          commentary: "Komentarz pracownika",
          concerns: "Dotyczy",
          subList: "Lista Podzadań",
          images: "Zdjęcia",
          action: "Wykonaj",
          user: "Użytkownik",
          contractor: "Kontrahent",
          group: "Grupa",
          OwnerUser: "Właściciel zadania",
        },
        notifications: {
          added: "Zadanie zostało dodane",
          updated: "Zadanie zostało zaktualizowane",
          error: "Błąd przy zapisie danych",
        },
      },
      visits: {
        name: "Wizyty",
        search: {
          dateFrom: "Data od",
          dateTo: "Data do",
          user: "Użytkownik / Kierownik",
          contractor: "Kontrahent",
          noContractor: "Brak wybranego kontrahenta",
          contractorSymbol: "Symbol kontrahenta",
          orderAcceptanceRequired: "Zamówienia wymagające akceptacji",
          returnAcceptanceRequired: "Korekty wymagające akceptacji",
          orderStatus: "Status zamówienia",
          timeReturnStatus: "Status korekty w terminie",
          qualityReturnStatus: "Status korekty jakościowej",
          qualityReturnSum: "Suma zwrotów jakościowch",
          returnSum: "Suma korekt w terminie",
          orderSum: "Suma zamówień",
          samplesSum: "Suma próbek",
          degustationsSum: "Suma degustacji",
          counter: "Licznik zwrotów",
          comment: "Uwagi",
        },
        notifications: {
          changeSuccess: "Pomyślnie zapisano zmiany",
          changeError: "Błąd przy zapisie zmian",
        },
        actions: {
          add: "Dodaj wizytę",
        },
      },
      visit: {
        title: "Wizyta z dnia: ",
        noDocument: "Brak dokumentu",
        data: {
          basic: {
            title: "Dane podstawowe",
            user: "Użytkownik",
            date: "Data wizyty",
            route: "Nazwa trasy",
          },
          contractor: "Odbiorca",
          payer: "Płatnik",
          note: "Uwagi",
          order: {
            title: "Zamówienie",
            name: "Nazwa dokumentu",
            net: "Wartość netto zamówienia",
            gross: "Wartość brutto zamówienia",
          },
          giveback: {
            deadline: "Zwrot w terminie",
            quality: "Zwrot jakościowy",
            name: "Nazwa dokumentu",
            net: "Wartość netto zamówienia",
            gross: "Wartość brutto zamówienia",
          },
          samples: {
            sample: "Próbki",
            degustation: "Degustacje",
            name: "Nazwa dokumentu",
            net: "Wartość netto",
            gross: "Wartość brutto",
          },
        },
      },
      changeStorageConfirm: {
        title: "Proszę potwiedzić akceptację logstyczną",
        count: "Ilość zamówień",
        storage: "Przypisany magazyn",
        releaseDate: "Data wystawienia",
        finishDate: "Data dostawy",
        confirm: "Zatwierdź",
        cancel: "Anuluj",
      },
      upload: {
        title: "Wgrywanie załącznika",
        chosen: "Wybrano plik: ",
        progress: "Postęp: ",
        sizeError: "Zbyt duży rozmiar pliku (do 500KB)",
      },
      login: {
        title: "SmakMAK logowanie do systemu.",
        stayLoggedCheckbox: "Pozostań zalogowany.",
        states: {
          emailInvalid: "Wprowadzono nieprawidłowy adres e-mail.",
          passwordInvalid: "Wprowadzono nieprawidłowe hasło.",
          emailNotRegistered:
            "Użytkownik nie został jeszcze zarejestrowany. Skontaktuj się z administratorem.",
          emailInactive:
            "Użytkownik nieaktywny. Prosze o kontakt z administratorem.",
        },
      },
      reset: {
        title: "SmakMAK resetowanie hasła.",
        titleConf: "SmakMAK wybranie nowego hasła.",
        confirm: "Potwierdzenie hasła",
        button: "Wyślij procedurę resetowania hasła",
        buttonConf: "Ustaw nowe hasło",
        passwordConf: "Nowe hasło.",
        passwordConf2: "Potwierdź nowe hasło.",
      },
      register: {
        title: "SmakMAK rejestracja",
        register: "Rejestruj użytkownika",
        changePassword: "Zmień hasło",
      },
      templates: {
        notifications: {
          nameExists: "Istnieje już szablon o podanej nazwie",
          sendError: "Błąd przy zapisie danych",
          sendSuccess: "Pomyślnie dodano szablon",
          updateSuccess: "Pomyślnie zaktualizowano szablon",
          validateSuccess: "Pomyślnie wygenerowano zawartość",
          validateError: "Błąd podczas generowania szablonu",
          validateNoDocumentNumber: "Podaj poprawny numer dokumentu",
          loadSingleError: "Błąd podczas pobierania szablonu",
          deleteSuccess: "Pomyślnie usunięto szablon",
          deleteError: "Błąd podczas usuwania szablonu",
          deleteIsUsed: "Szablon jest przypisany do jednego z kontrahentów",
        },
      },
      confirmModal: {
        warning: "Uwaga!",
        ok: "Potwierdź",
        cancel: "Anuluj",
        totalRecordCount: "Całkowita loczba rekordów",
        bodyChangeStatus: "Uwaga zamierzasz zmienić status rekordu!",
        contractor: {
          titleNipExists:
            "Wpisany NIP już istnieje dla następujących kontrahentów:",
        },
        contractors: {
          titleNipExists:
            "Wpisany NIP już istnieje dla następujących kontrahentów:",
        },
      },
      dict: {
        phonetype: {
          stationary: "Stacjonarny",
          gsm: "Komórkowy",
          fax: "Fax",
          private: "Prywatny",
          business: "Służbowy",
        },
        jobTitle: {
          owner: "Właściciel",
          director: "Dyrektor",
          regionalManager: "Kierownik regionu",
          salesRepresentative: "Przedstawiciel handlowy",
          administrationDirector: "Dyrektor administracyjny",
          administrationUser: "Pracownik administracyjny",
        },
      },
      common: {
        grid: {
          searchBox: "Wyszukaj",
        },
        notifications: {
          deleteSuccess: "Pomyślnie usunięto",
          deleteError: "Wystąpił błąd przy usuwaniu",
        },
        form: {
          email: "Wprowadź adres e-mail.",
          password: "Wprowadź hasło.",
          passwordConf: "Wprowadź hasło.",
          login: "Zaloguj",
          remindMe: "Zapamiętaj mnie",
          help: "Nie pamiętam hasła. Chcę ustawić nowe hasło.",
          register: "Rejestracja",
          confirm: "Zapisz",
          add: "Dodaj",
          //'reset': 'Wyślij na maila',
          checkbox: "Wybierz",
        },
        actions: {
          add: "Dodaj",
          delete: "Usuń",
          change: "Zmień",
          goBack: "Wróć",
          clear: "Wyczyść",
          accept: "Zaakceptuj",
          print: "Drukuj",
          printMarked: "Drukuj zaznaczone",
        },
        fields: {
          sent: "Wysłane",
          toSend: "Do wysłania",
        },
        validators: {
          differentPasswords: "Hasła nie są identyczne",
        },
        services: {
          "-1":
            "Problemy z połączeniem, proszę skontaktować się z administratorem systemu",
          400: "Brak użytkownika lub hasła",
          401: "error:401",
          404: "Brak rekordu w bazie danych",
          500: "Bład z połączeniem. Prosimy spróbować ponownie później.",
          forgotPassword: {
            400:
              "Brak email, proszę poprawić adres email lub skontaktować się z administratorem systemu.",
          },
          forgotPasswordConfirm: {
            400:
              "Błędny adres e-mail lub link został już wykorzystany do zresetowania hasła.",
          },
          register: {
            400: "Użytkownik już jest zarejestrowany",
            formInvalid: "Proszę uzupełnić wszyskie wymagane pola!",
          },
          roles: {
            409: "Nie można usunąć roli przypisanej do użytkowników!",
          },
        },
      },
      navbar: {
        manage: {
          title: "Moduł użytkowników",
          users: "Zarządzaj użytkownikami",
          permissions: "Zarządzaj uprawnieniami",
          roles: "Zarządzaj uprawnieniami",
          counters: "Zarządzaj licznikami",
        },
        crm: {
          title: "Moduł kontrahentów",
          contractors: "Zarządzaj kontrahentami",
          advisors: "Opiekunownie",
          addContractor: "Dodaj kontrahenta",
        },
        "doc-task": {
          title: "Dokumenty i Cele",
          documents: "Zarządzaj dokumentami",
          tasks: "Zarządzaj celami",
          samples: "Zarządzaj próbkami",
          degustations: "Zarządzaj degustacjami",
        },
        products: {
          excluded: "Wyłączone ze sprzedaży",
          title: "Produkty",
          products: "Zarządzaj produktami",
          preferredProd: "Zarządzaj preferowanymi produktami",
          promotions: "Zarządzaj promocjami",
        },
        "rout-obj": {
          title: "Trasy i zadania",
          routes: "Zarządzaj trasami",
          objectives: "Zarządzaj zadaniami",
        },
        visits: {
          title: "Wizyty",
          visits: "Zarządzaj wizytami",
        },
        app: {
          title: "Zarządzaj aplikacją",
          params: "Parametry",
          templates: "Szablony",
        },
        documentSystem: {
          title: "System dokumentów",
        },
      },
    });

    //  <h1>{{'component1.service1.400' | translate}}</h1>

    // Enable escaping of HTML
    $translateProvider.useSanitizeValueStrategy("escape");

    $translateProvider.preferredLanguage("pl");
  }
})();

(function () {
  "use strict";

  angular.module("smakMakweb").run(runBlock);

  /** @ngInject */
  function runBlock(
    $log,
    $rootScope,
    $state,
    AuthorizationService,
    Restangular,
    formlyValidationMessages,
    formlyConfig,
    LoginModalService,
    uibPaginationConfig
  ) {
    $rootScope.$on(
      "$stateChangeStart",
      function (event, toState, toParams, fromState, fromParams) {
        if (
          !(
            toState.name == "login" ||
            fromState.name == "login" ||
            toState.name == "register" ||
            toState.name == "resetpass" ||
            toState.name == "resetpassconfirm" ||
            toState.name == "error" ||
            toState.name == "acceptreturns"
          )
        ) {
          if (!AuthorizationService.isUserLogged()) {
            event.preventDefault();
            $state.go("login");
          }
        }
      }
    );

    if (AuthorizationService.isUserLogged()) {
      AuthorizationService.setAuthorisationHeader();
    }

    Restangular.setErrorInterceptor(function (
      response,
      deferred,
      responseHandler
    ) {
      if (response.status === 401) {
        LoginModalService.showLoginModal();
        return false; // error handled
      }

      return true; // error not handled
    });
    Restangular.configuration.restangularFields.id = "Id";

    //UI Bootstrap
    // uibPaginationConfig.next-text="Następne";
    //END UI Bootstrap

    //ANGULAR-DATATABLES
    //DTDefaultOptions.setLanguageSource('//cdn.datatables.net/plug-ins/1.10.9/i18n/Polish.json');

    //FORMLY
    formlyValidationMessages.addStringMessage("required", "Pole wymagane!");
    //    formlyValidationMessages.addStringMessage('min-length', 'Minimalna długość ' + to.field + ' to: '+length);
    //FORMLY END

    $log.debug("runBlock end");
  }
})();

(function () {
  "use strict";

  angular.module("smakMakweb").config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state("home", {
        url: "/home",
        views: {
          "": { templateUrl: "app/main/main.html" },
        },
      })
      .state("login", {
        url: "/login",
        views: {
          "": {
            templateUrl: "app/components/login/login.html",
          },
        },
      })
      .state("resetpass", {
        url: "/resetpass",
        views: {
          "": {
            templateUrl: "app/components/reset/reset.password.html",
            controller: "ResetController",
            controllerAs: "vm",
          },
        },
      })
      .state("acceptreturns", {
        url: "/acceptreturns",
        views: {
          "": {
            templateUrl: "app/components/acceptreturn/acceptreturn.html",
            controller: "AcceptReturnController",
            controllerAs: "vm",
          },
        },
      })
      .state("resetpassconfirm", {
        url: "/resetpassconfirm/:code",
        views: {
          "": {
            templateUrl: "app/components/reset/reset.password.confirm.html",
            controller: "ResetController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.mainPage", {
        url: "/mainPage",
        views: {
          content: {
            templateUrl: "app/main/mainPage.html",
            controller: "MainController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.users", {
        url: "/users",
        views: {
          content: {
            templateUrl: "app/components/users/users.html",
            controller: "UsersController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.users.user", {
        url: "/user/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/users/user.html",
            controller: "UserController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.users.registerPass", {
        url: "/registerPass/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/users/user.register.html",
            params: { user: undefined },
            controller: "RegisterController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.rights", {
        url: "/permissions",
        views: {
          content: {
            templateUrl: "app/components/permissions/permissions.html",
            controller: "PermissionsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.roles", {
        url: "/roles",
        views: {
          "content@home": {
            templateUrl: "app/components/permissions/roles.html",
            controller: "PermissionsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.roles.role", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/permissions/role.html",
            controller: "RoleController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.contractors", {
        url: "/contractors",
        params: {
          pagingData: undefined,
        },
        views: {
          "content@home": {
            templateUrl: "app/components/contractors/contractors.html",
            controller: "ContractorsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.contractors.contractor", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/contractors/contractor.html",
            controller: "ContractorController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.documents", {
        url: "/documents",
        views: {
          "content@home": {
            templateUrl: "app/components/documents/documents.html",
            controller: "DocumentsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.documents.document", {
        url: "/:id",
        params: { cameFrom: "documents", previousPageId: undefined },
        views: {
          "content@home": {
            templateUrl: "app/components/documents/document.html",
            controller: "DocumentController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.documents.history", {
        url: "/documents/history",
        views: {
          "content@home": {
            templateUrl: "app/components/documents/documents.history.html",
            controller: "DocumentsHistoryController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.documents.history.document", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/documents/document.history.html",
            controller: "DocumentHistoryController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.degreport", {
        url: "/degreport",
        views: {
          "content@home": {
            templateUrl:
              "app/components/documents/reports/degustations.report.html",
            controller: "DegustationsReportController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.producthisotoryreport", {
        url: "/productreport",
        views: {
          "content@home": {
            templateUrl:
              "app/components/documents/reports/history.product.report.html",
            controller: "DocumentHistoryReportController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.order", {
        url: "/order/:id",
        params: {
          contractor: undefined,
          route: undefined,
          routeEntity: undefined,
        },
        views: {
          "content@home": {
            templateUrl: "app/components/order/order.html",
            controller: "OrderController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.tasks", {
        url: "/tasks",
        views: {
          "content@home": {
            templateUrl: "app/components/tasks/tasks.html",
            controller: "TasksController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.tasks.task", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/tasks/task.html",
            controller: "TaskController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.tasks.userTask", {
        url: "/userTask/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/tasks/userTask.html",
            controller: "UserTaskController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.samples", {
        url: "/samples",
        params: { typeId: undefined },
        views: {
          "content@home": {
            templateUrl: "app/components/samples/samples.html",
            controller: "SamplesController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.samples.sample", {
        url: "/:id",
        params: { cameFrom: "samples", previousPageId: undefined },
        views: {
          "content@home": {
            templateUrl: "app/components/samples/sample.html",
            controller: "DocumentController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.excludedProducts", {
        url: "/excludedProducts",
        views: {
          "content@home": {
            templateUrl:
              "app/components/excludedProducts/excludedProducts.html",
            controller: "ExcludedProductsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.products", {
        url: "/products",
        views: {
          "content@home": {
            templateUrl: "app/components/products/products.html",
            controller: "ProductsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.products.one", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/products/product.html",
            controller: "ProductController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.preferredProductsList", {
        url: "/preferredProductsList",
        views: {
          "content@home": {
            templateUrl: "app/components/products/preferredProductsList.html",
            controller: "PreferredProductsListController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.preferredProductsList.one", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/products/preferredProducts.html",
            controller: "PreferredProductsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.parametrization", {
        url: "/parametrization",
        views: {
          "content@home": {
            templateUrl: "app/components/parametrization/parametrization.html",
            controller: "ParametrizationController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.notifications", {
        url: "/notifications",
        views: {
          "content@home": {
            templateUrl: "app/components/notifications/notifications.html",
            controller: "NotificationsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.routes", {
        url: "/routes",
        params: { shouldReload: true },
        views: {
          "content@home": {
            templateUrl: "app/components/routes/routes.html",
            controller: "RoutesController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.promotions", {
        url: "/promotions",
        views: {
          "content@home": {
            templateUrl: "app/components/promotions/promotions.html",
            controller: "PromotionsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.promotions.promotion", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/promotions/promotion.html",
            controller: "PromotionController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.objectives", {
        url: "/objectives",
        views: {
          "content@home": {
            templateUrl: "app/components/objectives/objectives.html",
            controller: "ObjectivesController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.objectives.objective", {
        url: "/:typeId/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/objectives/objective.html",
            controller: "ObjectiveController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.visits", {
        url: "/visits",
        views: {
          "content@home": {
            templateUrl: "app/components/visits/visits.html",
            controller: "VisitsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.visits.visit", {
        url: "/:id",
        params: { cameFrom: "visits" },
        views: {
          "content@home": {
            templateUrl: "app/components/visits/visit.html",
            controller: "VisitController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.returns", {
        url: "/returns",
        views: {
          "content@home": {
            templateUrl: "app/components/returns/returns.html",
            controller: "ReturnsController",
            controllerAs: "vm",
          },
        },
      })

      .state("home.returns.return", {
        url: "/:id",
        params: { cameFrom: "returns" },
        views: {
          "content@home": {
            templateUrl: "app/components/returns/return.html",
            controller: "ReturnController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.reports", {
        url: "/reports",
        views: {
          "content@home": {
            templateUrl: "app/components/reports/reports.html",
            controller: "ReportsController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.counters", {
        url: "/counters/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/counters/counters.html",
            controller: "CountersController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.templates", {
        url: "/templates",
        views: {
          "content@home": {
            templateUrl: "app/components/templates/templates.html",
            controller: "TemplatesController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.templates.template", {
        url: "/:id",
        views: {
          "content@home": {
            templateUrl: "app/components/templates/template.html",
            controller: "TemplateController",
            controllerAs: "vm",
          },
        },
      })
      .state("home.img", {
        url: "/img",
        views: {
          "content@home": {
            templateUrl: "app/components/test/imgUpload.html",
            controller: "ImgUploadController",
            controllerAs: "vm",
          },
        },
      })
      .state("error", {
        url: "error/:id",
        views: {
          "": {
            templateUrl: "app/components/error/error.html",
            controller: "ErrorController",
            controllerAs: "vm",
          },
        },
      });

    $urlRouterProvider.otherwise("/login");
  }
})();

/* global malarkey:false, toastr:false, moment:false */
(function () {
  "use strict";

  angular
    .module("smakMakweb")
    .constant("malarkey", malarkey)
    .constant("apiUrl", "https://api.smakmak.nextapps.pl/api")
    //.constant("apiUrl", "https://api.smakmak-test.nextapps.pl/api")
    .run(function ($rootScope, apiUrl) {
      $rootScope.API_URL = apiUrl;
    });
})();

(function () {
  "use strict";

  angular.module("smakMakweb").config(config);

  /** @ngInject */
  function config(
    $logProvider,
    $httpProvider,
    $locationProvider,
    RestangularProvider,
    formlyConfigProvider,
    LightboxProvider,
    NotificationProvider /*, dashboardProvider*/,
    apiUrl
  ) {
    // Enable log
    $logProvider.debugEnabled(true);
    Date.i18n.setLanguage("pl-PL");
    $httpProvider.defaults.withCredentials = true;

    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
    });
    RestangularProvider.setBaseUrl(apiUrl);
    RestangularProvider.setDefaultHeaders({
      SourceApp: "W",
    });

    // check count for requests
    RestangularProvider.addResponseInterceptor(function (
      data,
      operation,
      what,
      url,
      response,
      deferred
    ) {
      var data = response.data;
      var totalCount = response.headers("TotalCount");
      var nextSymbol = response.headers("NextSymbol");
      var totalAmount = response.headers("TotalAmount");

      if (totalCount) {
        data.totalCount = totalCount;
      }
      if (nextSymbol) {
        data.nextSymbol = nextSymbol;
      }
      if (totalAmount) {
        data.totalAmount = totalAmount;
      }
      return data;
    });

    //Formly
    formlyConfigProvider.extras.removeChromeAutoComplete = true;
    // formlyConfigProvider.extras.errorExistsAndShouldBeVisibleExpression = true;
    formlyConfigProvider.setWrapper([
      {
        template: [
          "<formly-transclude></formly-transclude>",
          '<div ng-if="showError" class="my-messages" ng-messages="fc.$error" ng-if="options.formControl.$touched">',
          '  <div class="some-message" ng-message="{{::name}}" ng-repeat="(name, message) in ::options.validation.messages">',
          "   {{message(fc.$viewValue, fc.$modelValue, this)}}",
          "  </div>",
          "</div>",
        ].join(" "),
      },
    ]);

    formlyConfigProvider.setType({
      name: "ui-select-multiple",
      extends: "select",
      templateUrl:
        "app/components/commonComponents/ui-select/ui-select2-multi.html",
    });

    formlyConfigProvider.setType({
      name: "ui-select-single",
      extends: "select",
      templateUrl: "ui-select-single.html",
    });

    formlyConfigProvider.setType({
      name: "ui-select-single2",
      extends: "select",
      templateUrl: "ui-select-single2.html",
    });
    //FORMLY END

    //LIGHTBOX METHODS for finding url and caption for opened in modal image
    LightboxProvider.getImageUrl = function (image) {
      return apiUrl + "/MediaFiles/" + image.Id + "/content";
    };

    LightboxProvider.getImageCaption = function (image) {
      return image.label;
    };
    //LIGHTBOX METHODS END

    NotificationProvider.setOptions({
      startTop: 50,
      startRight: 10,
    });

    /*dashboardProvider
          .structure('4-4-4', {
            rows: [{
              columns: [{
                styleClass: 'col-md-4',
                widgets: []
              }, {
                styleClass: 'col-md-4',
                widgets: []
              },
              {
                styleClass: 'col-md-4',
                widgets: []
              }]
            }]
          })*/
  }
})();

angular.module("smakMakweb").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=container-fluid><nxas-navbar></nxas-navbar><div class=content><div ui-view=content></div></div></div>");
$templateCache.put("app/main/mainPage.html","<div id=wrapper><div id=page-wrapper><div class=row><div class=col-lg-12><h3 class=page-header>Wirtualny pulpit użytkownika: {{vm.getUser().Name + \' \' + vm.getUser().SurName}}</h3></div><!-- /.col-lg-12 --></div><!--<adf-dashboard name=\"vm.dashboardName\" collapsible=\"true\" editable=\"true\" structure=\"6-6\" adf-model=\"vm.model\" />--><!-- /.row --></div><!-- /#page-wrapper --></div><!-- /#wrapper -->");
$templateCache.put("app/components/acceptreturn/acceptreturn.html","<div class=container><div class=row><div class=\"col-sm-6 col-md-4 col-md-offset-4\"><div class=account-wall><div class=logo></div><h1 class=\"text-center login-title\">{{vm.text}}</h1><h1 class=\"text-center login-title\" ng-if=vm.result.caseNumber>Numer sprawy: {{vm.result.caseNumber}}</h1><h1 class=\"text-center login-title\" ng-if=vm.result.caseNumber>Czas akceptacji: {{vm.result.time | date: \"yyyy-MM-dd H:M:s\"}}</h1></div></div></div></div>");
$templateCache.put("app/components/commonComponents/confirm.modal.html","<div class=modal-header><h3 class=modal-title>{{vm.content.title | translate}}</h3></div><div class=modal-body><div ng-if=\"vm.content.type == 2\">{{vm.content.topBodyText | translate}}<table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader rowSymbol\">{{\'contractors.fields.symbol\' | translate}}</th><th class=\"uiGridHeader rowName\">{{\'contractors.fields.name\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.content.body\"><th><span ng-bind=key.Symbol></span></th><td><span ng-bind=key.Name></span></td></tr></tbody></table>{{}}</div><div ng-if=\"vm.content.type == 1\">{{vm.content.topBodyText | translate}}</div></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=vm.ok()>{{vm.content.okText | translate}}</button> <button class=\"btn btn-warning\" type=button ng-click=vm.cancel()>{{vm.content.cancelText | translate}}</button></div>");
$templateCache.put("app/components/counters/counters.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{ \"counters.name\" | translate }} <span ng-if=\"vm.counters.User != undefined\">{{ \"counters.for\" | translate }}: {{ vm.counters.User.Name + \" \" + vm.counters.User.SurName }}</span></div><div class=panel-body><div><div><div class=row><div class=col-sm-4><label class=control-label>Przedział</label><ui-select ng-model=vm.selectedPeriod theme=bootstrap on-select=\"vm.onPeriodSelect($item, $model)\"><ui-select-match data-allow-clear=false placeholder=Brak>{{ $select.selected.BeginDate | date: \"yyyy-MM-dd\" }} - {{ $select.selected.EndDate | date: \"yyyy-MM-dd\" }}</ui-select-match><ui-select-choices repeat=\"period.Id as period in vm.periods | filter: $select.search\"><div><span ng-bind-html=\"period.BeginDate | date:\'yyyy-MM-dd\'\"></span> - <span ng-bind-html=\"period.EndDate | date:\'yyyy-MM-dd\'\"></span></div></ui-select-choices></ui-select><button class=\"btn btn-primary btn-submit\" style=\"float: right; border-right: 10px\" ng-show=\"vm.checkPermission(40) && vm.showEdit\" ng-click=vm.editPeriod() ng-disabled=\"(vm.isSaving) || !vm.selectedPeriodObject\">Edytuj</button> <button class=\"btn btn-primary btn-submit\" style=\"float: right; border-right: 10px\" ng-show=\"vm.checkPermission(40) && vm.showEdit\" ng-click=vm.addPeriod() ng-disabled=(vm.isSaving)>{{ \"common.form.add\" | translate }}</button></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 30%\">{{ \"counters.table.user\" | translate }}</th><th class=uiGridHeader style=\"width: 30%\">{{ \"counters.table.counter\" | translate }} <span ng-if=\"vm.counters.TimeReturnCounter != undefined\">({{ \"counters.table.availableLimit\" | translate }} <span ng-if=vm.counters.IsUnlimited>{{ \"counters.table.none\" | translate }})</span> <span ng-if=!vm.counters.IsUnlimited>{{ vm.counters.TimeReturnCounter.DecimalValue }})</span> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Rozdziel po równo\" popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.splitToAll(\'TimeReturnCounter\')\" style=float:right ng-if=!vm.counters.IsUnlimited><span class=\"glyphicon glyphicon-sort-by-attributes-alt\" aria-hidden=true></span></button></span></th><th class=uiGridHeader style=\"width: 30%\">{{ \"counters.table.spent\" | translate }}</th><th class=uiGridHeader style=\"width: 10%\">{{ \"counters.table.actions\" | translate }}</th></tr></thead><tbody><tr ng-repeat=\"employee in vm.counters.Employees\"><th><span uib-popover=\"{{\r\n                      employee.User.Name + \' \' + employee.User.SurName\r\n                    }}\" popover-trigger=mouseenter style=\"margin-top:7px; display:inline-block\" popover-append-to-body=true>{{ employee.User.Name + \" \" + employee.User.SurName }}</span></th><!-- old - two counters\r\n              <td>\r\n                <input class=\"form-control\" ng-model=\"employee.SampleCounter.DecimalValue\" type=\"number\"/>\r\n              </td>\r\n            --><td><input class=form-control ng-model=employee.TimeReturnCounter.DecimalValue type=number></td><td><span style=\"margin-top:7px; display:inline-block\" ng-if=!vm.counters.EditUserEmployees>{{ employee.TimeReturnCounter.CurrentDecimalValue }}</span> <span style=\"margin-top:7px; display:inline-block\" ng-if=vm.counters.EditUserEmployees>-</span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Przejdź popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.goToUser(employee.User.Id) style=\"margin-top: 7px\" ng-if=vm.counters.EditUserEmployees ng-disabled=vm.isSaving><span class=\"glyphicon glyphicon-arrow-right\" aria-hidden=true></span></button></td></tr></tbody></table><button class=\"btn btn-primary btn-submit\" style=\"float: right\" ng-click=vm.submit() ng-disabled=\"(vm.counters.User == undefined)||(vm.isSaving)\">{{ \"common.form.confirm\" | translate }}</button></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div></div>");
$templateCache.put("app/components/contractors/contractor-tabs.html","<div class=\"col-sm-16 col-md-12\"><div ng-show=vm.isError class=\"alert alert-danger alert-dismissible alert-login\" role=alert>{{vm.error}}</div><!-- <div class=\"alert alert-warning\" role=\"alert\">\n    contractor: {{vm.contractor}}<br> --><!-- DefaultAddress.CountryId: {{vm.contractor.DefaultAddress.CountryId}}<br> --><!-- FeatureIds: {{vm.contractor.FeatureIds}}<br> --><!-- vm.dictionaryData.ContractorType: {{vm.dictionaryData.ContractorType}} --><!-- </div> --></div><div class=\"col-sm-16 col-md-12\"><uib-tabset><uib-tab heading=\"Podstawowe informacje\"><div><input type=checkbox name=isPerson ng-model=vm.contractor.IsPerson>&nbsp;&nbsp;&nbsp;&nbsp;{{\'contractors.contractor.label.isCompany\' | translate}}</div><formly-form model=vm.contractor fields=vm.contractorFields></formly-form><div><label>{{\'contractors.contractor.label.patron\' | translate}}</label><ui-select ng-model=vm.contractor.PatronId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name + \" \" + $select.selected.SurName | truncate:25}}</ui-select-match><ui-select-choices repeat=\"selectChoiceUser.Id as selectChoiceUser in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"selectChoiceUser.Name + \' \' + selectChoiceUser.SurName | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'users.user.label.storage\' | translate}}</label><ui-select ng-model=vm.contractor.StorageId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:36}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div><div><label class=control-label>{{\'contractors.contractor.label.type\' | translate}}</label><ui-select ng-model=vm.contractor.Type ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorType | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></uib-tab><uib-tab heading=\"Dane kontaktowe\"><formly-form model=vm.contractor fields=vm.contactDataFields form=vm.contactDataForm></formly-form><div>Adres firmy po NIP (link do CEIDG): <a href=https://prod.ceidg.gov.pl/ceidg/ceidg.public.ui/search.aspx target=_blank>Sprawdź</a></div></uib-tab><uib-tab heading=\"Adres podstawowy\"><div><input type=checkbox name=IsDeliveryAddress ng-model=vm.contractor.IsDeliveryAddress>&nbsp;&nbsp;&nbsp;&nbsp;{{\'contractors.contractor.label.isDeliveryAddress\' | translate}}</div><formly-form model=vm.contractor fields=vm.defaultAddressFields form=vm.defaultAddressForm></formly-form><label class=control-label>{{\'contractors.contractor.label.province\' | translate}}</label><ui-select ng-model=vm.contractor.DefaultAddress.ProvinceId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ProvinceDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><label class=control-label>{{\'contractors.contractor.label.country\' | translate}}</label><ui-select ng-model=vm.contractor.DefaultAddress.CountryId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.CountryDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></uib-tab><uib-tab heading=\"Adres dostawy\"><formly-form model=vm.contractor fields=vm.deliveryAddressFields form=vm.deliveryAddressForm></formly-form><label class=control-label>{{\'contractors.contractor.label.province\' | translate}}</label><ui-select ng-model=vm.contractor.deliveryAddress.ProvinceId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ProvinceDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><label class=control-label>{{\'contractors.contractor.label.country\' | translate}}</label><ui-select ng-model=vm.contractor.deliveryAddress.CountryId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.CountryDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></uib-tab><uib-tab heading=\"Dane rozszerzone\"><div><label class=control-label>{{\'contractors.contractor.label.priceLevel\' | translate}}</label><ui-select ng-model=vm.contractor.PriceLevelId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.PriceLevel | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.prefferedContact\' | translate}}</label><ui-select ng-model=vm.contractor.PrefferedContactId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.PrefferedContact | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.feature\' | translate}}</label><ui-select multiple ng-model=vm.contractor.FeatureIds ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$item.Value}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorFeature | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div><label class=control-label>{{\'contractors.contractor.label.size\' | translate}}</label><ui-select ng-model=vm.contractor.ContractorSize ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorSizeDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><formly-form model=vm.contractor fields=vm.contractorExtendedFields form=vm.extendedForm></formly-form></uib-tab><uib-tab heading=Notatki><formly-form model=vm.contractor fields=vm.notesFields form=vm.notesForm></formly-form></uib-tab></uib-tabset></div><button type=submit class=\"btn btn-primary btn-lg btn-submit\" ng-click=vm.submit(vm.contractor) ng-show=vm.checkPermission(8)>{{\'common.form.confirm\' | translate}}</button>");
$templateCache.put("app/components/contractors/contractor.html","<div class=\"panel panel-default panel-table\"><div class=panel-heading>Kontrahent: {{vm.contractor.Name}}</div><div class=panel-body><div class=row><div class=\"col-sm-16 col-md-12\"><div ng-show=vm.isError class=\"alert alert-danger alert-dismissible alert-login\" role=alert>{{vm.error}}</div></div><div class=\"col-sm-12 col-md-12\"><uib-alert ng-show=vm.showStatusAlert>Kontrahent nie znajduje się jeszcze w bazie danych Subiekt. Aby to zrobić, proszę go zatwierdzić lub skontaktować się z osobą posiadającą odpowiednie uprawnienia.</uib-alert></div><uib-accordion close-others=false><div class=\"col-sm-6 col-md-4\"><uib-accordion-group heading=\"Podstawowe informacje\" is-open=true><div><input type=checkbox name=isPerson ng-model=vm.contractor.IsPerson>&nbsp;&nbsp;&nbsp;&nbsp;{{\'contractors.contractor.label.isCompany\' | translate}}</div><formly-form model=vm.contractor fields=vm.contractorFields form=vm.contractorForm></formly-form><div>Adres firmy po NIP (link do CEIDG): <a href=https://prod.ceidg.gov.pl/ceidg/ceidg.public.ui/search.aspx target=_blank>Sprawdź</a></div><!--<br>--><formly-form model=vm.contractor fields=vm.defaultAddressFields form=vm.defaultAddressForm></formly-form><label class=control-label>{{\'contractors.contractor.label.province\' | translate}}</label><ui-select ng-model=vm.contractor.DefaultAddress.ProvinceId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ProvinceDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><label class=control-label>{{\'contractors.contractor.label.country\' | translate}}</label><ui-select ng-model=vm.contractor.DefaultAddress.CountryId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.CountryDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><br><div><input type=checkbox name=IsDeliveryAddress ng-model=vm.contractor.IsDeliveryAddress>&nbsp;&nbsp;&nbsp;&nbsp;{{\'contractors.contractor.label.isDeliveryAddress\' | translate}}</div></uib-accordion-group><uib-accordion-group heading=\"Adres dostawy\" is-disabled=\"vm.contractor.IsDeliveryAddress === false\" is-disabled=\"vm.contractor.IsDeliveryAddress === false\"><formly-form model=vm.contractor fields=vm.deliveryAddressFields form=vm.deliveryAddressForm></formly-form><label class=control-label>{{\'contractors.contractor.label.province\' | translate}}</label><ui-select ng-model=vm.contractor.deliveryAddress.ProvinceId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ProvinceDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><label class=control-label>{{\'contractors.contractor.label.country\' | translate}}</label><ui-select ng-model=vm.contractor.deliveryAddress.CountryId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.CountryDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></uib-accordion-group></div><div class=\"col-sm-6 col-md-4\"><uib-accordion-group heading=\"Dane kontaktowe\" close-others=false is-open=true><formly-form model=vm.contractor fields=vm.contactDataFields form=vm.contactDataForm></formly-form><!-- Telefony kontaktowe --><div><label>{{\'contractors.contractor.label.phones\' | translate}}</label><form name=vm.phoneForm><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>Typ</th><th class=uiGridHeader>Numer</th><th class=uiGridHeader style=\"width: 15%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.phoneAttributes.Attributes\"><th scope=row style=\"overflow:visible !important\"><ui-select ng-model=key.DictionaryLocalId><ui-select-match placeholder=Brak>{{$select.selected.Value | translate | truncate:15}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.PhoneTypeDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value |translate | highlight: $select.search\"></div></ui-select-choices></ui-select></th><td><div class=form-group ng-class=\"{\'has-error\' : !phoneFieldForm.phone.$valid}\"><ng-form name=phoneFieldForm><input ng-model=key.ValueStr maxlength=15 min=6 max=15 minlength=6 class=form-control name=phone required></ng-form></div></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeAttribute(key)><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=3><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.addAttribute(2, vm.contractor.Id, 1, undefined, 1)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></form><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></uib-accordion-group><uib-accordion-group heading=\"Dane rozszerzone\"><div><label>{{\'contractors.contractor.label.patron\' | translate}}</label><ui-select ng-model=vm.contractor.PatronId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name + \" \" + $select.selected.SurName | truncate:25}}</ui-select-match><ui-select-choices repeat=\"selectChoiceUser.Id as selectChoiceUser in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"selectChoiceUser.Name + \' \' + selectChoiceUser.SurName | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'users.user.label.storage\' | translate}}</label><ui-select ng-model=vm.contractor.StorageId ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:36}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.type\' | translate}}</label><ui-select ng-model=vm.contractor.Type ng-disabled=\"vm.contractor.Disable=== true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorType | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.priceLevel\' | translate}}</label><ui-select ng-model=vm.contractor.PriceLevelId><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.PriceLevel | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.prefferedContact\' | translate}}</label><ui-select ng-model=vm.contractor.PrefferedContactId><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.PrefferedContact | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.group\' | translate}}</label><ui-select ng-model=vm.contractor.GroupId><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorGroupDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div><label class=control-label>{{\'contractors.contractor.label.feature\' | translate}}</label><ui-select multiple ng-model=vm.contractor.FeatureIds><ui-select-match data-allow-clear=true placeholder=Brak>{{$item.Value}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorFeature | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div><label class=control-label>{{\'contractors.contractor.label.size\' | translate}}</label><ui-select ng-model=vm.contractor.ContractorSize><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.ContractorSizeDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><formly-form model=vm.contractor fields=vm.contractorExtendedFields form=vm.extendedForm></formly-form><div><label class=control-label>{{\'contractors.contractor.label.defaultDocument\' | translate}}</label><ui-select ng-model=vm.contractor.DefaultDocumentType><ui-select-match placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.defaultDocTypes | filter: $select.search\"><div ng-bind-html=\"choice.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.payer\' | translate}}</label><div class=row><div style=\"margin-left: 17px\" ng-if=\"vm.contractor.DefaultPayerName !== undefined\">{{vm.contractor.DefaultPayerName}} <button type=button class=\"btn btn-default btn-xs\" style=\"margin-left: 10px\" uib-popover=Usuń popover-trigger=mouseenter ng-if=\"(vm.contractor.DefaultPayerId != undefined)&&(vm.contractor.DefaultPayerId != null)\" popover-append-to-body=true ng-click=vm.removeDefaultPayer()><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 20px\" uib-popover=Wybierz popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.setDefaultPayer()><span class=\"glyphicon glyphicon-plus\"></span></button></div></div><div><div class=row style=\"margin-left: 0px; margin-right: 0px\"><label class=control-label style=\"width: 49%\">Dostawa od</label><label class=control-label style=\"width: 49%\">Dostawa do</label></div><div class=row style=\"margin-left: 0px; margin-right: 0px\"><div class=\"timepicker-override pull-left\" style=\"padding-left: 0px; width:50%\"><div uib-timepicker ng-model=vm.contractor.DeliveryStartTimeProto hour-step=vm.timeOptions.hstep minute-step=vm.timeOptions.mstep show-meridian=false></div></div><div class=\"timepicker-override pull-left\" style=\"padding-left: 0px; width:50%\"><div uib-timepicker ng-model=vm.contractor.DeliveryStopTimeProto hour-step=vm.timeOptions.hstep minute-step=vm.timeOptions.mstep show-meridian=false></div></div></div></div></uib-accordion-group></div><div class=\"col-sm-6 col-md-4\"><uib-accordion-group heading=Notatki is-open=true><formly-form model=vm.contractor fields=vm.notesFields form=vm.notesForm></formly-form></uib-accordion-group></div><div class=\"col-sm-6 col-md-4\" ng-if=vm.contractor.Id><uib-accordion-group heading=Parametry is-open=true><div><table class=\"table table-striped\"><tbody><tr ng-repeat=\"param in vm.contractor.CustomParameters\"><th scope=row style=\"vertical-align: middle\">{{param.DictionaryItemValue}}</th><td><div class=flex-cell><input ng-model=param.TextValue class=form-control ng-keypress=\"param.isModified = true\" ng-keydown=\"param.isModified = true\" ng-paste=\"param.isModified = true\"> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-class=\"{\'danger-color\': param.isModified}\" ng-disabled=!param.isModified ng-click=vm.addOrUpdateParam(param)><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-disabled=\"!param.TextValue || !param.Id\" ng-click=vm.deleteParam(param)><span class=\"glyphicon glyphicon-remove\"></span></button></div></td></tr></tbody></table></div></uib-accordion-group></div></uib-accordion></div><div class=\"col-sm-6 col-md-4\"><uib-accordion-group heading=EDI is-open=true><div><div><div class=\"checkbox checkbox-primary\"><input type=checkbox ng-model=vm.contractor.IsEdi><label class=control-label>{{\'contractors.contractor.label.isUsingEdi\' | translate}}</label></div></div><div><label class=control-label>{{\'contractors.contractor.label.fsSend\' | translate}}</label><div class=\"btn-group pull-right radio-buttons\"><label class=\"btn btn-primary\" ng-model=vm.contractor.IsFsSendProd uib-btn-radio=false>{{\'contractors.contractor.label.test\' | translate}}</label><label class=\"btn btn-primary\" ng-model=vm.contractor.IsFsSendProd uib-btn-radio=true>{{\'contractors.contractor.label.prod\' | translate}}</label></div></div><div style=\"margin-top: 20px\"><label class=control-label>{{\'contractors.contractor.label.kfsSend\' | translate}}</label><div class=\"btn-group pull-right radio-buttons\"><label class=\"btn btn-primary\" ng-model=vm.contractor.IsKfsSendProd uib-btn-radio=false>{{\'contractors.contractor.label.test\' | translate}}</label><label class=\"btn btn-primary\" ng-model=vm.contractor.IsKfsSendProd uib-btn-radio=true>{{\'contractors.contractor.label.prod\' | translate}}</label></div></div><div style=\"margin-top: 20px; margin-bottom: 20px\"><label class=control-label>{{\'contractors.contractor.label.orderLoad\' | translate}}</label><div class=\"btn-group pull-right radio-buttons\"><label class=\"btn btn-primary\" ng-model=vm.contractor.IsOrderLoadProd uib-btn-radio=false>{{\'contractors.contractor.label.test\' | translate}}</label><label class=\"btn btn-primary\" ng-model=vm.contractor.IsOrderLoadProd uib-btn-radio=true>{{\'contractors.contractor.label.prod\' | translate}}</label></div></div><div><label class=control-label>{{\'contractors.contractor.label.fsTemplate\' | translate}}</label><div class=flex-cell><ui-select ng-model=vm.contractor.FsTemplateId style=\"width: 100%\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat=\"choice.Id as choice in vm.templates | filter: $select.search\"><div ng-bind-html=\"choice.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><button type=button ng-click=vm.openTemplateInNewWindow(vm.contractor.FsTemplateId) ng-disabled=!vm.contractor.FsTemplateId class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button></div></div><div><label class=control-label>{{\'contractors.contractor.label.kfsTemplate\' | translate}}</label><div class=flex-cell><ui-select ng-model=vm.contractor.KfsTemplateId style=\"width: 100%\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat=\"choice.Id as choice in vm.templates | filter: $select.search\"><div ng-bind-html=\"choice.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><button type=button ng-click=vm.openTemplateInNewWindow(vm.contractor.KfsTemplateId) ng-disabled=!vm.contractor.KfsTemplateId class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button></div></div></div></uib-accordion-group></div><!-- HDI --><div class=\"col-sm-6 col-md-4\"><uib-accordion-group heading=HDI is-open=true><div><div><div class=\"checkbox checkbox-primary\"><input type=checkbox ng-model=vm.contractor.IsHdi><label class=control-label>Korzysta z HDI</label></div></div><div><label class=control-label>{{\'contractors.contractor.label.fsSend\' | translate}}</label><div class=\"btn-group pull-right radio-buttons\"><label class=\"btn btn-primary\" ng-model=vm.contractor.IsHDISendProd uib-btn-radio=false>{{\'contractors.contractor.label.test\' | translate}}</label><label class=\"btn btn-primary\" ng-model=vm.contractor.IsHDISendProd uib-btn-radio=true>{{\'contractors.contractor.label.prod\' | translate}}</label></div></div><div><label class=control-label>{{\'contractors.contractor.label.fsTemplate\' | translate}}</label><div class=flex-cell><ui-select ng-model=vm.contractor.HDIFsTemplateId style=\"width: 100%\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat=\"choice.Id as choice in vm.hdiTemplates | filter: $select.search\"><div ng-bind-html=\"choice.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><button type=button ng-click=vm.openTemplateInNewWindow(vm.contractor.HDIFsTemplateId) ng-disabled=!vm.contractor.HDIFsTemplateId class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button></div></div></div></uib-accordion-group></div><!-- HDI end --></div><div><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>{{\'common.actions.goBack\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit(vm.contractor) ng-show=vm.checkPermission(8) ng-disabled=\"vm.contractorForm.$invalid || vm.phoneForm.$invalid\">{{\'common.form.confirm\' | translate}}</button></div></div>");
$templateCache.put("app/components/contractors/contractors.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Kontrahenci</div><div class=panel-body><div><div><!--<label class=\"control-label\">{{\'users.user.label.storage\' | translate}}</label>--><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'common.grid.searchBox\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=ContractorSearchBox name=ContractorSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div><!-- /input-group --><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.pagingData.searchStr\"--><!--on-press-enter=\"vm.onFilterChange()\">--></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div><div class=row><div class=col-sm-3 ng-show=vm.checkPermission(6)><label>{{\'contractors.search.patron\' | translate}}</label><ui-select ng-model=vm.pagingData.patronId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.group\' | translate}}</label><ui-select ng-model=vm.pagingData.groupId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorGroupDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.feature\' | translate}}</label><ui-select ng-model=vm.pagingData.featureId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorFeature | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.blocked\' | translate}}</label><ui-select ng-model=vm.pagingData.isBlocked theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.BlockedDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.type theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorType | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 style=\"position: relative\"><label style=\"width: 100%\">GLN/ILN</label><!--<input type=\"checkbox\" class=\"acceptance-checkbox\" ng-model=\"vm.pagingData.acceptance\" ng-change=\"vm.onFilterChange()\">--><div class=\"checkbox checkbox-primary acceptance-checkbox\"><input type=checkbox ng-model=vm.pagingData.gln ng-change=vm.onFilterChange()><label></label></div></div><div class=col-sm-3 style=\"position: relative\"><label style=\"width: 100%\">EDI - FS</label><ui-select ng-model=vm.pagingData.IsFsSendProd theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.EDIStatusedDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 style=\"position: relative\"><label style=\"width: 100%\">EDI - KFS</label><ui-select ng-model=vm.pagingData.IsKfsSendProd theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.EDIStatusedDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader rowSymbol\">{{\'contractors.fields.symbol\' | translate}}</th><th class=\"uiGridHeader rowName\">{{\'contractors.fields.name\' | translate}} <i class=fa ng-class=\"{\'fa-sort\': vm.pagingData.sortByName === 0, \'fa-sort-asc\': vm.pagingData.sortByName <0, \'fa-sort-desc\': vm.pagingData.sortByName >0}\" ng-click=vm.changeSortByName()></i></th><th class=\"uiGridHeader rowNIP\">{{\'contractors.fields.NIP\' | translate}}</th><th class=\"uiGridHeader rowAction\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Symbol></span></th><td><span ng-bind=vm.getNameText(key) uib-popover={{vm.getNameText(key)}} popover-trigger=mouseenter></span></td><td><span ng-bind=key.NIP></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.contractors.contractor({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=\"{{key.ObjectStatus < 10 ? \'Zatwierdź\' : \'Edytuj\'}}\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" ng-click=vm.toggleBlockedFlag(key) uib-popover=\"{{!key.IsBlocked ? \'Zablokuj\': \'Odblokuj\'}}\" popover-trigger=mouseenter popover-append-to-body=true><span class=glyphicon ng-class=\"{\'glyphicon-remove\': key.IsBlocked, \'glyphicon-ok\': !key.IsBlocked}\"></span></button> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Wymaga akceptacji\" ng-show=\"key.ObjectStatus < 10\" style=\"position: absolute; margin-left: 5px; font-size: 1.3em\"></span></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div><div style=\"overflow-y: hidden; display: flex; flex-direction: column\"><span class=pull-right style=\"margin-bottom: 5px; margin-left: auto\">Rekordów:{{vm.pagingData.totalCount}}</span> <button class=\"btn btn-primary btn-submit\" style=\"margin-left: auto\" ng-if=vm.checkPermission(4) ng-click=vm.addContractor()>{{\'contractors.addContractor\' | translate}}</button></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/contractors/contractorsSelect.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Wybierz kontrahenta</div><div class=panel-body><div><div><!--<label class=\"control-label\">{{\'users.user.label.storage\' | translate}}</label>--><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'common.grid.searchBox\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=ContractorSearchBox name=ContractorSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div><div class=row><div class=col-sm-3 ng-show=vm.checkPermission(6)><label>{{\'contractors.search.patron\' | translate}}</label><ui-select ng-model=vm.pagingData.patronId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\" ng-disabled=\"vm.userId !== undefined\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.group\' | translate}}</label><ui-select ng-model=vm.pagingData.groupId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorGroupDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.feature\' | translate}}</label><ui-select ng-model=vm.pagingData.featureId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorFeature | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.blocked\' | translate}}</label><ui-select ng-model=vm.pagingData.isBlocked theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\" ng-disabled=\"vm.status !== undefined\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.BlockedDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.type theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorType | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'contractors.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.type theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ContractorType | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 style=\"position: relative\"><label style=\"width: 100%\">GLN/ILN</label><!--<input type=\"checkbox\" class=\"acceptance-checkbox\" ng-model=\"vm.pagingData.acceptance\" ng-change=\"vm.onFilterChange()\">--><div class=\"checkbox checkbox-primary acceptance-checkbox\"><input type=checkbox ng-model=vm.pagingData.gln ng-change=vm.onFilterChange()><label></label></div></div><div class=\"col-sm-3 has-feedback pull-right\"></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader rowSymbol\">{{\'contractors.fields.symbol\' | translate}}</th><th class=\"uiGridHeader rowName\">{{\'contractors.fields.name\' | translate}} <i class=fa ng-class=\"{\'fa-sort\': vm.pagingData.sortByName === 0, \'fa-sort-asc\': vm.pagingData.sortByName <0, \'fa-sort-desc\': vm.pagingData.sortByName >0}\" ng-click=vm.changeSortByName()></i></th><th class=\"uiGridHeader rowNIP\">{{\'contractors.fields.NIP\' | translate}}</th><th class=\"uiGridHeader rowAction\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Symbol></span></th><td><span ng-bind=vm.getNameText(key) uib-popover={{vm.getNameText(key)}} popover-trigger=mouseenter></span></td><td><span ng-bind=key.NIP></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wybierz popover-trigger=mouseenter ng-show=!vm.isAdded(key) popover-append-to-body=true ng-click=vm.selectContractor(key)><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/error/error.html","<div class=container><div class=row><br><br><br><br><br><br><div class=\"col-sm-12 col-md-10 col-md-offset-1\"><div class=\"jumbotron center errorpage\"><h1>Strona nie znaleziona proszę spróbować jeszcze raz <small><font face=Tahoma color=red>Błąd 404</font></small></h1><br><a href=javascript:history.back() class=\"btn btn-large btn-info\">Powrót</a><br><br><a href=# ui-sref=home.mainPage class=\"btn btn-large btn-info\"><i class=\"icon-home icon-white\"></i> Powrót do Pulpitu</a></div></div></div></div>");
$templateCache.put("app/components/documents/acceptance.directive.html","<div ng-if=\"vm.data.TypeId != 1004\"><p>Oryginalna cena: {{key.OriginalAmountProductNet}}</p><p>Aktualna cena: {{key.AmountProductNet}}</p><button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Akceptuj cenę\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.acceptEntityPrice(key) ng-disabled=\"key.AcceptRecord.Action === 1\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Odrzuć cenę\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.rejectEntityPrice(key) ng-disabled=\"key.AcceptRecord.Action === 2\"><span class=\"glyphicon glyphicon-remove\"></span></button> <input ng-model=key.newEEPrice ng-change=vm.priceImputChange(key)></div><div ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Akceptuj pozycję\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.acceptEntityPrice(key) ng-disabled=\"key.AcceptRecord.Action === 1\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Odrzuć pozycję\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.rejectEntityPrice(key) ng-disabled=\"key.AcceptRecord.Action === 2\"><span class=\"glyphicon glyphicon-remove\"></span></button></div>");
$templateCache.put("app/components/documents/document.history.html","<div><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Usunięty dokument: {{vm.data.DocumentNumberFull}} <button class=\"btn-xs btn-primary btn-submit hidden-print\" ng-click=vm.showHistory() ng-disabled=\"vm.data.documentLock == true\" ng-if=\"vm.data.IsModifiedByUser == true\" id=doc-c>Historia zmian</button></div><div class=panel-body><div><div class=row><div class=\"col-sm-12 col-md-12 hidden-print\"><uib-alert ng-show=vm.data.IsSubiektError class=alert-danger><b>Wystąpił błąd podczas wysyłki do subiekta:</b> {{vm.data.SubiektError}}</uib-alert></div><div style=\"position: absolute; left: 50%\" class=hidden-print><div class=smak-icon id=loader style=\"opacity: 0.3\"></div></div><div class=\"col-sm-6 col-md-4 hidden-print\" id=doc-common-data style=\"opacity: 0.0\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Typ</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentTypeDictionary\',vm.data.TypeId).Value\"></span></td></tr><tr><th scope=row>Numer dokumentu</th><td><span ng-bind=\"vm.data.DocumentNumberFull \"></span></td></tr><tr><th scope=row style=\"vertical-align: middle\">Magazyn</th><td ng-if=\"!((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><span ng-bind=\"vm.getStrorageById(vm.data.Storage).Name \"></span></td><td ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><ui-select ng-model=vm.data.Storage theme=bootstrap on-select=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></td></tr><tr><th scope=row style=\"vertical-align: middle\">Data wystawienia</th><td ng-if=\"!((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><span ng-bind=\"vm.data.DocumentReleaseDate | date:\'yyyy-MM-dd\'\"></span></td><td ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><div class=input-group><input datepicker-localdate type=text uib-datepicker-popup ng-required=true class=form-control ng-model=vm.data.DocumentReleaseDate is-open=vm.datePickerReleaseOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateRelease> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><th scope=row>Data płatności</th><td><span ng-bind=\"vm.data.PaymentDate | date:\'yyyy-MM-dd\'\"></span></td></tr><tr><th scope=row style=\"vertical-align: middle\">Data dostawy</th><td ng-if=\"!((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><span ng-bind=\"vm.data.FinishDate | date:\'yyyy-MM-dd\'\"></span></td><td ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.data.FinishDate is-open=vm.datePickerFinishOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFinish> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><th scope=row>Forma płatności</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'PaymentTypesDictionary\',vm.data.PaymentMethodId).Value\"></span></td></tr><tr><th scope=row>Wystawił</th><td><span ng-bind=\"vm.data.RelatedUser.Name + \' \' + vm.data.RelatedUser.SurName\"></span></td></tr><tr><th scope=row>Opiekun</th><td><span ng-bind=\"vm.data.Patron.Name + \' \' + vm.data.Patron.SurName\"></span></td><!--<td><span ng-bind=\"vm.data.RelatedUser.Name + \' \' + vm.data.RelatedUser.SurName\"></span></td>--></tr><tr><th scope=row>Poziom ceny</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'PriceLevel\',vm.data.PriceLevelId).Value\"></span></td></tr><tr><th scope=row>Kategoria dokumentu</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentCategoryDictionary\',vm.data.CategoryId).Value\"></span></td></tr><tr><th scope=row>Osoba usuwająca</th><td><span ng-bind=vm.data.OperationUserName></span></td></tr><tr><th scope=row>Stanowisko usunięcia</th><td><span ng-bind=vm.data.OperationUserPosition></span></td></tr><tr><th scope=row>Data usunięcia</th><td><span ng-bind=vm.data.OperationDate></span></td></tr><tr ng-if=\"(vm.data.TypeId ===1001 || vm.data.TypeId === 1004) && vm.data.ObjectStatus > 9 && vm.data.ObjectStatus < 21\"><th scope=row>Status przetworzenia</th><td><span ng-bind=\"vm.data.IsProcessed == true ? \'Dokument przeanalizowany\' : \'Oczekuje na analizę\'\"></span></td></tr></tbody></table><button type=submit ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\" class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.saveStorageChanges()>Zapisz</button></div></div></div><div class=\"col-sm-6 col-md-4\" id=doc-note style=\"opacity: 0.0\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.note\' | translate}}</div><div class=panel-body><textarea cols=\"\" rows=\"\" class=\"textarea-style-visit hidden-print\" ng-model=vm.data.Note ng-disabled=\"!(vm.data.ObjectStatus == 1 || vm.data.ObjectStatus == 6 || vm.data.ObjectStatus == 22 || vm.data.ObjectStatus == 30 || vm.data.ObjectStatus == 31 || (vm.data.ObjectStatus == 10  && vm.data.IsSubiektError == true)) || !vm.checkPermission(29)\"></textarea><label class=note-label style=\"display: none\">{{::vm.data.Note}}</label><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=\"vm.comment(vm.data.Id, vm.data.Note)\" id=doc-accept_positions-button ng-hide=\"!(vm.data.ObjectStatus == 1 || vm.data.ObjectStatus == 6 || vm.data.ObjectStatus == 22 || vm.data.ObjectStatus == 30 || vm.data.ObjectStatus == 31 || (vm.data.ObjectStatus == 10  && vm.data.IsSubiektError == true)) || !vm.checkPermission(29)\">Zapisz komentarz</button><!--comment--></div></div></div><div class=\"col-sm-6 col-md-4 print-left\" id=doc-payer-data ng-if=\"vm.data.PayerAddress != null && vm.data.PayerAddress != undefined && vm.data.TypeId != 1002 && vm.data.TypeId != 1003\"><div class=\"panel panel-default\"><div class=panel-heading>Płatnik</div><div class=panel-body><table class=\"table table-striped\"><tbody class=print-no-border><tr class=hidden-print><th scope=row>Symbol</th><td><span ng-bind=vm.data.PayerSymbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.data.PayerAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.data.PayerAddress.NIP></span></td></tr><tr class=hidden-print><th scope=row>Miasto</th><td><span ng-bind=vm.data.PayerAddress.City></span></td></tr><tr class=hidden-print><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.data.PayerAddress.PostalCode></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Adres</th><td><span ng-bind=vm.data.PayerAddress.City></span> <span ng-bind=vm.data.PayerAddress.PostalCode></span></td></tr><tr class=hidden-print><th scope=row>Ulica</th><td><span ng-bind=vm.data.PayerAddress.Street></span></td></tr><tr class=hidden-print><th scope=row>Numer budynku</th><td><span ng-bind=vm.data.PayerAddress.BuildingNumber></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Ulica</th><td><span ng-bind=vm.data.PayerAddress.Street></span> <span ng-bind=vm.data.PayerAddress.BuildingNumber></span></td></tr><tr class=hidden-print><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\',vm.data.PayerAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\',vm.data.PayerAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 pull-right print-right\" id=doc-recipient-data ng-hide=\"vm.data.RecipientAddress == null || vm.data.RecipientAddress == undefined\"><div class=\"panel panel-default\"><div class=panel-heading>Odbiorca</div><div class=panel-body><table class=\"table table-striped\"><tbody class=print-no-border><tr class=hidden-print><th scope=row>Symbol</th><td><span ng-bind=vm.data.RecipientSymbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.data.RecipientAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.data.RecipientAddress.NIP></span></td></tr><tr class=hidden-print><th scope=row>Miasto</th><td><span ng-bind=vm.data.RecipientAddress.City></span></td></tr><tr class=hidden-print><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.data.RecipientAddress.PostalCode></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Adres</th><td><span ng-bind=vm.data.RecipientAddress.City></span> <span ng-bind=vm.data.RecipientAddress.PostalCode></span></td></tr><tr class=hidden-print><th scope=row>Ulica</th><td><span ng-bind=vm.data.RecipientAddress.Street></span></td></tr><tr class=hidden-print><th scope=row>Numer budynku</th><td><span ng-bind=vm.data.RecipientAddress.BuildingNumber></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Ulica</th><td><span ng-bind=vm.data.RecipientAddress.Street></span> <span ng-bind=vm.data.RecipientAddress.BuildingNumber></span></td></tr><tr class=hidden-print><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\',vm.data.RecipientAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\',vm.data.RecipientAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div></div><table class=\"table table-hover table-striped uiGrid print-table\" id=doc-entities-data style=\"opacity: 0.0\"><thead><tr><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Pozycja</th><!-- [PositionOnDocument]--><th class=\"uiGridHeader hidden-print\" style=\"width: 25%\">Nazwa produktu</th><!-- ng-if=\"vm.data.TypeId == 1004\" --><th class=\"uiGridHeader print-display-cell\" style=\"width: 35%; display: none\">Nazwa produktu</th><th ng-show=\"vm.data.TypeId == 1004\" class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Partia</th><th ng-show=\"vm.data.TypeId == 1004\" class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Termin ważności</th><!--[Name] --><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Ilość</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">Ilość</th><!-- [Count]--><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Jednostka</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">J.M</th><!--[MeasureUnit] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Cena j. netto</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 12%; display: none\">C. Netto</th><!--[[AmountProductNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Cena j. brutto</th><!--[[AmountProductNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość netto</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">W. Netto</th><!--[[AmountNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość VAT</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">VAT %</th><!--[[AmountGross]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość brutto</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 12%; display: none\">W. Brutto</th><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\" ng-if=\"vm.data.TypeId == 1004\">Zdjęcia</th><!--[[AmountGross]] --></tr></thead><tbody><!--nie FS i nie KFS--><tr ng-repeat=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId != 2 && vm.data.TypeId !=6\"><th class=hidden-print><span ng-bind=key.PositionOnDocument></span></th><!--  --><td><span ng-bind=key.RelatedProduct.Name></span></td><td ng-if=\"vm.data.TypeId == 1004\"><span ng-bind=key.BatchNumber popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.BatchNumber}}></span></td><td ng-if=\"vm.data.TypeId == 1004\"><span ng-bind=\"key.ExpirationDate  | date:\'yyyy-MM-dd\'\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"{{key.ExpirationDate  | date:\'yyyy-MM-dd\'}}\"></span></td><td><span ng-bind=key.Count></span> <span ng-if=\"key.CountReturned > 0 && vm.data.TypeId > 999\">(<span ng-bind=key.CountReturned></span>)</span></td><td><span ng-bind=key.MeasureUnit></span></td><td><span ng-if=\"key.AmountProductNet !== null\" ng-bind=\"key.AmountProductNet | number:2\"></span> <span ng-if=\"key.AmountProductNet === null\" ng-bind=\"key.AmountProductNet | number:2\"></span> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger hidden-print\" popover-trigger=mouseenter ng-if=\"key.AcceptanceReason > 0 && !vm.checkPermission(18) && vm.data.TypeId != 1004 && vm.data.ObjectStatus == 1\" popover-append-to-body=true uib-popover=\"Pozycje wymagają akceptacji z powodu zmiany ceny\" style=\"font-size: 1.3em\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right hidden-print\" ng-if=\"(key.AcceptanceReason == 1 || key.AcceptanceReason == 2) && vm.checkPermission(18) && vm.data.ObjectStatus === 1\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span><!--<button type=\"button\" class=\"btn btn-default btn-xs hidden-print\" uib-popover=\"Dodaj\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\"\n                      ng-click=\"vm.showImagesGallery(key)\" ng-disabled=\"key.Files.length < 1\">\n                    <span class=\"glyphicon glyphicon-camera\">\n                    </span></button>--> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right hidden-print\" ng-if=\"(key.AcceptanceReason == 3) && vm.checkPermission(28)\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span> <span class=\"glyphicon glyphicon-ok pull-right text-success hidden-print\" popover-trigger=mouseenter ng-if=\"key.CalculationStatus == 0 && vm.data.TypeId == 1004\" popover-append-to-body=true uib-popover=\"Pozycja zaakceptowana\" style=\"font-size: 1.3em\"></span> <span class=\"glyphicon glyphicon-remove pull-right text-danger hidden-print\" popover-trigger=mouseenter ng-if=\"key.CalculationStatus == 1 && vm.data.TypeId == 1004\" popover-append-to-body=true uib-popover=\"Pozycja odrzucona\" style=\"font-size: 1.3em\"></span></td><td class=hidden-print><span ng-bind=\"key.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><!--FS--><tr ng-repeat=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId == 2\"><th class=hidden-print><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.Count : key.RelatedEntity.Count\"></span><span ng-if=\"key.CountReturned > 0\">(<span ng-bind=key.CountReturned></span>)</span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"\"></span> <span ng-if=\"key.AmountProductNet !== null\" ng-bind=\"key.AmountProductNet | number:2\"></span> <span ng-if=\"key.AmountProductNet === null\" ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span><!----> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger hidden-print\" popover-trigger=mouseenter ng-if=\"key.AcceptanceReason > 0 && !vm.checkPermission(18)  && vm.data.ObjectStatus == 1\" popover-append-to-body=true uib-popover=\"Pozycje wymagają akceptacji z powodu zmiany ceny\" style=\"font-size: 1.3em\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right hidden-print\" ng-if=\"key.AcceptanceReason > 0 && vm.checkPermission(18)  && vm.data.ObjectStatus == 1\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span> <span uib-popover-template=\"\'app/components/documents/promotion.popover.html\'\" class=\"fa fa-tag pull-right hidden-print\" style=\"font-size: 1.3em\" ng-if=\"key.PromotionAmountProductNet == key.AmountSelectedNet && key.PromotionId != null\" popover-trigger=outsideClick></span></td><td class=hidden-print><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountNet : key.RelatedEntity.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountVAT : key.RelatedEntity.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountGross : key.RelatedEntity.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><!--dla KFS - pokazywanie rozwijanych pozycji z korektą itp --><!--FS - 2, ZK 16, WZ - 11--><tr ng-repeat-start=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId == 6\" ng-class=\"{\'info\': key.Count > 0}\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><th><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.Count : key.RelatedEntity.Count\"></span> <span ng-if=\"key.Count > 0\" ng-bind=\"\'(\' +  -key.Count + \')\'\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountNet : key.RelatedEntity.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountVAT : key.RelatedEntity.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountGross : key.RelatedEntity.AmountGross | number:2\"></span></td><td class=hidden-print><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><tr ng-if=\"key.Count > 0 && vm.data.TypeId == 6\" ng-hide=key.isCollapsed class=info><th><span>-</span></th><td><span class=pull-right>Korekta</span></td><td><span ng-bind=-key.Count></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"-key.AmountNet  | number:2\"></span></td><td><span ng-bind=\"-key.AmountVAT  | number:2\"></span></td><td><span ng-bind=\"-key.AmountGross| number:2\"></span></td><td><span></span></td></tr><tr ng-repeat-end ng-if=\"key.Count > 0 && vm.data.TypeId == 6\" ng-hide=key.isCollapsed class=info><th><span>-</span></th><td><span class=pull-right>Po korekcie</span></td><td><span ng-bind=\"key.RelatedEntity.Count - key.Count\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === undefined ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity.AmountNet - key.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity.AmountVAT - key.AmountVAT | number:2\"></span></td><td><span ng-bind=\" key.RelatedEntity.AmountGross - key.AmountGross| number:2\"></span></td><td><span></span></td></tr><tr class=info><th ng-show=\"vm.data.TypeId != 1004\" colspan=6 class=hidden-print><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><th ng-show=\"vm.data.TypeId == 1004\" colspan=8 class=hidden-print><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><th colspan=4 style=\"display: none\" class=print-display-cell><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><td><span ng-bind=\"vm.data.AmountNet | number:2\"></span></td><td><span ng-bind=\"vm.data.AmountVAT | number:2\"></span></td><td><span ng-bind=\"vm.data.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"></td></tr><tr class=\"info hidden-print\" ng-show=\"vm.data.TypeId === 1 || vm.data.TypeId === 2 || vm.data.TypeId === 6 || vm.data.TypeId === 5\"><th colspan=6><span ng-bind=\"\'Pozostaje do zapłaty\'\" class=pull-right></span></th><td><span ng-bind=\"\"></span></td><td><span ng-bind=\"\"></span></td><td><span ng-bind=\"vm.data.AmountPaidLeft | number:2\"></span></td><td ng-if=\"vm.data.TypeId == 1004\"></td></tr><tr class=\"info hidden-print\" ng-show=\"vm.data.TypeId === 1 || vm.data.TypeId === 2 || vm.data.TypeId === 6 || vm.data.TypeId === 5\"><th colspan=6><span ng-bind=\"\'Zapłacono\'\" class=pull-right></span></th><td></td><td></td><td><span ng-bind=\"vm.data.AmountGrossView - vm.data.AmountPaidLeft | number:2\"></span></td><td ng-if=\"vm.data.TypeId == 1004\"></td></tr></tbody></table><!-- sign space shown on print--><div style=\"display:none; padding-top: 50px\" class=print-display-cell><div style=\"border-bottom:1px solid; width: 200px\"></div><span style=\"font-size: 10px; padding: 5px 0px 0px 25px\">Podpis</span></div><!-- end of sign space --></div><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 0.0\" ng-click=vm.printDocument() id=doc-print-button>{{\'common.actions.print\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/documents/document.history.service.html","<div><!-- /.panel-heading --><div class=panel-body><!-- ng-repeat=\"key in vm.data\" --><div class=\"panel panel-default panel-table\" ng-repeat=\"key in vm.data.Lines\"><div class=panel-heading>Versja {{ key.VersionFrom }} -> {{ key.VersionTo }}</div><div class=panel-body><div><table class=table><tr><th colspan=2 class=info>Informacje podstawowe</th></tr><tr><td>Pracownik</td><td>{{ key.UserName }}</td></tr><tr><td>Stacja</td><td>{{ key.ComputerName }}</td></tr><tr><td>Data</td><td>{{ key.ChangeDate }}</td></tr></table><table class=table><tr><th colspan=3 class=info>Zmiany na dokumencie</th></tr><tr><th>Opis</th><th>Wartość pierwotna</th><th>Wartoć docelowa</th></tr><tr ng-repeat=\"keyy in key.documentChanges\" ng-if=\"key.documentChanges.length > 0\"><td>{{ keyy.FieldDescription }}</td><td>{{ keyy.ValueFrom }}</td><td>{{ keyy.ValueTo }}</td></tr><tr ng-if=\"key.documentChanges.length == 0\"><td colspan=3>Brak</td></tr></table><table class=table><tr><th colspan=3 class=info>Zmiany na pozycjach</th></tr><tr><th>Opis</th><th>Wartość pierwotna</th><th>Wartoć docelowa</th></tr><tr ng-repeat-start=\"keyy in key.positionsChanges\" ng-if=\"key.positionsChanges.length > 0\" class=active><td>{{ keyy.PositionName }}</td><td><span ng-if=\"keyy.Action == 0\">Dodana pozycja</span> <span ng-if=\"keyy.Action == 1\">Usunięte pozycja</span> <span ng-if=\"keyy.Action == 2\">Zmodyfikowana pozycja</span></td><td></td></tr><tr ng-repeat-end ng-repeat=\"keyyy in keyy.PositionChanges\"><td>{{ keyyy.FieldDescription }}</td><td><span ng-if=\"keyy.Action !== 0\">{{ keyyy.ValueFrom }}</span></td><td><span ng-if=\"keyy.Action !== 1\">{{ keyyy.ValueTo }}</span></td></tr><tr ng-if=\"key.positionsChanges.length == 0\"><td colspan=3>Brak</td></tr></table></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel --></div>");
$templateCache.put("app/components/documents/document.html","<div><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Dokument: {{vm.data.DocumentNumberFull}} <button class=\"btn-xs btn-primary btn-submit hidden-print\" ng-click=vm.showHistory() ng-disabled=\"vm.data.documentLock == true\" ng-if=\"vm.data.IsModifiedByUser == true && vm.checkPermission(37)\" id=doc-c>Historia zmian</button></div><div class=panel-body><div><div class=row><div class=\"col-sm-12 col-md-12 hidden-print\"><uib-alert ng-show=vm.data.IsSubiektError class=alert-danger><b>Wystąpił błąd podczas wysyłki do subiekta:</b> {{vm.data.SubiektError}}</uib-alert></div><div style=\"position: absolute; left: 50%\" class=hidden-print><div class=smak-icon id=loader style=\"opacity: 0.3\"></div></div><div class=\"col-sm-6 col-md-4 hidden-print\" id=doc-common-data style=\"opacity: 0\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Typ</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentTypeDictionary\',vm.data.TypeId).Value\"></span></td></tr><tr><th scope=row>Numer dokumentu</th><td><span ng-bind=\"vm.data.DocumentNumberFull \"></span></td></tr><tr><th scope=row style=\"vertical-align: middle\">Magazyn</th><td ng-if=\"!((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><span ng-bind=\"vm.getStrorageById(vm.data.Storage).Name \"></span></td><td ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><ui-select ng-model=vm.data.Storage theme=bootstrap on-select=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></td></tr><tr><th scope=row style=\"vertical-align: middle\">Data wystawienia</th><td ng-if=\"!((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><span ng-bind=\"vm.data.DocumentReleaseDate | date:\'yyyy-MM-dd\'\"></span></td><td ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><div class=input-group><input datepicker-localdate type=text uib-datepicker-popup ng-required=true class=form-control ng-model=vm.data.DocumentReleaseDate is-open=vm.datePickerReleaseOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateRelease> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><th scope=row>Data płatności</th><td><span ng-bind=\"vm.data.PaymentDate | date:\'yyyy-MM-dd\'\"></span></td></tr><tr><th scope=row style=\"vertical-align: middle\">Data dostawy</th><td ng-if=\"!((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><span ng-bind=\"vm.data.FinishDate | date:\'yyyy-MM-dd\'\"></span></td><td ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\"><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.data.FinishDate is-open=vm.datePickerFinishOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFinish> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><th scope=row>Forma płatności</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'PaymentTypesDictionary\',vm.data.PaymentMethodId).Value\"></span></td></tr><tr><th scope=row>Wystawił</th><td><span ng-bind=\"vm.data.RelatedUser.Name + \' \' + vm.data.RelatedUser.SurName\"></span></td></tr><tr><th scope=row>Opiekun</th><td><span ng-bind=\"vm.data.Patron.Name + \' \' + vm.data.Patron.SurName\"></span></td><!--<td><span ng-bind=\"vm.data.RelatedUser.Name + \' \' + vm.data.RelatedUser.SurName\"></span></td>--></tr><tr><th scope=row>Poziom ceny</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'PriceLevel\',vm.data.PriceLevelId).Value\"></span></td></tr><tr><th scope=row>Kategoria dokumentu</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentCategoryDictionary\',vm.data.CategoryId).Value\"></span></td></tr><tr ng-if=\"vm.data.TypeId < 1000\"><th scope=row>Status w Subiekt</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentStatusDictionary\',vm.data.Status).Value\"></span></td></tr><tr><th scope=row>Akceptacja</th><td><span ng-if=\"!(vm.data.TypeId ===1001 || vm.data.TypeId === 1004 || vm.data.TypeId === 1003 || vm.data.TypeId === 1002)\"><span ng-if=\"vm.data.ObjectStatus == 0\">---</span> <span ng-if=\"vm.data.ObjectStatus == 1\">Akceptacja</span> <span ng-if=\"vm.data.ObjectStatus == 2\">Akceptacja logistyka</span> <span ng-if=\"vm.data.ObjectStatus == 10\">Zaakceptowany</span> <span ng-if=\"vm.data.ObjectStatus == 11\">Przetwarzanie</span> <span ng-if=\"vm.data.ObjectStatus == 12\">Przetworzony</span> <span ng-if=\"vm.data.ObjectStatus == 20\">Wysłany</span> <span ng-if=\"vm.data.ObjectStatus == 21\">Błąd</span> <span ng-if=\"vm.data.ObjectStatus == 30\">Odrzucono</span> <span ng-if=\"vm.data.ObjectStatus == 32\">Odrzucony przez logistyka</span> </span><span ng-if=\"vm.data.TypeId ===1001 || vm.data.TypeId === 1004\"><span ng-if=\"key.ReturnDocumentStatus == 0\">---</span> <span ng-if=\"vm.data.ObjectStatus == 1\">Akceptacja</span> <span ng-if=\"vm.data.ObjectStatus == 6\">W przyszłości</span> <span ng-if=\"vm.data.ObjectStatus == 10\">Zaakceptowany</span> <span ng-if=\"vm.data.ObjectStatus == 11\">Przetwarzanie</span> <span ng-if=\"vm.data.ObjectStatus == 12\">Przetworzony</span> <span ng-if=\"vm.data.ObjectStatus == 22\">Dodano ręcznie</span> <span ng-if=\"vm.data.ObjectStatus == 31\">Anulowano</span> </span><span ng-if=\"vm.data.TypeId ===1002 || vm.data.TypeId === 1003\"><span ng-if=\"key.ReturnDocumentStatus == 0\">---</span> <span ng-if=\"vm.data.ObjectStatus == 1\">Akceptacja</span> <span ng-if=\"vm.data.ObjectStatus == 10\">Zaakceptowany</span> <span ng-if=\"vm.data.ObjectStatus == 11\">Do wysłania</span> <span ng-if=\"vm.data.ObjectStatus == 23\">Wysłany</span> <span ng-if=\"vm.data.ObjectStatus == 30\">Odrzucony</span></span></td></tr><tr ng-if=\"(vm.data.TypeId ===1001 || vm.data.TypeId === 1004) && vm.data.ObjectStatus > 9 && vm.data.ObjectStatus < 21\"><th scope=row>Status przetworzenia</th><td><span ng-bind=\"vm.data.IsProcessed == true ? \'Dokument przeanalizowany\' : \'Oczekuje na analizę\'\"></span></td></tr></tbody></table><button type=submit ng-if=\"((vm.data.ObjectStatus == 2)&&(vm.checkPermission(30)))\" class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.saveStorageChanges()>Zapisz</button></div></div></div><div class=\"col-sm-6 col-md-4\" id=doc-note style=\"opacity: 0\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.note\' | translate}}</div><div class=panel-body><textarea cols=\"\" rows=\"\" class=\"textarea-style-visit hidden-print\" ng-model=vm.data.Note ng-disabled=\"!(vm.data.ObjectStatus == 1 || vm.data.ObjectStatus == 6 || vm.data.ObjectStatus == 22 || vm.data.ObjectStatus == 30 || vm.data.ObjectStatus == 31 || (vm.data.ObjectStatus == 10  && vm.data.IsSubiektError == true)) || !vm.checkPermission(29)\"></textarea><label class=note-label style=\"display: none\">{{::vm.data.Note}}</label><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1\" ng-click=\"vm.comment(vm.data.Id, vm.data.Note)\" id=doc-accept_positions-button ng-hide=\"!(vm.data.ObjectStatus == 1 || vm.data.ObjectStatus == 6 || vm.data.ObjectStatus == 22 || vm.data.ObjectStatus == 30 || vm.data.ObjectStatus == 31 || (vm.data.ObjectStatus == 10  && vm.data.IsSubiektError == true)) || !vm.checkPermission(29)\">Zapisz komentarz</button><!--comment--></div></div></div><div class=\"col-sm-6 col-md-4 print-left\" id=doc-payer-data ng-if=\"vm.data.PayerAddress != null && vm.data.PayerAddress != undefined && vm.data.TypeId != 1002 && vm.data.TypeId != 1003\"><div class=\"panel panel-default\"><div class=panel-heading>Płatnik</div><div class=panel-body><table class=\"table table-striped\"><tbody class=print-no-border><tr class=hidden-print><th scope=row>Symbol</th><td><span ng-bind=vm.data.PayerSymbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.data.PayerAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.data.PayerAddress.NIP></span></td></tr><tr class=hidden-print><th scope=row>Miasto</th><td><span ng-bind=vm.data.PayerAddress.City></span></td></tr><tr class=hidden-print><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.data.PayerAddress.PostalCode></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Adres</th><td><span ng-bind=vm.data.PayerAddress.City></span> <span ng-bind=vm.data.PayerAddress.PostalCode></span></td></tr><tr class=hidden-print><th scope=row>Ulica</th><td><span ng-bind=vm.data.PayerAddress.Street></span></td></tr><tr class=hidden-print><th scope=row>Numer budynku</th><td><span ng-bind=vm.data.PayerAddress.BuildingNumber></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Ulica</th><td><span ng-bind=vm.data.PayerAddress.Street></span> <span ng-bind=vm.data.PayerAddress.BuildingNumber></span></td></tr><tr class=hidden-print><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\',vm.data.PayerAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\',vm.data.PayerAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 pull-right hidden-print\" id=doc-related-data style=\"opacity: 0\" ng-if=\"vm.data.TypeId != 1002 && vm.data.TypeId != 1003\"><div class=\"panel panel-default\"><div class=panel-heading>Dokumenty powiązane</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr ng-repeat=\"key in vm.data.RelatedDocuments\" ng-if=\"vm.data.TypeId < 1000\"><th scope=row ng-if=\"key.Id === vm.data.Id\" style=\"text-align: center\">{{key.DocumentNumberFull}}</th><td scope=row ng-if=\"!(key.Id === vm.data.Id)\" style=\"text-align: center\"><a ng-click=vm.goToDocument(key.Id)><!--ui-sref=\"home.documents.document({id: key.Id})\"-->{{key.DocumentNumberFull}}</a></td><!-- --></tr><tr ng-repeat=\"key in vm.data.RelatedKFSDocuments\" ng-if=\"vm.data.TypeId >= 1000\"><th scope=row ng-if=\"key.Id === vm.data.Id\" style=\"text-align: center\">{{key.DocumentNumberFull}}</th><td scope=row ng-if=\"!(key.Id === vm.data.Id)\" style=\"text-align: center\"><a ng-click=vm.goToDocument(key.Id)><!--ui-sref=\"home.documents.document({id: key.Id})\"--> {{key.DocumentNumberFull}}</a></td><!-- --></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 pull-right print-right\" id=doc-recipient-data ng-hide=\"vm.data.RecipientAddress == null || vm.data.RecipientAddress == undefined\"><div class=\"panel panel-default\"><div class=panel-heading>Odbiorca</div><div class=panel-body><table class=\"table table-striped\"><tbody class=print-no-border><tr class=hidden-print><th scope=row>Symbol</th><td><span ng-bind=vm.data.RecipientSymbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.data.RecipientAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.data.RecipientAddress.NIP></span></td></tr><tr class=hidden-print><th scope=row>Miasto</th><td><span ng-bind=vm.data.RecipientAddress.City></span></td></tr><tr class=hidden-print><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.data.RecipientAddress.PostalCode></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Adres</th><td><span ng-bind=vm.data.RecipientAddress.City></span> <span ng-bind=vm.data.RecipientAddress.PostalCode></span></td></tr><tr class=hidden-print><th scope=row>Ulica</th><td><span ng-bind=vm.data.RecipientAddress.Street></span></td></tr><tr class=hidden-print><th scope=row>Numer budynku</th><td><span ng-bind=vm.data.RecipientAddress.BuildingNumber></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Ulica</th><td><span ng-bind=vm.data.RecipientAddress.Street></span> <span ng-bind=vm.data.RecipientAddress.BuildingNumber></span></td></tr><tr class=hidden-print><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\',vm.data.RecipientAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\',vm.data.RecipientAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 hidden-print\" id=doc-photos style=\"opacity: 0\"><div class=\"panel panel-default\"><div class=panel-heading>Zdjęcia</div><div class=panel-body><ul style=\"list-style-type: none; padding-left: 0px\"><li ng-repeat=\"image in vm.data.Files\" class=image-li><a ng-click=vm.openLightboxModal($index)><img target=page type=button class=btn http-src=\"{{API_URL + \'/MediaFiles/\' + image.Id + \'/content\'}}\" width=100px height=\"100 px\" class=img-thumbnail> </a><button type=button class=\"btn btn-default btn-xs delete-button\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeImg(image)><span class=\"glyphicon glyphicon-remove\"></span></button></li></ul><button type=submit class=\"btn btn-primary\" ng-click=vm.uploadAttachment()>Wgraj zdjęcie</button></div></div></div></div><table class=\"table table-hover table-striped uiGrid print-table\" id=doc-entities-data style=\"opacity: 0\"><thead><tr><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Pozycja</th><!-- [PositionOnDocument]--><th class=\"uiGridHeader hidden-print\" style=\"width: 25%\">Nazwa produktu</th><!-- ng-if=\"vm.data.TypeId == 1004\" --><th class=\"uiGridHeader print-display-cell\" style=\"width: 35%; display: none\">Nazwa produktu</th><th ng-show=\"vm.data.TypeId == 1004\" class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Partia</th><th ng-show=\"vm.data.TypeId == 1004\" class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Termin ważności</th><!--[Name] --><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Ilość</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">Ilość</th><!-- [Count]--><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Jednostka</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">J.M</th><!--[MeasureUnit] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Cena j. netto</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 12%; display: none\">C. Netto</th><!--[[AmountProductNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Cena j. brutto</th><!--[[AmountProductNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość netto</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">W. Netto</th><!--[[AmountNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość VAT</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">VAT %</th><!--[[AmountGross]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość brutto</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 12%; display: none\">W. Brutto</th><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\" ng-if=\"vm.data.TypeId == 1004\">Zdjęcia</th><!--[[AmountGross]] --></tr></thead><tbody><!--nie FS i nie KFS--><tr ng-repeat=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId != 2 && vm.data.TypeId !=6\"><th class=hidden-print><span ng-bind=key.PositionOnDocument></span></th><!--  --><td><span ng-bind=key.RelatedProduct.Name></span></td><td ng-if=\"vm.data.TypeId == 1004\"><span ng-bind=key.BatchNumber popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.BatchNumber}}></span></td><td ng-if=\"vm.data.TypeId == 1004\"><span ng-bind=\"key.ExpirationDate  | date:\'yyyy-MM-dd\'\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"{{key.ExpirationDate  | date:\'yyyy-MM-dd\'}}\"></span></td><td><span ng-bind=key.Count></span> <span ng-if=\"key.CountReturned > 0 && vm.data.TypeId > 999\">(<span ng-bind=key.CountReturned></span>)</span></td><td><span ng-bind=key.MeasureUnit></span></td><td><span ng-if=\"key.AmountProductNet !== null\" ng-bind=\"key.AmountProductNet | number:2\"></span> <span ng-if=\"key.AmountProductNet === null\" ng-bind=\"key.AmountProductNet | number:2\"></span> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger hidden-print\" popover-trigger=mouseenter ng-if=\"key.AcceptanceReason > 0 && !vm.checkPermission(18) && vm.data.TypeId != 1004 && vm.data.ObjectStatus == 1\" popover-append-to-body=true uib-popover=\"Pozycje wymagają akceptacji z powodu zmiany ceny\" style=\"font-size: 1.3em\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right hidden-print\" ng-if=\"(key.AcceptanceReason == 1 || key.AcceptanceReason == 2) && vm.checkPermission(18) && vm.data.ObjectStatus === 1\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span><!--<button type=\"button\" class=\"btn btn-default btn-xs hidden-print\" uib-popover=\"Dodaj\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\"\r\n                    ng-click=\"vm.showImagesGallery(key)\" ng-disabled=\"key.Files.length < 1\">\r\n                  <span class=\"glyphicon glyphicon-camera\">\r\n                  </span></button>--> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right hidden-print\" ng-if=\"(key.AcceptanceReason == 3) && vm.checkPermission(28)\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span> <span class=\"glyphicon glyphicon-ok pull-right text-success hidden-print\" popover-trigger=mouseenter ng-if=\"key.CalculationStatus == 0 && vm.data.TypeId == 1004\" popover-append-to-body=true uib-popover=\"Pozycja zaakceptowana\" style=\"font-size: 1.3em\"></span> <span class=\"glyphicon glyphicon-remove pull-right text-danger hidden-print\" popover-trigger=mouseenter ng-if=\"key.CalculationStatus == 1 && vm.data.TypeId == 1004\" popover-append-to-body=true uib-popover=\"Pozycja odrzucona\" style=\"font-size: 1.3em\"></span></td><td class=hidden-print><span ng-bind=\"key.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wgraj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.uploadEntityAttachment(key) ng-show=vm.checkPermission(41)><span class=\"glyphicon glyphicon-plus\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Pokaż popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><!--FS--><tr ng-repeat=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId == 2\"><th class=hidden-print><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.Count : key.RelatedEntity.Count\"></span><span ng-if=\"key.CountReturned > 0\">(<span ng-bind=key.CountReturned></span>)</span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"\"></span> <span ng-if=\"key.AmountProductNet !== null\" ng-bind=\"key.AmountProductNet | number:2\"></span> <span ng-if=\"key.AmountProductNet === null\" ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span><!----> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger hidden-print\" popover-trigger=mouseenter ng-if=\"key.AcceptanceReason > 0 && !vm.checkPermission(18)  && vm.data.ObjectStatus == 1\" popover-append-to-body=true uib-popover=\"Pozycje wymagają akceptacji z powodu zmiany ceny\" style=\"font-size: 1.3em\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right hidden-print\" ng-if=\"key.AcceptanceReason > 0 && vm.checkPermission(18)  && vm.data.ObjectStatus == 1\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span> <span uib-popover-template=\"\'app/components/documents/promotion.popover.html\'\" class=\"fa fa-tag pull-right hidden-print\" style=\"font-size: 1.3em\" ng-if=\"key.PromotionAmountProductNet == key.AmountSelectedNet && key.PromotionId != null\" popover-trigger=outsideClick></span></td><td class=hidden-print><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountNet : key.RelatedEntity.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountVAT : key.RelatedEntity.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountGross : key.RelatedEntity.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Pokaż popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><!--dla KFS - pokazywanie rozwijanych pozycji z korektą itp --><!--FS - 2, ZK 16, WZ - 11--><tr ng-repeat-start=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId == 6\" ng-class=\"{\'info\': key.Count > 0}\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><th><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.Count : key.RelatedEntity.Count\"></span> <span ng-if=\"key.Count > 0\" ng-bind=\"\'(\' +  -key.Count + \')\'\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountNet : key.RelatedEntity.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountVAT : key.RelatedEntity.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountGross : key.RelatedEntity.AmountGross | number:2\"></span></td><td class=hidden-print><button type=button class=\"btn btn-default btn-xs\" uib-popover=Pokaż popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><tr ng-if=\"key.Count > 0 && vm.data.TypeId == 6\" ng-hide=key.isCollapsed class=info><th><span>-</span></th><td><span class=pull-right>Korekta</span></td><td><span ng-bind=-key.Count></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"-key.AmountNet  | number:2\"></span></td><td><span ng-bind=\"-key.AmountVAT  | number:2\"></span></td><td><span ng-bind=\"-key.AmountGross| number:2\"></span></td><td><span></span></td></tr><tr ng-repeat-end ng-if=\"key.Count > 0 && vm.data.TypeId == 6\" ng-hide=key.isCollapsed class=info><th><span>-</span></th><td><span class=pull-right>Po korekcie</span></td><td><span ng-bind=\"key.RelatedEntity.Count - key.Count\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity.AmountNet - key.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity.AmountVAT - key.AmountVAT | number:2\"></span></td><td><span ng-bind=\" key.RelatedEntity.AmountGross - key.AmountGross| number:2\"></span></td><td><span></span></td></tr><tr class=info><th ng-show=\"vm.data.TypeId != 1004\" colspan=6 class=hidden-print><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><th ng-show=\"vm.data.TypeId == 1004\" colspan=8 class=hidden-print><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><th colspan=4 style=\"display: none\" class=print-display-cell><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><td><span ng-bind=\"vm.data.AmountNet | number:2\"></span></td><td><span ng-bind=\"vm.data.AmountVAT | number:2\"></span></td><td><span ng-bind=\"vm.data.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"></td></tr><tr class=\"info hidden-print\" ng-show=\"vm.data.TypeId === 1 || vm.data.TypeId === 2 || vm.data.TypeId === 6 || vm.data.TypeId === 5\"><th colspan=6><span ng-bind=\"\'Pozostaje do zapłaty\'\" class=pull-right></span></th><td><span ng-bind=\"\"></span></td><td><span ng-bind=\"\"></span></td><td><span ng-bind=\"vm.data.AmountPaidLeft | number:2\"></span></td><td ng-if=\"vm.data.TypeId == 1004\"></td></tr><tr class=\"info hidden-print\" ng-show=\"vm.data.TypeId === 1 || vm.data.TypeId === 2 || vm.data.TypeId === 6 || vm.data.TypeId === 5\"><th colspan=6><span ng-bind=\"\'Zapłacono\'\" class=pull-right></span></th><td></td><td></td><td><span ng-bind=\"vm.data.AmountGrossView - vm.data.AmountPaidLeft | number:2\"></span></td><td ng-if=\"vm.data.TypeId == 1004\"></td></tr></tbody></table><!-- sign space shown on print--><div style=\"display: none; padding-top: 50px\" class=print-display-cell><div style=\"border-bottom: 1px solid; width: 200px\"></div><span style=\"font-size: 10px; padding: 5px 0px 0px 25px\">Podpis</span></div><!-- end of sign space --></div><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 0\" ng-click=vm.goBack() id=doc-back-button>{{\'common.actions.goBack\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 0\" ng-click=vm.printDocument() id=doc-print-button>{{\'common.actions.print\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1\" ng-click=vm.sendAgainToAccountingSystem() id=doc-send-again-button ng-if=vm.data.IsSubiektError>{{\'documents.actions.sendAgain\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1\" ng-click=vm.sendToClient() id=doc-send-to-client-button ng-if=vm.canBeSendToClient()>{{\'documents.actions.sendToClient\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1\" ng-click=vm.sendForAcceptance() id=doc-accept_positions-button ng-if=\"((vm.data.AcceptanceReason === 1 || vm.data.AcceptanceReason === 2) && vm.checkPermission(18)) ||\r\n                ((vm.data.AcceptanceReason === 3) && vm.checkPermission(28))\">Zapisz zmiany</button></div></div></div></div>");
$templateCache.put("app/components/documents/documents.history.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Dokumenty usunięte</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'documents.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 ng-show=vm.checkPermission(6)><label>Osoba usuwająca</label><ui-select ng-model=vm.pagingData.userId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.typeId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.DocumentTypeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><div class=row><div class=col-sm-6><label>{{\'documents.search.contractor\' | translate}}</label><div class=input-group><button type=button class=\"btn btn-default\" ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-search\"></span></button> <span>{{vm.pagingData.contractor.Name}} </span><button type=button class=\"btn btn-default\" ng-click=vm.removeContractor() ng-if=\"vm.pagingData.contractor !== undefined\"><span class=\"glyphicon glyphicon-remove\"></span></button> <span></span></div><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><div class=row><div class=col-sm-3><label>Suma netto dla kryteriów</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=!!vm.sums.totalAmount>{{vm.sums.totalAmount | number: 2}}</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=!vm.sums.totalAmount>---</div></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><div class=\"col-sm-12 col-md-12\"><uib-alert ng-show=\"vm.pagingData.totalCount>vm.maxCount\"><span ng-bind=\"\'documents.search.countWarning1\' | translate\"></span> <span ng-bind=vm.maxCount></span> <span ng-bind=\"\'documents.search.countWarning2\' | translate\"></span> <span ng-bind=vm.pagingData.totalCount></span> <span ng-bind=\"\'documents.search.countWarning3\' | translate\"></span></uib-alert></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><!-- 15 %--><th class=\"uiGridHeader rowNumberFull\">Pełny numer</th><!-- 10 %--><th class=\"uiGridHeader rowDate\">Data usunięcia</th><!-- 10 %--><th class=\"uiGridHeader rowDate\">Osoba</th><!-- 10 %--><th class=\"uiGridHeader rowDate\">Stanowisko</th><!-- 10  %--><th class=\"uiGridHeader rowAmount\">Wartość netto</th><!-- 10 %--><th class=\"uiGridHeader rowAmount\">Wartość brutto</th><!-- 25 %--><th class=\"uiGridHeader rowPayer\">Płatnik</th><!-- 7  %--><th class=\"uiGridHeader rowActionDocuments\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.ObjectName></span></th><td><span ng-bind=\"key.OperationDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=key.OperationUserName></span></td><td><span ng-bind=key.OperationUserPosition></span></td><td><span ng-bind=key.AmountNet.toFixed(2)></span></td><td><span ng-bind=key.AmountGross.toFixed(2)></span></td><td><span ng-bind=key.PayerName uib-popover={{key.PayerName}} popover-trigger=mouseenter></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.documents.history.document({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-8><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=\"vm.pagingData.totalCount > vm.maxCount ? vm.maxCount : vm.pagingData.totalCount\" max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --><!-- /.panel -->");
$templateCache.put("app/components/documents/documents.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Dokumenty</div><div class=panel-body><div><div class=row><div class=col-sm-3><label class=control-label>{{\'documents.search.documentNumber\' | translate}}</label><div class=input-group><input type=number class=form-control ng-model=vm.pagingData.documentNumber on-press-enter=vm.onFilterChange() id=DocumentSearchBox name=DocumentSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'documents.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.amountFrom\' | translate}}</label><div class=input-group><input type=number class=form-control ng-model=vm.pagingData.amountBegin on-press-enter=vm.onFilterChange()> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.amountTo\' | translate}}</label><div class=input-group><input type=number class=form-control ng-model=vm.pagingData.amountEnd on-press-enter=vm.onFilterChange()> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.category\' | translate}}</label><ui-select ng-model=vm.pagingData.categoryId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.DocumentCategoryDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 ng-show=vm.checkPermission(6)><label>{{\'contractors.search.patron\' | translate}}</label><ui-select ng-model=vm.pagingData.userId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.typeId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.DocumentTypeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.status\' | translate}}</label><ui-select ng-model=vm.pagingData.status theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.DocumentStatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.storage\' | translate}}</label><ui-select ng-model=vm.pagingData.storageId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 style=\"position: relative\" ng-if=vm.checkPermission(37)><label style=\"width: 100%\">Zmodyfikowany</label><!--<input type=\"checkbox\" class=\"acceptance-checkbox\" ng-model=\"vm.pagingData.acceptance\" ng-change=\"vm.onFilterChange()\">--><div class=\"checkbox checkbox-primary acceptance-checkbox\"><input type=checkbox ng-model=vm.pagingData.isModified ng-change=vm.onFilterChange()><label></label></div></div></div><div class=row><div class=col-sm-6><label>{{\'documents.search.contractor\' | translate}}</label><div class=input-group><button type=button class=\"btn btn-default\" ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-search\"></span></button> <span>{{vm.pagingData.contractor.Name}} </span><button type=button class=\"btn btn-default\" ng-click=vm.removeContractor() ng-if=\"vm.pagingData.contractor !== undefined\"><span class=\"glyphicon glyphicon-remove\"></span></button> <span></span></div><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><div class=\"col-sm-12 col-md-12\"><uib-alert ng-show=\"vm.pagingData.totalCount>vm.maxCount\"><span ng-bind=\"\'documents.search.countWarning1\' | translate\"></span> <span ng-bind=vm.maxCount></span> <span ng-bind=\"\'documents.search.countWarning2\' | translate\"></span> <span ng-bind=vm.pagingData.totalCount></span> <span ng-bind=\"\'documents.search.countWarning3\' | translate\"></span></uib-alert></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><!-- 15 %--><th class=\"uiGridHeader rowNumberFull\">Pełny numer</th><!-- 10 %--><th class=\"uiGridHeader rowDate\">Data wystawienia<i class=fa ng-class=\"{\'fa-sort-asc\': vm.pagingData.sortByDate <0, \'fa-sort-desc\': vm.pagingData.sortByDate >0}\" ng-click=vm.changeSortByDate()></i></th><!-- 10 %--><th class=\"uiGridHeader rowDate\">Data płatności</th><!-- 10  %--><th class=\"uiGridHeader rowAmount\">Wartość netto</th><!-- 10 %--><th class=\"uiGridHeader rowAmount\">Wartość brutto</th><!-- 25 %--><th class=\"uiGridHeader rowPayer\">Płatnik</th><!-- 13 %--><th class=\"uiGridHeader rowStatus\">Status</th><!-- 7  %--><th class=\"uiGridHeader rowActionDocuments\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\" ng-class=\"{warning: key.IsModifiedByUser == true && vm.checkPermission(37)}\"><th><span ng-bind=key.DocumentNumberFull></span></th><!--<td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentTypeDictionary\',key.TypeId).Value\"></span></td>--><td><span ng-bind=\"key.DocumentReleaseDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"key.PaymentDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=key.AmountNet.toFixed(2)></span></td><td><span ng-bind=key.AmountGross.toFixed(2)></span></td><td><span ng-bind=key.PayerName uib-popover={{key.PayerName}} popover-trigger=mouseenter></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentStatusDictionary\',key.Status).Value\" uib-popover=\"{{vm.getDictionaryElementByType(\'DocumentStatusDictionary\',key.Status).Value}}\" popover-trigger=mouseenter></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.documents.document({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <span ng-if=\"key.IsSubiektError === true\" class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Błąd podczas wysyłki\" style=\"position: absolute; margin-left: 5px; font-size: 1.3em\"></span></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-8><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=\"vm.pagingData.totalCount > vm.maxCount ? vm.maxCount : vm.pagingData.totalCount\" max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --><!-- /.panel -->");
$templateCache.put("app/components/documents/promotion.popover.html","<div><p>Cena oryginalna: {{key.OriginalAmountProductNet | number:2}}</p><p>Cena promocyjna: {{key.AmountSelectedNet | number:2}}</p><button type=button class=\"btn btn-default btn-xs\" ng-click=vm.goToPromotion(key)>idź do promocji</button></div>");
$templateCache.put("app/components/login/login.directive.html","<h1 class=\"text-center login-title\">{{\'login.title\' | translate}}</h1><form name=myForm class=form-signin><formly-form model=vm.user fields=vm.userFields form=vm.loginForm><uib-alert ng-show=vm.isError type=danger class=alert-login role=alert close=vm.closeAlert()>{{vm.error}}</uib-alert><div class=\"checkbox checkbox-primary\"><input type=checkbox id=checkbox1 ng-model=vm.stayLogged><label for=checkbox1>{{\'login.stayLoggedCheckbox\' | translate}}</label></div><md-button type=submit name=submit ng-disabled=vm.loginForm.$invalid ng-click=\"vm.logIn(vm.user.email, vm.user.password)\" class=\"btn btn-lg btn-primary btn-block login-submit\"><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\" ng-show=vm.isLoading></span> {{\'common.form.login\' | translate}}</md-button></formly-form><a ng-click=vm.goToRegister() class=\"pull-right need-help\">{{\'common.form.help\' | translate}} </a><span class=clearfix></span></form>");
$templateCache.put("app/components/login/login.html","<div class=container><div class=\"col-sm-6 col-md-4 col-md-offset-4\"><div class=account-wall><div class=logo></div><nxas-login sref=home.mainPage show-register=true></nxas-login></div></div></div>");
$templateCache.put("app/components/login/login.modal.html","<div><div class=row><div class=\"col-sm-12 col-md-12\"><nxas-login dispatch-events=true></nxas-login></div></div></div>");
$templateCache.put("app/components/login/register.html","<!--Wywołanie usługi LoginController.register(email, password, confirmPassword)\n--><div class=container><div class=row><div class=\"col-sm-6 col-md-4 col-md-offset-4\"><div class=account-wall><h1 class=\"text-center login-title\">{{\'register.title\' | translate}}</h1><form class=form-signin ng-submit=\"vm.register(vm.user.email, vm.user.password, vm.user.password2)\"><formly-form model=vm.user fields=vm.userFields><div ng-show=vm.isError class=\"alert alert-danger alert-dismissible\" role=alert>{{vm.error}}</div><md-button type=submit class=\"btn btn-lg btn-primary btn-block\" ng-click=\"vm.register(vm.user.email, vm.user.password, vm.user.password2)\">{{\'common.form.register\' | translate}}</md-button></formly-form></form></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=navbar-header><a class=navbar-brand href=# ui-sref=home.mainPage><img class=navbar-logo ng-src=/assets/images/logo_w.svg width=60px></a><span class=menu-hamburger ng-click=vm.toggleMenu()></span><ul class=\"nav navbar-nav navbar-top-links navbar-right\"><script type=text/ng-template id=notifPopover.html><div style=\"width: 220px\">\r\n        <div>\r\n          <div ng-click=\"vm.goToNofif(\'1\')\">\r\n            Nowi kontrahenci: {{vm.notificationsCountByType[\"1\"]}}\r\n          </div>\r\n        </div>\r\n        <!--<div ng-repeat=\"key in vm.notifications\">-->\r\n        <!--<div ng-click=\"vm.goToNofif(key)\"><b ng-if=\"key.Status < 10\">{{key.Title}}</b><span ng-if=\"key.Status >= 10\">{{key.Title}}</span></div>-->\r\n        <!--</div>-->\r\n      </div></script><!-- /.dropdown --><li ng-if=\"vm.AuthService.isUserLogged() && vm.notificationsCount < 1\"><a><span class=\"glyphicon glyphicon-bell\"></span> <span class=\"badge badge-notify\">{{vm.notificationsCount}}</span></a></li><!--<li class=\"notifications\" ng-if=\"vm.AuthService.isUserLogged() && vm.notificationsCount >= 1\">\r\n        <a uib-popover-template=\"vm.popoverTemplate\" popover-placement=\"bottom\">\r\n          <span class=\"glyphicon glyphicon-bell\"></span>\r\n          <span class=\"badge\"\r\n                ng-class=\"{\'badge-notify\': vm.newNotificationsCount < 1, \'badge-notify-red\': vm.newNotificationsCount > 0}\">{{vm.notificationsCount}}</span>\r\n        </a>\r\n      </li>--><!-- /.dropdown --><!--<li>--><!--<a ng-click=\"vm.openM()\">--><!--<span class=\"glyphicon glyphicon-bell\"></span>--><!--<span class=\"badge badge-notify\">3</span>--><!--</a>--><!--&lt;!&ndash; /.dropdown-alerts &ndash;&gt;--><!--</li>--><li ng-if=vm.AuthService.isUserLogged()><a href=# ng-click=vm.logout()><span>Wyloguj</span><!--<span class=\"badge badge-notify\">3</span>--> </a><!-- /.dropdown-user --></li><!-- /.dropdown --></ul></div><nav ng-class=\"{active: vm.menuShown}\" class=navbar-smak><ul class=\"nav navbar-nav\" ng-show=\"vm.checkPermission(1) || vm.checkPermission(2) || vm.checkPermission(22)\"><!--<li>\r\n          <a ui-sref=\"home.mainPage\">\r\n            <span class=\"glyphicon glyphicon-home\"></span>\r\n            //<span class=\"badge badge-notify\">3</span>\r\n          </a>\r\n        </li>--><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(0) class=dropdown-toggle>{{\'navbar.manage.title\' | translate}} <span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[0]}\" class=\"nav navbar-nav dropdown-items\"><li ng-show=vm.checkPermission(1)><a ui-sref=home.users>{{\'navbar.manage.users\' | translate}}</a></li><li ng-show=vm.checkPermission(2)><a ui-sref=home.roles>{{\'navbar.manage.roles\' | translate}}</a></li><!-- TODO permission \"vm.checkPermission(22)\"--><li ng-show=vm.checkPermission(22)><a ui-sref=\"home.counters({id: 0})\">{{\'navbar.manage.counters\' | translate}}</a></li></ul></ul><ul class=\"nav navbar-nav\" ng-show=\"(vm.checkPermission(6) || vm.checkPermission(7) || vm.checkPermission(8))\"><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(1) class=dropdown-toggle>{{\'navbar.crm.title\' | translate}} <span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[1]}\" class=\"nav navbar-nav dropdown-items\"><li ng-show=\"(vm.checkPermission(6) || vm.checkPermission(7) || vm.checkPermission(8))\"><a ui-sref=home.contractors>{{\'navbar.crm.contractors\' | translate}}</a></li><!--\r\n          <li ng-show=\"vm.checkPermission(4)\"><a ui-sref=\"home.contractors.contractor({id:0})\">{{\'navbar.crm.addContractor\'\r\n          | translate}}</a></li> --></ul></ul><ul class=\"nav navbar-nav\" ng-show=\"(vm.checkPermission(6) || vm.checkPermission(7) || vm.checkPermission(8)|| vm.checkPermission(9)|| vm.checkPermission(25))\"><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(2) class=dropdown-toggle>{{\'navbar.doc-task.title\' | translate}}<span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[2]}\" class=\"nav navbar-nav dropdown-items\"><li ng-show=\"(vm.checkPermission(6) || vm.checkPermission(7) || vm.checkPermission(8))\"><a ui-sref=home.documents>{{\'navbar.doc-task.documents\' | translate}}</a></li><li ng-show=vm.checkPermission(9)><a ui-sref=home.tasks>{{\'navbar.doc-task.tasks\' | translate}}</a></li><li ng-show=vm.checkPermission(25)><a ui-sref=\"home.samples({typeId: 1003})\">{{\'navbar.doc-task.samples\' | translate}}</a></li><li ng-show=vm.checkPermission(31)><a ui-sref=\"home.samples({typeId: 1002})\">{{\'navbar.doc-task.degustations\' | translate}}</a></li><li ng-show=vm.checkPermission(36)><a ui-sref=home.degreport>Raport DE/PR</a></li><li><a ng-show=vm.checkPermission(37) ui-sref=home.documents.history>Usunięte dokumenty</a></li><li><a ng-show=vm.checkPermission(37) ui-sref=home.producthisotoryreport>Raport zmian na dokumentach</a></li></ul></ul><ul class=\"nav navbar-nav\" ng-show=\"vm.checkPermission(14) || vm.checkPermission(26) || vm.checkPermission(27)\"><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(3) class=dropdown-toggle>{{\'navbar.products.title\' | translate}}<span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[3]}\" class=\"nav navbar-nav dropdown-items\"><li ng-show=vm.checkPermission(14)><a ui-sref=home.products>{{\'navbar.products.products\' | translate}}</a></li><li ng-show=vm.checkPermission(26)><a ui-sref=home.preferredProductsList>{{\'navbar.products.preferredProd\' | translate}}</a></li><!--\r\n          <li><a ui-sref=\"home.preferredProductsList.one({id:0})\">Dodaj listę produktów</a></li>\r\n          --><li ng-show=vm.checkPermission(27)><a ui-sref=home.promotions>{{\'navbar.products.promotions\' | translate}}</a></li><!--\r\n          <li><a ui-sref=\"home.promotions.promotion({id:0})\">Dodaj promocję</a></li>\r\n          --><li ng-show=vm.checkPermission(27)><a ui-sref=home.excludedProducts>{{\'navbar.products.excluded\' | translate}}</a></li></ul></ul><ul class=\"nav navbar-nav\" ng-show=\"vm.checkPermission(11) || vm.checkPermission(12) || vm.checkPermission(13)\"><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(4) class=dropdown-toggle>{{\'navbar.rout-obj.title\' | translate}}<span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[4]}\" class=\"nav navbar-nav dropdown-items\"><li><a ui-sref=home.routes ng-show=vm.checkPermission(13)>{{\'navbar.rout-obj.routes\' | translate}}</a></li><li><a ui-sref=home.objectives ng-show=vm.checkPermission(12)>{{\'navbar.rout-obj.objectives\' | translate}}</a></li></ul></ul><ul class=\"nav navbar-nav\" ng-show=vm.checkPermission(21)><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(5) class=dropdown-toggle>{{\'navbar.visits.title\' | translate}}<span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[5]}\" class=\"nav navbar-nav dropdown-items\"><li ng-show=vm.checkPermission(21)><a ui-sref=home.visits>{{\'navbar.visits.visits\' | translate}}</a></li></ul></ul><ul class=\"nav navbar-nav\" ng-show=vm.checkPermission(43)><li class=dropdown><a ui-sref=home.returns class=dropdown-toggle>Zwroty</a></li></ul><ul class=\"nav navbar-nav\" ng-show=vm.checkPermission(44)><li class=dropdown><a ui-sref=home.reports class=dropdown-toggle>Raporty</a></li></ul><ul class=\"nav navbar-nav\" ng-show=vm.checkPermission(24)><li class=dropdown><a href=\"\" ng-click=vm.toggleMenuItem(6) class=dropdown-toggle>{{\'navbar.app.title\' | translate}}<span class=caret></span></a></li><ul ng-class=\"{active: vm.menuItemActive[6]}\" class=\"nav navbar-nav dropdown-items\"><li><a ui-sref=home.parametrization ng-show=vm.checkPermission(24)>{{\'navbar.app.params\' | translate}}</a></li><li><a ui-sref=home.templates ng-show=vm.checkPermission(24)>{{\'navbar.app.templates\' | translate}}</a></li></ul></ul><ul class=\"nav navbar-nav\" ng-show=vm.checkPermission(42)><li class=dropdown><a href=https://web.dokumenty.nextapps.pl class=dropdown-toggle>{{\'navbar.documentSystem.title\' | translate}}</a></li></ul><!--</ul>--></nav>");
$templateCache.put("app/components/notifications/notification.html","");
$templateCache.put("app/components/notifications/notifications.html","notifications");
$templateCache.put("app/components/excludedProducts/excludedProducts.html","<div><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Produkty wyłączone ze sprzedaży</div><div class=panel-body><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><table class=\"table table-striped uiGrid\" ng-show=!vm.isDataReloading><thead><tr><th class=uiGridHeader style=\"width: 30%\">Produkt</th><th class=uiGridHeader style=\"width: 20%\">Magazyn</th><th class=uiGridHeader style=\"width: 20%\">Od</th><th class=uiGridHeader style=\"width: 20%\">Do</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><!-- ------------------OLD------------ --><tr ng-repeat=\"key in vm.excludedProducts\"><td><div class=flex-cell style=\"justify-content: space-between\"><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.ProductContext.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Wybierz produkt\" popover-trigger=mouseenter popover-append-to-body=true ng-if=!key.Id ng-click=vm.selectProduct(key)><span class=\"glyphicon glyphicon-plus\"></span></button></div></td><td><div class=form-group ng-class=\"{\'has-error\': !key.StorageId}\" style=\"margin-bottom: 0px\"><ui-select ng-model=key.StorageId theme=bootstrap append-to-body=true ng-disabled=key.Id ng-change=\"key.IsChanged = true\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td><td><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=key.BeginDate is-open=vm.beginDatePickerOpened[$index] ng-change=\"key.IsChanged = true\" datepicker-options=vm.dateOptions close-text=Zamknij datepicker-append-to-body=true current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1, $index, key)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=key.EndDate is-open=vm.endDatePickerOpened[$index] ng-change=\"key.IsChanged = true\" datepicker-options=vm.dateOptions close-text=Zamknij datepicker-append-to-body=true current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2, $index, key)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wyślij popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.sendRecord(key) ng-disabled=!vm.shouldSend(key) ng-class=\"{\'green-background\': vm.shouldSend(key)}\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.removeRow(key, $index)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><!-- ------------------OLD------------ --><!-- ------------------NEW------------ --><tr ng-repeat=\"key in vm.excludedProductsView\"><td><div class=flex-cell style=\"justify-content: space-between\"><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.ProductContext.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Wybierz produkt\" popover-trigger=mouseenter popover-append-to-body=true ng-if=key.IsNew ng-click=vm.selectProduct(key)><span class=\"glyphicon glyphicon-plus\"></span></button></div></td><td><div class=form-group ng-class=\"{\'has-error\': key.StorageIds.length < 1}\" style=\"margin-bottom: 0px\"><ui-select multiple ng-model=key.StorageIds theme=bootstrap append-to-body=true ng-disabled=key.Id ng-change=\"key.IsChanged = true\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$item.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td><td><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=key.BeginDate is-open=vm.beginDatePickerOpened[$index] ng-change=\"key.IsChanged = true\" datepicker-options=vm.dateOptions close-text=Zamknij datepicker-append-to-body=true current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1, $index, key)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=key.EndDate is-open=vm.endDatePickerOpened[$index] ng-change=\"key.IsChanged = true\" datepicker-options=vm.dateOptions close-text=Zamknij datepicker-append-to-body=true current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2, $index, key)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wyślij popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.sendRecord(key) ng-disabled=!vm.shouldSend(key) ng-class=\"{\'green-background\': vm.shouldSend(key)}\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.removeRow(key, $index)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><!-- ------------------NEW------------ --><tr><td colspan=5><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.addNew()><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><div class=\"row hidden-print\"><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/components/objectives/objective.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{\'objective.name\' | translate}}</div><div class=panel-body><form name=vm.form><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'objective.data.basic\' | translate}}</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row style=\"vertical-align: middle\">{{\'objective.data.name\' | translate}}</th><td><div class=form-group ng-class=\"{\'has-error\' : !vm.form.objectiveName.$valid}\"><input ng-model=vm.currentObjective.Name maxlength=45 min=3 max=45 class=form-control name=objectiveName ng-required=true ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))></div></td></tr><tr><th scope=row>{{\'objective.data.dateFrom\' | translate}}</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateFrom.$valid}\"><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.currentObjective.BeginDate is-open=vm.datePickerBeginOpened ng-change=\"vm.onDateChange(vm.endDateOptions, vm.currentObjective.BeginDate, true)\" datepicker-options=vm.beginDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFrom ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\" ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr><th scope=row>{{\'objective.data.dateTo\' | translate}}</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateTo.$valid}\"><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.currentObjective.EndDate is-open=vm.datePickerEndOpened ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.currentObjective.EndDate, false)\" datepicker-options=vm.endDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateTo ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\" ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr><th scope=row>{{\'objective.data.imagesQuantity\' | translate}}</th><td><ion-range-slider type=single min=0 max=5 from=vm.currentObjective.ImagesRequired step=1 disable=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))></ion-range-slider></td></tr><tr><th scope=row>{{\'objective.data.OwnerUser\' | translate}}</th><td><span>{{vm.currentObjective.User.SurName + \' \' + vm.currentObjective.User.Name}}</span> <button type=button class=\"btn btn-default btn-xs pull-right\" uib-popover=\"Wybierz siebie\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.setLoggedUserAsOwnerUser() ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))><span class=\"glyphicon glyphicon-user\"></span></button> <button type=button class=\"btn btn-default btn-xs pull-right\" uib-popover=\"Wybierz z listy\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectOwnerUser() ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent)) style=\"margin: 0px 2px 0px 0px\"><span class=\"glyphicon glyphicon-plus\"></span></button> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Wybierz właściciela\" ng-if=\"vm.currentObjective.User === undefined\" style=\"margin: 0px 10px 0px 0px; font-size: 1.5em\"></span></td></tr><tr ng-if=\"(vm.currentObjective.Type === 3)||(vm.currentObjective.ParentId > 0)\"><th scope=row ng-if=vm.showSingleSubContext(1)>{{\'objective.data.user\' | translate}}</th><th scope=row ng-if=vm.showSingleSubContext(2)>{{\'objective.data.contractor\' | translate}}</th><th scope=row ng-if=\"vm.currentObjective.Type === 3\">{{\'objective.data.group\' | translate}}</th><td><span ng-if=vm.showSingleSubContext(1)>{{vm.currentObjective.ContextObject.SurName + \' \' + vm.currentObjective.ContextObject.Name}}</span> <span ng-if=vm.showSingleSubContext(2)>{{vm.currentObjective.ContextObject.Name}}</span> <span ng-if=\"vm.currentObjective.Type === 3\">{{vm.currentObjective.ContextObject.Value}}</span> <button type=button class=\"btn btn-default btn-xs pull-right\" uib-popover=Wybierz popover-trigger=mouseenter popover-append-to-body=true ng-if=\"vm.currentObjective.Type === 3\" ng-click=vm.selectContractorGroup(3) ng-disabled=\"((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent)||(vm.currentObjective.User === undefined))\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><div class=\"panel panel-default\" ng-if=vm.showChildContextList()><div class=panel-heading ng-if=\"vm.currentObjective.Type === 1\">Użytkownicy</div><div class=panel-heading ng-if=\"vm.currentObjective.Type === 2\">Kontrahenci</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 80%\" ng-if=\"vm.currentObjective.Type === 1\">Imię i Nazwisko</th><th class=uiGridHeader style=\"width: 80%\" ng-if=\"vm.currentObjective.Type === 2\">Nazwa</th><th class=uiGridHeader style=\"width: 20%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentObjective.ChildContextObjects\"><td ng-if=\"vm.currentObjective.Type === 1\"><span uib-popover={{key.SurName}} popover-trigger=mouseenter>{{key.SurName + \' \' + key.Name}}</span></td><td ng-if=\"vm.currentObjective.Type === 2\"><span ng-bind=key.Name uib-popover={{key.Name}} popover-trigger=mouseenter></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeFromChildLists(key.ContextId) ng-disabled=(!vm.permission)||(!vm.isToDoInFuture)><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=3><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContext() ng-disabled=\"(!vm.permission)||(!vm.isToDoInFuture)||(vm.currentObjective.User === undefined)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'objective.data.description\' | translate}}</div><div class=panel-body><div class=form-group ng-class=\"{\'has-error\' : !vm.form.objectiveDescription.$valid}\"><textarea cols=\"\" rows=\"\" ng-model=vm.currentObjective.Description placeholder=\"Opis zadania...\" class=\"textarea-style form-control\" name=objectiveDescription ng-required=true ng-disabled=((!vm.permission)||(!vm.isToDoInFuture)||(vm.hasParent))>\r\n                  </textarea></div></div></div></div><div class=\"col-sm-6 col-md-4\" ng-if=vm.showCommentary()><div class=\"panel panel-default\"><div class=panel-heading>{{\'objective.data.commentary\' | translate}}</div><div class=panel-body><textarea cols=\"\" rows=\"\" ng-model=vm.currentObjective.UserComment placeholder=\"Komentarz pracownika...\" class=textarea-style ng-disabled=((!vm.isToDoInFuture)||(vm.currentObjective.Finished)||(vm.hasParent))></textarea></div></div></div><!--\r\n        </div>\r\n      --></div></form><!--\r\n      <div class=\"row\">\r\n      --><div class=\"col-sm-18 col-md-12\" ng-if=!vm.new><div class=\"panel panel-default\"><div class=panel-heading>{{\'objective.data.images\' | translate}}</div><div class=panel-body><ul style=\"list-style-type: none; padding-left: 0px\"><li ng-repeat=\"image in vm.currentObjective.Files\" ng-if=\"image.Type === 1\" class=image-li><a ng-click=vm.openLightboxModal($index)><img ng-src={{image.FileUrl}} width=100px height=\"100 px\" class=img-thumbnail> </a><button type=button class=\"btn btn-default btn-xs delete-button\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeImg(image) ng-if=vm.isToDoInFuture><span class=\"glyphicon glyphicon-remove\"></span></button></li></ul><button type=submit class=\"btn btn-primary\" ng-click=vm.uploadAttachment() ng-disabled=((!vm.isToDoInFuture)||(vm.hasParent))>Wgraj zdjęcie</button></div></div></div><div class=\"col-sm-18 col-md-12\" ng-if=vm.showSubContractorList()><div class=\"panel panel-default\"><div class=panel-heading>{{\'objective.data.subList\' | translate}}</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 20%\" ng-if=\"vm.currentObjective.Type === 1\">Użytkownik</th><th class=uiGridHeader style=\"width: 20%\" ng-if=\"(vm.currentObjective.Type === 2)||(vm.currentObjective.Type === 3)\">Kontrahent</th><th class=uiGridHeader style=\"width: 20%\">Status</th><th class=uiGridHeader style=\"width: 20%\">Właściciel</th><th class=uiGridHeader style=\"width: 10%\">Akcje</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th ng-if=\"vm.currentObjective.Type === 1\">{{key.ContextObject.SurName + \' \' + key.ContextObject.Name}}</th><th ng-if=\"(vm.currentObjective.Type === 2)||(vm.currentObjective.Type === 3)\"><span ng-bind=key.ContextObject.Name></span></th><td ng-class=\"{done: key.Status.Id === 1, \'in-progress\': key.Status.Id === 2, \'not-done\': key.Status.Id === 3, \'to-do-in-future\': key.Status.Id === 4}\"><span ng-bind=key.Status.Message></span></td><td><span ng-bind=key.UserFullName></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ng-click=vm.goToElement(key) class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeObjective(key)><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>Wróć</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.execute() ng-disabled=!vm.canBeExecuted() ng-if=!vm.permission ng-disable=vm.currentObjective.Finished>Wykonaj</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit() ng-disabled=(!vm.isObjectiveValid()||vm.blockSubmit) ng-if=vm.permission>Zapisz</button><!--\r\n    </div>\r\n    ---></div></div>");
$templateCache.put("app/components/objectives/objectiveType.modal.html","<div class=modal-header><h3 class=modal-title>Wybierz cel</h3></div><div class=\"modal-body overflow-body\"><div class=tile><button class=\"btn tile-button\" ng-click=vm.action(1)><i class=\"fa fa-user\" aria-hidden=true></i></button><div class=tile-text>Użytkownik</div></div><div class=tile><button class=\"btn tile-button\" ng-click=vm.action(2)><i class=\"fa fa-briefcase\" aria-hidden=true></i></button><div class=tile-text>Kontrahent</div></div><div class=tile><button class=\"btn tile-button\" ng-click=vm.action(3)><i class=\"fa fa-sitemap\" aria-hidden=true></i></button><div class=tile-text>Grupa</div></div></div>");
$templateCache.put("app/components/objectives/objectives.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{\'objectives.name\' | translate}}</div><div class=panel-body><div><div><div class=row><div class=col-sm-3><label class=control-label>{{\'objectives.search.name\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=DocumentSearchBox name=DocumentSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-2><label>{{\'objectives.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-2><label>{{\'objectives.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-2><label>{{\'objectives.search.user\' | translate}}</label><ui-select ng-model=vm.pagingData.selectedUserId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'objectives.search.status\' | translate}}</label><ui-select ng-model=vm.pagingData.status theme=bootstrap name=status on-select=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Message}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.statusOptions\"><div ng-bind-html=value.Message></div></ui-select-choices></ui-select></div><div class=col-sm-3><label>{{\'objectives.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.type theme=bootstrap name=type on-select=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Message}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.typeOptions\"><div ng-bind-html=value.Message></div></ui-select-choices></ui-select></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 20%\">Nazwa</th><th class=uiGridHeader style=\"width: 15%\">Użytkownik</th><th class=uiGridHeader style=\"width: 15%\">Status</th><th class=uiGridHeader style=\"width: 13%\">Data rozpoczęcia</th><th class=uiGridHeader style=\"width: 13%\">Data zakończenia</th><th class=uiGridHeader style=\"width: 14%\">Typ</th><th class=uiGridHeader style=\"width: 10%\">Akcje</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name uib-popover={{key.Name}} popover-trigger=mouseenter popover-append-to-body=true></span></th><td><span>{{key.User.SurName + \" \" + key.User.Name}}</span></td><td ng-class=\"{done: key.Status.Id === 1, \'in-progress\': key.Status.Id === 2, \'not-done\': key.Status.Id === 3, \'to-do-in-future\': key.Status.Id === 4}\"><span ng-bind=key.Status.Message></span> <span ng-if=\"key.childCount > 0\">({{key.childFinished}}/{{key.childCount}})</span></td><td><span ng-bind=\"key.BeginDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"key.EndDate |  date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=key.TypeDisplay></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ng-click=vm.goToElement(key) class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeObjective(key)><!--ng-disabled=\"vm.isTaskStarted(key)\"--> <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div><div style=\"overflow-y: hidden; display: flex; flex-direction: column\"><span class=pull-right style=\"margin-bottom: 5px; margin-left: auto\">Rekordów:{{vm.pagingData.totalCount}}</span> <button class=\"btn btn-primary btn-submit\" style=\"margin-left: auto\" ng-click=vm.openObjectiveCreationModal() ng-show=vm.checkPermission(11)>Dodaj nowe zadanie</button></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div></div>");
$templateCache.put("app/components/order/order.html","<div class=\"panel panel-default panel-table\" style=\"margin-top: 40px\"><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><div class=panel-heading ng-hide=vm.isDataReloading>Wizyta dla kontrahenta: {{vm.contractor.Name}}</div><div class=\"panel-body order-panel\" ng-hide=vm.isDataReloading><div ng-show=vm.error class=\"alert alert-danger alert-dismissible alert-login\" role=alert>{{vm.error}}</div><div class=row ng-if=!vm.error style=\"margin-bottom: 20px;display: flex;align-items: stretch\"><div class=\"col col-sm-4\"><table class=\"table table-striped inside-panel\"><tbody><tr><th scope=row>Użytkownik</th><td>{{vm.user.Context.SurName + \' \' + vm.user.Context.Name}} <button type=button class=\"btn btn-default btn-xs pull-right\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectUser()><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr><tr><th scope=row>Data <span ng-if=!vm.isSelectedDateSameAsRoute() popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Data rózni się od daty trasówki!\" class=\"glyphicon glyphicon-exclamation-sign alert-icon pull-right\"></span></th><td><div class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.currentRoute.CurrentDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.order.Date is-open=vm.orderDatePickerOpened datepicker-options=vm.orderDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><!-- datesAreOnSameDay --></tr><tr><th scope=row>Identyfikator trasy</th><td><span ng-if=\"vm.getEventId() === undefined\">---</span> <span ng-if=\"vm.getEventId() != undefined\">{{vm.getEventId()}}</span></td></tr><tr><th scope=row>Symbol kontrahenta</th><td><b>{{vm.contractor.Symbol}}</b></td></tr><tr><td colspan=2><button class=\"btn btn-primary btn-submit inside-panel\" ng-click=vm.contractorHistory(vm.contractor)><span class=\"glyphicon glyphicon-duplicate\"></span> Historia zamówień</button></td></tr></tbody></table></div><div class=\"col col-sm-4\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=\"Komentarz do wizyty...\" ng-model=vm.visitNote></textarea></div><div class=\"col col-sm-4\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=\"Komentarz do kontrahenta...\" ng-model=vm.contractor.NextVisitNote></textarea><button type=button class=\"btn btn-default pull-right\" style=\"margin-right: 30px\" ng-click=vm.saveNextVisitNote(vm.contractor)><i class=\"glyphicon glyphicon-floppy-disk\"></i></button></div></div><uib-accordion close-others=true ng-if=!vm.error><uib-accordion-group is-open=true><uib-accordion-heading><span>Zamówienie ({{vm.order.AmountNet | number: 2}} zł)</span> <span ng-if=\"!vm.areProductsFromDocumentValid(vm.order.Products) || !vm.areProductsMultiplicityValid()\" class=\"glyphicon glyphicon-alert warning-icon\"></span></uib-accordion-heading><div class=row><div style=\"width: 35%; float: left\"><table class=\"table table-striped inside-panel\"><tbody><tr><th scope=row>Suma netto</th><td><span ng-bind=\"vm.order.AmountNet | number: 2\"></span> <span ng-bind=vm.order.CurrencySymbol></span></td></tr><tr><th scope=row>Suma brutto</th><td><span ng-bind=\"vm.order.AmountGross | number: 2\"></span> <span ng-bind=vm.order.CurrencySymbol></span></td></tr><tr><th scope=row>Suma VAT</th><td><span ng-bind=\"vm.order.AmountVAT | number: 2\"></span> <span ng-bind=vm.order.CurrencySymbol></span></td></tr></tbody></table></div><div style=\"width: 40%; float: left\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=Komentarz... ng-model=vm.order.Note></textarea></div><div style=\"width: 25%; float: right\"><button class=\"btn btn-primary btn-submit btn-add-product inside-panel\" ng-click=\"vm.showProductPicker(vm.order.Products, true, {blockPrice: false} )\"><span class=\"glyphicon glyphicon-shopping-cart\"></span> Dodaj produkt</button></div></div><div class=row ng-if=!vm.error><table class=\"table table-hover table-striped uiGrid inside-panel\"><thead><th class=uiGridHeader style=\"width: 40%\">Produkt</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">Ilość</th><th class=uiGridHeader style=\"width: 5%; vertical-align: top\">J</th><th class=uiGridHeader style=\"width: 20%; vertical-align: top\">Cena</th><th class=uiGridHeader style=\"width: 20%; vertical-align: top\">% rabatu</th><th class=uiGridHeader style=\"width: 5%; vertical-align: top\">Akcje</th></thead><tbody><tr ng-repeat=\"key in vm.order.Products | filter: { isAdded: true } track by key.Id\"><td><div class=flex-cell-order><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.Name></span></perfect-scrollbar><div class=multiplicity-icon ng-if=key.Multiplicity uib-popover=\"Krotność: {{key.Multiplicity}}\" popover-trigger=mouseenter popover-append-to-body=true><span ng-class=\"{\'red-color\': !vm.isMultiplicityValid(key)}\" class=\"glyphicon glyphicon-stats\"></span></div><div class=multiplicity-icon ng-if=\"key.Price.MinimalPriceNet > 0\" uib-popover=\"Cena minimalna: {{key.Price.MinimalPriceNet | number: 2}}\" popover-trigger=mouseenter popover-append-to-body=true><span ng-class=\"{\'red-color\': !vm.isPriceValid(key)}\" class=\"glyphicon glyphicon-usd\"></span></div><button type=button class=\"btn btn-default pull-right\" popover-append-to-body=true popover-trigger=\"click outsideClick\" uib-popover-template=\"\'app/components/order/productPopover.html\'\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isCountValid(key)}\"><input class=form-control tabindex=\"{{$index + 1}}\" type=number ng-model=key.Count ng-change=\"vm.updatePrice(key, vm.order, vm.order.Products)\"></div></td><td><span>{{key.MeasureUnit}}</span></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isPriceValid(key)}\"><input class=form-control type=number step=0.01 ng-model=key.MyPriceNet ng-change=\"vm.onPriceChange(key, false, vm.order, vm.order.Products)\"></div></td><td><input class=form-control type=number ng-model=key.DiscountPercent ng-change=\"vm.onPriceChange(key, true, vm.order, vm.order.Products)\"></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"key.isAdded = false; vm.updatePrice(key, vm.order, vm.order.Products)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></uib-accordion-group><uib-accordion-group is-open=false><uib-accordion-heading><span>Zwrot w terminie ({{vm.timeReturn.AmountNet | number: 2}} zł)</span> <span ng-if=!vm.areProductsFromDocumentValid(vm.timeReturn.Products) class=\"glyphicon glyphicon-alert warning-icon\"></span></uib-accordion-heading><div class=row><div style=\"width: 35%; float: left\"><table class=\"table table-striped inside-panel\"><tbody><tr><th scope=row>Suma netto</th><td><span ng-bind=\"vm.timeReturn.AmountNet | number: 2\"></span> <span ng-bind=vm.timeReturn.CurrencySymbol></span></td></tr><tr><th scope=row>Suma brutto</th><td><span ng-bind=\"vm.timeReturn.AmountGross | number: 2\"></span> <span ng-bind=vm.timeReturn.CurrencySymbol></span></td></tr><tr><th scope=row>Suma VAT</th><td><span ng-bind=\"vm.timeReturn.AmountVAT | number: 2\"></span> <span ng-bind=vm.timeReturn.CurrencySymbol></span></td></tr></tbody></table></div><div style=\"width: 40%; float: left\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=Komentarz... ng-model=vm.timeReturn.Note></textarea></div><div style=\"width: 25%; float: right\"><button class=\"btn btn-primary btn-submit btn-add-product inside-panel\" ng-click=\"vm.showProductPicker(vm.timeReturn.Products, false, {blockPrice: true})\"><span class=\"glyphicon glyphicon-shopping-cart\"></span> Dodaj produkt</button></div></div><div class=row ng-if=!vm.error><table class=\"table table-hover table-striped uiGrid inside-panel\"><thead><th class=uiGridHeader style=\"width: 65%\">Produkt</th><th class=uiGridHeader style=\"width: 20%; vertical-align: top\">Ilość</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">J</th><th class=uiGridHeader style=\"width: 5%; vertical-align: top\">Akcje</th></thead><tbody><tr ng-repeat=\"key in vm.timeReturn.Products | filter: { isAdded: true } track by key.Id\"><td><div class=flex-cell-order><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default pull-right\" popover-append-to-body=true popover-trigger=\"click outsideClick\" uib-popover-template=\"\'app/components/order/productPopover.html\'\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isCountValid(key)}\"><input class=form-control tabindex=\"{{$index + 1}}\" type=number ng-model=key.Count ng-change=\"vm.updatePrice(key, vm.timeReturn, vm.timeReturn.Products)\"></div></td><td><span>{{key.MeasureUnit}}</span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"key.isAdded = false; vm.updatePrice(key, vm.timeReturn, vm.timeReturn.Products)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></uib-accordion-group><uib-accordion-group is-open=false><uib-accordion-heading><span>Zwrot jakościowy ({{vm.qualityReturn.AmountNet | number: 2}} zł)</span> <span ng-if=\"!vm.areProductsFromDocumentValid(vm.qualityReturn.Products, 1004)\" class=\"glyphicon glyphicon-alert warning-icon\"></span></uib-accordion-heading><div class=row><div style=\"width: 35%; float: left\"><table class=\"table table-striped inside-panel\"><tbody><tr><th scope=row>Suma netto</th><td><span ng-bind=\"vm.qualityReturn.AmountNet | number: 2\"></span> <span ng-bind=vm.qualityReturn.CurrencySymbol></span></td></tr><tr><th scope=row>Suma brutto</th><td><span ng-bind=\"vm.qualityReturn.AmountGross | number: 2\"></span> <span ng-bind=vm.qualityReturn.CurrencySymbol></span></td></tr><tr><th scope=row>Suma VAT</th><td><span ng-bind=\"vm.qualityReturn.AmountVAT | number: 2\"></span> <span ng-bind=vm.qualityReturn.CurrencySymbol></span></td></tr></tbody></table></div><div style=\"width: 40%; float: left\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=Komentarz... ng-model=vm.qualityReturn.Note></textarea></div><div style=\"width: 25%; float: right\"><button class=\"btn btn-primary btn-submit btn-add-product inside-panel\" ng-click=\"vm.showProductPicker(vm.qualityReturn.Products, false, {blockPrice: true, qualityReturnData: true})\"><span class=\"glyphicon glyphicon-shopping-cart\"></span> Dodaj produkt</button></div></div><div class=row ng-if=!vm.error><table class=\"table table-hover table-striped uiGrid inside-panel\"><thead><th class=uiGridHeader style=\"width: 45%\">Produkt</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">Ilość</th><th class=uiGridHeader style=\"width: 5%; vertical-align: top\">J</th><th class=uiGridHeader style=\"width: 15%; vertical-align: top\">Termin ważności</th><th class=uiGridHeader style=\"width: 15%; vertical-align: top\">Nr partii</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">Akcje</th></thead><tbody><tr ng-repeat=\"key in vm.qualityReturn.Products | filter: { isAdded: true } track by key.Id\"><td><div class=flex-cell-order><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default pull-right\" popover-append-to-body=true popover-trigger=\"click outsideClick\" uib-popover-template=\"\'app/components/order/productPopover.html\'\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isCountValid(key)}\"><input class=form-control tabindex=\"{{$index + 1}}\" type=number ng-model=key.Count ng-change=\"vm.updatePrice(key, vm.qualityReturn, vm.qualityReturn.Products)\"></div></td><td><span>{{key.MeasureUnit}}</span></td><td><div class=\"input-group has-feedback\" ng-class=\"{\'has-error\': !vm.isExpirationDateValid(key)}\"><input ng-change=vm.onDateChange() datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=key.ExpirationDate is-open=key.expirationDateDatePickerOpened datepicker-options=vm.expirationDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDPForEntity($event, 1, key)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isBatchNumberValid(key)}\"><input class=form-control tabindex=\"{{$index + 1}}\" type=text ng-model=key.BatchNumber></div></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"key.isAdded = false; vm.updatePrice(key, vm.qualityReturn, vm.qualityReturn.Products)\"><span class=\"glyphicon glyphicon-remove\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Wgraj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.uploadEntityAttachment(key) ng-show=vm.checkPermission(41)><span class=\"glyphicon glyphicon-plus\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Pokaż popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><!-- <tr> <td colspan=\"6\">aaa</td></tr> --></tbody></table></div></uib-accordion-group><uib-accordion-group is-open=false><uib-accordion-heading><span>Próbki ({{vm.samples.AmountNet | number: 2}} zł)</span> <span ng-if=!vm.areProductsFromDocumentValid(vm.samples.Products) class=\"glyphicon glyphicon-alert warning-icon\"></span></uib-accordion-heading><div class=row><div style=\"width: 35%; float: left\"><table class=\"table table-striped inside-panel\"><tbody><tr><th scope=row>Suma netto</th><td><span ng-bind=\"vm.samples.AmountNet | number: 2\"></span> <span ng-bind=vm.samples.CurrencySymbol></span></td></tr><tr><th scope=row>Suma brutto</th><td><span ng-bind=\"vm.samples.AmountGross | number: 2\"></span> <span ng-bind=vm.samples.CurrencySymbol></span></td></tr><tr><th scope=row>Suma VAT</th><td><span ng-bind=\"vm.samples.AmountVAT | number: 2\"></span> <span ng-bind=vm.samples.CurrencySymbol></span></td></tr></tbody></table></div><div style=\"width: 40%; float: left\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=Komentarz... ng-model=vm.samples.Note></textarea></div><div style=\"width: 25%; float: right\"><button class=\"btn btn-primary btn-submit btn-add-product inside-panel\" ng-click=\"vm.showProductPicker(vm.samples.Products, false, {blockPrice: true})\"><span class=\"glyphicon glyphicon-shopping-cart\"></span> Dodaj produkt</button></div></div><div class=row ng-if=!vm.error><table class=\"table table-hover table-striped uiGrid inside-panel\"><thead><th class=uiGridHeader style=\"width: 65%\">Produkt</th><th class=uiGridHeader style=\"width: 20%; vertical-align: top\">Ilość</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">J</th><th class=uiGridHeader style=\"width: 5%; vertical-align: top\">Akcje</th></thead><tbody><tr ng-repeat=\"key in vm.samples.Products | filter: { isAdded: true } track by key.Id\"><td><div class=flex-cell-order><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default pull-right\" popover-append-to-body=true popover-trigger=\"click outsideClick\" uib-popover-template=\"\'app/components/order/productPopover.html\'\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isCountValid(key)}\"><input class=form-control tabindex=\"{{$index + 1}}\" type=number ng-model=key.Count ng-change=\"vm.updatePrice(key, vm.samples, vm.samples.Products)\"></div></td><td><span>{{key.MeasureUnit}}</span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"key.isAdded = false; vm.updatePrice(key, vm.samples, vm.samples.Products)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></uib-accordion-group><uib-accordion-group is-open=false><uib-accordion-heading><span>Degustacje ({{vm.gratis.AmountNet | number: 2}} zł)</span> <span ng-if=!vm.areProductsFromDocumentValid(vm.gratis.Products) class=\"glyphicon glyphicon-alert warning-icon\"></span></uib-accordion-heading><div class=row><div style=\"width: 35%; float: left\"><table class=\"table table-striped inside-panel\"><tbody><tr><th scope=row>Suma netto</th><td><span ng-bind=\"vm.gratis.AmountNet | number: 2\"></span> <span ng-bind=vm.gratis.CurrencySymbol></span></td></tr><tr><th scope=row>Suma brutto</th><td><span ng-bind=\"vm.gratis.AmountGross | number: 2\"></span> <span ng-bind=vm.gratis.CurrencySymbol></span></td></tr><tr><th scope=row>Suma VAT</th><td><span ng-bind=\"vm.gratis.AmountVAT | number: 2\"></span> <span ng-bind=vm.gratis.CurrencySymbol></span></td></tr></tbody></table></div><div style=\"width: 40%; float: left\"><textarea cols=\"\" rows=\"\" class=\"form-control note-order inside-panel\" placeholder=Komentarz... ng-model=vm.gratis.Note></textarea></div><div style=\"width: 25%; float: right\"><button class=\"btn btn-primary btn-submit btn-add-product inside-panel\" ng-click=\"vm.showProductPicker(vm.gratis.Products, false, {blockPrice: true})\"><span class=\"glyphicon glyphicon-shopping-cart\"></span> Dodaj produkt</button></div></div><div class=row ng-if=!vm.error><table class=\"table table-hover table-striped uiGrid inside-panel\"><thead><th class=uiGridHeader style=\"width: 65%\">Produkt</th><th class=uiGridHeader style=\"width: 20%; vertical-align: top\">Ilość</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">J</th><th class=uiGridHeader style=\"width: 5%; vertical-align: top\">Akcje</th></thead><tbody><tr ng-repeat=\"key in vm.gratis.Products | filter: { isAdded: true } track by key.Id\"><td><div class=flex-cell-order><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default pull-right\" popover-append-to-body=true popover-trigger=\"click outsideClick\" uib-popover-template=\"\'app/components/order/productPopover.html\'\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div></td><td><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': !vm.isCountValid(key)}\"><input class=form-control tabindex=\"{{$index + 1}}\" type=number ng-model=key.Count ng-change=\"vm.updatePrice(key, vm.gratis, vm.gratis.Products)\"></div></td><td><span>{{key.MeasureUnit}}</span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"key.isAdded = false; vm.updatePrice(key, vm.gratis, vm.gratis.Products)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div></uib-accordion-group><uib-accordion-group is-open=vm.canOpen><uib-accordion-heading ng-click=\"vm.canOpen = !vm.canOpen\"><span>Oczekujące płatności ({{vm.lengthPendingPayments(vm.order.PendingPayments)}})</span> <span ng-if=!vm.isEmpty(vm.order.PendingPayments) popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Zaległe płatności\" class=\"glyphicon glyphicon-alert warning-icon margin-pendingPeyments\"></span> <span ng-if=!vm.isEmpty(vm.order.PendingPayments)>Zaległe płatności ({{vm.expiredPayments}})</span> <span ng-if=\"vm.expiredPayments > 0\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Płatności po terminie\" class=\"glyphicon glyphicon-exclamation-sign alert-icon margin-pendingPeyments\"></span> <span ng-if=vm.isEmpty(vm.order.PendingPayments) class=\"glyphicon glyphicon-ok ok-icon\"></span></uib-accordion-heading><div class=row ng-if=\"!vm.error && !vm.isEmpty(vm.order.PendingPayments)\"><table class=\"table table-hover table-striped uiGrid inside-panel\"><thead><th class=uiGridHeader style=\"width: 25%\">Nazwa dokumentu</th><th class=uiGridHeader style=\"width: 15%\">Data płatności</th><th class=uiGridHeader style=\"width: 15%\">Kwota</th><th class=uiGridHeader style=\"width: 35%\">Wymagające akcji</th><th class=uiGridHeader style=\"width: 10%\">Akcje</th></thead><tbody><tr ng-repeat=\"key in vm.order.PendingPayments\"><td><div class=flex-cell-order><span class=text-span ng-bind=key.DocumentNumberFull></span></div></td><td><div class=flex-cell-order><span class=text-span ng-bind=\"key.PaymentDate | date: \'dd-MM-yyyy\'\"></span><br><span popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Płatność po terminie\" class=\"glyphicon glyphicon-exclamation-sign alert-icon\" ng-if=\"key.isExpired === true\"></span><br></div></td><td><div class=flex-cell-order><span class=text-span ng-bind=\"key.Amount | number: 2\"></span>&nbsp; <span ng-bind=vm.order.CurrencySymbol></span></div></td><td><ui-select ng-if=\"key.isExpired === true\" ng-model=key.selectedAction theme=bootstrap><ui-select-match data-allow-clear=true placeholder=\"Wybierz akcję\">{{$select.selected.name}}</ui-select-match><ui-select-choices style=display:ruby-text-container repeat=\"dictionaryExpiredPayment in vm.dictionaryExpiredPayments track by $index\"><div ng-value=dictionaryExpiredPayment.id ng-bind-html=\"dictionaryExpiredPayment.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-if=\"key.selectedAction.id === 4\"><br><textarea rows=3 cols=25 name=description style=\"width: 100%;padding: 10px\" placeholder=\"Wpisz komentarz...\" ng-model=key.comment>{{key.comment}}</textarea></div></td><td><button type=button class=\"btn btn-default\" ng-click=vm.setOtherPendingAsThis(key)><i class=\"glyphicon glyphicon-sort-by-attributes\"></i></button></td></tr></tbody></table></div></uib-accordion-group></uib-accordion><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-right: 15px\" ng-click=vm.save() ng-disabled=\"vm.saveOnce || vm.isProductsError()\" ng-if=\"!vm.error && vm.areAllExpiredPaymentsResolved()\">Zapisz</button> <button class=\"btn btn-primary btn-submit pull-right disabled-button\" style=\"margin-right: 15px\" ng-click=\"vm.canOpen = true\" ng-if=!vm.areAllExpiredPaymentsResolved() uib-popover=\"Zaległe płatności\" popover-trigger=mouseenter popover-append-to-body=true>Zapisz</button></div></div>");
$templateCache.put("app/components/order/productPopover.html","<div><table class=\"table table-striped\"><tbody><tr><th scope=row>Netto:</th><td><span ng-bind=\"key.Price.AmountProductNet | number: 2\"></span> <span ng-bind=vm.order.CurrencySymbol></span></td></tr><tr><th scope=row>Brutto:</th><td><span ng-bind=\"key.Price.AmountProductGross | number: 2\"></span> <span ng-bind=vm.order.CurrencySymbol></span></td></tr><tr><th scope=row>VAT:</th><td><span ng-bind=\"key.Price.VatValue | number: 2\"></span> <span>%</span></td></tr><tr ng-if=key.Price.PromotionId><th scope=row>Cena promocyjna:</th><td><span ng-bind=\"key.Price.PromotionAmountProductNet | number: 2\"></span> <span ng-bind=vm.order.CurrencySymbol></span></td></tr><tr ng-if=key.Multiplicity><th scope=row>Krotność:</th><td><span ng-bind=key.Multiplicity></span></td></tr></tbody></table></div>");
$templateCache.put("app/components/parametrization/parametrization.html","<div><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{\'parametrization.title\' | translate}}</div><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.holidays\' | translate}}</span><ui-select ng-model=vm.chosenYear theme=bootstrap on-select=\"vm.onYearChange($item, $model)\" style=\"width: 150px; float:right\"><ui-select-match placeholder=Brak>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"year in vm.holidayYears\"><div ng-bind-html=year></div></ui-select-choices></ui-select></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr ng-repeat=\"holiday in vm.holidays\"><td><span>{{holiday.Date | date: \'dd-MM-yyyy\'}}</span> <button type=button class=\"btn btn-default btn-xs pull-right\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.remove(holiday)><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td><div class=\"input-group pull-left\" style=width:75%><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.newHolidayDate is-open=vm.datePickerHolidayOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\" ng-disabled=vm.block><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><button type=button class=\"btn btn-default pull-right\" ng-click=vm.saveNewHoliday() ng-disabled=\"vm.newHolidayDate == undefined\"><i class=\"glyphicon glyphicon-floppy-disk\"></i></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.minimumOrderPrice\' | translate}}</span></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><td><div class=pull-left style=width:75%><input type=number class=form-control ng-model=vm.parameters.MinimumOrderPrice.ValueDecimal></div><button type=button class=\"btn btn-default pull-right\" ng-click=vm.saveMinOrderPrice() ng-disabled=\"(vm.parameters.MinimumOrderPrice === undefined) || (vm.parameters.MinimumOrderPrice.ValueDecimal <= 0)\"><i class=\"glyphicon glyphicon-floppy-disk\"></i></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.visitCloseTime\' | translate}}</span></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><td><div class=\"timepicker-override pull-left\" style=width:75%><div uib-timepicker ng-model=vm.parameters.VisitCloseTime.Value hour-step=vm.timeOptions.hstep minute-step=vm.timeOptions.mstep show-meridian=false></div></div><button type=button class=\"btn btn-default pull-right submit-btn\" ng-click=vm.saveVisitCloseTime() ng-disabled=\"vm.parameters.VisitCloseTime === undefined\"><i class=\"glyphicon glyphicon-floppy-disk\"></i></button></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.companyData.title\' | translate}}</span></div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th>{{\'parametrization.companyData.fullName\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][0].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.streetAndNumber\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][1].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.cityName\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][2].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.postalCode\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][3].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.country\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][4].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.iln\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][5].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.taxId\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][6].Value1\" class=form-control type=text></td></tr><tr><th>{{\'parametrization.companyData.nrb\' | translate}}</th><td><input ng-model=\"vm.dictionaryData[\'CompanyDataDictionary\'][7].Value1\" class=form-control type=text></td></tr></tbody></table><button type=button class=\"btn btn-default pull-right\" ng-click=vm.updateCompanyData()><i class=\"glyphicon glyphicon-floppy-disk\"></i></button></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.customParamsProduct\' | translate}}</span></div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px !important\"><thead><tr><th class=uiGridHeader style=\"width: 70%\">Wartość</th><th class=uiGridHeader style=\"width: 30%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.parameters.CustomParametersProduct\"><td><input ng-model=key.Value class=form-control type=text></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wyślij popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.sendConst(key)><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.removeRow(key, $index, vm.parameters.CustomParametersProduct)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.addNewParam(1)><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.customParamsContractor\' | translate}}</span></div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px !important\"><thead><tr><th class=uiGridHeader style=\"width: 70%\">Wartość</th><th class=uiGridHeader style=\"width: 30%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.parameters.CustomParametersContractor\"><td><input ng-model=key.Value class=form-control type=text></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wyślij popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.sendConst(key)><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.removeRow(key, $index, vm.parameters.CustomParametersContractor)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.addNewParam(2)><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading style=\"overflow-y: visible; height: 50px\"><span style=\"position:absolute; top:0; margin-top: 17px\">{{\'parametrization.productManufacturer\' | translate}}</span></div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px !important\"><thead><tr><th class=uiGridHeader style=\"width: 70%\">Wartość</th><th class=uiGridHeader style=\"width: 30%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.parameters.Manufacturers\"><td><input ng-model=key.Value class=form-control type=text></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wyślij popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.sendConst(key)><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.removeRow(key, $index, vm.parameters.Manufacturers)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.addToDictionary(vm.parameters.Manufacturers, \'ManufacturerDictionary\')\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/products/preferredProducts.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Lista preferowanych produktów</div><div class=panel-body><div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row style=\"vertical-align: middle\">Nazwa</th><td><input ng-model=vm.data.Name maxlength=15 class=form-control></td></tr><tr><th scope=row>Ilość produktów</th><td><span ng-bind=\"vm.data.ListData.length \"></span></td></tr><tr><th scope=row>Ilość kontrahentów</th><td><span ng-bind=\"vm.data.ContextData1.length \"></span></td></tr><tr><th scope=row>Ilość grup kontrahentów</th><td><span ng-bind=\"vm.data.ContextData2.length \"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Kontrahenci</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 25%\">Symbol</th><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.ContextData1Objects\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.Symbol \"></span></th><td><span ng-bind=\"key.Name \"></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.data.ContextData1, vm.data.ContextData1Objects,key.Id)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=3><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectContractor(vm.data.ContextData1, vm.data.ContextData1Objects)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Grupy kontrahentów</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 10%; min-width: 30px\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.ContextData2Objects\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.Name \"></span></th><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.data.ContextData2, vm.data.ContextData2Objects, key.Id)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectGroup(vm.data.ContextData2, vm.data.ContextData2Objects)\" ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button><!--<ui-select ng-model=\"vm.group\" theme=\"bootstrap\"--><!--on-select=\"vm.selectGroup($item, $model, vm.data.ContextData2, vm.data.ContextData2Objects)\"--><!--on-remove=\"vm.onSelect($item, $model)\">--><!--<ui-select-match data-allow-clear=\"false\" placeholder=\"Brak\">{{$select.selected.Value |--><!--truncate:25}}--><!--</ui-select-match>--><!--<ui-select-choices--><!--repeat=\"value.LocalId as value in vm.dictionaryData.ContractorGroupDictionary | filter: $select.search\">--><!--<div ng-bind-html=\"value.Value | highlight: $select.search\"></div>--><!--</ui-select-choices>--><!--</ui-select>--></td></tr></tbody></table></div></div></div></div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 95%\">Nazwa produktu</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.ListDataObjects\"><th><span ng-bind=key.Name></span></th><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.data.ListData, vm.data.ListDataObjects, key.Id)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectProduct(vm.data.ListData, vm.data.ListDataObjects)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>{{\'common.actions.goBack\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-disabled=vm.disableSubmit() ng-click=vm.submit(vm.data)>{{\'common.form.confirm\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/products/preferredProductsList.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Produkty</div><div class=panel-body><div><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 90%\">Nazwa</th><th class=uiGridHeader style=\"width: 10%\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name></span></th><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.preferredProductsList.one({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.deleteOne(key.Id)><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div><div style=\"overflow-y: hidden; display: flex; flex-direction: column\"><span class=pull-right style=\"margin-bottom: 5px; margin-left: auto\">Rekordów:{{vm.pagingData.totalCount}}</span> <button class=\"btn btn-primary btn-submit\" style=\"margin-left: auto\" ng-click=vm.goToPreferredProducts()>Dodaj listę preferowanych produktów</button></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/products/product.html","<div><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Produkt: {{vm.data.Name}}</div><div class=panel-body><div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Informacje podstawowe</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Symbol</th><td><span ng-bind=vm.data.Symbol></span></td></tr><tr><th scope=row>Typ</th><td><span ng-bind=vm.data.Type></span></td></tr><tr><th scope=row>Jednostka miary</th><td><span ng-bind=vm.data.MeasureUnit></span></td></tr><tr><th scope=row>PKWiU</th><td><span ng-bind=vm.data.PKWiU></span></td></tr><tr><th scope=row>SWW</th><td><span ng-bind=vm.data.SWW></span></td></tr><tr><th scope=row>EAN</th><td><span ng-bind=vm.data.BarCode></span></td></tr><tr><th scope=row>VAT</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'VATDictionary\',vm.data.VATId).ValueDecimal +  \'%\'\"></span></td></tr><tr><th scope=row>Grupa</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProductGroupDictionary\',vm.data.GroupId).Value\"></span></td></tr><tr><th scope=row>Identyfikator (Optilo)</th><td><span ng-bind=vm.data.SubiektId></span></td></tr><tr><th scope=row>Koszt produkcji</th><td><span ng-bind=\"vm.data.ProductionCosts ? vm.data.ProductionCosts : \'-\'\"></span></td></tr><tr><th scope=row>Producent</th><td><ui-select ng-model=vm.data.ManufacturerId theme=bootstrap style=\"width: 200px\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ManufacturerDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Ceny</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 40%\">Nazwa</th><!-- [PositionOnDocument]--><th class=uiGridHeader style=\"width: 30%\">Netto</th><!--[Name] --><th class=uiGridHeader style=\"width: 30%\">Brutto</th><!-- [Count]--></tr></thead><tbody><tr ng-repeat=\"key in vm.dictionaryData[\'PriceLevel\']\"><th><span ng-bind=key.Value></span></th><td><span ng-bind=\"vm.data[\'AmountNet\' + ($index + 1)] + \'PLN\'\"></span></td><td><span ng-bind=\"vm.data[\'AmountGross\' + ($index + 1)] + \'PLN\'\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Pola rozszerzone</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr ng-repeat=\"key in [1,2,3,4,5,6,7,8]\"><th scope=row>{{key}}</th><td class=\"left: 50%; margin-right: -50%;\"><span>{{vm.data[\'CustomField\' + key] === undefined || vm.data[\'CustomField\' + key] === \'\' ? \'-\' : vm.data[\'CustomField\' + key]}}</span></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-12\"><div class=\"panel panel-default\"><div class=panel-heading>Parametry</div><div class=\"panel-body params-panel-body\" id=paramsPanel><div id=filter-row style=\"position:relative;z-index:2;padding: 15px 0px;background-color: #fff\"><button class=\"btn btn-default\" type=button ng-click=vm.filterParamsRows() uib-popover=Filtruj popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\"></span></button> <button type=button class=\"btn btn-default btn-m\" ng-click=vm.resetParamsFilters() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div><table class=\"table table-hover table-striped uiGrid\"><thead style=\"position:relative; z-index:2; background-color: #fff\"><tr><th style=\"width: 250px\"><input type=text class=form-control ng-model=vm.contractorFilter></th><td class=params-table-cell ng-repeat=\"filter in vm.paramsFilters\"><input type=text class=form-control ng-model=filter.value></td></tr><tr><th class=uiGridHeader style=\"width: 250px\">Kontrahent</th><th class=\"uiGridHeader params-table-cell\" ng-repeat=\"parameter in vm.dictionaryData[\'CustomParamsDictionary\']\">{{parameter.Value}}</th></tr></thead><tbody class=params-table-body style=\"position:relative; z-index: 1\"><tr ng-repeat=\"key in vm.displayedParameters | orderBy:\'ContractorObject.Name\'\"><th style=\"width: 250px\"><div class=flex-cell style=\"justify-content: space-between\"><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><span class=text-span ng-bind=key.ContractorObject.Name></span></perfect-scrollbar><button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Usuń wiersz\" popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.deleteParamsRow(key, $index)\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></th><td ng-repeat=\"param in key.Params\"><div class=flex-cell><input type=text class=form-control ng-model=param.TextValue ng-keypress=\"param.isModified = true\" ng-paste=\"param.isModified = true\" ng-keydown=\"param.isModified = true\" uib-popover={{key.ContractorObject.Name}} popover-trigger=focus popover-append-to-body=true> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-class=\"{\'danger-color\': param.isModified}\" ng-disabled=!param.isModified ng-click=vm.addOrUpdateParam(param)><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-disabled=\"!param.TextValue || !param.Id\" ng-click=vm.deleteParam(param)><span class=\"glyphicon glyphicon-remove\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Ustaw u wszystkich\" popover-trigger=mouseenter popover-append-to-body=true ng-disabled=!param.TextValue ng-click=\"vm.trySetParamInColumn(param.TextValue, $index)\"><span class=\"glyphicon glyphicon-sort-by-attributes-alt\"></span></button></div></td></tr><tr><td colspan=\"{{vm.dictionaryData[\'CustomParamsDictionary\'].length + 1}}\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dodatkowe dane dla mobile</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row style=\"vertical-align: middle\">Krotność</th><td><div class=form-group><input ng-model=vm.data.Multiplicity class=form-control name=productMultiplicity type=number ng-disabled=!vm.checkPermission(14)></div></td></tr><tr><th scope=row style=\"vertical-align: middle\">Dni ważności</th><td><div class=form-group><input ng-model=vm.data.ExpirationDays class=form-control name=productExpirationDays type=number ng-disabled=!vm.checkPermission(14)></div></td></tr><tr><th scope=row style=\"vertical-align: middle\">Waga(kg)</th><td><div class=form-group><input ng-model=vm.data.Weight class=form-control name=productWeight type=number min=0 step=0.01 ng-disabled=!vm.checkPermission(14)></div></td></tr><tr><th scope=row style=\"vertical-align: middle\">Minimalna cena</th><td><div class=form-group><input ng-model=vm.data.MinimalPriceNet class=form-control name=productWeight type=number min=0 step=0.01 ng-disabled=!vm.checkPermission(14)></div></td></tr></tbody></table></div></div></div></div><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>{{\'common.actions.goBack\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit(vm.data) ng-show=vm.checkPermission(14)>{{\'common.form.confirm\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/components/products/products.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Produkty</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'products.search.searchBox\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=ContractorSearchBox name=ContractorSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div><!-- /input-group --><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.pagingData.searchStr\"--><!--on-press-enter=\"vm.onFilterChange()\">--></div><div class=col-sm-3><label>{{\'products.search.group\' | translate}}</label><ui-select ng-model=vm.pagingData.groupId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ProductGroupDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><br><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 30%\">Nazwa</th><th class=uiGridHeader style=\"width: 5%\">Jednostka</th><th class=uiGridHeader style=\"width: 17%\">Grupa</th><th class=uiGridHeader style=\"width: 13%\">EAN</th><th class=uiGridHeader style=\"width: 10%\">VAT</th><th class=uiGridHeader style=\"width: 10%\">Status</th><th class=uiGridHeader style=\"width: 10%\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name></span></th><td><span ng-bind=key.MeasureUnit></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProductGroupDictionary\',key.GroupId).Value\"></span></td><td><span ng-bind=key.BarCode></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'VATDictionary\',key.VATId).ValueDecimal\"></span>%</td><td><span ng-bind=\"vm.Blocked == true ? \'zablokowany\' : \'aktywny\'\"></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.products.one({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/products/productsSelect.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Produkty</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'products.search.searchBox\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=ContractorSearchBox name=ContractorSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div><!-- /input-group --><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.pagingData.searchStr\"--><!--on-press-enter=\"vm.onFilterChange()\">--></div><div class=col-sm-3><label>{{\'products.search.group\' | translate}}</label><ui-select ng-model=vm.pagingData.groupId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ProductGroupDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><br><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 30%\">Nazwa</th><th class=uiGridHeader style=\"width: 8%\">Jednostka</th><th class=uiGridHeader style=\"width: 17%\">Grupa</th><th class=uiGridHeader style=\"width: 20%\">VAT</th><th class=uiGridHeader style=\"width: 10%\">Status</th><th class=uiGridHeader style=\"width: 10%\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name uib-popover={{key.Name}} popover-trigger=mouseenter></span></th><td><span ng-bind=key.MeasureUnit></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProductGroupDictionary\',key.GroupId).Value\"></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'VATDictionary\',key.VATId).Value\"></span></td><td><span ng-bind=\"vm.Blocked == true ? \'zablokowany\' : \'aktywny\'\"></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wybierz popover-trigger=mouseenter ng-show=!vm.isAdded(key) popover-append-to-body=true ng-click=vm.selectProduct(key)><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/permissions/permissions.html","<div><span ng-show=vm.loading>Loading</span> <button ng-click=vm.getAllPermissions()>GetAllPermissions</button><br><button ng-click=vm.getAllRoles()>GetAllRoles</button><br><button ng-click=vm.getRolePermissions(3)>GetRolePerms</button><br><button ng-click=vm.getPermissionById(1)>GetPermission</button><br><button ng-click=vm.updatePermission()>updatePermission</button><br><button ng-click=vm.getRoleById(4)>getRoleById</button><br><button ng-click=vm.getUserRoles(1)>getUserRoles</button><br><button ng-click=\"vm.addRole(\'roleName\',\'RoleDesc\')\">addRole</button><br><button ng-click=vm.updateRole()>updateRole</button><br><button ng-click=vm.updateRolePermissions(3)>updateRolePermissions</button><br><button ng-click=vm.updateUserRoles()>updateUserRoles</button><br><button ng-click=vm.getAllUserPermissions(1)>getAllUserPermissions</button><br>{{vm.permissionsDefs}}<br><br>{{vm.roleDefs}}<br><br>{{vm.rolePerms}}<br><br>{{vm.permission}}<br><br>{{vm.role}}<br><br>{{vm.UserRoles}}<br><br>{{vm.addedRole}}<br><br>{{vm.allUserPermissions}}<br><br></div>");
$templateCache.put("app/components/permissions/role.html","<div class=\"panel panel-default panel-table\"><div class=panel-heading>Rola: {{vm.role.Name}}</div><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><formly-form model=vm.role fields=vm.roleFields></formly-form></div></div></div><div class=\"col-sm-12 col-md-8\"><div class=\"panel panel-default\"><div class=panel-heading>Uprawnienia</div><div class=panel-body><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>{{\'common.form.checkbox\' | translate}}</th><th>{{\'roles.role.permission.name\' | translate}}</th><th>{{\'roles.role.permission.description\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"permissionDef in vm.permissionsDefs\"><td><input type=checkbox name=permission ng-model=permissionDef.isInRole></td><td>{{permissionDef.Name}}</td><td>{{permissionDef.Description}}</td></tr></tbody></table></div></div></div></div><div><button type=submit class=\"btn btn-default pull-right\" ng-click=vm.submit()>{{\'common.form.confirm\' | translate}}</button></div></div></div><!-- /.table-responsive -->");
$templateCache.put("app/components/permissions/roles.html","<div><div class=\"jumbotron alert alert-info\" ng-show=vm.loading><h2>Trwa ładowanie zawartości strony</h2><br><br><hr><br><br><h3><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Pamiętaj o wylogowaniu po zakończeniu pracy.</h3></div><div class=\"panel panel-default panel-table\" ng-show=!vm.loading><div class=panel-heading>Role</div><!-- /.panel-heading --><div class=panel-body><div><uib-alert ng-show=vm.isError type=danger class=alert-login role=alert close=vm.closeAlert()>{{vm.error}}</uib-alert><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader col-20\">{{\'headers.roles.name\' | translate}}</th><th class=\"uiGridHeader col-60\">{{\'headers.roles.description\' | translate}}</th><th class=uiGridHeader>{{\'headers.roles.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"role in vm.roleDefs\"><td>{{role.Name}}</td><td>{{role.Description}}</td><td><button type=button class=\"btn btn-default btn-xs\" ui-sref=\"home.roles.role({id: role.Id})\" uib-popover=Edytuj popover-trigger=mouseenter><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" ng-click=vm.deleteRole(role) uib-popover=Usuń popover-trigger=mouseenter><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button></td></tr></tbody></table></div><!-- /.table-responsive --> <button type=button class=\"btn .btn-primary pull-right\" ng-click=vm.newRole()><!--<span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span>--> {{\'roles.actions.add\' | translate}}</button></div><!--<button type=\"button\" class=\"btn .btn-primary btn-lg\">{{\'common.actions.delete\' | translate}}</button>--></div><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/promotions/promotion.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{\'promo.name\' | translate}}</div><div class=panel-body><div><div class=row><div class=\"col-sm-12 col-md-8\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'promo.view.data\' | translate}}</div><div class=panel-body><form name=vm.form><table class=\"table table-striped double-column-fix\"><tbody><tr class=height-fix><th scope=row style=\"vertical-align: middle\">{{\'promo.view.name\' | translate}}</th><td><div class=form-group ng-class=\"{\'has-error\' : !vm.form.taskName.$valid}\"><input ng-model=vm.currentPromotion.Name maxlength=45 min=3 max=45 class=form-control name=taskName ng-required=true></div></td></tr><tr class=height-fix><th scope=row>{{\'promo.view.dateFrom\' | translate}}</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateFrom.$valid}\"><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.currentPromotion.BeginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFrom> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr class=height-fix><th scope=row>{{\'promo.view.dateTo\' | translate}}</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateTo.$valid}\"><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.currentPromotion.EndDate is-open=vm.datePickerEndOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateTo> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr class=height-fix><th scope=row>{{\'promo.view.dateDelivery\' | translate}}</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateAt.$valid}\"><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true is-open=vm.datePickerDeliveryOpened ng-model=vm.currentPromotion.DeliveryDate datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateAt> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 3)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr></tbody></table><table class=\"table table-striped double-column-fix\"><tbody><tr class=height-fix><th scope=row>{{\'promo.view.type\' | translate}}</th><td><div class=form-group ng-class=\"{ \'has-error\': vm.form.customType.$invalid }\"><ui-select ng-model=vm.currentPromotion.SubType theme=bootstrap name=customType required><ui-select-match placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.PromotionTypeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td></tr><tr class=height-fix><th scope=row>{{\'promo.view.invoice.name\' | translate}}</th><td><div class=form-group><input type=checkbox ng-model=vm.currentPromotion.MarketingDocumentPaid name=invoiceName></div></td></tr><tr class=height-fix><th scope=row>{{\'promo.view.invoice.number\' | translate}}</th><td><div class=form-group ng-class=\"{\'has-error\' : !vm.form.invoiceNumber.$valid}\"><input type=text ng-model=vm.currentPromotion.DocumentNumber name=invoiceNumber class=form-control ng-required=vm.currentPromotion.MarketingDocumentPaid ng-disabled=!vm.currentPromotion.MarketingDocumentPaid></div></td></tr><tr class=height-fix><th scope=row>{{\'promo.view.invoice.date\' | translate}}</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateDoc.$valid}\"><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=vm.currentPromotion.MarketingDocumentPaid ng-disabled=!vm.currentPromotion.MarketingDocumentPaid is-open=vm.datePickerDocumentOpened ng-model=vm.currentPromotion.DocumentDate datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateDoc> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 4)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr></tbody></table><table class=\"table table-striped margin-fix\"><tbody><tr><th scope=row>{{\'promo.view.attachment\' | translate}}</th><td><!---IMAGES --><ul style=\"list-style-type: none; padding-left: 0px\"><li ng-repeat=\"image in vm.imageGallery\" class=attachment-li><a ng-click=vm.openLightboxModal($index)><img ng-src={{image.FileUrl}} width=100px height=\"100 px\" class=img-thumbnail> </a><button type=button class=\"btn btn-default btn-xs delete-button\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeAttachment(image)><span class=\"glyphicon glyphicon-remove\"></span></button></li></ul><!---PDFS--><ul style=\"list-style-type: none; padding-left: 0px\"><li ng-repeat=\"file in vm.currentPromotion.Files\" ng-if=\"file.Type === 3\" class=attachment-li-pdf><a ng-href={{file.FileUrl}}><button type=button class=\"btn btn-default\" uib-popover={{file.OrginalFileName}} popover-trigger=mouseenter popover-append-to-body=true><i class=\"glyphicon glyphicon-download-alt\"></i></button> </a><button type=button class=\"btn btn-default btn-xs delete-button-pdf\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeAttachment(file)><span class=\"glyphicon glyphicon-remove\"></span></button></li></ul><button type=submit class=\"btn btn-primary\" ng-click=vm.uploadAttachment() ng-disabled=\"vm.attachment !== undefined\">Wgraj załącznik</button></td></tr></tbody></table></form></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Kontrahenci</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 25%\">Symbol</th><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentPromotion.Entities\" ng-if=\"key.Type === 1\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.ContextObject.Symbol \"></span></th><td><span ng-bind=\"key.ContextObject.Name \" uib-popover={{key.ContextObject.Name}} popover-trigger=mouseenter></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.currentPromotion.Entities, key.ContextObject.Id)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=3><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectContractor(1, vm.currentPromotion.Entities)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Grupy kontrahentów</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 10%; min-width: 30px\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentPromotion.Entities\" ng-if=\"key.Type === 3\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.ContextObject.Value \"></span></th><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.currentPromotion.Entities, key.ContextId)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectContractorGroup(3, vm.currentPromotion.Entities)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div></div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 50%\">Nazwa produktu</th><th class=uiGridHeader style=\"width: 20%\">Typ</th><th class=uiGridHeader style=\"width: 20%\">Cena</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentPromotion.Entities\" ng-if=\"key.Type === 4\"><th style=\"vertical-align: middle\"><span ng-bind=key.ContextObject.Name></span> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Popraw cenę\" ng-show=\"(key.ValueDecimal === undefined)||(key.ValueDecimal == 0)\" style=\"margin-left: 5px; font-size: 1.3em\"></span></th><td style=\"overflow:visible !important\"><div><ui-select ng-model=key.MeasureUnit theme=bootstrap name=MeasureUnit on-select=vm.productTypeChange(key) required><ui-select-match placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.EventMeasureUnitDoctionary | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td><td><div class=input-group><input type=number min=0 step=0.01 ng-model=key.ValueDecimal class=form-control placeholder=0.00 ng-change=vm.updatePrice(key)> <span class=input-group-btn uib-dropdown dropdown-append-to-body><button class=\"btn btn-default\" type=button uib-dropdown-toggle ng-disabled=\"key.MeasureUnit === 2\"><span class=\"glyphicon glyphicon-menu-down\"></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-repeat=\"keyy in vm.dictionaryData[\'PriceLevel\']\"><a ng-click=\"vm.updatePrice(key, key.ContextObject[\'AmountGross\' + ($index + 1)])\">{{keyy.Value }} : <span class=pull-right>{{key.ContextObject[\'AmountGross\' + ($index + 1)]}} PLN</span></a></li></ul></span></div></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.currentPromotion.Entities, key.ContextObject.Id)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=4><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectProduct(4, vm.currentPromotion.Entities)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 50%\">Nazwa grupy</th><th class=uiGridHeader style=\"width: 15%\">Wartość</th><th class=uiGridHeader style=\"width: 15%\">Typ</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentPromotion.Entities\" ng-if=\"key.Type === 5\"><th style=\"vertical-align: middle\"><span ng-bind=key.ContextObject.Value></span> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Popraw cenę\" ng-show=\"(key.ValueDecimal === undefined)||(key.ValueDecimal <= 0)||(key.ValueDecimal > 100)\" style=\"margin-left: 5px; font-size: 1.3em\"></span></th><td><input type=number min=0 max=100 step=1 ng-model=key.ValueDecimal class=form-control placeholder=0 ng-change=vm.updatePrice(key)></td><td style=\"overflow:visible !important\"><span>{{vm.dictionaryData.EventMeasureUnitDoctionary[1].Value | translate}}</span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.currentPromotion.Entities, key.ContextObject.LocalId)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=4><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectProductGroup(5, vm.currentPromotion.Entities)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>{{\'common.actions.goBack\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.acceptPromotion() ng-if=vm.isAcceptRequired(vm.currentPromotion)>{{\'common.actions.accept\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit(1) ng-disabled=(!vm.isPromotionValid()||vm.blockSubmit)>{{\'common.form.confirm\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/promotions/promotions.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{\'promotions.name\' | translate}}</div><div class=panel-body><div><div><div class=row><div class=col-sm-3><label class=control-label>{{\'promotions.search.name\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=DocumentSearchBox name=DocumentSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'promotions.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'promotions.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'promotions.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.customTypeId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.PromotionTypeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3 style=\"position: relative\"><label style=\"width: 100%\">{{\'promotions.search.acceptance\' | translate}}</label><!--<input type=\"checkbox\" class=\"acceptance-checkbox\" ng-model=\"vm.pagingData.acceptance\" ng-change=\"vm.onFilterChange()\">--><div class=\"checkbox checkbox-primary acceptance-checkbox\"><input type=checkbox ng-model=vm.pagingData.acceptance ng-change=vm.onFilterChange()><label></label></div></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 40%\">Nazwa promocji</th><th class=uiGridHeader style=\"width: 20%\">Data rozpoczęcia</th><th class=uiGridHeader style=\"width: 20%\">Data zakończenia</th><th class=uiGridHeader style=\"width: 10%\">Akcje</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name></span></th><td><span ng-bind=\"key.BeginDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"key.EndDate |  date:\'yyyy-MM-dd\'\"></span></td><td><div style=\"position:relative; overflow-y: hidden; height: 100%\"><button type=button ng-click=vm.goToElement(key) class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removePromotion(key)><!--ng-disabled=\"vm.isTaskStarted(key)\"--> <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button> <span class=\"glyphicon glyphicon-exclamation-sign text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"{{\'promotions.needsAccept\' | translate}}\" ng-if=vm.isAcceptRequired(key) style=\"position:absolute; font-size: 1.5em; top: 0px; left: 0px\"></span></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div><div style=\"overflow-y: hidden; display: flex; flex-direction: column\"><span class=pull-right style=\"margin-bottom: 5px; margin-left: auto\">Rekordów:{{vm.pagingData.totalCount}}</span> <button class=\"btn btn-primary btn-submit\" style=\"margin-left: auto\" ng-click=vm.goToElement(0)>{{\'promotions.addNew\' | translate}}</button></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body -->");
$templateCache.put("app/components/reports/reports.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Raporty</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback pull-left\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-left\" ng-click=vm.addReport()><span class=\"glyphicon glyphicon-plus\"></span></button></div></div><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><br><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 20%\">Data dodania raportu</th><th class=uiGridHeader style=\"width: 20%\">Data od</th><th class=uiGridHeader style=\"width: 20%\">Data do</th><th class=uiGridHeader style=\"width: 20%\">Status</th><th class=uiGridHeader style=\"width: 20%\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><td><span ng-bind=\"key.CreateDate  | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"key.BeginDate  | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"key.EndDate  | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=vm.mapStatusToText(key.Status)></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button ng-if=\"!!key.FileUrl == true\" type=button class=\"btn btn-default\" uib-popover=pobierz popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.download(key)><i class=\"glyphicon glyphicon-download-alt\"></i></button> <span ng-if=\"!!key.FileUrl == false \">----</span></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/reports/reports.modal.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\" style=\"min-width: 200px\"><div class=panel-heading>Parametry raportu</div><div class=panel-body><div><div><div class=row style=\"margin-bottom: 20px\"><div class=\"col-sm-6 has-feedback\"><label class=control-label>Data początkowa</label><div class=input-group><input ng-change=vm.onDateChange() datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.dates.beginDate is-open=vm.beginDateDatePickerOpenedModal datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść on-press-enter=vm.closeByEnter()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=row style=\"margin-bottom: 20px\"><div class=\"col-sm-6 has-feedback\"><label class=control-label>Data końcowa</label><div class=input-group><input ng-change=vm.onDateChange() datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.dates.endDate is-open=vm.endDateDatePickerOpenedModal datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść on-press-enter=vm.closeByEnter()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ng-disabled=\"vm.dates.endDate === undefined || vm.dates.endDate === undefined\" class=\"btn btn-default btn-xs\" uib-popover=\"Stwórz raport\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.createReport(key)>Stwórz raport <span></span></button></div></div></div></div></div></div></div>");
$templateCache.put("app/components/reset/reset.password.confirm.html","<div class=container><div class=row><div class=\"col-sm-6 col-md-4 col-md-offset-4\"><div class=account-wall><h1 class=\"text-center login-title\">{{\'reset.titleConf\' | translate}}</h1><form class=form-signin ng-submit=\"vm.forgotPasswordConfirm(vm.user.email, vm.user.code, vm.user.password)\"><formly-form model=vm.user fields=vm.resetpassConfirmFields form=vm.userForm><br><uib-alert ng-show=vm.isError type=danger role=alert close=vm.closeAlert()>{{vm.error}}</uib-alert><md-button type=submit class=\"btn btn-lg btn-primary btn-block login-submit\" ng-click=\"vm.forgotPasswordConfirm(vm.user.email, vm.user.code, vm.user.password, vm.user.password2)\" ng-disabled=vm.disableButton>{{\'reset.buttonConf\' | translate}}</md-button></formly-form></form></div></div></div></div>");
$templateCache.put("app/components/reset/reset.password.html","<div class=container><div class=row><div class=\"col-sm-6 col-md-4 col-md-offset-4\"><div class=account-wall><div class=logo></div><div class=\"jumbotron alert alert-success\" ng-show=vm.isSend><h3><span class=\"glyphicon glyphicon-asterisk glyphicon-refresh-animate\"></span> Wiadomość została wysłana na podany adres email.</h3></div><h1 class=\"text-center login-title\">{{\'reset.title\' | translate}}</h1><form class=form-signin><formly-form model=vm.user fields=vm.resetpassFields form=vm.userForm><uib-alert ng-show=vm.isError type=danger role=alert close=vm.closeAlert()>{{vm.error}}</uib-alert><md-button type=submit class=\"btn btn-lg btn-primary btn-block login-submit\" ng-click=vm.forgotPassword(vm.user.email) ng-disabled=vm.disableButton>{{\'reset.button\' | translate}}</md-button></formly-form></form></div></div></div></div>");
$templateCache.put("app/components/returns/return.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Zwrot z dnia: {{vm.returnObject.CreateDate | date: \'dd-MM-yyyy\'}}</div><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.basic.title\' | translate}}</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Numer dokumentu</th><td><span>{{vm.returnObject.Document.DocumentNumberFull}}</span></td></tr><tr><th scope=row>Data zwrotu</th><td><span ng-bind=\"vm.returnObject.CreateDate | date: \'dd-MM-yyyy\'\"></span></td></tr><tr><th scope=row>Ostatnia aktualizacja</th><td><span ng-bind=\"vm.returnObject.ModifiedDate | date: \'dd-MM-yyyy\'\"></span></td></tr><tr><th scope=row>Status</th><td><span ng-bind=vm.mapStatusToText(vm.returnObject.Status)></span></td></tr></tbody></table></div></div><div class=\"panel panel-default\"><button ng-if=\"vm.returnObject.Status === 1 || vm.returnObject.Status === 6\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.accept(vm.returnObject.Id) id=doc-accept_positions-button>Akceptuj zwrot</button> <button ng-if=\"vm.returnObject.Status === 24\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.acceptToSend(vm.returnObject.Id) id=doc-accept_positions-button>Wyślij korekty do klienta</button> <button ng-if=\"vm.returnObject.Status === 24 || vm.returnObject.Status === 37 || vm.returnObject.Status === 38\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.regenerate(vm.returnObject.Id) id=doc-accept_positions-button>Gygeneruj ponownie PDF</button> <button ng-if=\"vm.returnObject.Status === 1 || vm.returnObject.Status === 6\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.cancel(vm.returnObject.Id) id=doc-accept_positions-button>Anuluj zwrot</button> <button ng-if=\"vm.returnObject.Status === 25\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.sendAgainFinal(vm.returnObject.Id) id=doc-accept_positions-button>Wyślij ponownie</button> <button ng-if=\"vm.returnObject.Status === 5\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.sendAgainProposition(vm.returnObject.Id) id=doc-accept_positions-button>Wyślij ponownie propozycję do klienta</button> <button ng-if=\"vm.returnObject.Status === 5 && vm.isExpired(vm.returnObject.EmailCodeExpirationTime)\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.cancel(vm.returnObject.Id) id=doc-accept_positions-button>Odrzuć zwrot</button> <button ng-if=\"vm.returnObject.Status === 1\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.inFuture(vm.returnObject.DocumentId) id=doc-accept_positions-button>Wystaw w przyszłości</button> <button ng-if=\"vm.returnObject.Status === 37 || vm.returnObject.Status === 38\" class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.skipError(vm.returnObject.Id) id=doc-accept_positions-button>Pomiń błąd i wyślij do klienta</button></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Płatnik</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Symbol</th><td><span ng-bind=vm.returnObject.PayerObject.Symbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.returnObject.PayerObject.DefaultAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.returnObject.PayerObject.NIP></span></td></tr><tr><th scope=row>Miasto</th><td><span ng-bind=vm.returnObject.PayerObject.DefaultAddress.City></span></td></tr><tr><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.returnObject.PayerObject.DefaultAddress.PostalCode></span></td></tr><tr><th scope=row>Ulica</th><td><span ng-bind=vm.returnObject.PayerObject.DefaultAddress.Street></span></td></tr><tr><th scope=row>Numer budynku</th><td><span ng-bind=vm.returnObject.PayerObject.DefaultAddress.BuildingNumber></span></td></tr><tr><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\', vm.returnObject.RecipientObject.DefaultAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\', vm.returnObject.RecipientObject.DefaultAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Odbiorca</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Symbol</th><td><span ng-bind=vm.returnObject.RecipientObject.Symbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.returnObject.RecipientObject.recieverAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.returnObject.RecipientObject.NIP></span></td></tr><tr><th scope=row>Miasto</th><td><span ng-bind=vm.returnObject.RecipientObject.recieverAddress.City></span></td></tr><tr><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.returnObject.RecipientObject.recieverAddress.PostalCode></span></td></tr><tr><th scope=row>Ulica</th><td><span ng-bind=vm.returnObject.RecipientObject.recieverAddress.Street></span></td></tr><tr><th scope=row>Numer budynku</th><td><span ng-bind=vm.returnObject.RecipientObject.recieverAddress.BuildingNumber></span></td></tr><tr><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\', vm.returnObject.RecipientObject.recieverAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\', vm.returnObject.RecipientObject.recieverAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Złożony zwrot w terminie</div><div class=panel-body><table class=\"table table-striped\" ng-if=\"vm.returnObject.Document !== null\"><tbody><tr><th scope=row>{{\'visit.data.giveback.name\' | translate}}</th><td><a ui-sref=\"home.documents.document({id: vm.returnObject.Document.Id, cameFrom: \'returns.return\', previousPageId: vm.returnObject.Id})\"><span ng-bind=vm.returnObject.Document.DocumentNumberFull></span></a></td></tr><tr><th scope=row>PDF</th><td><button ng-if=\"!!vm.returnObject.Document.GeneratedFileUrl == true\" type=button class=\"btn btn-default\" uib-popover=pobierz popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.download(vm.returnObject.Document)><i class=\"glyphicon glyphicon-download-alt\"></i></button> <span ng-if=\"!!vm.returnObject.Document.GeneratedFileUrl == false \">----</span></td></tr><tr><th scope=row>{{\'visit.data.giveback.net\' | translate}}</th><td><span ng-bind=vm.returnObject.Document.AmountNet></span></td></tr><tr><th scope=row>{{\'visit.data.giveback.gross\' | translate}}</th><td><span ng-bind=vm.returnObject.Document.AmountGross></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Wygenerowane korekty</div><div class=panel-body><table class=\"table table-striped\" ng-if=\"vm.returnObject.Document !== null\"><tbody><tr ng-repeat=\"key in vm.returnObject.GeneratedKfsDocuments\"><th scope=row><a ui-sref=\"home.documents.document({id: key.Id, cameFrom: \'returns.return\', previousPageId: vm.returnObject.Id})\"><span ng-bind=key.DocumentNumberFull></span> </a></th><td></td><td><button ng-if=\"!!key.GeneratedFileUrl == true\" type=button class=\"btn btn-default\" uib-popover=pobierz popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.download(key)><i class=\"glyphicon glyphicon-download-alt\"></i></button> <span ng-if=\"!!key.GeneratedFileUrl == false \">----</span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dostępne email <button class=\"btn-xs btn-primary btn-submit hidden-print\" ng-click=vm.setEmails()>Zapisz adresy</button></div><div class=panel-body><table class=\"table table-striped\" ng-if=\"vm.returnObject.Document !== null\"><tbody><tr ng-repeat=\"email in vm.emails\"><td><input type=checkbox class=form-check-input ng-model=email.selected ng-disabled=!email.valid></td><td><span ng-bind=email.Email></span></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-6 col-md-6\"><div class=\"panel panel-default\"><div class=panel-heading>Historia zgłoszenia</div><div class=panel-body><table class=\"table table-striped\" ng-if=\"vm.returnObject.Document !== null\"><tbody><tr ng-repeat=\"key in vm.acceptanceHistory\"><th scope=row>{{vm.mapStatusToText(key.Status)}}</th><td><span>{{key.CreateDate}}</span></td></tr></tbody></table></div></div></div></div><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>Wróć</button></div></div>");
$templateCache.put("app/components/returns/returns.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Produkty</div><div class=panel-body><div><div class=row><div class=col-sm-3><label>{{\'documents.search.drawer\' | translate}}</label><ui-select ng-model=vm.pagingData.userId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.SalesRepresentatives | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-4><label>{{\'visits.search.contractor\' | translate}}</label><div><div class=pull-left style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.contractorId === undefined\">{{\'visits.search.noContractor\' | translate}}</div><div class=pull-left style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.contractorId !== undefined\">{{vm.pagingData.contractorObj.Name}}</div><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"position:relative; top: 4px\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-plus\"></span></button></div></div><div class=col-sm-3><label>Status zwrotu</label><ui-select ng-model=vm.pagingData.status theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.ReturnAcceptanceStatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><div class=row><!-- date from  --><div class=col-sm-2><label>{{\'visits.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><!-- date from  --><div class=col-sm-2><label>{{\'visits.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>Suma korekt</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.userId === undefined && vm.pagingData.contractorId === unefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"(vm.pagingData.userId !== undefined || vm.pagingData.contractorId !== unefined) && vm.documentSums!== undefined\">{{vm.documentSums.Sum | number: 2}}</div></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms()><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><br><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 13%\">Składający</th><th class=uiGridHeader style=\"width: 13%\">Nazwa dokumentu</th><th class=uiGridHeader style=\"width: 8%\">Kwota</th><th class=uiGridHeader style=\"width: 22%\">Nazwa Kontrahenta</th><th class=uiGridHeader style=\"width: 8%\">Symbol</th><th class=uiGridHeader style=\"width: 8%\">Data dodania</th><th class=uiGridHeader style=\"width: 15%\">Status</th><th class=uiGridHeader style=\"width: 10%\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Patron.Name></span> <span ng-bind=key.Patron.SurName></span></th><th><span ng-bind=key.Document.DocumentNumberFull></span></th><td><span ng-bind=\"key.Document.AmountNet | number : 2\"></span></td><td><span ng-bind=key.RecipientObject.Name></span></td><td><span ng-bind=key.RecipientObject.Symbol></span></td><td><span ng-bind=\"key.CreateDate  | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=vm.mapStatusToText(key.Status)></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.returns.return({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/routes/routes.html","<div class=col-sm-3 style=\"padding-left: 0px; padding-right: 0px\"><div class=col-sm-6 style=\"padding-left: 0px\"><div class=\"effectiveness panel\"><label class=effectiveness-text>Plan</label><div class=effectiveness-progress><circular-progress value=\"(vm.relatedTasks.MonthAmountTask.CurrentAmount * 100) / vm.relatedTasks.MonthAmountTask.TotalAmount\" max=100 orientation=1 radius=80 stroke=6 base-color=\"rgba(255, 255, 255, 0.25)\" progress-color=#fff iterations=100 animation=easeInOutCubic></circular-progress><img class=progress-ring ng-src=/assets/icons/progress-ring.svg width=60px><div class=effectiveness-value ng-if=\"vm.relatedTasks.MonthAmountTask == undefined\">---</div><div class=effectiveness-value ng-if=\"vm.relatedTasks.MonthAmountTask != undefined\">{{(vm.relatedTasks.MonthAmountTask.CurrentAmount * 100) / vm.relatedTasks.MonthAmountTask.TotalAmount | number: 0 }}</div></div><p class=effectiveness-text ng-if=\"vm.relatedTasks.MonthAmountTask === undefined\">--- / ---</p><p class=effectiveness-text ng-if=\"vm.relatedTasks.MonthAmountTask != undefined\">{{vm.relatedTasks.MonthAmountTask.CurrentAmount}} / {{vm.relatedTasks.MonthAmountTask.TotalAmount}}</p></div></div><div class=col-sm-6 style=\"padding-left: 0px\"><div class=\"effectiveness panel\"><label class=effectiveness-text>Skuteczność</label><div class=effectiveness-progress><circular-progress value=vm.currentRouteEfficiency.percentage max=100 orientation=1 radius=80 stroke=6 base-color=\"rgba(255, 255, 255, 0.25)\" progress-color=#fff iterations=100 animation=easeInOutCubic></circular-progress><img class=progress-ring ng-src=/assets/icons/progress-ring.svg width=60px><div class=effectiveness-value ng-if=\"vm.currentRouteEfficiency == undefined\">---</div><div class=effectiveness-value ng-if=\"vm.currentRouteEfficiency != undefined\">{{vm.currentRouteEfficiency.percentage}}%</div></div><p class=effectiveness-text>{{vm.currentRouteEfficiency.finishedSum}} / {{vm.currentRouteEfficiency.totalSum}}</p></div></div></div><div class=col-sm-9 style=\"padding-right: 0px\"><div class=\"panel panel-default\" style=\"padding-left: 0px; padding-right: 0px\"><!-- <div class=\"panel-heading\">{{\'routes.route.data\' | translate}}\r\n  </div> --><div class=panel-body><form name=vm.form class=row><div class=col-sm-3><div><div class=input-label>{{\'routes.route.name\' | translate}}</div><td><div class=form-group ng-class=\"{\'has-error\' : !vm.form.routeName.$valid}\"><!--<label class=\"control-label\" for=\"inputError1\">Input with error</label>--> <input ng-model=vm.currentRoute.Name maxlength=50 minlength=3 class=input-control name=routeName ng-disabled=vm.isFormBlocked() required></div></td></div><div><div class=input-label>{{\'routes.route.date\' | translate}}</div><td><div class=input-group ng-class=\"{\'has-error\' : !vm.form.dateFrom.$valid}\"><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.currentRoute.CurrentDate, true)\" datepicker-localdate type=text class=input-control uib-datepicker-popup ng-required=true ng-model=vm.currentRoute.CurrentDate is-open=vm.datePickerBeginOpened ng-disabled=vm.isFormBlocked() date-disabled=\"vm.disableDP(date, mode)\" datepicker-options=vm.currentDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFrom> <span class=input-group-btn><button type=button class=\"btn btn-date\" ng-click=\"vm.openDP($event, 1)\" ng-disabled=vm.isFormBlocked()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></div></div><div class=col-sm-3><tr><div class=input-label>{{\'routes.route.cyclic\' | translate}}</div><td><ion-range-slider type=single min=0 max=4 from=vm.currentRoute.CycleCount disable=vm.isFormBlocked()></ion-range-slider></td></tr></div><div class=col-sm-4><div class=form-group><div class=input-label>{{\'routes.route.dateTo\' | translate}}</div><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateTo.$valid}\"><input ng-change=\"vm.onDateChange(vm.currentDateOptions, vm.currentRoute.EndDate, false)\" datepicker-localdate type=text class=input-control uib-datepicker-popup ng-model=vm.currentRoute.EndDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateTo ng-disabled=\"((vm.isFormBlocked())||!(vm.currentRoute.CycleCount > 0)||(vm.currentRoute.CurrentDate === undefined))\"> <span class=input-group-btn><button type=button class=\"btn btn-date\" ng-click=\"vm.openDP($event, 2)\" ng-disabled=\"((vm.isFormBlocked())||!(vm.currentRoute.CycleCount > 0))\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></div><div ng-if=\"vm.calendar.displayType === 2\"><th scope=row>{{\'routes.route.concerns\' | translate}}</th><td><span>{{vm.formUser.Context.SurName + \' \' + vm.formUser.Context.Name}}</span> <button type=button class=\"btn btn-xs pull-right\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectFormUser() ng-if=vm.showFormUser() ng-disabled=\"((vm.isFormBlocked())||(vm.calendarUser.Context.JobTitleId == 40) || )\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></div><div><div class=input-label>Magazyn</div><td><ui-select ng-disabled=vm.isFormBlocked() ng-model=vm.currentRoute.StorageId><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></td></div></div><div class=col-sm-2><div class=checkbox-container><span class=input-label>Akceptacja logistyka</span><div class=\"checkbox checkbox-primary\" style=\"display: inline\"><input type=checkbox ng-model=vm.currentRoute.LogisticsAcceptanceRequired ng-true-value=true ng-false-value=false><label></label></div></div><div class=checkbox-container><span class=input-label>Trasa dla PH</span><div class=\"checkbox checkbox-primary\" style=\"display: inline\"><input type=checkbox ng-model=vm.currentRoute.SyncToMobile ng-true-value=true ng-false-value=false><label></label></div></div><div class=btn-container><button class=\"btn btn-primary btn-submit\" ng-click=vm.clearCurrentRoute()>{{\'common.actions.clear\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit\" ng-click=vm.submit() ng-disabled=!vm.isRouteValid()>{{\'common.form.confirm\' | translate}}</button></div></div></form><span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover={{vm.errorText}} ng-if=vm.checkIfChoosingUserIsPossible() ng-show=vm.hasError style=\"margin: 15px 10px 0px 0px; font-size: 1.5em\"></span></div></div><div class=row style=\"margin-top: 10px; margin-left: 0px; margin-right: 0px\"><div class=col-sm-2 style=\"padding-left: 0px; padding-right: 0px\"><div class=\"panel panel-body order-panel\"><img class=order-icon ng-src=/assets/icons/orders.svg width=60px><div class=text-center><div class=order-value ng-if=\"vm.documentSums[0] == undefined\">---</div><div class=order-value ng-if=\"vm.documentSums[0] != undefined\">{{vm.documentSums[0].Sum | number: 2}}</div></div><p class=order-label>Wartość zamówień</p></div></div><div class=col-sm-2 style=\"padding-left: 0px; padding-right: 0px\"><div class=\"panel panel-body order-panel\"><img class=order-icon ng-src=/assets/icons/magic.svg width=60px><div class=text-center><div class=order-value ng-if=\"vm.documentSums[2] == undefined\">---</div><div class=order-value ng-if=\"vm.documentSums[2] != undefined\">{{vm.documentSums[2].Sum | number: 2}}</div></div><p class=order-label>Wartość korekt</p></div></div><div class=col-sm-2 style=\"padding-left: 0px; padding-right: 0px\"><div class=\"panel panel-body order-panel\"><img class=order-icon ng-src=/assets/icons/package.svg width=60px><div class=text-center><div class=order-value ng-if=\"vm.documentSums[3] == undefined\">---</div><div class=order-value ng-if=\"vm.documentSums[3] != undefined\">{{vm.documentSums[3].Sum | number: 2}}</div></div><p class=order-label>Wartość próbek</p></div></div><!-- <div style=\"font-size: 17px; padding-top: 4px;\" ng-if=\"vm.documentSums[3] != undefined\">{{vm.documentSums[3].Sum | number: 2}}</div> --><div class=\"col-sm-6 goals-stat panel\"><div class=goal><label>Cele tygodniowe:</label></div><div class=goal ng-if=\"vm.relatedTasks.WeekTasks.length === 0\"><div>---</div></div><div class=goal ng-repeat=\"key in vm.relatedTasks.WeekTasks\"><label class=\"goal-label sub-label\">{{key.Name}}</label><div class=progress-bar><div class=progress-bar-fill ng-style=\"{\'width\':(key.CurrentAmount / key.TotalAmount) * 100 + \'%\'}\"></div></div><div class=progress-value ng-if=\"vm.relatedTasks.WeekTasks != undefined\">{{(key.CurrentAmount / key.TotalAmount) * 100 | number: 1}} %<br><span style=\"font-size: 8px\">{{key.CurrentAmount}} / {{key.TotalAmount}}</span></div></div><div class=goal><label class=goal-label>Cel miesięczny</label><div ng-if=\"vm.relatedTasks.MonthTask == undefined\">---</div><div ng-if=\"vm.relatedTasks.MonthTask != undefined\" class=progress-bar><div class=progress-bar-fill ng-style=\"{\'width\':(vm.relatedTasks.MonthTask.CurrentAmount / vm.relatedTasks.MonthTask.TotalAmount) * 100 + \'%\'}\"></div></div><div class=progress-value ng-if=\"vm.relatedTasks.MonthTask != undefined\">{{(vm.relatedTasks.MonthTask.CurrentAmount / vm.relatedTasks.MonthTask.TotalAmount) * 100 | number: 1}} %<br><span style=\"font-size: 8px\">{{vm.relatedTasks.MonthTask.CurrentAmount}} / {{vm.relatedTasks.MonthTask.TotalAmount}}</span></div></div></div></div></div><div class=\"btn-group tabs\" role=group><button type=button class=\"btn btn-secondary mr-4\" ng-class=\"{\'view-chosen\': (vm.routeEditType == \'data\')}\" ng-click=\"vm.routeEditType = \'data\'\" style=\"border-radius: 6px 0 0 0\">Dane</button> <button type=button class=\"btn btn-secondary\" ng-class=\"{\'view-chosen\': (vm.routeEditType == \'order\')}\" ng-click=\"vm.routeEditType = \'order\'\" style=\"border-radius: 0 6px 0 0\">Kolejność</button></div><div class=\"panel panel-default panel-table\"><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><div class=row><div class=\"col-sm-12 col-md-12\"><div class=\"panel-default col-sm-12\" style=\"padding-left: 0px; padding-right: 0px\"><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\" id=routeTable ng-if=\"vm.routeEditType == \'data\'\"><thead><tr><th class=uiGridHeader style=\"width: 10%\" uib-popover=Symbol popover-trigger=mouseenter popover-append-to-body=true>Symbol</th><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader uib-popover=Uwagi popover-trigger=mouseenter popover-append-to-body=true>Uwagi</th><th class=uiGridHeader style=\"width: 5%\" uib-popover=\"Historia zamówień\" popover-trigger=mouseenter popover-append-to-body=true></th><th class=uiGridHeader style=\"width: 5%\" uib-popover=Zamówienie popover-trigger=mouseenter popover-append-to-body=true></th><th class=uiGridHeader style=\"width: 5%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentRoute.Entities | orderBy: Position\" ng-if=\"key.Type === 1\" ng-class=\"{success: (key.Visit !== null)&&(key.Visit !== undefined)}\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.ContextObject.Symbol \"></span></th><td><b><span ng-bind=\"key.ContextObject.Name \" uib-popover={{key.ContextObject.Name}} popover-trigger=mouseenter></span></b><br ng-show=\"key.phoneNumbers != null\"><span ng-repeat=\"item in key.phoneNumbers\">Tel: <a ng-href=tel:{{item.Number}} uib-popover=\"Tel: {{item.Number}}\" popover-trigger=mouseenter>{{item.Number}}<br><a></a></a></span> <a ng-href=\"mailto:{{ key.ContextObject.Email }}\" ng-show=vm.isEmailVaild(key.ContextObject.Email)>{{ key.ContextObject.Email }}</a></td><!-- <td style=\"padding: 9px 8px 8px 8px\">\r\n              <span ng-if=\"(key.Visit === null)||(key.Visit === undefined)\"> - </span>\r\n              <span ng-if=\"(key.Visit !== null)&&(key.Visit !== undefined)\" class=\"glyphicon glyphicon-menu-right\" ng-click=\"vm.goToVisit(key.Visit)\"></span>\r\n            </td> --><!-- <td>(<span ng-bind=\"key.PendingPaymentsCount\" uib-popover=\"Zaległe płatności {{key.PendingPaymentsCount}}\" popover-trigger=\"mouseenter\"></span>)</td> --><td style=\"white-space: unset; padding-right: 3rem\">{{key.ContextObject.NextVisitNote}}</td><td><button type=button class=\"btn btn-m btn-accent\" uib-popover=\"Historia zamówień\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.contractorHistory(key.ContextObject) ng-disabled=\"\"><span class=\"glyphicon glyphicon-duplicate\"></span></button></td><td><!-- <span class=\"glyphicon glyphicon-exclamation-sign\"  ng-if=\'key.ContextObject.NextVisitNote != null && key.ContextObject.NextVisitNote != \"\"\'\r\n                uib-popover=\"{{key.ContextObject.NextVisitNote}}\" popover-trigger=\"mouseenter\"\r\n                popover-append-to-body=\"true\"></span> --> <button type=button class=\"btn btn-m\" uib-popover=\"Dodaj zamówienie\" popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.addOrderForContractorAndRouteItem(key.ContextObject.Id, vm.currentRoute, key)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td><td><button type=button class=\"btn btn-m btn-remove\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.remove(vm.currentRoute.Entities, key.ContextObject.Id)\" ng-disabled=vm.isFormBlocked()><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=6><button type=button class=\"btn btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.selectContractor(1, vm.currentRoute.Entities)\" ng-disabled=vm.disableContractorSelect()><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\" id=routeTable ng-if=\"vm.routeEditType == \'order\'\"><thead><tr><th class=uiGridHeader style=\"width: 14%\" uib-popover=Symbol popover-trigger=mouseenter popover-append-to-body=true>Symbol</th><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 55%\" uib-popover=Zamówienie popover-trigger=mouseenter popover-append-to-body=true>Pozycja</th></tr></thead><tbody><tr ng-repeat=\"key in vm.currentRoute.Entities  | orderBy: Position\" ng-if=\"key.Type === 1\" ng-class=\"{success: (key.Visit !== null)&&(key.Visit !== undefined)}\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.ContextObject.Symbol \"></span></th><td><b><span ng-bind=\"key.ContextObject.Name \" uib-popover={{key.ContextObject.Name}} popover-trigger=mouseenter></span></b><br ng-show=\"key.phoneNumbers != null\"><span ng-repeat=\"item in key.phoneNumbers\">Tel: <span uib-popover=\"Tel: {{item.Number}}\" popover-trigger=mouseenter>{{item.Number}}<br><span></span></span></span></td><td>{{vm.assignIndex(key, $index)}}<div class=\"btn-group pull-right\" role=group><button type=button class=\"btn btn-xs btn-secondary\" ng-click=\"vm.swapItemsInArray(vm.currentRoute.Entities, $index - 1, $index)\" ng-disabled=$first><span class=\"glyphicon glyphicon-chevron-up\"></span></button> <button type=button class=\"btn btn-xs btn-secondary\" ng-click=\"vm.swapItemsInArray(vm.currentRoute.Entities, $index, $index + 1)\" ng-disabled=$last><span class=\"glyphicon glyphicon-chevron-down\"></span></button></div></td></tr></tbody></table></div></div></div></div><div class=\"btn-group tabs\" role=group><button type=button class=\"btn btn-secondary\" ng-click=vm.switchToMonthlyView() ng-class=\"{\'view-chosen\': (vm.calendar.displayType === 1)}\">{{\'routes.monthly\' | translate}}</button> <button type=button class=\"btn btn-secondary mr-4\" ng-click=vm.switchToWeeklyView() ng-class=\"{\'view-chosen\': (vm.calendar.displayType === 2)}\">{{\'routes.weekly\' | translate}}</button></div><div class=\"panel panel-default panel-table\"><div class=row><div class=\"col-sm-12 col-md-12\"><div class=\"col-sm-12 col-md-12\"><div style=\"margin-top: 20px\"><div class=\"btn-group calendar-button-group\"><button type=button class=btn uib-popover=\"Wybierz użytkownika\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectcalendarUser() ng-if=vm.checkIfChoosingUserIsPossible()><span class=\"glyphicon glyphicon-plus\"></span></button></div><span ng-if=vm.calendarUser.Context.SurName class=name-tag>{{\' \' + vm.calendarUser.Context.SurName + \' \' + vm.calendarUser.Context.Name}} <button type=button class=btn uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-if=\"vm.calendarUser !== undefined\" ng-click=vm.removeUser()><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button> </span><span class=pull-right style=\"font-size: 15px; padding-top: 5px\">{{vm.efficiencyStringfied}}</span></div><div class=panel-body><div class=calendar-header><i class=\"fa fa-angle-left\" ng-click=vm.goPrevious()></i> <span>{{vm.calendar.title}} </span><i class=\"fa fa-angle-right\" ng-click=vm.goNext()></i></div><div class=calendar-core><div class=week-number><div class=week-days><span class=day>Poniedziałek</span> <span class=day>Wtorek</span> <span class=day>Środa</span> <span class=day>Czwartek</span> <span class=day>Piątek</span> <span class=day>Sobota</span> <span class=day>Niedziela</span></div><div class=calendar-grid><div class=calendar-week ng-repeat=\"week in vm.calendar.display\"><div class=week-order><p>{{week.title}}</p></div><div class=day ng-repeat=\"day in week.days\" ng-class=\"{\'different-month\': !day.isCurrentMonth, \'free-day\': day.isFree, \'day-in-week-view\': (vm.calendar.displayType === 2)}\" ng-click=vm.chosenDay(day)><div class=number>{{day.number}}</div><div ng-repeat=\"list in day.list\"><span class=user-full-name ng-if=\"vm.calendar.displayType === 2\">{{list.UserFullName}}</span><perfect-scrollbar class=scroller wheel-propagation=true wheel-speed=10 min-scrollbar-length=20><ul dnd-list=list.routes dnd-drop=\"vm.dropCallback(item, day, list)\"><li ng-repeat=\"item in list.routes\" dnd-draggable=item dnd-disable-if=!vm.isDraggingPermitted(item) dnd-dragstart=vm.dragStartCallback() dnd-moved=\"day.list.splice($index, 1)\" dnd-effect-allowed=move dnd-dragend=vm.dragEndCallback() ng-click=vm.selectRoute(item) ng-class=\"{\'past-event\': item.DndId === undefined}\"><div>{{item.Name}} ({{item.Entities1FinishedCount}}/{{item.Entities1Count}})</div></li></ul></perfect-scrollbar></div></div></div></div><div class=calendar-utility ng-class=\"{\'dragging-trash\': vm.isDragging}\"><ul dnd-list=[] dnd-drop=vm.trashDrop(item) ng-class=\"{\'dragging-trash\': vm.isDragging}\"><i class=\"fa fa-trash-o\"></i></ul></div><!-- <div class=\"calendar-utility pull-right\" ng-class=\"{\'dragging-transfer\': vm.isDragging}\">\r\n                    <ul dnd-list=\"[]\" dnd-drop=\"vm.transferDrop(item)\" ng-class=\"{\'dragging-transfer\': vm.isDragging}\">\r\n                      <i class=\"fa fa-refresh\"></i>\r\n                    </ul>\r\n                  </div> --> <button type=button class=\"btn pull-left\" ng-show=\"(vm.calendar.displayType === 1)\" ng-click=vm.selectFormDestinationUser() ng-disabled=\"vm.calendarUser === undefined || !vm.checkPermission(35)\">Przenieś trasy</button></div></div></div></div></div></div></div>");
$templateCache.put("app/components/routes/selection.modal.html","<div class=modal-header><h3 class=modal-title ng-if=\"vm.actionName == undefined\">Wybierz typ operacji</h3><h3 class=modal-title ng-if=\"vm.actionName == \'delete\'\">Wybierz operację dla usunięcia</h3></div><div class=modal-body><div class=user-select ng-show=vm.transfer><ui-select ng-model=vm.result.selectedId theme=bootstrap on-select=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.action(1) ng-disabled=!vm.userPicked>Jednorazowa operacja</button> <button class=\"btn btn-primary btn-block\" type=button ng-click=vm.action(2) ng-disabled=!vm.userPicked>Zastosuj dla kolejnych</button></div>");
$templateCache.put("app/components/samples/sample.html","<div><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=\"panel-heading hidden-print\">Dokument: {{vm.data.DocumentNumberFull}}</div><div class=panel-body><!-- only for print section--><div style=\"display: none\" class=print-display-block><div class=print-company-data>Smakmak sp. z o.o.<br>Ul. Balonowa 7A, 64-100 Strzyżewice</div><div class=print-date>Data wystawienia: {{vm.data.DocumentReleaseDate | date:\'yyyy.MM.dd\'}}</div><div class=print-document-number>Wydanie: {{vm.data.DocumentNumberFull}}</div></div><!--end of print section--><div><div class=row><div class=\"col-sm-12 col-md-12 hidden-print\"><uib-alert ng-show=vm.data.IsSubiektError class=alert-danger><b>Wystąpił błąd podczas wysyłki do subiekta:</b> {{vm.data.SubiektError}}</uib-alert></div><div style=\"position: absolute; left: 50%\" class=hidden-print><div class=smak-icon id=loader style=\"opacity: 0.3\"></div></div><div class=\"col-sm-6 col-md-4 hidden-print\" id=doc-common-data style=\"opacity: 0.0\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Typ</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentTypeDictionary\',vm.data.TypeId).Value\"></span></td></tr><tr><th scope=row>Numer dokumentu</th><td><span ng-bind=\"vm.data.DocumentNumberFull \"></span></td></tr><tr><th scope=row>Data wystawienia</th><td><span ng-bind=\"vm.data.DocumentReleaseDate | date:\'yyyy-MM-dd\'\"></span></td></tr><tr><th scope=row>Wystawił</th><td><span ng-bind=\"vm.data.RelatedUser.Name + \' \' + vm.data.RelatedUser.SurName\"></span></td></tr><tr><th scope=row>Poziom ceny</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'PriceLevel\',vm.data.PriceLevelId).Value\"></span></td></tr><tr><th scope=row>Status</th><td><span ng-if=vm.data.IsSendToClient>Wysłany do klienta</span> <span ng-if=!vm.data.IsSendToClient>Do wysłania</span></td></tr><tr ng-if=\"vm.data.TypeId ===1001 || vm.data.TypeId === 1004\"><th scope=row>Status przetworzenia</th><td><span ng-bind=\"vm.data.IsProcessed == true ? \'Dokument przeanalizowany\' : \'Oczekuje na analizę\'\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\" id=doc-note style=\"opacity: 0.0\"><div class=\"panel panel-default\" ng-class=\"{\'hidden-print\': vm.data.Note == undefined}\"><div class=panel-heading>{{\'visit.data.note\' | translate}}</div><div class=panel-body><textarea cols=\"\" rows=\"\" class=\"textarea-style-visit hidden-print\" ng-model=vm.data.Note ng-disabled=true></textarea><label class=note-label style=\"display: none\">{{::vm.data.Note}}</label></div></div></div><div class=\"col-sm-6 col-md-4 print-left\" id=doc-payer-data ng-if=\"vm.data.PayerAddress != null && vm.data.PayerAddress != undefined && vm.data.TypeId != 1002 && vm.data.TypeId != 1003\"><div class=\"panel panel-default\"><div class=panel-heading>Kontrahent</div><div class=panel-body><table class=\"table table-striped\"><tbody class=print-no-border><tr class=hidden-print><th scope=row>Symbol</th><td><span ng-bind=vm.data.PayerSymbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.data.PayerAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.data.PayerAddress.NIP></span></td></tr><tr class=hidden-print><th scope=row>Miasto</th><td><span ng-bind=vm.data.PayerAddress.City></span></td></tr><tr class=hidden-print><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.data.PayerAddress.PostalCode></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Adres</th><td><span ng-bind=vm.data.PayerAddress.City></span> <span ng-bind=vm.data.PayerAddress.PostalCode></span></td></tr><tr class=hidden-print><th scope=row>Ulica</th><td><span ng-bind=vm.data.PayerAddress.Street></span></td></tr><tr class=hidden-print><th scope=row>Numer budynku</th><td><span ng-bind=vm.data.PayerAddress.BuildingNumber></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Ulica</th><td><span ng-bind=vm.data.PayerAddress.Street></span> <span ng-bind=vm.data.PayerAddress.BuildingNumber></span></td></tr><tr class=hidden-print><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\',vm.data.PayerAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\',vm.data.PayerAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 pull-right hidden-print\" id=doc-related-data style=\"opacity: 0.0\" ng-if=\"vm.data.TypeId != 1002 && vm.data.TypeId != 1003\"><div class=\"panel panel-default\"><div class=panel-heading>Dokumenty powiązane</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr ng-repeat=\"key in vm.data.RelatedDocuments\" ng-if=\"vm.data.TypeId < 1000\"><th scope=row ng-if=\"key.Id === vm.data.Id\" style=\"text-align: center\">{{key.DocumentNumberFull}}</th><td scope=row ng-if=\"!(key.Id === vm.data.Id)\" style=\"text-align: center\"><a ng-click=vm.goToDocument(key.Id)><!--ui-sref=\"home.documents.document({id: key.Id})\"-->{{key.DocumentNumberFull}}</a></td><!-- --></tr><tr ng-repeat=\"key in vm.data.RelatedKFSDocuments\" ng-if=\"vm.data.TypeId >= 1000\"><th scope=row ng-if=\"key.Id === vm.data.Id\" style=\"text-align: center\">{{key.DocumentNumberFull}}</th><td scope=row ng-if=\"!(key.Id === vm.data.Id)\" style=\"text-align: center\"><a ng-click=vm.goToDocument(key.Id)><!--ui-sref=\"home.documents.document({id: key.Id})\"--> {{key.DocumentNumberFull}}</a></td><!-- --></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 pull-right print-recipient\" id=doc-recipient-data ng-hide=\"vm.data.RecipientAddress == null || vm.data.RecipientAddress == undefined\"><div class=\"panel panel-default\"><div class=panel-heading>Odbiorca</div><div class=panel-body><table class=\"table table-striped\"><tbody class=print-no-border><tr><th scope=row>Symbol</th><td><span ng-bind=vm.data.RecipientSymbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.data.RecipientName></span></td></tr><tr class=hidden-print><th scope=row>NIP</th><td><span ng-bind=vm.data.RecipientAddress.NIP></span></td></tr><tr class=hidden-print><th scope=row>Miasto</th><td><span ng-bind=vm.data.RecipientAddress.City></span></td></tr><tr class=hidden-print><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.data.RecipientAddress.PostalCode></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Adres</th><td><span ng-bind=vm.data.RecipientAddress.City></span> <span ng-bind=vm.data.RecipientAddress.PostalCode></span></td></tr><tr class=hidden-print><th scope=row>Ulica</th><td><span ng-bind=vm.data.RecipientAddress.Street></span></td></tr><tr class=hidden-print><th scope=row>Numer budynku</th><td><span ng-bind=vm.data.RecipientAddress.BuildingNumber></span></td></tr><tr class=print-display-row style=\"display: none\"><th scope=row>Ulica</th><td><span ng-bind=vm.data.RecipientAddress.Street></span> <span ng-bind=vm.data.RecipientAddress.BuildingNumber></span></td></tr><tr class=hidden-print><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\',vm.data.RecipientAddress.ProvinceId).Value\"></span></td></tr><tr class=hidden-print><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\',vm.data.RecipientAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4 hidden-print\" id=doc-photos style=\"opacity: 0.0\"><div class=\"panel panel-default\"><div class=panel-heading>Zdjęcia</div><div class=panel-body><ul style=\"list-style-type: none; padding-left: 0px\"><li ng-repeat=\"image in vm.data.Files\" class=image-li><a ng-click=vm.openLightboxModal($index)><img ng-src={{image.FileUrl}} width=100px height=\"100 px\" class=img-thumbnail> </a><button type=button class=\"btn btn-default btn-xs delete-button\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeImg(image)><span class=\"glyphicon glyphicon-remove\"></span></button></li></ul><button type=submit class=\"btn btn-primary\" ng-click=vm.uploadAttachment()>Wgraj zdjęcie</button></div></div></div></div><table class=\"table table-hover table-striped uiGrid print-table\" id=doc-entities-data style=\"opacity: 0.0\"><thead><tr><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Pozycja</th><!-- [PositionOnDocument]--><th class=\"uiGridHeader hidden-print\" style=\"width: 35%\">Nazwa produktu</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 35%; display: none\">Nazwa produktu</th><!--[Name] --><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Ilość</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">Ilość</th><!-- [Count]--><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\">Jednostka</th><th class=\"uiGridHeader print-display-cell\" style=\"width: 10%; display: none\">J.M</th><!--[MeasureUnit] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Cena j. netto</th><!--[[AmountProductNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Cena j. brutto</th><!--[[AmountProductNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość netto</th><!--[[AmountNet]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość VAT</th><!--[[AmountGross]] --><th class=\"uiGridHeader hidden-print\" style=\"width: 9%\">Wartość brutto</th><th class=\"uiGridHeader hidden-print\" style=\"width: 5%\" ng-if=\"vm.data.TypeId == 1004\">Zdjęcia</th><!--[[AmountGross]] --></tr></thead><tbody><tr ng-repeat=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId != 2 && vm.data.TypeId !=6\"><th class=hidden-print><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=key.Count></span> <span ng-if=\"key.CountReturned > 0 && vm.data.TypeId > 999\">(<span ng-bind=key.CountReturned></span>) </span></td><td><span ng-bind=key.MeasureUnit></span></td><td class=hidden-print><span ng-bind=\"key.AmountProductNet | number:2\"></span> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter ng-if=\"key.AcceptanceReason > 0 && !vm.checkPermission(18) && vm.data.TypeId != 1004\" popover-append-to-body=true uib-popover=\"Pozycje wymagają akceptacji z powodu zmiany ceny\" style=\"font-size: 1.3em\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right\" ng-if=\"(key.AcceptanceReason == 1 || key.AcceptanceReason == 2) && vm.checkPermission(18)\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right\" ng-if=\"(key.AcceptanceReason == 3) && vm.checkPermission(28)\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span> <span class=\"glyphicon glyphicon-ok pull-right text-success\" popover-trigger=mouseenter ng-if=\"key.CalculationStatus == 0 && vm.data.TypeId == 1004\" popover-append-to-body=true uib-popover=\"Pozycja zaakceptowana\" style=\"font-size: 1.3em\"></span> <span class=\"glyphicon glyphicon-remove pull-right text-danger\" popover-trigger=mouseenter ng-if=\"key.CalculationStatus == 1 && vm.data.TypeId == 1004\" popover-append-to-body=true uib-popover=\"Pozycja odrzucona\" style=\"font-size: 1.3em\"></span></td><td class=hidden-print><span ng-bind=\"key.AmountProductGross | number:2\"></span></td><td class=hidden-print><span ng-bind=\"key.AmountNet | number:2\"></span></td><td class=hidden-print><span ng-bind=\"key.AmountVAT | number:2\"></span></td><td class=hidden-print><span ng-bind=\"key.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><tr ng-repeat=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId == 2\"><th class=hidden-print><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.Count : key.RelatedEntity.Count\"></span><span ng-if=\"key.CountReturned > 0\">(<span ng-bind=key.CountReturned></span>)</span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span><!----> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter ng-if=\"key.AcceptanceReason > 0 && !vm.checkPermission(18)\" popover-append-to-body=true uib-popover=\"Pozycje wymagają akceptacji z powodu zmiany ceny\" style=\"font-size: 1.3em\"></span> <span uib-popover-template=\"\'app/components/documents/acceptance.directive.html\'\" class=\"glyphicon glyphicon-exclamation-sign pull-right\" ng-if=\"key.AcceptanceReason > 0 && vm.checkPermission(18)\" style=\"font-size: 1.3em\" popover-trigger=outsideClick ng-class=\"{\'text-danger\': key.AcceptRecord.Send === false, \'text-success\': key.AcceptRecord.Send === true}\"></span></td><td class=hidden-print><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountNet : key.RelatedEntity.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountVAT : key.RelatedEntity.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountGross : key.RelatedEntity.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><!--dla KFS - pokazywanie rozwijanych pozycji z korektą itp --><tr ng-repeat-start=\"key in vm.data.DocumentEntities\" ng-if=\"vm.data.TypeId == 6\" ng-class=\"{\'info\': key.Count > 0}\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><th><span ng-bind=key.PositionOnDocument></span></th><td><span ng-bind=key.RelatedProduct.Name></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.Count : key.RelatedEntity.Count\"></span> <span ng-if=\"key.Count > 0\" ng-bind=\"\'(\' +  -key.Count + \')\'\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountNet : key.RelatedEntity.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountVAT : key.RelatedEntity.AmountVAT | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountGross : key.RelatedEntity.AmountGross | number:2\"></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.showImagesGallery(key) ng-disabled=\"key.Files.length < 1\"><span class=\"glyphicon glyphicon-camera\"></span></button></td></tr><tr ng-if=\"key.Count > 0 && vm.data.TypeId == 6\" ng-hide=key.isCollapsed class=info><th><span>-</span></th><td><span class=pull-right>Korekta</span></td><td><span ng-bind=-key.Count></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"-key.AmountNet  | number:2\"></span></td><td><span ng-bind=\"-key.AmountVAT  | number:2\"></span></td><td><span ng-bind=\"-key.AmountGross| number:2\"></span></td><td><span></span></td></tr><tr ng-repeat-end ng-if=\"key.Count > 0 && vm.data.TypeId == 6\" ng-hide=key.isCollapsed class=info><th><span>-</span></th><td><span class=pull-right>Po korekcie</span></td><td><span ng-bind=\"key.RelatedEntity.Count - key.Count\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.MeasureUnit : key.RelatedEntity.MeasureUnit\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductNet : key.RelatedEntity.AmountProductNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity === null ? key.AmountProductGross : key.RelatedEntity.AmountProductGross | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity.AmountNet - key.AmountNet | number:2\"></span></td><td><span ng-bind=\"key.RelatedEntity.AmountVAT - key.AmountVAT | number:2\"></span></td><td><span ng-bind=\" key.RelatedEntity.AmountGross - key.AmountGross| number:2\"></span></td><td><span></span></td></tr><tr class=\"info hidden-print\"><th colspan=6><span ng-bind=\"\'Razem\'\" class=pull-right></span></th><td><span ng-bind=\"vm.data.AmountNet | number:2\"></span></td><td><span ng-bind=\"vm.data.AmountVAT | number:2\"></span></td><td><span ng-bind=\"vm.data.AmountGross | number:2\"></span></td><td class=hidden-print ng-if=\"vm.data.TypeId == 1004\"></td></tr><tr class=\"info hidden-print\" ng-show=\"vm.data.TypeId === 1 || vm.data.TypeId === 2 || vm.data.TypeId === 6 || vm.data.TypeId === 5\"><th colspan=6><span ng-bind=\"\'Pozostaje do zapłaty\'\" class=pull-right></span></th><td><span ng-bind=\"\"></span></td><td><span ng-bind=\"\"></span></td><td><span ng-bind=\"vm.data.AmountPaidLeft | number:2\"></span></td><td ng-if=\"vm.data.TypeId == 1004\"></td></tr><tr class=\"info hidden-print\" ng-show=\"vm.data.TypeId === 1 || vm.data.TypeId === 2 || vm.data.TypeId === 6 || vm.data.TypeId === 5\"><th colspan=6><span ng-bind=\"\'Zapłacono\'\" class=pull-right></span></th><td></td><td></td><td><span ng-bind=\"vm.data.AmountGrossView - vm.data.AmountPaidLeft | number:2\"></span></td><td ng-if=\"vm.data.TypeId == 1004\"></td></tr></tbody></table><!-- sign space shown on print--><div style=\"display:none; padding-top: 50px\" class=\"print-display-cell pull-right\"><div style=\"border-bottom:1px solid; width: 200px\"></div><span style=\"font-size: 10px; padding: 5px 0px 0px 25px\">Podpis - potwierdzenie odbioru</span></div><!-- end of sign space --></div><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 0.0\" ng-click=vm.goBack() id=doc-back-button>{{\'common.actions.goBack\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 0.0\" ng-click=vm.printDocument() id=doc-print-button>{{\'common.actions.print\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.sendAgainToAccountingSystem() id=doc-send-again-button ng-if=vm.data.IsSubiektError>{{\'documents.actions.sendAgain\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.sendToClient() id=doc-send-to-client-button ng-if=vm.canBeSendToClient()>{{\'documents.actions.sendToClient\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=vm.sendForAcceptance() id=doc-accept_positions-button ng-if=\"((vm.data.AcceptanceReason === 1 || vm.data.AcceptanceReason === 2) && vm.checkPermission(18)) ||\r\n                ((vm.data.AcceptanceReason === 3) && vm.checkPermission(28))\">Akceptuj pozycje</button></div></div></div></div>");
$templateCache.put("app/components/samples/samples.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Próbki i gratisy</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'documents.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><!-- <label>{{\'visits.search.orderStatus\' | translate}}</label> --><label>Status</label><ui-select ng-model=vm.pagingData.objectStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.StatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.drawer\' | translate}}</label><ui-select ng-model=vm.pagingData.userId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.SalesRepresentatives | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><div class=row><div class=col-sm-3><label>{{\'documents.search.storage\' | translate}}</label><ui-select ng-model=vm.pagingData.storageId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-6><label>{{\'documents.search.contractor\' | translate}}</label><div class=input-group><button type=button class=\"btn btn-default\" ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-search\"></span></button> <span>{{vm.pagingData.contractor.Name}} </span><button type=button class=\"btn btn-default\" ng-click=vm.removeContractor() ng-if=\"vm.pagingData.contractor !== undefined\"><span class=\"glyphicon glyphicon-remove\"></span></button> <span></span></div><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><div class=\"col-sm-12 col-md-12\"><uib-alert ng-show=\"vm.pagingData.totalCount>vm.maxCount\"><span ng-bind=\"\'documents.search.countWarning1\' | translate\"></span> <span ng-bind=vm.maxCount></span> <span ng-bind=\"\'documents.search.countWarning2\' | translate\"></span> <span ng-bind=vm.pagingData.totalCount></span> <span ng-bind=\"\'documents.search.countWarning3\' | translate\"></span></uib-alert></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><!-- 15 %--><th class=\"uiGridHeader rowNumberFull\">Pełny numer</th><!-- 10 %--><th class=\"uiGridHeader rowDate\">Data wystawienia<i class=fa ng-class=\"{\'fa-sort-asc\': vm.pagingData.sortByDate <0, \'fa-sort-desc\': vm.pagingData.sortByDate >0}\" ng-click=vm.changeSortByDate()></i></th><!-- 25 %--><th class=\"uiGridHeader rowPayer\">Kontrahent</th><!-- 13 %--><th class=\"uiGridHeader rowStatus\">Status</th><!-- 7  %--><th class=\"uiGridHeader rowActionDocuments\">{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.DocumentNumberFull></span></th><!--<td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentTypeDictionary\',key.TypeId).Value\"></span></td>--><td><span ng-bind=\"key.DocumentReleaseDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-if=\"key.RecipientName != null && key.RecipientName != undefined\" ng-bind=key.PayerName uib-popover={{key.RecipientName}} popover-trigger=mouseenter></span> <span ng-if=\"key.RecipientName == null || key.RecipientName == undefined\">-</span></td><!--<td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentStatusDictionary\',key.Status).Value\" uib-popover=\"{{vm.getDictionaryElementByType(\'DocumentStatusDictionary\',key.Status).Value}}\" popover-trigger=\"mouseenter\"></span></td>--><td><span ng-if=\"key.ObjectStatus == 1\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Akceptacja>Akceptacja</span> <span ng-if=\"key.ObjectStatus == 10\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Zaakceptowany>Zaakceptowany</span> <span ng-if=\"key.ObjectStatus == 11\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Do wysłania\">Do wysłania</span> <span ng-if=\"key.ObjectStatus == 23\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Wysłany>Wysłany</span> <span ng-if=\"key.ObjectStatus == 30\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Odrzucony>Odrzucony</span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.samples.sample({id: key.Id, cameFrom: \'samples\'})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <button type=button ng-click=vm.markForPrint(key) class=\"btn btn-default btn-xs print-button\" ng-class=\"{\'marked-for-print\': key.isMarkedForPrint}\" uib-popover=\"Oznacz do druku\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-print\" aria-hidden=true></span></button><!-- <button type=\"button\"\r\n                          class=\"btn btn-default btn-xs\"\r\n                          uib-popover=\"Usuń\" popover-trigger=\"mouseenter\"\r\n                          popover-append-to-body=\"true\"\r\n                          ng-click=\"vm.tryRemoveDocument(key)\"\r\n                    >\r\n\r\n                    <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\r\n                  </button> --></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-8><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=\"vm.pagingData.totalCount > vm.maxCount ? vm.maxCount : vm.pagingData.totalCount\" max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div><div class=hidden-print><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px\" ng-click=vm.printDocuments() ng-disabled=\"vm.printOnce || !vm.isAnyPrintMarked \">{{\'common.actions.printMarked\' | translate}}</button></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --><!-- /.panel -->");
$templateCache.put("app/components/templates/template.html","<div class=template-view><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=\"panel-heading hidden-print\">Szablon</div><div class=panel-body><div class=row><table class=\"table table-striped\"><tbody><tr><th scope=row>Typ</th><td><ui-select ng-model=vm.currentTemplate.Type theme=bootstrap style=\"width: 50%\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat=\"key.Value as key in vm.templateTypes | filter: $select.search\"><div ng-bind-html=\"key.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></td></tr><tr><th scope=row style=\"vertical-align: middle\">Tytuł</th><td><div class=form-group><input type=text class=form-control ng-model=vm.currentTemplate.Title style=\"width: 50%\"></div></td></tr><tr><th scope=row style=\"vertical-align: middle\">Nazwa</th><td><div class=form-group><input type=text class=form-control ng-model=vm.currentTemplate.Name style=\"width: 50%\"></div></td></tr><tr><th scope=row style=\"vertical-align: middle\">Kontrahent</th><td><div class=form-group><div style=\"width: 50%\"><div ng-if=vm.contractorObject style=\"float: left\">{{vm.contractorObject.Name}}</div><button type=button class=\"btn btn-default btn-xs\" style=\"float: right\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></td></tr><tr><th scope=row style=\"vertical-align: middle\">Dokument</th><td><div class=form-group><div style=\"width: 50%\"><div ng-if=vm.documentObject style=\"float: left\">{{vm.documentObject.DocumentNumberFull}}</div><button type=button class=\"btn btn-default btn-xs\" style=\"float: right\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-disabled=!vm.contractorObject ng-click=vm.selectDocument()><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></td></tr></tbody></table><span class=xml-label>Zawartość XML</span><div ui-ace ng-model=vm.currentTemplate.Content ng-change=\"vm.isTemplateModified = true\" style=\"margin-bottom: 20px\"></div><span class=xml-label>Wygenerowana zawartość</span><div ui-ace=\"{onLoad: vm.aceLoaded}\" ng-model=vm.currentTemplate.RenderedTemplate></div><button class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit() style=\"margin-left: 5px\">Zapisz</button> <button class=\"btn btn-primary btn-submit pull-right\" ng-class=\"{\'danger-color\': vm.isTemplateModified}\" ng-click=vm.validateTemplate()>Sprawdź</button></div></div></div></div></div>");
$templateCache.put("app/components/templates/templates.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Szablony</div><div class=panel-body><div><div class=row><div class=col-sm-3><label>Typ</label><ui-select ng-model=vm.pagingData.type theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.templateTypes | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 30%\">Nazwa</th><th class=uiGridHeader style=\"width: 40%\">Tytuł</th><th class=uiGridHeader style=\"width: 20%\">Typ</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name></span></th><th><span ng-bind=key.Title></span></th><td><span ng-bind=key.TypeName></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ui-sref=\"home.templates.template({id: key.Id})\" class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeTemplate(key)><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-8><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div><div style=\"overflow-y: hidden; display: flex; flex-direction: column\"><button class=\"btn btn-primary btn-submit\" style=\"margin-left: auto\" ng-click=vm.goToAddTemplate()>Dodaj szablon</button></div></div></div></div></div></div>");
$templateCache.put("app/components/tasks/task.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Cel dla użytkownika: <span ng-if=vm.viewData.Owner>{{vm.viewData.Owner.Name + \" \" + vm.viewData.Owner.SurName + \" (\" + vm.viewData.Owner.EMail + \")\"}}</span></div><div class=panel-body><div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><form name=vm.form><table class=\"table table-striped\"><tbody><tr><th scope=row style=\"vertical-align: middle\">Nazwa</th><td><div class=form-group ng-class=\"{\'has-error\' : !vm.form.taskName.$valid}\"><!--<label class=\"control-label\" for=\"inputError1\">Input with error</label>--> <input ng-model=vm.viewData.Name maxlength=45 min=3 max=45 class=form-control name=taskName required ng-disabled=\"vm.viewData.ParentTaskId > 0\"></div></td></tr><tr><th scope=row>Obowiązuje od</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateFrom.$valid}\"><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.viewData.BeginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-disabled=\"vm.viewData.ParentTaskId > 0\" ng-model=vm.viewData.BeginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFrom> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\" ng-disabled=\"vm.viewData.ParentTaskId > 0\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr><th scope=row>Obowiązuje do</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateTo.$valid}\"><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.viewData.EndDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-disabled=\"vm.viewData.ParentTaskId > 0 \" ng-model=vm.viewData.EndDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateTo> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\" ng-disabled=\"vm.viewData.ParentTaskId > 0\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr><th scope=row>Typ</th><td><div class=form-group ng-class=\"{ \'has-error\': vm.form.customType.$invalid }\"><ui-select ng-model=vm.viewData.CustomTypeId theme=bootstrap name=customType ng-required=true ng-disabled=\"vm.viewData.ParentTaskId > 0\"><ui-select-match placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.taskTypes | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td></tr><tr><th scope=row>Ilość kontrahentów</th><td><span ng-bind=\"vm.viewData.ContextData1.length \"></span></td></tr><tr><th scope=row>Ilość grup kontrahentów</th><td><span ng-bind=\"vm.viewData.ContextData2.length \"></span></td></tr><tr><th scope=row>Ilość produktów</th><td><span ng-bind=\"vm.viewData.TaskEntities.length \"></span></td></tr></tbody></table></form></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Kontrahenci</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 25%\">Symbol</th><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.viewData.TaskEntities | filter:{ Type: 3 }\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=key.ContextObject.Symbol></span></th><td><span ng-bind=\"key.ContextObject.Name \" uib-popover={{key.ContextObject.Name}} popover-trigger=mouseenter></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=3><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractor() ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Grupy kontrahentów</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader style=\"width: 10%; min-width: 30px\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.viewData.TaskEntities | filter:{ Type: 4}\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.ContextObject.Name \"></span></th><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=2 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractorGroup() ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-12 col-md-8\"><div class=\"panel panel-default\"><div class=panel-heading>Użytkownicy</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 20%\">Imię</th><th class=uiGridHeader>Nazwisko</th><th class=uiGridHeader>Stanowisko</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.viewData.Employees\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.Name \"></span></th><td><span ng-bind=\"key.SurName \"></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'JobTitleDictionary\', key.JobTitleId).Value | translate\"></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeUser(key) ng-if=vm.allowPropagate()><span class=\"glyphicon glyphicon-remove\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Propaguj popover-trigger=mouseenter popover-append-to-body=true ng-if=\"key.Task.Id > 0 && vm.allowPropagate()\"><span class=\"glyphicon glyphicon-indent-left\" ui-sref=\"home.tasks.task({id: key.Task.Id})\"></span></button></td></tr><tr><td colspan=4><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectUser() ng-if=vm.allowPropagate()><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div></div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 35%\">Nazwa produktu</th><th class=uiGridHeader style=\"width: 30%\">Wykonano</th><th class=uiGridHeader style=\"width: 10%\">Wartość celu</th><th class=uiGridHeader style=\"width: 10%\">Typ</th><th class=uiGridHeader style=\"width: 12%\">Marka</th><th class=uiGridHeader style=\"width: 13%\">Min. cena</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat-start=\"key in vm.viewData.TaskEntities  | filter:{ Type: 1 }\"><th style=\"vertical-align: middle\"><span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.ErrorText}} ng-show=!vm.isEntityValid(key) style=\"margin-left: 5px; font-size: 1.3em\"></span> <span ng-bind=key.ContextObject.Name></span></th><td><uib-progressbar animate=false max=100 value=vm.getProgress(key) type=\"{{vm.getProgress(key) < 33? \'danger\' : (vm.getProgress(key) < 100? \'warning\' : \'success\')}}\"><b>Wykonano:{{vm.getProgress(key) | number:0}}% ({{key.CurrentAmount}})</b></uib-progressbar></td><td><input type=number min=1 step=1 ng-model=key.TotalAmount class=form-control ng-disabled=\"vm.viewData.ParentTaskId > 0\"></td><td style=\"overflow:visible !important\"><ui-select ng-model=key.MeasureUnit theme=bootstrap on-select=vm.updateUnit(key) ng-disabled=\"vm.viewData.ParentTaskId > 0\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.TaskUnitDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><!-- marka --><td style=\"overflow:visible !important\"><ui-select ng-model=key.ManufacturerId theme=bootstrap><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ManufacturerDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><td><div class=input-group><input type=number min=0 step=0.01 ng-model=key.Param1 class=form-control placeholder=0.00 ng-change=vm.updatePrice(key) ng-disabled=\"vm.viewData.ParentTaskId > 0\"> <span class=input-group-btn uib-dropdown dropdown-append-to-body><button class=\"btn btn-default\" type=button uib-dropdown-toggle ng-disabled=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-menu-down\"></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-repeat=\"keyy in vm.dictionaryData[\'PriceLevel\']\"><a ng-click=\"vm.updatePrice(key, key.ContextObject[\'AmountNet\' + ($index + 1)])\">{{keyy.Value }} : <span class=pull-right>{{key.ContextObject[\'AmountNet\' + ($index + 1)]}} PLN</span></a></li></ul></span></div><!-- /input-group --></td><td><button type=button class=\"btn btn-default btn-xs\" aria-label=\"Left Align\" ng-click=\"key.isCollapsed = !key.isCollapsed\" ng-disabled=\"key.ChildEntities.length < 1\"><span class=glyphicon ng-class=\"{\'glyphicon-menu-down\' : key.isCollapsed, \'glyphicon-menu-up\' : !key.isCollapsed}\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Rozdziel równo\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.divideEntity(key) ng-disabled=\"key.ChildEntities.length < 1\" ng-if=vm.allowPropagate()><span class=\"glyphicon glyphicon-sort-by-attributes\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr ng-repeat-end ng-repeat=\"keyy in key.ChildEntities\" uib-collapse=key.isCollapsed><td><span class=\"glyphicon glyphicon-user\" aria-hidden=true></span> <span ng-bind=\"keyy.ParentT.Owner.Name + \' \' + keyy.ParentT.Owner.SurName\"></span></td><td><uib-progressbar animate=false max=100 value=vm.getProgress(keyy) type=\"{{vm.getProgress(keyy) < 33? \'danger\' : vm.getProgress(keyy) < 100? \'warning\' : \'success\'}}\"><b>Wykonano:{{vm.getProgress(keyy) | number:0}}% ({{keyy.CurrentAmount}})</b></uib-progressbar></td><td><input type=number ng-model=keyy.TotalAmount class=form-control></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'TaskUnitDictionary\',keyy.MeasureUnit).Value\"></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'ManufacturerDictionary\',keyy.ManufacturerId).Value\"></span></td><td><span ng-bind=keyy.Param1></span></td><td></td></tr><td colspan=7><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectProduct() ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tbody></table><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 40%\">Nazwa grupy</th><th class=uiGridHeader style=\"width: 30%\">Wykonano</th><th class=uiGridHeader style=\"width: 10%\">Wartość celu</th><th class=uiGridHeader style=\"width: 10%\">Typ</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat-start=\"key in vm.viewData.TaskEntities | filter:{ Type: 2 }\"><th style=\"vertical-align: middle\"><span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.ErrorText}} ng-show=!vm.isEntityValid(key) style=\"margin-left: 5px; font-size: 1.3em\"></span> <span ng-bind=key.ContextObject.Name></span></th><td><uib-progressbar animate=false max=100 value=vm.getProgress(key) type=\"{{vm.getProgress(key) < 33? \'danger\' : (vm.getProgress(key) < 100? \'warning\' : \'success\')}}\"><b>Wykonano:{{vm.getProgress(key) | number:0}}% ({{key.CurrentAmount}})</b></uib-progressbar></td><td><input type=number min=1 step=1 ng-model=key.TotalAmount class=form-control ng-disabled=\"vm.viewData.ParentTaskId > 0\"></td><td style=\"overflow:visible !important\"><ui-select ng-model=key.MeasureUnit theme=bootstrap on-select=vm.updateUnit(key) ng-disabled=\"vm.viewData.ParentTaskId > 0\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.TaskUnitDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><td><button type=button class=\"btn btn-default btn-xs\" aria-label=\"Left Align\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><span class=glyphicon ng-class=\"{\'glyphicon-menu-down\' : key.isCollapsed, \'glyphicon-menu-up\' : !key.isCollapsed}\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Rozdziel równo\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.divideEntity(key) ng-disabled=\"key.ChildEntities.length < 1\"><span class=\"glyphicon glyphicon-sort-by-attributes\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr ng-repeat-end ng-repeat=\"keyy in key.ChildEntities\" uib-collapse=key.isCollapsed><td><span class=\"glyphicon glyphicon-user\" aria-hidden=true></span> <span ng-bind=\"keyy.ParentT.Owner.Name + \' \' + keyy.ParentT.Owner.SurName\"></span></td><td><uib-progressbar animate=false max=100 value=vm.getProgress(keyy) type=\"{{vm.getProgress(keyy) < 33? \'danger\' : vm.getProgress(keyy) < 100? \'warning\' : \'success\'}}\"><b>Wykonano:{{vm.getProgress(keyy) | number:0}}% ({{keyy.CurrentAmount}})</b></uib-progressbar></td><td><input type=number ng-model=keyy.TotalAmount class=form-control></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'TaskUnitDictionary\',keyy.MeasureUnit).Value\"></span></td><td></td></tr><tr><td colspan=5 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectProductGroup() ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><!-- \r\n          **************************** MIXY ****************************\r\n        **************************** \r\n      --><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 40%\">Nazwa produktu (MIX)</th><th class=uiGridHeader style=\"width: 30%\">Wykonano</th><th class=uiGridHeader style=\"width: 10%\">Wartość celu</th><th class=uiGridHeader style=\"width: 10%\">Typ</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat-start=\"key in vm.viewData.TaskEntities | filter:{ Type: 6 }\"><th style=\"vertical-align: middle\"><span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.ErrorText}} ng-show=!vm.isEntityValid(key) style=\"margin-left: 5px; font-size: 1.3em\"></span> <span>**** MIX ****</span></th><td><uib-progressbar animate=false max=100 value=vm.getProgress(key) type=\"{{vm.getProgress(key) < 33? \'danger\' : (vm.getProgress(key) < 100? \'warning\' : \'success\')}}\"><b>Wykonano: {{vm.getProgress(key) | number:0}}% ({{key.CurrentAmount}})</b></uib-progressbar></td><td><input type=number min=1 step=1 ng-model=key.TotalAmount class=form-control ng-disabled=\"vm.viewData.ParentTaskId > 0\"></td><td style=\"overflow:visible !important\"><ui-select ng-model=key.MeasureUnit theme=bootstrap on-select=vm.updateUnit(key) ng-disabled=\"vm.viewData.ParentTaskId > 0\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.TaskUnitDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><td><button type=button class=\"btn btn-default btn-xs\" aria-label=\"Left Align\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><span class=glyphicon ng-class=\"{\'glyphicon-menu-down\' : key.isCollapsed, \'glyphicon-menu-up\' : !key.isCollapsed}\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" aria-label=\"Left Align\" ng-click=vm.addProductToMix(key) ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=\"Rozdziel równo\" popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.divideEntity(key) ng-disabled=\"key.ChildEntities.length < 1\"><span class=\"glyphicon glyphicon-sort-by-attributes\"></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr ng-repeat-end ng-repeat-start=\"keyy in key.ChildEntities\" uib-collapse=key.isCollapsed ng-class=\"{\'warning\' : keyy.Type === 1}\"><td ng-if=\"keyy.Type == 6\"><span class=\"glyphicon glyphicon-user\" aria-hidden=true></span> <span ng-bind=\"keyy.ParentT.Owner.Name + \' \' + keyy.ParentT.Owner.SurName + \' \' + keyy.Type\"></span></td><td ng-if=\"keyy.Type == 1\" colspan=5><span class=\"glyphicon glyphicon-apple\" aria-hidden=true></span> <span ng-bind=\"keyy.ContextObject.Name + \' \' + keyy.Type\"></span> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeProductFromMix(keyy) ng-if=vm.allowPropagate()><span class=\"glyphicon glyphicon-remove\"></span></button></td><td ng-if=\"keyy.Type == 6\"><uib-progressbar animate=false max=100 value=vm.getProgress(keyy) type=\"{{vm.getProgress(keyy) < 33? \'danger\' : vm.getProgress(keyy) < 100? \'warning\' : \'success\'}}\"><b>Wykonano: {{vm.getProgress(keyy) | number:0}}% ({{keyy.CurrentAmount}})</b></uib-progressbar></td><td ng-if=\"keyy.Type == 6\"><input type=number ng-model=keyy.TotalAmount class=form-control></td><td ng-if=\"keyy.Type == 6\"><span ng-bind=\"vm.getDictionaryElementByType(\'TaskUnitDictionary\',keyy.MeasureUnit).Value\"></span></td><td ng-if=\"keyy.Type == 6\"></td></tr><tr ng-repeat-end ng-show=(keyy.ParentEntity.isCollapsed)><td colspan=5 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.addNewMix() ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr><tr><td colspan=5 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.addNewMix() ng-hide=\"vm.viewData.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>{{\'common.actions.goBack\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit(vm.data) ng-disabled=!vm.isTaskValid()>{{\'common.form.confirm\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/tasks/taskType.modal.html","<div class=modal-header><h3 class=modal-title>Wybierz cel</h3></div><div class=\"modal-body overflow-body\"><div class=tile><button class=\"btn tile-button\" ng-click=vm.action(1)><i class=\"fa fa-user\" aria-hidden=true></i></button><div class=tile-text>Użytkownik</div></div><div class=tile><button class=\"btn tile-button\" ng-click=vm.action(2)><i class=\"fa fa-briefcase\" aria-hidden=true></i></button><div class=tile-text>Kontrahent</div></div><div class=tile><button class=\"btn tile-button\" ng-click=vm.action(3)><i class=\"fa fa-archive\" aria-hidden=true></i></button><div class=tile-text>Produkt</div></div></div>");
$templateCache.put("app/components/tasks/tasks.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Cele</div><div class=panel-body><div><div><div class=row><div class=col-sm-3><label class=control-label>{{\'tasks.search.name\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange() id=DocumentSearchBox name=DocumentSearchBox> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'tasks.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'tasks.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'tasks.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.customTypeId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.TaskProductTypeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'tasks.search.status\' | translate}}</label><ui-select ng-model=vm.pagingData.status theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.TaskProductStatusDictionary  | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'tasks.search.user\' | translate}}</label><ui-select ng-model=vm.pagingData.selectedUserId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 33%\">Nazwa celu</th><th class=uiGridHeader style=\"width: 23%\">Procent wykonania</th><th class=uiGridHeader style=\"width: 14%\">Typ</th><th class=uiGridHeader style=\"width: 10%\">Data rozpoczęcia</th><th class=uiGridHeader style=\"width: 10%\">Data zakończenia</th><th class=uiGridHeader style=\"width: 10%\">Akcje</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.Name></span></th><td><div class=progress><uib-progressbar animate=false max=100 value=key.viewProgress type={{key.progressType}}><b>{{key.fillText}}</b></uib-progressbar></div></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'TaskProductTypeDictionary\',key.CustomTypeId).Value | translate\"></span></td><td><span ng-bind=\"key.BeginDate | date:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"key.EndDate |  date:\'yyyy-MM-dd\'\"></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ng-click=vm.goToElement(key) class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeTask(key.Id) ng-if=vm.allowRemove()><!--ng-disabled=\"vm.isTaskStarted(key)\"--> <span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></button> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.ErrorText}} ng-show=!vm.isTaskValid(key) style=\"position: absolute; margin-left: 5px; font-size: 1.3em\"></span></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div><div style=\"overflow-y: hidden; display: flex; flex-direction: column\"><span class=pull-right style=\"margin-bottom: 5px; margin-left: auto\">Rekordów:{{vm.pagingData.totalCount}}</span> <button class=\"btn btn-primary btn-submit\" style=\"margin-left: auto\" ng-if=vm.checkPermission(9) ng-click=vm.openTaskCreationModal()>Dodaj cel</button></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/tasks/userTask.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Cel dla użytkownika: <span ng-if=vm.data.Owner>{{vm.data.Owner.Name + \" \" + vm.data.Owner.SurName + \" (\" + vm.data.Owner.EMail + \")\"}}</span></div><div class=panel-body><div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><form name=vm.form><table class=\"table table-striped\"><tbody><tr><th scope=row style=\"vertical-align: middle\">Nazwa</th><td><div class=form-group ng-class=\"{\'has-error\' : !vm.form.taskName.$valid}\"><!--<label class=\"control-label\" for=\"inputError1\">Input with error</label>--> <input ng-model=vm.data.Name maxlength=45 min=3 max=45 class=form-control name=taskName required ng-disabled=\"vm.data.ParentTaskId > 0\"></div></td></tr><tr><th scope=row>Obowiązuje od</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateFrom.$valid}\"><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.data.BeginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-disabled=\"vm.data.ParentTaskId > 0\" ng-model=vm.data.BeginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFrom> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\" ng-disabled=\"vm.data.ParentTaskId > 0\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr><th scope=row>Obowiązuje do</th><td><p class=input-group ng-class=\"{\'has-error\' : !vm.form.dateTo.$valid}\"><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.data.EndDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-disabled=\"vm.data.ParentTaskId > 0 \" ng-model=vm.data.EndDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateTo> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\" ng-disabled=\"vm.data.ParentTaskId > 0\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></td></tr><tr><th scope=row>Typ</th><td><div class=form-group ng-class=\"{ \'has-error\': vm.form.customType.$invalid }\"><ui-select ng-model=vm.data.CustomTypeId theme=bootstrap name=customType ng-required=true on-select=\"vm.onSelectType($item, $model)\" ng-disabled=\"vm.data.Id > 0\"><ui-select-match placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.taskTypes   | filter: $select.search\"><div ng-bind-html=\"value.Value | translate | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td></tr></tbody></table></form></div></div></div><div class=\"col-sm-12 col-md-8\" ng-if=\"vm.data.CustomTypeId === 7\"><div class=\"panel panel-default\"><div class=panel-heading>Kontrahenci</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 25%\">Symbol</th><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader>Aktualne wykonanie</th><th class=uiGridHeader>Wartość</th><th class=uiGridHeader>Marka</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.TaskEntities | filter:{ Type: 3 }\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.ContextObject.Symbol \"></span></th><td><span ng-bind=\"key.ContextObject.Name \" uib-popover={{key.ContextObject.Name}} popover-trigger=mouseenter></span></td><td><span ng-bind=\"key.CurrentAmount | number:2 \"></span></td><td><input type=number min=1 step=1 ng-model=key.TotalAmount class=form-control ng-disabled=\"vm.data.ParentTaskId > 0\"></td><td style=\"overflow:visible !important\"><ui-select ng-model=key.ManufacturerId theme=bootstrap><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ManufacturerDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.data.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=6><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractor() ng-hide=\"vm.data.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-12 col-md-8\" ng-if=\"vm.data.CustomTypeId === 7\"><div class=\"panel panel-default\"><div class=panel-heading>Grupy kontrahentów</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>Nazwa</th><th class=uiGridHeader>Aktualne wykonanie</th><th class=uiGridHeader>Wartość</th><th class=uiGridHeader>Marka</th><th class=uiGridHeader style=\"width: 10%; min-width: 30px\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.TaskEntities | filter:{ Type: 4 }\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=key.ContextObject.Name></span></th><td><span ng-bind=\"key.CurrentAmount | number:2 \"></span></td><td><input type=number min=1 step=1 ng-model=key.TotalAmount class=form-control ng-disabled=\"vm.data.ParentTaskId > 0\"></td><td style=\"overflow:visible !important\"><ui-select ng-model=key.ManufacturerId theme=bootstrap><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ManufacturerDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeEntity(key) ng-hide=\"vm.data.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=5 style=\"overflow:visible !important\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractorGroup() ng-hide=\"vm.data.ParentTaskId > 0\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div><div class=\"col-sm-12 col-md-8\" ng-if=\"vm.data.CustomTypeId === 6\"><div class=\"panel panel-default\"><div class=panel-heading>Użytkownicy</div><div class=panel-body><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader style=\"width: 20%\">Imię</th><th class=uiGridHeader>Nazwisko</th><th class=uiGridHeader>Stanowisko</th><th class=uiGridHeader>Aktualne wykonanie</th><th class=uiGridHeader>Wartość</th><th class=uiGridHeader>Marka</th><th class=uiGridHeader style=\"width: 10%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.ChildTasks\"><th scope=row style=\"overflow:visible !important\"><span ng-bind=\"key.Owner.Name \"></span></th><td><span ng-bind=\"key.Owner.SurName \"></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'JobTitleDictionary\', key.Owner.JobTitleId).Value | translate\"></span></td><td><span ng-bind=\"key.CurrentAmount | number:2 \"></span></td><td><input type=number min=1 step=1 ng-model=key.TotalAmount class=form-control ng-disabled=\"vm.data.ParentTaskId > 0\"></td><td style=\"overflow:visible !important\"><ui-select ng-model=key.ManufacturerId theme=bootstrap><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.ManufacturerDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeUser(key) ng-if=vm.allowPropagate()><span class=\"glyphicon glyphicon-remove\"></span></button><!--<button type=\"button\" class=\"btn btn-default btn-xs\"--><!--uib-popover=\"Propaguj\" popover-trigger=\"mouseenter\"--><!--popover-append-to-body=\"true\" ng-if=\"key.Task.Id > 0 && vm.allowPropagate()\">--><!--<span class=\"glyphicon glyphicon-indent-left\"--><!--ui-sref=\"home.tasks.task({id: key.Task.Id})\"></span></button>--></td></tr><tr><td colspan=7><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectUser() ng-if=vm.allowPropagate()><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></div></div></div></div><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>Wróć</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.submit(vm.data) ng-disabled=!vm.isTaskValid()>Zapisz</button></div></div></div></div>");
$templateCache.put("app/components/test/imgUpload.html","<div>{{vm.progress}} <button ng-disabled=vm.uploading type=button class=\"btn btn-default btn-lg\" ngf-select=\"vm.onFileSelect($file, $invalidFiles)\" ngf-max-size=5MB><span class=\"glyphicon glyphicon-upload\" aria-hidden=true></span> Wyślij plik</button></div>");
$templateCache.put("app/components/users/user.html","<div class=\"panel panel-default panel-table\"><div class=panel-heading>Użytkownik: {{vm.viewUser.Name + \' \' + vm.viewUser.SurName}}</div><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Dane podstawowe</div><div class=panel-body><formly-form model=vm.viewUser fields=vm.userFields form=vm.userForm><div class=row><div class=col-md-6><label class=control-label>{{\'users.user.label.employmentFrom\' | translate}}</label><p class=input-group><input datepicker-localdate type=text class=\"form-control ui-datepicker\" uib-datepicker-popup ng-model=vm.viewUser.EmploymentDateBegin is-open=vm.datePickerBeginOpened datepicker-options=vm.dateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event,  1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-md-6><label class=control-label>{{\'users.user.label.employmentTo\' | translate}}</label><p class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.viewUser.EmploymentDateEnd is-open=vm.datePickerEndOpened datepicker-options=vm.dateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div><label class=control-label>{{\'users.user.label.storage\' | translate}}</label><ui-select ng-model=vm.viewUser.Storage theme=bootstrap><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:36}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'users.user.label.jobTitle\' | translate}}</label><ui-select ng-model=vm.viewUser.JobTitleId theme=bootstrap on-select=\"vm.jobTitleSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Value | translate | truncate:15}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.JobTitleDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value |translate | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div><label class=control-label>{{\'users.user.label.superior\' | translate}}</label><ui-select ng-model=vm.viewUser.superiorId theme=bootstrap select-reset-model><ui-select-match data-allow-clear=true placeholder=Brak>{{vm.getUserSelectText($select.selected) | truncate:36}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.users | filter: $select.search\"><div ng-bind-html=\"vm.getUserSelectText(value) | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div><label class=control-label>{{\'users.user.label.mobile\' | translate}}</label><ui-select ng-model=vm.viewUser.AllowMobile theme=bootstrap><ui-select-match>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.TrueFalseDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><!-- /uiselect--><div ng-show=vm.isError class=\"alert alert-danger alert-dismissible alert-login\" role=alert>{{vm.error}}</div></formly-form></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Uprawnienia</div><div class=panel-body><h5>{{\'users.user.roles\' | translate}}</h5><ul class=list-group><li class=list-group-item ng-repeat=\"role in vm.userRoles\"><div class=col-md-8><span ng-show=\"role.GroupDef.Description == undefined || role.GroupDef.Description.length < 1\">{{role.GroupDef.Name}}</span> <span ng-show=\"role.GroupDef.Description && role.GroupDef.Description.length > 0\">{{role.GroupDef.Name}} - {{role.GroupDef.Description}}</span></div><button type=button class=\"btn btn-default\" ng-click=vm.removeRoleFromUser(role)><!--<span class=\"glyphicon glyphicon-remove\" ng-class=\"\"></span>--> {{\'users.user.removeRole\' | translate}}</button></li><li class=\"list-group-item disabled\" ng-hide=\"vm.rolesToAdd.length < 1\"></li><li class=list-group-item><form name=addRole ng-hide=\"vm.rolesToAdd.length < 1\"><label for=roleSelect>Dodaj nową role:</label><select name=roleSelect class=form-control id=roleSelect ng-options=\"option.Name for option in vm.rolesToAdd track by option.Id\" ng-model=vm.role></select><button type=submit class=\"btn btn-default btn-submit\" ng-click=vm.addRoleToUser(vm.role)><!--<span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"> {{\'users.user.addRole\' | translate}} </span>--> {{\'users.user.addRole\' | translate}}</button></form></li></ul></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Kontakt telefoniczny</div><div class=panel-body><label>{{\'contractors.contractor.label.phones\' | translate}}</label><form name=vm.phoneForm><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>Typ:</th><th class=uiGridHeader>Numer:</th><th class=uiGridHeader style=\"width: 15%\"></th></tr></thead><tbody><tr ng-repeat=\"key in vm.phoneAttributes.Attributes\"><th scope=row style=\"overflow:visible !important\"><ui-select ng-model=key.DictionaryLocalId><ui-select-match placeholder=Brak>{{$select.selected.Value | translate | truncate:15}}</ui-select-match><ui-select-choices repeat=\"choice.LocalId as choice in vm.dictionaryData.UserPhoneTypeDictionary | filter: $select.search\"><div ng-bind-html=\"choice.Value |translate | highlight: $select.search\"></div></ui-select-choices></ui-select></th><td><div class=form-group ng-class=\"{\'has-error\' : !phoneFieldForm.phone.$valid}\"><ng-form name=phoneFieldForm><input name=phone ng-model=key.ValueStr maxlength=15 min=6 max=15 minlength=6 class=form-control required></ng-form></div></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Usuń popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.removeAttribute(key)><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr><tr><td colspan=3><button type=button class=\"btn btn-default btn-xs\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=\"vm.addAttribute(1, vm.contractor.Id, 1, undefined, 1)\"><span class=\"glyphicon glyphicon-plus\"></span></button></td></tr></tbody></table></form></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Kategorie dokumentów</div><div class=panel-body><div><label class=control-label>{{\'contractors.contractor.label.orderDocumentCategory\' | translate}}</label><!--<ui-select ng-model=\"vm.viewUser.OrderDocumentCategory\">\r\n                <ui-select-match data-allow-clear=\"true\" placeholder=\"Brak\">{{$select.selected.Value | truncate:36}}\r\n                </ui-select-match>\r\n                <ui-select-choices refresh-delay=\"500\"\r\n                  repeat=\"choice.LocalId as choice in vm.dictionaryData.DocumentCategoryDictionary | filter: $select.search\">\r\n                  <div ng-bind-html=\"choice.Value | highlight: $select.search\"></div>\r\n                </ui-select-choices>\r\n              </ui-select>--><ui-select ng-model=vm.viewUser.OrderDocumentCategory><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices refresh-delay=300 minimum-input-length=3 repeat=\"choice.LocalId as choice in vm.dictionaryData.DocumentCategoryDictionary | filter: $select.search\"><div ng-bind-html=choice.Value></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.returnDocumentCategory\' | translate}}</label><ui-select ng-model=vm.viewUser.ReturnDocumentCategory><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices refresh-delay=300 minimum-input-length=3 repeat=\"choice.LocalId as choice in vm.dictionaryData.DocumentCategoryDictionary | filter: $select.search\"><div ng-bind-html=choice.Value></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div><label class=control-label>{{\'contractors.contractor.label.qualityReturnDocumentCategory\' | translate}}</label><ui-select ng-model=vm.viewUser.QualityReturnDocumentCategory><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | truncate:36}}</ui-select-match><ui-select-choices refresh-delay=300 minimum-input-length=3 repeat=\"choice.LocalId as choice in vm.dictionaryData.DocumentCategoryDictionary | filter: $select.search\"><div ng-bind-html=choice.Value></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>System dokumentów</div><div class=panel-body><div><button class=\"btn btn-default btn-submit\" ng-click=vm.addUserToDocumentSystem(vm.user.Id) ng-hide=vm.user.DocumentSystemid>Aktywuj użytkownika</button><div>Użytkownik zarejestrowany, identyfikator: <span ng-bind=vm.user.DocumentSystemid ng-show=vm.user.DocumentSystemid></span></div></div></div></div></div></div></div><div><button type=submit class=\"btn btn-default btn-submit pull-right\" ng-click=vm.submit(vm.user) ng-disabled=!vm.phoneForm.$valid>{{\'common.form.confirm\' | translate}}</button></div></div>");
$templateCache.put("app/components/users/user.register.html","<div class=\"panel panel-default panel-table\"><div class=panel-heading>Użytkownik: {{vm.user.Name + \' \' + vm.user.SurName}}</div><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Resetuj hasło</div><div class=panel-body><formly-form model=vm.registerObj fields=vm.userFields form=vm.userForm><br><div ng-show=vm.isError class=\"alert alert-danger alert-dismissible\" role=alert>{{vm.error}}</div></formly-form></div></div></div></div><div><button type=submit class=\"btn btn-default btn-submit pull-right\" ng-click=vm.submit(vm.register)>{{vm.getButtonText()}}</button></div></div></div>");
$templateCache.put("app/components/users/users.html","<div><!--<div class=\"jumbotron alert alert-info\" ng-show=\"vm.isLoading\">--><!--<h2>Trwa ładowanie zawartości strony</h2>--><!--<br><br>--><!--<hr>--><!--<br><br>--><!--<h3><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Pamiętaj o wylogowaniu po zakończeniu pracy.</h3>--><!--</div>--><div class=\"panel panel-default panel-table\"><div class=panel-heading>Użytkownicy</div><!-- /.panel-heading --><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'common.grid.searchBox\' | translate}}</label><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange()> <span class=\"glyphicon glyphicon-search form-control-feedback\" style=\"margin-right: 18px\" ng-click=vm.onFilterChange()></span></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'users.search.active\' | translate}}</label><ui-select ng-model=vm.pagingData.isActive theme=bootstrap on-select=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.ActiveDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'users.search.jobTitle\' | translate}}</label><ui-select ng-model=vm.pagingData.jobTitleId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.JobTitleDictionary  |filter: $select.search\"><div ng-bind-html=\"value.Value |translate | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'users.search.storage\' | translate}}</label><ui-select ng-model=vm.pagingData.storage theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | translate}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages  |filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'users.search.superior\' | translate}}</label><ui-select ng-model=vm.pagingData.superiorId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name + \' \' + $select.selected.Name | translate}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Superiors  |filter: $select.search\"><div ng-bind-html=\"value.Name + \' \' + value.SurName | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div><div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 15%\">{{\'headers.users.name\' | translate}}</th><th class=uiGridHeader style=\"width: 15%\">{{\'headers.users.surname\' | translate}}</th><th class=uiGridHeader style=\"width: 20%\">{{\'headers.users.storage\' | translate}}</th><th class=uiGridHeader style=\"width: 20%\">{{\'headers.users.jobTitle\' | translate}}</th><th class=uiGridHeader style=\"width: 20%\">{{\'headers.users.email\' | translate}}</th><!--<th class=\"uiGridHeader rowAction\">{{\'users.user.superior\' | translate}}</th>--><th class=uiGridHeader style=\"width: 10%\">{{\'headers.users.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.users\"><td><span ng-bind=key.Name></span></td><td><span ng-bind=key.SurName></span></td><td><span ng-bind=vm.getStrorageById(key.Storage).Name></span></td><td><span ng-bind=\"vm.getDictionaryElementByType(\'JobTitleDictionary\',key.JobTitleId).Value | translate\"></span></td><td><span ng-bind=key.EMail></span></td><td><button type=button class=\"btn btn-default btn-xs\" ui-sref=\"home.users.user({id: key.Id})\" uib-popover=Edytuj popover-trigger=mouseenter><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span></button> <button ng-disabled=!vm.checkPermission(3) type=button class=\"btn btn-default btn-xs\" ng-click=vm.goToRegPass(key) uib-popover=\"{{key.AccountId === null? \'Zarejestruj\': \'Zmień hasło\'}}\" popover-trigger=mouseenter><span class=glyphicon ng-class=\"{\'text-muted\': !vm.checkPermission(3), \'glyphicon-user\': !(key.AccountId !== null), \'glyphicon-cog\': key.AccountId !== null}\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" ng-click=vm.togleActiveFlag(key) uib-popover=\"{{key.IsActive ? \'Zablokuj\': \'Odblokuj\'}}\" popover-trigger=mouseenter ng-diabled=\"key.disableChangeStatusButton === true\"><span class=glyphicon ng-class=\"{\'glyphicon-remove\': !key.IsActive, \'glyphicon-ok\': key.IsActive}\"></span></button></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isLoading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div></div><!-- /.table-responsive --></div><!-- /.panel-body --></div><!-- /.panel --></div>");
$templateCache.put("app/components/users/usersSelect.html","<div><!--<div class=\"jumbotron alert alert-info\" ng-show=\"vm.isLoading\">--><!--<h2>Trwa ładowanie zawartości strony</h2>--><!--<br><br>--><!--<hr>--><!--<br><br>--><!--<h3><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Pamiętaj o wylogowaniu po zakończeniu pracy.</h3>--><!--</div>--><div class=\"panel panel-default panel-table\"><div class=panel-heading>Użytkownicy</div><!-- /.panel-heading --><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'common.grid.searchBox\' | translate}}</label><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange()> <span class=\"glyphicon glyphicon-search form-control-feedback\" style=\"margin-right: 18px\" ng-click=vm.onFilterChange()></span></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>{{\'users.search.active\' | translate}}</label><ui-select ng-model=vm.pagingData.isActive theme=bootstrap on-select=\"vm.onSelect($item, $model)\" ng-disabled=\"vm.isActive !== undefined\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.ActiveDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'users.search.jobTitle\' | translate}}</label><ui-select ng-model=vm.pagingData.jobTitleId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\" ng-disabled=\"vm.JobTitleId !== undefined\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Value | translate}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.JobTitleDictionary  |filter: $select.search\"><div ng-bind-html=\"value.Value | translate |highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader rowName\">{{\'headers.users.name\' | translate}}</th><th class=\"uiGridHeader rowSurName\">{{\'headers.users.surname\' | translate}}</th><th class=\"uiGridHeader rowEMail\">{{\'headers.users.email\' | translate}}</th><!--<th class=\"uiGridHeader rowAction\">{{\'users.user.superior\' | translate}}</th>--><th class=\"uiGridHeader rowAction\">{{\'headers.users.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.users\" ng-if=\"key.Id !== vm.notShowingThisUser\"><td><span ng-bind=key.Name></span></td><td><span ng-bind=key.SurName></span></td><td><span ng-bind=key.EMail></span></td><td><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wybierz popover-trigger=mouseenter ng-show=!vm.isAdded(key) popover-append-to-body=true ng-click=vm.selectUser(key)><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isLoading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div></div><!-- /.table-responsive --></div><!-- /.panel-body --></div><!-- /.panel --></div></div>");
$templateCache.put("app/components/visits/changeStorage.modal.html","<div class=col-md-3><div class=\"panel panel-default panel-table\"><div class=panel-heading>Zmień dane</div><!-- /.panel-heading --><div class=panel-body><div><table class=table><tbody><tr><th scope=row style=\"vertical-align: middle; border-top: 0px\">Magazyn</th><td style=\"border-top: 0px\"><ui-select ng-model=vm.document.Storage theme=bootstrap on-select=\"vm.onSelectStorage($item, $model)\"><ui-select-match data-allow-clear=false placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></td></tr><tr><th scope=row>Data wystawienia</th><td><div class=input-group><input datepicker-localdate type=text uib-datepicker-popup ng-required=true class=form-control ng-model=vm.document.DocumentReleaseDate is-open=vm.datePickerReleaseOpened datepicker-options=vm.releaseDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateRelease> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr><tr><th scope=row>Data dostawy</th><td><div class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-required=true ng-model=vm.document.FinishDate is-open=vm.datePickerFinishOpened datepicker-options=vm.dateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść name=dateFinish> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td></tr></tbody></table><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.action(false)>Wróć</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-disabled=\"vm.document.Storage == undefined\" ng-click=vm.action(true)>Zapisz</button></div></div><!-- /.panel-body --></div><!-- /.panel --></div>");
$templateCache.put("app/components/visits/changeStorageConfirm.modal.html","<div class=modal-header><h3 class=modal-title>{{\'changeStorageConfirm.title\' | translate}}</h3></div><div class=\"modal-body overflow-body\"><table class=table><tr><th style=\"border-top: 0px\" class=bolded>{{\'changeStorageConfirm.count\' | translate}}:</th><td style=\"border-top: 0px\">{{vm.data.DocumentIds.length}}</td></tr><tr><th class=bolded>{{\'changeStorageConfirm.storage\' | translate}}:</th><td>{{vm.data.StorageName}}</td></tr><tr><th class=bolded>{{\'changeStorageConfirm.releaseDate\' | translate}}:</th><td>{{vm.data.DocumentReleaseDate | date: \'yyyy-MM-dd\'}}</td></tr><tr><th class=bolded>{{\'changeStorageConfirm.finishDate\' | translate}}:</th><td>{{vm.data.FinishDate | date: \'yyyy-MM-dd\'}}</td></tr></table><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.action(false)>{{\'changeStorageConfirm.cancel\' | translate}}</button> <button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.action(true)>{{\'changeStorageConfirm.confirm\' | translate}}</button></div>");
$templateCache.put("app/components/visits/visit.html","<div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{\'visit.title\' | translate}} {{vm.currentVisit.Date | date: \'dd-MM-yyyy\'}}</div><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.basic.title\' | translate}}</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>{{\'visit.data.basic.user\' | translate}}</th><td><span>{{vm.currentVisit.User.SurName + \" \" + vm.currentVisit.User.Name}}</span></td></tr><tr><th scope=row>{{\'visit.data.basic.date\' | translate}}</th><td><span ng-bind=\"vm.currentVisit.Date | date: \'dd-MM-yyyy\'\"></span></td></tr><tr><th scope=row>{{\'visit.data.basic.route\' | translate}}</th><td><span ng-bind=vm.currentVisit.Route.Name></span></td></tr></tbody></table></div></div><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.note\' | translate}}</div><div class=panel-body><textarea cols=\"\" rows=\"\" class=textarea-style-visit ng-model=vm.currentVisit.Comment></textarea></div><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px; opacity: 1.0\" ng-click=\"vm.comment(vm.currentVisit.Id, vm.currentVisit.Comment)\" id=doc-accept_positions-button>Zapisz komentarz</button></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.contractor\' | translate}}</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Symbol</th><td><span ng-bind=vm.currentVisit.ContractorObject.Symbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.currentVisit.Receiver.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.currentVisit.Receiver.NIP></span></td></tr><tr><th scope=row>Miasto</th><td><span ng-bind=vm.currentVisit.Receiver.City></span></td></tr><tr><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.currentVisit.Receiver.PostalCode></span></td></tr><tr><th scope=row>Ulica</th><td><span ng-bind=vm.currentVisit.Receiver.Street></span></td></tr><tr><th scope=row>Numer budynku</th><td><span ng-bind=vm.currentVisit.Receiver.BuildingNumber></span></td></tr><tr><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\', vm.currentVisit.Receiver.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\', vm.currentVisit.Receiver.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\" ng-if=\"vm.currentVisit.PayerObject != null\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.payer\' | translate}}</div><div class=panel-body><table class=\"table table-striped\"><tbody><tr><th scope=row>Symbol</th><td><span ng-bind=vm.currentVisit.PayerObject.Symbol></span></td></tr><tr><th scope=row>Nazwa</th><td><span ng-bind=vm.currentVisit.PayerObject.DefaultAddress.Name></span></td></tr><tr><th scope=row>NIP</th><td><span ng-bind=vm.currentVisit.PayerObject.DefaultAddress.NIP></span></td></tr><tr><th scope=row>Miasto</th><td><span ng-bind=vm.currentVisit.PayerObject.DefaultAddress.City></span></td></tr><tr><th scope=row>Kod pocztowy</th><td><span ng-bind=vm.currentVisit.PayerObject.DefaultAddress.PostalCode></span></td></tr><tr><th scope=row>Ulica</th><td><span ng-bind=vm.currentVisit.PayerObject.DefaultAddress.Street></span></td></tr><tr><th scope=row>Numer budynku</th><td><span ng-bind=vm.currentVisit.PayerObject.DefaultAddress.BuildingNumber></span></td></tr><tr><th scope=row>Województwo</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'ProvinceDictionary\', vm.currentVisit.PayerObject.DefaultAddress.ProvinceId).Value\"></span></td></tr><tr><th scope=row>Kraj</th><td><span ng-bind=\"vm.getDictionaryElementByType(\'CountryDictionary\', vm.currentVisit.PayerObject.DefaultAddress.CountryId).Value\"></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>Zebrane płatności</div><div class=panel-body><span ng-if=\"vm.currentVisit.Payments.length == 0\">Brak płatności</span><table class=\"table table-striped\" ng-if=\"vm.currentVisit.Payments.length > 0\"><tbody><tr ng-repeat=\"key in vm.currentVisit.Payments\"><!-- <th scope=\"row\" style=\"text-align: center\">\r\n                          {{key.DocumentNumberFull}}\r\n                        </th> --><td scope=row style=\"text-align: center\"><span ng-show=\"key.DocumentId > 0\"><a ng-click=vm.goToDocument(-key.DocumentId)>{{key.DocumentNumberFull}}</a> </span><span ng-show=\"key.DocumentId <= 0\">{{key.DocumentNumberFull}}</span></td><td scope=row style=\"text-align: center\"><span ng-if=\"key.Type == 1\">Gotówka</span> <span ng-if=\"key.Type == 2\">Kierowca</span> <span ng-if=\"key.Type == 3\">Przelew</span> <span ng-if=\"key.Type == 4\">Inna forma</span></td><td scope=row style=\"text-align: center; position: relative\"><span ng-if=\"key.Type == 1\">{{key.Amount | number: 2}}</span> <span ng-if=\"key.Type != 1\">---</span> <span ng-if=\"key.Comment && (key.Type == 4)\" class=\"glyphicon glyphicon-comment pull-right text-info\" popover-placement=left popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.Comment}} style=\"margin-left: 5px; font-size: 1.3em\"></span></td><!-- --></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.order.title\' | translate}}</div><div class=panel-body><span ng-if=\"vm.currentVisit.OrderDocument === null\">{{\'visit.noDocument\' | translate}}</span><table class=\"table table-striped\" ng-if=\"vm.currentVisit.OrderDocument !== null\"><tbody><tr><th scope=row>{{\'visit.data.order.name\' | translate}}</th><td><a ui-sref=\"home.documents.document({id: vm.currentVisit.OrderDocument.Id, cameFrom: \'visits.visit\', previousPageId: vm.currentVisit.Id})\"><span ng-bind=vm.currentVisit.OrderDocument.DocumentNumberFull></span></a></td></tr><tr><th scope=row>{{\'visit.data.order.net\' | translate}}</th><td><span ng-bind=vm.currentVisit.OrderDocument.AmountNet></span></td></tr><tr><th scope=row>{{\'visit.data.order.gross\' | translate}}</th><td><span ng-bind=vm.currentVisit.OrderDocument.AmountGross></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.giveback.deadline\' | translate}}</div><div class=panel-body><span ng-if=\"vm.currentVisit.ReturnDocument === null\">{{\'visit.noDocument\' | translate}}</span><table class=\"table table-striped\" ng-if=\"vm.currentVisit.ReturnDocument !== null\"><tbody><tr><th scope=row>{{\'visit.data.giveback.name\' | translate}}</th><td><a ui-sref=\"home.documents.document({id: vm.currentVisit.ReturnDocument.Id, cameFrom: \'visits.visit\', previousPageId: vm.currentVisit.Id})\"><span ng-bind=vm.currentVisit.ReturnDocument.DocumentNumberFull></span></a></td></tr><tr><th scope=row>{{\'visit.data.giveback.net\' | translate}}</th><td><span ng-bind=vm.currentVisit.ReturnDocument.AmountNet></span></td></tr><tr><th scope=row>{{\'visit.data.giveback.gross\' | translate}}</th><td><span ng-bind=vm.currentVisit.ReturnDocument.AmountGross></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.giveback.quality\' | translate}}</div><div class=panel-body><span ng-if=\"vm.currentVisit.QualityReturnDocument === null\">{{\'visit.noDocument\' | translate}}</span><table class=\"table table-striped\" ng-if=\"vm.currentVisit.QualityReturnDocument !== null\"><tbody><tr><th scope=row>{{\'visit.data.giveback.name\' | translate}}</th><td><a ui-sref=\"home.documents.document({id: vm.currentVisit.QualityReturnDocument.Id, cameFrom: \'visits.visit\', previousPageId: vm.currentVisit.Id})\"><span ng-bind=vm.currentVisit.QualityReturnDocument.DocumentNumberFull></span></a></td></tr><tr><th scope=row>{{\'visit.data.giveback.net\' | translate}}</th><td><span ng-bind=vm.currentVisit.QualityReturnDocument.AmountNet></span></td></tr><tr><th scope=row>{{\'visit.data.giveback.gross\' | translate}}</th><td><span ng-bind=vm.currentVisit.QualityReturnDocument.AmountGross></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.samples.degustation\' | translate}}</div><div class=panel-body><span ng-if=\"vm.currentVisit.DegustationDocument === null\">{{\'visit.noDocument\' | translate}}</span><table class=\"table table-striped\" ng-if=\"vm.currentVisit.DegustationDocument !== null\"><tbody><tr><th scope=row>{{\'visit.data.samples.name\' | translate}}</th><td><a ui-sref=\"home.documents.document({id: vm.currentVisit.DegustationDocument.Id, cameFrom: \'visits.visit\', previousPageId: vm.currentVisit.Id})\"><span ng-bind=vm.currentVisit.DegustationDocument.DocumentNumberFull></span></a></td></tr><tr><th scope=row>{{\'visit.data.samples.net\' | translate}}</th><td><span ng-bind=vm.currentVisit.DegustationDocument.AmountNet></span></td></tr><tr><th scope=row>{{\'visit.data.samples.gross\' | translate}}</th><td><span ng-bind=vm.currentVisit.DegustationDocument.AmountGross></span></td></tr></tbody></table></div></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"panel panel-default\"><div class=panel-heading>{{\'visit.data.samples.sample\' | translate}}</div><div class=panel-body><span ng-if=\"vm.currentVisit.SampleDocument === null\">{{\'visit.noDocument\' | translate}}</span><table class=\"table table-striped\" ng-if=\"vm.currentVisit.SampleDocument !== null\"><tbody><tr><th scope=row>{{\'visit.data.samples.name\' | translate}}</th><td><a ui-sref=\"home.documents.document({id: vm.currentVisit.SampleDocument.Id, cameFrom: \'visits.visit\', previousPageId: vm.currentVisit.Id})\"><span ng-bind=vm.currentVisit.SampleDocument.DocumentNumberFull></span></a></td></tr><tr><th scope=row>{{\'visit.data.samples.net\' | translate}}</th><td><span ng-bind=vm.currentVisit.SampleDocument.AmountNet></span></td></tr><tr><th scope=row>{{\'visit.data.samples.gross\' | translate}}</th><td><span ng-bind=vm.currentVisit.SampleDocument.AmountGross></span></td></tr></tbody></table></div></div></div></div><button class=\"btn btn-primary btn-submit pull-right\" style=\"margin-left: 5px\" ng-click=vm.goBack()>Wróć</button></div></div></div>");
$templateCache.put("app/components/visits/visits.html","<div class=panel-body><div class=\"panel panel-default panel-table hidden-print\"><div class=panel-heading>{{\'visits.name\' | translate}} <span class=pull-right>Odświeżenie za: {{vm.refresh.refreshTime}} s</span></div><div class=panel-body><div class=row><div class=\"col-sm-3 has-feedback\"><label class=control-label>{{\'visits.search.contractorSymbol\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.contractorSymbol on-press-enter=vm.onFilterChange()> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=col-sm-1><label>Widok</label><div class=hidden-print uib-dropdown is-open=vm.viewEditDD auto-close=outsideClick dropdown-append-to-body><button type=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"glyphicon glyphicon-th-list\" aria-hidden=true></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem><a ng-click=\"vm.changeColumns(\'order\')\"><span ng-class=\"{\'font-bold\': vm.viewVisitsConfig.order}\">Zamówienia</span></a></li><li role=menuitem><a ng-click=\"vm.changeColumns(\'qualityReturn\')\"><span ng-class=\"{\'font-bold\': vm.viewVisitsConfig.qualityReturn}\">Zwroty jakościowe</span></a></li><li role=menuitem><a ng-click=\"vm.changeColumns(\'timeReturn\')\"><span ng-class=\"{\'font-bold\': vm.viewVisitsConfig.timeReturn}\">Zwroty w terminie</span></a></li><li role=menuitem><a ng-click=\"vm.changeColumns(\'sample\')\"><span ng-class=\"{\'font-bold\': vm.viewVisitsConfig.sample}\">Próbki</span></a></li><li role=menuitem><a ng-click=\"vm.changeColumns(\'degustation\')\"><span ng-class=\"{\'font-bold\': vm.viewVisitsConfig.degustation}\">Degustacje</span></a></li></ul></div></div><div class=\"col-sm-1 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-2><label>{{\'visits.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-2><label>{{\'visits.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'visits.search.user\' | translate}}</label><ui-select ng-model=vm.pagingData.selectedUserId theme=bootstrap on-select=\"vm.onSelectUser($item, $model)\" on-remove=\"vm.onSelectUser($item, $model)\"><ui-select-match data-allow-clear=\"{{vm.loggedUser.JobTitleId != 30}}\" placeholder=Brak>{{$select.selected.SurName + \" \" + $select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.UsersDictionary | filter: $select.search\"><div ng-bind-html=\"value.SurName + \' \' + value.Name | highlight: $select.search\" ng-class=\"{\'superior\': value.IsSuperior}\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-4><label>{{\'visits.search.contractor\' | translate}}</label><div><div class=pull-left style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.contractorId === undefined\">{{\'visits.search.noContractor\' | translate}}</div><div class=pull-left style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.contractorId !== undefined\">{{vm.pagingData.contractorObj.Name}}</div><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"position:relative; top: 4px\" uib-popover=Dodaj popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectContractor()><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></div><div class=row style=\"margin-top: 10px\"><div class=col-sm-3><label>{{\'visits.search.orderStatus\' | translate}}</label><ui-select ng-model=vm.pagingData.OrderDocumentStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.OrderDocumentStatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'visits.search.qualityReturnStatus\' | translate}}</label><ui-select ng-model=vm.pagingData.QualityReturnDocumentStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.QualityReturnDocumentStatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'visits.search.timeReturnStatus\' | translate}}</label><ui-select ng-model=vm.pagingData.ReturnDocumentStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.ReturnDocumentStatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><!-- TODO here --><div class=col-sm-3><!-- <label>{{\'visits.search.timeReturnStatus\' | translate}}</label> --><label>Status próbki/gratisu</label><ui-select ng-model=vm.pagingData.sampleStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.SamplesStatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=row style=\"margin-top: 10px; margin-left: 0px\"><div class=col-sm-3><label>{{\'visits.search.orderSum\' | translate}}</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId == undefined || vm.documentSums[0] == undefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId != undefined && vm.documentSums[0] != undefined\">{{vm.documentSums[0].Sum | number: 2}}</div></div></div><div class=col-sm-3><label>{{\'visits.search.returnSum\' | translate}}</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId == undefined || vm.documentSums[2] == undefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId != undefined && vm.documentSums[2] != undefined\">{{vm.documentSums[2].Sum | number: 2}}</div></div></div><div class=col-sm-3><label>{{\'visits.search.qualityReturnSum\' | translate}}</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId == undefined || vm.documentSums[1] == undefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId != undefined && vm.documentSums[1] != undefined\">{{vm.documentSums[1].Sum | number: 2}}</div></div></div><div class=col-sm-2><label>{{\'visits.search.counter\' | translate}}</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId == undefined || vm.counters == undefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId != undefined && vm.counters != undefined\">{{vm.counters.TimeReturnCounter.CurrentDecimalValue | number: 2}} / {{vm.counters.TimeReturnCounter.DecimalValue | number: 2}}</div></div></div><div class=col-sm-1><label>{{\'visits.search.comment\' | translate}}</label><div class=\"checkbox checkbox-primary text-center\"><input type=checkbox ng-model=vm.pagingData.isComment ng-change=vm.onFilterChange()><label></label></div></div></div><div class=row style=\"margin-top: 0px; margin-left: 0px\"><div class=col-sm-3><label>{{\'visits.search.samplesSum\' | translate}}</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId == undefined || vm.documentSums[3] == undefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId != undefined && vm.documentSums[3] != undefined\">{{vm.documentSums[3].Sum | number: 2}}</div></div></div><div class=col-sm-3><label>{{\'visits.search.degustationsSum\' | translate}}</label><div class=text-center><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId == undefined || vm.documentSums[4] == undefined\">---</div><div style=\"font-size: 17px; padding-top: 4px\" ng-if=\"vm.pagingData.selectedUserId != undefined && vm.documentSums[4] != undefined\">{{vm.documentSums[4].Sum | number: 2}}</div></div></div></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><div style=\"display: none\" class=print-title ng-if=\"vm.pagingData.selectedUserObject != null\">Wydruk dla: {{vm.pagingData.selectedUserObject.Name + \' \' + vm.pagingData.selectedUserObject.SurName}}</div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader hidden-print\" style=\"width: 15%; vertical-align: top\">Użytkownik</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\">Data</th><th class=uiGridHeader style=\"width: 20%; vertical-align: top\">Kontrahent</th><th class=uiGridHeader style=\"width: 7%; vertical-align: top\">Symbol</th><th class=\"uiGridHeader hidden-print\" style=\"width: 10%; vertical-align: top\" ng-if=vm.viewVisitsConfig.order>Zamówienie <span class=\"checkbox checkbox-primary\" style=\"margin-bottom: 0px; margin-top: 0px\" ng-show=vm.checkPermission(30)><input type=checkbox class=styled style=\"position: absolute; cursor: pointer\" ng-model=vm.isSelectAllForChangeStorage ng-change=vm.selectAllForChangeStorage()><label></label></span></th><th class=\"uiGridHeader hidden-print\" style=\"width: 10%; vertical-align: top\" ng-if=vm.viewVisitsConfig.order>Status</th><th class=\"uiGridHeader hidden-print\" style=\"width: 10%; vertical-align: top\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Zwrot jakościowy\" ng-if=vm.viewVisitsConfig.qualityReturn><span>Zwrot jakościowy</span></th><th class=\"uiGridHeader hidden-print\" style=\"width: 10%; vertical-align: top\" ng-if=vm.viewVisitsConfig.qualityReturn>Status</th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Zwrot w terminie\" ng-if=vm.viewVisitsConfig.timeReturn><span class=hidden-print>Zwrot w terminie</span> <span style=\"display: none\" class=span-on-print>Zwrot</span> <span class=\"checkbox checkbox-primary hidden-print\" style=\"margin-bottom: 0px; margin-top: 0px\" ng-show=vm.checkPermission(17)><input type=checkbox id=checkbox3 class=styled style=\"position: absolute; cursor: pointer\" ng-model=vm.selectAllTimeReturn ng-change=vm.selectAll(3)><label></label></span></th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\" ng-if=vm.viewVisitsConfig.timeReturn>Status</th><!-- samples --><th class=uiGridHeader style=\"width: 10%; vertical-align: top\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Próbki ng-if=vm.viewVisitsConfig.sample><span class=hidden-print>Próbki</span> <span style=\"display: none\" class=span-on-print>Próbki</span></th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\" ng-if=vm.viewVisitsConfig.sample>Status</th><!-- degustations --><th class=uiGridHeader style=\"width: 10%; vertical-align: top\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Degustacje ng-if=vm.viewVisitsConfig.degustation><span class=hidden-print>Degustacje</span> <span style=\"display: none\" class=span-on-print>Degustacje</span></th><th class=uiGridHeader style=\"width: 10%; vertical-align: top\" ng-if=vm.viewVisitsConfig.degustation>Status</th><th class=\"uiGridHeader hidden-print\" style=\"width: 12%; vertical-align: top\">Akcje</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\" ng-class=\"{info: key.User.JobTitleId == 30}\"><th class=hidden-print><span popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"{{key.User.SurName + \' \' + key.User.Name}}\">{{key.User.SurName + \" \" + key.User.Name}}</span></th><!--date cell - print and no print variants--><td class=hidden-print><span ng-bind=\"key.CreateDateTime | date:\'yyyy-MM-dd HH:mm\'\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"{{key.CreateDateTime | date:\'yyyy-MM-dd HH:mm\'}}\"></span></td><td style=\"display: none\" class=cell-on-print><span ng-bind=\"key.CreateDateTime | date:\'yyyy-MM-dd\'\"></span></td><td popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.ContractorName}}><span>{{key.ContractorName}}</span></td><td><span>{{key.ContractorSymbol}}</span></td><td class=hidden-print ng-if=vm.viewVisitsConfig.order><span ng-if=\"key.OrderDocumentId != null\"><a ui-sref=\"home.documents.document({id: key.OrderDocumentId, cameFrom: \'visits\'})\" ng-bind=\"key.OrderDocumentAmountNet | number:2\"></a><div class=\"btn-group pull-right\" uib-dropdown is-open=key.isopendd dropdown-append-to-body ng-if=\"((key.OrderDocumentStatus == 1 || key.OrderDocumentStatus == 21) && (vm.checkPermission(17) || vm.checkPermission(18) || vm.checkPermission(19))) || (key.OrderDocumentStatus == 2 && vm.checkPermission(30))\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Akcje popover-trigger=mouseenter popover-append-to-body=true style=\"margin-bottom: 0px; margin-top: 0px; margin-right: 5px\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-if=\"(key.OrderDocumentStatus == 21) && (vm.checkPermission(17) || vm.checkPermission(18) || vm.checkPermission(19))\"><a ng-click=\"vm.sendDocAgainToAccountingSystem(key.OrderDocumentId, key, \'orderLock\')\">Ponów wysyłkę</a></li><li role=menuitem ng-if=\"(key.OrderDocumentStatus == 2 && vm.checkPermission(30))\"><a ng-click=vm.changeStorage(key.OrderDocumentId)>Przepisz zamówienie</a></li><li role=menuitem ng-if=\"(key.OrderDocumentStatus == 1 || key.OrderDocumentStatus == 21) && (vm.checkPermission(17) || vm.checkPermission(18) || vm.checkPermission(19))\"><a ng-click=\"vm.changeDocumentStatusWithConfirm(key.OrderDocumentId, 30, key, \'orderLock\')\">Odrzuć</a></li><li role=menuitem ng-if=\"(key.OrderDocumentStatus == 2 && vm.checkPermission(30))\"><a ng-click=\"vm.changeDocumentStatusWithConfirm(key.OrderDocumentId, 32, key, \'orderLock\')\">Odrzuć</a></li></ul></div><span ng-if=\"key.IsOrderDocumentAccepted === false\"><span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"{{key.OrderDocumentStatus == 1 ? \'Pozycje wymagają akceptacji z powodu zmiany ceny\' : \'Wymagana akceptacja przez logistyka\'}}\" style=\"font-size: 1.3em\"></span> </span><span ng-if=\"(key.OrderDocumentStatus == 2) && vm.checkPermission(30)\"><span class=\"checkbox checkbox-primary pull-right\" style=\"margin-bottom: 0px; margin-top: 0px\"><input type=checkbox class=styled style=\"position: absolute; cursor: pointer\" ng-model=key.IsChangeStorage><label></label></span></span></span><span ng-if=\"key.OrderDocumentId == null\">-</span></td><td class=hidden-print ng-if=vm.viewVisitsConfig.order><span ng-if=\"key.OrderDocumentStatus == 0\">---</span> <span ng-if=\"key.OrderDocumentStatus == 1\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Akceptacja>Akceptacja</span> <span ng-if=\"key.OrderDocumentStatus == 2\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Akceptacja logistyka\">Akceptacja logistyka</span> <span ng-if=\"key.OrderDocumentStatus == 10\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Zaakceptowany>Zaakceptowany</span> <span ng-if=\"key.OrderDocumentStatus == 11\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Przetwarzanie>Przetwarzanie</span> <span ng-if=\"key.OrderDocumentStatus == 12\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Przetworzony>Przetworzony</span> <span ng-if=\"key.OrderDocumentStatus == 20\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Wysłany>Wysłany</span> <span ng-if=\"key.OrderDocumentStatus == 30\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Odrzucony>Odrzucony</span> <span ng-if=\"key.OrderDocumentStatus == 32\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Odrzucony przez logistyka\">Odrzucony przez logistyka</span> <span ng-if=\"key.OrderDocumentStatus == 21\" popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.OrderDocumentStatusText}}><span>Błąd</span> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" style=\"margin-left: 5px; font-size: 1.3em\"></span></span></td><td class=hidden-print ng-if=vm.viewVisitsConfig.qualityReturn><span ng-if=\"key.QualityReturnDocumentId != null\"><a ui-sref=\"home.documents.document({id: key.QualityReturnDocumentId, cameFrom: \'visits\'})\" ng-bind=\"key.QualityReturnDocumentAmountNet | number:2\"></a> <span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger\" popover-trigger=mouseenter popover-append-to-body=true ng-if=\"key.IsQualityReturnDocumentAccepted === false\" uib-popover=\"Wymaga akceptacji pozycji\" style=\"margin-left: 5px; font-size: 1.3em\"></span> </span><span ng-if=\"key.QualityReturnDocumentId == null\">-</span></td><td class=hidden-print ng-class=\"{success: key.QualityReturnDocumentStatus == 12, danger: key.QualityReturnDocumentStatus == 14}\" ng-if=vm.viewVisitsConfig.qualityReturn><span ng-if=\"key.QualityReturnDocumentStatus == 0\">---</span> <span ng-if=\"key.QualityReturnDocumentStatus == 1\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Akceptacja>Akceptacja</span> <span ng-if=\"key.QualityReturnDocumentStatus == 10\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Zaakceptowany>Zaakceptowany</span> <span ng-if=\"key.QualityReturnDocumentStatus == 11\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Przetwarzanie>Przetwarzanie</span> <span ng-if=\"key.QualityReturnDocumentStatus == 12\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Przetworzony>Przetworzony</span> <span ng-if=\"key.QualityReturnDocumentStatus == 14\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Przetworzony - brak zwrotów\">Przetworzony - brak zwrotów</span> <span ng-if=\"key.QualityReturnDocumentStatus == 13\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Zaakceptowany częściowo\">Zaakceptowany częściowo</span> <span ng-if=\"key.QualityReturnDocumentStatus == 22\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Dodano ręcznie\">Dodany ręcznie</span> <span ng-if=\"key.QualityReturnDocumentStatus == 30\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Odrzucony>Odrzucony</span></td><td ng-if=vm.viewVisitsConfig.timeReturn><span ng-if=\"key.ReturnDocumentId != null\"><a ui-sref=\"home.documents.document({id: key.ReturnDocumentId, cameFrom: \'visits\'})\" ng-bind=\"key.ReturnDocumentAmountNet | number:2\"></a> <span style=\"display: none\" class=span-on-print>zł</span> <span ng-if=\"key.IsReturnDocumentAccepted === false  && vm.checkPermission(17) && key.ReturnDocumentStatus != 6\" class=hidden-print><span class=\"checkbox checkbox-primary pull-right\" style=\"margin-bottom: 0px; margin-top: 0px\"><input type=checkbox class=styled style=\"position: absolute; cursor: pointer\" ng-model=key.acceptTimeReturn><label></label></span></span><div class=\"btn-group pull-right hidden-print\" uib-dropdown is-open=key.isopenddRet dropdown-append-to-body ng-if=\"(key.ReturnDocumentStatus == 6 || key.ReturnDocumentStatus == 1) && (vm.checkPermission(17))\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Akcje popover-trigger=mouseenter popover-append-to-body=true style=\"margin-bottom: 0px; margin-top: 0px; margin-right: 5px\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-if=\"key.ReturnDocumentStatus == 6 && (vm.checkPermission(17))\"><a ng-click=\"vm.changeDocumentStatus(key.ReturnDocumentId, 10, key, \'returnLock\')\">Przelicz teraz</a></li><li role=menuitem ng-if=\"(key.ReturnDocumentStatus == 1 || key.ReturnDocumentStatus == 6) && (vm.checkPermission(17))\"><a ng-click=vm.addManualReturn(key.ReturnDocumentId)>Wystaw ręcznie</a></li><li role=menuitem ng-if=\"(key.ReturnDocumentStatus == 1) && (vm.checkPermission(17))\"><a ng-click=\"vm.changeDocumentStatus(key.ReturnDocumentId, 6, key, \'returnLock\')\">Wystaw w przyszłości</a></li><li role=menuitem ng-if=\"(key.ReturnDocumentStatus == 1 || key.ReturnDocumentStatus == 6)&& (vm.checkPermission(17))\"><a ng-click=\"vm.changeDocumentStatus(key.ReturnDocumentId, 31, key, \'returnLock\')\">Anuluj</a></li></ul></div><span class=\"glyphicon glyphicon-exclamation-sign pull-right text-danger hidden-print\" popover-trigger=mouseenter popover-append-to-body=true ng-if=\"key.IsReturnDocumentAccepted === false  && !vm.checkPermission(17)\" uib-popover=\"Wymaga akceptacji\" style=\"margin-left: 5px; font-size: 1.3em\"></span> </span><span ng-if=\"key.ReturnDocumentId == null\">-</span></td><td ng-class=\"{success: key.ReturnDocumentStatus == 12, danger: key.ReturnDocumentStatus == 14}\" ng-if=vm.viewVisitsConfig.timeReturn><span ng-if=\"key.ReturnDocumentStatus == 0\">---</span> <span ng-if=\"key.ReturnDocumentStatus == 1\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Akceptacja>Akceptacja</span> <span ng-if=\"key.ReturnDocumentStatus == 6\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Odłożony>Odłożony</span> <span ng-if=\"key.ReturnDocumentStatus == 10\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Zaakceptowany>Zaakceptowany</span> <span ng-if=\"key.ReturnDocumentStatus == 11\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Przetwarzanie>Przetwarzanie</span> <span ng-if=\"key.ReturnDocumentStatus == 12\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Przetworzony>Przetworzony</span> <span ng-if=\"key.ReturnDocumentStatus == 14\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Przetworzony - brak zwrotów\">Przetworzony - brak zwrotów</span> <span ng-if=\"key.ReturnDocumentStatus == 22\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Dodano ręcznie\">Dodano ręcznie</span> <span ng-if=\"key.ReturnDocumentStatus == 31\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Anulowany>Anulowany</span></td><!--  sample cells --><td ng-if=vm.viewVisitsConfig.sample><span ng-if=\"key.SampleDocumentId != null\"><a ui-sref=\"home.documents.document({id: key.SampleDocumentId, cameFrom: \'visits\'})\" ng-bind=\"key.SampleDocumentAmountNet | number:2\"></a> <span style=\"display: none\" class=span-on-print>zł</span><div class=\"btn-group pull-right hidden-print\" uib-dropdown is-open=key.isopenddRetsamp dropdown-append-to-body ng-if=\"(key.SampleDocumentStatus == 1) && (vm.checkPermission(32))\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Akcje popover-trigger=mouseenter popover-append-to-body=true style=\"margin-bottom: 0px; margin-top: 0px; margin-right: 5px\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><!-- vm.changeDocumentStatus(key.SampleDocumentId, 11, key, \'sampleLock\') --><li role=menuitem ng-if=\"key.SampleDocumentStatus ==  1 && (vm.checkPermission(32))\"><a ng-click=vm.changeStorage(key.SampleDocumentId)>Zaakceptuj</a></li><!-- vm.changeDocumentStatus(key.SampleDocumentId, 30, key, \'sampleLock\') --><li role=menuitem ng-if=\"key.SampleDocumentStatus ==  1 && (vm.checkPermission(32))\"><a ng-click=\"vm.changeDocumentStatus(key.SampleDocumentId, 30, key, \'sampleLock\')\">Anuluj</a></li></ul></div></span><span ng-if=\"key.SampleDocumentId == null\">-</span></td><td ng-if=vm.viewVisitsConfig.sample><span ng-if=\"key.SampleDocumentStatus == 0\">---</span> <span ng-if=\"key.SampleDocumentStatus == 1\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Akceptacja>Akceptacja</span> <span ng-if=\"key.SampleDocumentStatus == 10\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Zaakceptowany>Zaakceptowany</span> <span ng-if=\"key.SampleDocumentStatus == 11\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Do wysłania\">Do wysłania</span> <span ng-if=\"key.SampleDocumentStatus == 23\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Wysłany>Wysłany</span> <span ng-if=\"key.SampleDocumentStatus == 30\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Odrzucony>Odrzucony</span></td><!-- degustations --><td ng-if=vm.viewVisitsConfig.degustation><span ng-if=\"key.DegustationDocumentId != null\"><a ui-sref=\"home.documents.document({id: key.DegustationDocumentId, cameFrom: \'visits\'})\" ng-bind=\"key.DegustationDocumentAmountNet | number:2\"></a> <span style=\"display: none\" class=span-on-print>zł</span><div class=\"btn-group pull-right hidden-print\" uib-dropdown is-open=key.isopenddRetDeg dropdown-append-to-body ng-if=\"(key.DegustationDocumentStatus == 1) && (vm.checkPermission(32))\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Akcje popover-trigger=mouseenter popover-append-to-body=true style=\"margin-bottom: 0px; margin-top: 0px; margin-right: 5px\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-if=\"key.DegustationDocumentStatus ==  1 && (vm.checkPermission(32))\"><a ng-click=vm.changeStorage(key.DegustationDocumentId)>Zaakceptuj</a></li><li role=menuitem ng-if=\"key.DegustationDocumentStatus ==  1 && (vm.checkPermission(32))\"><a ng-click=\"vm.changeDocumentStatus(key.DegustationDocumentId, 30, key, \'sampleLock\')\">Anuluj</a></li></ul></div></span><span ng-if=\"key.DegustationDocumentId == null\">-</span></td><td ng-if=vm.viewVisitsConfig.degustation><span ng-if=\"key.DegustationDocumentStatus == 0\">---</span> <span ng-if=\"key.DegustationDocumentStatus == 1\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Akceptacja>Akceptacja</span> <span ng-if=\"key.DegustationDocumentStatus == 10\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Zaakceptowany>Zaakceptowany</span> <span ng-if=\"key.DegustationDocumentStatus == 11\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=\"Do wysłania\">Do wysłania</span> <span ng-if=\"key.DegustationDocumentStatus == 23\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Wysłany>Wysłany</span> <span ng-if=\"key.DegustationDocumentStatus == 30\" popover-trigger=mouseenter popover-append-to-body=true uib-popover=Odrzucony>Odrzucony</span></td><td class=hidden-print><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button ng-click=vm.goToElement(key) class=\"btn btn-default btn-xs\" uib-popover=Szczegóły popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-search\" aria-hidden=true></span></button> <span ng-if=\"key.Comment != null && key.Comment != \'\'\" class=\"glyphicon glyphicon-comment pull-right text-info\" popover-placement=left popover-trigger=mouseenter popover-append-to-body=true uib-popover={{key.Comment}} style=\"position: absolute; margin-left: 5px; font-size: 1.3em\"></span></div></td></tr></tbody></table><div class=\"row hidden-print\"><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div></div><div class=hidden-print><span class=pull-right style=\"margin-left: auto\">Rekordów:{{vm.pagingData.totalCount}}</span></div><br><div class=hidden-print><button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px\" ng-click=vm.acceptVisits() ng-show=\"vm.checkPermission(17) || vm.checkPermission(18) || vm.checkPermission(19)\">Akceptuj</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px\" ng-click=vm.changeStorageSelected() ng-show=vm.checkPermission(30)>Akceptuj logistycznie</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px\" ng-click=vm.print()>{{\'common.actions.print\' | translate}}</button> <button class=\"btn btn-primary btn-submit pull-right hidden-print\" style=\"margin-left: 5px\" ng-click=vm.addVisit() ng-show=vm.checkPermission(34)>{{\'visits.actions.add\' | translate}}</button></div></div>");
$templateCache.put("app/components/commonComponents/constSelect/constSelect.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>{{vm.title}}</div><div class=panel-body><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><div class=row style=\"padding-bottom: 10px\" ng-if=\"vm.filterField != undefined\"><div class=\"col-md-4 has-feedback\"><label class=control-label>{{\'common.grid.searchBox\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=vm.pagingData.searchStr on-press-enter=vm.onFilterChange()> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.onFilterChange()><span class=\"glyphicon glyphicon-search\"></span></button></span></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\" style=\"min-width: 0px\"><thead><tr><th class=uiGridHeader>{{\'contractors.fields.name\' | translate}} <i class=fa ng-class=\"{\'fa-sort\': vm.pagingData.sortByName === 0, \'fa-sort-asc\': vm.pagingData.sortByName <0, \'fa-sort-desc\': vm.pagingData.sortByName >0}\" ng-click=vm.changeSortByName()></i></th><th class=uiGridHeader>{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><td><span ng-bind=key.Value></span></td><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wybierz popover-trigger=mouseenter popover-append-to-body=true ng-click=vm.selectObject(key) ng-show=!vm.isAdded(key)><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --><!-- /.panel -->");
$templateCache.put("app/components/commonComponents/ui-select/ui-select2-multi.html","<ui-select multiple data-ng-model=model[options.key] data-required={{to.required}} data-disabled={{to.disabled}} theme=bootstrap><ui-select-match placeholder={{to.placeholder}}>{{$item[to.labelProp]}}</ui-select-match><ui-select-choices data-repeat={{to.ngOptions}}><div ng-bind-html=\"option[to.labelProp] | highlight: $select.search\"></div></ui-select-choices></ui-select>");
$templateCache.put("app/components/commonComponents/uploadService/upload.modal.html","<div class=modal-header><h3 class=modal-title>{{\'upload.title\' | translate}}</h3></div><div class=modal-body><div style=\"margin-bottom: 20px\">{{\'upload.chosen\' | translate}}{{vm.file.name}}</div><div style=\"margin-bottom: 20px\" ng-show=vm.progressCheck()>{{\'upload.progress\' | translate}}{{vm.progress}}%</div><div style=\"margin-bottom: 20px; color: red\" ng-show=\"(vm.file !== undefined)&&(vm.file.size > 3000000)\">{{\'upload.sizeError\' | translate}}</div><button class=\"btn btn-primary btn-block\" type=button ngf-select ng-model=vm.file name=file ngf-pattern=\"\'image/*,.pdf\'\" ngf-accept={{vm.FileTypes}}>Wybierz plik</button> <button class=\"btn btn-primary btn-block\" type=button ng-disabled=\"(vm.file == undefined)||(vm.file.size > 3000000)\" ng-click=vm.submit(vm.file)>Zapisz</button></div>");
$templateCache.put("app/components/counters/periodSelect/periodPicker.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\" style=\"min-width:100px !important\"><div class=panel-heading>Wybierz przedział czasowy</div><div class=panel-body><div><div><div class=row style=\"margin-bottom: 20px\"><div class=col-sm-6><label class=control-label>Od</label><p class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.dates.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-6><label class=control-label>Do</label><p class=input-group><input datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.dates.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div><div class=row style=\"margin-bottom: 20px\"><div class=col-sm-6><button class=\"btn btn-primary btn-submit\" style=\"float: right\" ng-click=vm.submit() ng-disabled=!vm.areDatesSelected()||(vm.isSaving) ng-if=\"vm.mode === 0\">{{ \"common.form.confirm\" | translate }}</button> <button class=\"btn btn-primary btn-submit\" style=\"float: right\" ng-click=vm.edit() ng-disabled=!vm.areDatesSelected()||(vm.isSaving) ng-if=\"vm.mode === 1\">Zapisz edycję</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/contractors/partials/contractors.actions.html","<div class=actions><button type=button class=\"btn btn-default btn-xs\" ui-sref=\"home.contractors.contractor({id: row.entity.Id})\" uib-popover=Edytuj popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-pencil\" aria-hidden=true></span></button> <button type=button class=\"btn btn-default btn-xs\" ng-click=grid.appScope.vm.toggleBlockedFlag(row.entity) uib-popover=\"{{!row.entity.IsBlocked ? \'Zablokuj\': \'Odblokuj\'}}\" popover-trigger=mouseenter popover-append-to-body=true><span class=glyphicon ng-class=\"{\'glyphicon-remove\': row.entity.IsBlocked, \'glyphicon-ok\': !row.entity.IsBlocked}\"></span></button></div>");
$templateCache.put("app/components/documents/documentsSelect/documentsSelect.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Wybierz dokument</div><div class=panel-body><div><div><!--<label class=\"control-label\">{{\'users.user.label.storage\' | translate}}</label>--><div class=row><div class=\"col-sm-6 has-feedback\"><label class=control-label>Kontrahent</label><span>{{vm.pagingData.contractorObj.Name}}</span></div></div><br><div class=row><div class=col-sm-3><label>{{\'documents.search.dateFrom\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, vm.pagingData.beginDate, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.beginDate is-open=vm.datePickerBeginOpened datepicker-options=vm.beginDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.dateTo\' | translate}}</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.beginDateOptions, vm.pagingData.endDate, false)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.endDate is-open=vm.datePickerEndOpened datepicker-options=vm.endDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.type\' | translate}}</label><ui-select ng-model=vm.pagingData.typeId theme=bootstrap on-select=\"vm.onFilterChange($item, $model)\" on-remove=\"vm.onFilterChange($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Value | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.LocalId as value in vm.dictionaryData.DocumentTypeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Value | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria filtru\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 80%\">Pełny numer</th>><th class=uiGridHeader>{{\'contractors.fields.actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data\"><th><span ng-bind=key.DocumentNumberFull></span></th><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wybierz popover-trigger=mouseenter ng-show=!vm.isAdded(key) popover-append-to-body=true ng-click=vm.selectDocument(key)><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button></div></td></tr></tbody></table><div class=row><div class=col-sm-2 style=\"max-width: 140px\"><!-- pagesizze --><div style=\"margin-top: 20px\"><ui-select ng-model=vm.pagingData.pageSize theme=bootstrap on-select=\"vm.onSelectPageCount($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.PageSizeDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=col-sm-10><!-- ui-bootstrap pagination--><uib-pagination ng-change=vm.pageChanged() total-items=vm.pagingData.totalCount max-size=vm.pagingData.pagingButtonsMaxSize items-per-page=vm.pagingData.pageSize ng-model=vm.pagingData.currentPage boundary-links=true rotate=false ng-disabled=vm.isDataReloading previous-text=Cofnij next-text=Dalej first-text=Pierwsza last-text=Ostatnia></uib-pagination></div><div class=col-sm-2 style=\"max-width: 140px\"><div style=\"margin-top: 20px\"><span class=pull-right>Rekordów:{{vm.pagingData.totalCount}}</span></div></div></div></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");
$templateCache.put("app/components/documents/reports/degustations.report.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Raport dzienny degustacji i gratisów</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>Data(dzień):</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.date is-open=vm.datePickerOpened datepicker-options=vm.dateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><!-- <label>{{\'visits.search.orderStatus\' | translate}}</label> --><label>Status</label><ui-select ng-model=vm.pagingData.objectStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.StatusDictionary | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-6><label>{{\'documents.search.storage\' | translate}}</label><ui-select multiple ng-model=vm.pagingData.storageId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$item.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=\"uiGridHeader rowPayer\">Nazwa produktu</th><th class=\"uiGridHeader rowDate\">Symbol</th><th class=\"uiGridHeader rowStatus\">Ilość</th></tr></thead><tbody><tr ng-repeat=\"key in vm.data.DocumentEntities\"><th><span ng-bind=key.RelatedProduct.Name></span></th><!--<td><span ng-bind=\"vm.getDictionaryElementByType(\'DocumentTypeDictionary\',key.TypeId).Value\"></span></td>--><td><span ng-bind=key.RelatedProduct.Symbol></span></td><td><span ng-bind=key.Count></span></td></tr></tbody></table></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --><!-- /.panel -->");
$templateCache.put("app/components/documents/reports/history.product.report.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Raport dzienny zmian produktów</div><div class=panel-body><div><div class=row><div class=\"col-sm-3 has-feedback pull-right\"><label class=control-label></label><br><button type=button class=\"btn btn-default btn-m pull-right\" ng-click=vm.resetSearchTerms() uib-popover=\"Resetuj kryteria\" popover-trigger=mouseenter popover-append-to-body=true><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=row><div class=col-sm-3><label>Data(dzień):</label><p class=input-group><input ng-change=\"vm.onDateChange(vm.endDateOptions, true)\" datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.pagingData.date is-open=vm.datePickerOpened datepicker-options=vm.dateOptions date-disabled=\"disabled(date, mode)\" close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>{{\'documents.search.storage\' | translate}}</label><ui-select ng-model=vm.pagingData.storageId theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match data-allow-clear=true placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Id as value in vm.dictionaryData.Storages | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div><div class=col-sm-3><label>Rodzaj zmiany</label><ui-select ng-model=vm.pagingData.objectStatus theme=bootstrap on-select=\"vm.onSelect($item, $model)\" on-remove=\"vm.onSelect($item, $model)\"><ui-select-match placeholder=Brak>{{$select.selected.Name | truncate:25}}</ui-select-match><ui-select-choices repeat=\"value.Value as value in vm.dictionaryData.DeletedDocumentsDictionary | filter: $select.search\"><div ng-bind-html=\"value.Name | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"form-group ng-scope\" ng-class=\"{\'has-error\': showError}\"></div></div></div></div><br><div class=\"row text-center\" ng-show=vm.isDataReloading><h2><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie zawartości strony...</h2></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 40%\">Nazwa usuniętego produktu</th><th class=uiGridHeader style=\"width: 15%\">Data zmiany</th><th class=uiGridHeader style=\"width: 10%\">Typ zmiany</th><th class=uiGridHeader style=\"width: 10%\">Ilość</th><th class=uiGridHeader style=\"width: 10%\">Wartość</th><th class=uiGridHeader style=\"width: 15%\">Dokument</th></tr></thead><tbody><!-- ng-repeat-start --><tr ng-repeat-start=\"key in vm.data.removedProducts\" class=info><th>{{key.ProductName}}</th><td>-</td><td>-</td><td>{{key.TotalCount | number: 3}}</td><td>{{key.TotalAmount| number: 2}}</td><td><button type=button class=\"btn btn-default btn-xs\" aria-label=\"Left Align\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><span class=glyphicon ng-class=\"{\'glyphicon-menu-down\' : key.isCollapsed, \'glyphicon-menu-up\' : !key.isCollapsed}\" aria-hidden=true></span></button></td><!-- <td><span ng-repeat=\"keyy in key.details\"> | {{keyy.DocumentNumberFull}} | ({{keyy.ValueFrom}}) -> ({{keyy.ValueTo}}) | <span ng-show=\"keyy.IsDeleted\">Usunięty</span> <span ng-show=\"!keyy.IsDeleted\">Zmodyfikowany</span> </br></span></td> --></tr><tr ng-repeat-end ng-repeat=\"keyy in key.details\" ng-show=!key.isCollapsed><td>{{keyy.OperationUserName}}<br><b>{{keyy.ContractorName}}<br>{{keyy.ContractorSymbol}}</b></td><td>{{keyy.OperationDate}}<br><b>{{keyy.PatronName}}</b></td><td><span ng-show=keyy.IsDeleted>Usunięty</span> <span ng-show=!keyy.IsDeleted>Zmodyfikowany</span><br></td><td>{{keyy.ValueTo - keyy.ValueFrom | number: 2}}</td><td>{{keyy.TotalAmount | number:2}}</td><td>{{keyy.DocumentNumberFull}}</td></tr><tr><th colspan=3>Suma:</th><th>{{vm.dataStats.removedCount | number: 3}}</th><th>{{vm.dataStats.removedAmount| number: 2}}</th><td>-</td></tr></tbody></table><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 40%\">Nazwa dodanego produktu</th><th class=uiGridHeader style=\"width: 15%\">Data zmiany</th><th class=uiGridHeader style=\"width: 10%\">Typ zmiany</th><th class=uiGridHeader style=\"width: 10%\">Ilość</th><th class=uiGridHeader style=\"width: 10%\">Wartość</th><th class=uiGridHeader style=\"width: 15%\">Dokument</th></tr></thead><tbody><!-- ng-repeat-start --><tr ng-repeat-start=\"key in vm.data.addedProducts\" class=info><th>{{key.ProductName}}</th><td>-</td><td>-</td><td>{{key.TotalCount | number: 3}}</td><td>{{key.TotalAmount | number: 2}}</td><td><button type=button class=\"btn btn-default btn-xs\" aria-label=\"Left Align\" ng-click=\"key.isCollapsed = !key.isCollapsed\"><span class=glyphicon ng-class=\"{\'glyphicon-menu-down\' : key.isCollapsed, \'glyphicon-menu-up\' : !key.isCollapsed}\" aria-hidden=true></span></button></td></tr><tr ng-repeat-end ng-repeat=\"keyy in key.details\" ng-show=!key.isCollapsed><td>{{keyy.OperationUserName}}<br><b>{{keyy.ContractorName}}<br>{{keyy.ContractorSymbol}}</b></td><td>{{keyy.OperationDate}} <b>{{keyy.PatronName}}</b></td><td><span ng-show=keyy.IsDeleted>Usunięty</span> <span ng-show=!keyy.IsDeleted>Zmodyfikowany</span><br></td><td>{{keyy.ValueTo - keyy.ValueFrom | number: 2}}</td><td>{{keyy.TotalAmount | number:2}}</td><td>{{keyy.DocumentNumberFull}}</td></tr><tr><th colspan=3>Suma:</th><th>{{vm.dataStats.addedCount | number: 3}}</th><th>{{vm.dataStats.addedAmount| number: 2}}</th><td>-</td></tr></tbody></table></div></div></div></div><!-- /.table-responsive --><!-- /.panel-body --><!-- /.panel -->");
$templateCache.put("app/components/order/productPicker/productCountPicker.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\" style=\"min-width: 200px\"><div class=panel-heading>Parametry produktu: {{vm.product.Name}}</div><div class=panel-body><div><div><div class=row style=\"margin-bottom: 20px\"><div class=\"col-sm-6 has-feedback\"><label class=control-label>Ilość</label><div class=input-group><input type=number class=form-control ng-model=vm.product.Count focus-me=!!true on-press-enter=vm.closeByEnter() tabindex=1></div></div></div><div class=row style=\"margin-bottom: 20px\" ng-hide=!!vm.options.blockPrice><div class=\"col-sm-6 has-feedback\"><label class=control-label>Cena</label><div class=input-group><input type=number class=form-control type=number step=0.01 ng-model=vm.product.MyPriceNet on-press-enter=vm.closeByEnter() tabindex=2></div></div></div><div class=row style=\"margin-bottom: 20px\" ng-hide=!vm.options.qualityReturnData><div class=\"col-sm-6 has-feedback\"><label class=control-label>Termin ważności</label><div class=input-group><input ng-change=vm.onDateChange() datepicker-localdate type=text class=form-control uib-datepicker-popup ng-model=vm.product.ExpirationDate is-open=vm.product.expirationDateDatePickerOpenedModal datepicker-options=vm.expirationDateOptions close-text=Zamknij current-text=Dzisiaj clear-text=Wyczyść on-press-enter=vm.closeByEnter()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.openDP($event, 1, vm.product)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=row style=\"margin-bottom: 20px\" ng-hide=!vm.options.qualityReturnData><div class=\"col-sm-6 has-feedback\"><label class=control-label>Nr partii</label><div class=input-group><input class=form-control tabindex=3 type=text ng-model=vm.product.BatchNumber></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/order/productPicker/productPicker.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"panel panel-default panel-table\"><div class=panel-heading>Wybierz produkty</div><div class=panel-body><div><div><div class=row style=\"margin-bottom: 20px\"><div class=\"col-sm-4 has-feedback\"><label class=control-label>{{ \"common.grid.searchBox\" | translate }}</label><div class=input-group><input type=text class=form-control ng-model=vm.searchStr></div></div><div class=col-sm-6><label class=control-label>Widoczne</label><div class=input-group><div class=\"btn-group pull-right radio-buttons\"><label class=\"btn btn-primary\" ng-model=vm.productListType uib-btn-radio=1 ng-click=vm.onListTypeChange()>Wszystkie</label><label class=\"btn btn-primary\" ng-model=vm.productListType uib-btn-radio=2 ng-click=vm.onListTypeChange()>Promocje</label><label class=\"btn btn-primary\" ng-model=vm.productListType uib-btn-radio=3 ng-click=vm.onListTypeChange()>Preferowane</label></div></div></div></div></div><!-- custom grid--><table class=\"table table-hover table-striped uiGrid\"><thead><tr><th class=uiGridHeader style=\"width: 60%\">Nazwa</th><th class=uiGridHeader style=\"width: 10%\">Symbol</th><th class=uiGridHeader style=\"width: 20%\">Cena promocyjna</th><th class=uiGridHeader></th></tr></thead><tbody><tr ng-repeat=\"key in vm.visibleProducts | filter: vm.searchStr\"><th><span ng-bind=key.Name uib-popover=\"{{ key.Name }}\" popover-trigger=mouseenter popover-append-to-body=true></span></th><th><span ng-bind=key.Symbol></span></th><th><span ng-if=key.Price.PromotionAmountProductNet ng-bind=\"key.Price.PromotionAmountProductNet | number: 2\"></span> <span ng-if=!key.Price.PromotionAmountProductNet>-</span></th><td><div style=\"position:relative; overflow: auto; height: 100%\"><button type=button class=\"btn btn-default btn-xs\" uib-popover=Wybierz popover-trigger=mouseenter ng-show=!vm.isAdded(key) popover-append-to-body=true ng-click=vm.selectProduct(key)><span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span></button></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/components/routes/orderHistory/orderHistory.modal.html","<div><!-- /.panel-heading --><div class=panel-body><div class=\"row text-center\" ng-show=vm.isDataReloading><h3><span class=\"glyphicon glyphicon-refresh glyphicon-refresh-animate\"></span> Trwa ładowanie danych...</h3></div><div ng-if=\"vm.orders.length !== 0\" class=\"panel panel-default panel-table\" ng-repeat=\"key in vm.orders\"><div class=panel-heading>{{ key.DocumentNumberFull }} | {{ key.DocumentReleaseDate | date: \"yyyy-MM-dd\" }}</div><div class=panel-body><table class=table><tr><th>Nazwa produktu</th><th>Ilość</th></tr><tr ng-repeat=\"keyy in key.DocumentEntities\"><td>{{ keyy.RelatedProduct.Name }}</td><td>{{ keyy.Count }}</td></tr></table></div></div><div ng-if=\"vm.orders.length === 0\" class=\"panel panel-default panel-table\"><div class=\"row text-center\"><h3>Brak historii zamówień</h3></div></div><div class=panel-body><div><button type=submit class=\"btn btn-primary btn-submit pull-right\" ng-click=vm.close()>Zamknij</button></div></div></div><!-- /.table-responsive --><!-- /.panel-body --></div><!-- /.panel -->");}]);